(function () {
  const root = document.querySelector('[data-srd-designer]');
  if (!root) return;
  document.body.classList.add('srd-designer-app-page');

  const designerCalibration = window.SRDDesignerCalibration || {};
  const standardSignsCalibration = designerCalibration.standard_signs || {};
  const blankCanvasCalibration = designerCalibration.blank_canvas || {};
  const nitrousCalibration = designerCalibration.nitrous || {};
  const dcpArtworkReselectionGuidance = 'Preview and placement are restored. Reselect the production file before ordering; you may choose the same original file.';

  const fontColorLabels = {
    '': 'Font Color required',
    black: 'Black',
    white: 'White',
    red: 'Red',
    blue: 'Blue',
    yellow: 'Yellow',
    orange: 'Orange'
  };

  const fontColorValues = {
    '': '#111111',
    black: '#111111',
    white: '#ffffff',
    red: '#c8202f',
    blue: '#2c6fb7',
    yellow: '#f0bc1a',
    orange: '#e35d13'
  };

  const dcpDieVinylColorCatalog = Object.freeze([
    Object.freeze({ key: 'white', label: 'White', value: '#ffffff' }),
    Object.freeze({ key: 'gloss_black', label: 'Gloss Black', value: '#111111' }),
    Object.freeze({ key: 'matte_black', label: 'Matte Black', value: '#111111' }),
    Object.freeze({ key: 'red', label: 'Red', value: '#c8202f' }),
    Object.freeze({ key: 'green', label: 'Green', value: '#238b45' }),
    Object.freeze({ key: 'blue', label: 'Blue', value: '#2c6fb7' }),
    Object.freeze({ key: 'orange', label: 'Orange', value: '#e35d13' }),
    Object.freeze({ key: 'signal_yellow', label: 'Signal Yellow', value: '#f0bc1a' }),
    Object.freeze({ key: 'pink', label: 'Pink', value: '#e83e8c' }),
    Object.freeze({ key: 'purple', label: 'Purple', value: '#7b3fb3' }),
    Object.freeze({ key: 'reflective_white', label: 'Reflective White', value: '#ffffff' })
  ]);
  const dcpDieVinylColorsByKey = dcpDieVinylColorCatalog.reduce((catalog, item) => {
    catalog[item.key] = item;
    return catalog;
  }, {});
  const dcpPrintTextColorCatalog = Object.freeze([
    Object.freeze({ key: 'black', label: 'Black' }),
    Object.freeze({ key: 'white', label: 'White' }),
    Object.freeze({ key: 'red', label: 'Red' }),
    Object.freeze({ key: 'blue', label: 'Blue' }),
    Object.freeze({ key: 'yellow', label: 'Yellow' }),
    Object.freeze({ key: 'orange', label: 'Orange' })
  ]);

  const dcpTextShapeLabels = {
    straight: 'Straight',
    arch_up: 'Arch Up',
    arch_down: 'Arch Down'
  };

  // DCP SHAPES Phase A: trusted browser geometry; no customer path data is accepted.
  const dcpShapeCatalogVersion = 'dcp-shape-catalog-v1';
  const dcpShapeGeometryVersion = 'dcp-shape-geometry-v1';
  const dcpShapeProductionContractVersion = 'dcp-shape-production-v1';
  const dcpShapeCatalog = [
    { shapeKey: 'rectangle', label: 'Rectangle', aspectRatio: 5 / 3, defaultWidth: 50, resizePolicy: 'free' },
    { shapeKey: 'rounded_rectangle', label: 'Rounded Rectangle', aspectRatio: 5 / 3, defaultWidth: 50, resizePolicy: 'free' },
    { shapeKey: 'circle_oval', label: 'Circle / Oval', aspectRatio: 1, defaultWidth: 34, resizePolicy: 'free' },
    { shapeKey: 'triangle', label: 'Triangle', aspectRatio: 1, defaultWidth: 34, resizePolicy: 'free' },
    { shapeKey: 'diamond', label: 'Diamond', aspectRatio: 1, defaultWidth: 34, resizePolicy: 'free' },
    { shapeKey: 'shield', label: 'Shield', aspectRatio: 4 / 5, defaultWidth: 32, resizePolicy: 'proportional' },
    { shapeKey: 'five_point_star', label: 'Five-Point Star', aspectRatio: 1, defaultWidth: 34, resizePolicy: 'proportional' }
  ];
  const dcpShapeCatalogByKey = dcpShapeCatalog.reduce((catalog, item) => { catalog[item.shapeKey] = item; return catalog; }, {});
  const dcpShapeColorValues = {
    black: '#111111', white: '#ffffff', gloss_black: '#111111', matte_black: '#111111',
    red: '#c8202f', green: '#238b45', blue: '#2c6fb7', orange: '#e35d13',
    yellow: '#f0bc1a', signal_yellow: '#f0bc1a', pink: '#e83e8c', purple: '#7b3fb3',
    reflective_white: '#ffffff', transparent: 'none', none: 'none'
  };
  const dcpShapeThicknessValues = { thin: 0.015, medium: 0.03, thick: 0.05, extra_thick: 0.08 };
  const dcpTextOutlineThicknessValues = { thin: 0.015, medium: 0.03, thick: 0.05, extra_thick: 0.08 };
  const dcpEditingZoomSteps = [0.5, 0.75, 1, 1.25, 1.5, 2, 2.5, 3, 4, 5, 6];
  let dcpShapeLibraryAppearance = 'solid';

  const blankCanvasSubfamilies = {
    print_design: { label: 'Print Design', enabled: true },
    die_cutting: { label: 'Die Cutting - Development Preview', enabled: true, developmentOnly: true }
  };
  const topLevelProductFamilies = Object.freeze([
    Object.freeze({ key: 'custom_die_cut_design', label: 'Custom Die-Cut Design', category: 'blank_canvas', workspaceMode: 'die_cutting' }),
    Object.freeze({ key: 'custom_print_design', label: 'Custom Print Design', category: 'blank_canvas', workspaceMode: 'print_design' }),
    Object.freeze({ key: 'nitrous_bottle_labels', label: 'Nitrous Bottle Labels', category: 'nitrous', workspaceMode: '' }),
    Object.freeze({ key: 'standard_safety_signs', label: 'Standard Safety Signs', category: 'standard', workspaceMode: '' })
  ]);
  const topLevelProductFamiliesByKey = topLevelProductFamilies.reduce((catalog, family) => {
    catalog[family.key] = family;
    return catalog;
  }, {});
  const dcpWorkspaceModeCapabilities = Object.freeze({
    print_design: Object.freeze({
      text: true,
      header: true,
      shape: true,
      symbol: true,
      artwork: true,
      qr: true,
      barcode: true,
      fixedSize: true,
      physicalDimensions: false,
      printJobSettings: true,
      commerce: true
    }),
    die_cutting: Object.freeze({
      text: true,
      header: false,
      shape: false,
      symbol: false,
      artwork: false,
      qr: false,
      barcode: false,
      fixedSize: false,
      physicalDimensions: true,
      printJobSettings: false,
      commerce: true
    })
  });
  const dcpPhysicalCanvasDefaults = Object.freeze({
    version: 1,
    unit: 'in',
    width: 6,
    height: 2
  });
  const dcpPhysicalCanvasLimits = Object.freeze({
    width: Object.freeze({ min: 0.5, max: 48 }),
    height: Object.freeze({ min: 0.5, max: 8 }),
    precision: 2
  });
  const dcpDiePricing = Object.freeze({
    baseCents: 889,
    widthTiers: Object.freeze([[6, 0], [12, 200], [18, 400], [24, 700], [30, 1000], [36, 1300], [42, 1600], [48, 1900]]),
    heightTiers: Object.freeze([[2, 0], [3, 200], [4, 400], [5, 700], [6, 1000], [7, 1300], [8, 1600]]),
    standardColorCents: 200,
    standardColors: Object.freeze(['gloss_black', 'matte_black', 'red', 'green', 'blue', 'orange', 'signal_yellow', 'pink', 'purple']),
    reflectiveAreaTiers: Object.freeze([[24, 400], [72, 600], [144, 900], [240, 1300], [384, 1800]]),
    additionalTextCents: Object.freeze({ midHeight: 400, tallHeight: 600 })
  });
  const dcpDcArtBasePriceCents = Object.freeze({
    simple: Object.freeze({ 6: 889, 8: 1089, 10: 1289, 12: 1589 }),
    standard: Object.freeze({ 6: 1089, 8: 1289, 10: 1589, 12: 1889 }),
    detailed: Object.freeze({ 6: 1289, 8: 1589, 10: 1889, 12: 2289 })
  });
  const dcpDieProductHandle = 'srd-custom-die-vinyl-lettering-development';
  const dcpDieVariantSkuPrefix = 'SRD-DIE-UNIT-';
  const dcpDieRequiredUnitCents = Object.freeze([
    889, 1089, 1289, 1489, 1589, 1689, 1789, 1889, 1989, 2089,
    2189, 2289, 2389, 2489, 2589, 2689, 2789, 2889, 2989, 3089,
    3189, 3289, 3389, 3489, 3589, 3689, 3789, 3889, 3989, 4089,
    4189, 4289, 4389, 4489, 4589, 4689, 4789, 4889, 4989, 5089,
    5189, 5289, 5389, 5489, 5589, 5689, 5789, 5889, 5989, 6189,
    6289, 6489, 6789, 7089, 7389
  ]);
  const dcpDieProductData = parseDcpDieProductData();
  let dcpDieVariantLookup = buildDcpDieVariantLookup(dcpDieProductData);
  const dieCuttingMaxNonSpaceCharacters = 30;
  const dieCuttingCharacterLimitMessage = 'Maximum of 30 characters per line. Spaces do not count.';
  const dcpDieProductionContractType = 'srd-die-cutting-production-geometry';
  const dcpDieProductionContractVersion = 1;
  const dcpDcArtProductionContractVersion = 'srd-dc-art-plus-text-production-v1';
  const dcpDcArtCatalogVersion = 'srd-dc-art-catalog-v1';
  const dcpDcArtSupportedSizes = [6, 8, 10, 12];
  const dcpDieProductionPrecision = 3;
  const dcpDieSafetyMarginIn = 0.0625;
  const dcpDieMinimumPaintedCharacterHeightIn = 0.75;
  const dcpDieMinimumCuttableFeatureIn = 0.06;
  const dcpDieMinimumHorizontalScale = 0.35;
  const dcpDieMaximumHorizontalScale = 2.5;
  const dcpDieContourIntersectionToleranceIn = 0.000001;
  const dcpDieSelectionPaddingPx = 1;
  const dcpDieOutlineCatalog = window.SRDDieFontOutlines || { fonts: {} };
  const dcpDieParsedGlyphPathCache = new Map();
  const dcpDieProofLimits = Object.freeze({
    maxWidth: 1600,
    maxHeight: 1600,
    maxPixels: 2000000
  });

  const templateLabels = {
    '': 'Template required',
    danger: 'Danger',
    warning: 'Warning',
    warning_orange_black: 'Warning',
    caution: 'Caution',
    notice: 'Notice',
    blank_canvas: 'Blank Canvas'
  };

  const templateDisplayLabels = {
    '': 'Template required',
    danger: 'Danger',
    warning: 'Warning',
    warning_orange_black: 'Warning (Orange / Black)',
    caution: 'Caution',
    notice: 'Notice',
    blank_canvas: 'Blank Canvas'
  };

  const nitrousTemplateChoices = [
    { key: 'nitrous_srd_amx', label: 'American Mexico Flags', assetKey: 'SRD-AMX' },
    { key: 'nitrous_srd_aquacf', label: 'Aqua Carbon Fiber', assetKey: 'SRD-AquaCF' },
    { key: 'nitrous_srd_black', label: 'Black', assetKey: 'SRD-Black', blackSurcharge: true },
    { key: 'nitrous_srd_blkcf', label: 'Black Carbon Fiber', assetKey: 'SRD-BlkCF' },
    { key: 'nitrous_srd_blkpunchalum', label: 'Black Punch Aluminum', assetKey: 'SRD-BlkPunchAlum' },
    { key: 'nitrous_srd_blue', label: 'Blue', assetKey: 'SRD-Blue' },
    { key: 'nitrous_srd_chkrflag', label: 'Checker Flag', assetKey: 'SRD-ChkrFlag' },
    { key: 'nitrous_srd_digcamo', label: 'Digital Camo', assetKey: 'SRD-DigCamo' },
    { key: 'nitrous_srd_gray', label: 'Gray', assetKey: 'SRD-Gray' },
    { key: 'nitrous_srd_green', label: 'Green', assetKey: 'SRD-Green' },
    { key: 'nitrous_srd_grndc', label: 'Green Digital Camo', assetKey: 'SRD-GrnDC' },
    { key: 'nitrous_srd_mex', label: 'Mexico Flag', assetKey: 'SRD-Mex' },
    { key: 'nitrous_srd_orange', label: 'Orange', assetKey: 'SRD-Orange' },
    { key: 'nitrous_srd_orgcf', label: 'Orange Carbon Fiber', assetKey: 'SRD-OrgCF' },
    { key: 'nitrous_srd_pink', label: 'Pink', assetKey: 'SRD-Pink' },
    { key: 'nitrous_srd_purple', label: 'Purple', assetKey: 'SRD-Purple' },
    { key: 'nitrous_srd_red', label: 'Red', assetKey: 'SRD-Red' },
    { key: 'nitrous_srd_redcf', label: 'Red Carbon Fiber', assetKey: 'SRD-RedCF' },
    { key: 'nitrous_srd_txflag', label: 'Texas Flag', assetKey: 'SRD-TXFlag' },
    { key: 'nitrous_srd_white', label: 'White', assetKey: 'SRD-White' },
    { key: 'nitrous_srd_yellow', label: 'Yellow', assetKey: 'SRD-Yellow' },
    { key: 'nitrous_custom_upload', label: 'Custom Upload', customUpload: true }
  ];

  const nitrousTemplateSources = {
    'SRD-AMX': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-AMX.png?v=1783103435',
    'SRD-AquaCF': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-AquaCF.png?v=1783103442',
    'SRD-Black': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-Black.png?v=1783103407',
    'SRD-BlkCF': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-BlkCF.png?v=1783103434',
    'SRD-BlkPunchAlum': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-BlkPunchAlum.png?v=1783103442',
    'SRD-Blue': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-Blue.png?v=1783103413',
    'SRD-ChkrFlag': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-ChkrFlag.png?v=1783103424',
    'SRD-DigCamo': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-DigCamo.png?v=1783103416',
    'SRD-Gray': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-Gray.png?v=1783103414',
    'SRD-Green': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-Green.png?v=1783103413',
    'SRD-GrnDC': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-GrnDC.png?v=1783103421',
    'SRD-Mex': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-Mex.png?v=1783103439',
    'SRD-Orange': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-Orange.png?v=1783103413',
    'SRD-OrgCF': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-OrgCF.png?v=1783103443',
    'SRD-Pink': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-Pink.png?v=1783103415',
    'SRD-Purple': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-Purple.png?v=1783103413',
    'SRD-Red': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-Red.png?v=1783103412',
    'SRD-RedCF': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-RedCF.png?v=1783103443',
    'SRD-TXFlag': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-TXFlag.png?v=1783103440',
    'SRD-White': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-White.png?v=1783103409',
    'SRD-Yellow': 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/SRD-Yellow.png?v=1783103408'
  };

  const nitrousDefaultPreviewSrc = 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/nitrous-bottle-label-customizer-preview.png?v=1783197141';
  const dcpVectorPdfNoticeSrc = 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/srd_vector_notification.png?v=1783481753';

  const nitrousHeaderChoices = [
    { key: 'nitrous_oxide_performance', label: 'Nitrous Oxide Performance', src: 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/nop-logo-new_transparent.png?v=1783114883' },
    { key: 'nos', label: 'NOS', src: 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/nos-logo_transparent.png?v=1783114883' },
    { key: 'nx', label: 'NX', src: 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/nx-logo_transparent.png?v=1783114912' },
    { key: 'no', label: 'NO', src: 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/no-logo_transparent.png?v=1783114883' },
    { key: 'induction_solutions', label: 'Induction Solutions', src: 'https://cdn.shopify.com/s/files/1/0812/2371/3003/files/induction-solutions_transparent.png?v=1783114883' },
    { key: 'custom_art', label: 'Custom Art', src: '', customUpload: true }
  ];

  function standardTemplateCalibration(key) {
    const templates = standardSignsCalibration.templates || {};
    return Object.assign({}, templates[key] || {});
  }

  function nitrousSizeLabel(profile) {
    if (profile.finished_size_label) return profile.finished_size_label;
    if (profile.finished_width && profile.finished_height) return profile.finished_width + ' x ' + profile.finished_height + ' in';
    return '';
  }

  function normalizedNitrousBottleProfile(key, profile) {
    const width = Number(profile.finished_width);
    const height = Number(profile.finished_height);
    const aspectNumber = Number.isFinite(width) && Number.isFinite(height) && height !== 0 ? width / height : 1;
    return {
      finishedSize: nitrousSizeLabel(profile),
      aspectRatio: Number.isFinite(width) && Number.isFinite(height) ? width + ' / ' + height : '1 / 1',
      aspectNumber: aspectNumber,
      calibrationProfile: profile.calibration_profile || key,
      weightCalibration: profile.weight_overlay || {},
      mobileWeightCalibration: profile.mobile_weight_overlay_override || null,
      headerArea: profile.header_area || {},
      previewScale: profile.preview_scale || 1,
      defaultQuantity: profile.package_quantity,
      packagePrice: profile.package_price,
      materialPackagePrices: profile.material_package_prices || {},
      weightCard: profile.weight_values || []
    };
  }

  function buildNitrousBottleProfiles() {
    const profiles = {};
    const bottleSizes = nitrousCalibration.bottle_sizes || {};
    Object.keys(bottleSizes).forEach((key) => {
      profiles[key] = normalizedNitrousBottleProfile(key, bottleSizes[key]);
    });
    return profiles;
  }

  const nitrousBottleProfiles = buildNitrousBottleProfiles();
  const nitrousHeaderCalibrations = nitrousCalibration.headers || {};
  const emptyNitrousBottleProfile = {
    finishedSize: '',
    aspectRatio: '1 / 1',
    aspectNumber: 1,
    calibrationProfile: '',
    weightCalibration: {},
    mobileWeightCalibration: null,
    headerArea: {},
    previewScale: 1,
    defaultQuantity: '',
    packagePrice: NaN,
    materialPackagePrices: {},
    weightCard: []
  };

  const templateIntelligence = {
    '': {
      preview_png: root.dataset.templateSplashSrc,
      alt: 'SRD Designer splash logo',
      ...standardTemplateCalibration('splash'),
      splash: true
    },
    danger: {
      preview_png: root.dataset.templateDangerSrc,
      alt: 'Danger safety label proof template',
      ...standardTemplateCalibration('danger')
    },
    warning: {
      preview_png: root.dataset.templateWarningSrc,
      alt: 'Warning safety label proof template',
      ...standardTemplateCalibration('warning')
    },
    warning_orange_black: {
      preview_png: root.dataset.templateWarningOrangeBlackSrc,
      alt: 'Warning orange and black safety label proof template',
      ...standardTemplateCalibration('warning_orange_black')
    },
    caution: {
      preview_png: root.dataset.templateCautionSrc,
      alt: 'Caution safety label proof template',
      ...standardTemplateCalibration('caution')
    },
    notice: {
      preview_png: root.dataset.templateNoticeSrc,
      alt: 'Notice safety label proof template',
      ...standardTemplateCalibration('notice')
    },
    blank_canvas: {
      preview_png: '',
      alt: 'Blank white die cutting and print canvas',
      writable_area_center_x: null,
      writable_area_center_y: null,
      writable_area_width: null,
      writable_area_height: null,
      default_horizontal_alignment: 'center',
      default_vertical_alignment: 'center',
      default_padding: 0,
      blank_canvas: true
    },
  };

  nitrousTemplateChoices.forEach((choice) => {
    templateLabels[choice.key] = choice.label;
    templateDisplayLabels[choice.key] = choice.label;
    templateIntelligence[choice.key] = {
      preview_png: choice.customUpload ? '' : nitrousTemplateSources[choice.assetKey],
      alt: choice.label + ' nitrous bottle label template',
      writable_area_center_x: null,
      writable_area_center_y: null,
      writable_area_width: null,
      writable_area_height: null,
      default_horizontal_alignment: 'center',
      default_vertical_alignment: 'center',
      default_padding: 0,
      nitrous: true,
      nitrous_label: choice.label,
      nitrous_asset_key: choice.assetKey || '',
      black_surcharge: Boolean(choice.blackSurcharge),
      custom_upload: Boolean(choice.customUpload)
    };
  });

  const legacyFontLabels = {
    '': 'Font required',
    arial: 'Arial Bold',
    impact: 'Impact',
    anton: 'Anton',
    bowlby: 'Bowlby One SC',
    alfa: 'Alfa Slab One'
  };

  const legacyFontStacks = {
    arial: '"SRD Arial Bold", Arial, Helvetica, sans-serif',
    impact: '"SRD Impact", Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif',
    anton: '"SRD Anton", "Arial Narrow", Arial, sans-serif',
    bowlby: '"SRD Bowlby One SC", "Arial Black", Arial, sans-serif',
    alfa: '"SRD Alfa Slab One", Georgia, serif'
  };

  const srdFontCatalog = window.SRDDesignerFontCatalog || {
    entries: [],
    workflows: { print_design: ['arial', 'impact', 'anton', 'bowlby', 'alfa'], die_cutting: ['anton'] },
    defaults: { print_design: 'arial', die_cutting: 'anton' }
  };
  const fontCatalogById = (srdFontCatalog.entries || []).reduce((catalog, entry) => {
    if (entry && entry.id && !catalog[entry.id]) catalog[entry.id] = entry;
    return catalog;
  }, {});
  const fontLabels = { ...legacyFontLabels };
  const fontStacks = { ...legacyFontStacks };
  Object.keys(fontCatalogById).forEach((key) => {
    const entry = fontCatalogById[key];
    fontLabels[key] = entry.label;
    fontStacks[key] = '"' + entry.cssFamily + '"';
  });

  function fontStackFor(key) {
    return fontStacks[key] || legacyFontStacks.arial;
  }

  function colorValueFor(key) {
    return fontColorValues[key] || fontColorValues.black;
  }

  function dcpDieVinylColorDescriptor(key) {
    const candidate = String(key || '').trim().toLowerCase();
    if (dcpDieVinylColorsByKey[candidate]) return dcpDieVinylColorsByKey[candidate];
    if (candidate === 'yellow') return dcpDieVinylColorsByKey.signal_yellow;
    if (candidate === 'black') return { key: 'black', label: 'Black (Legacy)', value: fontColorValues.black };
    return { key: candidate || 'white', label: candidate ? 'Legacy color' : 'White', value: fontColorValues.white };
  }

  function dcpTextColorValue(key, workspaceMode) {
    return normalizeBlankCanvasSubfamily(workspaceMode || activeDcpWorkspaceMode) === 'die_cutting'
      ? dcpDieVinylColorDescriptor(key).value
      : colorValueFor(key);
  }

  function dcpTextColorLabel(key, workspaceMode) {
    return normalizeBlankCanvasSubfamily(workspaceMode || activeDcpWorkspaceMode) === 'die_cutting'
      ? dcpDieVinylColorDescriptor(key).label
      : (fontColorLabels[key] || fontColorLabels.black);
  }

  const quantityDefaultsBySize = {
    '2 x 3 in': 8,
    '3.5 x 5 in': 7,
    '5 x 7 in': 5,
    '10 x 7 in': 4,
    '11 x 8 in': 3,
    '11 x 17 in': 2,
    '12 x 18 in': 2
  };

  const pricingModelName = 'SRD Designer v2 Locked Package Pricing';

  const designerPackagePricing = {
    '2 x 3 in': {
      minimum_package_qty: 8,
      standard_no_lamination: 22.89,
      standard_laminated: 28.78,
      reflective_no_lamination: 40.89,
      reflective_laminated: 47.78
    },
    '3.5 x 5 in': {
      minimum_package_qty: 7,
      standard_no_lamination: 23.89,
      standard_laminated: 29.78,
      reflective_no_lamination: 43.89,
      reflective_laminated: 51.78
    },
    '5 x 7 in': {
      minimum_package_qty: 5,
      standard_no_lamination: 24.89,
      standard_laminated: 30.78,
      reflective_no_lamination: 44.89,
      reflective_laminated: 49.78
    },
    '10 x 7 in': {
      minimum_package_qty: 4,
      standard_no_lamination: 25.89,
      standard_laminated: 31.78,
      reflective_no_lamination: 45.89,
      reflective_laminated: 52.78
    },
    '11 x 8 in': {
      minimum_package_qty: 3,
      standard_no_lamination: 26.89,
      standard_laminated: 32.78,
      reflective_no_lamination: 46.89,
      reflective_laminated: 54.78
    },
    '11 x 17 in': {
      minimum_package_qty: 2,
      standard_no_lamination: 27.89,
      standard_laminated: 34.78,
      reflective_no_lamination: 47.89,
      reflective_laminated: 51.78
    },
    '12 x 18 in': {
      minimum_package_qty: 2,
      standard_no_lamination: 28.98,
      standard_laminated: 35.78,
      reflective_no_lamination: 48.89,
      reflective_laminated: 52.78
    }
  };

  const designerProductJsonUrls = [
    '/products/custom-safety-label-order.js',
    '/products/srd-custom-safety-label-designer.js'
  ];
  const dcpProductJsonUrls = [
    '/products/custom-dcp-order.js'
  ];
  const dcpProductId = '9802672570603';
  const dcpNativeArtworkPropertyName = 'DCP Uploaded Artwork File';
  const dcpProofFilePropertyName = '_DCP Final Proof File';
  const dcpTrustedArtworkUploadPathPrefix = '/s/files/1/0812/2371/3003/uploads/';
  const dcpCartRequestTimeoutMs = 12000;
  const dcpPricingModelName = 'SRD Designer DCP Package + Extra Piece Pricing v1';
  const dcpExtraPieceAddonType = 'DCP Extra Piece';
  const dcpSymbolCatalogVersion = 'dcp-symbol-catalog-v2';
  const dcpSymbolAssetVersion = 'v2';
  const dcpSymbolProductionContractVersion = 'dcp-symbol-production-v1';
  const nitrousProductId = '9788555493611';
  const nitrousProductJsonUrls = [
    '/products/custom-nitrous-bottle-label-order.js'
  ];
  const pricingModeName = 'shopify_product_json';
  const emergencyFallbackModeName = 'emergency_single_variant_fallback';
  const dcpExtraPieceVariantMap = parseDcpExtraPieceVariantMap();
  const shopifyVariantLookup = {
    loading: false,
    loaded: false,
    failed: false,
    error: '',
    product: null,
    productJsonUrl: '',
    variantsByKey: {}
  };
  const nitrousVariantLookup = {
    loading: false,
    loaded: false,
    failed: false,
    error: '',
    product: null,
    productJsonUrl: '',
    variants: [],
    lastMatchDiagnostic: null
  };
  const dcpVariantLookup = {
    loading: false,
    loaded: false,
    failed: false,
    error: '',
    product: null,
    productJsonUrl: '',
    variantsByKey: {},
    lastMatchDiagnostic: null
  };
  let designerProductJsonRequested = false;
  let nitrousProductJsonRequested = false;
  let dcpProductJsonRequested = false;

  const controls = {
    template: root.querySelector('[data-srd-template]'),
    body: root.querySelector('[data-srd-body]'),
    messageLines: root.querySelectorAll('[data-srd-message-line]'),
    font: root.querySelector('[data-srd-font]'),
    size: root.querySelector('[data-srd-size]'),
    nitrousBottleWeight: root.querySelector('[data-srd-nitrous-bottle-weight]'),
    nitrousHeader: root.querySelector('[data-srd-nitrous-header]'),
    nitrousTemplate: root.querySelector('[data-srd-nitrous-template]'),
    nitrousUpload: root.querySelector('[data-srd-nitrous-upload]'),
    blankCanvasSubfamily: root.querySelector('[data-srd-blank-canvas-subfamily]'),
    blankCanvasStart: root.querySelector('[data-srd-blank-canvas-start]'),
    blankCanvasUpload: root.querySelector('[data-srd-blank-canvas-upload]'),
    dcpWidth: root.querySelector('[data-srd-dcp-width]'),
    dcpHeight: root.querySelector('[data-srd-dcp-height]'),
    dcpTextInput: root.querySelector('[data-srd-dcp-text-input]'),
    dcpFont: root.querySelector('[data-srd-dcp-font]'),
    dcpFontColor: root.querySelector('[data-srd-dcp-font-color]'),
    dieVinylColor: root.querySelector('[data-srd-die-vinyl-color]'),
    dcpTextOutlineColor: root.querySelector('[data-srd-dcp-text-outline-color]'),
    dcpTextOutlineThickness: root.querySelector('[data-srd-dcp-text-outline-thickness]'),
    material: root.querySelector('[data-srd-material]'),
    lamination: root.querySelector('[data-srd-lamination]'),
    quantity: root.querySelector('[data-srd-quantity]'),
    confirmation: root.querySelector('[data-srd-confirmation]'),
    color: root.querySelector('[data-srd-color]'),
    colorSelect: root.querySelector('[data-srd-color-select]'),
    colorButton: root.querySelector('[data-srd-color-button]'),
    colorMenu: root.querySelector('[data-srd-color-menu]'),
    colorSelectedChip: root.querySelector('[data-srd-color-selected-chip]'),
    colorSelectedLabel: root.querySelector('[data-srd-color-selected-label]'),
    colorOptions: root.querySelectorAll('[data-srd-color-option]')
  };

  const selectionLabels = root.querySelectorAll('[data-srd-selection-label]');
  const selectionTriggers = root.querySelectorAll('[data-srd-flyout-trigger]');
  const industryFamilies = {
    Safety: ['ANSI Safety Labels', 'First Aid', 'PPE Labels'],
    Electrical: ['Conduit Markers', 'Arc Flash', 'High Voltage', 'Disconnect Labels', 'Panel Labels'],
    Facility: ['Authorized Personnel', 'Restricted Area', 'Emergency', 'Housekeeping', 'Warehouse'],
    'Machine / Equipment': ['Moving Parts', 'Pinch Point', 'Hot Surface', 'Lockout / Tagout', 'Service Labels'],
    Transportation: ['Stay Back 200', 'Stay Back 300', 'Fleet Safety', 'DOT / Trailer Labels', 'Vehicle Markings'],
    Motorsports: ['Nitrous', 'Race Fuel', 'Tow Vehicle', 'N2O Refill Labels', 'Racing Use Labels'],
    'Hard Hat': ['Hard Hat Decals', 'Welder Decals', 'Crew ID Decals', 'Certification Decals'],
    Custom: ['Blank Custom Label', 'Custom Decal']
  };
  const selectorState = {
    industry: 'Safety',
    product_family: 'ANSI Safety Labels',
    product_family_key: '',
    template_category: '',
    blank_canvas_subfamily: 'print_design',
    openType: ''
  };
  const dcpHeaderCatalogVersion = 'dcp-header-catalog-v1';
  const dcpHeaderProductionContractVersion = 'dcp-header-production-v1';
  const dcpHeaderProductionMetadata = {
    beware_oval: { assetVersion: 'v1', epsSha256: '8d8efe16040fd8e491f88c3c66cbbf780dc86036f58e227d019b31299f4337a4', boundingBox: [0, 0, 288, 88], hiResBoundingBox: [0, 0, 288.288, 88.903385] },
    beware_red: { assetVersion: 'v1', epsSha256: '19c6da3e279a1c013b454f216b5c321eb51e3afb0435e4fd17e4d730d24ce5a0', boundingBox: [0, 0, 288, 78], hiResBoundingBox: [0, 0, 288.288, 78.657292] },
    black: { assetVersion: 'v1', epsSha256: '0fa687f35f9f1fa2861c137f953e66bb03eac5abf3affddb27aef69c474b9e56', boundingBox: [0, 0, 288, 72], hiResBoundingBox: [0, 0, 288.288, 72.288] },
    blue: { assetVersion: 'v1', epsSha256: '807b07df759304f636cfb5d349562fd50406ec526b99b456b553e2640d04411b', boundingBox: [0, 0, 288, 72], hiResBoundingBox: [0, 0, 288.288, 72.288] },
    bright_green: { assetVersion: 'v1', epsSha256: 'b9605d2e8b822dee8a6c52b8fa6b45250366c2d79a650dcd35744ecf6b9661b4', boundingBox: [0, 0, 288, 72], hiResBoundingBox: [0, 0, 288.288, 72.288] },
    caution: { assetVersion: 'v1', epsSha256: '911323c5955d1c1a24a52b2dc9796146894500d04c6ebb8686356dd50900e56d', boundingBox: [0, 0, 288, 66], hiResBoundingBox: [0, 0, 288.288, 66.547179] },
    danger_oval: { assetVersion: 'v1', epsSha256: '7828ce13f082a39a32e2f8336b6711f2dda620882a35c40024ff6de6e21c271d', boundingBox: [0, 0, 288, 86], hiResBoundingBox: [0, 0, 288.288, 86.740332] },
    danger_red: { assetVersion: 'v1', epsSha256: '78a012b917b5fc19b3c67cdc498f28e583e94301124e198b91ed11ceb663ebfb', boundingBox: [0, 0, 288, 78], hiResBoundingBox: [0, 0, 288.288, 78.657292] },
    green: { assetVersion: 'v1', epsSha256: 'f5a86f664edfe12f15dacbd1b95fc0ad5bd03310c0d365065707f9c35e64cac6', boundingBox: [0, 0, 288, 72], hiResBoundingBox: [0, 0, 288.288, 72.288] },
    gray: { assetVersion: 'v1', epsSha256: '7690cd7e00ce4a2782acf614914f2fb6f7ba9144375a666442d772228efe7c6f', boundingBox: [0, 0, 288, 72], hiResBoundingBox: [0, 0, 288.288, 72.288] },
    notice: { assetVersion: 'v1', epsSha256: '735206bafbb0ac8cdcb45d699b2f1d9bd818ee685fd9cbef76549110dc35bec7', boundingBox: [0, 0, 288, 78], hiResBoundingBox: [0, 0, 288.288, 78.657292] },
    orange: { assetVersion: 'v1', epsSha256: 'f5ac29fe4d536eddf939992ac2466d7da1f8b4a139bb3b31b568d73684c2e8f9', boundingBox: [0, 0, 288, 72], hiResBoundingBox: [0, 0, 288.288, 72.288] },
    pink: { assetVersion: 'v1', epsSha256: '95780385e875d38ed8b12fa51790c2f41635db82b6b88517eedbe57036fe7347', boundingBox: [0, 0, 288, 72], hiResBoundingBox: [0, 0, 288.288, 72.288] },
    purple: { assetVersion: 'v1', epsSha256: '9b6dba3666b7d7e3553b20e724a256b9554a0d04a1e43cdd3fc7b79cbe014b22', boundingBox: [0, 0, 288, 72], hiResBoundingBox: [0, 0, 288.288, 72.288] },
    red: { assetVersion: 'v1', epsSha256: '4ec68cc43f55bfff18124dc3c09c2ac38bc908cafe55c0c53e9e8fd537d3bab3', boundingBox: [0, 0, 288, 72], hiResBoundingBox: [0, 0, 288.288, 72.288] },
    warning_oval: { assetVersion: 'v1', epsSha256: 'b56f54492e41c2cad280b65ac0c621e58ad20389c756c9c228a72f0e10a4c2ae', boundingBox: [0, 0, 288, 86], hiResBoundingBox: [0, 0, 288.288, 86.740332] },
    warning_rectangle: { assetVersion: 'v1', epsSha256: 'aa45775e5dc613162fd363601582cf61cee47e337fb10b69dc602cf9ececa343', boundingBox: [0, 0, 288, 57], hiResBoundingBox: [0, 0, 288.288, 57.888] },
    warning_red_square: { assetVersion: 'v1', epsSha256: '8fe946c3c6557259481359b6c2c4dbef0ca520dcbd93dcdeddad054c3e8b947f', boundingBox: [0, 0, 288, 64], hiResBoundingBox: [0, 0, 288.288, 64.827249] },
    yellow: { assetVersion: 'v1', epsSha256: '9341d56e5f9ab959f361ac151f6c126acb3e4e2428badf2109f3483b93854908', boundingBox: [0, 0, 288, 72], hiResBoundingBox: [0, 0, 288.288, 72.288] }
  };
  const dcpHeaderCatalog = [
    { libraryKey: 'beware_oval', label: 'Beware Oval', category: 'safety', displayOrder: 1, pngAsset: 'srd-dcp-header-beware-oval.png', epsMaster: 'beware oval.eps', pixelWidth: 363, pixelHeight: 112, src: root.dataset.dcpHeaderBewareOvalSrc || '' },
    { libraryKey: 'beware_red', label: 'Beware Red', category: 'safety', displayOrder: 2, pngAsset: 'srd-dcp-header-beware-red.png', epsMaster: 'beware red header.eps', pixelWidth: 360, pixelHeight: 98, src: root.dataset.dcpHeaderBewareRedSrc || '' },
    { libraryKey: 'black', label: 'Black', category: 'color', displayOrder: 1, pngAsset: 'srd-dcp-header-black.png', epsMaster: 'black header.eps', pixelWidth: 360, pixelHeight: 90, src: root.dataset.dcpHeaderBlackSrc || '' },
    { libraryKey: 'blue', label: 'Blue', category: 'color', displayOrder: 2, pngAsset: 'srd-dcp-header-blue.png', epsMaster: 'blue header.eps', pixelWidth: 360, pixelHeight: 90, src: root.dataset.dcpHeaderBlueSrc || '' },
    { libraryKey: 'bright_green', label: 'Bright Green', category: 'color', displayOrder: 3, pngAsset: 'srd-dcp-header-bright-green.png', epsMaster: 'bright green header.eps', pixelWidth: 360, pixelHeight: 90, src: root.dataset.dcpHeaderBrightGreenSrc || '' },
    { libraryKey: 'caution', label: 'Caution', category: 'safety', displayOrder: 3, pngAsset: 'srd-dcp-header-caution.png', epsMaster: 'caution header.eps', pixelWidth: 364, pixelHeight: 84, src: root.dataset.dcpHeaderCautionSrc || '' },
    { libraryKey: 'danger_oval', label: 'Danger Oval', category: 'safety', displayOrder: 4, pngAsset: 'srd-dcp-header-danger-oval.png', epsMaster: 'danger oval.eps', pixelWidth: 366, pixelHeight: 110, src: root.dataset.dcpHeaderDangerOvalSrc || '' },
    { libraryKey: 'danger_red', label: 'Danger Red', category: 'safety', displayOrder: 5, pngAsset: 'srd-dcp-header-danger-red.png', epsMaster: 'danger red header.eps', pixelWidth: 360, pixelHeight: 98, src: root.dataset.dcpHeaderDangerRedSrc || '' },
    { libraryKey: 'green', label: 'Green', category: 'color', displayOrder: 4, pngAsset: 'srd-dcp-header-green.png', epsMaster: 'green header.eps', pixelWidth: 360, pixelHeight: 90, src: root.dataset.dcpHeaderGreenSrc || '' },
    { libraryKey: 'gray', label: 'Gray', category: 'color', displayOrder: 5, pngAsset: 'srd-dcp-header-gray.png', epsMaster: 'grey header.eps', pixelWidth: 360, pixelHeight: 90, src: root.dataset.dcpHeaderGraySrc || '' },
    { libraryKey: 'notice', label: 'Notice', category: 'safety', displayOrder: 6, pngAsset: 'srd-dcp-header-notice.png', epsMaster: 'notice header.eps', pixelWidth: 360, pixelHeight: 98, src: root.dataset.dcpHeaderNoticeSrc || '' },
    { libraryKey: 'orange', label: 'Orange', category: 'color', displayOrder: 6, pngAsset: 'srd-dcp-header-orange.png', epsMaster: 'orange header.eps', pixelWidth: 360, pixelHeight: 90, src: root.dataset.dcpHeaderOrangeSrc || '' },
    { libraryKey: 'pink', label: 'Pink', category: 'color', displayOrder: 7, pngAsset: 'srd-dcp-header-pink.png', epsMaster: 'pink header.eps', pixelWidth: 360, pixelHeight: 90, src: root.dataset.dcpHeaderPinkSrc || '' },
    { libraryKey: 'purple', label: 'Purple', category: 'color', displayOrder: 8, pngAsset: 'srd-dcp-header-purple.png', epsMaster: 'purple header.eps', pixelWidth: 360, pixelHeight: 90, src: root.dataset.dcpHeaderPurpleSrc || '' },
    { libraryKey: 'red', label: 'Red', category: 'color', displayOrder: 9, pngAsset: 'srd-dcp-header-red.png', epsMaster: 'red header.eps', pixelWidth: 360, pixelHeight: 90, src: root.dataset.dcpHeaderRedSrc || '' },
    { libraryKey: 'warning_oval', label: 'Warning Oval', category: 'safety', displayOrder: 7, pngAsset: 'srd-dcp-header-warning-oval.png', epsMaster: 'warning oval.eps', pixelWidth: 366, pixelHeight: 110, src: root.dataset.dcpHeaderWarningOvalSrc || '' },
    { libraryKey: 'warning_rectangle', label: 'Warning Rectangle', category: 'safety', displayOrder: 8, pngAsset: 'srd-dcp-header-warning-rectangle.png', epsMaster: 'warning rectangle ob.eps', pixelWidth: 360, pixelHeight: 72, src: root.dataset.dcpHeaderWarningRectangleSrc || '' },
    { libraryKey: 'warning_red_square', label: 'Warning Red Square', category: 'safety', displayOrder: 9, pngAsset: 'srd-dcp-header-warning-red-square.png', epsMaster: 'warning red sq.eps', pixelWidth: 365, pixelHeight: 82, src: root.dataset.dcpHeaderWarningRedSquareSrc || '' },
    { libraryKey: 'yellow', label: 'Yellow', category: 'color', displayOrder: 10, pngAsset: 'srd-dcp-header-yellow.png', epsMaster: 'yellow header.eps', pixelWidth: 360, pixelHeight: 90, src: root.dataset.dcpHeaderYellowSrc || '' }
  ];
  dcpHeaderCatalog.forEach((item) => {
    const production = dcpHeaderProductionMetadata[item.libraryKey];
    if (!production) throw new Error('Missing trusted DCP Header production metadata for ' + item.libraryKey + '.');
    const hiRes = production.hiResBoundingBox;
    item.catalogVersion = dcpHeaderCatalogVersion;
    item.assetVersion = production.assetVersion;
    item.trustedPngAsset = item.pngAsset;
    item.trustedEpsMaster = item.epsMaster;
    item.epsSha256 = production.epsSha256;
    item.boundingBox = production.boundingBox.slice();
    item.hiResBoundingBox = hiRes.slice();
    item.authoritativeAspectRatio = (hiRes[2] - hiRes[0]) / (hiRes[3] - hiRes[1]);
    item.aspectRatio = item.pixelWidth / item.pixelHeight;
  });
  const dcpHeaderCatalogByKey = dcpHeaderCatalog.reduce((items, item) => {
    items[item.libraryKey] = item;
    return items;
  }, {});
  let renderedDesignerModeSignature = '';
  let activeDesignerMode = 'none';
  let uploadedNitrousHeaderArtwork = {
    url: '',
    name: '',
    type: '',
    dimensions: '',
    width: '',
    height: '',
    reference: '',
    status: '',
    supported: false,
    previewable: false,
    message: ''
  };
  let uploadedBlankCanvasArtwork = {
    url: '',
    name: '',
    type: '',
    dimensions: '',
    width: '',
    height: '',
    reference: '',
    status: '',
    supported: false,
    previewable: false,
    message: ''
  };
  let currentDcpProofState = null;
  let activeDcpCatalogArtwork = null;
  const flyout = document.createElement('div');
  flyout.className = 'srd-designer-flyout';
  flyout.hidden = true;
  flyout.setAttribute('role', 'dialog');
  flyout.setAttribute('aria-label', 'Designer selection menu');
  root.appendChild(flyout);

  const targets = {
    templateArtwork: root.querySelector('[data-srd-template-artwork]'),
    previewMessage: root.querySelector('[data-srd-preview-message]'),
    proofCanvas: root.querySelector('.srd-designer-proof__canvas'),
    proofArtboard: root.querySelector('.srd-designer-proof__artboard'),
    dcpPrecisionFrame: root.querySelector('[data-srd-dcp-precision-frame]'),
    dcpPrecisionTools: root.querySelector('[data-srd-dcp-precision-tools]'),
    dcpPrecisionToggles: Array.from(root.querySelectorAll('[data-srd-dcp-precision-toggle]')),
    dcpRulerCorner: root.querySelector('[data-srd-dcp-ruler-corner]'),
    dcpHorizontalRuler: root.querySelector('[data-srd-dcp-ruler="horizontal"]'),
    dcpVerticalRuler: root.querySelector('[data-srd-dcp-ruler="vertical"]'),
    dcpPrecisionGrid: root.querySelector('[data-srd-dcp-precision-grid]'),
    dcpGuideLayer: root.querySelector('[data-srd-dcp-guide-layer]'),
    dcpSnapLayer: root.querySelector('[data-srd-dcp-snap-layer]'),
    dcpVerticalSnapIndicator: root.querySelector('[data-srd-dcp-snap-indicator="vertical"]'),
    dcpHorizontalSnapIndicator: root.querySelector('[data-srd-dcp-snap-indicator="horizontal"]'),
    nitrousHeaderLogo: root.querySelector('[data-srd-nitrous-header-logo]'),
    nitrousWeightCard: root.querySelector('[data-srd-nitrous-weight-card]'),
    nitrousWeightTitle: root.querySelector('[data-srd-nitrous-weight-title]'),
    nitrousWeightLines: root.querySelectorAll('[data-srd-nitrous-weight-line]'),
    nitrousUploadNotice: root.querySelector('[data-srd-nitrous-upload-notice]'),
    blankCanvasPreview: root.querySelector('[data-srd-blank-canvas-preview]'),
    blankCanvasArtwork: root.querySelector('[data-srd-blank-canvas-artwork]'),
    blankCanvasArtworkHit: root.querySelector('[data-srd-dcp-artwork-hit]'),
    dcpShapeObject: root.querySelector('[data-srd-dcp-shape-object]'),
    dcpShapeSvg: root.querySelector('[data-srd-dcp-shape-svg]'),
    dcpDeleteShape: root.querySelector('[data-srd-dcp-delete-shape]'),
    dcpHeaderObject: root.querySelector('[data-srd-dcp-header-object]'),
    dcpHeaderImage: root.querySelector('[data-srd-dcp-header-image]'),
    dcpDeleteHeader: root.querySelector('[data-srd-dcp-delete-header]'),
    dcpSymbolLayer: root.querySelector('[data-srd-dcp-symbol-layer]'),
    dcpTextLayer: root.querySelector('[data-srd-dcp-text-layer]'),
    dcpResizeHandle: root.querySelector('[data-srd-dcp-resize-handle]'),
    dcpResizeHandles: Array.from(root.querySelectorAll('[data-srd-dcp-resize-handle]')),
    blankCanvasUploadNotice: root.querySelector('[data-srd-blank-canvas-upload-notice]'),
    blankCanvasSelectedFile: root.querySelector('[data-srd-blank-canvas-selected-file]'),
    blankCanvasRemoveArtwork: root.querySelector('[data-srd-blank-canvas-remove-artwork]'),
    dcpToolbarField: root.querySelector('[data-srd-dcp-toolbar-field]'),
    dcpAddText: root.querySelector('[data-srd-dcp-add-text]'),
    dcpPlacement: root.querySelector('[data-srd-dcp-placement]'),
    dcpRotateControls: root.querySelector('[data-srd-dcp-rotate-controls]'),
    dcpRotateToggle: root.querySelector('[data-srd-dcp-rotate-toggle]'),
    dcpRotateFlyout: root.querySelector('[data-srd-dcp-rotate-flyout]'),
    dcpRotateActions: Array.from(root.querySelectorAll('[data-srd-dcp-rotate-action]')),
    dcpToolbarHeader: root.querySelector('[data-srd-dcp-toolbar-header]'),
    dcpToolbarShape: root.querySelector('[data-srd-dcp-toolbar-shape]'),
    dcpToolbarSymbol: root.querySelector('[data-srd-dcp-toolbar-symbol]'),
    dcpToolbarArtwork: root.querySelector('[data-srd-dcp-toolbar-artwork]'),
    dcpToolbarQr: root.querySelector('[data-srd-dcp-toolbar-qr]'),
    dcpToolbarBarcode: root.querySelector('[data-srd-dcp-toolbar-barcode]'),
    dcpHistoryControls: root.querySelector('[data-srd-dcp-history-controls]'),
    dcpMultiSelectControls: root.querySelector('[data-srd-dcp-multi-select-controls]'),
    dcpMultiSelectToggle: root.querySelector('[data-srd-dcp-multi-select-toggle]'),
    dcpAlignControls: root.querySelector('[data-srd-dcp-align-controls]'),
    dcpAlignToggle: root.querySelector('[data-srd-dcp-align-toggle]'),
    dcpAlignFlyout: root.querySelector('[data-srd-dcp-align-flyout]'),
    dcpAlignActions: Array.from(root.querySelectorAll('[data-srd-dcp-align-action]')),
    dcpBringForward: root.querySelector('[data-srd-dcp-bring-forward]'),
    dcpSendBackward: root.querySelector('[data-srd-dcp-send-backward]'),
    dcpUndo: root.querySelector('[data-srd-dcp-undo]'),
    dcpRedo: root.querySelector('[data-srd-dcp-redo]'),
    dcpZoomControls: root.querySelector('[data-srd-dcp-zoom-controls]'),
    dcpZoomOut: root.querySelector('[data-srd-dcp-zoom-out]'),
    dcpZoomRelative: root.querySelector('[data-srd-dcp-zoom-relative]'),
    dcpZoomIn: root.querySelector('[data-srd-dcp-zoom-in]'),
    dcpZoomFit: root.querySelector('[data-srd-dcp-zoom-fit]'),
    dcpZoomStatus: root.querySelector('[data-srd-dcp-zoom-status]'),
    dcpHeaderFlyout: root.querySelector('[data-srd-dcp-header-flyout]'),
    dcpHeaderFlyoutGrid: root.querySelector('[data-srd-dcp-header-flyout-grid]'),
    dcpHeaderFlyoutClose: root.querySelector('[data-srd-dcp-header-flyout-close]'),
    dcpShapeFlyout: root.querySelector('[data-srd-dcp-shape-flyout]'),
    dcpShapeFlyoutGrid: root.querySelector('[data-srd-dcp-shape-flyout-grid]'),
    dcpShapeFlyoutClose: root.querySelector('[data-srd-dcp-shape-flyout-close]'),
    dcpShapeLibraryAppearance: Array.from(root.querySelectorAll('[data-srd-dcp-shape-library-appearance]')),
    dcpSymbolCatalog: root.querySelector('[data-srd-dcp-symbol-catalog]'),
    dcpSymbolFlyout: root.querySelector('[data-srd-dcp-symbol-flyout]'),
    dcpSymbolFlyoutClose: root.querySelector('[data-srd-dcp-symbol-flyout-close]'),
    dcpSymbolSearch: root.querySelector('[data-srd-dcp-symbol-search]'),
    dcpSymbolSearchClear: root.querySelector('[data-srd-dcp-symbol-search-clear]'),
    dcpSymbolCount: root.querySelector('[data-srd-dcp-symbol-count]'),
    dcpSymbolResults: root.querySelector('[data-srd-dcp-symbol-results]'),
    dcpSymbolGrid: root.querySelector('[data-srd-dcp-symbol-grid]'),
    dcpSymbolState: root.querySelector('[data-srd-dcp-symbol-state]'),
    dcpSymbolActivationStatus: root.querySelector('[data-srd-dcp-symbol-activation-status]'),
    dcpToolbarStatus: root.querySelector('[data-srd-dcp-toolbar-status]'),
    proofWatermark: root.querySelector('[data-srd-proof-watermark]'),
    controlsHeading: root.querySelector('[data-srd-controls-heading]'),
    dcpJobSettings: root.querySelector('[data-srd-dcp-job-settings]'),
    modeControls: root.querySelector('[data-srd-mode-controls]'),
    controlBank: root.querySelector('[data-srd-control-bank]'),
    dcpPropertyPanel: root.querySelector('[data-srd-dcp-property-panel]'),
    dcpPropertyEmpty: root.querySelector('[data-srd-dcp-property-empty]'),
    dcpPropertyMultiple: root.querySelector('[data-srd-dcp-property-multiple]'),
    dcpPropertyText: root.querySelector('[data-srd-dcp-property-text]'),
    dcpTextObjectColorField: root.querySelector('[data-srd-dcp-text-object-color-field]'),
    dcpFontColorLabel: root.querySelector('[data-srd-dcp-font-color-label]'),
    dcpTextOutlineControls: root.querySelector('[data-srd-dcp-text-outline-controls]'),
    dcpTextOutlineToggles: Array.from(root.querySelectorAll('[data-srd-dcp-text-outline]')),
    dcpPropertyArtwork: root.querySelector('[data-srd-dcp-property-artwork]'),
    dcpPropertyHeader: root.querySelector('[data-srd-dcp-property-header]'),
    dcpPropertyShape: root.querySelector('[data-srd-dcp-property-shape]'),
    dcpPropertySymbol: root.querySelector('[data-srd-dcp-property-symbol]'),
    dcpSymbolPropertyLabel: root.querySelector('[data-srd-dcp-symbol-property-label]'),
    dcpSymbolPropertyThumbnail: root.querySelector('[data-srd-dcp-symbol-property-thumbnail]'),
    dcpSymbolRotation: root.querySelector('[data-srd-dcp-symbol-rotation]'),
    dcpSymbolRotationValue: root.querySelector('[data-srd-dcp-symbol-rotation-value]'),
    dcpReplaceSymbol: root.querySelector('[data-srd-dcp-replace-symbol]'),
    dcpRemoveSymbol: root.querySelector('[data-srd-dcp-remove-symbol]'),
    dcpShapePropertyLabel: root.querySelector('[data-srd-dcp-shape-property-label]'),
    dcpShapeAppearance: Array.from(root.querySelectorAll('[data-srd-dcp-shape-appearance]')),
    dcpShapeFill: root.querySelector('[data-srd-dcp-shape-fill]'),
    dcpShapeBorder: root.querySelector('[data-srd-dcp-shape-border]'),
    dcpShapeThickness: root.querySelector('[data-srd-dcp-shape-thickness]'),
    dcpShapeRotation: root.querySelector('[data-srd-dcp-shape-rotation]'),
    dcpShapeRotationValue: root.querySelector('[data-srd-dcp-shape-rotation-value]'),
    dcpReplaceShape: root.querySelector('[data-srd-dcp-replace-shape]'),
    dcpRemoveShape: root.querySelector('[data-srd-dcp-remove-shape]'),
    dcpHeaderPropertyLabel: root.querySelector('[data-srd-dcp-header-property-label]'),
    dcpHeaderPropertyThumbnail: root.querySelector('[data-srd-dcp-header-property-thumbnail]'),
    dcpReplaceHeader: root.querySelector('[data-srd-dcp-replace-header]'),
    dcpRemoveHeader: root.querySelector('[data-srd-dcp-remove-header]'),
    dcpArtworkPropertyFilename: root.querySelector('[data-srd-dcp-artwork-property-filename]'),
    dcpArtworkPropertyType: root.querySelector('[data-srd-dcp-artwork-property-type]'),
    dcpArtworkPropertyDimensions: root.querySelector('[data-srd-dcp-artwork-property-dimensions]'),
    dcpArtworkPropertyStatus: root.querySelector('[data-srd-dcp-artwork-property-status]'),
    dcpUploadArtworkControls: root.querySelector('[data-srd-dcp-upload-artwork-controls]'),
    dcpCatalogArtworkControls: root.querySelector('[data-srd-dcp-catalog-artwork-controls]'),
    dcpCatalogArtworkTitle: root.querySelector('[data-srd-dcp-catalog-artwork-title]'),
    dcpCatalogArtworkSize: root.querySelector('[data-srd-dcp-catalog-artwork-size]'),
    dcpCatalogArtworkColor: root.querySelector('[data-srd-dcp-catalog-artwork-color]'),
    dcpCatalogArtworkChange: root.querySelector('[data-srd-dcp-catalog-artwork-change]'),
    dcpCatalogArtworkReset: root.querySelector('[data-srd-dcp-catalog-artwork-reset]'),
    dcpReplaceArtwork: root.querySelector('[data-srd-dcp-replace-artwork]'),
    dcpRemoveArtwork: root.querySelector('[data-srd-dcp-remove-artwork]'),
    dcpTextShape: root.querySelector('[data-srd-dcp-text-shape]'),
    dcpArcField: root.querySelector('[data-srd-dcp-arc-field]'),
    dcpArcAmount: root.querySelector('[data-srd-dcp-arc-amount]'),
    dcpArcValue: root.querySelector('[data-srd-dcp-arc-value]'),
    dcpRotation: root.querySelector('[data-srd-dcp-rotation]'),
    dcpRotationValue: root.querySelector('[data-srd-dcp-rotation-value]'),
    standardTemplateField: root.querySelector('[data-srd-standard-template-field]'),
    sizeField: root.querySelector('[data-srd-size-field]'),
    nitrousBottleField: root.querySelector('[data-srd-nitrous-bottle-field]'),
    nitrousHeaderField: root.querySelector('[data-srd-nitrous-header-field]'),
    nitrousTemplateField: root.querySelector('[data-srd-nitrous-template-field]'),
    nitrousUploadField: root.querySelector('[data-srd-nitrous-upload-field]'),
    blankCanvasSubfamilyField: root.querySelector('[data-srd-blank-canvas-subfamily-field]'),
    familyControls: root.querySelector('[data-srd-family-controls]'),
    dieCuttingStatus: root.querySelector('[data-srd-die-cutting-status]'),
    dieCuttingReadiness: root.querySelector('[data-srd-die-cutting-readiness]'),
    dieCuttingContractInspection: root.querySelector('[data-srd-die-cutting-contract-inspection]'),
    dcpDimensionsField: root.querySelector('[data-srd-dcp-dimensions-field]'),
    dcpDimensionsStatus: root.querySelector('[data-srd-dcp-dimensions-status]'),
    dcpSwapDimensions: root.querySelector('[data-srd-dcp-swap-dimensions]'),
    blankCanvasStartField: root.querySelector('[data-srd-blank-canvas-start-field]'),
    blankCanvasUploadField: root.querySelector('[data-srd-blank-canvas-upload-field]'),
    fontField: controls.font ? controls.font.closest('.srd-designer-field') : null,
    fontColorField: controls.color ? controls.color.closest('.srd-designer-field') : null,
    messageField: controls.messageLines && controls.messageLines[0] ? controls.messageLines[0].closest('.srd-designer-field') : null,
    quantityField: root.querySelector('[data-srd-quantity-field]'),
    quantityHint: root.querySelector('[data-srd-quantity-hint]'),
    standardSharedFields: [
      controls.material ? controls.material.closest('.srd-designer-field') : null,
      controls.lamination ? controls.lamination.closest('.srd-designer-field') : null,
      controls.font ? controls.font.closest('.srd-designer-field') : null,
      controls.color ? controls.color.closest('.srd-designer-field') : null,
      controls.messageLines && controls.messageLines[0] ? controls.messageLines[0].closest('.srd-designer-field') : null
    ].filter(Boolean),
    nitrousSharedFields: [
      controls.material ? controls.material.closest('.srd-designer-field') : null,
      controls.lamination ? controls.lamination.closest('.srd-designer-field') : null
    ].filter(Boolean),
    blankCanvasSharedFields: [
      root.querySelector('[data-srd-blank-canvas-subfamily-field]'),
      root.querySelector('[data-srd-size-field]'),
      root.querySelector('[data-srd-dcp-dimensions-field]'),
      controls.material ? controls.material.closest('.srd-designer-field') : null,
      controls.lamination ? controls.lamination.closest('.srd-designer-field') : null,
      root.querySelector('[data-srd-quantity-field]'),
      root.querySelector('[data-srd-blank-canvas-start-field]')
    ].filter(Boolean),
    summaryTemplate: root.querySelector('[data-srd-summary-template]'),
    summarySize: root.querySelector('[data-srd-summary-size]'),
    orderDetails: root.querySelector('[data-srd-order-details]'),
    orderPanel: root.querySelector('[data-srd-order-panel]'),
    dieVinylColorField: root.querySelector('[data-srd-die-vinyl-color-field]'),
    dieOrderingStatus: root.querySelector('[data-srd-die-ordering-status]'),
    pricingSubtotal: root.querySelector('[data-srd-pricing-subtotal]'),
    pricingTotalLabel: root.querySelector('[data-srd-pricing-total-label]'),
    pricingDetails: root.querySelector('[data-srd-pricing-details]'),
    pricingPackageRow: root.querySelector('[data-srd-pricing-package-row]'),
    pricingPackagePrice: root.querySelector('[data-srd-pricing-package-price]'),
    pricingQuantityLabel: root.querySelector('[data-srd-pricing-quantity-label]'),
    pricingQuantity: root.querySelector('[data-srd-pricing-quantity]'),
    pricingExtraRow: root.querySelector('[data-srd-pricing-extra-row]'),
    pricingExtraPieces: root.querySelector('[data-srd-pricing-extra-pieces]'),
    pricingAddOnsRow: root.querySelector('[data-srd-pricing-addons-row]'),
    pricingAddOnsLabel: root.querySelector('[data-srd-pricing-addons-label]'),
    pricingAddOns: root.querySelector('[data-srd-pricing-addons]'),
    propertyTemplate: root.querySelector('[data-srd-property-template]'),
    propertyTemplateKey: root.querySelector('[data-srd-property-template-key]'),
    propertyHeader: root.querySelector('[data-srd-property-header]'),
    propertyBody: root.querySelector('[data-srd-property-body]'),
    propertyFont: root.querySelector('[data-srd-property-font]'),
    propertyColor: root.querySelector('[data-srd-property-color]'),
    propertySize: root.querySelector('[data-srd-property-size]'),
    propertySizeAlias: root.querySelector('[data-srd-property-size-alias]'),
    propertyProductFamily: root.querySelector('[data-srd-property-product-family]'),
    propertySelectedTemplateCategory: root.querySelector('[data-srd-property-selected-template-category]'),
    propertyNitrousColorPattern: root.querySelector('[data-srd-property-nitrous-color-pattern]'),
    propertyNitrousProductId: root.querySelector('[data-srd-property-nitrous-product-id]'),
    propertyNitrousTemplateKey: root.querySelector('[data-srd-property-nitrous-template-key]'),
    propertyNitrousTemplateLabel: root.querySelector('[data-srd-property-nitrous-template-label]'),
    propertyNitrousTemplateImageUrl: root.querySelector('[data-srd-property-nitrous-template-image-url]'),
    propertyNitrousHeaderPublic: root.querySelector('[data-srd-property-nitrous-header-public]'),
    propertyNitrousHeaderLabel: root.querySelector('[data-srd-property-nitrous-header-label]'),
    propertyNitrousHeaderKey: root.querySelector('[data-srd-property-nitrous-header-key]'),
    propertyNitrousHeaderImageUrl: root.querySelector('[data-srd-property-nitrous-header-image-url]'),
    propertyNitrousBottleWeight: root.querySelector('[data-srd-property-nitrous-bottle-weight]'),
    propertyNitrousFinishedSize: root.querySelector('[data-srd-property-nitrous-finished-size]'),
    propertyNitrousCalibrationProfile: root.querySelector('[data-srd-property-nitrous-calibration-profile]'),
    propertyNitrousWeightValues: root.querySelector('[data-srd-property-nitrous-weight-values]'),
    propertyNitrousPackageQuantity: root.querySelector('[data-srd-property-nitrous-package-quantity]'),
    propertyCustomArtFilename: root.querySelector('[data-srd-property-custom-art-filename]'),
    propertyCustomArtReference: root.querySelector('[data-srd-property-custom-art-reference]'),
    propertyCustomArtType: root.querySelector('[data-srd-property-custom-art-type]'),
    propertyCustomArtDimensions: root.querySelector('[data-srd-property-custom-art-dimensions]'),
    propertyCustomArtStatus: root.querySelector('[data-srd-property-custom-art-status]'),
    propertyBlankCanvasSubfamily: root.querySelector('[data-srd-property-blank-canvas-subfamily]'),
    propertyBlankCanvasSubfamilyKey: root.querySelector('[data-srd-property-blank-canvas-subfamily-key]'),
    propertyBlankCanvasMode: root.querySelector('[data-srd-property-blank-canvas-mode]'),
    propertyBlankCanvasFilename: root.querySelector('[data-srd-property-blank-canvas-filename]'),
    propertyBlankCanvasType: root.querySelector('[data-srd-property-blank-canvas-type]'),
    propertyBlankCanvasStatus: root.querySelector('[data-srd-property-blank-canvas-status]'),
    propertyBlankCanvasModeKey: root.querySelector('[data-srd-property-blank-canvas-mode-key]'),
    propertyDcpArtworkFileDisplay: root.querySelector('[data-srd-property-dcp-artwork-file-display]'),
    propertyDcpUploadedFileReference: root.querySelector('[data-srd-property-dcp-uploaded-file-reference]'),
    propertyDcpOriginalFilename: root.querySelector('[data-srd-property-dcp-original-filename]'),
    propertyDcpArtworkFilenameHidden: root.querySelector('[data-srd-property-dcp-artwork-filename]'),
    propertyDcpArtworkTypeHidden: root.querySelector('[data-srd-property-dcp-artwork-type]'),
    propertyDcpCanvasSizeHidden: root.querySelector('[data-srd-property-dcp-canvas-size]'),
    propertyDcpMaterialHidden: root.querySelector('[data-srd-property-dcp-material-hidden]'),
    propertyDcpLaminationHidden: root.querySelector('[data-srd-property-dcp-lamination-hidden]'),
    propertyDcpQuantityHidden: root.querySelector('[data-srd-property-dcp-quantity-hidden]'),
    propertyDcpArtworkTransform: root.querySelector('[data-srd-property-dcp-artwork-transform]'),
    propertyDcpCanvasObjects: root.querySelector('[data-srd-property-dcp-canvas-objects]'),
    propertyDcpHeaderLabel: root.querySelector('[data-srd-property-dcp-header-label]'),
    propertyDcpHeaderProduction: root.querySelector('[data-srd-property-dcp-header-production]'),
    propertyDcpShapeLabel: root.querySelector('[data-srd-property-dcp-shape-label]'),
    propertyDcpShapeProduction: root.querySelector('[data-srd-property-dcp-shape-production]'),
    propertyDcpSymbolsLabel: root.querySelector('[data-srd-property-dcp-symbols-label]'),
    propertyDcpSymbolProduction: root.querySelector('[data-srd-property-dcp-symbol-production]'),
    propertyDcpTextPosition: root.querySelector('[data-srd-property-dcp-text-position]'),
    propertyDcpArtworkPosition: root.querySelector('[data-srd-property-dcp-artwork-position]'),
    propertyDcpSize: root.querySelector('[data-srd-property-dcp-size]'),
    propertyDcpMaterial: root.querySelector('[data-srd-property-dcp-material]'),
    propertyDcpLamination: root.querySelector('[data-srd-property-dcp-lamination]'),
    propertyDcpQuantity: root.querySelector('[data-srd-property-dcp-quantity]'),
    propertyDcpArtworkStatus: root.querySelector('[data-srd-property-dcp-artwork-status]'),
    propertyMaterial: root.querySelector('[data-srd-property-material]'),
    propertyLamination: root.querySelector('[data-srd-property-lamination]'),
    propertyQuantity: root.querySelector('[data-srd-property-quantity]'),
    propertySubtotal: root.querySelector('[data-srd-property-subtotal]'),
    propertyPricingModel: root.querySelector('[data-srd-property-pricing-model]'),
    propertyBasePackagePrice: root.querySelector('[data-srd-property-base-package-price]'),
    propertyDefaultQuantity: root.querySelector('[data-srd-property-default-quantity]'),
    propertyExtraPieceCount: root.querySelector('[data-srd-property-extra-piece-count]'),
    propertyExtraPiecePrice: root.querySelector('[data-srd-property-extra-piece-price]'),
    propertyLaminationAddOn: root.querySelector('[data-srd-property-lamination-addon]'),
    propertyDesignData: root.querySelector('[data-srd-property-design-data]'),
    propertyMarker: root.querySelector('[data-srd-property-marker]'),
    propertyBuild: root.querySelector('[data-srd-property-build]'),
    propertyProofWatermark: root.querySelector('[data-srd-property-proof-watermark]'),
    propertyProductionWatermark: root.querySelector('[data-srd-property-production-watermark]'),
    propertyMatchedVariantSku: root.querySelector('[data-srd-property-matched-variant-sku]'),
    propertyMatchedVariantId: root.querySelector('[data-srd-property-matched-variant-id]'),
    propertyVariantSource: root.querySelector('[data-srd-property-variant-source]'),
    variantId: root.querySelector('[data-srd-variant-id]'),
    cartForm: root.querySelector('[data-srd-cart-form]'),
    addButton: root.querySelector('[data-srd-add-button]'),
    cartMessage: root.querySelector('[data-srd-cart-message]'),
    quantityHint: root.querySelector('[data-srd-quantity-hint]'),
    calibrationPanel: root.querySelector('[data-srd-calibration-panel]'),
    calibrationTemplate: root.querySelector('[data-srd-calibration-template]'),
    calibrationJson: root.querySelector('[data-srd-calibration-json]'),
    calibrationTarget: root.querySelector('[data-srd-calibration-target]'),
    calibrationFields: root.querySelectorAll('[data-srd-calibration-field]'),
    debugProduct: root.querySelector('[data-srd-debug-product]'),
    debugVariantId: root.querySelector('[data-srd-debug-variant-id]'),
    debugVariantAvailable: root.querySelector('[data-srd-debug-variant-available]'),
    debugFallbackVariant: root.querySelector('[data-srd-debug-fallback-variant]'),
    debugVariantSource: root.querySelector('[data-srd-debug-variant-source]'),
    debugValid: root.querySelector('[data-srd-debug-valid]'),
    debugFailure: root.querySelector('[data-srd-debug-failure]'),
    debugCartStatus: root.querySelector('[data-srd-debug-cart-status]'),
    debugCartPayload: root.querySelector('[data-srd-debug-cart-payload]'),
    debugHttpStatus: root.querySelector('[data-srd-debug-http-status]'),
    debugShopifyMessage: root.querySelector('[data-srd-debug-shopify-message]'),
    debugResponseJson: root.querySelector('[data-srd-debug-response-json]'),
    debugResponseText: root.querySelector('[data-srd-debug-response-text]'),
    debugPricingMode: root.querySelector('[data-srd-debug-pricing-mode]'),
    debugPricingMapRequired: root.querySelector('[data-srd-debug-pricing-map-required]'),
    debugBaseVariant: root.querySelector('[data-srd-debug-base-variant]'),
    debugLaminationVariant: root.querySelector('[data-srd-debug-lamination-variant]'),
    debugExtraVariant: root.querySelector('[data-srd-debug-extra-variant]'),
    debugExpectedTotal: root.querySelector('[data-srd-debug-expected-total]')
  };

  const calibrationMode = new URLSearchParams(window.location.search).get('calibration') === '1';
  const pageParams = new URLSearchParams(window.location.search);
  let previousSize = controls.size ? controls.size.value : '';
  let latestCartPayload = null;
  let latestDesignData = null;
  let latestPricing = null;
  let latestPricingVariants = null;
  let cartAddInProgress = false;
  let selectedDcpObject = null;
  let selectedDcpObjects = [];
  let dieCuttingStateError = '';
  let dcpDieProductionContractCache = { signature: '', contract: null };
  let dcpDieProductionReadinessTimer = null;
  let dcpFontLoadRevision = 0;
  const loadedDcpFontIds = new Set();
  const failedDcpFontIds = new Set();
  const dcpFontLoadPromises = new Map();
  const pendingDcpFontRefits = new Set();
  let dcpMultiSelectMode = false;
  let dcpObjectInteraction = null;
  let dcpTextObjectCounter = 0;
  let dcpEditorSyncing = false;
  let previousDcpPhysicalSize = '';
  let dcpWorkspaceRenderRevision = 0;
  let dcpModeActivationRevision = 0;
  let dcpWorkspaceFrame = 0;
  let dcpWorkspaceObserver = null;
  let dcpDimensionEditSession = null;
  let dcpWorkspaceDimensions = { width: 0, height: 0 };
  let dcpSelectionDeleteControl = null;
  let dcpEditingZoom = 1;
  let dcpRequestedEditingZoom = 1;
  let dcpFitEditingZoom = 1;
  let dcpEditingZoomIntent = 'relative';
  let dcpPrecisionTools = null;
  let dcpGuideInteraction = null;
  let dcpShapeRestoreValidationError = '';
  let dcpSymbolRestoreValidationError = '';
  const dcpHistoryLimit = 50;
  const dcpArtworkFileRevisions = new Map();
  const dcpProductionArtworkRevisions = new Map();
  let dcpArtworkRevisionCounter = 0;
  let dcpProductionArtworkRevisionCounter = 0;
  let dcpArtworkAssetToken = '';
  let dcpProductionArtworkAssetToken = '';
  let dcpSymbolCatalogCache = null;
  let dcpSymbolObserver = null;
  let dcpSymbolQuery = '';
  let dcpSymbolObjectCounter = 0;
  let dcpSymbolLoadRevision = 0;
  let dcpSymbolProofRevision = 0;
  let dcpSymbolRestorePending = false;
  let dcpSymbolLibraryMode = 'add';
  let dcpSymbolReplacementId = '';
  const dcpSymbolMasterLoads = new Map();
  let dcpArtworkNeedsReselection = false;
  let dcpProductionArtworkSource = {
    status: 'none',
    cartLineKey: '',
    originalVariantId: '',
    propertyKey: dcpNativeArtworkPropertyName,
    reference: '',
    originalFilename: '',
    fileType: '',
    mutation: 'unchanged'
  };
  const dcpModeWorkspaces = {
    print_design: null,
    die_cutting: null
  };
  let activeDcpWorkspaceMode = 'print_design';
  let dcpDieVinylColorContext = 'white';
  let dcpCartEditSession = {
    active: false,
    status: 'inactive',
    lineKey: '',
    expectedVariantId: '',
    expectedProductId: '',
    originalVariantId: '',
    originalProductId: '',
    originalProductionReference: '',
    originalFilename: '',
    originalFileType: '',
    originalHadArtwork: false,
    failure: ''
  };
  let dcpHistory = createDcpHistoryState();

  function defaultDcpTextObject() {
    return {
      id: '',
      text: '',
      font: '',
      fontKey: '',
      fontColor: '',
      fontColorKey: '',
      x: 50,
      y: 50,
      scale: 1,
      horizontalScale: 1,
      width: 24,
      height: 8,
      maxFontSize: 260,
      textShape: 'straight',
      arcAmount: 35,
      rotation: 0,
      outlineEnabled: false,
      outlineColorKey: 'white',
      outlineThicknessKey: 'medium'
    };
  }

  function defaultDcpCanvasObjects() {
    return {
      textObjects: [],
      artwork: {
        x: 50,
        y: 50,
        scale: 1,
        width: 84,
        height: 84,
        rotation: 0
      },
      header: null,
      shape: null,
      symbolObjects: [],
      layerOrder: []
    };
  }

  function clampDcpNumber(value, min, max, fallback) {
    const number = Number(value);
    if (!Number.isFinite(number)) return fallback;
    return Math.min(max, Math.max(min, number));
  }

  function normalizeDcpTextShape(value) {
    return Object.prototype.hasOwnProperty.call(dcpTextShapeLabels, value) ? value : 'straight';
  }

  function normalizeDcpHeaderObject(item) {
    if (!item || typeof item !== 'object') return null;
    const catalogItem = dcpHeaderCatalogByKey[item.libraryKey];
    if (!catalogItem) return null;
    const width = clampDcpNumber(item.width, 4, 96, 60);
    const height = clampDcpNumber(item.height, 2, 96, 18);
    return {
      libraryKey: catalogItem.libraryKey,
      catalogVersion: catalogItem.catalogVersion,
      assetVersion: catalogItem.assetVersion,
      label: catalogItem.label,
      pngAsset: catalogItem.pngAsset,
      epsMaster: catalogItem.epsMaster,
      aspectRatio: catalogItem.authoritativeAspectRatio,
      x: clampDcpNumber(item.x, width / 2, 100 - width / 2, 50),
      y: clampDcpNumber(item.y, height / 2, 100 - height / 2, 20),
      width: width,
      height: height
    };
  }

  function normalizeDcpShapeObject(item) {
    if (!item || typeof item !== 'object') return null;
    const catalogItem = dcpShapeCatalogByKey[item.shapeKey];
    if (!catalogItem) return null;
    let appearanceMode = item.appearanceMode === 'outline' ? 'outline' : 'solid';
    const dieColorKeys = dcpDieVinylColorCatalog.map((color) => color.key);
    const allowedFillColors = ['black', 'white', 'red', 'blue', 'yellow', 'orange', 'transparent'].concat(dieColorKeys);
    const allowedBorderColors = ['black', 'white', 'red', 'blue', 'yellow', 'orange', 'none'].concat(dieColorKeys);
    let fillColorKey = allowedFillColors.indexOf(item.fillColorKey) !== -1 ? item.fillColorKey : (appearanceMode === 'outline' ? 'transparent' : 'black');
    let borderColorKey = allowedBorderColors.indexOf(item.borderColorKey) !== -1 ? item.borderColorKey : (appearanceMode === 'outline' ? 'black' : 'none');
    const allowedSolidFillColors = ['black', 'white', 'red', 'blue', 'yellow', 'orange'].concat(dieColorKeys);
    const solidFillColorKey = allowedSolidFillColors.indexOf(item.solidFillColorKey) !== -1
      ? item.solidFillColorKey
      : (allowedSolidFillColors.indexOf(fillColorKey) !== -1 ? fillColorKey : 'black');
    const borderThicknessKey = Object.prototype.hasOwnProperty.call(dcpShapeThicknessValues, item.borderThicknessKey) ? item.borderThicknessKey : 'medium';
    if (appearanceMode === 'outline') {
      fillColorKey = 'transparent';
      if (borderColorKey === 'none' || borderColorKey === 'transparent') borderColorKey = 'black';
    } else if (fillColorKey === 'transparent' && (borderColorKey === 'none' || borderColorKey === 'transparent')) {
      fillColorKey = 'black';
    }
    const width = clampDcpNumber(item.width, 8, 96, catalogItem.defaultWidth);
    const height = clampDcpNumber(item.height, 8, 96, catalogItem.defaultWidth / catalogItem.aspectRatio);
    return {
      shapeKey: catalogItem.shapeKey,
      label: catalogItem.label,
      appearanceMode: appearanceMode,
      fillColorKey: fillColorKey,
      solidFillColorKey: solidFillColorKey,
      borderColorKey: borderColorKey,
      borderThicknessKey: borderThicknessKey,
      x: clampDcpNumber(item.x, width / 2, 100 - width / 2, 50),
      y: clampDcpNumber(item.y, height / 2, 100 - height / 2, 50),
      width: width,
      height: height,
      rotation: clampDcpNumber(item.rotation, -180, 180, 0),
      catalogVersion: dcpShapeCatalogVersion,
      geometryVersion: dcpShapeGeometryVersion,
      resizePolicy: catalogItem.resizePolicy,
      layer: 15
    };
  }

  function validateDcpShapeObject(item, canvasAspect) {
    if (!item) return { valid: true, present: false, shape: null, message: '' };
    if (typeof item !== 'object' || Array.isArray(item)) {
      return { valid: false, present: true, shape: null, message: 'Shape data is not valid.' };
    }
    const forbiddenFields = ['path', 'pathData', 'pathCommands', 'commands', 'd', 'points', 'svg', 'svgMarkup', 'html', 'url', 'src', 'formula'];
    if (forbiddenFields.some((field) => Object.prototype.hasOwnProperty.call(item, field))) {
      return { valid: false, present: true, shape: null, message: 'Shape data contains unsupported drawing instructions.' };
    }
    const catalogItem = dcpShapeCatalogByKey[item.shapeKey];
    if (!catalogItem) return { valid: false, present: true, shape: null, message: 'The selected Shape is not recognized.' };
    if (item.catalogVersion !== dcpShapeCatalogVersion || item.geometryVersion !== dcpShapeGeometryVersion) {
      return { valid: false, present: true, shape: null, message: 'The selected Shape geometry version is not supported.' };
    }
    if (item.appearanceMode !== 'solid' && item.appearanceMode !== 'outline') {
      return { valid: false, present: true, shape: null, message: 'The selected Shape appearance is not supported.' };
    }
    const dieColorKeys = dcpDieVinylColorCatalog.map((color) => color.key);
    const allowedFillColors = ['black', 'white', 'red', 'blue', 'yellow', 'orange', 'transparent'].concat(dieColorKeys);
    const allowedBorderColors = ['black', 'white', 'red', 'blue', 'yellow', 'orange', 'none'].concat(dieColorKeys);
    if (allowedFillColors.indexOf(item.fillColorKey) === -1) {
      return { valid: false, present: true, shape: null, message: 'The selected Shape fill color is not supported.' };
    }
    if (allowedBorderColors.indexOf(item.borderColorKey) === -1) {
      return { valid: false, present: true, shape: null, message: 'The selected Shape border color is not supported.' };
    }
    if (!Object.prototype.hasOwnProperty.call(dcpShapeThicknessValues, item.borderThicknessKey)) {
      return { valid: false, present: true, shape: null, message: 'The selected Shape border thickness is not supported.' };
    }
    if (item.appearanceMode === 'outline' && (item.fillColorKey !== 'transparent' || item.borderColorKey === 'none')) {
      return { valid: false, present: true, shape: null, message: 'Outline Shapes require a visible border and transparent interior.' };
    }
    if (item.fillColorKey === 'transparent' && item.borderColorKey === 'none') {
      return { valid: false, present: true, shape: null, message: 'The selected Shape has no visible fill or border.' };
    }
    if (item.resizePolicy !== catalogItem.resizePolicy || item.layer !== 15) {
      return { valid: false, present: true, shape: null, message: 'The selected Shape geometry policy is not valid.' };
    }
    const geometryFields = ['x', 'y', 'width', 'height'];
    if (geometryFields.some((field) => typeof item[field] !== 'number' || !Number.isFinite(item[field]))) {
      return { valid: false, present: true, shape: null, message: 'The selected Shape placement is incomplete.' };
    }
    if (item.rotation !== undefined && (typeof item.rotation !== 'number' || !Number.isFinite(item.rotation))) {
      return { valid: false, present: true, shape: null, message: 'The selected Shape rotation is not valid.' };
    }
    const x = Number(item.x);
    const y = Number(item.y);
    const width = Number(item.width);
    const height = Number(item.height);
    const tolerance = 0.001;
    if (width < 8 || height < 8 || width > 100 || height > 100 ||
        x - width / 2 < -tolerance || x + width / 2 > 100 + tolerance ||
        y - height / 2 < -tolerance || y + height / 2 > 100 + tolerance) {
      return { valid: false, present: true, shape: null, message: 'The selected Shape placement is outside the printable canvas.' };
    }
    if (catalogItem.resizePolicy === 'proportional' && Number.isFinite(Number(canvasAspect)) && Number(canvasAspect) > 0) {
      const renderedAspect = width * Number(canvasAspect) / height;
      const relativeDifference = Math.abs(renderedAspect - catalogItem.aspectRatio) / catalogItem.aspectRatio;
      if (relativeDifference > 0.02) {
        return { valid: false, present: true, shape: null, message: 'The selected Shape proportions are not valid.' };
      }
    }
    return { valid: true, present: true, shape: normalizeDcpShapeObject(item), message: '' };
  }

  function normalizeDcpCanvasObjects(objects, workspaceMode) {
    const defaults = defaultDcpCanvasObjects();
    const textDefaults = defaultDcpTextObject();
    const source = objects && typeof objects === 'object' ? objects : {};
    const normalizationMode = normalizeBlankCanvasSubfamily(workspaceMode || activeDcpWorkspaceMode);
    const artworkScale = clampDcpNumber(source.artwork && source.artwork.scale, 0.2, 3, defaults.artwork.scale);
    const artworkWidthFallback = defaults.artwork.width * artworkScale;
    const artworkHeightFallback = defaults.artwork.height * artworkScale;
    const normalizedTextObjects = Array.isArray(source.textObjects)
      ? (normalizationMode === 'die_cutting' ? source.textObjects : source.textObjects.slice(0, 3))
        .map((item, index) => normalizeDcpTextObject(item, index, normalizationMode))
        .filter((item) => item && item.id)
      : [];

    // One-time migration only: old DCP cart restore data stored a single legacy
    // objects.text record. Active DCP rendering now uses textObjects[] only.
    if (!normalizedTextObjects.length && source.text && isComplete(source.text.text)) {
      normalizedTextObjects.push(normalizeDcpTextObject({
        ...source.text,
        id: source.text.id || textDefaults.id || 'text_1'
      }, 0, normalizationMode));
    }

    const normalized = {
      textObjects: normalizedTextObjects,
      artwork: {
        x: clampDcpNumber(source.artwork && source.artwork.x, 4, 96, defaults.artwork.x),
        y: clampDcpNumber(source.artwork && source.artwork.y, 4, 96, defaults.artwork.y),
        scale: artworkScale,
        width: clampDcpNumber(source.artwork && source.artwork.width, 8, 120, artworkWidthFallback),
        height: clampDcpNumber(source.artwork && source.artwork.height, 8, 120, artworkHeightFallback),
        rotation: clampDcpNumber(source.artwork && source.artwork.rotation, -180, 180, defaults.artwork.rotation)
      },
      header: normalizeDcpHeaderObject(source.header),
      shape: normalizationMode === 'die_cutting' ? null : normalizeDcpShapeObject(source.shape),
      symbolObjects: normalizeDcpSymbolObjects(source.symbolObjects),
      layerOrder: []
    };
    normalized.layerOrder = normalizeDcpLayerOrder(source.layerOrder, normalized);
    return normalized;
  }

  function normalizeDcpTextObject(item, index, workspaceMode) {
    if (!item || typeof item !== 'object') return null;
    const defaults = defaultDcpTextObject();
    const scale = clampDcpNumber(item.scale, 0.25, 2.5, defaults.scale);
    const dieCuttingPosition = normalizeBlankCanvasSubfamily(workspaceMode || activeDcpWorkspaceMode) === 'die_cutting';
    const textShape = normalizeDcpTextShape(item.textShape);
    return {
      id: typeof item.id === 'string' && item.id ? item.id : 'text_' + (index + 1),
      text: typeof item.text === 'string' ? item.text : '',
      font: typeof item.font === 'string' ? item.font : '',
      fontKey: typeof item.fontKey === 'string' ? item.fontKey : '',
      fontColor: typeof item.fontColor === 'string' ? item.fontColor : '',
      fontColorKey: typeof item.fontColorKey === 'string' ? item.fontColorKey : '',
      x: clampDcpNumber(item.x, dieCuttingPosition ? 0 : 4, dieCuttingPosition ? 100 : 96, defaults.x),
      y: clampDcpNumber(item.y, dieCuttingPosition ? 0 : 4, dieCuttingPosition ? 100 : 96, defaults.y),
      scale: scale,
      horizontalScale: dieCuttingPosition
        ? clampDcpNumber(item.horizontalScale, dcpDieMinimumHorizontalScale, dcpDieMaximumHorizontalScale, 1)
        : 1,
      width: clampDcpNumber(item.width, 8, 96, defaults.width * scale),
      height: clampDcpNumber(item.height, 5, 96, defaults.height * scale),
      maxFontSize: clampDcpNumber(item.maxFontSize, 18, 320, defaults.maxFontSize),
      textShape: textShape,
      arcAmount: textShape === 'straight' ? 0 : clampDcpNumber(item.arcAmount, 0, 100, defaults.arcAmount),
      rotation: clampDcpNumber(item.rotation, -180, 180, defaults.rotation),
      outlineEnabled: item.outlineEnabled === true,
      outlineColorKey: ['black', 'white', 'red', 'blue', 'yellow', 'orange'].indexOf(item.outlineColorKey) !== -1
        ? item.outlineColorKey
        : defaults.outlineColorKey,
      outlineThicknessKey: Object.prototype.hasOwnProperty.call(dcpTextOutlineThicknessValues, item.outlineThicknessKey)
        ? item.outlineThicknessKey
        : defaults.outlineThicknessKey
    };
  }

  function dcpDefaultLayerOrder(objects) {
    const normalized = objects || defaultDcpCanvasObjects();
    return []
      .concat(normalized.shape ? ['shape'] : [])
      .concat(['artwork'])
      .concat((normalized.symbolObjects || []).map((item) => dcpSymbolSelection(item.id)))
      .concat(normalized.header ? ['header'] : [])
      .concat((normalized.textObjects || []).map((item) => dcpTextSelection(item.id)));
  }

  function normalizeDcpLayerOrder(value, objects) {
    const defaults = dcpDefaultLayerOrder(objects);
    const allowed = new Set(defaults);
    const seen = new Set();
    const explicit = Array.isArray(value) ? value : [];
    const normalized = explicit.filter((selection) => {
      const key = typeof selection === 'string' ? selection : '';
      if (!allowed.has(key) || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
    defaults.forEach((selection) => {
      if (!seen.has(selection)) normalized.push(selection);
    });
    return normalized;
  }

  function formatDcpObjectPosition(object) {
    const normalized = object || {};
    return 'X ' + Math.round(clampDcpNumber(normalized.x, 4, 96, 50)) +
      '%, Y ' + Math.round(clampDcpNumber(normalized.y, 4, 96, 50)) +
      '%, W ' + Math.round(clampDcpNumber(normalized.width, 5, 120, 50)) +
      '%, H ' + Math.round(clampDcpNumber(normalized.height, 5, 120, 20)) +
      '%, Scale ' + clampDcpNumber(normalized.scale, 0.2, 3, 1).toFixed(2);
  }

  function updateDcpTextObjectFromControls() {
    if (dcpEditorSyncing) return normalizeDcpCanvasObjects(getDcpProofState().objects);
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const selectedText = selectedDcpTextObject(objects);
    if (!selectedText) return objects;
    const derivedStateBefore = JSON.stringify({
      text: selectedText.text,
      fontKey: selectedText.fontKey,
      textShape: selectedText.textShape,
      arcAmount: selectedText.arcAmount,
      rotation: selectedText.rotation
    });
    const editorValue = controls.dcpTextInput ? controls.dcpTextInput.value : selectedText.text;
    const dieCuttingValidation = isDieCuttingMode()
      ? validateDieCuttingTextValue(editorValue)
      : null;
    if (dieCuttingValidation && !dieCuttingValidation.valid) {
      if (controls.dcpTextInput) {
        const previousValue = selectedText.text || '';
        controls.dcpTextInput.value = previousValue;
        const cursor = previousValue.length;
        if (typeof controls.dcpTextInput.setSelectionRange === 'function') {
          controls.dcpTextInput.setSelectionRange(cursor, cursor);
        }
      }
      setDieCuttingDevelopmentMessage(dieCuttingValidation.message);
      return objects;
    }
    const message = dieCuttingValidation
      ? dieCuttingValidation.value
      : normalizeDcpTextMessage(String(editorValue || '').replace(/\r/g, ''));
    const fontKey = controls.dcpFont && controls.dcpFont.value ? controls.dcpFont.value : (selectedText.fontKey || 'arial');
    const dieCuttingMode = isDieCuttingMode();
    const colorKey = dieCuttingMode
      ? (authorizedDcpDieVinylColorKey(selectedText.fontColorKey)
        || authorizedDcpDieVinylColorKey(proof.dieVinylColorKey)
        || 'white')
      : (controls.dcpFontColor && controls.dcpFontColor.value ? controls.dcpFontColor.value : (selectedText.fontColorKey || 'black'));
    selectedText.text = message || '';
    const workflow = currentDcpFontWorkflow();
    const safeFontKey = dcpFontAllowedForWorkflow(fontKey, workflow)
      ? fontKey
      : dcpDefaultFontKey(workflow);
    selectedText.font = fontLabels[safeFontKey] || fontLabels.arial || 'Arial Bold';
    selectedText.fontKey = safeFontKey;
    selectedText.fontColor = dcpTextColorLabel(colorKey, activeDcpWorkspaceMode);
    selectedText.fontColorKey = colorKey;
    if (dieCuttingMode) dcpDieVinylColorContext = colorKey;
    if (!dieCuttingMode) {
      selectedText.outlineEnabled = targets.dcpTextOutlineToggles.some((button) =>
        button.classList.contains('is-active') && button.dataset.srdDcpTextOutline === 'on'
      );
      if (controls.dcpTextOutlineColor) selectedText.outlineColorKey = controls.dcpTextOutlineColor.value;
      if (controls.dcpTextOutlineThickness) selectedText.outlineThicknessKey = controls.dcpTextOutlineThickness.value;
    }
    const previousTextShape = normalizeDcpTextShape(selectedText.textShape);
    const nextTextShape = targets.dcpTextShape
      ? normalizeDcpTextShape(targets.dcpTextShape.value)
      : previousTextShape;
    selectedText.textShape = nextTextShape;
    if (nextTextShape === 'straight') {
      selectedText.arcAmount = 0;
    } else if (previousTextShape === 'straight') {
      selectedText.arcAmount = 35;
    } else if (targets.dcpArcAmount) {
      selectedText.arcAmount = clampDcpNumber(targets.dcpArcAmount.value, 0, 100, 35);
    }
    if (targets.dcpRotation) selectedText.rotation = clampDcpNumber(targets.dcpRotation.value, -180, 180, selectedText.rotation || 0);
    if (controls.font && Array.from(controls.font.options || []).some((option) => option.value === safeFontKey)) {
      controls.font.value = safeFontKey;
    }
    if (controls.color && !dieCuttingMode) controls.color.value = colorKey;
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    const derivedStateAfter = JSON.stringify({
      text: selectedText.text,
      fontKey: selectedText.fontKey,
      textShape: selectedText.textShape,
      arcAmount: selectedText.arcAmount,
      rotation: selectedText.rotation
    });
    if (dieCuttingMode && derivedStateBefore !== derivedStateAfter) {
      invalidateDcpDieTextDerivedState(selectedDcpObject, false);
    }
    return objects;
  }

  function normalizeDcpTextMessage(value) {
    const lines = String(value || '').split('\n');
    while (lines.length > 1 && !lines[lines.length - 1].trim()) {
      lines.pop();
    }
    return lines.join('\n');
  }

  function updateSelectedDcpTextObjectFromEditor() {
    if (!isBlankCanvasMode(controls.template.value)
      || selectedDcpObjects.length !== 1
      || dcpObjectType(selectedDcpObject) !== 'text') {
      return normalizeDcpCanvasObjects(getDcpProofState().objects);
    }
    return updateDcpTextObjectFromControls();
  }

  function dcpObjectType(selection) {
    if (!selection) return '';
    if (selection === 'artwork' || selection === 'header' || selection === 'shape') return selection;
    if (String(selection).indexOf('text:') === 0) return 'text';
    return String(selection).indexOf('symbol:') === 0 ? 'symbol' : '';
  }

  function dcpObjectId(selection) {
    const type = dcpObjectType(selection);
    return type === 'text' || type === 'symbol' ? String(selection).replace(type + ':', '') : '';
  }

  function dcpTextSelection(id) {
    return id ? 'text:' + id : null;
  }

  function dcpSymbolSelection(id) {
    return id ? 'symbol:' + id : null;
  }

  function selectedDcpTextObject(objects) {
    const normalized = objects && Array.isArray(objects.textObjects)
      ? objects
      : normalizeDcpCanvasObjects(objects || getDcpProofState().objects);
    const id = dcpObjectId(selectedDcpObject);
    return id ? normalized.textObjects.find((item) => item.id === id) || null : null;
  }

  function hasDcpTextObjects(objects) {
    return normalizeDcpCanvasObjects(objects || getDcpProofState().objects).textObjects.some((item) => isComplete(item.text));
  }

  function hasDcpHeaderObject(objects) {
    return Boolean(normalizeDcpCanvasObjects(objects || getDcpProofState().objects).header);
  }

  function dcpShapeValidation(objects, size) {
    if (isDieCuttingMode()) {
      dcpShapeRestoreValidationError = '';
      return { valid: true, present: false, shape: null, message: '' };
    }
    const source = objects && typeof objects === 'object' ? objects : getDcpProofState().objects;
    const shape = source && source.shape;
    if (!shape && dcpShapeRestoreValidationError) {
      return { valid: false, present: true, shape: null, message: dcpShapeRestoreValidationError };
    }
    const physicalCanvas = isDieCuttingMode() ? normalizeDcpPhysicalCanvas(getDcpProofState().physicalCanvas) : null;
    const aspect = physicalCanvas
      ? physicalCanvas.width / physicalCanvas.height
      : (isComplete(size || (controls.size && controls.size.value))
          ? aspectForDesignerSize(dcpLandscapeSize(size || controls.size.value)).number
          : null);
    return validateDcpShapeObject(shape, aspect);
  }

  function hasDcpShapeObject(objects, size) {
    const validation = dcpShapeValidation(objects, size);
    return validation.valid && validation.present;
  }

  function dcpShapeProductionContract(objects, size) {
    const validation = dcpShapeValidation(objects, size);
    if (!validation.valid || !validation.shape) return null;
    return {
      contractVersion: dcpShapeProductionContractVersion,
      catalogVersion: dcpShapeCatalogVersion,
      shapeKey: validation.shape.shapeKey,
      geometryVersion: dcpShapeGeometryVersion,
      appearanceMode: validation.shape.appearanceMode,
      fillColorKey: validation.shape.fillColorKey,
      borderColorKey: validation.shape.borderColorKey,
      borderThicknessKey: validation.shape.borderThicknessKey
    };
  }

  function dcpShapeCartProperties(objects, size) {
    const validation = dcpShapeValidation(objects, size);
    const contract = dcpShapeProductionContract(objects, size);
    if (!validation.valid || !validation.shape || !contract) return {};
    return {
      Shape: validation.shape.label + ' \u2014 ' + (validation.shape.appearanceMode === 'outline' ? 'Outline' : 'Solid'),
      '_dcp_shape_production': JSON.stringify(contract)
    };
  }

  function dcpHeaderProductionContract(objects) {
    const header = normalizeDcpCanvasObjects(objects || getDcpProofState().objects).header;
    if (!header) return null;
    const catalogItem = dcpHeaderCatalogByKey[header.libraryKey];
    if (!catalogItem) return null;
    return {
      contractVersion: dcpHeaderProductionContractVersion,
      catalogVersion: catalogItem.catalogVersion,
      libraryKey: catalogItem.libraryKey,
      assetVersion: catalogItem.assetVersion,
      epsSha256: catalogItem.epsSha256
    };
  }

  function dcpHeaderCartProperties(objects) {
    const header = normalizeDcpCanvasObjects(objects || getDcpProofState().objects).header;
    if (!header) return {};
    const catalogItem = dcpHeaderCatalogByKey[header.libraryKey];
    const contract = dcpHeaderProductionContract({ header: header });
    if (!catalogItem || !contract) return {};
    return {
      Header: catalogItem.label,
      '_dcp_header_production': JSON.stringify(contract)
    };
  }

  function dcpTextSummary(objects) {
    return normalizeDcpCanvasObjects(objects || getDcpProofState().objects).textObjects
      .map((item) => item.text)
      .filter(isComplete)
      .join(' / ');
  }

  function dcpTextCartProperties(objects, workspaceMode) {
    const properties = {};
    const textObjects = normalizeDcpCanvasObjects(objects || getDcpProofState().objects, workspaceMode).textObjects;
    const serializedObjects = workspaceMode === 'die_cutting' ? textObjects : textObjects.slice(0, 3);
    serializedObjects.forEach((item, index) => {
      const number = index + 1;
      if (!isComplete(item.text)) return;
      properties['Text ' + number] = item.text;
      if (isComplete(item.font || item.fontKey)) properties['Font ' + number] = item.font || fontLabels[item.fontKey] || '';
      if (isComplete(item.fontColor || item.fontColorKey)) properties['Color ' + number] = item.fontColor || fontColorLabels[item.fontColorKey] || '';
      properties['Text ' + number + ' Shape'] = dcpTextShapeLabels[normalizeDcpTextShape(item.textShape)] || dcpTextShapeLabels.straight;
      if (normalizeDcpTextShape(item.textShape) !== 'straight') properties['Text ' + number + ' Arc'] = String(clampDcpNumber(item.arcAmount, 0, 100, 35));
      if (clampDcpNumber(item.rotation, -180, 180, 0) !== 0) properties['Text ' + number + ' Rotation'] = clampDcpNumber(item.rotation, -180, 180, 0) + '°';
    });
    return properties;
  }

  function dcpDieTextObjectAllowance(height) {
    const designHeight = Number(height);
    if (designHeight >= 6) return 3;
    if (designHeight >= 4) return 2;
    return 1;
  }

  function dcpDieTextObjectAllowanceMessage(height, currentCount) {
    const allowance = dcpDieTextObjectAllowance(height);
    const noun = allowance === 1 ? 'text object' : 'text objects';
    if (Number(currentCount) > allowance) {
      return 'This design height allows a maximum of ' + allowance + ' ' + noun + '. Increase the design height or remove a text object.';
    }
    return allowance === 1
      ? 'This design height allows 1 text object.'
      : 'This design height allows up to ' + allowance + ' text objects.';
  }

  function dcpDieAdditionalTextPricing(height, textObjectCount) {
    const safeHeight = clampDcpNumber(height, dcpPhysicalCanvasLimits.height.min, activeDcpCatalogArtwork ? 12 : dcpPhysicalCanvasLimits.height.max, dcpPhysicalCanvasDefaults.height);
    const count = Math.max(0, Math.floor(Number(textObjectCount) || 0));
    const allowance = dcpDieTextObjectAllowance(safeHeight);
    if (count > allowance) {
      return {
        valid: false,
        object_count: count,
        additional_object_count: Math.max(0, count - 1),
        unit_cents: 0,
        surcharge_cents: 0
      };
    }
    const additionalObjectCount = Math.max(0, count - 1);
    const unitCents = safeHeight >= 6
      ? dcpDiePricing.additionalTextCents.tallHeight
      : (safeHeight >= 4 ? dcpDiePricing.additionalTextCents.midHeight : 0);
    return {
      valid: true,
      object_count: count,
      additional_object_count: additionalObjectCount,
      unit_cents: additionalObjectCount ? unitCents : 0,
      surcharge_cents: additionalObjectCount * unitCents
    };
  }

  function nextDcpTextObjectId() {
    dcpTextObjectCounter += 1;
    return activeDcpWorkspaceMode + '_text_' + Date.now().toString(36) + '_' + dcpTextObjectCounter;
  }

  function nextDcpTextObjectPosition(objects) {
    const count = normalizeDcpCanvasObjects(objects).textObjects.length;
    const offset = Math.min(count, 8) * 3;
    return {
      x: 20 + offset,
      y: 20 + offset
    };
  }

  function dcpDieInitialTextGeometry(object, position, proof) {
    const canvas = dcpPhysicalCanvasForProof(proof);
    const targetHeight = dcpDieMinimumPaintedCharacterHeightIn;
    const marginX = dcpDieSafetyMarginIn / canvas.width * 100;
    const marginY = dcpDieSafetyMarginIn / canvas.height * 100;
    const maximumWidth = Math.min(96, 100 - marginX * 2);
    const maximumHeight = Math.min(96, 100 - marginY * 2);
    let width = object.width;
    let height = object.height;
    for (let attempt = 0; attempt < 4; attempt += 1) {
      const measuredObject = { ...object, x: 50, y: 50, width: width, height: height };
      const result = dcpDieObjectProductionGeometry(measuredObject, canvas, 0);
      const practicalHeight = result.object
        ? result.object.glyphs
          .filter((glyph) => /[\p{L}\p{N}]/u.test(glyph.character))
          .reduce((maximum, glyph) => Math.max(maximum, Number(glyph.paintedHeightIn) || 0), 0)
        : 0;
      if (!practicalHeight || practicalHeight + 0.0005 >= targetHeight) break;
      const fitScale = targetHeight / practicalHeight;
      const nextWidth = Math.min(maximumWidth, width * fitScale);
      const nextHeight = Math.min(maximumHeight, height * fitScale);
      if (Math.abs(nextWidth - width) < 0.0001 && Math.abs(nextHeight - height) < 0.0001) break;
      width = nextWidth;
      height = nextHeight;
    }
    const minX = marginX + width / 2;
    const maxX = 100 - marginX - width / 2;
    const minY = marginY + height / 2;
    const maxY = 100 - marginY - height / 2;
    return {
      width: width,
      height: height,
      x: clampDcpNumber(position.x, minX, maxX, 50),
      y: clampDcpNumber(position.y, minY, maxY, 50)
    };
  }

  function dcpShapeDefaultGeometry(catalogItem) {
    const rect = targets.proofArtboard ? targets.proofArtboard.getBoundingClientRect() : null;
    const width = catalogItem.defaultWidth;
    const canvasRatio = rect && rect.width && rect.height ? rect.width / rect.height : 1.5;
    const height = Math.min(80, Math.max(8, width * canvasRatio / catalogItem.aspectRatio));
    return { x: 50, y: 50, width: width, height: height };
  }

  function constrainedDcpShapeGeometry(catalogItem, current) {
    const base = current || dcpShapeDefaultGeometry(catalogItem);
    let width = clampDcpNumber(base.width, 8, 96, catalogItem.defaultWidth);
    let height = clampDcpNumber(base.height, 8, 96, dcpShapeDefaultGeometry(catalogItem).height);
    const x = clampDcpNumber(base.x, 4, 96, 50);
    const y = clampDcpNumber(base.y, 4, 96, 50);
    if (catalogItem.resizePolicy === 'proportional') {
      const rect = targets.proofArtboard ? targets.proofArtboard.getBoundingClientRect() : null;
      if (rect && rect.width && rect.height) height = width * rect.width / rect.height / catalogItem.aspectRatio;
    }
    const factor = Math.min(1, (Math.min(x, 100 - x) * 2) / width, (Math.min(y, 100 - y) * 2) / height);
    return { x: x, y: y, width: width * factor, height: height * factor };
  }

  function setDcpShape(shapeKey) {
    if (!isBlankCanvasMode(controls.template.value) || !dcpModeAllows('shape')) return;
    const catalogItem = dcpShapeCatalogByKey[shapeKey];
    if (!catalogItem) return;
    const historyStart = beginDcpHistoryTransaction();
    dcpShapeRestoreValidationError = '';
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const current = objects.shape;
    const appearanceMode = dcpShapeLibraryAppearance === 'outline' ? 'outline' : 'solid';
    const geometry = constrainedDcpShapeGeometry(catalogItem, current);
    const solidFillColorKey = current ? current.solidFillColorKey : 'black';
    let fillColorKey = current ? current.fillColorKey : solidFillColorKey;
    let borderColorKey = current ? current.borderColorKey : 'none';
    const borderThicknessKey = current ? current.borderThicknessKey : 'medium';
    if (appearanceMode === 'outline') {
      fillColorKey = 'transparent';
      if (borderColorKey === 'none' || borderColorKey === 'transparent') borderColorKey = 'black';
    } else {
      if (fillColorKey === 'transparent') fillColorKey = solidFillColorKey;
      if (!current) borderColorKey = 'none';
    }
    objects.shape = normalizeDcpShapeObject({
      shapeKey: shapeKey,
      appearanceMode: appearanceMode,
      fillColorKey: fillColorKey,
      solidFillColorKey: solidFillColorKey,
      borderColorKey: borderColorKey,
      borderThicknessKey: borderThicknessKey,
      rotation: current ? current.rotation : 0,
      ...geometry
    });
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    selectDcpObject('shape');
    closeDcpShapeLibrary();
    update();
    commitDcpHistoryTransaction(historyStart, current ? 'Replace shape' : 'Add shape');
  }

  function clearDcpShape() {
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    dcpShapeRestoreValidationError = '';
    objects.shape = null;
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    selectDcpObject(null);
    closeDcpShapeLibrary();
    update();
    commitDcpHistoryTransaction(historyStart, 'Delete shape');
  }

  function svgElement(name) {
    return document.createElementNS('http://www.w3.org/2000/svg', name);
  }

  function dcpShapePoints(shapeKey, mapX, mapY) {
    const source = shapeKey === 'triangle' ? [[50, 0], [100, 100], [0, 100]]
      : shapeKey === 'diamond' ? [[50, 0], [100, 50], [50, 100], [0, 50]]
      : shapeKey === 'five_point_star' ? Array.from({ length: 10 }, (_, index) => {
        const radius = index % 2 === 0 ? 50 : 50 * 0.381966;
        const angle = (-90 + index * 36) * Math.PI / 180;
        return [50 + Math.cos(angle) * radius, 50 + Math.sin(angle) * radius];
      }) : [];
    return source.map((point) => mapX(point[0]) + ',' + mapY(point[1])).join(' ');
  }

  function renderDcpShapeSvg(svg, shape, width, height) {
    if (!svg || !shape) return;
    const safeWidth = Math.max(1, width || 240);
    const safeHeight = Math.max(1, height || 160);
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    svg.setAttribute('viewBox', '0 0 ' + safeWidth + ' ' + safeHeight);
    svg.setAttribute('preserveAspectRatio', 'none');
    const strokePercent = dcpShapeThicknessValues[shape.borderThicknessKey] || dcpShapeThicknessValues.medium;
    const hasStroke = shape.borderColorKey !== 'none' && shape.borderColorKey !== 'transparent';
    const strokeWidth = hasStroke ? Math.min(safeWidth, safeHeight) * strokePercent : 0;
    const inset = strokeWidth / 2;
    const innerWidth = Math.max(1, safeWidth - strokeWidth);
    const innerHeight = Math.max(1, safeHeight - strokeWidth);
    const mapX = (value) => inset + innerWidth * value / 100;
    const mapY = (value) => inset + innerHeight * value / 100;
    let element;
    if (shape.shapeKey === 'rectangle' || shape.shapeKey === 'rounded_rectangle') {
      element = svgElement('rect');
      element.setAttribute('x', inset); element.setAttribute('y', inset);
      element.setAttribute('width', innerWidth); element.setAttribute('height', innerHeight);
      if (shape.shapeKey === 'rounded_rectangle') {
        const radius = Math.min(innerWidth, innerHeight) * 0.12;
        element.setAttribute('rx', radius); element.setAttribute('ry', radius);
      }
    } else if (shape.shapeKey === 'circle_oval') {
      element = svgElement('ellipse');
      element.setAttribute('cx', safeWidth / 2); element.setAttribute('cy', safeHeight / 2);
      element.setAttribute('rx', innerWidth / 2); element.setAttribute('ry', innerHeight / 2);
    } else if (shape.shapeKey === 'shield') {
      element = svgElement('path');
      element.setAttribute('d', 'M' + mapX(50) + ',' + mapY(0) + ' L' + mapX(92) + ',' + mapY(14) + ' L' + mapX(86) + ',' + mapY(62) + ' Q' + mapX(78) + ',' + mapY(87) + ' ' + mapX(50) + ',' + mapY(100) + ' Q' + mapX(22) + ',' + mapY(87) + ' ' + mapX(14) + ',' + mapY(62) + ' L' + mapX(8) + ',' + mapY(14) + ' Z');
    } else {
      element = svgElement('polygon');
      element.setAttribute('points', dcpShapePoints(shape.shapeKey, mapX, mapY));
    }
    element.setAttribute('fill', dcpShapeColorValues[shape.fillColorKey] || 'none');
    element.setAttribute('stroke', hasStroke ? dcpShapeColorValues[shape.borderColorKey] : 'none');
    element.setAttribute('stroke-width', strokeWidth);
    element.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(element);
  }

  function renderDcpShapeLibrary() {
    if (!targets.dcpShapeFlyoutGrid) return;
    targets.dcpShapeFlyoutGrid.innerHTML = '';
    dcpShapeCatalog.forEach((item) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'srd-designer-shape-library__item';
      button.dataset.srdDcpShapeChoice = item.shapeKey;
      button.title = item.label; button.setAttribute('aria-label', 'Add ' + item.label + ' shape');
      const svg = svgElement('svg'); svg.classList.add('srd-designer-shape-library__thumbnail');
      svg.dataset.srdDcpShapePreviewAppearance = dcpShapeLibraryAppearance;
      renderDcpShapeSvg(svg, normalizeDcpShapeObject({ shapeKey: item.shapeKey, appearanceMode: dcpShapeLibraryAppearance, fillColorKey: dcpShapeLibraryAppearance === 'outline' ? 'transparent' : 'black', borderColorKey: dcpShapeLibraryAppearance === 'outline' ? 'black' : 'none', borderThicknessKey: 'medium' }), 120, 80);
      const label = document.createElement('span'); label.textContent = item.label;
      button.appendChild(svg); button.appendChild(label); targets.dcpShapeFlyoutGrid.appendChild(button);
    });
    syncDcpShapeLibraryActiveState();
  }

  function syncDcpShapeLibraryActiveState() {
    const shape = normalizeDcpCanvasObjects(getDcpProofState().objects).shape;
    if (targets.dcpShapeFlyoutGrid) targets.dcpShapeFlyoutGrid.querySelectorAll('[data-srd-dcp-shape-choice]').forEach((button) => {
      const active = Boolean(shape && button.dataset.srdDcpShapeChoice === shape.shapeKey);
      button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    targets.dcpShapeLibraryAppearance.forEach((button) => button.classList.toggle('is-active', button.dataset.srdDcpShapeLibraryAppearance === dcpShapeLibraryAppearance));
    if (targets.dcpToolbarShape) targets.dcpToolbarShape.classList.toggle('is-active', Boolean(shape) || (targets.dcpShapeFlyout && !targets.dcpShapeFlyout.hidden));
  }

  function openDcpShapeLibrary() {
    if (!requireDcpObjectToolbarCanvas() || !dcpModeAllows('shape') || !targets.dcpShapeFlyout) return;
    closeDcpHeaderLibrary();
    closeDcpSymbolLibrary();
    renderDcpShapeLibrary(); targets.dcpShapeFlyout.hidden = false;
    if (targets.dcpToolbarShape) targets.dcpToolbarShape.setAttribute('aria-expanded', 'true');
    syncDcpShapeLibraryActiveState();
  }

  function closeDcpShapeLibrary() {
    if (!targets.dcpShapeFlyout) return;
    targets.dcpShapeFlyout.hidden = true;
    if (targets.dcpToolbarShape) targets.dcpToolbarShape.setAttribute('aria-expanded', 'false');
    syncDcpShapeLibraryActiveState();
  }

  function normalizeDcpSymbolSearch(value) {
    return String(value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('en-US');
  }

  function trustedDcpSymbolFileSource(source, pngAsset) {
    const filename = String(pngAsset || '').trim();
    const value = String(source || '').trim();
    if (!/^srd-dcp-symbol-[a-z0-9-]+\.png$/.test(filename) || !value) return '';
    try {
      const url = new URL(value, window.location.href);
      const expectedPath = `/cdn/shop/files/${filename}`;
      if (!/^https?:$/.test(url.protocol)
        || decodeURIComponent(url.pathname) !== expectedPath
        || Array.from(url.searchParams.keys()).some((key) => key !== 'v')) return '';
      return `${url.pathname}${url.search}`;
    } catch (_error) {
      return '';
    }
  }

  function readDcpSymbolCatalog() {
    if (dcpSymbolCatalogCache) return dcpSymbolCatalogCache;
    try {
      const parsed = JSON.parse(targets.dcpSymbolCatalog ? targets.dcpSymbolCatalog.textContent : '');
      const symbols = Array.isArray(parsed.symbols) ? parsed.symbols : [];
      const ids = new Set();
      const titles = new Set();
      if (parsed.schemaVersion !== 'srd-dcp-symbol-catalog-schema-v2'
        || parsed.catalogVersion !== dcpSymbolCatalogVersion
        || parsed.recordCount !== 148
        || symbols.length !== 148) throw new Error('Unexpected trusted Symbol catalog version or count.');
      symbols.forEach((item) => {
        const id = String(item.canonicalId || '');
        const title = String(item.displayTitle || '').trim();
        const titleKey = title.toLocaleLowerCase('en-US');
        const bounds = Array.isArray(item.contentBounds) ? item.contentBounds.map(Number) : [];
        const pixelWidth = Number(item.pixelWidth);
        const pixelHeight = Number(item.pixelHeight);
        const contentAspectRatio = Number(item.contentAspectRatio);
        const trustedFileSource = trustedDcpSymbolFileSource(item.src, item.pngAsset);
        if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(id)
          || !title
          || !String(item.thumbnailSrc || '').trim()
          || !trustedFileSource
          || !/^srd-dcp-symbol-[a-z0-9-]+\.png$/.test(String(item.pngAsset || ''))
          || !/^[a-f0-9]{64}$/.test(String(item.pngSha256 || ''))
          || !String(item.epsMaster || '').trim()
          || !/^[a-f0-9]{64}$/.test(String(item.epsSha256 || ''))
          || pixelWidth !== 2048
          || pixelHeight !== 2048
          || bounds.length !== 4
          || bounds.some((value) => !Number.isFinite(value))
          || bounds[0] < 0 || bounds[1] < 0 || bounds[2] > pixelWidth || bounds[3] > pixelHeight
          || bounds[2] <= bounds[0] || bounds[3] <= bounds[1]
          || !Number.isFinite(contentAspectRatio) || contentAspectRatio <= 0
          || ids.has(id)
          || titles.has(titleKey)) throw new Error('Invalid or duplicate trusted Symbol record.');
        item.src = trustedFileSource;
        ids.add(id);
        titles.add(titleKey);
      });
      const ordered = symbols.map((item, index) => ({ ...item, catalogIndex: index })).sort((left, right) => {
        const titleOrder = left.displayTitle.toLocaleLowerCase('en-US').localeCompare(right.displayTitle.toLocaleLowerCase('en-US'), 'en-US');
        return titleOrder || left.catalogIndex - right.catalogIndex;
      });
      dcpSymbolCatalogCache = { ok: true, symbols: ordered };
    } catch (error) {
      dcpSymbolCatalogCache = { ok: false, symbols: [], message: 'Symbols are temporarily unavailable.' };
      if (window.console && typeof window.console.error === 'function') window.console.error('SRD Symbols catalog validation failed.', error);
    }
    return dcpSymbolCatalogCache;
  }

  function disconnectDcpSymbolObserver() {
    if (dcpSymbolObserver) dcpSymbolObserver.disconnect();
    dcpSymbolObserver = null;
  }

  function loadDcpSymbolThumbnail(image) {
    if (!image || image.dataset.srdDcpSymbolLoaded === 'true') return;
    const source = image.dataset.srdDcpSymbolThumbnailSrc;
    if (!source) return;
    image.dataset.srdDcpSymbolLoaded = 'true';
    image.src = source;
  }

  function loadVisibleDcpSymbolThumbnails() {
    if (!targets.dcpSymbolResults || targets.dcpSymbolFlyout.hidden) return;
    const viewport = targets.dcpSymbolResults.getBoundingClientRect();
    targets.dcpSymbolGrid.querySelectorAll('[data-srd-dcp-symbol-thumbnail-src]').forEach((image) => {
      if (image.dataset.srdDcpSymbolLoaded === 'true') return;
      const card = image.closest('[data-srd-dcp-symbol-choice]');
      const bounds = card ? card.getBoundingClientRect() : null;
      if (bounds && bounds.bottom >= viewport.top - 160 && bounds.top <= viewport.bottom + 160) loadDcpSymbolThumbnail(image);
    });
  }

  function observeDcpSymbolThumbnails() {
    disconnectDcpSymbolObserver();
    if (!targets.dcpSymbolGrid || !targets.dcpSymbolResults || targets.dcpSymbolFlyout.hidden) return;
    const images = Array.from(targets.dcpSymbolGrid.querySelectorAll('[data-srd-dcp-symbol-thumbnail-src]'))
      .filter((image) => image.dataset.srdDcpSymbolLoaded !== 'true');
    if (typeof IntersectionObserver !== 'function') {
      loadVisibleDcpSymbolThumbnails();
      return;
    }
    dcpSymbolObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadDcpSymbolThumbnail(entry.target);
        if (dcpSymbolObserver) dcpSymbolObserver.unobserve(entry.target);
      });
    }, { root: targets.dcpSymbolResults, rootMargin: '160px 0px', threshold: 0.01 });
    images.forEach((image) => dcpSymbolObserver.observe(image));
  }

  function filteredDcpSymbols(symbols) {
    const query = normalizeDcpSymbolSearch(dcpSymbolQuery);
    if (!query) return symbols;
    return symbols.filter((item) => normalizeDcpSymbolSearch(item.displayTitle).includes(query)
      || normalizeDcpSymbolSearch(item.canonicalId).includes(query));
  }

  function renderDcpSymbolLibrary() {
    if (!targets.dcpSymbolGrid || !targets.dcpSymbolState || !targets.dcpSymbolCount) return;
    disconnectDcpSymbolObserver();
    targets.dcpSymbolGrid.replaceChildren();
    const catalog = readDcpSymbolCatalog();
    if (!catalog.ok) {
      targets.dcpSymbolState.hidden = false;
      targets.dcpSymbolState.textContent = catalog.message;
      targets.dcpSymbolCount.textContent = 'Symbols unavailable';
      return;
    }
    const symbols = filteredDcpSymbols(catalog.symbols);
    targets.dcpSymbolCount.textContent = dcpSymbolQuery
      ? 'Showing ' + symbols.length + ' of ' + catalog.symbols.length + ' symbols'
      : catalog.symbols.length + ' symbols';
    targets.dcpSymbolSearchClear.hidden = !dcpSymbolQuery;
    if (!symbols.length) {
      targets.dcpSymbolState.hidden = false;
      targets.dcpSymbolState.textContent = 'No symbols match your search.';
      return;
    }
    targets.dcpSymbolState.hidden = true;
    symbols.forEach((item) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'srd-designer-symbol-library__item';
      button.dataset.srdDcpSymbolChoice = item.canonicalId;
      button.setAttribute('aria-label', 'Add ' + item.displayTitle + ' symbol');
      button.title = item.displayTitle;
      const thumbnail = document.createElement('span');
      thumbnail.className = 'srd-designer-symbol-library__thumbnail';
      const image = document.createElement('img');
      image.alt = item.displayTitle + ' symbol';
      image.width = Number(item.thumbnailWidth) || 256;
      image.height = Number(item.thumbnailHeight) || 256;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.dataset.srdDcpSymbolThumbnailSrc = item.thumbnailSrc;
      const fallback = document.createElement('span');
      fallback.className = 'srd-designer-symbol-library__thumbnail-fallback';
      fallback.textContent = 'Preview unavailable';
      fallback.hidden = true;
      image.addEventListener('error', () => {
        image.hidden = true;
        fallback.hidden = false;
        button.classList.add('has-thumbnail-error');
      }, { once: true });
      const label = document.createElement('span');
      label.className = 'srd-designer-symbol-library__label';
      label.textContent = item.displayTitle;
      thumbnail.appendChild(image);
      thumbnail.appendChild(fallback);
      button.appendChild(thumbnail);
      button.appendChild(label);
      targets.dcpSymbolGrid.appendChild(button);
    });
    observeDcpSymbolThumbnails();
  }

  function syncDcpSymbolToolbarEligibility() {
    if (!targets.dcpToolbarSymbol) return;
    const eligible = isBlankCanvasMode(controls.template.value) && selectedBlankCanvasSubfamily() === 'print_design';
    targets.dcpToolbarSymbol.disabled = !eligible;
    if (!eligible) closeDcpSymbolLibrary();
  }

  function openDcpSymbolLibrary(mode) {
    if (isDieCuttingMode()) {
      setDieCuttingDevelopmentMessage('Symbols are unavailable for Die Cutting.');
      return;
    }
    if (!requireDcpObjectToolbarCanvas()
      || selectedBlankCanvasSubfamily() !== 'print_design'
      || !targets.dcpSymbolFlyout) return;
    const selected = selectedDcpSymbolObject(normalizeDcpCanvasObjects((currentDcpProofState || emptyDcpProofState()).objects));
    dcpSymbolLibraryMode = mode === 'replace' && selected ? 'replace' : 'add';
    dcpSymbolReplacementId = dcpSymbolLibraryMode === 'replace' ? selected.id : '';
    closeDcpHeaderLibrary();
    closeDcpShapeLibrary();
    targets.dcpSymbolFlyout.hidden = false;
    targets.dcpToolbarSymbol.setAttribute('aria-expanded', 'true');
    targets.dcpToolbarSymbol.classList.add('is-active');
    if (!targets.dcpSymbolGrid.childElementCount) renderDcpSymbolLibrary();
    else observeDcpSymbolThumbnails();
  }

  function closeDcpSymbolLibrary() {
    if (!targets.dcpSymbolFlyout) return;
    disconnectDcpSymbolObserver();
    targets.dcpSymbolFlyout.hidden = true;
    if (targets.dcpToolbarSymbol) {
      targets.dcpToolbarSymbol.setAttribute('aria-expanded', 'false');
      targets.dcpToolbarSymbol.classList.remove('is-active');
    }
  }

  function trustedDcpSymbolRecord(canonicalId) {
    const catalog = readDcpSymbolCatalog();
    return catalog.ok ? catalog.symbols.find((item) => item.canonicalId === canonicalId) || null : null;
  }

  function nextDcpSymbolObjectId(objects) {
    const used = new Set((objects && objects.symbolObjects || []).map((item) => item.id));
    let id = '';
    do {
      dcpSymbolObjectCounter += 1;
      id = 'symbol_' + Date.now().toString(36) + '_' + dcpSymbolObjectCounter.toString(36);
    } while (used.has(id));
    return id;
  }

  function dcpSymbolGeometry(catalogItem, physicalSize, index) {
    if (!catalogItem || !physicalSize) return null;
    const aspect = Number(catalogItem.contentAspectRatio);
    const extent = Math.min(physicalSize.width, physicalSize.height) * 0.25;
    const widthInches = aspect >= 1 ? extent : extent * aspect;
    const heightInches = aspect >= 1 ? extent / aspect : extent;
    const offset = Math.min(Number(index) || 0, 8) * 3;
    const width = widthInches / physicalSize.width * 100;
    const height = heightInches / physicalSize.height * 100;
    const maxX = 100 - width / 2;
    const maxY = 100 - height / 2;
    return {
      x: clampDcpNumber(50 + offset, width / 2, maxX, 50),
      y: clampDcpNumber(50 + offset, height / 2, maxY, 50),
      width: width,
      height: height
    };
  }

  function normalizeDcpSymbolObject(item) {
    if (!item || typeof item !== 'object') return null;
    const catalogItem = trustedDcpSymbolRecord(item.canonicalId);
    const id = typeof item.id === 'string' && /^symbol_[a-z0-9_-]+$/i.test(item.id) ? item.id : '';
    if (!catalogItem || !id) return null;
    const geometry = [item.x, item.y, item.width, item.height, item.rotation].map(Number);
    if (!geometry.every(Number.isFinite)
      || geometry[0] < 0 || geometry[0] > 100
      || geometry[1] < 0 || geometry[1] > 100
      || geometry[2] < 1 || geometry[2] > 100
      || geometry[3] < 1 || geometry[3] > 100
      || geometry[4] < -180 || geometry[4] > 180) return null;
    const width = geometry[2];
    const height = geometry[3];
    const base = {
      id: id,
      objectType: 'symbol',
      canonicalId: catalogItem.canonicalId,
      catalogVersion: dcpSymbolCatalogVersion,
      assetVersion: dcpSymbolAssetVersion,
      displayTitle: catalogItem.displayTitle,
      pngAsset: catalogItem.pngAsset,
      pngSha256: catalogItem.pngSha256,
      epsMaster: catalogItem.epsMaster,
      epsSha256: catalogItem.epsSha256,
      src: catalogItem.src,
      contentBounds: catalogItem.contentBounds.map(Number),
      aspectRatio: Number(catalogItem.contentAspectRatio),
      pixelWidth: Number(catalogItem.pixelWidth),
      pixelHeight: Number(catalogItem.pixelHeight),
      x: clampDcpNumber(geometry[0], width / 2, 100 - width / 2, 50),
      y: clampDcpNumber(geometry[1], height / 2, 100 - height / 2, 50),
      width: width,
      height: height,
      rotation: geometry[4],
      layer: 25
    };
    const physicalSize = dcpPhysicalSize(controls.size ? controls.size.value : '');
    return physicalSize ? dcpProportionalGeometryForCanvas(base, base.aspectRatio, physicalSize) : base;
  }

  function normalizeDcpSymbolObjects(items) {
    if (!Array.isArray(items)) return [];
    const ids = new Set();
    return items.map(normalizeDcpSymbolObject).filter((item) => {
      if (!item || ids.has(item.id)) return false;
      ids.add(item.id);
      return true;
    });
  }

  function validateDcpSymbolObjects(items, size, requireReady) {
    if (items === undefined || items === null) {
      return { valid: true, present: false, ready: true, symbols: [], message: '' };
    }
    if (!Array.isArray(items)) {
      return { valid: false, present: true, ready: false, symbols: [], message: 'Symbol data is not valid.' };
    }
    const physicalSize = dcpPhysicalSize(size || (controls.size ? controls.size.value : ''));
    const ids = new Set();
    const symbols = [];
    for (const item of items) {
      const catalogItem = item && typeof item === 'object' ? trustedDcpSymbolRecord(item.canonicalId) : null;
      if (!catalogItem) {
        return { valid: false, present: true, ready: false, symbols: [], message: 'The selected Symbol is not recognized.' };
      }
      const identityMatches = item.catalogVersion === dcpSymbolCatalogVersion
        && item.assetVersion === dcpSymbolAssetVersion
        && item.displayTitle === catalogItem.displayTitle
        && item.pngAsset === catalogItem.pngAsset
        && item.pngSha256 === catalogItem.pngSha256
        && item.epsMaster === catalogItem.epsMaster
        && item.epsSha256 === catalogItem.epsSha256
        && item.src === catalogItem.src
        && item.layer === 25;
      if (!identityMatches) {
        return { valid: false, present: true, ready: false, symbols: [], message: 'The selected Symbol identity is not trusted.' };
      }
      if (typeof item.id !== 'string' || !/^symbol_[a-z0-9_-]+$/i.test(item.id) || ids.has(item.id)) {
        return { valid: false, present: true, ready: false, symbols: [], message: 'The selected Symbol instance is not valid.' };
      }
      const geometry = [item.x, item.y, item.width, item.height, item.rotation];
      if (geometry.some((value) => typeof value !== 'number' || !Number.isFinite(value))
        || item.width <= 0 || item.height <= 0
        || item.width > 100 || item.height > 100
        || item.rotation < -180 || item.rotation > 180
        || item.x - item.width / 2 < -0.001 || item.x + item.width / 2 > 100.001
        || item.y - item.height / 2 < -0.001 || item.y + item.height / 2 > 100.001) {
        return { valid: false, present: true, ready: false, symbols: [], message: 'The selected Symbol placement is not valid.' };
      }
      if (!physicalSize) {
        return { valid: false, present: true, ready: false, symbols: [], message: 'Select a finished size before using a Symbol.' };
      }
      const renderedAspect = item.width * physicalSize.width / (item.height * physicalSize.height);
      const trustedAspect = Number(catalogItem.contentAspectRatio);
      if (!Number.isFinite(trustedAspect) || trustedAspect <= 0
        || Math.abs(renderedAspect - trustedAspect) / trustedAspect > 0.02) {
        return { valid: false, present: true, ready: false, symbols: [], message: 'The selected Symbol proportions are not valid.' };
      }
      const normalized = normalizeDcpSymbolObject(item);
      if (!normalized) {
        return { valid: false, present: true, ready: false, symbols: [], message: 'The selected Symbol could not be validated.' };
      }
      ids.add(item.id);
      symbols.push(normalized);
    }
    const ready = !requireReady || symbols.every((symbol) => dcpSymbolMasterLoads.has(symbol.canonicalId));
    return {
      valid: true,
      present: symbols.length > 0,
      ready: ready,
      symbols: symbols,
      message: ready ? '' : 'The selected Symbol artwork is not ready.'
    };
  }

  function dcpSymbolValidation(objects, size, requireReady) {
    const source = objects && typeof objects === 'object' ? objects : getDcpProofState().objects;
    const items = source && source.symbolObjects;
    if (dcpSymbolRestoreValidationError) {
      return {
        valid: false,
        present: true,
        ready: false,
        symbols: normalizeDcpSymbolObjects(items),
        message: dcpSymbolRestoreValidationError
      };
    }
    const validation = validateDcpSymbolObjects(items, size, requireReady);
    if (requireReady && validation.valid && validation.present && dcpSymbolRestorePending) {
      return {
        ...validation,
        ready: false,
        message: 'The restored Symbol artwork is still loading.'
      };
    }
    return validation;
  }

  function serializedDcpSymbolObject(symbol) {
    return {
      id: symbol.id,
      canonicalId: symbol.canonicalId,
      catalogVersion: dcpSymbolCatalogVersion,
      assetVersion: dcpSymbolAssetVersion,
      x: symbol.x,
      y: symbol.y,
      width: symbol.width,
      height: symbol.height,
      rotation: symbol.rotation,
      layer: 25
    };
  }

  function validateSerializedDcpSymbolObjects(items, size) {
    if (items === undefined) {
      return { valid: true, present: false, symbols: [], message: '' };
    }
    if (!Array.isArray(items)) {
      return { valid: false, present: true, symbols: [], message: 'Saved Symbol data is not an array.' };
    }
    const allowedKeys = new Set([
      'id',
      'canonicalId',
      'catalogVersion',
      'assetVersion',
      'x',
      'y',
      'width',
      'height',
      'rotation',
      'layer'
    ]);
    const requiredKeys = Array.from(allowedKeys);
    const ids = new Set();
    const restored = [];
    const physicalSize = dcpPhysicalSize(size || (controls.size ? controls.size.value : ''));
    for (const item of items) {
      if (!item || typeof item !== 'object' || Array.isArray(item)) {
        return { valid: false, present: true, symbols: restored, message: 'A saved Symbol instance is malformed.' };
      }
      const keys = Object.keys(item);
      if (keys.some((key) => !allowedKeys.has(key)) || requiredKeys.some((key) => !Object.prototype.hasOwnProperty.call(item, key))) {
        return { valid: false, present: true, symbols: restored, message: 'A saved Symbol contains unsupported or missing fields.' };
      }
      const catalogItem = trustedDcpSymbolRecord(item.canonicalId);
      if (!catalogItem
        || item.catalogVersion !== dcpSymbolCatalogVersion
        || item.assetVersion !== dcpSymbolAssetVersion
        || item.layer !== 25) {
        return { valid: false, present: true, symbols: restored, message: 'A saved Symbol identity is unavailable or untrusted.' };
      }
      if (typeof item.id !== 'string' || !/^symbol_[a-z0-9_-]+$/i.test(item.id) || ids.has(item.id)) {
        return { valid: false, present: true, symbols: restored, message: 'A saved Symbol instance ID is missing or duplicated.' };
      }
      const geometry = [item.x, item.y, item.width, item.height, item.rotation];
      if (geometry.some((value) => typeof value !== 'number' || !Number.isFinite(value))
        || item.width <= 0 || item.height <= 0
        || item.width > 100 || item.height > 100
        || item.rotation < -180 || item.rotation > 180
        || item.x - item.width / 2 < -0.001 || item.x + item.width / 2 > 100.001
        || item.y - item.height / 2 < -0.001 || item.y + item.height / 2 > 100.001) {
        return { valid: false, present: true, symbols: restored, message: 'A saved Symbol has invalid geometry.' };
      }
      if (!physicalSize) {
        return { valid: false, present: true, symbols: restored, message: 'A finished size is required to restore Symbols.' };
      }
      const renderedAspect = item.width * physicalSize.width / (item.height * physicalSize.height);
      const trustedAspect = Number(catalogItem.contentAspectRatio);
      if (!Number.isFinite(trustedAspect)
        || trustedAspect <= 0
        || Math.abs(renderedAspect - trustedAspect) / trustedAspect > 0.02) {
        return { valid: false, present: true, symbols: restored, message: 'A saved Symbol has an invalid aspect ratio.' };
      }
      const normalized = normalizeDcpSymbolObject(item);
      const validation = normalized ? validateDcpSymbolObjects([normalized], size, false) : null;
      if (!validation || !validation.valid || !validation.symbols.length) {
        return { valid: false, present: true, symbols: restored, message: 'A saved Symbol could not be revalidated.' };
      }
      ids.add(item.id);
      restored.push(validation.symbols[0]);
    }
    return {
      valid: true,
      present: restored.length > 0,
      symbols: restored,
      message: ''
    };
  }

  function dcpSymbolCartProperties(objects, size, requireReady) {
    const validation = dcpSymbolValidation(objects, size, requireReady !== false);
    if (!validation.valid || !validation.present || (requireReady !== false && !validation.ready)) return {};
    const counts = new Map();
    validation.symbols.forEach((symbol) => {
      const entry = counts.get(symbol.canonicalId) || { title: symbol.displayTitle, count: 0 };
      entry.count += 1;
      counts.set(symbol.canonicalId, entry);
    });
    const summary = Array.from(counts.values())
      .map((entry) => entry.title + (entry.count > 1 ? ' (' + entry.count + ')' : ''))
      .join('; ');
    const contract = {
      contractVersion: dcpSymbolProductionContractVersion,
      catalogVersion: dcpSymbolCatalogVersion,
      instances: validation.symbols.map((symbol) => ({
        instanceId: symbol.id,
        canonicalId: symbol.canonicalId,
        assetVersion: dcpSymbolAssetVersion,
        epsSha256: trustedDcpSymbolRecord(symbol.canonicalId).epsSha256
      }))
    };
    return {
      Symbols: summary,
      '_dcp_symbol_production': JSON.stringify(contract)
    };
  }

  function dcpSymbolSerializationError(message) {
    const error = new Error('Symbol cart state could not be prepared: ' + (message || 'The Symbol state is not trusted.'));
    error.code = 'DCP_SYMBOL_SERIALIZATION_FAILED';
    return error;
  }

  function serializedDcpSymbolObjects(objects, size, requireReady) {
    const validation = dcpSymbolValidation(objects, size, requireReady !== false);
    if (!validation.valid || (requireReady !== false && !validation.ready)) {
      throw dcpSymbolSerializationError(validation.message);
    }
    return validation.symbols.map(serializedDcpSymbolObject);
  }

  function dcpSymbolSubmissionSnapshot(data) {
    if (!data || data.selected_template_category !== 'blank_canvas') return '';
    const current = serializedDcpSymbolObjects(getDcpProofState().objects, data.size, true);
    const prepared = validateSerializedDcpSymbolObjects(
      data.dcp_canvas_objects && data.dcp_canvas_objects.symbolObjects,
      data.size
    );
    if (!prepared.valid) throw dcpSymbolSerializationError(prepared.message);
    const currentSnapshot = JSON.stringify(current);
    const preparedSnapshot = JSON.stringify(prepared.symbols.map(serializedDcpSymbolObject));
    if (currentSnapshot !== preparedSnapshot) {
      throw dcpSymbolSerializationError('The Symbol design changed before submission preparation completed.');
    }
    return currentSnapshot;
  }

  function assertDcpSymbolSubmissionSnapshotCurrent(data, snapshot) {
    if (!snapshot && (!data || data.selected_template_category !== 'blank_canvas')) return;
    if (dcpSymbolSubmissionSnapshot(data) !== snapshot) {
      throw dcpSymbolSerializationError('The Symbol design changed while the cart payload was being prepared.');
    }
  }

  function selectedDcpSymbolObject(objects) {
    if (dcpObjectType(selectedDcpObject) !== 'symbol') return null;
    const normalized = objects && Array.isArray(objects.symbolObjects) ? objects : normalizeDcpCanvasObjects(objects || getDcpProofState().objects);
    const id = dcpObjectId(selectedDcpObject);
    return normalized.symbolObjects.find((item) => item.id === id) || null;
  }

  function loadTrustedDcpSymbolMaster(catalogItem) {
    if (!catalogItem || !catalogItem.src) return Promise.reject(new Error('The selected Symbol is not available.'));
    if (dcpSymbolMasterLoads.has(catalogItem.canonicalId)) return dcpSymbolMasterLoads.get(catalogItem.canonicalId);
    const load = new Promise((resolve, reject) => {
      const image = new Image();
      let settled = false;
      const finish = (error) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        image.onload = null;
        image.onerror = null;
        if (error) reject(error);
        else resolve(catalogItem);
      };
      const timeout = setTimeout(() => finish(new Error('The full-resolution Symbol took too long to load.')), 10000);
      image.onload = () => finish(
        image.naturalWidth !== Number(catalogItem.pixelWidth)
          || image.naturalHeight !== Number(catalogItem.pixelHeight)
          ? new Error('The full-resolution Symbol dimensions do not match the trusted catalog.')
          : null
      );
      image.onerror = () => finish(new Error('The full-resolution Symbol could not be loaded.'));
      image.src = catalogItem.src;
    }).catch((error) => {
      dcpSymbolMasterLoads.delete(catalogItem.canonicalId);
      throw error;
    });
    dcpSymbolMasterLoads.set(catalogItem.canonicalId, load);
    return load;
  }

  function dcpRestoredSymbolSnapshot(symbols) {
    return JSON.stringify((symbols || []).map(serializedDcpSymbolObject));
  }

  function prepareDcpRestoredSymbolAssets(objects) {
    const normalized = normalizeDcpCanvasObjects(objects);
    const symbols = normalized.symbolObjects;
    const revision = ++dcpSymbolLoadRevision;
    dcpSymbolRestorePending = Boolean(symbols.length && !dcpSymbolRestoreValidationError);
    if (!dcpSymbolRestorePending) return Promise.resolve(false);
    const snapshot = dcpRestoredSymbolSnapshot(symbols);
    const uniqueRecords = Array.from(new Set(symbols.map((symbol) => symbol.canonicalId)))
      .map(trustedDcpSymbolRecord)
      .filter(Boolean);
    return Promise.all(uniqueRecords.map(loadTrustedDcpSymbolMaster)).then(() => {
      const current = normalizeDcpCanvasObjects(getDcpProofState().objects);
      if (revision !== dcpSymbolLoadRevision
        || !isBlankCanvasMode(controls.template ? controls.template.value : '')
        || selectedBlankCanvasSubfamily() !== 'print_design'
        || dcpRestoredSymbolSnapshot(current.symbolObjects) !== snapshot) return false;
      dcpSymbolRestorePending = false;
      dcpSymbolRestoreValidationError = '';
      update();
      return true;
    }).catch((error) => {
      if (revision !== dcpSymbolLoadRevision) return false;
      dcpSymbolRestorePending = false;
      dcpSymbolRestoreValidationError = 'Trusted Symbol artwork could not be loaded. Remove and re-add the Symbol.';
      if (targets.dcpSymbolActivationStatus) targets.dcpSymbolActivationStatus.textContent = dcpSymbolRestoreValidationError;
      debugLog('restored Symbol readiness failed', error);
      update();
      return false;
    });
  }

  function replaceOrAddDcpSymbol(catalogItem, replacementId) {
    const physicalSize = activeDcpPhysicalSize();
    if (!physicalSize) throw new Error('Select a finished size before adding a Symbol.');
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const selected = replacementId
      ? objects.symbolObjects.find((item) => item.id === replacementId) || null
      : null;
    let nextSelection = null;
    dcpSymbolLoadRevision += 1;
    dcpSymbolRestorePending = false;
    dcpSymbolRestoreValidationError = '';
    if (selected) {
      const largestInches = Math.max(selected.width / 100 * physicalSize.width, selected.height / 100 * physicalSize.height);
      const aspect = Number(catalogItem.contentAspectRatio);
      const widthInches = aspect >= 1 ? largestInches : largestInches * aspect;
      const heightInches = aspect >= 1 ? largestInches / aspect : largestInches;
      const replacement = normalizeDcpSymbolObject({
        id: selected.id,
        canonicalId: catalogItem.canonicalId,
        x: selected.x,
        y: selected.y,
        width: widthInches / physicalSize.width * 100,
        height: heightInches / physicalSize.height * 100,
        rotation: selected.rotation
      });
      const index = objects.symbolObjects.findIndex((item) => item.id === selected.id);
      objects.symbolObjects.splice(index, 1, replacement);
      nextSelection = dcpSymbolSelection(replacement.id);
    } else {
      const geometry = dcpSymbolGeometry(catalogItem, physicalSize, objects.symbolObjects.length);
      const object = normalizeDcpSymbolObject({
        id: nextDcpSymbolObjectId(objects),
        canonicalId: catalogItem.canonicalId,
        ...geometry,
        rotation: 0
      });
      objects.symbolObjects.push(object);
      nextSelection = dcpSymbolSelection(object.id);
    }
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    selectDcpObject(nextSelection);
    update();
    commitDcpHistoryTransaction(historyStart, selected ? 'Replace symbol' : 'Add symbol');
  }

  async function activateDcpSymbolLibraryCard(canonicalId) {
    if (isDieCuttingMode()) {
      setDieCuttingDevelopmentMessage('Symbols are unavailable for Die Cutting.');
      return;
    }
    const item = trustedDcpSymbolRecord(canonicalId);
    if (!item || !targets.dcpSymbolActivationStatus) return;
    const revision = ++dcpSymbolLoadRevision;
    const selectionAtActivation = selectedDcpObject;
    const replacementId = dcpSymbolLibraryMode === 'replace' ? dcpSymbolReplacementId : '';
    targets.dcpSymbolActivationStatus.textContent = 'Loading ' + item.displayTitle + '...';
    try {
      await loadTrustedDcpSymbolMaster(item);
      if (revision !== dcpSymbolLoadRevision
        || !isBlankCanvasMode(controls.template.value)
        || selectedBlankCanvasSubfamily() !== 'print_design') return;
      if (selectedDcpObject !== selectionAtActivation) {
        targets.dcpSymbolActivationStatus.textContent = 'Symbol placement canceled because the canvas selection changed.';
        return;
      }
        replaceOrAddDcpSymbol(item, replacementId);
      targets.dcpSymbolActivationStatus.textContent = item.displayTitle + ' added to the canvas.';
      closeDcpSymbolLibrary();
    } catch (error) {
      if (revision !== dcpSymbolLoadRevision) return;
      targets.dcpSymbolActivationStatus.textContent = error && error.message ? error.message : 'The selected Symbol could not be loaded.';
    }
  }

  function removeDcpSymbolObject(id) {
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const targetId = id || dcpObjectId(selectedDcpObject);
    const nextSymbols = objects.symbolObjects.filter((item) => item.id !== targetId);
    if (nextSymbols.length === objects.symbolObjects.length) return;
    dcpSymbolLoadRevision += 1;
    dcpSymbolRestorePending = false;
    dcpSymbolRestoreValidationError = '';
    objects.symbolObjects = nextSymbols;
    proof.objects = objects;
    currentDcpProofState = proof;
    clearDcpObjectSelection();
    syncDcpProofCompatibilityAlias();
    update();
    commitDcpHistoryTransaction(historyStart, 'Delete symbol');
  }

  function updateSelectedDcpSymbolRotation(value) {
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    const symbol = selectedDcpSymbolObject(objects);
    if (!symbol) return;
    const historyStart = beginDcpHistoryTransaction();
    updateDcpObjectTransform(selectedDcpObject, { rotation: value });
    applyDcpObjectStyles();
    renderDcpSelectedObjectPanel(getDcpProofState().objects);
    commitDcpHistoryTransaction(historyStart, 'Rotate symbol', {
      coalescingKey: 'symbol-rotation:' + symbol.id,
      coalescingWindow: 300
    });
  }

  function addDcpTextObject(options) {
    const settings = options || {};
    if (!isBlankCanvasMode(controls.template.value)) return;
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    if (isDieCuttingMode()) {
      const allowance = dcpDieTextObjectAllowance(dcpPhysicalCanvasForProof(proof).height);
      if (objects.textObjects.length >= allowance) return;
    } else if (objects.textObjects.length >= 3) return;
    const position = nextDcpTextObjectPosition(objects);
    const fontKey = dcpDefaultFontKey(currentDcpFontWorkflow());
    const colorKey = isDieCuttingMode()
      ? (authorizedDcpDieVinylColorKey(proof.dieVinylColorKey) || 'white')
      : 'black';
    if (failedDcpFontIds.has(fontKey) || dcpFontLoadPromises.has(fontKey)) {
      setDieCuttingDevelopmentMessage(failedDcpFontIds.has(fontKey)
        ? 'The default font could not be loaded. Text creation is unavailable.'
        : 'The default font is loading. Try Add Text again in a moment.');
      return;
    }
    const historyStart = settings.history === false ? null : beginDcpHistoryTransaction();
    const object = normalizeDcpTextObject({
      id: nextDcpTextObjectId(),
      text: 'NEW TEXT',
      font: fontLabels[fontKey] || fontLabels.arial || 'Arial Bold',
      fontKey: fontKey,
      fontColor: dcpTextColorLabel(colorKey, activeDcpWorkspaceMode),
      fontColorKey: colorKey,
      x: position.x,
      y: position.y,
      width: isDieCuttingMode() ? 34 : 24,
      height: isDieCuttingMode() ? 10 : 8,
      scale: 1,
      maxFontSize: 260,
      textShape: 'straight',
      arcAmount: 35,
      rotation: 0
    }, objects.textObjects.length, activeDcpWorkspaceMode);
    if (isDieCuttingMode()) Object.assign(object, dcpDieInitialTextGeometry(object, position, proof));
    objects.textObjects.push(object);
    proof.objects = objects;
    currentDcpProofState = proof;
    selectDcpObject(dcpTextSelection(object.id));
    syncDcpProofCompatibilityAlias();
    if (settings.update !== false) update();
    if (historyStart) commitDcpHistoryTransaction(historyStart, 'Add text');
    return object;
  }

  function openDcpTextTool() {
    if (!requireDcpObjectToolbarCanvas()) return;
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    const selectedText = selectedDcpTextObject(objects);
    if (selectedText) {
      if (selectedDcpObjects.length > 1) selectDcpObject(dcpTextSelection(selectedText.id));
      syncDcpTextEditorFromSelection(objects);
      syncDcpToolbarAndEditor(objects);
      if (controls.dcpTextInput) controls.dcpTextInput.focus();
      return;
    }
    addDcpTextObject();
  }

  function dcpHeaderHeightForWidth(catalogItem, width) {
    const rect = targets.proofArtboard ? targets.proofArtboard.getBoundingClientRect() : null;
    const canvasWidth = rect && rect.width ? rect.width : 1000;
    const canvasHeight = rect && rect.height ? rect.height : 700;
    const aspect = catalogItem.aspectRatio;
    return width * canvasWidth / canvasHeight / aspect;
  }

  function constrainedDcpHeaderGeometry(catalogItem, geometry) {
    const x = clampDcpNumber(geometry && geometry.x, 0, 100, 50);
    const y = clampDcpNumber(geometry && geometry.y, 0, 100, 20);
    let width = clampDcpNumber(geometry && geometry.width, 4, 96, 60);
    let height = dcpHeaderHeightForWidth(catalogItem, width);
    const maxWidth = Math.max(4, Math.min(x, 100 - x) * 2);
    const maxHeight = Math.max(2, Math.min(y, 100 - y) * 2);
    if (width > maxWidth || height > maxHeight) {
      const factor = Math.min(maxWidth / width, maxHeight / height);
      width *= factor;
      height *= factor;
    }
    return { x: x, y: y, width: width, height: height };
  }

  function setDcpHeader(libraryKey) {
    if (isDieCuttingMode()) {
      setDieCuttingDevelopmentMessage('Headers are unavailable for Die Cutting.');
      return;
    }
    if (!isBlankCanvasMode(controls.template.value)) return;
    const catalogItem = dcpHeaderCatalogByKey[libraryKey];
    if (!catalogItem) return;
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const current = objects.header;
    const geometry = constrainedDcpHeaderGeometry(catalogItem, current || { x: 50, y: 20, width: 60 });
    objects.header = normalizeDcpHeaderObject({
      libraryKey: catalogItem.libraryKey,
      x: geometry.x,
      y: geometry.y,
      width: geometry.width,
      height: geometry.height
    });
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    selectDcpObject('header');
    closeDcpHeaderLibrary();
    update();
    commitDcpHistoryTransaction(historyStart, current ? 'Replace header' : 'Add header');
  }

  function clearDcpHeader() {
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    objects.header = null;
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    selectDcpObject(null);
    closeDcpHeaderLibrary();
    update();
    commitDcpHistoryTransaction(historyStart, 'Delete header');
  }

  function renderDcpHeaderLibrary() {
    if (!targets.dcpHeaderFlyoutGrid || targets.dcpHeaderFlyoutGrid.childElementCount) return;
    const groups = [
      { category: 'safety', label: 'Safety Headers' },
      { category: 'color', label: 'Color Headers' }
    ];
    groups.forEach((group) => {
      const section = document.createElement('section');
      section.className = 'srd-designer-header-library__group';
      section.dataset.srdDcpHeaderGroup = group.category;
      const heading = document.createElement('h3');
      heading.className = 'srd-designer-header-library__group-heading';
      heading.textContent = group.label;
      const grid = document.createElement('div');
      grid.className = 'srd-designer-header-library__group-grid';
      dcpHeaderCatalog
        .filter((item) => item.category === group.category)
        .sort((first, second) => first.displayOrder - second.displayOrder)
        .forEach((item) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'srd-designer-header-library__item';
          button.dataset.srdDcpHeaderChoice = item.libraryKey;
          button.setAttribute('aria-label', 'Add ' + item.label + ' header');
          button.title = item.label;
          const thumbnail = document.createElement('span');
          thumbnail.className = 'srd-designer-header-library__thumbnail';
          const image = document.createElement('img');
          image.src = item.src;
          image.alt = '';
          image.loading = 'lazy';
          thumbnail.appendChild(image);
          const label = document.createElement('span');
          label.className = 'srd-designer-header-library__label';
          label.textContent = item.label;
          button.appendChild(thumbnail);
          button.appendChild(label);
          grid.appendChild(button);
        });
      section.appendChild(heading);
      section.appendChild(grid);
      targets.dcpHeaderFlyoutGrid.appendChild(section);
    });
  }

  function syncDcpHeaderLibraryActiveState() {
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    const activeKey = objects.header ? objects.header.libraryKey : '';
    if (targets.dcpHeaderFlyoutGrid) {
      targets.dcpHeaderFlyoutGrid.querySelectorAll('[data-srd-dcp-header-choice]').forEach((button) => {
        const active = button.dataset.srdDcpHeaderChoice === activeKey;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    if (targets.dcpToolbarHeader) {
      targets.dcpToolbarHeader.classList.toggle('is-active', Boolean(activeKey) || (targets.dcpHeaderFlyout && !targets.dcpHeaderFlyout.hidden));
    }
  }

  function openDcpHeaderLibrary() {
    if (isDieCuttingMode()) {
      setDieCuttingDevelopmentMessage('Headers are unavailable for Die Cutting.');
      return;
    }
    if (!requireDcpObjectToolbarCanvas() || !targets.dcpHeaderFlyout) return;
    closeDcpShapeLibrary();
    closeDcpSymbolLibrary();
    renderDcpHeaderLibrary();
    targets.dcpHeaderFlyout.hidden = false;
    if (targets.dcpToolbarHeader) targets.dcpToolbarHeader.setAttribute('aria-expanded', 'true');
    syncDcpHeaderLibraryActiveState();
  }

  function closeDcpHeaderLibrary() {
    if (!targets.dcpHeaderFlyout) return;
    targets.dcpHeaderFlyout.hidden = true;
    if (targets.dcpToolbarHeader) targets.dcpToolbarHeader.setAttribute('aria-expanded', 'false');
    syncDcpHeaderLibraryActiveState();
  }

  function deleteSelectedDcpTextObject() {
    const id = dcpObjectId(selectedDcpObject);
    if (!id) return;
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    objects.textObjects = objects.textObjects.filter((item) => item.id !== id);
    proof.objects = objects;
    currentDcpProofState = proof;
    clearDcpObjectSelection();
    syncDcpProofCompatibilityAlias();
    update();
    commitDcpHistoryTransaction(historyStart, 'Delete text');
  }

  function setDcpEditorControlValue(control, value, force) {
    if (!control || (!force && document.activeElement === control)) return;
    const nextValue = String(value === undefined || value === null ? '' : value);
    if (control.value !== nextValue) control.value = nextValue;
  }

  function authorizedDcpDieVinylColorKey(key) {
    const candidate = String(key || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
    if (!candidate) return '';
    if (candidate === 'black') return 'gloss_black';
    const descriptor = dcpDieVinylColorDescriptor(candidate);
    return dcpDieVinylColorsByKey[descriptor.key] ? descriptor.key : '';
  }

  function normalizeDcpDieObjectColors(proof) {
    const target = proof || emptyDcpProofState();
    const fallbackColorKey = authorizedDcpDieVinylColorKey(target.dieVinylColorKey) || 'white';
    const normalized = normalizeDcpCanvasObjects(target.objects, 'die_cutting');
    normalized.textObjects.forEach((object) => {
      object.fontColorKey = fallbackColorKey;
      object.fontColor = dcpDieVinylColorDescriptor(fallbackColorKey).label;
    });
    target.dieVinylColorKey = fallbackColorKey;
    target.objects = normalized;
    return target;
  }

  function dcpDieUsedVinylColorKeys(objects, proof) {
    const normalized = normalizeDcpCanvasObjects(objects, 'die_cutting');
    const fallbackColorKey = authorizedDcpDieVinylColorKey((proof || getDcpProofState()).dieVinylColorKey) || 'white';
    const hasVisibleText = normalized.textObjects.some((object) => isComplete(String(object.text || '').trim()));
    return (activeDcpCatalogArtwork || hasVisibleText) ? [fallbackColorKey] : [];
  }

  function dcpDieVinylColorsLabel(objects, proof) {
    const colors = dcpDieUsedVinylColorKeys(objects, proof);
    return colors.length
      ? colors.map((colorKey) => dcpDieVinylColorDescriptor(colorKey).label).join(', ')
      : '\u2014';
  }

  function dcpProofColorChannels(value) {
    const hex = String(value || '').trim().replace(/^#/, '');
    if (!/^[0-9a-f]{6}$/i.test(hex)) return [0, 0, 0];
    return [0, 2, 4].map((offset) => parseInt(hex.slice(offset, offset + 2), 16) / 255);
  }

  function dcpProofRelativeLuminance(value) {
    const channels = dcpProofColorChannels(value).map((channel) =>
      channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4)
    );
    return (0.2126 * channels[0]) + (0.7152 * channels[1]) + (0.0722 * channels[2]);
  }

  function dcpProofContrastRatio(foreground, background) {
    const foregroundLuminance = dcpProofRelativeLuminance(foreground);
    const backgroundLuminance = dcpProofRelativeLuminance(background);
    const lighter = Math.max(foregroundLuminance, backgroundLuminance);
    const darker = Math.min(foregroundLuminance, backgroundLuminance);
    return (lighter + 0.05) / (darker + 0.05);
  }

  function resolveDcpDieProofContrast(objects, proof) {
    const colorKeys = dcpDieUsedVinylColorKeys(objects, proof);
    if (!colorKeys.length || colorKeys.every((key) => key === 'white' || key === 'reflective_white')) {
      return { mode: 'dark', colorKeys: colorKeys };
    }
    const colors = colorKeys.map((key) => dcpDieVinylColorDescriptor(key).value);
    if (colors.every((color) => dcpProofContrastRatio(color, '#ffffff') >= 4.5)) {
      return { mode: 'light', colorKeys: colorKeys };
    }
    if (colors.every((color) => dcpProofContrastRatio(color, '#000000') >= 4.5)) {
      return { mode: 'dark', colorKeys: colorKeys };
    }
    return { mode: dcpProofContrastRatio(colors[0], '#20242b') >= dcpProofContrastRatio(colors[0], '#f4f4f1') ? 'dark' : 'light', colorKeys: colorKeys };
  }

  function paintDcpDieProofContrastSurface(context, width, height, contrast) {
    const mode = contrast && contrast.mode ? contrast.mode : 'light';
    context.fillStyle = mode === 'dark' ? '#20242b' : '#f4f4f1';
    context.fillRect(0, 0, width, height);
  }

  function selectedDcpDieObjectVinylColorKey(objects, proof) {
    if (!isDieCuttingMode() || selectedDcpObjects.length !== 1) return '';
    const normalized = normalizeDcpCanvasObjects(objects || getDcpProofState().objects, 'die_cutting');
    const fallbackColorKey = authorizedDcpDieVinylColorKey((proof || getDcpProofState()).dieVinylColorKey) || 'white';
    const type = dcpObjectType(selectedDcpObject);
    if (type === 'artwork' && activeDcpCatalogArtwork) return fallbackColorKey;
    if (type === 'text') {
      return selectedDcpTextObject(normalized) ? fallbackColorKey : '';
    }
    return '';
  }

  function setSelectedDcpDieObjectVinylColor(colorKey) {
    if (!isDieCuttingMode() || selectedDcpObjects.length !== 1) return false;
    const safeColorKey = authorizedDcpDieVinylColorKey(colorKey);
    if (!safeColorKey) return false;
    const proof = normalizeDcpDieObjectColors(currentDcpProofState || emptyDcpProofState());
    const currentColorKey = authorizedDcpDieVinylColorKey(proof.dieVinylColorKey) || 'white';
    if (!currentColorKey || currentColorKey === safeColorKey) return false;
    setDcArtVinylColor(safeColorKey);
    return true;
  }

  function syncSelectedDcpDieVinylColorControl(objects) {
    if (!targets.dieVinylColorField || !controls.dieVinylColor) return;
    const colorKey = selectedDcpDieObjectVinylColorKey(objects, getDcpProofState());
    const visible = isDieCuttingMode() && Boolean(colorKey);
    targets.dieVinylColorField.hidden = !visible;
    controls.dieVinylColor.disabled = !visible;
    controls.dieVinylColor.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (visible && controls.dieVinylColor.value !== colorKey) controls.dieVinylColor.value = colorKey;
  }

  function syncDcpTextColorControlCatalog(objects) {
    if (!controls.dcpFontColor) return;
    const dieCuttingMode = isDieCuttingMode();
    if (targets.dcpTextObjectColorField) targets.dcpTextObjectColorField.hidden = dieCuttingMode;
    controls.dcpFontColor.disabled = dieCuttingMode;
    const catalog = dieCuttingMode ? dcpDieVinylColorCatalog : dcpPrintTextColorCatalog;
    const catalogMode = dieCuttingMode ? 'die_cutting' : 'print_design';
    const normalized = normalizeDcpCanvasObjects(objects || getDcpProofState().objects);
    const selectedText = selectedDcpObjects.length === 1 ? selectedDcpTextObject(normalized) : null;
    let desiredKey = dieCuttingMode
      ? (selectedText
        ? (authorizedDcpDieVinylColorKey(selectedText.fontColorKey)
          || authorizedDcpDieVinylColorKey(getDcpProofState().dieVinylColorKey)
          || 'white')
        : 'white')
      : (selectedText && selectedText.fontColorKey ? selectedText.fontColorKey : 'black');
    if (dieCuttingMode) {
      const authorizedKey = authorizedDcpDieVinylColorKey(desiredKey);
      if (authorizedKey) desiredKey = authorizedKey;
    }
    const catalogChanged = controls.dcpFontColor.dataset.srdColorWorkflow !== catalogMode;
    if (catalogChanged) {
      controls.dcpFontColor.replaceChildren(...catalog.map((item) => {
        const option = document.createElement('option');
        option.value = item.key;
        option.textContent = item.label;
        return option;
      }));
      controls.dcpFontColor.dataset.srdColorWorkflow = catalogMode;
      if (catalog.some((item) => item.key === desiredKey)) {
        controls.dcpFontColor.value = desiredKey;
      } else {
        controls.dcpFontColor.selectedIndex = -1;
      }
    }
    const label = dieCuttingMode ? 'Vinyl Color' : 'Font Color';
    if (targets.dcpFontColorLabel) targets.dcpFontColorLabel.textContent = label;
    controls.dcpFontColor.setAttribute('aria-label', label);
  }

  function syncDcpDieVinylWorkspaceContrast(objects) {
    if (!isDieCuttingMode()) {
      root.removeAttribute('data-srd-die-vinyl-workspace');
      root.removeAttribute('data-srd-die-proof-contrast');
      return;
    }
    const contrast = resolveDcpDieProofContrast(objects, getDcpProofState());
    root.setAttribute('data-srd-die-proof-contrast', contrast.mode);
    root.setAttribute('data-srd-die-vinyl-workspace', contrast.mode === 'dark' ? 'black' : contrast.mode);
  }

  function syncDcpTextEditorFromSelection(objects, force) {
    if (!isBlankCanvasMode(controls.template.value)) return;
    syncDcpFontControlCatalog();
    syncDcpTextColorControlCatalog(objects);
    if (controls.dcpTextInput) {
      const dieCuttingMode = isDieCuttingMode();
      controls.dcpTextInput.rows = dieCuttingMode ? 1 : 3;
      controls.dcpTextInput.setAttribute('aria-label', dieCuttingMode ? 'Die Cutting text line' : 'Text');
    }
    dcpEditorSyncing = true;
    const selectedText = selectedDcpTextObject(objects);
    const textValue = selectedText ? selectedText.text : '';
    const workflow = currentDcpFontWorkflow();
    const selectedFontKey = selectedText && selectedText.fontKey ? selectedText.fontKey : '';
    ensureDcpLegacyFontOption(selectedFontKey, workflow);
    const fontKey = dcpFontAllowedForWorkflow(selectedFontKey, workflow)
      ? selectedFontKey
      : dcpDefaultFontKey(workflow);
    const colorKey = isDieCuttingMode()
      ? (selectedText
        ? (authorizedDcpDieVinylColorKey(selectedText.fontColorKey)
          || authorizedDcpDieVinylColorKey(getDcpProofState().dieVinylColorKey)
          || 'white')
        : 'white')
      : (selectedText && selectedText.fontColorKey ? selectedText.fontColorKey : 'black');
    setDcpEditorControlValue(controls.dcpTextInput, textValue, force);
    setDcpEditorControlValue(controls.dcpFont, fontKey, force);
    setDcpEditorControlValue(controls.dcpFontColor, colorKey, force);
    const outlineEnabled = Boolean(selectedText && selectedText.outlineEnabled);
    const outlineColorKey = selectedText ? selectedText.outlineColorKey : 'white';
    const outlineThicknessKey = selectedText ? selectedText.outlineThicknessKey : 'medium';
    setDcpEditorControlValue(controls.dcpTextOutlineColor, outlineColorKey, force);
    setDcpEditorControlValue(controls.dcpTextOutlineThickness, outlineThicknessKey, force);
    targets.dcpTextOutlineToggles.forEach((button) => {
      const active = button.dataset.srdDcpTextOutline === (outlineEnabled ? 'on' : 'off');
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (controls.dcpTextOutlineColor) controls.dcpTextOutlineColor.disabled = !outlineEnabled;
    if (controls.dcpTextOutlineThickness) controls.dcpTextOutlineThickness.disabled = !outlineEnabled;
    const textShape = selectedText ? normalizeDcpTextShape(selectedText.textShape) : 'straight';
    const arcAmount = textShape === 'straight'
      ? 0
      : clampDcpNumber(selectedText && selectedText.arcAmount, 0, 100, 35);
    setDcpEditorControlValue(targets.dcpTextShape, textShape, force);
    setDcpEditorControlValue(targets.dcpArcAmount, String(arcAmount), force);
    if (targets.dcpArcAmount) targets.dcpArcAmount.disabled = !selectedText || textShape === 'straight';
    if (targets.dcpArcValue) targets.dcpArcValue.textContent = targets.dcpArcAmount ? targets.dcpArcAmount.value : '35';
    setDcpEditorControlValue(targets.dcpRotation, selectedText ? String(clampDcpNumber(selectedText.rotation, -180, 180, 0)) : '0', force);
    if (targets.dcpRotationValue) targets.dcpRotationValue.textContent = (targets.dcpRotation ? targets.dcpRotation.value : '0') + '°';
    if (selectedText && controls.font && Array.from(controls.font.options || []).some((option) => option.value === fontKey)) {
      controls.font.value = fontKey;
    }
    if (selectedText && controls.color && !isDieCuttingMode()) controls.color.value = colorKey;
    if (isDieCuttingMode()) dcpDieVinylColorContext = colorKey;
    dcpEditorSyncing = false;
  }

  function defaultDcpPhysicalCanvas() {
    return { ...dcpPhysicalCanvasDefaults };
  }

  function normalizeDcpPhysicalCanvas(value) {
    const candidate = value && typeof value === 'object' ? value : {};
    function normalizedDimension(key) {
      const limits = key === 'height' && (candidate.trustedDcArtRestore === true || activeDcpCatalogArtwork || (currentDcpProofState && currentDcpProofState.catalogArtwork)
        || (dcpCartEditSession.active && dcpCartEditSession.verifiedDcArtRestore === true))
        ? { min: dcpPhysicalCanvasLimits.height.min, max: 12 }
        : dcpPhysicalCanvasLimits[key];
      const numeric = Number(candidate[key]);
      if (!Number.isFinite(numeric) || numeric < limits.min || numeric > limits.max) {
        return dcpPhysicalCanvasDefaults[key];
      }
      const factor = 10 ** dcpPhysicalCanvasLimits.precision;
      return Math.round(numeric * factor) / factor;
    }
    return {
      version: dcpPhysicalCanvasDefaults.version,
      unit: dcpPhysicalCanvasDefaults.unit,
      width: normalizedDimension('width'),
      height: normalizedDimension('height'),
      trustedDcArtRestore: candidate.trustedDcArtRestore === true
    };
  }

  function dcpPhysicalCanvasForProof(proof) {
    return normalizeDcpPhysicalCanvas((proof || getDcpProofState()).physicalCanvas);
  }

  function dcpPhysicalCanvasLabel(canvas) {
    const normalized = normalizeDcpPhysicalCanvas(canvas);
    return normalized.width + ' x ' + normalized.height + ' in';
  }

  function dcpDieFinishedSizeLabel(canvas) {
    const normalized = normalizeDcpPhysicalCanvas(canvas);
    return normalized.width + '" \u00d7 ' + normalized.height + '"';
  }

  // DCP proof-state architecture: upload and restore both update one current proof object.
  function emptyDcpProofState() {
    return {
      mode: 'upload_artwork',
      source: '',
      url: '',
      previewUrl: '',
      name: '',
      filename: '',
      originalFilename: '',
      type: '',
      fileType: '',
      dimensions: '',
      width: '',
      height: '',
      reference: '',
      artworkReference: '',
      proofReference: '',
      status: '',
      supported: false,
      previewable: false,
      noticeImage: false,
      noticeUrl: '',
      restored: false,
      transform: 'fit-contain-center',
      physicalCanvas: defaultDcpPhysicalCanvas(),
      dieVinylColorKey: 'white',
      legacyDieVinylColorSnapshot: null,
      objects: defaultDcpCanvasObjects(),
      message: ''
    };
  }

  function syncDcpProofCompatibilityAlias() {
    let proof = currentDcpProofState || emptyDcpProofState();
    if (activeDcpWorkspaceMode === 'die_cutting') proof = normalizeDcpDieObjectColors(proof);
    proof.physicalCanvas = normalizeDcpPhysicalCanvas(proof.physicalCanvas);
    proof.objects = normalizeDcpCanvasObjects(proof.objects);
    uploadedBlankCanvasArtwork = {
      url: proof.previewUrl || proof.url || '',
      name: proof.originalFilename || proof.filename || proof.name || '',
      type: proof.fileType || proof.type || '',
      dimensions: proof.dimensions || '',
      width: proof.width || '',
      height: proof.height || '',
      reference: proof.artworkReference || proof.reference || '',
      status: proof.status || '',
      supported: Boolean(proof.supported),
      previewable: Boolean(proof.previewable),
      message: proof.message || proof.status || ''
    };
  }

  function setDcpProofFromUpload(uploadState) {
    const previousProof = getDcpProofState();
    const previousObjects = normalizeDcpCanvasObjects(previousProof.objects);
    const previousPhysicalCanvas = dcpPhysicalCanvasForProof(previousProof);
    currentDcpProofState = {
      ...emptyDcpProofState(),
      ...uploadState,
      source: 'upload',
      previewUrl: uploadState && uploadState.url ? uploadState.url : '',
      filename: uploadState && (uploadState.originalFilename || uploadState.name) ? uploadState.originalFilename || uploadState.name : '',
      originalFilename: uploadState && (uploadState.originalFilename || uploadState.name) ? uploadState.originalFilename || uploadState.name : '',
      fileType: uploadState && uploadState.type ? uploadState.type : '',
      artworkReference: uploadState && uploadState.reference ? uploadState.reference : '',
      restored: false,
      transform: uploadState && uploadState.transform ? uploadState.transform : 'fit-contain-center',
      physicalCanvas: previousPhysicalCanvas,
      objects: normalizeDcpCanvasObjects(uploadState && uploadState.objects ? uploadState.objects : previousObjects)
    };
    syncDcpProofCompatibilityAlias();
    return currentDcpProofState;
  }

  function hasMeaningfulDcpStructuredObjects(objects, size, hasArtwork) {
    const normalized = normalizeDcpCanvasObjects(objects);
    const shapeValidation = dcpShapeValidation(normalized, size);
    const symbolValidation = validateDcpSymbolObjects(normalized.symbolObjects, size, false);
    return Boolean(
      hasArtwork ||
      hasDcpTextObjects(normalized) ||
      normalized.header ||
      (shapeValidation.valid && shapeValidation.present) ||
      (symbolValidation.valid && symbolValidation.present)
    );
  }

  function selectDefaultDcpObject(objects, preferArtwork) {
    const normalized = normalizeDcpCanvasObjects(objects || getDcpProofState().objects);
    const proof = getDcpProofState();
    if (preferArtwork && (proof.previewUrl || proof.url || proof.noticeUrl)) {
      selectDcpObject('artwork');
      return;
    }
    if (normalized.textObjects.length) {
      selectDcpObject(dcpTextSelection(normalized.textObjects[0].id));
      return;
    }
    if (hasDcpShapeObject(normalized, controls.size && controls.size.value)) {
      selectDcpObject('shape');
      return;
    }
    if (normalized.header) {
      selectDcpObject('header');
      return;
    }
    selectDcpObject(normalized.symbolObjects.length ? dcpSymbolSelection(normalized.symbolObjects[0].id) : null);
  }

  function clearDcpNativeArtworkInputForReselection() {
    const input = controls.blankCanvasUpload;
    if (!input) return;
    input.value = '';
    if (!input.files || !input.files.length || typeof DataTransfer !== 'function') return;
    try {
      input.files = new DataTransfer().files;
    } catch (error) {
      debugLog('native Artwork input FileList cleanup skipped', error);
    }
  }

  function setDcpProofFromRestore(restoreState) {
    const previousProof = getDcpProofState();
    const previousObjects = normalizeDcpCanvasObjects(previousProof.objects);
    const previousPhysicalCanvas = dcpPhysicalCanvasForProof(previousProof);
    currentDcpProofState = {
      ...emptyDcpProofState(),
      ...restoreState,
      source: 'restore',
      previewUrl: restoreState && restoreState.url ? restoreState.url : '',
      filename: restoreState && (restoreState.originalFilename || restoreState.name) ? restoreState.originalFilename || restoreState.name : '',
      originalFilename: restoreState && (restoreState.originalFilename || restoreState.name) ? restoreState.originalFilename || restoreState.name : '',
      fileType: restoreState && restoreState.type ? restoreState.type : '',
      artworkReference: restoreState && restoreState.reference ? restoreState.reference : '',
      supported: restoreState && typeof restoreState.supported !== 'undefined' ? Boolean(restoreState.supported) : true,
      previewable: restoreState && typeof restoreState.previewable !== 'undefined' ? Boolean(restoreState.previewable) : true,
      restored: true,
      transform: restoreState && restoreState.transform ? restoreState.transform : 'fit-contain-center',
      dieVinylColorKey: restoreState && Object.prototype.hasOwnProperty.call(restoreState, 'dieVinylColorKey')
        ? restoreState.dieVinylColorKey
        : '',
      physicalCanvas: normalizeDcpPhysicalCanvas(restoreState && restoreState.physicalCanvas ? restoreState.physicalCanvas : previousPhysicalCanvas),
      objects: normalizeDcpCanvasObjects(restoreState && restoreState.objects ? restoreState.objects : previousObjects)
    };
    dcpArtworkFileRevisions.clear();
    dcpArtworkAssetToken = '';
    dcpArtworkNeedsReselection = dcpProofHasArtwork(currentDcpProofState);
    registerDcpProductionArtworkSource({
      status: dcpArtworkNeedsReselection ? 'missing_or_untrusted' : 'none',
      originalFilename: currentDcpProofState.originalFilename || '',
      fileType: currentDcpProofState.fileType || '',
      mutation: 'unchanged'
    });
    if (dcpArtworkNeedsReselection) clearDcpNativeArtworkInputForReselection();
    syncDcpProofCompatibilityAlias();
    return currentDcpProofState;
  }

  function getDcpProofState() {
    return currentDcpProofState || emptyDcpProofState();
  }

  // DCP production Artwork source is session state, separate from proof and geometry serialization.
  function emptyDcpProductionArtworkSource(overrides) {
    return {
      status: 'none',
      cartLineKey: '',
      originalVariantId: '',
      propertyKey: dcpNativeArtworkPropertyName,
      reference: '',
      originalFilename: '',
      fileType: '',
      mutation: 'unchanged',
      ...(overrides || {})
    };
  }

  function normalizeDcpProductionArtworkSource(source) {
    const candidate = source || {};
    const allowedStatuses = new Set(['none', 'native_file', 'trusted_cart_reference', 'missing_or_untrusted']);
    const allowedMutations = new Set(['unchanged', 'replaced', 'removed']);
    return emptyDcpProductionArtworkSource({
      status: allowedStatuses.has(candidate.status) ? candidate.status : 'missing_or_untrusted',
      cartLineKey: String(candidate.cartLineKey || ''),
      originalVariantId: String(candidate.originalVariantId || ''),
      reference: String(candidate.reference || ''),
      originalFilename: String(candidate.originalFilename || ''),
      fileType: String(candidate.fileType || ''),
      mutation: allowedMutations.has(candidate.mutation) ? candidate.mutation : 'unchanged'
    });
  }

  function registerDcpProductionArtworkSource(source) {
    dcpProductionArtworkRevisionCounter += 1;
    const token = 'dcp-production-artwork-' + Date.now().toString(36) + '-' + dcpProductionArtworkRevisionCounter;
    const normalized = normalizeDcpProductionArtworkSource(source);
    dcpProductionArtworkRevisions.set(token, normalized);
    dcpProductionArtworkAssetToken = token;
    dcpProductionArtworkSource = normalized;
    dcpArtworkNeedsReselection = dcpProofHasArtwork() && !dcpProductionArtworkReady();
    return token;
  }

  function restoreDcpProductionArtworkSource(token) {
    const source = token ? dcpProductionArtworkRevisions.get(token) : null;
    dcpProductionArtworkAssetToken = source ? token : '';
    dcpProductionArtworkSource = source
      ? normalizeDcpProductionArtworkSource(source)
      : emptyDcpProductionArtworkSource({
          status: dcpProofHasArtwork() ? 'missing_or_untrusted' : 'none'
        });
    dcpArtworkNeedsReselection = dcpProofHasArtwork() && !dcpProductionArtworkReady();
  }

  function dcpProductionArtworkReady() {
    return dcpProductionArtworkSource.status === 'native_file' ||
      dcpProductionArtworkSource.status === 'trusted_cart_reference';
  }

  function dcpProductionArtworkReferenceForCart() {
    return dcpProductionArtworkSource.status === 'trusted_cart_reference' &&
      dcpProductionArtworkSource.mutation === 'unchanged'
      ? dcpProductionArtworkSource.reference
      : '';
  }

  function dcpCartLineProperties(line) {
    return line && line.properties && typeof line.properties === 'object' ? line.properties : {};
  }

  function normalizedDcpFileExtension(value) {
    const match = String(value || '').toLowerCase().match(/\.([a-z0-9]+)(?:$|[?#])/);
    if (!match) return '';
    return match[1] === 'jpeg' ? 'jpg' : match[1];
  }

  function isTrustedDcpUploadUrl(value) {
    if (!value) return false;
    try {
      const url = new URL(String(value));
      return url.protocol === 'https:' &&
        url.hostname === 'cdn.shopify.com' &&
        url.pathname.indexOf(dcpTrustedArtworkUploadPathPrefix) === 0;
    } catch (error) {
      return false;
    }
  }

  async function verifyDcpProductionReferenceAccessible(reference) {
    if (!isTrustedDcpUploadUrl(reference)) return false;
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timeout = window.setTimeout(() => {
      if (controller) controller.abort();
    }, dcpCartRequestTimeoutMs);
    try {
      const options = {
        method: 'HEAD',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store'
      };
      if (controller) options.signal = controller.signal;
      const response = await fetch(reference, options);
      return response.ok;
    } catch (error) {
      debugLog('trusted production Artwork accessibility check failed', error);
      return false;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function hasStructuredDcpArtworkProperty(properties) {
    try {
      const parsed = JSON.parse(String(properties._dcp_canvas_objects || ''));
      const artwork = parsed && parsed.artwork;
      return Boolean(artwork &&
        Number.isFinite(Number(artwork.x)) &&
        Number.isFinite(Number(artwork.y)) &&
        Number(artwork.width) > 0 &&
        Number(artwork.height) > 0);
    } catch (error) {
      return false;
    }
  }

  function hasDcpCartIdentity(properties) {
    const source = properties || {};
    const family = String(source['Product Family'] || source['_Product Family'] || '');
    const category = String(source['_Selected Template Category'] || '');
    return String(source._SRDDESIGNER || '') === 'true'
      && String(source['_Template Key'] || '') === 'blank_canvas'
      && (family === 'Blank Canvas'
        || family === 'Die Cutting & Print (Blank Canvas)'
        || family === 'Custom Print Design'
        || family === 'Custom Die-Cut Vinyl Lettering'
        || category === 'blank_canvas');
  }

  function canonicalDcpCartDesignValue(value) {
    if (Array.isArray(value)) return value.map(canonicalDcpCartDesignValue);
    if (!value || typeof value !== 'object') return value;
    return Object.keys(value).sort().reduce((canonical, key) => {
      canonical[key] = canonicalDcpCartDesignValue(value[key]);
      return canonical;
    }, {});
  }

  function firstDcpCartDesignDifference(left, right, path) {
    if (Object.is(left, right)) return '';
    const location = path || 'design';
    if (Array.isArray(left) || Array.isArray(right)) {
      if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) return location;
      for (let index = 0; index < left.length; index += 1) {
        const difference = firstDcpCartDesignDifference(left[index], right[index], location + '[' + index + ']');
        if (difference) return difference;
      }
      return '';
    }
    if (left && right && typeof left === 'object' && typeof right === 'object') {
      const keys = Array.from(new Set(Object.keys(left).concat(Object.keys(right)))).sort();
      for (const key of keys) {
        if (!Object.prototype.hasOwnProperty.call(left, key) || !Object.prototype.hasOwnProperty.call(right, key)) {
          return location + '.' + key;
        }
        const difference = firstDcpCartDesignDifference(left[key], right[key], location + '.' + key);
        if (difference) return difference;
      }
      return '';
    }
    return location;
  }

  function dcpCartLineIdentityError(line, session) {
    if (!session.lineKey || !session.expectedVariantId || !session.expectedProductId) {
      return 'The Edit Design link is missing required cart identity.';
    }
    if (!line || String(line.key || '') !== String(session.lineKey || '')) return 'The original cart line is no longer available.';
    const lineVariantId = String(line.variant_id || line.id || '');
    const lineProductId = String(line.product_id || '');
    const properties = dcpCartLineProperties(line);
    const dieCuttingLine = String(properties['_Blank Canvas Subfamily Key'] || '') === 'die_cutting';
    const expectedProductId = dieCuttingLine ? dcpDieVariantLookup.productId : dcpProductId;
    if (lineProductId !== expectedProductId || (session.expectedProductId && lineProductId !== session.expectedProductId)) {
      return 'The original cart product no longer matches this Blank Canvas design.';
    }
    if (session.expectedVariantId && lineVariantId !== session.expectedVariantId) {
      return 'The original cart variant no longer matches this edit session.';
    }
    if (!hasDcpCartIdentity(properties)) {
      return 'The original cart line is not a matching SRD Blank Canvas design.';
    }
    const transportedObjects = parseDcpCanvasObjects(pageParams.get('dcp_canvas_objects') || '');
    const cartObjects = parseDcpCanvasObjects(properties._dcp_canvas_objects || '');
    const designDifference = transportedObjects && cartObjects
      ? firstDcpCartDesignDifference(cartObjects, transportedObjects, 'design')
      : 'design';
    if (designDifference) {
      return 'The original cart design data no longer matches this edit session (' + designDifference + ').';
    }
    if (dcpSymbolRestoreValidationError) return dcpSymbolRestoreValidationError;
    if (dieCuttingLine) {
      if (String(properties['_Blank Canvas Subfamily Key'] || '') !== 'die_cutting' || cartObjects.shape
          || cartObjects.header || (cartObjects.symbolObjects && cartObjects.symbolObjects.length)) {
        return 'The original cart line is not a text-only Custom Die design.';
      }
      return '';
    }
    const symbolProperties = dcpSymbolCartProperties(cartObjects, controls.size && controls.size.value, false);
    const hasSymbols = Boolean(cartObjects.symbolObjects && cartObjects.symbolObjects.length);
    if (hasSymbols) {
      if (String(properties['_Blank Canvas Subfamily Key'] || '') !== 'print_design') {
        return 'The original cart Symbol design is not a matching Print Design.';
      }
      if (String(properties.Symbols || '') !== String(symbolProperties.Symbols || '')
        || String(properties._dcp_symbol_production || '') !== String(symbolProperties._dcp_symbol_production || '')) {
        return 'The original cart Symbol contract no longer matches this edit session.';
      }
    } else if (properties.Symbols || properties._dcp_symbol_production) {
      return 'The original cart contains Symbol properties without matching design state.';
    }
    return '';
  }

  function existingProductionArtworkReferenceIsTrusted(line) {
    const properties = dcpCartLineProperties(line);
    const reference = String(properties[dcpNativeArtworkPropertyName] || '');
    const originalFilename = String(properties._dcp_original_filename || properties._dcp_artwork_filename || properties['Artwork File'] || '');
    const fileType = String(properties._dcp_artwork_type || properties['_Blank Canvas Artwork Type'] || '');
    const proofReferences = new Set([
      String(properties[dcpProofFilePropertyName] || ''),
      String(properties['_Proof Image Data'] || ''),
      String(properties._dcp_proof_image_data || ''),
      String(properties._dcp_artwork_image_data || '')
    ].filter(Boolean));
    const filenameParam = pageParams.get('dcp_artwork_filename') || '';
    const fileExtension = normalizedDcpFileExtension(originalFilename);
    const referenceExtension = normalizedDcpFileExtension(reference);
    const acceptedExtensions = new Set(['png', 'jpg', 'webp', 'gif', 'bmp', 'svg', 'eps', 'ai', 'pdf']);

    if (!reference) return { trusted: false, reason: 'The original production Artwork reference is missing.' };
    if (!isTrustedDcpUploadUrl(reference)) return { trusted: false, reason: 'The original production Artwork reference is not a trusted Shopify upload.' };
    if (proofReferences.has(reference)) return { trusted: false, reason: 'A proof or preview reference cannot be used as production Artwork.' };
    if (!originalFilename || !filenameParam || filenameParam !== originalFilename) return { trusted: false, reason: 'The original Artwork filename does not match this edit session.' };
    if (!acceptedExtensions.has(fileExtension) || !acceptedExtensions.has(referenceExtension) || fileExtension !== referenceExtension) {
      return { trusted: false, reason: 'The original Artwork file type does not match its Shopify upload reference.' };
    }
    if (!hasStructuredDcpArtworkProperty(properties)) return { trusted: false, reason: 'The original cart line has no valid structured Artwork object.' };
    return {
      trusted: true,
      reason: '',
      reference: reference,
      originalFilename: originalFilename,
      fileType: fileType
    };
  }

  function dcpCartFetch(url, options) {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timeout = window.setTimeout(() => {
      if (controller) controller.abort();
    }, dcpCartRequestTimeoutMs);
    const requestOptions = { ...(options || {}) };
    if (controller) requestOptions.signal = controller.signal;
    return fetch(url, requestOptions).then(async (response) => {
      const rawText = await response.text();
      let data = null;
      if (rawText) {
        try {
          data = JSON.parse(rawText);
        } catch (error) {
          data = null;
        }
      }
      if (!response.ok) {
        const detail = data && (data.description || data.message) ? data.description || data.message : 'Shopify cart request failed.';
        throw new Error(detail);
      }
      if (!data) throw new Error('Shopify returned an unreadable cart response.');
      return data;
    }).finally(() => window.clearTimeout(timeout));
  }

  function fetchCurrentDcpCart() {
    return dcpCartFetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
  }

  function findDcpCartLine(cart, lineKey) {
    return cart && Array.isArray(cart.items)
      ? cart.items.find((item) => String(item.key || '') === String(lineKey || '')) || null
      : null;
  }

  function setDcpCartEditFailure(message) {
    dcpCartEditSession.status = 'stale';
    dcpCartEditSession.failure = message || 'The original cart line could not be verified.';
    if (dcpProofHasArtwork() && dcpProductionArtworkSource.status !== 'native_file') {
      registerDcpProductionArtworkSource(emptyDcpProductionArtworkSource({ status: 'missing_or_untrusted' }));
    }
    setCartMessage(dcpCartEditSession.failure + ' Your current design remains in the editor.', 'error');
  }

  async function resolveDcpCartEditSession() {
    if (!dcpCartEditSession.active) return null;
    const workspaceMode = activeDcpWorkspaceMode;
    const activationRevision = dcpModeActivationRevision;
    if (!dcpCartEditSession.lineKey) {
      setDcpCartEditFailure('The Edit Design link does not identify its original cart line.');
      update();
      return null;
    }
    dcpCartEditSession.status = 'resolving';
    dcpCartEditSession.failure = '';
    update();
    try {
      const cart = await fetchCurrentDcpCart();
      if (!isCurrentDcpModeActivation(workspaceMode, activationRevision)) return null;
      const line = findDcpCartLine(cart, dcpCartEditSession.lineKey);
      const identityError = dcpCartLineIdentityError(line, dcpCartEditSession);
      if (identityError) throw new Error(identityError);
      const pricingIntegrity = dcpPricingSnapshotFromCartLine(line);
      if (pricingIntegrity.error) throw new Error(pricingIntegrity.error);
      const pricingError = validateDcpPricingGroup(
        cart,
        pricingIntegrity.group,
        String(line.variant_id || line.id || ''),
        pricingIntegrity.pricing
      );
      if (pricingError) throw new Error(pricingError);
      const properties = dcpCartLineProperties(line);
      let verifiedSavedPhysicalCanvas = null;
      if (!controls.quantity) throw new Error('The DCP printed-quantity control is unavailable.');
      controls.quantity.value = String(pricingIntegrity.pricing.quantity);
      if (String(properties['_Blank Canvas Subfamily Key'] || '') === 'die_cutting') {
        const proof = getDcpProofState();
        const savedPhysicalCanvas = JSON.parse(String(properties._dcp_physical_canvas || '{}'));
        const hasVerifiedDcArtContract = Boolean(String(properties._dcp_dc_art_production || ''));
        proof.physicalCanvas = hasVerifiedDcArtContract
          && Number(savedPhysicalCanvas.width) >= dcpPhysicalCanvasLimits.width.min
          && Number(savedPhysicalCanvas.width) <= dcpPhysicalCanvasLimits.width.max
          && Number(savedPhysicalCanvas.height) >= dcpPhysicalCanvasLimits.height.min
          && Number(savedPhysicalCanvas.height) <= 12
          ? { version: 1, unit: 'in', width: Number(savedPhysicalCanvas.width), height: Number(savedPhysicalCanvas.height), trustedDcArtRestore: true }
          : normalizeDcpPhysicalCanvas(savedPhysicalCanvas);
        verifiedSavedPhysicalCanvas = hasVerifiedDcArtContract ? cloneDcpHistoryValue(proof.physicalCanvas) : null;
        currentDcpProofState = proof;
        syncDcpProofCompatibilityAlias();
      }
      const originalFilename = String(properties._dcp_original_filename || properties._dcp_artwork_filename || properties['Artwork File'] || '');
      const productionReference = String(properties[dcpNativeArtworkPropertyName] || '');
      dcpCartEditSession.status = 'resolved';
      dcpCartEditSession.originalVariantId = String(line.variant_id || line.id || '');
      dcpCartEditSession.originalProductId = String(line.product_id || '');
      dcpCartEditSession.originalProductionReference = productionReference;
      dcpCartEditSession.originalFilename = originalFilename;
      dcpCartEditSession.originalFileType = String(properties._dcp_artwork_type || properties['_Blank Canvas Artwork Type'] || '');
      dcpCartEditSession.originalHadArtwork = Boolean(originalFilename || productionReference);
      const trustedDcCatalogRestore = Boolean(dcpCartEditSession.verifiedDcArtRestore && activeDcpCatalogArtwork && getDcpProofState().catalogArtwork);
      if (dcpProofHasArtwork() && !trustedDcCatalogRestore) {
        const trust = existingProductionArtworkReferenceIsTrusted(line);
        const accessible = trust.trusted && await verifyDcpProductionReferenceAccessible(trust.reference);
        if (!isCurrentDcpModeActivation(workspaceMode, activationRevision)) return null;
        if (trust.trusted && accessible) {
          registerDcpProductionArtworkSource({
            status: 'trusted_cart_reference',
            cartLineKey: line.key,
            originalVariantId: dcpCartEditSession.originalVariantId,
            reference: trust.reference,
            originalFilename: trust.originalFilename,
            fileType: trust.fileType,
            mutation: 'unchanged'
          });
          const proof = getDcpProofState();
          proof.originalFilename = trust.originalFilename;
          proof.filename = trust.originalFilename;
          proof.fileType = trust.fileType || proof.fileType;
          proof.status = 'Original production file retained from cart.';
          proof.supported = true;
          currentDcpProofState = proof;
          syncDcpProofCompatibilityAlias();
        } else {
          registerDcpProductionArtworkSource({
            status: 'missing_or_untrusted',
            originalFilename: originalFilename,
            fileType: dcpCartEditSession.originalFileType,
            mutation: 'unchanged'
          });
          dcpCartEditSession.failure = trust.reason || 'The original production Artwork reference is not accessible.';
        }
      } else {
        registerDcpProductionArtworkSource({ status: 'none', mutation: 'unchanged' });
      }
      if (verifiedSavedPhysicalCanvas) {
        const proof = getDcpProofState();
        proof.physicalCanvas = verifiedSavedPhysicalCanvas;
        currentDcpProofState = proof;
        if (controls.dcpWidth) controls.dcpWidth.value = String(verifiedSavedPhysicalCanvas.width);
        if (controls.dcpHeight) controls.dcpHeight.value = String(verifiedSavedPhysicalCanvas.height);
      }
      if (!dcpHistory.past.length && !dcpHistory.future.length) dcpHistory.present = captureDcpHistorySnapshot();
      update();
      return line;
    } catch (error) {
      if (!isCurrentDcpModeActivation(workspaceMode, activationRevision)) return null;
      setDcpCartEditFailure(error && error.message ? error.message : 'The original cart line could not be verified.');
      update();
      return null;
    }
  }

  // Global Designer Controls Phase A: browser-only history over the existing proof state.
  function cloneDcpHistoryValue(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function createDcpHistoryState() {
    return {
      past: [],
      future: [],
      present: null,
      contextKey: '',
      applying: false
    };
  }

  function dcpWorkspaceModeConfig(mode) {
    return dcpWorkspaceModeCapabilities[normalizeBlankCanvasSubfamily(mode)]
      || dcpWorkspaceModeCapabilities.print_design;
  }

  function dcpModeAllows(capability, mode) {
    return Boolean(dcpWorkspaceModeConfig(mode || activeDcpWorkspaceMode)[capability]);
  }

  function defaultDcpPrecisionTools() {
    return {
      rulers: true,
      grid: true,
      guides: true,
      snap: true,
      horizontalGuides: [],
      verticalGuides: []
    };
  }

  function normalizeDcpGuideCoordinates(values, maximum) {
    const limit = Number(maximum);
    const seen = new Set();
    return (Array.isArray(values) ? values : []).reduce((guides, value) => {
      const numeric = Number(value);
      if (!Number.isFinite(numeric) || numeric < 0 || (Number.isFinite(limit) && numeric > limit)) return guides;
      const normalized = Math.round(numeric * 1000) / 1000;
      const key = normalized.toFixed(3);
      if (!seen.has(key)) {
        seen.add(key);
        guides.push(normalized);
      }
      return guides;
    }, []);
  }

  function cloneDcpPrecisionTools(value, physicalSize) {
    const source = value && typeof value === 'object' ? value : defaultDcpPrecisionTools();
    const size = physicalSize || null;
    return {
      rulers: source.rulers !== false,
      grid: source.grid !== false,
      guides: source.guides !== false,
      snap: source.snap !== false,
      horizontalGuides: normalizeDcpGuideCoordinates(source.horizontalGuides, size ? size.height : undefined),
      verticalGuides: normalizeDcpGuideCoordinates(source.verticalGuides, size ? size.width : undefined)
    };
  }

  function activeDcpPrecisionTools() {
    if (!dcpPrecisionTools) dcpPrecisionTools = defaultDcpPrecisionTools();
    return dcpPrecisionTools;
  }

  function dcpPrecisionRulerSize() {
    return activeDcpPrecisionTools().rulers ? 22 : 0;
  }

  function drawDcpRuler(canvas, orientation, inches, pixels) {
    if (!canvas || !Number.isFinite(inches) || inches <= 0 || !Number.isFinite(pixels) || pixels <= 0) return;
    const rulerThickness = 22;
    const horizontal = orientation === 'horizontal';
    const cssWidth = horizontal ? pixels : rulerThickness;
    const cssHeight = horizontal ? rulerThickness : pixels;
    const ratio = Math.max(1, Number(window.devicePixelRatio) || 1);
    canvas.style.width = cssWidth.toFixed(2) + 'px';
    canvas.style.height = cssHeight.toFixed(2) + 'px';
    canvas.width = Math.max(1, Math.round(cssWidth * ratio));
    canvas.height = Math.max(1, Math.round(cssHeight * ratio));
    const context = canvas.getContext('2d');
    if (!context) return;
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
    context.clearRect(0, 0, cssWidth, cssHeight);
    context.fillStyle = '#171a1f';
    context.fillRect(0, 0, cssWidth, cssHeight);
    const pixelsPerInch = pixels / inches;
    const subdivision = pixelsPerInch >= 48 ? 8 : (pixelsPerInch >= 24 ? 4 : (pixelsPerInch >= 12 ? 2 : 1));
    const labelStep = pixelsPerInch >= 34 ? 1 : (pixelsPerInch >= 17 ? 2 : 4);
    const totalTicks = Math.round(inches * subdivision);
    context.strokeStyle = 'rgba(255,255,255,0.82)';
    context.fillStyle = '#f07822';
    context.lineWidth = 1;
    context.font = '700 8px Arial, Helvetica, sans-serif';
    for (let index = 0; index <= totalTicks; index += 1) {
      const inchValue = index / subdivision;
      const position = inchValue * pixelsPerInch;
      const whole = index % subdivision === 0;
      const half = subdivision > 1 && index % Math.max(1, subdivision / 2) === 0;
      const quarter = subdivision > 3 && index % Math.max(1, subdivision / 4) === 0;
      const tickLength = whole ? 10 : (half ? 7 : (quarter ? 5 : 3));
      context.beginPath();
      if (horizontal) {
        context.moveTo(Math.round(position) + 0.5, rulerThickness);
        context.lineTo(Math.round(position) + 0.5, rulerThickness - tickLength);
      } else {
        context.moveTo(rulerThickness, Math.round(position) + 0.5);
        context.lineTo(rulerThickness - tickLength, Math.round(position) + 0.5);
      }
      context.stroke();
      if (!whole || Math.round(inchValue) % labelStep !== 0) continue;
      if (horizontal) {
        context.fillText(String(Math.round(inchValue)), Math.min(cssWidth - 10, position + 2), 8);
      } else {
        context.save();
        context.translate(8, Math.min(cssHeight - 2, position + 11));
        context.rotate(-Math.PI / 2);
        context.fillText(String(Math.round(inchValue)), 0, 0);
        context.restore();
      }
    }
  }

  function renderDcpGuides(physicalSize) {
    if (!targets.dcpGuideLayer) return;
    const precision = activeDcpPrecisionTools();
    precision.horizontalGuides = normalizeDcpGuideCoordinates(precision.horizontalGuides, physicalSize.height);
    precision.verticalGuides = normalizeDcpGuideCoordinates(precision.verticalGuides, physicalSize.width);
    targets.dcpGuideLayer.replaceChildren();
    if (!precision.guides) {
      targets.dcpGuideLayer.hidden = true;
      return;
    }
    targets.dcpGuideLayer.hidden = false;
    ['vertical', 'horizontal'].forEach((orientation) => {
      const values = orientation === 'vertical' ? precision.verticalGuides : precision.horizontalGuides;
      const maximum = orientation === 'vertical' ? physicalSize.width : physicalSize.height;
      values.forEach((value, index) => {
        const guide = document.createElement('button');
        guide.type = 'button';
        guide.className = 'srd-designer-proof__guide srd-designer-proof__guide--' + orientation;
        guide.dataset.srdDcpGuideOrientation = orientation;
        guide.dataset.srdDcpGuideIndex = String(index);
        guide.setAttribute('aria-label', (orientation === 'vertical' ? 'Vertical' : 'Horizontal') + ' guide at ' + value + ' inches');
        guide.style[orientation === 'vertical' ? 'left' : 'top'] = (value / maximum * 100) + '%';
        guide.addEventListener('pointerdown', beginDcpExistingGuideInteraction);
        targets.dcpGuideLayer.appendChild(guide);
      });
    });
  }

  function syncDcpPrecisionTools() {
    const available = isBlankCanvasMode(controls.template ? controls.template.value : '');
    const precision = activeDcpPrecisionTools();
    const physicalSize = available ? activeDcpPhysicalSize() : null;
    if (targets.dcpPrecisionTools) targets.dcpPrecisionTools.hidden = !available;
    targets.dcpPrecisionToggles.forEach((control) => {
      const key = control.dataset.srdDcpPrecisionToggle;
      control.checked = Boolean(precision[key]);
      control.disabled = !available;
    });
    root.setAttribute('data-srd-dcp-rulers', available && precision.rulers ? 'true' : 'false');
    if (targets.dcpPrecisionFrame) {
      targets.dcpPrecisionFrame.style.setProperty('--srd-dcp-ruler-size', available && precision.rulers ? '22px' : '0px');
    }
    const rulerVisible = Boolean(available && physicalSize && precision.rulers);
    [targets.dcpRulerCorner, targets.dcpHorizontalRuler, targets.dcpVerticalRuler].filter(Boolean).forEach((element) => {
      element.hidden = !rulerVisible;
    });
    if (!available || !physicalSize || !targets.proofArtboard) {
      if (targets.dcpPrecisionGrid) targets.dcpPrecisionGrid.hidden = true;
      if (targets.dcpGuideLayer) targets.dcpGuideLayer.hidden = true;
      clearDcpSnapIndicators();
      return;
    }
    const rect = targets.proofArtboard.getBoundingClientRect();
    if (rulerVisible) {
      drawDcpRuler(targets.dcpHorizontalRuler, 'horizontal', physicalSize.width, rect.width);
      drawDcpRuler(targets.dcpVerticalRuler, 'vertical', physicalSize.height, rect.height);
    }
    if (targets.dcpPrecisionGrid) {
      targets.dcpPrecisionGrid.hidden = !precision.grid;
      targets.dcpPrecisionGrid.style.setProperty('--srd-dcp-grid-x', (rect.width / physicalSize.width * 0.5).toFixed(3) + 'px');
      targets.dcpPrecisionGrid.style.setProperty('--srd-dcp-grid-y', (rect.height / physicalSize.height * 0.5).toFixed(3) + 'px');
    }
    renderDcpGuides(physicalSize);
  }

  function updateDcpPrecisionSetting(control) {
    const key = control && control.dataset.srdDcpPrecisionToggle;
    if (!['rulers', 'grid', 'guides', 'snap'].includes(key)) return;
    const precision = activeDcpPrecisionTools();
    const enabled = Boolean(control.checked);
    if (precision[key] === enabled) return;
    precision[key] = enabled;
    if (key === 'rulers') {
      dcpWorkspaceDimensions = { width: 0, height: 0 };
      scheduleDcpWorkspaceSync();
    } else {
      syncDcpPrecisionTools();
    }
    if (key === 'snap' && !control.checked) clearDcpSnapIndicators();
  }

  function guideCoordinateFromPointer(event, orientation) {
    if (!targets.proofArtboard) return null;
    const rect = targets.proofArtboard.getBoundingClientRect();
    const physicalSize = activeDcpPhysicalSize();
    if (!physicalSize || !rect.width || !rect.height) return null;
    const vertical = orientation === 'vertical';
    const screenValue = vertical ? event.clientX - rect.left : event.clientY - rect.top;
    const screenMaximum = vertical ? rect.width : rect.height;
    const physicalMaximum = vertical ? physicalSize.width : physicalSize.height;
    return {
      inside: event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom,
      value: Math.round(Math.max(0, Math.min(screenMaximum, screenValue)) / screenMaximum * physicalMaximum * 1000) / 1000
    };
  }

  function beginDcpGuideInteraction(event, orientation, index, created) {
    if (!isBlankCanvasMode(controls.template.value) || !activeDcpPrecisionTools().guides) return;
    event.preventDefault();
    event.stopPropagation();
    const precision = activeDcpPrecisionTools();
    const key = orientation === 'vertical' ? 'verticalGuides' : 'horizontalGuides';
    let guideIndex = Number(index);
    if (created) {
      const coordinate = guideCoordinateFromPointer(event, orientation);
      precision[key].push(coordinate ? coordinate.value : 0);
      guideIndex = precision[key].length - 1;
    }
    if (!Number.isInteger(guideIndex) || guideIndex < 0 || guideIndex >= precision[key].length) return;
    dcpGuideInteraction = {
      orientation: orientation,
      index: guideIndex,
      key: key,
      pointerId: event.pointerId,
      created: Boolean(created),
      originalValue: precision[key][guideIndex]
    };
    renderDcpGuides(activeDcpPhysicalSize());
  }

  function beginDcpExistingGuideInteraction(event) {
    beginDcpGuideInteraction(
      event,
      event.currentTarget.dataset.srdDcpGuideOrientation,
      Number(event.currentTarget.dataset.srdDcpGuideIndex),
      false
    );
  }

  function moveDcpGuideInteraction(event) {
    if (!dcpGuideInteraction || event.pointerId !== dcpGuideInteraction.pointerId) return;
    event.preventDefault();
    const coordinate = guideCoordinateFromPointer(event, dcpGuideInteraction.orientation);
    if (!coordinate) return;
    const values = activeDcpPrecisionTools()[dcpGuideInteraction.key];
    if (!values || dcpGuideInteraction.index >= values.length) return;
    values[dcpGuideInteraction.index] = coordinate.value;
    renderDcpGuides(activeDcpPhysicalSize());
  }

  function endDcpGuideInteraction(event) {
    if (!dcpGuideInteraction || (event && event.pointerId !== dcpGuideInteraction.pointerId)) return;
    const interaction = dcpGuideInteraction;
    dcpGuideInteraction = null;
    const coordinate = event ? guideCoordinateFromPointer(event, interaction.orientation) : null;
    const values = activeDcpPrecisionTools()[interaction.key];
    if (event && event.type === 'pointercancel') {
      if (interaction.created) values.splice(interaction.index, 1);
      else values[interaction.index] = interaction.originalValue;
    } else if (!coordinate || !coordinate.inside) values.splice(interaction.index, 1);
    else values[interaction.index] = coordinate.value;
    renderDcpGuides(activeDcpPhysicalSize());
  }

  function dcpAllObjectSelections(objects, proof) {
    const selections = objects.textObjects.map((item) => dcpTextSelection(item.id))
      .concat(objects.symbolObjects.map((item) => dcpSymbolSelection(item.id)));
    if (objects.header) selections.push('header');
    if (objects.shape) selections.push('shape');
    if (dcpProofHasArtwork(proof)) selections.push('artwork');
    return selections;
  }

  function dcpSnapTolerancePercent(axis) {
    const rect = targets.proofArtboard && targets.proofArtboard.getBoundingClientRect();
    const physicalSize = activeDcpPhysicalSize();
    if (!rect || !physicalSize) return 0;
    const pixels = axis === 'x' ? rect.width : rect.height;
    const inches = axis === 'x' ? physicalSize.width : physicalSize.height;
    return Math.min(8 / pixels * 100, 0.375 / inches * 100);
  }

  function dcpSnapAxisTargets(axis, excludedSelections, nearValue) {
    const physicalSize = activeDcpPhysicalSize();
    if (!physicalSize) return [];
    const precision = activeDcpPrecisionTools();
    const maximum = axis === 'x' ? physicalSize.width : physicalSize.height;
    const targetsForAxis = [
      { value: 0, source: 'artboard-edge' },
      { value: 50, source: 'artboard-center' },
      { value: 100, source: 'artboard-edge' }
    ];
    const nearInches = nearValue / 100 * maximum;
    const nearestGrid = Math.round(nearInches / 0.5) * 0.5;
    [-0.5, 0, 0.5].forEach((offset) => {
      const value = nearestGrid + offset;
      if (value >= 0 && value <= maximum) targetsForAxis.push({ value: value / maximum * 100, source: 'grid' });
    });
    if (precision.guides) {
      const guides = axis === 'x' ? precision.verticalGuides : precision.horizontalGuides;
      guides.forEach((value) => targetsForAxis.push({ value: value / maximum * 100, source: 'guide' }));
    }
    const proof = getDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const excluded = new Set(excludedSelections || []);
    dcpAllObjectSelections(objects, proof).forEach((selection) => {
      if (excluded.has(selection)) return;
      const object = dcpObjectRecordForSelection(objects, selection);
      const bounds = object && dcpAlignmentObjectBounds(selection, object, proof, physicalSize);
      if (!bounds) return;
      const first = axis === 'x' ? bounds.left : bounds.top;
      const last = axis === 'x' ? bounds.right : bounds.bottom;
      targetsForAxis.push({ value: first, source: 'object-edge' });
      targetsForAxis.push({ value: (first + last) / 2, source: 'object-center' });
      targetsForAxis.push({ value: last, source: 'object-edge' });
    });
    return targetsForAxis;
  }

  function nearestDcpSnap(value, axis, excludedSelections) {
    if (!activeDcpPrecisionTools().snap) return null;
    const tolerance = dcpSnapTolerancePercent(axis);
    return dcpSnapAxisTargets(axis, excludedSelections, value).reduce((best, target) => {
      const distance = Math.abs(target.value - value);
      if (distance > tolerance || (best && distance >= best.distance)) return best;
      return { value: target.value, correction: target.value - value, distance: distance, source: target.source };
    }, null);
  }

  function bestDcpSnapForAnchors(anchors, axis, excludedSelections) {
    return anchors.reduce((best, anchor) => {
      const match = nearestDcpSnap(anchor, axis, excludedSelections);
      if (!match || (best && match.distance >= best.distance)) return best;
      return match;
    }, null);
  }

  function showDcpSnapIndicators(xMatch, yMatch) {
    if (!targets.dcpSnapLayer) return;
    const visible = Boolean(xMatch || yMatch);
    targets.dcpSnapLayer.hidden = !visible;
    if (targets.dcpVerticalSnapIndicator) {
      targets.dcpVerticalSnapIndicator.hidden = !xMatch;
      if (xMatch) targets.dcpVerticalSnapIndicator.style.left = xMatch.value + '%';
    }
    if (targets.dcpHorizontalSnapIndicator) {
      targets.dcpHorizontalSnapIndicator.hidden = !yMatch;
      if (yMatch) targets.dcpHorizontalSnapIndicator.style.top = yMatch.value + '%';
    }
  }

  function clearDcpSnapIndicators() {
    if (targets.dcpSnapLayer) targets.dcpSnapLayer.hidden = true;
    if (targets.dcpVerticalSnapIndicator) targets.dcpVerticalSnapIndicator.hidden = true;
    if (targets.dcpHorizontalSnapIndicator) targets.dcpHorizontalSnapIndicator.hidden = true;
  }

  function snappedDcpMoveDelta(startObjects, deltaX, deltaY) {
    if (!activeDcpPrecisionTools().snap) return { x: deltaX, y: deltaY };
    const proof = getDcpProofState();
    const physicalSize = activeDcpPhysicalSize();
    const records = startObjects.map((item) => {
      const bounds = dcpAlignmentObjectBounds(item.selection, item.object, proof, physicalSize);
      return bounds ? { selection: item.selection, bounds: bounds } : null;
    }).filter(Boolean);
    if (!records.length) return { x: deltaX, y: deltaY };
    const group = records.reduce((bounds, record) => ({
      left: Math.min(bounds.left, record.bounds.left),
      right: Math.max(bounds.right, record.bounds.right),
      top: Math.min(bounds.top, record.bounds.top),
      bottom: Math.max(bounds.bottom, record.bounds.bottom)
    }), { left: Infinity, right: -Infinity, top: Infinity, bottom: -Infinity });
    const excluded = startObjects.map((item) => item.selection);
    const xMatch = bestDcpSnapForAnchors([
      group.left + deltaX,
      (group.left + group.right) / 2 + deltaX,
      group.right + deltaX
    ], 'x', excluded);
    const yMatch = bestDcpSnapForAnchors([
      group.top + deltaY,
      (group.top + group.bottom) / 2 + deltaY,
      group.bottom + deltaY
    ], 'y', excluded);
    showDcpSnapIndicators(xMatch, yMatch);
    return {
      x: deltaX + (xMatch ? xMatch.correction : 0),
      y: deltaY + (yMatch ? yMatch.correction : 0)
    };
  }

  function snappedDcpResizePointer(pointer, handle, selection) {
    if (!activeDcpPrecisionTools().snap) return pointer;
    const horizontal = handle.indexOf('left') !== -1 || handle.indexOf('right') !== -1;
    const vertical = handle.indexOf('top') !== -1 || handle.indexOf('bottom') !== -1;
    const excluded = [selection];
    const xMatch = horizontal ? nearestDcpSnap(pointer.x, 'x', excluded) : null;
    const yMatch = vertical ? nearestDcpSnap(pointer.y, 'y', excluded) : null;
    showDcpSnapIndicators(xMatch, yMatch);
    return {
      x: pointer.x + (xMatch ? xMatch.correction : 0),
      y: pointer.y + (yMatch ? yMatch.correction : 0)
    };
  }

  function defaultDcpModeWorkspace(mode) {
    const workspaceMode = normalizeBlankCanvasSubfamily(mode);
    const proof = emptyDcpProofState();
    if (workspaceMode === 'die_cutting') proof.mode = 'start_blank';
    return {
      mode: workspaceMode,
      proof: proof,
      selection: null,
      selections: [],
      multiSelectMode: false,
      history: createDcpHistoryState(),
      editingZoom: 1,
      editingZoomIntent: 'relative',
      requestedEditingZoom: 1,
      fitEditingZoom: 1,
      precisionTools: defaultDcpPrecisionTools(),
      previousPhysicalSize: '',
      previousSize: '',
      fixedSize: controls.size ? controls.size.value : '',
      material: controls.material ? controls.material.value : '',
      lamination: controls.lamination ? controls.lamination.value : '',
      quantity: controls.quantity ? controls.quantity.value : '',
      blankCanvasStart: 'start_blank',
      vinylColorContext: 'white',
      artworkAssetToken: '',
      productionArtworkAssetToken: '',
      artworkNeedsReselection: false,
      productionArtworkSource: emptyDcpProductionArtworkSource(),
      cartEditSession: {
        active: false,
        status: 'inactive',
        lineKey: '',
        expectedVariantId: '',
        expectedProductId: '',
        originalVariantId: '',
        originalProductId: '',
        originalProductionReference: '',
        originalFilename: '',
        originalFileType: '',
        originalHadArtwork: false,
        failure: ''
      },
      textObjectCounter: 0,
      shapeRestoreValidationError: '',
      symbolRestoreValidationError: ''
    };
  }

  function captureActiveDcpModeWorkspace() {
    const workspaceMode = activeDcpWorkspaceMode;
    const existing = dcpModeWorkspaces[workspaceMode] || defaultDcpModeWorkspace(workspaceMode);
    const capturedProof = cloneDcpHistoryValue(getDcpProofState());
    if (workspaceMode === 'die_cutting') capturedProof.objects = normalizeDcpCanvasObjects(capturedProof.objects, 'die_cutting');
    dcpModeWorkspaces[workspaceMode] = {
      ...existing,
      mode: workspaceMode,
      proof: capturedProof,
      selection: selectedDcpObject,
      selections: selectedDcpObjects.slice(),
      multiSelectMode: Boolean(dcpMultiSelectMode),
      history: dcpHistory,
      editingZoom: dcpEditingZoom,
      editingZoomIntent: dcpEditingZoomIntent,
      requestedEditingZoom: dcpRequestedEditingZoom,
      fitEditingZoom: dcpFitEditingZoom,
      precisionTools: cloneDcpPrecisionTools(dcpPrecisionTools),
      previousPhysicalSize: previousDcpPhysicalSize,
      previousSize: previousSize,
      fixedSize: controls.size ? controls.size.value : '',
      material: controls.material ? controls.material.value : '',
      lamination: controls.lamination ? controls.lamination.value : '',
      quantity: controls.quantity ? controls.quantity.value : '',
      blankCanvasStart: controls.blankCanvasStart ? controls.blankCanvasStart.value : 'start_blank',
      vinylColorContext: workspaceMode === 'die_cutting'
        ? (selectedDcpDieObjectVinylColorKey(getDcpProofState().objects, getDcpProofState()) || 'white')
        : 'white',
      artworkAssetToken: dcpArtworkAssetToken,
      productionArtworkAssetToken: dcpProductionArtworkAssetToken,
      artworkNeedsReselection: Boolean(dcpArtworkNeedsReselection),
      productionArtworkSource: cloneDcpHistoryValue(dcpProductionArtworkSource),
      cartEditSession: cloneDcpHistoryValue(dcpCartEditSession),
      textObjectCounter: dcpTextObjectCounter,
      shapeRestoreValidationError: dcpShapeRestoreValidationError,
      symbolRestoreValidationError: dcpSymbolRestoreValidationError
    };
    return dcpModeWorkspaces[workspaceMode];
  }

  function activateDcpModeWorkspace(mode, workspace) {
    const workspaceMode = normalizeBlankCanvasSubfamily(mode);
    const next = workspace || defaultDcpModeWorkspace(workspaceMode);
    activeDcpWorkspaceMode = workspaceMode;
    selectorState.product_family_key = topLevelProductFamilyForWorkspace(workspaceMode);
    selectorState.product_family = topLevelProductFamiliesByKey[selectorState.product_family_key].label;
    selectorState.blank_canvas_subfamily = workspaceMode;
    if (controls.blankCanvasSubfamily) controls.blankCanvasSubfamily.value = workspaceMode;
    currentDcpProofState = cloneDcpHistoryValue(next.proof);
    if (workspaceMode === 'die_cutting') {
      currentDcpProofState.objects = normalizeDcpCanvasObjects(currentDcpProofState.objects, 'die_cutting');
      next.proof = cloneDcpHistoryValue(currentDcpProofState);
      next.selection = dcpObjectType(next.selection) === 'shape' ? null : next.selection;
      next.selections = (next.selections || []).filter((selection) => dcpObjectType(selection) !== 'shape');
      next.shapeRestoreValidationError = '';
    }
    syncDcpProofCompatibilityAlias();
    dcpHistory = next.history || createDcpHistoryState();
    dcpArtworkAssetToken = next.artworkAssetToken || '';
    dcpProductionArtworkAssetToken = next.productionArtworkAssetToken || '';
    dcpArtworkNeedsReselection = Boolean(next.artworkNeedsReselection);
    dcpProductionArtworkSource = cloneDcpHistoryValue(next.productionArtworkSource || emptyDcpProductionArtworkSource());
    dcpCartEditSession = cloneDcpHistoryValue(next.cartEditSession || defaultDcpModeWorkspace(workspaceMode).cartEditSession);
    dcpTextObjectCounter = Number(next.textObjectCounter || 0);
    dcpShapeRestoreValidationError = next.shapeRestoreValidationError || '';
    dcpSymbolRestoreValidationError = next.symbolRestoreValidationError || '';
    if (controls.size) controls.size.value = next.fixedSize || controls.size.value;
    if (controls.material) controls.material.value = next.material || '';
    if (controls.lamination) controls.lamination.value = next.lamination || '';
    if (controls.quantity) controls.quantity.value = next.quantity || '';
    if (controls.blankCanvasStart) controls.blankCanvasStart.value = next.blankCanvasStart || 'start_blank';
    dcpDieVinylColorContext = 'white';
    dcpEditingZoomIntent = next.editingZoomIntent || 'relative';
    dcpRequestedEditingZoom = Number(next.requestedEditingZoom || 1);
    dcpFitEditingZoom = Number(next.fitEditingZoom || 1);
    dcpEditingZoom = Number(next.editingZoom || dcpRequestedEditingZoom);
    dcpPrecisionTools = cloneDcpPrecisionTools(next.precisionTools);
    dcpGuideInteraction = null;
    const activePhysicalSize = activeDcpPhysicalSize(effectiveDesignerSize(controls.template.value));
    previousDcpPhysicalSize = next.previousPhysicalSize || (activePhysicalSize ? activePhysicalSize.key : '');
    previousSize = next.previousSize || effectiveDesignerSize(controls.template.value);
    dcpWorkspaceDimensions = { width: 0, height: 0 };
    dcpObjectInteraction = null;
    dcpDimensionEditSession = null;
    dcpFontLoadRevision += 1;
    if (controls.dcpFont) controls.dcpFont.disabled = false;
    dcpMultiSelectMode = Boolean(next.multiSelectMode);
    setDcpObjectSelection(next.selections || [], next.selection || null);
    if (!dcpHistory.present) {
      resetDcpHistoryBaseline('mode-initialization', dcpHistoryContextValue('blank_canvas'));
    } else {
      updateDcpHistoryControls();
    }
    dcpModeWorkspaces[workspaceMode] = next;
    root.setAttribute('data-srd-dcp-workspace-mode', workspaceMode);
    syncDieCuttingCommerceFormLock(workspaceMode === 'die_cutting' && !dcpModeAllows('commerce', workspaceMode));
    if (workspaceMode === 'die_cutting') {
      latestCartPayload = null;
      if (targets.addButton) {
        targets.addButton.disabled = true;
        targets.addButton.setAttribute('aria-disabled', 'true');
      }
    }
    dcpModeActivationRevision += 1;
    dcpWorkspaceRenderRevision += 1;
    invalidateAllDcpTextFits();
  }

  function adoptCurrentStateAsDcpModeWorkspace(mode) {
    activeDcpWorkspaceMode = normalizeBlankCanvasSubfamily(mode);
    selectorState.product_family_key = topLevelProductFamilyForWorkspace(activeDcpWorkspaceMode);
    selectorState.product_family = topLevelProductFamiliesByKey[selectorState.product_family_key].label;
    selectorState.blank_canvas_subfamily = activeDcpWorkspaceMode;
    if (controls.blankCanvasSubfamily) controls.blankCanvasSubfamily.value = activeDcpWorkspaceMode;
    if (activeDcpWorkspaceMode === 'die_cutting') {
      const proof = currentDcpProofState || emptyDcpProofState();
      proof.objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
      currentDcpProofState = proof;
      dcpShapeRestoreValidationError = '';
      sanitizeDcpObjectSelection(proof.objects, proof);
      syncDcpProofCompatibilityAlias();
    }
    dcpModeWorkspaces[activeDcpWorkspaceMode] = null;
    captureActiveDcpModeWorkspace();
    root.setAttribute('data-srd-dcp-workspace-mode', activeDcpWorkspaceMode);
    syncDieCuttingCommerceFormLock(activeDcpWorkspaceMode === 'die_cutting' && !dcpModeAllows('commerce', activeDcpWorkspaceMode));
    if (activeDcpWorkspaceMode === 'die_cutting') latestCartPayload = null;
    dcpFontLoadRevision += 1;
    if (controls.dcpFont) controls.dcpFont.disabled = false;
    dcpModeActivationRevision += 1;
  }

  function isCurrentDcpModeActivation(mode, revision) {
    return activeDcpWorkspaceMode === normalizeBlankCanvasSubfamily(mode)
      && dcpModeActivationRevision === revision;
  }

  function dcpProofHasArtwork(proof) {
    const state = proof || getDcpProofState();
    return Boolean(state.originalFilename || state.filename || state.name || state.previewUrl || state.url || state.noticeUrl);
  }

  function dcpBlankCanvasContentState(objects, size, proof) {
    const state = proof || getDcpProofState();
    const source = objects || state.objects;
    const normalized = normalizeDcpCanvasObjects(source);
    const shapeValidation = dcpShapeValidation(normalized, size);
    const symbolValidation = dcpSymbolValidation(source, size, true);
    const hasArtwork = dcpProofHasArtwork(state);
    return {
      objects: normalized,
      shapeValidation: shapeValidation,
      symbolValidation: symbolValidation,
      hasText: hasDcpTextObjects(normalized),
      hasHeader: hasDcpHeaderObject(normalized),
      hasShape: shapeValidation.valid && shapeValidation.present,
      hasSymbols: symbolValidation.valid && symbolValidation.present && symbolValidation.ready,
      hasArtwork: hasArtwork,
      hasValidArtwork: hasArtwork && state.supported === true,
      artworkFileReady: !hasArtwork || (state.supported === true && dcpProductionArtworkReady())
    };
  }

  function hasValidBlankCanvasContent(objects, size, proof) {
    const content = dcpBlankCanvasContentState(objects, size, proof);
    if (isDieCuttingMode()) return content.hasText;
    return content.hasText || content.hasHeader || content.hasShape || content.hasValidArtwork || content.hasSymbols;
  }

  function dcpHistoryArtworkState(proof) {
    const state = proof || getDcpProofState();
    return {
      mode: state.mode || 'upload_artwork',
      source: state.source || '',
      url: state.url || '',
      previewUrl: state.previewUrl || '',
      name: state.name || '',
      filename: state.filename || '',
      originalFilename: state.originalFilename || '',
      type: state.type || '',
      fileType: state.fileType || '',
      dimensions: state.dimensions || '',
      width: state.width || '',
      height: state.height || '',
      reference: state.reference || '',
      artworkReference: state.artworkReference || '',
      status: state.status || '',
      supported: Boolean(state.supported),
      previewable: Boolean(state.previewable),
      noticeImage: Boolean(state.noticeImage),
      noticeUrl: state.noticeUrl || '',
      restored: Boolean(state.restored),
      dieVinylColorKey: authorizedDcpDieVinylColorKey(state.dieVinylColorKey) || 'white',
      catalogArtwork: state.catalogArtwork ? cloneDcpHistoryValue(state.catalogArtwork) : null,
      transform: state.transform || 'fit-contain-center',
      message: state.message || ''
    };
  }

  function dcpHistoryContextValue(mode, size) {
    const physicalContext = isDieCuttingMode()
      ? 'custom-physical'
      : (size || (controls.size ? controls.size.value : ''));
    return [
      mode || designerModeFromState(controls.template ? controls.template.value : ''),
      selectedBlankCanvasSubfamily(),
      physicalContext
    ].join('|');
  }

  function captureDcpHistorySnapshot() {
    const proof = getDcpProofState();
    if (isDieCuttingMode()) {
      const validation = dieCuttingStateValidation(proof.objects, proof);
      if (!validation.valid) setDieCuttingDevelopmentMessage(validation.message);
    }
    const design = {
      objects: normalizeDcpCanvasObjects(proof.objects),
      physicalCanvas: dcpPhysicalCanvasForProof(proof),
      artwork: dcpHistoryArtworkState(proof),
      artworkAssetToken: dcpArtworkAssetToken,
      productionSourceToken: dcpProductionArtworkAssetToken,
      artworkNeedsReselection: Boolean(dcpArtworkNeedsReselection)
      ,catalogRecord: activeDcpCatalogArtwork ? cloneDcpHistoryValue(activeDcpCatalogArtwork) : null
    };
    return {
      contextKey: dcpHistory.contextKey || dcpHistoryContextValue(),
      design: cloneDcpHistoryValue(design),
      selection: selectedDcpObject,
      selections: selectedDcpObjects.slice(),
      boundaryAttachments: captureDcpDieTextBoundaryAttachments()
    };
  }

  function dcpHistorySignature(snapshot) {
    return snapshot ? JSON.stringify(snapshot.design) : '';
  }

  function sameDcpHistorySnapshot(first, second) {
    return Boolean(first && second) && JSON.stringify(first) === JSON.stringify(second);
  }

  function syncDcpHistoryAfterCanonicalSettlement(previousPresent) {
    const settled = captureDcpHistorySnapshot();
    settled.contextKey = dcpHistory.contextKey;
    const latest = dcpHistory.past[dcpHistory.past.length - 1];
    const canSyncLatest = Boolean(
      previousPresent &&
      latest &&
      latest.after &&
      !dcpHistory.future.length &&
      previousPresent.contextKey === dcpHistory.contextKey &&
      latest.after.contextKey === dcpHistory.contextKey &&
      sameDcpHistorySnapshot(dcpHistory.present, previousPresent) &&
      sameDcpHistorySnapshot(latest.after, previousPresent)
    );
    if (canSyncLatest) latest.after = cloneDcpHistoryValue(settled);
    dcpHistory.present = settled;
    updateDcpHistoryControls();
    return canSyncLatest;
  }

  function updateDcpHistoryControls() {
    const available = isBlankCanvasMode(controls.template ? controls.template.value : '');
    if (targets.dcpHistoryControls) targets.dcpHistoryControls.hidden = !available;
    if (targets.dcpUndo) targets.dcpUndo.disabled = !available || !dcpHistory.past.length;
    if (targets.dcpRedo) targets.dcpRedo.disabled = !available || !dcpHistory.future.length;
    if (targets.dcpRotateToggle) {
      const type = selectedDcpObjects.length === 1 ? dcpObjectType(selectedDcpObject) : '';
      targets.dcpRotateToggle.disabled = !available || (type !== 'artwork' && type !== 'text');
    }
  }

  function resetDcpHistoryBaseline(reason, contextKey) {
    dcpHistory.past = [];
    dcpHistory.future = [];
    dcpHistory.contextKey = contextKey || dcpHistoryContextValue();
    dcpHistory.present = captureDcpHistorySnapshot();
    dcpHistory.present.contextKey = dcpHistory.contextKey;
    root.dataset.srdDcpHistoryBaseline = reason || 'reset';
    updateDcpHistoryControls();
  }

  function syncDcpHistoryContextBoundary(mode, size) {
    const contextKey = dcpHistoryContextValue(mode, size);
    if (!dcpHistory.present || dcpHistory.contextKey !== contextKey) {
      if (dcpHistory.present && dcpHistory.contextKey !== contextKey) {
        dcpSymbolLoadRevision += 1;
        dcpSymbolRestorePending = false;
        dcpObjectInteraction = null;
        dcpMultiSelectMode = false;
        clearDcpObjectSelection();
        applyDcpObjectSelectionState();
        closeDcpSymbolLibrary();
      }
      resetDcpHistoryBaseline('workspace-boundary', contextKey);
    } else {
      updateDcpHistoryControls();
    }
  }

  function resetDcpWorkspaceAtFamilyBoundary(nextMode) {
    const leavingBlankCanvas = activeDesignerMode === 'blank_canvas' && nextMode !== 'blank_canvas';
    activeDesignerMode = nextMode;
    if (!leavingBlankCanvas) return;

    captureActiveDcpModeWorkspace();
    currentDcpProofState = emptyDcpProofState();
    uploadedBlankCanvasArtwork = emptyUploadedBlankCanvasArtwork();
    dcpArtworkAssetToken = '';
    dcpProductionArtworkAssetToken = '';
    dcpArtworkNeedsReselection = false;
    dcpProductionArtworkSource = emptyDcpProductionArtworkSource();
    dcpSymbolLoadRevision += 1;
    dcpSymbolProofRevision += 1;
    dcpSymbolRestorePending = false;
    dcpSymbolMasterLoads.clear();
    closeDcpSymbolLibrary();
    if (targets.dcpSymbolLayer) targets.dcpSymbolLayer.replaceChildren();
    dcpCartEditSession = {
      active: false,
      status: 'inactive',
      lineKey: '',
      expectedVariantId: '',
      expectedProductId: '',
      originalVariantId: '',
      originalProductId: '',
      originalProductionReference: '',
      originalFilename: '',
      originalFileType: '',
      originalHadArtwork: false,
      failure: ''
    };
    dcpShapeRestoreValidationError = '';
    dcpSymbolRestoreValidationError = '';
    selectedDcpObjects = [];
    selectedDcpObject = null;
    dcpMultiSelectMode = false;
    dcpObjectInteraction = null;
    previousDcpPhysicalSize = '';
    activeDcpWorkspaceMode = 'print_design';
    syncDieCuttingCommerceFormLock(false);
    dcpFontLoadRevision += 1;
    if (controls.dcpFont) controls.dcpFont.disabled = false;
    dcpModeActivationRevision += 1;
    dcpHistory = createDcpHistoryState();
    if (controls.blankCanvasUpload) controls.blankCanvasUpload.value = '';
    if (controls.blankCanvasStart) controls.blankCanvasStart.value = 'start_blank';
    root.setAttribute('data-srd-dcp-selected-object', 'none');
    closeDcpHeaderLibrary();
    closeDcpShapeLibrary();

    if (targets.dcpTextLayer) targets.dcpTextLayer.replaceChildren();
    if (targets.blankCanvasArtwork) {
      targets.blankCanvasArtwork.hidden = true;
      targets.blankCanvasArtwork.removeAttribute('src');
    }
    if (targets.blankCanvasArtworkHit) targets.blankCanvasArtworkHit.hidden = true;
    if (targets.dcpHeaderObject) targets.dcpHeaderObject.hidden = true;
    if (targets.dcpHeaderImage) targets.dcpHeaderImage.removeAttribute('src');
    if (targets.dcpShapeObject) targets.dcpShapeObject.hidden = true;
    if (targets.dcpShapeSvg) targets.dcpShapeSvg.replaceChildren();
    (targets.dcpResizeHandles || []).forEach((handle) => { handle.hidden = true; });

    syncDcpProofCompatibilityAlias();
    resetDcpHistoryBaseline(
      'product-family-boundary',
      dcpHistoryContextValue(nextMode, controls.size ? controls.size.value : '')
    );
  }

  function beginDcpHistoryTransaction() {
    if (dcpHistory.applying || !isBlankCanvasMode(controls.template ? controls.template.value : '')) return null;
    return captureDcpHistorySnapshot();
  }

  function commitDcpHistoryTransaction(before, label, options) {
    if (!before || dcpHistory.applying || before.contextKey !== dcpHistory.contextKey) return false;
    const after = captureDcpHistorySnapshot();
    after.contextKey = dcpHistory.contextKey;
    if (dcpHistorySignature(before) === dcpHistorySignature(after)) {
      dcpHistory.present = after;
      updateDcpHistoryControls();
      return false;
    }
    const settings = options || {};
    const now = Date.now();
    const last = dcpHistory.past[dcpHistory.past.length - 1];
    const coalesce = Boolean(
      settings.coalescingKey &&
      last &&
      last.coalescingKey === settings.coalescingKey &&
      now - last.timestamp <= (settings.coalescingWindow || 0) &&
      dcpHistorySignature(last.after) === dcpHistorySignature(before)
    );
    if (coalesce) {
      last.after = after;
      last.timestamp = now;
      last.label = label || last.label;
      if (dcpHistorySignature(last.before) === dcpHistorySignature(last.after)) dcpHistory.past.pop();
    } else {
      dcpHistory.past.push({
        label: label || 'Edit design',
        before: cloneDcpHistoryValue(before),
        after: cloneDcpHistoryValue(after),
        coalescingKey: settings.coalescingKey || '',
        timestamp: now
      });
      if (dcpHistory.past.length > dcpHistoryLimit) dcpHistory.past.shift();
    }
    dcpHistory.future = [];
    dcpHistory.present = after;
    updateDcpHistoryControls();
    return true;
  }

  function registerDcpArtworkFileRevision(file) {
    if (!file) return '';
    dcpArtworkRevisionCounter += 1;
    const token = 'dcp-artwork-' + Date.now().toString(36) + '-' + dcpArtworkRevisionCounter;
    dcpArtworkFileRevisions.set(token, file);
    return token;
  }

  function sameDcpArtworkFile(first, second) {
    return Boolean(first && second &&
      first.name === second.name &&
      first.size === second.size &&
      first.type === second.type &&
      first.lastModified === second.lastModified);
  }

  function restoreDcpArtworkFileRevision(snapshot) {
    const design = snapshot && snapshot.design ? snapshot.design : {};
    const artwork = design.artwork || {};
    if (design.catalogRecord && design.catalogRecord.record) {
      dcpArtworkAssetToken = '';
      dcpArtworkNeedsReselection = false;
      if (controls.blankCanvasUpload) controls.blankCanvasUpload.value = '';
      return;
    }
    const hasArtwork = dcpProofHasArtwork(artwork);
    const token = design.artworkAssetToken || '';
    const file = token ? dcpArtworkFileRevisions.get(token) : null;
    dcpArtworkAssetToken = token;
    dcpArtworkNeedsReselection = Boolean(design.artworkNeedsReselection);
    if (!controls.blankCanvasUpload) {
      dcpArtworkNeedsReselection = hasArtwork;
      return;
    }
    if (!hasArtwork) {
      controls.blankCanvasUpload.value = '';
      dcpArtworkAssetToken = '';
      dcpArtworkNeedsReselection = false;
      return;
    }
    if (file && typeof DataTransfer === 'function') {
      try {
        const transfer = new DataTransfer();
        transfer.items.add(file);
        controls.blankCanvasUpload.files = transfer.files;
        if (controls.blankCanvasUpload.files && sameDcpArtworkFile(controls.blankCanvasUpload.files[0], file)) {
          dcpArtworkNeedsReselection = false;
          return;
        }
      } catch (error) {
        debugLog('artwork history file restoration requires re-selection', error);
      }
    }
    controls.blankCanvasUpload.value = '';
    dcpArtworkNeedsReselection = true;
  }

  function validDcpHistorySelection(selection, objects, proof) {
    const type = dcpObjectType(selection);
    if (type === 'text') return objects.textObjects.some((item) => item.id === dcpObjectId(selection)) ? selection : null;
    if (type === 'symbol') return objects.symbolObjects.some((item) => item.id === dcpObjectId(selection)) ? selection : null;
    if (type === 'artwork') return dcpProofHasArtwork(proof) ? 'artwork' : null;
    if (type === 'header') return objects.header ? 'header' : null;
    if (type === 'shape') return objects.shape ? 'shape' : null;
    return null;
  }

  function dcpObjectRecordForSelection(objects, selection) {
    const type = dcpObjectType(selection);
    const id = dcpObjectId(selection);
    if (type === 'text') return objects.textObjects.find((item) => item.id === id) || null;
    if (type === 'symbol') return objects.symbolObjects.find((item) => item.id === id) || null;
    if (type === 'artwork') return objects.artwork || null;
    if (type === 'header') return objects.header || null;
    if (type === 'shape') return objects.shape || null;
    return null;
  }

  // DCP Multi-Select Phase 1: transient stable identities only; object data stays in proof state.
  function sanitizeDcpObjectSelection(objects, proof, preferredPrimary) {
    const normalized = normalizeDcpCanvasObjects(objects || getDcpProofState().objects);
    const currentProof = proof || getDcpProofState();
    const seen = new Set();
    selectedDcpObjects = selectedDcpObjects.filter((selection) => {
      const valid = validDcpHistorySelection(selection, normalized, currentProof);
      if (!valid || seen.has(valid)) return false;
      seen.add(valid);
      return true;
    });
    const preferred = validDcpHistorySelection(preferredPrimary || selectedDcpObject, normalized, currentProof);
    if (preferred && !seen.has(preferred)) {
      selectedDcpObjects.push(preferred);
      seen.add(preferred);
    }
    selectedDcpObject = preferred && seen.has(preferred)
      ? preferred
      : (selectedDcpObjects.length ? selectedDcpObjects[selectedDcpObjects.length - 1] : null);
    root.setAttribute('data-srd-dcp-selected-object', selectedDcpObject || 'none');
    return selectedDcpObjects;
  }

  function setDcpObjectSelection(selections, primary) {
    selectedDcpObjects = Array.isArray(selections) ? selections.slice() : [];
    selectedDcpObject = primary || null;
    const proof = getDcpProofState();
    const objects = proof.objects;
    sanitizeDcpObjectSelection(objects, proof, selectedDcpObject);
    if (selectedDcpObjects.length === 1 && dcpObjectType(selectedDcpObject) === 'text') {
      syncDcpTextEditorFromSelection(objects, true);
    }
    renderDcpSelectedObjectPanel(objects);
    updateDcpMultiSelectControls();
  }

  function clearDcpObjectSelection() {
    setDcpObjectSelection([], null);
  }

  function toggleDcpObjectSelection(selection) {
    const proof = getDcpProofState();
    const valid = validDcpHistorySelection(selection, normalizeDcpCanvasObjects(proof.objects), proof);
    if (!valid) return;
    const index = selectedDcpObjects.indexOf(valid);
    if (index === -1) {
      setDcpObjectSelection(selectedDcpObjects.concat(valid), valid);
    } else {
      const next = selectedDcpObjects.filter((item) => item !== valid);
      setDcpObjectSelection(next, selectedDcpObject === valid ? next[next.length - 1] || null : selectedDcpObject);
    }
    applyDcpObjectSelectionState();
  }

  function dcpTouchSelectionAvailable() {
    if (typeof window.matchMedia === 'function') {
      return window.matchMedia('(max-width: 820px)').matches;
    }
    return Number(window.innerWidth || document.documentElement.clientWidth || 0) <= 820;
  }

  function updateDcpMultiSelectControls() {
    const available = isBlankCanvasMode(controls.template ? controls.template.value : '');
    const touchAvailable = dcpTouchSelectionAvailable();
    const proof = getDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const objectCount = objects.textObjects.length
      + objects.symbolObjects.length
      + (objects.header ? 1 : 0)
      + (objects.shape ? 1 : 0)
      + (dcpProofHasArtwork(proof) ? 1 : 0);
    root.setAttribute('data-srd-touch-capable', touchAvailable ? 'true' : 'false');
    if (!available || !touchAvailable || objectCount < 1) dcpMultiSelectMode = false;
    if (targets.dcpMultiSelectControls) targets.dcpMultiSelectControls.hidden = !available || !touchAvailable;
    if (targets.dcpMultiSelectToggle) {
      targets.dcpMultiSelectToggle.disabled = !available || !touchAvailable || objectCount < 1;
      targets.dcpMultiSelectToggle.classList.toggle('is-active', dcpMultiSelectMode);
      targets.dcpMultiSelectToggle.setAttribute('aria-pressed', dcpMultiSelectMode ? 'true' : 'false');
      targets.dcpMultiSelectToggle.textContent = dcpMultiSelectMode ? 'Done' : 'Select';
      targets.dcpMultiSelectToggle.setAttribute('aria-label', dcpMultiSelectMode ? 'Finish selecting objects' : 'Select multiple objects');
    }
  }

  function applyDcpHistorySnapshot(snapshot) {
    if (!snapshot || snapshot.contextKey !== dcpHistory.contextKey) return false;
    if (isDieCuttingMode()) {
      const validation = dieCuttingStateValidation(snapshot.design && snapshot.design.objects, null);
      if (!validation.valid) {
        setDieCuttingDevelopmentMessage(validation.message);
        return false;
      }
    }
    dcpHistory.applying = true;
    try {
      const design = cloneDcpHistoryValue(snapshot.design);
      const artwork = design.artwork || {};
      activeDcpCatalogArtwork = design.catalogRecord && design.catalogRecord.record
        ? { record: normalizedDcArtRecord(design.catalogRecord.record), nominalSize: Number(design.catalogRecord.nominalSize) || 6 }
        : null;
      if (activeDcpCatalogArtwork) {
        artwork.mode = 'upload_artwork';
        artwork.source = 'dc_art_catalog';
        artwork.url = activeDcpCatalogArtwork.record.previewSrc;
        artwork.previewUrl = activeDcpCatalogArtwork.record.previewSrc;
        artwork.name = activeDcpCatalogArtwork.record.title;
        artwork.filename = activeDcpCatalogArtwork.record.designId;
        artwork.originalFilename = activeDcpCatalogArtwork.record.designId;
        artwork.type = 'catalog_artwork';
        artwork.fileType = 'catalog_artwork';
        artwork.status = 'Approved DC Art Library design';
        artwork.supported = true;
        artwork.previewable = true;
        artwork.transform = 'catalog-locked-aspect';
        artwork.catalogArtwork = {
          designId: activeDcpCatalogArtwork.record.designId,
          catalogVersion: activeDcpCatalogArtwork.record.catalogVersion,
          nominalSize: activeDcpCatalogArtwork.nominalSize,
          physicalSizeIn: cloneDcpHistoryValue(activeDcpCatalogArtwork.record.exactDimensions[String(activeDcpCatalogArtwork.nominalSize)]),
          lockedAspectRatio: true
        };
      }
      currentDcpProofState = {
        ...emptyDcpProofState(),
        ...artwork,
        physicalCanvas: normalizeDcpPhysicalCanvas(design.physicalCanvas),
        objects: normalizeDcpCanvasObjects(design.objects)
      };
      if (controls.blankCanvasStart && artwork.mode) controls.blankCanvasStart.value = artwork.mode;
      restoreDcpArtworkFileRevision(snapshot);
      restoreDcpProductionArtworkSource(design.productionSourceToken || '');
      syncDcpProofCompatibilityAlias();
      const restoredSelection = Array.isArray(snapshot.selections)
        ? snapshot.selections
        : (snapshot.selection ? [snapshot.selection] : []);
      setDcpObjectSelection(restoredSelection, snapshot.selection || restoredSelection[restoredSelection.length - 1] || null);
      syncDcpTextEditorFromSelection(currentDcpProofState.objects, true);
      Array.from(targets.dcpTextLayer ? targets.dcpTextLayer.querySelectorAll('[data-srd-dcp-text-id]') : []).forEach((element) => {
        delete element.dataset.srdDcpFitSignature;
      });
      update();
      const settlement = settleDcpDieTextPositionsAfterRefit(snapshot.boundaryAttachments);
      if (settlement.valid && activeDcpCatalogArtwork) {
        document.dispatchEvent(new CustomEvent('srd:dc-art-changed', { detail: dcArtState() }));
      }
      return settlement.valid;
    } finally {
      dcpHistory.applying = false;
      updateDcpHistoryControls();
    }
  }

  function undoDcpHistory() {
    dcpSymbolLoadRevision += 1;
    dcpSymbolRestorePending = false;
    closeDcpSymbolLibrary();
    if (targets.dcpSymbolActivationStatus) targets.dcpSymbolActivationStatus.textContent = '';
    dcpObjectInteraction = null;
    if (!dcpHistory.past.length || dcpHistory.applying) return false;
    const entry = dcpHistory.past.pop();
    let applied = false;
    try {
      applied = applyDcpHistorySnapshot(entry.before);
    } catch (error) {
      debugLog('undo history restoration failed', error);
    }
    if (!applied) {
      dcpHistory.past.push(entry);
      updateDcpHistoryControls();
      return false;
    }
    dcpHistory.future.push(entry);
    dcpHistory.present = captureDcpHistorySnapshot();
    if (controls.confirmation) controls.confirmation.checked = false;
    update();
    updateDcpHistoryControls();
    return true;
  }

  function redoDcpHistory() {
    dcpSymbolLoadRevision += 1;
    dcpSymbolRestorePending = false;
    closeDcpSymbolLibrary();
    if (targets.dcpSymbolActivationStatus) targets.dcpSymbolActivationStatus.textContent = '';
    dcpObjectInteraction = null;
    if (!dcpHistory.future.length || dcpHistory.applying) return false;
    const entry = dcpHistory.future.pop();
    let applied = false;
    try {
      applied = applyDcpHistorySnapshot(entry.after);
    } catch (error) {
      debugLog('redo history restoration failed', error);
    }
    if (!applied) {
      dcpHistory.future.push(entry);
      updateDcpHistoryControls();
      return false;
    }
    dcpHistory.past.push(entry);
    dcpHistory.present = captureDcpHistorySnapshot();
    if (controls.confirmation) controls.confirmation.checked = false;
    update();
    updateDcpHistoryControls();
    return true;
  }

  function clearDcpUploadedArtwork() {
    const historyStart = beginDcpHistoryTransaction();
    const proof = getDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    objects.artwork = defaultDcpCanvasObjects().artwork;
    if (controls.blankCanvasUpload) controls.blankCanvasUpload.value = '';
    dcpArtworkAssetToken = '';
    setDcpProofFromUpload({
      ...emptyDcpProofState(),
      mode: selectedBlankCanvasStartMode(),
      objects: objects
    });
    registerDcpProductionArtworkSource({
      status: 'none',
      mutation: dcpCartEditSession.active && dcpCartEditSession.originalHadArtwork ? 'removed' : 'unchanged'
    });
    selectDcpObject(objects.textObjects.length ? dcpTextSelection(objects.textObjects[0].id) : null);
    update();
    commitDcpHistoryTransaction(historyStart, 'Delete artwork');
  }

  function storeSessionDataUrl(reference, dataUrl) {
    try {
      sessionStorage.setItem(reference, dataUrl);
      return true;
    } catch (error) {
      debugLog('session proof storage failed', error);
      return false;
    }
  }

  function parseDcpCanvasObjects(value) {
    if (!value) return null;
    const candidates = [String(value || '')];
    try {
      candidates.push(decodeURIComponent(String(value || '')));
    } catch (error) {
      // URLSearchParams usually decodes this already; keep raw candidate.
    }
    candidates.push(String(value || '')
      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&'));
    try {
      for (const candidate of candidates) {
        if (!candidate) continue;
        try {
          const parsed = JSON.parse(candidate);
          if (activeDcpWorkspaceMode === 'die_cutting') {
            const dieCuttingValidation = dieCuttingStateValidation(parsed, null);
            if (!dieCuttingValidation.valid) {
              dieCuttingStateError = dieCuttingValidation.message;
              return null;
            }
          }
          const sanitized = parsed && typeof parsed === 'object' ? { ...parsed } : {};
          if (activeDcpWorkspaceMode === 'die_cutting') {
            sanitized.shape = null;
            dcpShapeRestoreValidationError = '';
          } else {
            const validation = validateDcpShapeObject(
              parsed && parsed.shape,
              isComplete(controls.size && controls.size.value)
                ? aspectForDesignerSize(dcpLandscapeSize(controls.size.value)).number
                : null
            );
            if (!validation.valid) {
              dcpShapeRestoreValidationError = 'The saved Shape could not be restored: ' + validation.message + ' Please remove and re-add the Shape.';
              sanitized.shape = null;
            } else {
              dcpShapeRestoreValidationError = '';
            }
          }
          const symbolValidation = validateSerializedDcpSymbolObjects(
            parsed && Object.prototype.hasOwnProperty.call(parsed, 'symbolObjects') ? parsed.symbolObjects : undefined,
            controls.size && controls.size.value
          );
          if (!symbolValidation.valid) {
            dcpSymbolRestoreValidationError = 'The saved Symbols could not be restored: ' + symbolValidation.message + ' Re-add the affected Symbol before submitting.';
            sanitized.symbolObjects = symbolValidation.symbols.map(serializedDcpSymbolObject);
          } else {
            dcpSymbolRestoreValidationError = '';
            if (Object.prototype.hasOwnProperty.call(sanitized, 'symbolObjects')) {
              sanitized.symbolObjects = symbolValidation.symbols.map(serializedDcpSymbolObject);
            }
          }
          return normalizeDcpCanvasObjects(sanitized);
        } catch (error) {
          // Try the next likely Shopify/Liquid encoding form.
        }
      }
    } catch (error) {
      // Fall through to the restore warning below.
    }
    debugLog('dcp canvas object restore skipped', value);
    return null;
  }

  function dcpCanvasObjectsForExistingCommerce(objects, size, strictSymbols) {
    const normalized = normalizeDcpCanvasObjects(objects);
    let symbolObjects = [];
    if (strictSymbols) {
      symbolObjects = serializedDcpSymbolObjects(normalized, size, true);
    } else {
      const validation = dcpSymbolValidation(normalized, size, false);
      symbolObjects = validation.valid ? validation.symbols.map(serializedDcpSymbolObject) : [];
    }
    return {
      textObjects: normalized.textObjects,
      artwork: normalized.artwork,
      header: normalized.header,
      shape: normalized.shape,
      symbolObjects: symbolObjects,
      layerOrder: normalizeDcpLayerOrder(normalized.layerOrder, {
        ...normalized,
        symbolObjects: symbolObjects
      })
    };
  }

  function serializeDcpProofForCart() {
    assertPrintDesignCommerceAllowed();
    const proof = getDcpProofState();
    const originalFilename = proof.originalFilename || proof.filename || proof.name || '';
    const size = controls.size && controls.size.value;
    const objects = dcpCanvasObjectsForExistingCommerce(proof.objects, size, true);
    const shapeProperties = dcpShapeCartProperties(objects, size);
    const properties = {
      '_dcp_canvas_objects': JSON.stringify(objects),
      ...dcpHeaderCartProperties(objects),
      ...(shapeProperties.Shape ? { Shape: shapeProperties.Shape } : {}),
      ...dcpSymbolCartProperties(proof.objects, size, true)
    };
    if (dcpProofHasArtwork(proof)) {
      Object.assign(properties, {
        '_dcp_original_filename': originalFilename,
        '_dcp_artwork_type': proof.fileType || proof.type || ''
      });
    }
    return properties;
  }

  function restoreBlankCanvasArtworkFromProof(reference, filename, fileType, status, objects) {
    const restoredObjects = normalizeDcpCanvasObjects(objects);
    if (!reference) {
      if (!filename) return;
      const extension = filename.split('.').pop().toLowerCase();
      const showNotice = isDcpVectorPdfNotice(extension, fileType || extension);
      const rasterPreview = isDcpRasterPreview(fileType || '', extension) || fileType === 'image/svg+xml' || extension === 'svg';
      const restoreStatus = status || (showNotice ? 'Browser preview is unavailable. Your original file will be used for production review.' : 'Restored uploaded artwork filename.');
      setDcpProofFromRestore({
        url: reference && rasterPreview ? reference : '',
        name: filename,
        originalFilename: filename,
        type: fileType || extension,
        dimensions: '',
        width: '',
        height: '',
        reference: reference || '',
        status: restoreStatus,
        supported: true,
        previewable: Boolean(reference && rasterPreview),
        noticeImage: showNotice,
        noticeUrl: showNotice ? dcpVectorPdfNoticeSrc : '',
        objects: restoredObjects,
        message: filename + ' - ' + restoreStatus
      });
      return;
    }
    let proofData = '';
    try {
      proofData = window.sessionStorage ? window.sessionStorage.getItem(reference) || '' : '';
    } catch (error) {
      proofData = '';
    }
    if (!proofData) {
      if (!filename) return;
      const extension = filename.split('.').pop().toLowerCase();
      const showNotice = isDcpVectorPdfNotice(extension, fileType || extension);
      const rasterPreview = isDcpRasterPreview(fileType || '', extension) || fileType === 'image/svg+xml' || extension === 'svg';
      const restoreStatus = status || (showNotice ? 'Browser preview is unavailable. Your original file will be used for production review.' : 'Restored uploaded artwork file reference.');
      setDcpProofFromRestore({
        url: reference && rasterPreview ? reference : '',
        name: filename,
        originalFilename: filename,
        type: fileType || extension,
        dimensions: '',
        width: '',
        height: '',
        reference: reference || '',
        status: restoreStatus,
        supported: true,
        previewable: Boolean(reference && rasterPreview),
        noticeImage: showNotice,
        noticeUrl: showNotice ? dcpVectorPdfNoticeSrc : '',
        objects: restoredObjects,
        message: filename + ' - ' + restoreStatus
      });
      return;
    }
    setDcpProofFromRestore({
      url: proofData,
      name: filename || 'Restored artwork proof',
      originalFilename: filename || 'Restored artwork proof',
      type: fileType || 'image/png',
      dimensions: '',
      width: '',
      height: '',
      reference: reference,
      status: status || 'Restored from cart proof preview.',
      supported: true,
      previewable: true,
      objects: restoredObjects,
      message: filename ? filename + ' - ' + (status || 'Restored from cart proof preview.') : status || 'Restored from cart proof preview.'
    });
  }

  function storeDcpArtworkSnapshot(image) {
    if (!image || !image.naturalWidth || !image.naturalHeight) return '';
    try {
      const maxDimension = 1800;
      const scale = Math.min(1, maxDimension / Math.max(image.naturalWidth, image.naturalHeight));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
      const context = canvas.getContext('2d');
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      const reference = 'srd-dcp-artwork-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      return storeSessionDataUrl(reference, canvas.toDataURL('image/jpeg', 0.9)) ? reference : '';
    } catch (error) {
      debugLog('dcp artwork snapshot skipped', error);
      return '';
    }
  }

  function isDcpRasterPreview(fileType, extension) {
    return fileType === 'image/png' ||
      fileType === 'image/jpeg' ||
      fileType === 'image/webp' ||
      fileType === 'image/gif' ||
      fileType === 'image/bmp' ||
      ['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp'].includes(extension);
  }

  function isDcpVectorPdfNotice(extension, fileType) {
    return extension === 'eps' ||
      extension === 'ai' ||
      extension === 'pdf' ||
      fileType === 'application/pdf';
  }

  async function normalizeDcpRasterProof(objectUrl) {
    if (!objectUrl) return null;
    try {
      const image = await loadCanvasImage(objectUrl);
      const reference = storeDcpArtworkSnapshot(image);
      if (!reference) return null;
      const dataUrl = window.sessionStorage ? window.sessionStorage.getItem(reference) || '' : '';
      if (!dataUrl) return null;
      return {
        url: dataUrl,
        reference: reference,
        width: image.naturalWidth || image.width || '',
        height: image.naturalHeight || image.height || '',
        dimensions: image.naturalWidth && image.naturalHeight ? image.naturalWidth + ' x ' + image.naturalHeight + ' px' : ''
      };
    } catch (error) {
      debugLog('dcp raster normalization skipped', error);
      return null;
    }
  }

  function selectedFontColor() {
    return controls.color ? controls.color.value : '';
  }

  function optionLabel(control, fallback) {
    if (!control || !control.value) return fallback;
    const option = Array.from(control.options || []).find((item) => item.value === control.value);
    return option ? option.textContent.trim() : control.value;
  }

  function isNitrousTemplate(template) {
    return Boolean(templateIntelligence[template] && templateIntelligence[template].nitrous);
  }

  function isNitrousMode(template) {
    return selectorState.template_category === 'nitrous' || isNitrousTemplate(template);
  }

  function isBlankCanvasTemplate(template) {
    return template === 'blank_canvas';
  }

  function isBlankCanvasMode(template) {
    return selectorState.template_category === 'blank_canvas' || isBlankCanvasTemplate(template);
  }

  function normalizeTopLevelProductFamily(value) {
    const key = String(value || '').trim().toLowerCase();
    if (topLevelProductFamiliesByKey[key]) return key;
    const labelMatch = topLevelProductFamilies.find((family) => family.label.toLowerCase() === key);
    return labelMatch ? labelMatch.key : '';
  }

  function topLevelProductFamilyForWorkspace(mode) {
    return normalizeBlankCanvasSubfamily(mode) === 'die_cutting'
      ? 'custom_die_cut_design'
      : 'custom_print_design';
  }

  function selectedTopLevelProductFamily() {
    return topLevelProductFamiliesByKey[normalizeTopLevelProductFamily(selectorState.product_family_key)] || null;
  }

  function selectedTopLevelProductFamilyLabel() {
    const family = selectedTopLevelProductFamily();
    return family ? family.label : 'Select Product Family';
  }

  function productFamilyFromPathname(pathname) {
    let normalizedPath = String(pathname || '/').trim().toLowerCase();
    try {
      normalizedPath = new URL(normalizedPath, window.location.origin).pathname.toLowerCase();
    } catch (error) {
      normalizedPath = normalizedPath.split(/[?#]/, 1)[0];
    }
    normalizedPath = normalizedPath.replace(/\/+$/, '') || '/';
    if (normalizedPath === '/pages/custom-die-cut-design') return 'custom_die_cut_design';
    if (normalizedPath === '/pages/custom-print-design') return 'custom_print_design';
    return '';
  }

  function activateTopLevelProductFamily(key, options) {
    const familyKey = normalizeTopLevelProductFamily(key);
    const family = topLevelProductFamiliesByKey[familyKey];
    const settings = options || {};
    if (!family) return false;
    if (cartAddInProgress && !settings.initial) {
      setCartMessage('Finish the current cart operation before changing Product Family.', 'neutral');
      return false;
    }

    if (family.category === 'blank_canvas') {
      const enteringCustomFamily = selectorState.template_category !== 'blank_canvas';
      const previousFamilyState = {
        key: selectorState.product_family_key,
        label: selectorState.product_family,
        industry: selectorState.industry,
        category: selectorState.template_category,
        template: controls.template.value,
        nitrousTemplate: controls.nitrousTemplate ? controls.nitrousTemplate.value : ''
      };
      selectorState.product_family_key = family.key;
      selectorState.product_family = family.label;
      selectorState.industry = 'Custom';
      selectorState.template_category = 'blank_canvas';
      controls.template.value = 'blank_canvas';
      if (controls.nitrousTemplate) controls.nitrousTemplate.value = '';
      const workspaceMode = family.workspaceMode;
      if (settings.initial || enteringCustomFamily) {
        activateDcpModeWorkspace(workspaceMode, dcpModeWorkspaces[workspaceMode] || defaultDcpModeWorkspace(workspaceMode));
      } else if (workspaceMode !== activeDcpWorkspaceMode) {
        if (!selectBlankCanvasSubfamily(workspaceMode)) {
          selectorState.product_family_key = previousFamilyState.key;
          selectorState.product_family = previousFamilyState.label;
          selectorState.industry = previousFamilyState.industry;
          selectorState.template_category = previousFamilyState.category;
          controls.template.value = previousFamilyState.template;
          if (controls.nitrousTemplate) controls.nitrousTemplate.value = previousFamilyState.nitrousTemplate;
          return false;
        }
      } else {
        selectorState.blank_canvas_subfamily = workspaceMode;
        if (controls.blankCanvasSubfamily) controls.blankCanvasSubfamily.value = workspaceMode;
      }
    } else if (family.category === 'nitrous') {
      selectorState.product_family_key = family.key;
      selectorState.product_family = family.label;
      selectorState.industry = 'Motorsports';
      selectorState.template_category = 'nitrous';
      controls.template.value = controls.nitrousTemplate && controls.nitrousTemplate.value
        ? controls.nitrousTemplate.value
        : '';
    } else {
      selectorState.product_family_key = family.key;
      selectorState.product_family = family.label;
      selectorState.industry = 'Safety';
      selectorState.template_category = 'standard';
      if (isNitrousTemplate(controls.template.value) || isBlankCanvasTemplate(controls.template.value)) {
        controls.template.value = '';
      }
      if (controls.nitrousTemplate) controls.nitrousTemplate.value = '';
    }

    if (!settings.skipUpdate) update();
    return true;
  }

  function initializeProductFamilyFromPathname() {
    const routedFamily = productFamilyFromPathname(window.location.pathname);
    if (!routedFamily) return false;
    return activateTopLevelProductFamily(routedFamily, { initial: true, skipUpdate: true });
  }

  function normalizeBlankCanvasSubfamily(value) {
    const key = String(value || '').trim().toLowerCase();
    const choice = blankCanvasSubfamilies[key];
    return choice && choice.enabled ? key : 'print_design';
  }

  function selectedBlankCanvasSubfamily() {
    selectorState.blank_canvas_subfamily = activeDcpWorkspaceMode;
    if (controls.blankCanvasSubfamily && controls.blankCanvasSubfamily.value !== activeDcpWorkspaceMode) {
      controls.blankCanvasSubfamily.value = activeDcpWorkspaceMode;
    }
    return activeDcpWorkspaceMode;
  }

  function selectedBlankCanvasSubfamilyLabel() {
    const choice = blankCanvasSubfamilies[selectedBlankCanvasSubfamily()];
    return choice ? choice.label : blankCanvasSubfamilies.print_design.label;
  }

  function isDieCuttingMode() {
    return isBlankCanvasMode(controls.template ? controls.template.value : '')
      && selectedBlankCanvasSubfamily() === 'die_cutting';
  }

  function dcpFontIdsForWorkflow(workflow) {
    const ids = srdFontCatalog.workflows && srdFontCatalog.workflows[workflow];
    return Array.isArray(ids) ? ids.filter((id) => Boolean(fontLabels[id])) : [];
  }

  function dcpDefaultFontKey(workflow) {
    const configured = srdFontCatalog.defaults && srdFontCatalog.defaults[workflow];
    const ids = dcpFontIdsForWorkflow(workflow);
    return configured && ids.includes(configured) ? configured : (ids[0] || 'arial');
  }

  function dcpFontAllowedForWorkflow(fontKey, workflow) {
    return dcpFontIdsForWorkflow(workflow).includes(fontKey)
      || (workflow === 'die_cutting' && dcpLegacyDieFontIds.has(fontKey));
  }

  const dcpLegacyDieFontIds = new Set([
    'agincort-condensed',
    'brush-stroke-26-bold-italic',
    'caligula',
    'cowboy-bold-italic',
    'cowboy-bold',
    'cowboy-italic',
    'cowboy-regular',
    'cowboy-thin-italic',
    'cowboy-thin'
  ]);

  function ensureDcpLegacyFontOption(fontKey, workflow) {
    if (!controls.dcpFont || workflow !== 'die_cutting' || !dcpLegacyDieFontIds.has(fontKey)) return;
    if (Array.from(controls.dcpFont.options).some((option) => option.value === fontKey)) return;
    const option = document.createElement('option');
    option.value = fontKey;
    option.textContent = (fontLabels[fontKey] || fontKey) + ' (legacy design)';
    option.disabled = true;
    option.dataset.srdLegacyFont = 'true';
    controls.dcpFont.appendChild(option);
  }

  function currentDcpFontWorkflow() {
    return isDieCuttingMode() ? 'die_cutting' : 'print_design';
  }

  function syncDcpFontControlCatalog() {
    if (!controls.dcpFont) return;
    const workflow = currentDcpFontWorkflow();
    const ids = dcpFontIdsForWorkflow(workflow);
    if (controls.dcpFont.dataset.srdFontWorkflow === workflow
      && controls.dcpFont.options.length === ids.length) return;
    const previous = controls.dcpFont.value;
    controls.dcpFont.innerHTML = '';
    ids.forEach((fontKey) => {
      const option = document.createElement('option');
      option.value = fontKey;
      option.textContent = fontLabels[fontKey];
      controls.dcpFont.appendChild(option);
    });
    const fallback = dcpDefaultFontKey(workflow);
    controls.dcpFont.value = ids.includes(previous) ? previous : fallback;
    controls.dcpFont.dataset.srdFontWorkflow = workflow;
  }

  function setDieCuttingDevelopmentMessage(message) {
    dieCuttingStateError = message || '';
    if (targets.dcpToolbarStatus && message) targets.dcpToolbarStatus.textContent = message;
    if (message) setCartMessage(message, 'neutral');
  }

  function dieCuttingStateValidation(objects, proof) {
    const source = objects && typeof objects === 'object' ? objects : {};
    const textObjects = Array.isArray(source.textObjects) ? source.textObjects : [];
    if (source.header || (Array.isArray(source.symbolObjects) && source.symbolObjects.length)) {
      return { valid: false, message: 'Headers and Symbols are unavailable for Die Cutting.' };
    }
    if (proof && dcpProofHasArtwork(proof) && !proof.catalogArtwork) return { valid: false, message: 'Artwork uploads are unavailable for Die Cutting.' };
    for (let index = 0; index < textObjects.length; index += 1) {
      const item = textObjects[index] || {};
      if (/[\r\n]/.test(String(item.text || ''))) {
        return { valid: false, objectIndex: index, message: 'Each Die Cutting text object must contain exactly one line.' };
      }
      const textValidation = validateDieCuttingTextValue(item.text);
      if (!textValidation.valid) return { valid: false, objectIndex: index, message: textValidation.message };
      if (!dcpFontAllowedForWorkflow(String(item.fontKey || ''), 'die_cutting')) {
        return { valid: false, objectIndex: index, message: 'A saved text object uses a font that is not approved for Die Cutting.' };
      }
    }
    return { valid: true, message: '' };
  }

  function selectBlankCanvasSubfamily(key) {
    const normalized = normalizeBlankCanvasSubfamily(key);
    if (cartAddInProgress) {
      setCartMessage('Finish the current cart operation before changing Blank Canvas type.', 'neutral');
      return false;
    }
    if (normalized === activeDcpWorkspaceMode) {
      selectorState.product_family_key = topLevelProductFamilyForWorkspace(normalized);
      selectorState.product_family = topLevelProductFamiliesByKey[selectorState.product_family_key].label;
      selectorState.blank_canvas_subfamily = normalized;
      if (controls.blankCanvasSubfamily) controls.blankCanvasSubfamily.value = normalized;
      syncDcpFontControlCatalog();
      return true;
    }
    updateSelectedDcpTextObjectFromEditor();
    captureActiveDcpModeWorkspace();
    const nextWorkspace = dcpModeWorkspaces[normalized] || defaultDcpModeWorkspace(normalized);
    if (normalized === 'die_cutting') {
      const proof = nextWorkspace.proof;
      const validation = dieCuttingStateValidation(proof.objects, proof);
      if (!validation.valid) {
        setDieCuttingDevelopmentMessage(validation.message);
        return false;
      }
      const normalizedObjects = normalizeDcpCanvasObjects(proof.objects, normalized);
      normalizedObjects.textObjects.forEach((item) => {
        item.text = normalizeDieCuttingTextValue(item.text);
      });
      proof.objects = normalizedObjects;
      nextWorkspace.blankCanvasStart = 'start_blank';
    }
    dieCuttingStateError = '';
    dcpSymbolLoadRevision += 1;
    dcpSymbolRestorePending = false;
    closeDcpHeaderLibrary();
    closeDcpShapeLibrary();
    closeDcpSymbolLibrary();
    activateDcpModeWorkspace(normalized, nextWorkspace);
    syncDcpFontControlCatalog();
    const defaultFontKey = dcpDefaultFontKey(normalized);
    const activationRevision = dcpModeActivationRevision;
    ensureDcpFontReady(defaultFontKey)
      .then(() => {
        if (isCurrentDcpModeActivation(normalized, activationRevision)) update();
      })
      .catch(() => {
        if (!isCurrentDcpModeActivation(normalized, activationRevision)) return;
        failedDcpFontIds.add(defaultFontKey);
        syncDcpFontControlCatalog();
        setDieCuttingDevelopmentMessage('The default font could not be loaded. Text creation is unavailable.');
        update();
      });
    return true;
  }

  function normalizeDieCuttingTextValue(value) {
    return normalizeDieCuttingWhitespace(value);
  }

  function normalizeDieCuttingWhitespace(value) {
    return String(value || '').replace(/\r\n?|\n/gu, ' ').replace(/\t/gu, ' ');
  }

  function dieCuttingNonSpaceCharacterCount(value) {
    return dcpTextGraphemes(normalizeDieCuttingTextValue(value))
      .filter((character) => !/\s/u.test(character))
      .length;
  }

  function validateDieCuttingTextValue(value) {
    const normalized = normalizeDieCuttingTextValue(value);
    const count = dieCuttingNonSpaceCharacterCount(normalized);
    return {
      valid: count <= dieCuttingMaxNonSpaceCharacters,
      value: normalized,
      count: count,
      message: count <= dieCuttingMaxNonSpaceCharacters ? '' : dieCuttingCharacterLimitMessage
    };
  }

  function dcpDieRound(value) {
    const factor = 10 ** dcpDieProductionPrecision;
    const rounded = Math.round((Number(value) + Number.EPSILON) * factor) / factor;
    return Object.is(rounded, -0) ? 0 : rounded;
  }

  function dcpDiePoint(x, y) {
    return { x: dcpDieRound(x), y: dcpDieRound(y) };
  }

  function dcpDieBounds(left, top, right, bottom) {
    if (![left, top, right, bottom].every(Number.isFinite)) return null;
    return {
      left: dcpDieRound(left),
      top: dcpDieRound(top),
      right: dcpDieRound(right),
      bottom: dcpDieRound(bottom),
      width: dcpDieRound(Math.max(0, right - left)),
      height: dcpDieRound(Math.max(0, bottom - top))
    };
  }

  function dcpDieUnionBounds(boundsList) {
    const valid = boundsList.filter(Boolean);
    if (!valid.length) return null;
    return dcpDieBounds(
      Math.min(...valid.map((item) => item.left)),
      Math.min(...valid.map((item) => item.top)),
      Math.max(...valid.map((item) => item.right)),
      Math.max(...valid.map((item) => item.bottom))
    );
  }

  function dcpDiePathCommands(fontKey, codePoint, pathData) {
    const cacheKey = fontKey + '|' + codePoint;
    if (dcpDieParsedGlyphPathCache.has(cacheKey)) return dcpDieParsedGlyphPathCache.get(cacheKey);
    const tokens = String(pathData || '').match(/[MLCZ]|-?(?:\d+\.?\d*|\.\d+)/g) || [];
    const commands = [];
    let index = 0;
    while (index < tokens.length) {
      const type = tokens[index++];
      if (type === 'Z') {
        commands.push({ type: 'Z', points: [] });
        continue;
      }
      const count = type === 'C' ? 6 : 2;
      const points = [];
      for (let valueIndex = 0; valueIndex < count; valueIndex += 2) {
        points.push({ x: Number(tokens[index + valueIndex]), y: Number(tokens[index + valueIndex + 1]) });
      }
      index += count;
      commands.push({ type: type, points: points });
    }
    dcpDieParsedGlyphPathCache.set(cacheKey, commands);
    return commands;
  }

  function dcpDieCubicValue(start, control1, control2, end, t) {
    const inverse = 1 - t;
    return inverse ** 3 * start
      + 3 * inverse ** 2 * t * control1
      + 3 * inverse * t ** 2 * control2
      + t ** 3 * end;
  }

  function dcpDieCubicExtrema(start, control1, control2, end) {
    const a = -start + 3 * control1 - 3 * control2 + end;
    const b = 2 * (start - 2 * control1 + control2);
    const c = control1 - start;
    if (Math.abs(a) < 1e-12) {
      if (Math.abs(b) < 1e-12) return [];
      const t = -c / b;
      return t > 0 && t < 1 ? [t] : [];
    }
    const discriminant = b * b - 4 * a * c;
    if (discriminant < 0) return [];
    const root = Math.sqrt(discriminant);
    return [(-b + root) / (2 * a), (-b - root) / (2 * a)].filter((t) => t > 0 && t < 1);
  }

  function dcpDieTransformPath(commands, transformPoint) {
    const output = [];
    const contours = [];
    let contour = [];
    let current = null;
    let start = null;
    let left = Infinity;
    let right = -Infinity;
    let top = Infinity;
    let bottom = -Infinity;
    const include = (point) => {
      left = Math.min(left, point.x);
      right = Math.max(right, point.x);
      top = Math.min(top, point.y);
      bottom = Math.max(bottom, point.y);
    };
    const appendPoint = (point) => {
      include(point);
      contour.push(point);
    };
    commands.forEach((command) => {
      if (command.type === 'M') {
        if (contour.length > 2) contours.push(contour);
        contour = [];
        current = transformPoint(command.points[0]);
        start = current;
        appendPoint(current);
        output.push('M' + dcpDieRound(current.x) + ' ' + dcpDieRound(current.y));
        return;
      }
      if (command.type === 'L') {
        current = transformPoint(command.points[0]);
        appendPoint(current);
        output.push('L' + dcpDieRound(current.x) + ' ' + dcpDieRound(current.y));
        return;
      }
      if (command.type === 'C' && current) {
        const control1 = transformPoint(command.points[0]);
        const control2 = transformPoint(command.points[1]);
        const end = transformPoint(command.points[2]);
        const extrema = new Set([
          ...dcpDieCubicExtrema(current.x, control1.x, control2.x, end.x),
          ...dcpDieCubicExtrema(current.y, control1.y, control2.y, end.y)
        ]);
        extrema.forEach((t) => include({
          x: dcpDieCubicValue(current.x, control1.x, control2.x, end.x, t),
          y: dcpDieCubicValue(current.y, control1.y, control2.y, end.y, t)
        }));
        for (let sample = 1; sample <= 24; sample += 1) {
          const t = sample / 24;
          appendPoint({
            x: dcpDieCubicValue(current.x, control1.x, control2.x, end.x, t),
            y: dcpDieCubicValue(current.y, control1.y, control2.y, end.y, t)
          });
        }
        current = end;
        output.push(
          'C' + dcpDieRound(control1.x) + ' ' + dcpDieRound(control1.y) + ' '
          + dcpDieRound(control2.x) + ' ' + dcpDieRound(control2.y) + ' '
          + dcpDieRound(end.x) + ' ' + dcpDieRound(end.y)
        );
        return;
      }
      if (command.type === 'Z') {
        if (start && current && (Math.abs(current.x - start.x) > 1e-9 || Math.abs(current.y - start.y) > 1e-9)) {
          contour.push(start);
        }
        if (contour.length > 2) contours.push(contour);
        contour = [];
        current = start;
        output.push('Z');
      }
    });
    if (contour.length > 2) contours.push(contour);
    return {
      pathData: output.join(''),
      bounds: dcpDieBounds(left, top, right, bottom),
      contours: contours
    };
  }

  function dcpDieFilterNumericalGlyphSubpaths(commands, glyph) {
    const subpaths = [];
    let current = [];
    (commands || []).forEach((command) => {
      if (command.type === 'M' && current.length) {
        subpaths.push(current);
        current = [];
      }
      current.push(command);
    });
    if (current.length) subpaths.push(current);
    const glyphBounds = glyph && Array.isArray(glyph.bounds) ? glyph.bounds : [0, 0, 0, 0];
    const glyphSpan = Math.max(Math.abs(Number(glyphBounds[2]) || 0), Math.abs(Number(glyphBounds[3]) || 0), 1);
    const artifactThreshold = glyphSpan * 0.005;
    return subpaths.filter((subpath) => {
      const points = subpath.flatMap((command) => command.points || []);
      if (points.length < 3) return false;
      const width = Math.max(...points.map((point) => point.x)) - Math.min(...points.map((point) => point.x));
      const height = Math.max(...points.map((point) => point.y)) - Math.min(...points.map((point) => point.y));
      if (width <= 1e-9 || height <= 1e-9) return false;
      return width >= artifactThreshold || height >= artifactThreshold;
    }).flat();
  }

  function dcpDieRotatePoint(point, center, radians) {
    const cosine = Math.cos(radians);
    const sine = Math.sin(radians);
    const x = point.x - center.x;
    const y = point.y - center.y;
    return {
      x: center.x + x * cosine - y * sine,
      y: center.y + x * sine + y * cosine
    };
  }

  function dcpDieFontRecord(fontKey) {
    const record = dcpDieOutlineCatalog.fonts && dcpDieOutlineCatalog.fonts[fontKey];
    const catalog = fontCatalogById[fontKey];
    if (!record || !catalog || record.sourceSha256 !== catalog.sourceSha256) return null;
    return { outline: record, catalog: catalog };
  }

  function dcpDieGlyphRecords(text, fontRecord) {
    const characters = Array.from(String(text || ''));
    return characters.map((character, index) => {
      const codePoint = character.codePointAt(0);
      const glyph = fontRecord.outline.glyphs[String(codePoint)];
      return {
        index: index,
        character: character,
        codePoint: codePoint,
        glyph: glyph || null
      };
    });
  }

  function dcpDieObjectBox(object, canvas) {
    const width = canvas.width * Number(object.width) / 100;
    const height = canvas.height * Number(object.height) / 100;
    const center = {
      x: canvas.width * Number(object.x) / 100,
      y: canvas.height * Number(object.y) / 100
    };
    return {
      center: center,
      width: width,
      height: height,
      left: center.x - width / 2,
      top: center.y - height / 2
    };
  }

  function dcpDieHorizontalScale(object) {
    return clampDcpNumber(
      object && object.horizontalScale,
      dcpDieMinimumHorizontalScale,
      dcpDieMaximumHorizontalScale,
      1
    );
  }

  function dcpDieStraightGeometry(object, canvas, fontRecord, glyphRecords) {
    const box = dcpDieObjectBox(object, canvas);
    const horizontalScale = dcpDieHorizontalScale(object);
    let cursor = 0;
    let localLeft = Infinity;
    let localRight = -Infinity;
    let localTop = Infinity;
    let localBottom = -Infinity;
    glyphRecords.forEach((record) => {
      record.cursor = cursor;
      if (record.glyph && record.glyph.path) {
        const bounds = record.glyph.bounds;
        localLeft = Math.min(localLeft, cursor + bounds[0]);
        localTop = Math.min(localTop, bounds[1]);
        localRight = Math.max(localRight, cursor + bounds[0] + bounds[2]);
        localBottom = Math.max(localBottom, bounds[1] + bounds[3]);
      }
      cursor += record.glyph ? Number(record.glyph.advance) : 0;
    });
    if (![localLeft, localTop, localRight, localBottom].every(Number.isFinite)) return null;
    const paintWidth = Math.max(0.000001, localRight - localLeft);
    const paintHeight = Math.max(0.000001, localBottom - localTop);
    const scale = Math.min(box.width / paintWidth, box.height / paintHeight);
    const localCenterX = (localLeft + localRight) / 2;
    const localCenterY = (localTop + localBottom) / 2;
    const rotation = Number(object.rotation || 0) * Math.PI / 180;
    const glyphs = [];
    glyphRecords.forEach((record) => {
      if (!record.glyph || !record.glyph.path) return;
      const transform = (point) => dcpDieRotatePoint({
        x: box.center.x + ((record.cursor + point.x) - localCenterX) * scale * horizontalScale,
        y: box.center.y + (point.y - localCenterY) * scale
      }, box.center, rotation);
      const transformed = dcpDieTransformPath(
        dcpDieFilterNumericalGlyphSubpaths(
          dcpDiePathCommands(object.fontKey, record.codePoint, record.glyph.path),
          record.glyph
        ),
        transform
      );
      const anchor = dcpDieRotatePoint({
        x: box.center.x + ((record.cursor + Number(record.glyph.advance) / 2) - localCenterX) * scale * horizontalScale,
        y: box.center.y - localCenterY * scale
      }, box.center, rotation);
      glyphs.push({
        index: record.index,
        character: record.character,
        codePoint: record.codePoint,
        glyphId: record.glyph.glyphId,
        pathData: transformed.pathData,
        paintedBoundsIn: transformed.bounds,
        paintedHeightIn: dcpDieRound(record.glyph.bounds[3] * scale),
        anchorIn: dcpDiePoint(anchor.x, anchor.y),
        scaleInPerEm: dcpDieRound(scale),
        rotationDeg: dcpDieRound(Number(object.rotation || 0)),
        tangentDeg: 0,
        contours: transformed.contours
      });
    });
    const bounds = dcpDieUnionBounds(glyphs.map((glyph) => glyph.paintedBoundsIn));
    const baselineStart = dcpDieRotatePoint({
      x: box.center.x + (0 - localCenterX) * scale * horizontalScale,
      y: box.center.y - localCenterY * scale
    }, box.center, rotation);
    const baselineEnd = dcpDieRotatePoint({
      x: box.center.x + (cursor - localCenterX) * scale * horizontalScale,
      y: box.center.y - localCenterY * scale
    }, box.center, rotation);
    return {
      glyphs: glyphs,
      bounds: bounds,
      localBounds: dcpDieBounds(
        box.center.x + (localLeft - localCenterX) * scale * horizontalScale,
        box.center.y + (localTop - localCenterY) * scale,
        box.center.x + (localRight - localCenterX) * scale * horizontalScale,
        box.center.y + (localBottom - localCenterY) * scale
      ),
      scale: scale,
      horizontalScale: horizontalScale,
      baseline: { startIn: dcpDiePoint(baselineStart.x, baselineStart.y), endIn: dcpDiePoint(baselineEnd.x, baselineEnd.y) }
    };
  }

  function dcpDieArchGeometry(object, width, height) {
    const shape = normalizeDcpTextShape(object && object.textShape);
    const arc = clampDcpNumber(object && object.arcAmount, 0, 100, 35);
    const boxWidth = Math.max(0.000001, Number(width) || 0);
    const boxHeight = Math.max(0.000001, Number(height) || 0);
    const padX = boxWidth * 0.08;
    const centerX = boxWidth / 2;
    const centerY = boxHeight * 0.52;
    const strength = arc / 100;
    const direction = shape === 'arch_down' ? 1 : -1;
    const endpointY = centerY - direction * boxHeight * 0.32 * strength;
    const apexY = centerY + direction * boxHeight * 0.40 * strength;
    return {
      start: { x: padX, y: endpointY },
      control: { x: centerX, y: 2 * apexY - endpointY },
      end: { x: boxWidth - padX, y: endpointY }
    };
  }

  function dcpDieArchedCandidate(object, box, glyphRecords, scale) {
    const geometry = dcpDieArchGeometry(object, box.width, box.height);
    const table = dcpQuadraticArcTable(geometry);
    const totalAdvance = glyphRecords.reduce((sum, record) => sum + (record.glyph ? Number(record.glyph.advance) * scale : 0), 0);
    if (!totalAdvance || totalAdvance > table.length) return null;
    let cursor = (table.length - totalAdvance) / 2;
    const placements = [];
    let left = Infinity;
    let right = -Infinity;
    let top = Infinity;
    let bottom = -Infinity;
    glyphRecords.forEach((record) => {
      const advance = record.glyph ? Number(record.glyph.advance) * scale : 0;
      const placement = dcpQuadraticPointAtLength(geometry, table, cursor + advance / 2);
      cursor += advance;
      if (!record.glyph || !record.glyph.path) return;
      const bounds = record.glyph.bounds;
      const corners = [
        { x: (bounds[0] - Number(record.glyph.advance) / 2) * scale, y: bounds[1] * scale },
        { x: (bounds[0] + bounds[2] - Number(record.glyph.advance) / 2) * scale, y: bounds[1] * scale },
        { x: (bounds[0] + bounds[2] - Number(record.glyph.advance) / 2) * scale, y: (bounds[1] + bounds[3]) * scale },
        { x: (bounds[0] - Number(record.glyph.advance) / 2) * scale, y: (bounds[1] + bounds[3]) * scale }
      ].map((point) => ({
        x: placement.x + point.x * Math.cos(placement.angle) - point.y * Math.sin(placement.angle),
        y: placement.y + point.x * Math.sin(placement.angle) + point.y * Math.cos(placement.angle)
      }));
      corners.forEach((point) => {
        left = Math.min(left, point.x);
        right = Math.max(right, point.x);
        top = Math.min(top, point.y);
        bottom = Math.max(bottom, point.y);
      });
      placements.push({ record: record, placement: placement });
    });
    return {
      geometry: geometry,
      table: table,
      totalAdvance: totalAdvance,
      placements: placements,
      bounds: dcpDieBounds(left, top, right, bottom),
      fits: left >= 0 && top >= 0 && right <= box.width && bottom <= box.height
    };
  }

  function dcpDieArchedGeometry(object, canvas, fontRecord, glyphRecords) {
    const box = dcpDieObjectBox(object, canvas);
    const horizontalScale = dcpDieHorizontalScale(object);
    const paintedGlyphs = glyphRecords.filter((record) => record.glyph && record.glyph.path);
    if (!paintedGlyphs.length) return null;
    const totalAdvance = glyphRecords.reduce((sum, record) => sum + (record.glyph ? Number(record.glyph.advance) : 0), 0);
    const paintTop = Math.min(...paintedGlyphs.map((record) => Number(record.glyph.bounds[1])));
    const paintBottom = Math.max(...paintedGlyphs.map((record) => Number(record.glyph.bounds[1]) + Number(record.glyph.bounds[3])));
    const paintHeight = Math.max(0.000001, paintBottom - paintTop);
    const scale = Math.min(box.width * 0.84 / Math.max(totalAdvance, 0.000001), box.height / paintHeight);
    const candidate = dcpDieArchedCandidate(object, box, glyphRecords, scale);
    const best = candidate ? { ...candidate, scale: scale } : null;
    if (!best) return null;
    const objectRotation = Number(object.rotation || 0) * Math.PI / 180;
    const glyphs = best.placements.map((item) => {
      const record = item.record;
      const placement = item.placement;
      const transform = (point) => {
        const localX = placement.x + (point.x - Number(record.glyph.advance) / 2) * best.scale * Math.cos(placement.angle)
          - point.y * best.scale * Math.sin(placement.angle);
        const localY = placement.y + (point.x - Number(record.glyph.advance) / 2) * best.scale * Math.sin(placement.angle)
          + point.y * best.scale * Math.cos(placement.angle);
        return dcpDieRotatePoint({
          x: box.left + box.width / 2 + (localX - box.width / 2) * horizontalScale,
          y: box.top + localY
        }, box.center, objectRotation);
      };
      const transformed = dcpDieTransformPath(
        dcpDieFilterNumericalGlyphSubpaths(
          dcpDiePathCommands(object.fontKey, record.codePoint, record.glyph.path),
          record.glyph
        ),
        transform
      );
      const anchor = dcpDieRotatePoint({
        x: box.left + box.width / 2 + (placement.x - box.width / 2) * horizontalScale,
        y: box.top + placement.y
      }, box.center, objectRotation);
      const scaledTangentAngle = Math.atan2(
        Math.sin(placement.angle),
        horizontalScale * Math.cos(placement.angle)
      );
      return {
        index: record.index,
        character: record.character,
        codePoint: record.codePoint,
        glyphId: record.glyph.glyphId,
        pathData: transformed.pathData,
        paintedBoundsIn: transformed.bounds,
        paintedHeightIn: dcpDieRound(record.glyph.bounds[3] * best.scale),
        anchorIn: dcpDiePoint(anchor.x, anchor.y),
        scaleInPerEm: dcpDieRound(best.scale),
        rotationDeg: dcpDieRound(Number(object.rotation || 0) + scaledTangentAngle * 180 / Math.PI),
        tangentDeg: dcpDieRound(scaledTangentAngle * 180 / Math.PI),
        contours: transformed.contours
      };
    });
    const curvePoints = [best.geometry.start, best.geometry.control, best.geometry.end].map((point) => {
      return dcpDieRotatePoint({
        x: box.left + box.width / 2 + (point.x - box.width / 2) * horizontalScale,
        y: box.top + point.y
      }, box.center, objectRotation);
    });
    const localBounds = best.bounds
      ? dcpDieBounds(
          box.left + box.width / 2 + (best.bounds.left - box.width / 2) * horizontalScale,
          box.top + best.bounds.top,
          box.left + box.width / 2 + (best.bounds.right - box.width / 2) * horizontalScale,
          box.top + best.bounds.bottom
        )
      : null;
    const transformedCurve = {
      start: curvePoints[0],
      control: curvePoints[1],
      end: curvePoints[2]
    };
    return {
      glyphs: glyphs,
      bounds: dcpDieUnionBounds(glyphs.map((glyph) => glyph.paintedBoundsIn)),
      localBounds: localBounds,
      scale: best.scale,
      horizontalScale: horizontalScale,
      baseline: {
        type: 'quadratic',
        startIn: dcpDiePoint(curvePoints[0].x, curvePoints[0].y),
        controlIn: dcpDiePoint(curvePoints[1].x, curvePoints[1].y),
        endIn: dcpDiePoint(curvePoints[2].x, curvePoints[2].y)
      },
      pathLengthIn: dcpDieRound(dcpQuadraticArcTable(transformedCurve).length)
    };
  }

  function dcpDiePolygonBounds(points) {
    if (!points || !points.length) return null;
    return dcpDieBounds(
      Math.min(...points.map((point) => point.x)),
      Math.min(...points.map((point) => point.y)),
      Math.max(...points.map((point) => point.x)),
      Math.max(...points.map((point) => point.y))
    );
  }

  function dcpDiePointOnSegment(point, start, end) {
    const cross = (end.x - start.x) * (point.y - start.y) - (end.y - start.y) * (point.x - start.x);
    if (Math.abs(cross) > dcpDieContourIntersectionToleranceIn) return false;
    return point.x >= Math.min(start.x, end.x) - dcpDieContourIntersectionToleranceIn
      && point.x <= Math.max(start.x, end.x) + dcpDieContourIntersectionToleranceIn
      && point.y >= Math.min(start.y, end.y) - dcpDieContourIntersectionToleranceIn
      && point.y <= Math.max(start.y, end.y) + dcpDieContourIntersectionToleranceIn;
  }

  function dcpDieSegmentsIntersect(a, b, c, d) {
    const cross = (p, q, r) => (q.x - p.x) * (r.y - p.y) - (q.y - p.y) * (r.x - p.x);
    const first = cross(a, b, c);
    const second = cross(a, b, d);
    const third = cross(c, d, a);
    const fourth = cross(c, d, b);
    const tolerance = dcpDieContourIntersectionToleranceIn;
    const crosses = ((first > tolerance && second < -tolerance) || (first < -tolerance && second > tolerance))
      && ((third > tolerance && fourth < -tolerance) || (third < -tolerance && fourth > tolerance));
    return crosses
      || (Math.abs(first) <= tolerance && dcpDiePointOnSegment(c, a, b))
      || (Math.abs(second) <= tolerance && dcpDiePointOnSegment(d, a, b))
      || (Math.abs(third) <= tolerance && dcpDiePointOnSegment(a, c, d))
      || (Math.abs(fourth) <= tolerance && dcpDiePointOnSegment(b, c, d));
  }

  function dcpDiePointInPolygon(point, polygon) {
    let inside = false;
    for (let index = 0, previous = polygon.length - 1; index < polygon.length; previous = index++) {
      const currentPoint = polygon[index];
      const previousPoint = polygon[previous];
      const crosses = ((currentPoint.y > point.y) !== (previousPoint.y > point.y))
        && point.x < (previousPoint.x - currentPoint.x) * (point.y - currentPoint.y)
          / ((previousPoint.y - currentPoint.y) || 1e-12) + currentPoint.x;
      if (crosses) inside = !inside;
    }
    return inside;
  }

  function dcpDiePointInContours(point, contours) {
    return contours.reduce((inside, contour) => dcpDiePointInPolygon(point, contour) ? !inside : inside, false);
  }

  function dcpDieContoursOverlap(first, second) {
    for (const firstContour of first) {
      for (const secondContour of second) {
        for (let a = 1; a < firstContour.length; a += 1) {
          for (let b = 1; b < secondContour.length; b += 1) {
            if (dcpDieSegmentsIntersect(firstContour[a - 1], firstContour[a], secondContour[b - 1], secondContour[b])) return true;
          }
        }
      }
    }
    return first.some((contour) => contour.some((point) => dcpDiePointInContours(point, second)))
      || second.some((contour) => contour.some((point) => dcpDiePointInContours(point, first)));
  }

  function dcpDieBoundsIntersect(first, second) {
    if (!first || !second) return false;
    const tolerance = dcpDieContourIntersectionToleranceIn;
    return first.left <= second.right + tolerance
      && first.right + tolerance >= second.left
      && first.top <= second.bottom + tolerance
      && first.bottom + tolerance >= second.top;
  }

  function dcpDieGlyphContoursOverlap(firstGlyphs, secondGlyphs) {
    for (const first of firstGlyphs || []) {
      for (const second of secondGlyphs || []) {
        if (!dcpDieBoundsIntersect(first.bounds, second.bounds)) continue;
        if (dcpDieContoursOverlap(first.contours, second.contours)) return true;
      }
    }
    return false;
  }

  function dcpDieIssue(code, objectId, message, detail, blocking) {
    return {
      code: code,
      objectId: objectId || null,
      message: message,
      detail: detail,
      classification: blocking === false ? 'warning' : 'blocking'
    };
  }

  function dcpDieObjectProductionGeometry(object, canvas, order) {
    const fontRecord = dcpDieFontRecord(object.fontKey);
    const issues = [];
    if (!fontRecord) {
      issues.push(dcpDieIssue(
        'DIE_FONT_UNAVAILABLE',
        object.id,
        'The selected font is not available for production.',
        'No hash-matched outline catalog entry exists for font key ' + object.fontKey + '.'
      ));
      return { object: null, issues: issues };
    }
    const glyphRecords = dcpDieGlyphRecords(object.text, fontRecord);
    const missing = glyphRecords.filter((record) => !record.glyph && !/\s/u.test(record.character));
    if (missing.length) {
      issues.push(dcpDieIssue(
        'DIE_GLYPH_UNAVAILABLE',
        object.id,
        'The selected font does not contain every character in this text.',
        'Missing Unicode code points: ' + missing.map((record) => 'U+' + record.codePoint.toString(16).toUpperCase().padStart(4, '0')).join(', ') + '.'
      ));
      return { object: null, issues: issues };
    }
    const shape = normalizeDcpTextShape(object.textShape);
    const geometry = shape === 'straight'
      ? dcpDieStraightGeometry(object, canvas, fontRecord, glyphRecords)
      : dcpDieArchedGeometry(object, canvas, fontRecord, glyphRecords);
    if (!geometry || !geometry.bounds || !geometry.glyphs.length) {
      issues.push(dcpDieIssue(
        'DIE_PATH_GENERATION_FAILED',
        object.id,
        'This text could not be converted into production outlines.',
        'No finite painted path geometry was produced.'
      ));
      return { object: null, issues: issues };
    }
    const box = dcpDieObjectBox(object, canvas);
    const pathData = geometry.glyphs.map((glyph) => glyph.pathData).join('');
    const contours = geometry.glyphs.flatMap((glyph) => glyph.contours);
    const productionObject = {
      id: object.id,
      type: 'text',
      order: order,
      sourceText: String(object.text || ''),
      nonSpaceCharacterCount: dieCuttingNonSpaceCharacterCount(object.text),
      font: {
        key: object.fontKey,
        displayName: fontRecord.catalog.label,
        postScriptName: fontRecord.catalog.postScriptName || '',
        productionFontReference: fontRecord.catalog.productionFontReference || '',
        sourceSha256: fontRecord.catalog.sourceSha256 || ''
      },
      vinylColor: {
        key: object.fontColorKey || 'white',
        name: dcpDieVinylColorDescriptor(object.fontColorKey || 'white').label
      },
      textShape: shape,
      arcAmount: shape === 'straight' ? 0 : dcpDieRound(Number(object.arcAmount || 0)),
      rotationDeg: dcpDieRound(Number(object.rotation || 0)),
      horizontalScale: dcpDieRound(dcpDieHorizontalScale(object)),
      physicalAnchorIn: dcpDiePoint(box.center.x, box.center.y),
      objectBoxIn: {
        width: dcpDieRound(box.width),
        height: dcpDieRound(box.height)
      },
      localUnrotatedPaintedBoundsIn: geometry.localBounds,
      transformedPaintedBoundsIn: geometry.bounds,
      baseline: geometry.baseline,
      pathData: pathData,
      glyphs: geometry.glyphs.map((glyph) => ({
        index: glyph.index,
        character: glyph.character,
        codePoint: glyph.codePoint,
        glyphId: glyph.glyphId,
        anchorIn: glyph.anchorIn,
        scaleInPerEm: glyph.scaleInPerEm,
        rotationDeg: glyph.rotationDeg,
        tangentDeg: glyph.tangentDeg,
        paintedBoundsIn: glyph.paintedBoundsIn,
        paintedHeightIn: glyph.paintedHeightIn,
        pathData: glyph.pathData
      })),
      productionEnvelopeIn: geometry.bounds,
      _contours: contours,
      _glyphContours: geometry.glyphs.map((glyph) => ({
        bounds: glyph.paintedBoundsIn,
        contours: glyph.contours
      }))
    };
    const meaningfulGlyphs = geometry.glyphs.filter((glyph) => /[\p{L}\p{N}]/u.test(glyph.character));
    const meaningfulPaintedBounds = dcpDieUnionBounds(
      meaningfulGlyphs.map((glyph) => glyph.paintedBoundsIn)
    );
    const practicalLetteringHeightIn = meaningfulPaintedBounds
      ? Number(meaningfulPaintedBounds.height) || 0
      : 0;
    let featureFailureAdded = false;
    if (!meaningfulGlyphs.length) {
      issues.push(dcpDieIssue(
        'DIE_MEANINGFUL_TEXT_REQUIRED',
        object.id,
        'Add at least one letter or number.',
        'Punctuation and spaces alone do not create producible lettering.'
      ));
    } else if (practicalLetteringHeightIn + 0.0005 < dcpDieMinimumPaintedCharacterHeightIn) {
      issues.push(dcpDieIssue(
        'DIE_MIN_CHARACTER_HEIGHT',
        object.id,
        'Lettering is below the minimum practical height.',
        'The complete meaningful painted text is ' + practicalLetteringHeightIn.toFixed(3)
          + ' in; minimum is ' + dcpDieMinimumPaintedCharacterHeightIn.toFixed(2) + ' in.'
      ));
    }
    geometry.glyphs.forEach((glyph) => {
      glyph.contours.forEach((contour) => {
        if (featureFailureAdded) return;
        const contourBounds = dcpDiePolygonBounds(contour);
        if (contourBounds && Math.min(contourBounds.width, contourBounds.height) + 0.0005 < dcpDieMinimumCuttableFeatureIn) {
          featureFailureAdded = true;
          issues.push(dcpDieIssue(
            'DIE_MIN_CLOSED_FEATURE',
            object.id,
            'This font contains details too small to cut reliably.',
            'Character "' + glyph.character + '" contains a closed contour measuring '
              + contourBounds.width.toFixed(3) + ' x ' + contourBounds.height.toFixed(3)
              + ' in; minimum measured feature is ' + dcpDieMinimumCuttableFeatureIn.toFixed(2) + ' in.'
          ));
        }
      });
    });
    return { object: productionObject, issues: issues };
  }

  function dcpDieLocalPaintedBounds(productionObject) {
    const anchor = productionObject && productionObject.physicalAnchorIn;
    const contours = productionObject && productionObject._contours;
    if (!anchor || !Array.isArray(contours) || !contours.length) {
      return productionObject && productionObject.localUnrotatedPaintedBoundsIn;
    }
    const inverseRotation = -Number(productionObject.rotationDeg || 0) * Math.PI / 180;
    const points = contours.flatMap((contour) => contour.map((point) => (
      dcpDieRotatePoint(point, anchor, inverseRotation)
    )));
    return dcpDiePolygonBounds(points) || productionObject.localUnrotatedPaintedBoundsIn;
  }

  function dcpDieProductionSignature(objects, canvas) {
    const normalized = normalizeDcpCanvasObjects(objects, 'die_cutting');
    return JSON.stringify({
      canvas: normalizeDcpPhysicalCanvas(canvas),
      vinylColorKeys: dcpDieUsedVinylColorKeys(normalized, getDcpProofState()),
      artwork: normalized.artwork ? {
        x: normalized.artwork.x,
        y: normalized.artwork.y,
        width: normalized.artwork.width,
        height: normalized.artwork.height,
        scale: normalized.artwork.scale,
        rotation: normalized.artwork.rotation
      } : null,
      objects: normalized.textObjects.map((object) => ({
        id: object.id,
        text: object.text,
        fontKey: object.fontKey,
        fontColorKey: object.fontColorKey,
        x: object.x,
        y: object.y,
        width: object.width,
        height: object.height,
        horizontalScale: object.horizontalScale,
        textShape: object.textShape,
        arcAmount: object.arcAmount,
        rotation: object.rotation
      }))
    });
  }

  function dcpRotatedRectangleBounds(x, y, width, height, rotation) {
    const centerX = Number(x || 0);
    const centerY = Number(y || 0);
    const halfWidth = Math.max(0, Number(width || 0)) / 2;
    const halfHeight = Math.max(0, Number(height || 0)) / 2;
    const radians = Number(rotation || 0) * Math.PI / 180;
    const cosine = Math.cos(radians);
    const sine = Math.sin(radians);
    const corners = [
      [-halfWidth, -halfHeight],
      [halfWidth, -halfHeight],
      [halfWidth, halfHeight],
      [-halfWidth, halfHeight]
    ].map((corner) => ({
      x: centerX + corner[0] * cosine - corner[1] * sine,
      y: centerY + corner[0] * sine + corner[1] * cosine
    }));
    const left = Math.min(...corners.map((point) => point.x));
    const top = Math.min(...corners.map((point) => point.y));
    const right = Math.max(...corners.map((point) => point.x));
    const bottom = Math.max(...corners.map((point) => point.y));
    return { left: left, top: top, right: right, bottom: bottom, width: right - left, height: bottom - top };
  }

  function dcpAuthoritativeCompositionContainment(canvas, objects, productionTextObjects) {
    const normalizedCanvas = {
      width: Math.max(0, Number(canvas && canvas.width || 0)),
      height: Math.max(0, Number(canvas && canvas.height || 0))
    };
    const items = [];
    const artwork = objects && objects.artwork;
    if (artwork) {
      const artworkWidth = Number(artwork.width || 0) / 100 * normalizedCanvas.width;
      const artworkHeight = Number(artwork.height || 0) / 100 * normalizedCanvas.height;
      items.push({
        type: 'artwork',
        id: 'artwork',
        label: 'Artwork',
        rotation: Number(artwork.rotation || 0),
        bounds: dcpRotatedRectangleBounds(
          Number(artwork.x || 0) / 100 * normalizedCanvas.width,
          Number(artwork.y || 0) / 100 * normalizedCanvas.height,
          artworkWidth,
          artworkHeight,
          Number(artwork.rotation || 0)
        )
      });
    }
    (productionTextObjects || []).forEach((production, index) => {
      if (!production || !production.transformedPaintedBoundsIn) return;
      items.push({
        type: 'text',
        id: production.id,
        label: 'Text ' + (index + 1),
        rotation: Number(production.rotationDeg || 0),
        bounds: production.transformedPaintedBoundsIn
      });
    });
    const failures = [];
    items.forEach((item) => {
      const bounds = item.bounds;
      if (!bounds || !Number.isFinite(bounds.left) || !Number.isFinite(bounds.top)
        || !Number.isFinite(bounds.right) || !Number.isFinite(bounds.bottom)
        || bounds.left < -0.0005 || bounds.top < -0.0005
        || bounds.right > normalizedCanvas.width + 0.0005
        || bounds.bottom > normalizedCanvas.height + 0.0005) {
        failures.push({
          item: item,
          message: item.label + ' is outside the ' + dcpDieRound(normalizedCanvas.width) + ' x ' + dcpDieRound(normalizedCanvas.height) + ' in installation workspace.'
        });
      }
    });
    const envelope = dcpDieUnionBounds(items.map((item) => item.bounds));
    return { valid: failures.length === 0, failures: failures, items: items, envelope: envelope };
  }

  function buildDcpDieProductionContract(objects, proof) {
    const canvas = dcpPhysicalCanvasForProof(proof);
    const normalized = normalizeDcpCanvasObjects(objects, 'die_cutting');
    const signature = dcpDieProductionSignature(normalized, canvas) + '|' + JSON.stringify(proof && proof.catalogArtwork ? {
      designId: proof.catalogArtwork.designId,
      catalogVersion: proof.catalogArtwork.catalogVersion,
      nominalSize: proof.catalogArtwork.nominalSize
    } : null);
    if (dcpDieProductionContractCache.signature === signature && dcpDieProductionContractCache.contract) {
      return dcpDieProductionContractCache.contract;
    }
    const failures = [];
    const warnings = [];
    const productionObjects = [];
    const catalogArtwork = proof && proof.catalogArtwork ? proof.catalogArtwork : null;
    const textObjectAllowance = dcpDieTextObjectAllowance(canvas.height);
    if (normalized.textObjects.length > textObjectAllowance) {
      const allowanceMessage = dcpDieTextObjectAllowanceMessage(canvas.height, normalized.textObjects.length);
      failures.push(dcpDieIssue('DIE_TEXT_OBJECT_LIMIT', null, allowanceMessage, allowanceMessage));
    }
    const stateValidation = dieCuttingStateValidation(normalized, proof || getDcpProofState());
    if (!stateValidation.valid) {
      const stateObjectIndex = Number.isInteger(stateValidation.objectIndex) ? stateValidation.objectIndex : -1;
      const stateObject = stateObjectIndex >= 0 ? normalized.textObjects[stateObjectIndex] : null;
      const stateMessage = stateObjectIndex >= 0
        ? 'Text ' + (stateObjectIndex + 1) + ': ' + stateValidation.message
        : stateValidation.message;
      failures.push(dcpDieIssue('DIE_STATE_INVALID', stateObject && stateObject.id, stateMessage, stateMessage));
    }
    if (!catalogArtwork && !normalized.textObjects.some((object) => isComplete(String(object.text || '').trim()))) {
      failures.push(dcpDieIssue('DIE_OBJECT_REQUIRED', null, 'Add at least one text object.', 'No valid Die text object exists.'));
    }
    normalized.textObjects.forEach((object, index) => {
      const result = dcpDieObjectProductionGeometry(object, canvas, index);
      result.issues.forEach((issue) => {
        const labeledIssue = issue.objectId
          ? { ...issue, objectIndex: index, objectLabel: 'Text ' + (index + 1), message: 'Text ' + (index + 1) + ': ' + issue.message }
          : issue;
        (issue.classification === 'warning' ? warnings : failures).push(labeledIssue);
      });
      if (result.object) productionObjects.push(result.object);
    });
    const compositionContainment = dcpAuthoritativeCompositionContainment(canvas, normalized, productionObjects);
    compositionContainment.failures.forEach((failure) => {
      failures.push(dcpDieIssue(
        'DIE_WORKSPACE_CONTAINMENT',
        failure.item.id,
        failure.message,
        failure.message
      ));
    });
    const productionTextObjects = productionObjects.filter((object) => object.type === 'text');
    for (let first = 0; first < productionTextObjects.length; first += 1) {
      for (let second = first + 1; second < productionTextObjects.length; second += 1) {
        const a = productionTextObjects[first];
        const b = productionTextObjects[second];
        const boundsOverlap = a.transformedPaintedBoundsIn.left < b.transformedPaintedBoundsIn.right
          && a.transformedPaintedBoundsIn.right > b.transformedPaintedBoundsIn.left
          && a.transformedPaintedBoundsIn.top < b.transformedPaintedBoundsIn.bottom
          && a.transformedPaintedBoundsIn.bottom > b.transformedPaintedBoundsIn.top;
        if (boundsOverlap && dcpDieGlyphContoursOverlap(a._glyphContours, b._glyphContours)) {
          failures.push(dcpDieIssue(
            'DIE_OBJECT_OVERLAP',
            a.id,
            'Two separate text objects overlap.',
            'Production paths for ' + a.id + ' and ' + b.id + ' intersect.'
          ));
        }
      }
    }
    const layerMap = new Map();
    productionObjects.forEach((object) => {
      const key = object.vinylColor.key;
      if (!layerMap.has(key)) {
        layerMap.set(key, {
          colorKey: key,
          colorName: object.vinylColor.name,
          objectIds: [],
          pathData: '',
          productionEnvelopeIn: null
        });
      }
      const layer = layerMap.get(key);
      layer.objectIds.push(object.id);
      if (object.pathData) layer.pathData += object.pathData;
      layer.productionEnvelopeIn = dcpDieUnionBounds([layer.productionEnvelopeIn, object.productionEnvelopeIn]);
    });
    const layers = Array.from(layerMap.values());
    const contract = {
      contractType: dcpDieProductionContractType,
      contractVersion: dcpDieProductionContractVersion,
      generator: {
        designerVersion: 'V4.5.3-development',
        outlineCatalogVersion: dcpDieOutlineCatalog.contract || '',
        deterministic: true
      },
      unit: 'in',
      precision: dcpDieProductionPrecision,
      physicalCanvas: {
        width: dcpDieRound(canvas.width),
        height: dcpDieRound(canvas.height)
      },
      vinylColors: dcpDieUsedVinylColorKeys(normalized, proof || getDcpProofState()).map((colorKey) => ({
        key: colorKey,
        name: dcpDieVinylColorDescriptor(colorKey).label
      })),
      rules: {
        safetyMarginIn: dcpDieSafetyMarginIn,
        minimumPaintedCharacterHeightIn: dcpDieMinimumPaintedCharacterHeightIn,
        minimumCuttableFeatureIn: dcpDieMinimumCuttableFeatureIn,
        maximumNonSpaceCharactersPerObject: dieCuttingMaxNonSpaceCharacters,
        maximumTextObjectsForCanvasHeight: textObjectAllowance,
        measuredFeatureClasses: ['closed contour width', 'closed contour height'],
        unmeasuredFeatureClasses: ['stroke necks', 'bridges', 'open gaps']
      },
      proofPreview: {
        authoritative: false,
        maxWidthPx: dcpDieProofLimits.maxWidth,
        maxHeightPx: dcpDieProofLimits.maxHeight,
        maxPixels: dcpDieProofLimits.maxPixels,
        rasterSize: dcpDieProofCanvasSize(canvas)
      },
      eligibility: {
        status: failures.length ? 'not_ready' : 'ready',
        failures: failures,
        warnings: warnings
      },
      objects: productionObjects.map((object) => {
        const localPaintedBounds = dcpDieLocalPaintedBounds(object);
        const output = { ...object };
        delete output._contours;
        delete output._glyphContours;
        Object.defineProperty(output, '_selectionPaintedBoundsIn', {
          value: localPaintedBounds,
          enumerable: false
        });
        return output;
      }),
      layers: layers,
      combinedDesignEnvelopeIn: compositionContainment.envelope,
      compositionContainment: compositionContainment
    };
    dcpDieProductionContractCache = { signature: signature, contract: contract };
    return contract;
  }

  function dcpDcArtBounds(x, y, width, height) {
    return {
      left: x - width / 2,
      top: y - height / 2,
      right: x + width / 2,
      bottom: y + height / 2,
      width: width,
      height: height
    };
  }

  function dcpDcArtValueInches(value, dimension) {
    return dcpDieRound(Number(value || 0) / 100 * Number(dimension || 0));
  }

  function dcpDcArtPriceTier(envelope) {
    const controlling = Math.max(Number(envelope && envelope.width || 0), Number(envelope && envelope.height || 0));
    return dcpDcArtSupportedSizes.find((size) => controlling <= size + 0.01) || null;
  }

  function buildDcpDcArtProductionContract(proof, objects, dieContract) {
    const catalogArtwork = proof && proof.catalogArtwork;
    const activeRecord = activeDcpCatalogArtwork && activeDcpCatalogArtwork.record;
    if (!catalogArtwork || !activeRecord || catalogArtwork.designId !== activeRecord.designId
      || catalogArtwork.catalogVersion !== dcpDcArtCatalogVersion) {
      throw new Error('Choose an approved DC Art Library design before ordering.');
    }
    const artSizeInches = Number(catalogArtwork.nominalSize);
    if (!dcpDcArtSupportedSizes.includes(artSizeInches) || artSizeInches !== Number(activeDcpCatalogArtwork.nominalSize)) {
      throw new Error('The selected DC artwork size is not certified. Choose 6, 8, 10, or 12 inches.');
    }
    const expectedDimensions = activeRecord.exactDimensions[String(artSizeInches)];
    const canvas = dcpPhysicalCanvasForProof(proof);
    const artwork = objects && objects.artwork;
    if (!artwork || !Number.isFinite(Number(artwork.rotation || 0))) throw new Error('DC Art Library artwork transform is invalid.');
    const art = {
      x: dcpDcArtValueInches(artwork.x, canvas.width),
      y: dcpDcArtValueInches(artwork.y, canvas.height),
      width: dcpDcArtValueInches(artwork.width, canvas.width),
      height: dcpDcArtValueInches(artwork.height, canvas.height),
      rotation: dcpDieRound(Number(artwork.rotation || 0))
    };
    if (!expectedDimensions || Math.abs(art.width - Number(expectedDimensions.width)) > 0.011
      || Math.abs(art.height - Number(expectedDimensions.height)) > 0.011) {
      throw new Error('DC Art Library artwork dimensions no longer match the selected certified size.');
    }
    const colorKey = authorizedDcpDieVinylColorKey(proof.dieVinylColorKey);
    const color = colorKey ? dcpDieVinylColorDescriptor(colorKey).label : '';
    if (!color || !activeRecord.approvedVinylColors.includes(color)) {
      throw new Error('The selected vinyl color is not approved for this DC Art Library design.');
    }
    const textObjects = Array.isArray(objects && objects.textObjects) ? objects.textObjects : [];
    if (!textObjects.length) throw new Error('Add at least one valid text object to order DC Library artwork plus text.');
    if (textObjects.length > 3) throw new Error('DC Library artwork supports a maximum of three text objects.');
    const productionById = new Map((dieContract && dieContract.objects || []).map((item) => [item.id, item]));
    const serializedText = textObjects.map((object) => {
      const production = productionById.get(object.id);
      const bounds = production && production.transformedPaintedBoundsIn;
      const nonSpaceCount = dieCuttingNonSpaceCharacterCount(object.text);
      const shape = normalizeDcpTextShape(object.textShape);
      if (!production || !bounds || !isComplete(String(object.text || '').trim()) || nonSpaceCount < 1 || nonSpaceCount > dieCuttingMaxNonSpaceCharacters) {
        throw new Error('Each DC Library text object must contain 1-30 valid non-space characters and certified production geometry.');
      }
      if (!['straight', 'arch_up', 'arch_down'].includes(shape)) {
        throw new Error('Each DC Library text object must use Straight, Arch Up, or Arch Down.');
      }
      if (!Number.isFinite(Number(object.rotation || 0))) throw new Error('DC Library text rotation is invalid.');
      if (authorizedDcpDieVinylColorKey(object.fontColorKey) !== colorKey) {
        throw new Error('DC Library artwork and text must use the same approved vinyl color.');
      }
      const width = dcpDieRound(Number(bounds.width || 0));
      const height = dcpDieRound(Number(bounds.height || 0));
      if (height + 0.0005 < dcpDieMinimumPaintedCharacterHeightIn) {
        throw new Error('DC Library text is below the minimum meaningful painted height of ' + dcpDieMinimumPaintedCharacterHeightIn.toFixed(2) + ' inches.');
      }
      return {
        instanceId: object.id,
        text: String(object.text),
        fontKey: object.fontKey,
        shape: shape,
        x: dcpDieRound((Number(bounds.left || 0) + Number(bounds.right || 0)) / 2),
        y: dcpDieRound((Number(bounds.top || 0) + Number(bounds.bottom || 0)) / 2),
        width: width,
        height: height,
        rotation: dcpDieRound(Number(object.rotation || 0)),
        color: color
      };
    });
    const containment = dieContract && dieContract.compositionContainment;
    if (!containment || !containment.valid || !containment.envelope) {
      throw new Error(containment && containment.failures && containment.failures[0]
        ? containment.failures[0].message
        : 'The complete composition could not be verified inside the installation workspace.');
    }
    const envelope = {
      width: dcpDieRound(Number(containment.envelope.width || 0)),
      height: dcpDieRound(Number(containment.envelope.height || 0))
    };
    const allowance = dcpDieTextObjectAllowance(envelope.height);
    if (serializedText.length > allowance) throw new Error(dcpDieTextObjectAllowanceMessage(envelope.height, serializedText.length));
    if (!dcpDcArtPriceTier(envelope)) {
      throw new Error('This DC Library composition exceeds the certified 12-inch finished-size ceiling.');
    }
    // DC Library pricing is certified to the explicitly selected approved art
    // size; the envelope remains a production-limit check, not a price tier.
    const priceTierInches = artSizeInches;
    return {
      contractVersion: dcpDcArtProductionContractVersion,
      catalogVersion: dcpDcArtCatalogVersion,
      designId: activeRecord.designId,
      title: activeRecord.title,
      artSizeInches: artSizeInches,
      priceTierInches: priceTierInches,
      vinylColor: color,
      art: art,
      textObjects: serializedText,
      finishedEnvelopeInches: envelope
    };
  }

  function dcpDcArtProductionReferenceId(contract, transactionToken) {
    return 'SRD-DCAPT-' + contract.designId + '-' + contract.priceTierInches + '-' + String(transactionToken || '').replace(/[^A-Za-z0-9_-]/g, '');
  }

  function serializeDcpDieProductionContract(contract) {
    return JSON.stringify(contract || buildDcpDieProductionContract(getDcpProofState().objects, getDcpProofState()));
  }

  function applyDcpDiePaintedSelectionBounds(element, productionObject, stateObject, canvas, artboardRect) {
    const bounds = productionObject && productionObject._selectionPaintedBoundsIn;
    const anchor = productionObject && productionObject.physicalAnchorIn;
    if (!element || !bounds || !anchor || !stateObject || !canvas || !artboardRect
        || !artboardRect.width || !artboardRect.height || !Number(canvas.width) || !Number(canvas.height)) return;
    const pixelsPerInchX = artboardRect.width / Number(canvas.width);
    const pixelsPerInchY = artboardRect.height / Number(canvas.height);
    const wrapperWidth = Number(stateObject.width) / 100 * artboardRect.width;
    const wrapperHeight = Number(stateObject.height) / 100 * artboardRect.height;
    const paintedWidth = Number(bounds.width) * pixelsPerInchX;
    const paintedHeight = Number(bounds.height) * pixelsPerInchY;
    element.dataset.srdDcpDiePaintedWidth = paintedWidth.toFixed(3);
    element.dataset.srdDcpDiePaintedHeight = paintedHeight.toFixed(3);
    applyDcpTextPaintBounds(element, {
      left: wrapperWidth / 2 + (Number(bounds.left) - Number(anchor.x)) * pixelsPerInchX - dcpDieSelectionPaddingPx,
      top: wrapperHeight / 2 + (Number(bounds.top) - Number(anchor.y)) * pixelsPerInchY - dcpDieSelectionPaddingPx,
      width: paintedWidth + dcpDieSelectionPaddingPx * 2,
      height: paintedHeight + dcpDieSelectionPaddingPx * 2
    });
  }

  function syncDcpDiePaintedGeometry(objects) {
    if (!targets.dcpTextLayer) return;
    const existingOverlay = targets.dcpTextLayer.querySelector('[data-srd-dcp-die-painted-geometry]');
    const textElements = Array.from(targets.dcpTextLayer.querySelectorAll('[data-srd-dcp-text-id]'));
    if (!isDieCuttingMode()) {
      if (existingOverlay) existingOverlay.remove();
      textElements.forEach((element) => {
        const layer = element.querySelector('[data-srd-dcp-straight-text-layer], [data-srd-dcp-arched-glyph-layer]');
        if (layer) layer.style.removeProperty('opacity');
        delete element.dataset.srdDcpDiePaintedWidth;
        delete element.dataset.srdDcpDiePaintedHeight;
      });
      return;
    }

    const proof = getDcpProofState();
    const contract = buildDcpDieProductionContract(objects, proof);
    const canvas = contract && contract.physicalCanvas;
    if (!canvas || !Number(canvas.width) || !Number(canvas.height)) return;

    let overlay = existingOverlay;
    if (!overlay) {
      overlay = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      overlay.dataset.srdDcpDiePaintedGeometry = '';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('preserveAspectRatio', 'none');
      overlay.style.position = 'absolute';
      overlay.style.inset = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.overflow = 'visible';
      overlay.style.pointerEvents = 'none';
      targets.dcpTextLayer.insertBefore(overlay, targets.dcpTextLayer.firstChild);
    }
    overlay.setAttribute('viewBox', '0 0 ' + Number(canvas.width) + ' ' + Number(canvas.height));
    overlay.replaceChildren();

    const productionById = new Map((contract.objects || []).map((object) => [object.id, object]));
    const stateById = new Map(normalizeDcpCanvasObjects(objects, 'die_cutting').textObjects.map((object) => [object.id, object]));
    const artboardRect = targets.proofArtboard && targets.proofArtboard.getBoundingClientRect();
    textElements.forEach((element) => {
      const productionObject = productionById.get(element.dataset.srdDcpTextId);
      const layer = element.querySelector('[data-srd-dcp-straight-text-layer], [data-srd-dcp-arched-glyph-layer]');
      if (layer) layer.style.opacity = productionObject && productionObject.pathData ? '0' : '';
      if (productionObject && artboardRect) {
        applyDcpDiePaintedSelectionBounds(
          element,
          productionObject,
          stateById.get(element.dataset.srdDcpTextId),
          canvas,
          artboardRect
        );
      }
    });
    (contract.objects || []).forEach((object) => {
      if (!object.pathData) return;
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.dataset.srdDcpDiePaintedObjectId = object.id;
      path.setAttribute('d', object.pathData);
      path.setAttribute('fill', dcpTextColorValue(object.vinylColor && object.vinylColor.key, 'die_cutting'));
      path.setAttribute('fill-rule', 'nonzero');
      overlay.appendChild(path);
    });
  }

  function restoreDcpDieProductionContract(serialized) {
    const contract = typeof serialized === 'string' ? JSON.parse(serialized) : serialized;
    if (!contract || contract.contractType !== dcpDieProductionContractType || contract.contractVersion !== dcpDieProductionContractVersion) {
      throw new Error('Unsupported Die production contract.');
    }
    const proof = getDcpProofState();
    proof.physicalCanvas = normalizeDcpPhysicalCanvas(contract.physicalCanvas);
    const contractTextObjects = contract.objects.filter((object) => object.type === 'text');
    const contractColor = contractTextObjects.find((object) => object.vinylColor && authorizedDcpDieVinylColorKey(object.vinylColor.key));
    proof.dieVinylColorKey = contract.designVinylColor && authorizedDcpDieVinylColorKey(contract.designVinylColor.key)
      ? contract.designVinylColor.key
      : (contractColor ? contractColor.vinylColor.key : (proof.dieVinylColorKey || 'white'));
    proof.objects = normalizeDcpCanvasObjects({
      ...proof.objects,
      textObjects: contractTextObjects.map((object) => ({
        id: object.id,
        text: object.sourceText,
        font: object.font.displayName,
        fontKey: object.font.key,
        fontColor: object.vinylColor.name,
        fontColorKey: object.vinylColor.key,
        x: object.physicalAnchorIn.x / contract.physicalCanvas.width * 100,
        y: object.physicalAnchorIn.y / contract.physicalCanvas.height * 100,
        width: object.objectBoxIn.width / contract.physicalCanvas.width * 100,
        height: object.objectBoxIn.height / contract.physicalCanvas.height * 100,
        horizontalScale: object.horizontalScale,
        textShape: object.textShape,
        arcAmount: object.arcAmount,
        rotation: object.rotationDeg
      })),
      shape: null
    }, 'die_cutting');
    dcpDieProductionContractCache = { signature: '', contract: null };
    update();
    return buildDcpDieProductionContract(proof.objects, proof);
  }

  function trustedDcArtRecordForRestore(designId) {
    const catalogElement = document.querySelector('[data-srd-dc-art-catalog]');
    if (!catalogElement) throw new Error('The trusted DC Art Library is unavailable.');
    const catalog = JSON.parse(catalogElement.textContent || '{}');
    if (catalog.schemaVersion !== 'srd-dc-art-catalog-schema-v1'
      || catalog.catalogVersion !== dcpDcArtCatalogVersion
      || !Array.isArray(catalog.records)
      || Number(catalog.recordCount) !== catalog.records.length) {
      throw new Error('The trusted DC Art Library could not be verified.');
    }
    const record = catalog.records.find((candidate) => String(candidate && candidate.designId || '') === String(designId || ''));
    if (!record) throw new Error('The saved DC artwork is no longer available.');
    return normalizedDcArtRecord({ ...record, catalogVersion: catalog.catalogVersion });
  }

  function failClosedDcArtRestore(detail) {
    const safeMessage = 'This saved artwork design could not be restored. Your original cart line has not been changed.';
    if (dcpCartEditSession.active) {
      dcpCartEditSession.status = 'failed';
      dcpCartEditSession.failure = safeMessage;
    }
    setDieCuttingDevelopmentMessage(detail || safeMessage);
    setCartMessage(safeMessage, 'error');
  }

  function dcpDieProofCanvasSize(canvas) {
    const ratio = canvas.width / canvas.height;
    let width = dcpDieProofLimits.maxWidth;
    let height = width / ratio;
    if (height > dcpDieProofLimits.maxHeight) {
      height = dcpDieProofLimits.maxHeight;
      width = height * ratio;
    }
    const pixelScale = Math.min(1, Math.sqrt(dcpDieProofLimits.maxPixels / Math.max(1, width * height)));
    return {
      width: Math.max(1, Math.round(width * pixelScale)),
      height: Math.max(1, Math.round(height * pixelScale))
    };
  }

  function renderDcpDieProductionProof(contract) {
    const source = contract || buildDcpDieProductionContract(getDcpProofState().objects, getDcpProofState());
    const size = dcpDieProofCanvasSize(source.physicalCanvas);
    const canvas = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;
    const context = canvas.getContext('2d');
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, size.width, size.height);
    context.save();
    context.scale(size.width / source.physicalCanvas.width, size.height / source.physicalCanvas.height);
    source.layers.forEach((layer) => {
      context.fillStyle = dcpTextColorValue(layer.colorKey, 'die_cutting');
      if (layer.pathData) context.fill(new Path2D(layer.pathData), 'nonzero');
    });
    context.restore();
    return {
      width: size.width,
      height: size.height,
      dataUrl: canvas.toDataURL('image/png'),
      contract: source
    };
  }

  function syncDcpDieProductionReadiness() {
    if (!targets.dieCuttingReadiness) return;
    if (!isDieCuttingMode()) {
      targets.dieCuttingReadiness.hidden = true;
      return;
    }
    const contract = buildDcpDieProductionContract(getDcpProofState().objects, getDcpProofState());
    const firstFailure = contract.eligibility.failures[0];
    targets.dieCuttingReadiness.hidden = false;
    targets.dieCuttingReadiness.dataset.srdStatus = contract.eligibility.status;
    targets.dieCuttingReadiness.textContent = firstFailure
      ? 'Production check: Not ready - ' + firstFailure.message
      : 'Production check: Ready';
    if (targets.dieCuttingContractInspection) {
      targets.dieCuttingContractInspection.textContent = serializeDcpDieProductionContract(contract);
    }
  }

  function scheduleDcpDieProductionReadiness() {
    if (dcpDieProductionReadinessTimer) window.clearTimeout(dcpDieProductionReadinessTimer);
    dcpDieProductionReadinessTimer = window.setTimeout(() => {
      dcpDieProductionReadinessTimer = null;
      syncDcpDieProductionReadiness();
    }, 90);
  }

  function dieCuttingProductionMeasurementSnapshot(textObject, element) {
    const object = normalizeDcpTextObject(textObject || {}, 0, 'die_cutting');
    const canvas = dcpPhysicalCanvasForProof();
    const snapshot = {
      placementWidthIn: canvas.width * object.width / 100,
      placementHeightIn: canvas.height * object.height / 100,
      nonSpaceCharacterCount: dieCuttingNonSpaceCharacterCount(object.text),
      fontKey: object.fontKey || '',
      textShape: normalizeDcpTextShape(object.textShape),
      rotation: Number(object.rotation || 0),
      horizontalScale: dcpDieHorizontalScale(object),
      renderedFontSizePx: null,
      renderedTextLengthPx: null,
      renderedPathLengthPx: null,
      renderedBoundsPx: null
    };
    if (!element) return snapshot;
    const dieLayout = element.__srdDcpTextLayout;
    if (dieLayout) {
      snapshot.renderedFontSizePx = Number(dieLayout.fontSize) || null;
      snapshot.renderedTextLengthPx = Number(dieLayout.textLength)
        || (dieLayout.lines || []).reduce((maximum, line) => Math.max(maximum, line.right - line.left), 0)
        || null;
      snapshot.renderedPathLengthPx = Number(dieLayout.pathLength) || null;
      if (dieLayout.paintBounds) {
        snapshot.renderedBoundsPx = {
          x: dieLayout.paintBounds.left,
          y: dieLayout.paintBounds.top,
          width: dieLayout.paintBounds.width,
          height: dieLayout.paintBounds.height
        };
      }
      return snapshot;
    }
    const text = element.querySelector('[data-srd-dcp-arched-text-value], [data-srd-dcp-text-value]');
    const path = element.querySelector('[data-srd-dcp-arched-text-path]');
    const fontSize = Number.parseFloat(getComputedStyle(text || element).fontSize);
    if (Number.isFinite(fontSize)) snapshot.renderedFontSizePx = fontSize;
    try {
      if (text && typeof text.getComputedTextLength === 'function') {
        snapshot.renderedTextLengthPx = text.getComputedTextLength();
      } else if (text) {
        snapshot.renderedTextLengthPx = text.getBoundingClientRect().width;
      }
      if (path && typeof path.getTotalLength === 'function') {
        snapshot.renderedPathLengthPx = path.getTotalLength();
      }
      if (text && typeof text.getBBox === 'function') {
        const bounds = text.getBBox();
        snapshot.renderedBoundsPx = {
          x: bounds.x,
          y: bounds.y,
          width: bounds.width,
          height: bounds.height
        };
      }
    } catch (_error) {
      // Measurements remain nullable until the browser completes font and SVG layout.
    }
    return snapshot;
  }

  function validateDieCuttingProductionMeasurements(textObject, element) {
    const contract = buildDcpDieProductionContract(getDcpProofState().objects, getDcpProofState());
    const objectId = textObject && textObject.id;
    const issues = contract.eligibility.failures
      .concat(contract.eligibility.warnings)
      .filter((issue) => !objectId || !issue.objectId || issue.objectId === objectId);
    return {
      valid: !issues.some((issue) => issue.classification === 'blocking'),
      thresholdsApplied: true,
      issues: issues,
      measurements: dieCuttingProductionMeasurementSnapshot(textObject, element)
    };
  }

  function dieCuttingTextCharacterCounts(objects) {
    const source = objects && typeof objects === 'object' ? objects : {};
    return Array.isArray(source.textObjects)
      ? source.textObjects.filter((item) => item && isComplete(item.text))
        .map((item) => dieCuttingNonSpaceCharacterCount(item.text))
      : [];
  }

  function dieCuttingLineCount(objects) {
    const source = objects && typeof objects === 'object' ? objects : {};
    return Array.isArray(source.textObjects)
      ? source.textObjects.filter((item) => item && isComplete(item.text)).length
      : 0;
  }

  function ensureDcpFontReady(fontKey) {
    const entry = fontCatalogById[fontKey];
    if (!entry || entry.browserFormat !== 'woff2' || !document.fonts || typeof document.fonts.load !== 'function') {
      return Promise.resolve(true);
    }
    if (loadedDcpFontIds.has(fontKey)) return Promise.resolve(true);
    if (dcpFontLoadPromises.has(fontKey)) return dcpFontLoadPromises.get(fontKey);
    failedDcpFontIds.delete(fontKey);
    const loadPromise = document.fonts.load('16px "' + entry.cssFamily + '"', 'SRD')
      .then((faces) => {
        if (!faces || !faces.length) throw new Error('Font asset did not load.');
        loadedDcpFontIds.add(fontKey);
        failedDcpFontIds.delete(fontKey);
        clearDcpGlyphMeasurementCache();
        return true;
      })
      .catch((error) => {
        failedDcpFontIds.add(fontKey);
        throw error;
      })
      .finally(() => dcpFontLoadPromises.delete(fontKey));
    dcpFontLoadPromises.set(fontKey, loadPromise);
    return loadPromise;
  }

  function selectedBlankCanvasStartMode() {
    return controls.blankCanvasStart && controls.blankCanvasStart.value
      ? controls.blankCanvasStart.value
      : 'start_blank';
  }

  function selectedNitrousBottleProfile() {
    const key = controls.nitrousBottleWeight && controls.nitrousBottleWeight.value
      ? controls.nitrousBottleWeight.value
      : '10 LB Bottle';
    const firstConfiguredProfile = nitrousBottleProfiles[Object.keys(nitrousBottleProfiles)[0]];
    return nitrousBottleProfiles[key] || nitrousBottleProfiles['10 LB Bottle'] || firstConfiguredProfile || emptyNitrousBottleProfile;
  }

  function selectedNitrousBottleWeight() {
    return controls.nitrousBottleWeight && controls.nitrousBottleWeight.value
      ? controls.nitrousBottleWeight.value
      : '10 LB Bottle';
  }

  function mobilePreviewLayoutActive() {
    return Boolean(window.matchMedia && window.matchMedia('(max-width: 820px)').matches);
  }

  function activeNitrousWeightCalibration(profile) {
    const desktopCalibration = profile.weightCalibration || {};
    if (mobilePreviewLayoutActive() && profile.mobileWeightCalibration) {
      return Object.assign({}, desktopCalibration, profile.mobileWeightCalibration);
    }
    return desktopCalibration;
  }

  function selectedNitrousHeaderChoice() {
    const key = controls.nitrousHeader && controls.nitrousHeader.value ? controls.nitrousHeader.value : 'nitrous_oxide_performance';
    return nitrousHeaderChoices.find((choice) => choice.key === key) || nitrousHeaderChoices[0];
  }

  function isNitrousCustomArtSelected() {
    return isNitrousMode(controls.template.value) && Boolean(selectedNitrousHeaderChoice().customUpload);
  }

  function hasUploadedNitrousCustomArt() {
    return Boolean(
      controls.nitrousUpload &&
      controls.nitrousUpload.files &&
      controls.nitrousUpload.files.length &&
      uploadedNitrousHeaderArtwork.name
    );
  }

  function hasSupportedNitrousCustomArtUpload() {
    return hasUploadedNitrousCustomArt() && uploadedNitrousHeaderArtwork.supported === true;
  }

  function selectedNitrousTemplateChoice() {
    const key = controls.nitrousTemplate && controls.nitrousTemplate.value ? controls.nitrousTemplate.value : '';
    return nitrousTemplateChoices.find((choice) => choice.key === key) || null;
  }

  function effectiveDesignerSize(template) {
    if (isNitrousMode(template)) return selectedNitrousBottleProfile().finishedSize;
    if (isBlankCanvasMode(template) && isDieCuttingMode()) {
      return dcpPhysicalCanvasLabel(dcpPhysicalCanvasForProof());
    }
    return controls.size.value;
  }

  function aspectForDesignerSize(size) {
    const fallback = {
      ratio: '1',
      number: 1
    };
    if (!size) return fallback;
    const match = String(size).match(/([0-9]+(?:\.[0-9]+)?)\s*x\s*([0-9]+(?:\.[0-9]+)?)/i);
    if (!match) return fallback;
    const width = Number(match[1]);
    const height = Number(match[2]);
    if (!Number.isFinite(width) || !Number.isFinite(height) || height <= 0) return fallback;
    return {
      ratio: width + ' / ' + height,
      number: width / height
    };
  }

  function dcpLandscapeSize(size) {
    const normalized = normalizeVariantOption(size);
    const sizeMap = {
      '2 x 3 in': '3 x 2 in',
      '3.5 x 5 in': '5 x 3.5 in',
      '5 x 7 in': '7 x 5 in',
      '10 x 7 in': '10 x 7 in',
      '11 x 8 in': '11 x 8 in',
      '11 x 17 in': '17 x 11 in',
      '12 x 18 in': '18 x 12 in'
    };
    return sizeMap[normalized] || normalized;
  }

  function dcpPhysicalSize(size) {
    const landscapeSize = dcpLandscapeSize(size);
    const match = String(landscapeSize || '').match(/([0-9]+(?:\.[0-9]+)?)\s*x\s*([0-9]+(?:\.[0-9]+)?)/i);
    if (!match) return null;
    const width = Number(match[1]);
    const height = Number(match[2]);
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
    return { key: landscapeSize, width: width, height: height };
  }

  function activeDcpPhysicalSize(size) {
    if (isDieCuttingMode()) {
      const canvas = dcpPhysicalCanvasForProof();
      return {
        key: dcpPhysicalCanvasLabel(canvas),
        width: canvas.width,
        height: canvas.height
      };
    }
    return dcpPhysicalSize(typeof size === 'undefined' ? (controls.size ? controls.size.value : '') : size);
  }

  function setDcpDimensionStatus(message, invalid) {
    if (!targets.dcpDimensionsStatus) return;
    targets.dcpDimensionsStatus.textContent = message || (activeDcpCatalogArtwork
      ? 'DC artwork uses its certified 6, 8, 10, or 12-inch size.'
      : 'Width 0.5-48 in. Height 0.5-8 in.');
    targets.dcpDimensionsStatus.dataset.srdInvalid = invalid ? 'true' : 'false';
  }

  function validateDcpDimensionInput(key, rawValue) {
    const text = String(rawValue || '').trim();
    const limits = key === 'height' && activeDcpCatalogArtwork
      ? { min: dcpPhysicalCanvasLimits.height.min, max: 12 }
      : dcpPhysicalCanvasLimits[key];
    if (!text || text === '.' || /^\d+\.$/.test(text)) {
      return { complete: false, valid: false, message: 'Enter a complete ' + key + ' in inches.' };
    }
    if (!/^(?:\d+|\d*\.\d{1,2})$/.test(text)) {
      return { complete: true, valid: false, message: 'Use no more than two decimal places.' };
    }
    const numeric = Number(text);
    if (!Number.isFinite(numeric) || numeric < limits.min || numeric > limits.max) {
      return {
        complete: true,
        valid: false,
        message: key === 'width'
          ? 'Width must be between 0.5 and 48 inches.'
          : ('Height must be between 0.5 and ' + limits.max + ' inches.')
      };
    }
    return { complete: true, valid: true, value: numeric, message: '' };
  }

  function readDcpDimensionControls() {
    const width = validateDcpDimensionInput('width', controls.dcpWidth ? controls.dcpWidth.value : '');
    const height = validateDcpDimensionInput('height', controls.dcpHeight ? controls.dcpHeight.value : '');
    if (!width.valid) return { valid: false, incomplete: !width.complete, message: width.message };
    if (!height.valid) return { valid: false, incomplete: !height.complete, message: height.message };
    return {
      valid: true,
      physicalCanvas: normalizeDcpPhysicalCanvas({ width: width.value, height: height.value })
    };
  }

  function syncDcpDimensionControls(force) {
    const canvas = dcpPhysicalCanvasForProof();
    const active = document.activeElement;
    if (controls.dcpWidth && (force || active !== controls.dcpWidth)) controls.dcpWidth.value = String(canvas.width);
    if (controls.dcpHeight && (force || active !== controls.dcpHeight)) controls.dcpHeight.value = String(canvas.height);
    if (!dcpDimensionEditSession) setDcpDimensionStatus('');
  }

  function setDcpPhysicalCanvas(nextCanvas) {
    const proof = getDcpProofState();
    const previousCanvas = normalizeDcpPhysicalCanvas(proof.physicalCanvas);
    proof.physicalCanvas = normalizeDcpPhysicalCanvas(nextCanvas);
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    if (previousCanvas.width !== proof.physicalCanvas.width || previousCanvas.height !== proof.physicalCanvas.height) {
      invalidateDcpDieTextDerivedState(null, false);
    }
    return proof.physicalCanvas;
  }

  function beginDcpDimensionEdit() {
    if (!isDieCuttingMode() || dcpDimensionEditSession) return;
    dcpDimensionEditSession = {
      before: beginDcpHistoryTransaction(),
      original: dcpPhysicalCanvasForProof(),
      dirty: false
    };
  }

  function applyDcpDimensionInputs(event) {
    if (event) event.stopPropagation();
    if (!isDieCuttingMode()) return false;
    beginDcpDimensionEdit();
    const result = readDcpDimensionControls();
    if (!result.valid) {
      setDcpDimensionStatus(result.message, !result.incomplete);
      return false;
    }
    if (dcpDimensionEditSession) {
      dcpDimensionEditSession.dirty =
        dcpDimensionEditSession.original.width !== result.physicalCanvas.width
        || dcpDimensionEditSession.original.height !== result.physicalCanvas.height;
    }
    setDcpDimensionStatus('');
    return true;
  }

  function finishDcpDimensionEdit(event) {
    if (event) event.stopPropagation();
    if (event && event.type === 'blur'
      && (event.relatedTarget === controls.dcpWidth || event.relatedTarget === controls.dcpHeight)) {
      return;
    }
    if (!dcpDimensionEditSession) {
      syncDcpDimensionControls(true);
      return;
    }
    const session = dcpDimensionEditSession;
    const result = readDcpDimensionControls();
    if (!result.valid) {
      setDcpPhysicalCanvas(session.original);
      dcpDimensionEditSession = null;
      syncDcpDimensionControls(true);
      setDcpDimensionStatus(result.message, true);
      return;
    }
    const dimensionsChanged =
      session.original.width !== result.physicalCanvas.width ||
      session.original.height !== result.physicalCanvas.height;
    dcpDimensionEditSession = null;
    setDcpPhysicalCanvas(result.physicalCanvas);
    if (dimensionsChanged) setDcpEditingZoom('fit', dcpFitEditingZoom, false);
    update();
    if (session.dirty) {
      commitDcpHistoryTransaction(session.before, 'Change finished size');
    }
    syncDcpDimensionControls(true);
  }

  function cancelDcpDimensionEdit(event) {
    if (!dcpDimensionEditSession) return;
    event.preventDefault();
    event.stopPropagation();
    const session = dcpDimensionEditSession;
    setDcpPhysicalCanvas(session.original);
    dcpDimensionEditSession = null;
    syncDcpDimensionControls(true);
    setDcpDimensionStatus('');
    event.currentTarget.blur();
  }

  function swapDcpDimensions(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!isDieCuttingMode()) return;
    const current = dcpPhysicalCanvasForProof();
    const width = validateDcpDimensionInput('width', String(current.height));
    const height = validateDcpDimensionInput('height', String(current.width));
    if (!width.valid || !height.valid) {
      setDcpDimensionStatus('These dimensions cannot be swapped because height cannot exceed 8 inches.', true);
      return;
    }
    const historyStart = beginDcpHistoryTransaction();
    setDcpPhysicalCanvas({ width: width.value, height: height.value });
    update();
    commitDcpHistoryTransaction(historyStart, 'Swap finished dimensions');
    syncDcpDimensionControls(true);
  }

  function dcpTrustedHeaderAspect(catalogItem) {
    const trusted = Number(catalogItem && catalogItem.authoritativeAspectRatio);
    if (Number.isFinite(trusted) && trusted > 0) return trusted;
    return Number(catalogItem && catalogItem.aspectRatio) || 1;
  }

  function dcpProportionalGeometryForCanvas(object, aspect, physicalSize) {
    if (!object || !physicalSize || !Number.isFinite(aspect) || aspect <= 0) return object;
    const x = clampDcpNumber(object.x, 0, 100, 50);
    const y = clampDcpNumber(object.y, 0, 100, 50);
    let width = clampDcpNumber(object.width, 0.01, 100, 40);
    let height = width * physicalSize.width / physicalSize.height / aspect;
    const availableWidth = Math.max(0.01, Math.min(x, 100 - x) * 2);
    const availableHeight = Math.max(0.01, Math.min(y, 100 - y) * 2);
    const fit = Math.min(1, availableWidth / width, availableHeight / height);
    width *= fit;
    height *= fit;
    return { ...object, x: x, y: y, width: width, height: height };
  }

  function reconcileDcpProportionalObjectsForSize(objects, physicalSize) {
    const normalized = normalizeDcpCanvasObjects(objects);
    if (normalized.header) {
      const headerCatalogItem = dcpHeaderCatalogByKey[normalized.header.libraryKey];
      if (headerCatalogItem) normalized.header = normalizeDcpHeaderObject(dcpProportionalGeometryForCanvas(normalized.header, dcpTrustedHeaderAspect(headerCatalogItem), physicalSize));
    }
    if (normalized.shape) {
      const shapeCatalogItem = dcpShapeCatalogByKey[normalized.shape.shapeKey];
      if (shapeCatalogItem && shapeCatalogItem.resizePolicy === 'proportional') {
        normalized.shape = normalizeDcpShapeObject(dcpProportionalGeometryForCanvas(normalized.shape, shapeCatalogItem.aspectRatio, physicalSize));
      }
    }
    normalized.symbolObjects = normalized.symbolObjects.map((symbol) => normalizeDcpSymbolObject(
      dcpProportionalGeometryForCanvas(symbol, symbol.aspectRatio, physicalSize)
    )).filter(Boolean);
    return normalized;
  }

  function invalidateAllDcpTextFits() {
    if (!targets.dcpTextLayer) return;
    Array.from(targets.dcpTextLayer.querySelectorAll('[data-srd-dcp-text-id]')).forEach((element) => {
      delete element.dataset.srdDcpFitSignature;
    });
  }

  function measureDcpWorkspace() {
    if (!targets.proofCanvas) return null;
    const style = getComputedStyle(targets.proofCanvas);
    const horizontalPadding = (Number.parseFloat(style.paddingLeft) || 0) + (Number.parseFloat(style.paddingRight) || 0);
    const verticalPadding = (Number.parseFloat(style.paddingTop) || 0) + (Number.parseFloat(style.paddingBottom) || 0);
    const rulerSize = isBlankCanvasMode(controls.template.value) ? dcpPrecisionRulerSize() : 0;
    const width = targets.proofCanvas.clientWidth - horizontalPadding - rulerSize;
    const height = targets.proofCanvas.clientHeight - verticalPadding - rulerSize;
    if (width <= 0 || height <= 0) return null;
    return { width: width, height: height };
  }

  function dcpZoomPercent(value) {
    return Math.max(1, Math.round(Number(value || 1) * 100));
  }

  function syncDcpZoomControls(show) {
    if (!targets.dcpZoomControls) return;
    const shouldShow = typeof show === 'boolean'
      ? show
      : isBlankCanvasMode(controls.template.value);
    targets.dcpZoomControls.hidden = !shouldShow;
    if (!shouldShow) return;
    const tolerance = 0.001;
    const atMinimum = dcpEditingZoom <= dcpEditingZoomSteps[0] + tolerance;
    const atMaximum = dcpEditingZoom >= dcpEditingZoomSteps[dcpEditingZoomSteps.length - 1] - tolerance;
    const atFit = dcpEditingZoomIntent === 'fit' && Math.abs(dcpEditingZoom - dcpFitEditingZoom) <= tolerance;
    const relative = dcpEditingZoomIntent === 'relative' && Math.abs(dcpEditingZoom - 1) <= tolerance;
    const status = relative
      ? 'Relative 100%'
      : (atFit
        ? 'Fit ' + dcpZoomPercent(dcpEditingZoom) + '%'
        : 'Editing Zoom ' + dcpZoomPercent(dcpEditingZoom) + '%');
    targets.dcpZoomControls.dataset.srdDcpZoomEnlarged = dcpEditingZoom > 1 + tolerance ? 'true' : 'false';
    targets.dcpZoomControls.dataset.srdDcpZoomMode = relative ? 'relative' : (atFit ? 'fit' : 'editing');
    if (targets.dcpZoomStatus) targets.dcpZoomStatus.textContent = dcpZoomPercent(dcpEditingZoom) + '%';
    if (targets.dcpZoomOut) targets.dcpZoomOut.disabled = atMinimum;
    if (targets.dcpZoomIn) targets.dcpZoomIn.disabled = atMaximum;
    if (targets.dcpZoomRelative) {
      targets.dcpZoomRelative.disabled = relative;
      targets.dcpZoomRelative.setAttribute('aria-pressed', relative ? 'true' : 'false');
    }
    if (targets.dcpZoomFit) {
      targets.dcpZoomFit.disabled = atFit;
      targets.dcpZoomFit.setAttribute('aria-pressed', atFit ? 'true' : 'false');
      targets.dcpZoomFit.title = 'Fit for Editing (' + dcpZoomPercent(dcpFitEditingZoom) + '%)';
    }
  }

  function setDcpEditingZoom(intent, requestedZoom, schedule) {
    if (intent === 'fit') {
      dcpEditingZoomIntent = 'fit';
      dcpRequestedEditingZoom = dcpFitEditingZoom;
    } else if (intent === 'relative') {
      dcpEditingZoomIntent = 'relative';
      dcpRequestedEditingZoom = 1;
    } else {
      dcpEditingZoomIntent = 'step';
      dcpRequestedEditingZoom = clampDcpNumber(requestedZoom, dcpEditingZoomSteps[0], dcpEditingZoomSteps[dcpEditingZoomSteps.length - 1], 1);
    }
    if (schedule !== false) scheduleDcpWorkspaceSync();
    syncDcpZoomControls();
  }

  function stepDcpEditingZoom(direction) {
    const tolerance = 0.001;
    if (direction > 0) {
      const next = dcpEditingZoomSteps.find((value) => value > dcpEditingZoom + tolerance);
      if (typeof next === 'number') setDcpEditingZoom('step', next);
      return;
    }
    const previous = dcpEditingZoomSteps.filter((value) => value < dcpEditingZoom - tolerance).pop();
    if (typeof previous === 'number') setDcpEditingZoom('step', previous);
  }

  function resetDcpEditingZoom(schedule) {
    setDcpEditingZoom('relative', 1, schedule);
  }

  function applyDcpPhysicalCanvasSize(size) {
    if (!targets.proofArtboard || !isBlankCanvasMode(controls.template.value)) return false;
    const physicalSize = activeDcpPhysicalSize(size);
    const workspace = measureDcpWorkspace();
    if (!physicalSize || !workspace) return false;
    const basePixelsPerInch = Math.min(workspace.width / 18, workspace.height / 12);
    const relativeWidth = Math.max(1, physicalSize.width * basePixelsPerInch);
    const relativeHeight = Math.max(1, physicalSize.height * basePixelsPerInch);
    dcpFitEditingZoom = Math.max(0.05, Math.min(6, workspace.width / relativeWidth, workspace.height / relativeHeight));
    const requestedZoom = dcpEditingZoomIntent === 'fit' ? dcpFitEditingZoom : dcpRequestedEditingZoom;
    dcpEditingZoom = dcpEditingZoomIntent === 'fit'
      ? dcpFitEditingZoom
      : clampDcpNumber(requestedZoom, dcpEditingZoomSteps[0], dcpEditingZoomSteps[dcpEditingZoomSteps.length - 1], 1);
    const width = relativeWidth * dcpEditingZoom;
    const height = relativeHeight * dcpEditingZoom;
    const changed = Math.abs(width - dcpWorkspaceDimensions.width) > 0.1 || Math.abs(height - dcpWorkspaceDimensions.height) > 0.1;
    targets.proofArtboard.style.setProperty('--srd-dcp-canvas-width', width.toFixed(2) + 'px');
    targets.proofArtboard.style.setProperty('--srd-dcp-canvas-height', height.toFixed(2) + 'px');
    targets.proofArtboard.dataset.srdDcpPhysicalSize = physicalSize.width + 'x' + physicalSize.height;
    targets.proofArtboard.dataset.srdDcpPixelsPerInch = basePixelsPerInch.toFixed(4);
    targets.proofArtboard.dataset.srdDcpEditingZoom = dcpEditingZoom.toFixed(4);
    syncDcpZoomControls();
    if (!changed) return false;
    dcpWorkspaceDimensions = { width: width, height: height };
    dcpWorkspaceRenderRevision += 1;
    invalidateAllDcpTextFits();
    return true;
  }

  function syncDcpWorkspaceAfterResize() {
    dcpWorkspaceFrame = 0;
    if (!isBlankCanvasMode(controls.template.value)) return;
    const size = effectiveDesignerSize(controls.template.value);
    const boundaryAttachments = captureDcpDieTextBoundaryAttachments();
    if (!applyDcpPhysicalCanvasSize(size)) return;
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    applyDcpShapeObjectStyle(objects);
    applyDcpArtworkObjectStyle(objects);
    applyDcpHeaderObjectStyle(objects);
    syncDcpTextObjectElements(objects, fontStackFor(controls.font ? controls.font.value : 'arial'), colorValueFor(selectedFontColor()));
    settleDcpDieTextPositionsAfterRefit(boundaryAttachments);
    applyDcpObjectSelectionState();
    syncDcpProofWatermarkLayout(true);
    syncDcpPrecisionTools();
  }

  function scheduleDcpWorkspaceSync() {
    if (dcpWorkspaceFrame) return;
    dcpWorkspaceFrame = window.requestAnimationFrame(syncDcpWorkspaceAfterResize);
  }

  function percent(value) {
    return (Number(value) * 100) + '%';
  }

  function setPercentVar(element, name, value) {
    const numericValue = Number(value);
    if (Number.isFinite(numericValue)) {
      element.style.setProperty(name, percent(numericValue));
    } else {
      element.style.removeProperty(name);
    }
  }

  function setRawVar(element, name, value, suffix) {
    if (value !== undefined && value !== null && value !== '') {
      element.style.setProperty(name, String(value) + (suffix || ''));
    } else {
      element.style.removeProperty(name);
    }
  }

  function setPixelVar(element, name, value) {
    const numericValue = Number(value);
    if (Number.isFinite(numericValue)) {
      element.style.setProperty(name, numericValue + 'px');
    } else {
      element.style.removeProperty(name);
    }
  }

  function renderedTemplateBox() {
    if (!targets.templateArtwork || !targets.proofArtboard) return null;
    const artboardRect = targets.proofArtboard.getBoundingClientRect();
    if (!artboardRect.width || !artboardRect.height) return null;

    const naturalWidth = targets.templateArtwork.naturalWidth;
    const naturalHeight = targets.templateArtwork.naturalHeight;
    if (!naturalWidth || !naturalHeight) {
      return { left: 0, top: 0, width: artboardRect.width, height: artboardRect.height };
    }

    const artboardRatio = artboardRect.width / artboardRect.height;
    const imageRatio = naturalWidth / naturalHeight;
    let width = artboardRect.width;
    let height = artboardRect.height;
    let left = 0;
    let top = 0;

    if (artboardRatio > imageRatio) {
      width = height * imageRatio;
      left = (artboardRect.width - width) / 2;
    } else if (artboardRatio < imageRatio) {
      height = width / imageRatio;
      top = (artboardRect.height - height) / 2;
    }

    return { left: left, top: top, width: width, height: height };
  }

  function applyPercentCalibration(element, prefix, calibration) {
    if (!element || !calibration) return;
    const box = renderedTemplateBox();
    if (box) {
      setPixelVar(element, '--' + prefix + '-left', box.left + (Number(calibration.x) * box.width));
      setPixelVar(element, '--' + prefix + '-top', box.top + (Number(calibration.y) * box.height));
      setPixelVar(element, '--' + prefix + '-width', Number(calibration.width) * box.width);
      setPixelVar(element, '--' + prefix + '-height', Number(calibration.height) * box.height);
    } else {
      setPercentVar(element, '--' + prefix + '-left', calibration.x);
      setPercentVar(element, '--' + prefix + '-top', calibration.y);
      setPercentVar(element, '--' + prefix + '-width', calibration.width);
      setPercentVar(element, '--' + prefix + '-height', calibration.height);
    }
    setRawVar(element, '--' + prefix + '-scale', calibration.scale);
    setRawVar(element, '--' + prefix + '-rotation', calibration.rotation, 'deg');
  }

  function applyWeightCalibration(element, calibration) {
    if (!element || !calibration) return;
    const box = renderedTemplateBox();
    if (box) {
      setPixelVar(element, '--nitrous-card-left', box.left + (Number(calibration.x) * box.width));
      setPixelVar(element, '--nitrous-card-top', box.top + (Number(calibration.y) * box.height));
      setPixelVar(element, '--nitrous-card-width', Number(calibration.width) * box.width);
    } else {
      setPercentVar(element, '--nitrous-card-left', calibration.x);
      setPercentVar(element, '--nitrous-card-top', calibration.y);
      setPercentVar(element, '--nitrous-card-width', calibration.width);
    }
    setRawVar(element, '--nitrous-card-line-spacing', calibration.lineSpacing, 'em');
    setRawVar(element, '--nitrous-card-font-size', calibration.fontSize);
    setRawVar(element, '--nitrous-card-align', calibration.alignment);
    setPercentVar(element, '--nitrous-card-value-offset-x', calibration.valueOffsetX);
  }

  function designerModeFromState(template) {
    if (selectorState.template_category === 'blank_canvas' || template === 'blank_canvas') return 'blank_canvas';
    if (selectorState.template_category === 'nitrous' || isNitrousTemplate(template)) return 'nitrous';
    if (selectorState.template_category === 'standard') return 'standard';
    return 'none';
  }

  function setDesignerMode(mode) {
    const nitrousCustomArt = mode === 'nitrous' && Boolean(selectedNitrousHeaderChoice().customUpload);
    const blankCanvasSubfamily = mode === 'blank_canvas' ? selectedBlankCanvasSubfamily() : '';
    const dieCuttingMode = mode === 'blank_canvas' && blankCanvasSubfamily === 'die_cutting';
    const blankCanvasUpload = mode === 'blank_canvas'
      && blankCanvasSubfamily !== 'die_cutting'
      && selectedBlankCanvasStartMode() === 'upload_artwork';
    const signature = mode + '|' + (nitrousCustomArt ? 'custom-art' : 'built-in') + '|' + (blankCanvasUpload ? 'upload-artwork' : 'start-blank') + '|' + blankCanvasSubfamily;
    const dieCuttingStatusVisible = mode === 'blank_canvas' && dieCuttingMode;
    root.setAttribute('data-srd-product-family', normalizeTopLevelProductFamily(selectorState.product_family_key) || 'none');
    if (targets.dieCuttingStatus) targets.dieCuttingStatus.hidden = !dieCuttingStatusVisible;
    if (targets.orderPanel) targets.orderPanel.hidden = false;
    if (renderedDesignerModeSignature === signature) {
      root.setAttribute('data-srd-designer-mode', mode);
      root.setAttribute('data-srd-dcp-workspace-mode', blankCanvasSubfamily || 'none');
      syncDcpSymbolToolbarEligibility();
      return;
    }
    renderedDesignerModeSignature = signature;
    const groups = {
      standard: [targets.standardTemplateField, targets.sizeField],
      nitrous: [targets.nitrousTemplateField, targets.nitrousHeaderField, targets.nitrousBottleField],
      blankCanvas: dieCuttingMode
        ? [targets.quantityField].filter(Boolean)
        : [
          targets.sizeField,
          controls.material ? controls.material.closest('.srd-designer-field') : null,
          controls.lamination ? controls.lamination.closest('.srd-designer-field') : null,
          targets.quantityField,
          targets.blankCanvasStartField
        ].filter(Boolean),
      standardShared: targets.standardSharedFields,
      nitrousShared: targets.nitrousSharedFields
    };
    const allModeFields = groups.standard
      .concat(groups.nitrous)
      .concat(groups.blankCanvas)
      .concat(targets.blankCanvasSharedFields)
      .concat(groups.standardShared)
      .concat(groups.nitrousShared)
      .concat([targets.nitrousUploadField, targets.blankCanvasUploadField, targets.sizeField, targets.dcpDimensionsField])
      .filter(Boolean);

    if (targets.controlBank) {
      allModeFields.forEach((field) => {
        field.hidden = true;
        targets.controlBank.appendChild(field);
      });
    }

    if (dieCuttingMode && targets.familyControls && targets.dcpDimensionsField) {
      targets.dcpDimensionsField.hidden = false;
      targets.familyControls.insertBefore(targets.dcpDimensionsField, targets.dieCuttingStatus || null);
    }

    function renderFields(fields) {
      if (!targets.modeControls) return;
      fields.filter(Boolean).forEach((field) => {
        field.hidden = false;
        targets.modeControls.appendChild(field);
      });
    }

    if (mode === 'standard') {
      renderFields(groups.standard.concat(groups.standardShared));
    } else if (mode === 'nitrous') {
      renderFields(groups.nitrous.concat(groups.nitrousShared).concat(nitrousCustomArt ? [targets.nitrousUploadField] : []));
    } else if (mode === 'blank_canvas') {
      renderFields(groups.blankCanvas.concat(blankCanvasUpload ? [targets.blankCanvasUploadField] : []));
    }
    if (targets.dcpToolbarField) {
      targets.dcpToolbarField.hidden = mode !== 'blank_canvas';
    }
    if (mode !== 'blank_canvas') {
      closeDcpHeaderLibrary();
      closeDcpShapeLibrary();
      closeDcpSymbolLibrary();
    }

    root.setAttribute('data-srd-designer-mode', mode);
    root.setAttribute('data-srd-dcp-workspace-mode', blankCanvasSubfamily || 'none');
    syncDcpSymbolToolbarEligibility();
  }

  function renderDcpSelectedObjectPanel(objects) {
    const blankCanvasMode = isBlankCanvasMode(controls.template.value);
    const normalized = normalizeDcpCanvasObjects(objects || getDcpProofState().objects);
    const proof = getDcpProofState();
    sanitizeDcpObjectSelection(normalized, proof);
    const selectionCount = blankCanvasMode ? selectedDcpObjects.length : 0;
    const multipleSelected = selectionCount > 1;
    const selectedText = blankCanvasMode && !multipleSelected ? selectedDcpTextObject(normalized) : null;
    const selectedType = blankCanvasMode && !multipleSelected ? dcpObjectType(selectedDcpObject) : '';
    const selectedSymbol = selectedType === 'symbol' ? selectedDcpSymbolObject(normalized) : null;
    const hasSelectedObject = selectedType === 'text' || selectedType === 'artwork' || selectedType === 'header' || selectedType === 'shape' || Boolean(selectedSymbol);
    const catalogArtworkSelected = selectedType === 'artwork' && Boolean(activeDcpCatalogArtwork);

    if (targets.controlsHeading) {
      targets.controlsHeading.textContent = blankCanvasMode && multipleSelected
        ? 'Selected Objects'
        : (blankCanvasMode && hasSelectedObject && !catalogArtworkSelected ? 'Selected Object' : 'Job Settings');
    }
    if (targets.dcpJobSettings) {
      targets.dcpJobSettings.hidden = blankCanvasMode && (hasSelectedObject || multipleSelected);
    }
    if (targets.dcpPropertyPanel) {
      targets.dcpPropertyPanel.hidden = !blankCanvasMode || (!hasSelectedObject && !multipleSelected);
    }
    if (targets.dcpPropertyEmpty) {
      targets.dcpPropertyEmpty.hidden = true;
    }
    if (targets.dcpPropertyMultiple) {
      targets.dcpPropertyMultiple.hidden = !blankCanvasMode || !multipleSelected;
    }
    if (targets.dcpPropertyText) {
      targets.dcpPropertyText.hidden = !blankCanvasMode || !selectedText;
    }
    if (targets.dcpPropertyArtwork) {
      targets.dcpPropertyArtwork.hidden = !blankCanvasMode || selectedType !== 'artwork';
    }
    if (targets.dcpPropertyHeader) {
      targets.dcpPropertyHeader.hidden = !blankCanvasMode || selectedType !== 'header';
    }
    if (targets.dcpPropertyShape) {
      targets.dcpPropertyShape.hidden = !blankCanvasMode || selectedType !== 'shape';
    }
    if (targets.dcpPropertySymbol) {
      targets.dcpPropertySymbol.hidden = !blankCanvasMode || !selectedSymbol;
    }

    if (blankCanvasMode && selectedSymbol) {
      const catalogItem = trustedDcpSymbolRecord(selectedSymbol.canonicalId);
      if (targets.dcpSymbolPropertyLabel) targets.dcpSymbolPropertyLabel.textContent = selectedSymbol.displayTitle;
      if (targets.dcpSymbolPropertyThumbnail && catalogItem) {
        targets.dcpSymbolPropertyThumbnail.src = catalogItem.thumbnailSrc;
        targets.dcpSymbolPropertyThumbnail.alt = selectedSymbol.displayTitle + ' symbol preview';
      }
      if (targets.dcpSymbolRotation) targets.dcpSymbolRotation.value = String(Math.round(selectedSymbol.rotation));
      if (targets.dcpSymbolRotationValue) targets.dcpSymbolRotationValue.textContent = Math.round(selectedSymbol.rotation) + '\u00b0';
    }

    if (blankCanvasMode && selectedType === 'header' && normalized.header) {
      const catalogItem = dcpHeaderCatalogByKey[normalized.header.libraryKey];
      if (targets.dcpHeaderPropertyLabel) targets.dcpHeaderPropertyLabel.textContent = normalized.header.label;
      if (targets.dcpHeaderPropertyThumbnail && catalogItem) {
        targets.dcpHeaderPropertyThumbnail.src = catalogItem.src;
        targets.dcpHeaderPropertyThumbnail.alt = normalized.header.label + ' header preview';
      }
    }

    if (blankCanvasMode && selectedType === 'shape' && normalized.shape) {
      const shape = normalized.shape;
      if (targets.dcpShapePropertyLabel) targets.dcpShapePropertyLabel.textContent = shape.label;
      targets.dcpShapeAppearance.forEach((button) => button.classList.toggle('is-active', button.dataset.srdDcpShapeAppearance === shape.appearanceMode));
      if (targets.dcpShapeFill) {
        targets.dcpShapeFill.value = shape.fillColorKey;
        targets.dcpShapeFill.disabled = shape.appearanceMode === 'outline';
      }
      if (targets.dcpShapeBorder) targets.dcpShapeBorder.value = shape.borderColorKey;
      if (targets.dcpShapeThickness) {
        targets.dcpShapeThickness.value = shape.borderThicknessKey;
        targets.dcpShapeThickness.disabled = shape.borderColorKey === 'none';
      }
      if (targets.dcpShapeRotation) targets.dcpShapeRotation.value = String(Math.round(shape.rotation || 0));
      if (targets.dcpShapeRotationValue) targets.dcpShapeRotationValue.textContent = Math.round(shape.rotation || 0) + '\u00b0';
    }

    if (blankCanvasMode && selectedType === 'artwork') {
      const catalogArtwork = Boolean(activeDcpCatalogArtwork);
      if (targets.dcpUploadArtworkControls) targets.dcpUploadArtworkControls.hidden = catalogArtwork;
      if (targets.dcpCatalogArtworkControls) targets.dcpCatalogArtworkControls.hidden = !catalogArtwork;
      if (catalogArtwork) {
        const state = dcArtState();
        const color = dcpDieVinylColorDescriptor(state ? state.vinylColorKey : proof.dieVinylColorKey);
        if (targets.dcpCatalogArtworkTitle) targets.dcpCatalogArtworkTitle.textContent = activeDcpCatalogArtwork.record.title;
        if (targets.dcpCatalogArtworkSize) targets.dcpCatalogArtworkSize.textContent = activeDcpCatalogArtwork.nominalSize + '-inch certified artwork size';
        if (targets.dcpCatalogArtworkColor) targets.dcpCatalogArtworkColor.textContent = color.label;
      }
      const originalFilename = proof.originalFilename || proof.filename || proof.name || '';
      const filenameExtension = originalFilename.indexOf('.') !== -1 ? originalFilename.split('.').pop().toLowerCase() : '';
      const fileType = proof.fileType || proof.type || filenameExtension;
      const dimensions = proof.dimensions || (proof.width && proof.height ? proof.width + ' x ' + proof.height + ' px' : '');
      const trustedCartArtwork = dcpProductionArtworkSource.status === 'trusted_cart_reference';
      const artworkReady = dcpProductionArtworkReady();
      const status = trustedCartArtwork
        ? 'Original production file retained from cart.'
        : (!artworkReady ? dcpArtworkReselectionGuidance : (proof.status || proof.message || ''));
      const replaceLabel = artworkReady ? 'Replace Artwork' : 'Reselect Production File';
      if (targets.dcpArtworkPropertyFilename) targets.dcpArtworkPropertyFilename.textContent = originalFilename || 'Not available';
      if (targets.dcpArtworkPropertyType) targets.dcpArtworkPropertyType.textContent = fileType || 'Not available';
      if (targets.dcpArtworkPropertyDimensions) targets.dcpArtworkPropertyDimensions.textContent = dimensions || 'Not available';
      if (targets.dcpArtworkPropertyStatus) targets.dcpArtworkPropertyStatus.textContent = status || 'Status unavailable';
      if (targets.dcpReplaceArtwork) {
        targets.dcpReplaceArtwork.textContent = replaceLabel;
        targets.dcpReplaceArtwork.setAttribute('aria-label', replaceLabel);
        targets.dcpReplaceArtwork.title = replaceLabel;
      }
      if (targets.dcpRemoveArtwork) targets.dcpRemoveArtwork.disabled = !originalFilename && !proof.previewUrl && !proof.url && !proof.noticeUrl;
    }

    if (selectedText) {
      syncDcpTextEditorFromSelection(normalized, false);
      const selectedShape = normalizeDcpTextShape(selectedText.textShape);
      if (targets.dcpPlacement) targets.dcpPlacement.value = selectedShape === 'arch_up' ? 'arch_up' : (selectedShape === 'arch_down' ? 'arch_down' : 'free');
      if (targets.dcpArcField) targets.dcpArcField.hidden = selectedShape === 'straight';
      if (targets.dcpArcAmount) targets.dcpArcAmount.disabled = selectedShape === 'straight';
      if (targets.dcpTextOutlineControls) targets.dcpTextOutlineControls.hidden = isDieCuttingMode();
    } else if (targets.dcpArcField) {
      targets.dcpArcField.hidden = true;
      if (targets.dcpArcAmount) targets.dcpArcAmount.disabled = true;
    }
    if (!selectedText && targets.dcpTextOutlineControls) targets.dcpTextOutlineControls.hidden = true;
    syncSelectedDcpDieVinylColorControl(normalized);
  }

  function setSelectedDcpTextOutlineEnabled(enabled) {
    if (isDieCuttingMode() || selectedDcpObjects.length !== 1 || dcpObjectType(selectedDcpObject) !== 'text') return false;
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const selectedText = selectedDcpTextObject(objects);
    if (!selectedText || selectedText.outlineEnabled === Boolean(enabled)) return false;
    selectedText.outlineEnabled = Boolean(enabled);
    targets.dcpTextOutlineToggles.forEach((button) => {
      const active = button.dataset.srdDcpTextOutline === (enabled ? 'on' : 'off');
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (controls.dcpTextOutlineColor) controls.dcpTextOutlineColor.disabled = !enabled;
    if (controls.dcpTextOutlineThickness) controls.dcpTextOutlineThickness.disabled = !enabled;
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    update();
    commitDcpHistoryTransaction(historyStart, enabled ? 'Enable text outline' : 'Disable text outline');
    return true;
  }

  function updateSelectedDcpShape(properties) {
    if (selectedDcpObject !== 'shape') return;
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    if (!objects.shape) return;
    const changes = properties || {};
    const next = { ...objects.shape, ...changes };
    const changesAppearance = Object.prototype.hasOwnProperty.call(changes, 'appearanceMode');
    const changesFill = Object.prototype.hasOwnProperty.call(changes, 'fillColorKey');
    const changesBorder = Object.prototype.hasOwnProperty.call(changes, 'borderColorKey');

    if (changesFill && next.fillColorKey !== 'transparent') next.solidFillColorKey = next.fillColorKey;

    if (changesAppearance && next.appearanceMode === 'solid') {
      next.fillColorKey = next.solidFillColorKey || 'black';
    } else if (next.appearanceMode === 'outline' || (changesFill && next.fillColorKey === 'transparent')) {
      next.appearanceMode = 'outline';
      next.fillColorKey = 'transparent';
      if (next.borderColorKey === 'none') next.borderColorKey = 'black';
    }

    if (changesBorder && next.borderColorKey === 'none' && next.appearanceMode === 'outline') {
      next.borderColorKey = objects.shape.borderColorKey !== 'none' ? objects.shape.borderColorKey : 'black';
    }

    if (next.fillColorKey === 'transparent' && next.borderColorKey === 'none') next.borderColorKey = 'black';
    objects.shape = normalizeDcpShapeObject(next);
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    update();
    commitDcpHistoryTransaction(historyStart, 'Change shape style', {
      coalescingKey: 'shape-style',
      coalescingWindow: 300
    });
  }

  function bindDcpShapeStyleControl(control, propertyName) {
    if (!control) return;
    const commit = (event) => {
      event.stopPropagation();
      const shape = normalizeDcpCanvasObjects(getDcpProofState().objects).shape;
      if (!shape || shape[propertyName] === control.value) return;
      updateSelectedDcpShape({ [propertyName]: control.value });
    };
    control.addEventListener('input', commit);
    control.addEventListener('change', commit);
  }

  const dcpObjectToolbarSizeMessage = 'Please select a size to continue.';

  function hasDcpObjectToolbarCanvas() {
    return isBlankCanvasMode(controls.template ? controls.template.value : '')
      && Boolean(activeDcpPhysicalSize());
  }

  function closeDcpObjectToolbarFlyouts() {
    const symbolWasActive = Boolean(
      (targets.dcpSymbolFlyout && !targets.dcpSymbolFlyout.hidden)
      || (targets.dcpSymbolActivationStatus && /^Loading /.test(targets.dcpSymbolActivationStatus.textContent || ''))
    );
    closeDcpHeaderLibrary();
    closeDcpShapeLibrary();
    closeDcpSymbolLibrary();
    closeDcpAlignmentFlyout();
    if (symbolWasActive) {
      dcpSymbolLoadRevision += 1;
      dcpSymbolRestorePending = false;
    }
  }

  function syncDcpObjectToolbarCanvasGate() {
    if (hasDcpObjectToolbarCanvas()) return true;
    closeDcpObjectToolbarFlyouts();
    return false;
  }

  function requireDcpObjectToolbarCanvas() {
    if (!isBlankCanvasMode(controls.template ? controls.template.value : '')) return false;
    if (syncDcpObjectToolbarCanvasGate()) return true;
    if (targets.dcpToolbarStatus) targets.dcpToolbarStatus.textContent = dcpObjectToolbarSizeMessage;
    return false;
  }

  function syncDcpToolbarAndEditor(objects) {
    const blankCanvasMode = isBlankCanvasMode(controls.template.value);
    const dieCuttingMode = blankCanvasMode && selectedBlankCanvasSubfamily() === 'die_cutting';
    const normalized = normalizeDcpCanvasObjects(objects || getDcpProofState().objects);
    const selectedText = blankCanvasMode ? selectedDcpTextObject(normalized) : null;
    const textObjectCount = normalized.textObjects.length;
    const dieTextObjectAllowance = dieCuttingMode
      ? dcpDieTextObjectAllowance(dcpPhysicalCanvasForProof().height)
      : 0;
    syncDcpFontControlCatalog();
    syncDcpTextColorControlCatalog(normalized);
    if (targets.dcpAddText) {
      const defaultFontKey = dcpDefaultFontKey(currentDcpFontWorkflow());
      targets.dcpAddText.disabled = !blankCanvasMode
        || failedDcpFontIds.has(defaultFontKey)
        || dcpFontLoadPromises.has(defaultFontKey)
        || (!selectedText && (dieCuttingMode
          ? textObjectCount >= dieTextObjectAllowance
          : textObjectCount >= 3));
    }
    [
      { button: targets.dcpToolbarHeader, capability: 'header' },
      { button: targets.dcpToolbarShape, capability: 'shape' },
      { button: targets.dcpToolbarSymbol, capability: 'symbol' },
      { button: targets.dcpToolbarArtwork, capability: 'artwork' },
      { button: targets.dcpToolbarQr, capability: 'qr' },
      { button: targets.dcpToolbarBarcode, capability: 'barcode' }
    ].filter((entry) => Boolean(entry.button)).forEach((entry) => {
      const button = entry.button;
      const allowed = dcpModeAllows(entry.capability);
      button.hidden = !allowed;
      const placeholder = button === targets.dcpToolbarQr || button === targets.dcpToolbarBarcode;
      button.disabled = !allowed;
      button.setAttribute('aria-disabled', !allowed || placeholder ? 'true' : 'false');
    });
    if (dieCuttingMode) {
      closeDcpHeaderLibrary();
      closeDcpShapeLibrary();
      closeDcpSymbolLibrary();
    }
    if (targets.dcpToolbarStatus) {
      targets.dcpToolbarStatus.textContent = dieCuttingStateError
        ? dieCuttingStateError
        : (blankCanvasMode && !syncDcpObjectToolbarCanvasGate()
        ? dcpObjectToolbarSizeMessage
        : (dieCuttingMode
          ? dcpDieTextObjectAllowanceMessage(dcpPhysicalCanvasForProof().height, textObjectCount)
          : textObjectCount + ' of 3 text objects added.')
          + (selectedText ? ' Editing selected text.' : ' Select a text object to edit.'));
    }
    syncDcpHeaderLibraryActiveState();
    renderDcpSelectedObjectPanel(normalized);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[character]));
  }

  function renderOrderDetails(mode, details) {
    if (!targets.orderDetails) return;
    const rows = mode === 'standard'
      ? [
          ['Product Family', 'Standard Safety Signs'],
          ['Header', details.templateDisplayLabel || 'Header required'],
          ['Size', details.size || 'Size required'],
          ['Material', details.material || 'Material required'],
          ['Lamination', details.lamination || 'Lamination required'],
          ['Font', details.fontLabel || 'Font required'],
          ['Font Color', details.fontColorLabel || 'Font Color required'],
          ['Quantity', formatQuantity(details.quantity)],
          ['Price', details.subtotal || 'Pending pricing rules']
        ]
      : (mode === 'nitrous'
          ? [
              ['Product Family', 'Nitrous Bottle Labels'],
              ['Color / Pattern', details.nitrousTemplateLabel || 'Color / Pattern required'],
              ['Nitrous Header', details.nitrousHeaderLabel || 'Nitrous Header required'],
              ['Bottle Size', details.nitrousBottleWeight || 'Bottle Size required'],
              ['Finished Label Size', details.size || 'Bottle Size required'],
              ['Material', details.material || 'Material required'],
              ['Lamination', details.lamination || 'Lamination required'],
              ['Package Quantity', formatQuantity(details.quantity)],
              ['Package Price', details.packagePrice || 'Pending pricing rules'],
              ['Estimated Total', details.subtotal || 'Pending pricing rules']
            ]
          : (mode === 'blank_canvas'
              ? (details.dieCuttingMode
                ? [
                    ['Design Type', 'Custom Die-Cut Design'],
                    ['INSTALLATION SPACE', details.dieFinishedSize],
                    ['Vinyl Colors', details.dieVinylColors],
                    ['Premask', 'Included'],
                    ['Text Objects', String(details.dcpTextObjectCount)],
                    ['Pricing', details.pricing_enforcement_ready ? 'Exact physical price' : 'Pricing validation pending']
                  ]
                : [
                  ['Product Family', details.productFamilyLabel || 'Custom Print Design'],
                  ['Size', details.size || 'Size required'],
                  ['Material', details.material || 'Material required'],
                  ['Lamination', details.lamination || 'Lamination required'],
                  ['Text Objects', details.dcpTextObjectCount ? String(details.dcpTextObjectCount) : 'None added'],
                  ['Artwork', details.blankCanvasHasArtwork ? 'Added' : 'Not added (optional)'],
                  ['Artwork File', details.blankCanvasHasArtwork
                    ? (details.blankCanvasArtworkNeedsReselection
                        ? 'Reselect production file; the same original file may be chosen'
                        : (details.blankCanvasArtworkFilename || 'Artwork upload required'))
                    : 'Not added'],
                  ['Quantity', formatQuantity(details.quantity)],
                  ['Pricing', details.subtotal || 'Quote after artwork review']
                ])
              : [['Product Family', 'Select Product Family']]));

    targets.orderDetails.innerHTML = rows.map((row) => (
      '<div><dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd></div>'
    )).join('');
  }

  function setSelectionLabel(key, value, colorKey) {
    const label = Array.from(selectionLabels).find((item) => item.dataset.srdSelectionLabel === key);
    if (!label) return;
    if (key === 'font_color') {
      label.innerHTML = '<span class="srd-designer-swatch__chip srd-designer-swatch__chip--' + (colorKey || 'black') + '"></span>' + value;
      return;
    }
    label.textContent = value;
  }

  function updateSelectionRows() {
    setSelectionLabel('industry', selectorState.industry);
    setSelectionLabel('product_family', selectorState.product_family);
    setSelectionLabel('template', selectedTopLevelProductFamilyLabel());
    setSelectionLabel('standard_template', !isNitrousTemplate(controls.template.value) ? optionLabel(controls.template, 'Select Header') : 'Select Header');
    setSelectionLabel('nitrous_bottle_weight', selectedNitrousBottleWeight());
    setSelectionLabel('nitrous_header', selectedNitrousHeaderChoice().label);
    setSelectionLabel('nitrous_template', selectedNitrousTemplateChoice() ? selectedNitrousTemplateChoice().label : 'Select Color / Pattern');
    setSelectionLabel('blank_canvas_subfamily', selectedBlankCanvasSubfamilyLabel());
    setSelectionLabel('blank_canvas_start', optionLabel(controls.blankCanvasStart, 'Start Blank'));
    const sizeLabel = optionLabel(controls.size, 'Select Size');
    const sizeMinimum = controls.size && controls.size.value ? quantityDefaultForSize(controls.size.value) : '';
    setSelectionLabel('size', controls.size && controls.size.value && sizeMinimum ? sizeLabel + ' — Qty Min ' + sizeMinimum : sizeLabel);
    setSelectionLabel('material', optionLabel(controls.material, 'Select Material'));
    setSelectionLabel('lamination', optionLabel(controls.lamination, 'Select Lamination'));
    setSelectionLabel('font', optionLabel(controls.font, 'Select Font'));
    const color = selectedFontColor() || 'black';
    setSelectionLabel('font_color', fontColorLabels[color] || 'Black', color);
  }

  function closeFlyout() {
    flyout.hidden = true;
    flyout.innerHTML = '';
    selectorState.openType = '';
    selectionTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
  }

  function positionFlyout(trigger) {
    const rect = trigger.getBoundingClientRect();
    const rootRect = root.getBoundingClientRect();
    const desiredWidth = selectorState.openType === 'industry'
      ? 320
      : ((selectorState.openType === 'template' || selectorState.openType === 'standard_template' || selectorState.openType === 'blank_canvas_subfamily') ? 300 : 168);
    const rootWidth = root.clientWidth || window.innerWidth;
    const width = Math.min(desiredWidth, rootWidth - 24);
    const left = Math.min(Math.max(12, rect.left - rootRect.left), rootWidth - width - 12);
    const top = Math.max(12, rect.bottom - rootRect.top + 6);
    flyout.style.left = left + 'px';
    flyout.style.top = top + 'px';
    flyout.style.width = width + 'px';
  }

  function setSelectValue(control, value) {
    if (!control) return;
    control.value = value;
    control.dispatchEvent(new Event('change', { bubbles: true }));
    update();
  }

  function flyoutButton(label, onClick, active, extraClass, htmlPrefix, disabled) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'srd-designer-flyout__item' + (extraClass ? ' ' + extraClass : '');
    if (active) button.classList.add('is-active');
    button.innerHTML = (htmlPrefix || '') + '<span>' + label + '</span>';
    if (disabled) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.addEventListener('click', () => {
        const shouldClose = onClick();
        updateSelectionRows();
        if (shouldClose === false) return;
        closeFlyout();
      });
    }
    return button;
  }

  function renderBlankCanvasSubfamilyFlyout() {
    const grid = document.createElement('div');
    grid.className = 'srd-designer-flyout__grid';
    const selected = selectedBlankCanvasSubfamily();
    Object.keys(blankCanvasSubfamilies).forEach((key) => {
      const choice = blankCanvasSubfamilies[key];
      grid.appendChild(flyoutButton(choice.label, () => {
        if (!selectBlankCanvasSubfamily(key)) return false;
        update();
        return true;
      }, selected === key, 'srd-designer-flyout__item--blank-canvas-subfamily', '', !choice.enabled));
    });
    return grid;
  }

  function renderStandardFlyout(type) {
    const map = {
      nitrous_bottle_weight: controls.nitrousBottleWeight,
      nitrous_header: controls.nitrousHeader,
      nitrous_template: controls.nitrousTemplate,
      size: controls.size,
      material: controls.material,
      lamination: controls.lamination,
      font: controls.font,
      blank_canvas_start: controls.blankCanvasStart
    };
    const control = map[type];
    const grid = document.createElement('div');
    grid.className = 'srd-designer-flyout__grid';
    if (!control) return grid;
    Array.from(control.options || []).filter((option) => option.value).forEach((option) => {
      grid.appendChild(flyoutButton(option.textContent.trim(), () => {
        if (type === 'nitrous_template') {
          selectorState.template_category = 'nitrous';
          controls.template.value = option.value;
        }
        setSelectValue(control, option.value);
      }, control.value === option.value));
    });
    return grid;
  }

  function renderTemplateFlyout() {
    const grid = document.createElement('div');
    grid.className = 'srd-designer-flyout__grid';
    topLevelProductFamilies.forEach((family) => {
      grid.appendChild(flyoutButton(family.label, () => {
        return activateTopLevelProductFamily(family.key);
      }, selectorState.product_family_key === family.key, 'srd-designer-flyout__item--category'));
    });
    return grid;
  }

  function renderStandardTemplateFlyout() {
    const grid = document.createElement('div');
    grid.className = 'srd-designer-flyout__grid';
    Array.from(controls.template.options || []).filter((option) => {
      if (!option.value) return false;
      return !isNitrousTemplate(option.value) && !isBlankCanvasTemplate(option.value);
    }).forEach((option) => {
      const key = isNitrousTemplate(option.value) ? 'nitrous' : (option.value === 'warning_orange_black' ? 'warning-ob' : option.value);
      const previewText = isNitrousTemplate(option.value) ? 'N2O' : option.textContent.trim().replace(' (Orange / Black)', '');
      const preview = '<span class="srd-designer-flyout__template-preview srd-designer-flyout__template-preview--' + key + '">' + previewText + '</span>';
      grid.appendChild(flyoutButton(option.textContent.trim(), () => {
        selectorState.template_category = 'standard';
        setSelectValue(controls.template, option.value);
      }, controls.template.value === option.value, 'srd-designer-flyout__item--template', preview));
    });
    return grid;
  }

  function renderColorFlyout() {
    const colors = ['black', 'white', 'red', 'blue', 'yellow', 'orange'];
    const grid = document.createElement('div');
    grid.className = 'srd-designer-flyout__grid';
    colors.forEach((color) => {
      const prefix = '<span class="srd-designer-swatch__chip srd-designer-swatch__chip--' + color + '"></span>';
      grid.appendChild(flyoutButton(fontColorLabels[color], () => {
        controls.color.value = color;
        update();
      }, selectedFontColor() === color, '', prefix));
    });
    return grid;
  }

  function renderIndustryFlyout() {
    const grid = document.createElement('div');
    grid.className = 'srd-designer-flyout__grid srd-designer-flyout__grid--nested';
    const industryColumn = document.createElement('div');
    const familyColumn = document.createElement('div');
    industryColumn.className = 'srd-designer-flyout__column';
    familyColumn.className = 'srd-designer-flyout__column';

    function renderFamilies(industry) {
      familyColumn.innerHTML = '<p class="srd-designer-flyout__subhead">' + industry + '</p>';
      (industryFamilies[industry] || []).forEach((family) => {
        familyColumn.appendChild(flyoutButton(family, () => {
          selectorState.industry = industry;
          selectorState.product_family = family;
        }, selectorState.industry === industry && selectorState.product_family === family));
      });
    }

    Object.keys(industryFamilies).forEach((industry) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'srd-designer-flyout__item';
      if (selectorState.industry === industry) button.classList.add('is-active');
      button.textContent = industry;
      button.addEventListener('click', () => {
        selectorState.industry = industry;
        selectorState.product_family = industryFamilies[industry][0];
        renderFamilies(industry);
        updateSelectionRows();
        industryColumn.querySelectorAll('.srd-designer-flyout__item').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
      button.addEventListener('mouseenter', () => renderFamilies(industry));
      industryColumn.appendChild(button);
    });

    renderFamilies(selectorState.industry);
    grid.appendChild(industryColumn);
    grid.appendChild(familyColumn);
    return grid;
  }

  function renderProductFamilyFlyout() {
    const grid = document.createElement('div');
    grid.className = 'srd-designer-flyout__grid';
    (industryFamilies[selectorState.industry] || []).forEach((family) => {
      grid.appendChild(flyoutButton(family, () => {
        selectorState.product_family = family;
      }, selectorState.product_family === family));
    });
    return grid;
  }

  function openFlyout(type, trigger) {
    closeFlyout();
    selectorState.openType = type;
    trigger.setAttribute('aria-expanded', 'true');
    const flyoutTitles = {
      template: 'Product Family',
      standard_template: 'Header',
      nitrous_template: 'Color / Pattern',
      nitrous_header: 'Nitrous Headers',
      nitrous_bottle_weight: 'Bottle Size',
      font_color: 'Font Color'
    };
    const title = flyoutTitles[type] || type.replace('_', ' ');
    flyout.innerHTML = '<div class="srd-designer-flyout__head"><span>' + title + '</span><button class="srd-designer-flyout__close" type="button">Close</button></div>';
    const content = type === 'industry' ? renderIndustryFlyout()
      : type === 'product_family' ? renderProductFamilyFlyout()
      : type === 'template' ? renderTemplateFlyout()
      : type === 'standard_template' ? renderStandardTemplateFlyout()
      : type === 'font_color' ? renderColorFlyout()
      : renderStandardFlyout(type);
    flyout.appendChild(content);
    flyout.querySelector('.srd-designer-flyout__close').addEventListener('click', closeFlyout);
    positionFlyout(trigger);
    flyout.hidden = false;
  }

  function setControlFromParam(control, value) {
    if (!control || !value) return;
    const option = Array.from(control.options || []).find((item) => item.value === value || item.textContent.trim() === value);
    control.value = option ? option.value : value;
  }

  function restoreDesignFromQuery() {
    if (pageParams.get('edit') !== '1') return;
    selectedDcpObjects = [];
    selectedDcpObject = null;
    dcpMultiSelectMode = false;
    root.setAttribute('data-srd-dcp-selected-object', 'none');
    const restoreTemplate = pageParams.get('template');
    const restoredFamilyValue = pageParams.get('product_family_key')
      || pageParams.get('family')
      || pageParams.get('product_family')
      || '';
    const restoredFamilyKey = normalizeTopLevelProductFamily(restoredFamilyValue);
    let restoredDcpObjects = null;
    const hasDcpRestoreParams = [
      'dcp_proof_ref',
      'dcp_artwork_preview_ref',
      'dcp_artwork_compatibility_ref',
      'dcp_artwork_ref',
      'dcp_artwork_filename',
      'dcp_artwork_type',
      'dcp_canvas_objects',
      'dcp_canvas_size',
      'dcp_material',
      'dcp_lamination',
      'dcp_quantity',
      'blank_canvas_subfamily'
    ].some((param) => Boolean(pageParams.get(param)));
    const restoredCustomFamily = restoredFamilyKey === 'custom_die_cut_design' || restoredFamilyKey === 'custom_print_design';
    const restoredLegacyBlankCanvas = String(restoredFamilyValue).trim().toLowerCase() === 'blank_canvas'
      || String(restoredFamilyValue).trim().toLowerCase() === 'blank canvas';
    const effectiveTemplate = restoreTemplate || ((hasDcpRestoreParams || restoredCustomFamily || restoredLegacyBlankCanvas) ? 'blank_canvas' : '');
    setControlFromParam(controls.template, effectiveTemplate);
    setControlFromParam(controls.size, pageParams.get('size'));
    if (effectiveTemplate === 'blank_canvas') {
      selectorState.template_category = 'blank_canvas';
      selectorState.industry = 'Custom';
      activeDcpWorkspaceMode = restoredFamilyKey === 'custom_die_cut_design'
        ? 'die_cutting'
        : (restoredFamilyKey === 'custom_print_design'
          ? 'print_design'
          : normalizeBlankCanvasSubfamily(pageParams.get('blank_canvas_subfamily')));
      selectorState.product_family_key = topLevelProductFamilyForWorkspace(activeDcpWorkspaceMode);
      selectorState.product_family = topLevelProductFamiliesByKey[selectorState.product_family_key].label;
      selectorState.blank_canvas_subfamily = activeDcpWorkspaceMode;
      if (controls.blankCanvasSubfamily) controls.blankCanvasSubfamily.value = activeDcpWorkspaceMode;
      dcpCartEditSession = {
        active: Boolean(pageParams.get('dcp_cart_line_key')),
        status: 'resolving',
        lineKey: pageParams.get('dcp_cart_line_key') || '',
        expectedVariantId: pageParams.get('dcp_cart_variant_id') || '',
        expectedProductId: pageParams.get('dcp_cart_product_id') || '',
        originalVariantId: '',
        originalProductId: '',
        originalProductionReference: '',
        originalFilename: '',
        originalFileType: '',
        originalHadArtwork: false,
        failure: ''
      };
      const restoredArtworkMode = pageParams.get('dcp_artwork_mode') || '';
      if (controls.blankCanvasStart) controls.blankCanvasStart.value = restoredArtworkMode || 'start_blank';
      restoredDcpObjects = parseDcpCanvasObjects(pageParams.get('dcp_canvas_objects'));
      const restoringDieCuttingCart = activeDcpWorkspaceMode === 'die_cutting'
        || pageParams.get('blank_canvas_subfamily') === 'die_cutting';
      if (restoringDieCuttingCart && pageParams.get('dcp_physical_canvas')) {
        const proof = getDcpProofState();
        try {
          const restoredPhysicalCanvas = pageParams.get('dcp_physical_canvas')
            .replace(/&quot;/g, '"')
            .replace(/&#34;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&amp;/g, '&');
          const savedPhysicalCanvas = JSON.parse(restoredPhysicalCanvas);
          proof.physicalCanvas = restoringDieCuttingCart
            && Number(savedPhysicalCanvas.width) >= dcpPhysicalCanvasLimits.width.min
            && Number(savedPhysicalCanvas.width) <= dcpPhysicalCanvasLimits.width.max
            && Number(savedPhysicalCanvas.height) >= dcpPhysicalCanvasLimits.height.min
            && Number(savedPhysicalCanvas.height) <= 12
            ? { version: 1, unit: 'in', width: Number(savedPhysicalCanvas.width), height: Number(savedPhysicalCanvas.height), trustedDcArtRestore: Boolean(pageParams.get('dcp_dc_art_production')) }
            : normalizeDcpPhysicalCanvas(savedPhysicalCanvas);
          currentDcpProofState = proof;
          syncDcpProofCompatibilityAlias();
        } catch (error) {
          setDieCuttingDevelopmentMessage('The saved Custom Die dimensions could not be restored.');
        }
      }
      let dcArtRestoreCompleted = false;
      const serializedDcArtContract = pageParams.get('dcp_dc_art_production') || '';
      if (restoringDieCuttingCart && dcpCartEditSession.active) {
        try {
          if (!serializedDcArtContract) throw new Error('The saved trusted DC artwork record is missing.');
          const dcContract = JSON.parse(serializedDcArtContract
            .replace(/&quot;/g, '"')
            .replace(/&#34;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&amp;/g, '&'));
          if (!dcContract || dcContract.contractVersion !== dcpDcArtProductionContractVersion
            || dcContract.catalogVersion !== dcpDcArtCatalogVersion
            || !dcpDcArtSupportedSizes.includes(Number(dcContract.artSizeInches))) {
            throw new Error('The saved trusted DC artwork record is invalid.');
          }
          const record = trustedDcArtRecordForRestore(dcContract.designId);
          const colorKey = authorizedDcpDieVinylColorKey(dcContract.vinylColor);
          if (!colorKey || !record.approvedVinylColors.includes(dcpDieVinylColorDescriptor(colorKey).label)) {
            throw new Error('The saved DC artwork color is not approved.');
          }
          if (!restoredDcpObjects || !restoredDcpObjects.artwork || !restoredDcpObjects.textObjects.length) {
            throw new Error('The saved DC artwork composition is incomplete.');
          }
          activeDcpCatalogArtwork = { record: record, nominalSize: Number(dcContract.artSizeInches) };
        dcpCartEditSession.verifiedDcArtRestore = true;
        dcpCartEditSession.failure = '';
          const proof = getDcpProofState();
          proof.source = 'dc_art_catalog'; proof.url = record.previewSrc; proof.previewUrl = record.previewSrc;
          proof.name = record.title; proof.filename = record.designId; proof.originalFilename = record.designId;
          proof.type = 'catalog_artwork'; proof.fileType = 'catalog_artwork';
          proof.status = 'Restored trusted DC Art Library design.'; proof.supported = true; proof.previewable = true;
          proof.dieVinylColorKey = colorKey;
          proof.catalogArtwork = { designId: record.designId, catalogVersion: record.catalogVersion, nominalSize: Number(dcContract.artSizeInches), physicalSizeIn: cloneDcpHistoryValue(record.exactDimensions[String(dcContract.artSizeInches)]), lockedAspectRatio: true };
          proof.objects = normalizeDcpCanvasObjects(restoredDcpObjects, 'die_cutting');
          currentDcpProofState = normalizeDcpDieObjectColors(proof);
          if (controls.blankCanvasStart) controls.blankCanvasStart.value = 'upload_artwork';
          dcArtRestoreCompleted = true;
          syncDcpProofCompatibilityAlias();
          window.setTimeout(() => document.dispatchEvent(new CustomEvent('srd:dc-art-changed', { detail: dcArtState() })), 0);
        } catch (error) {
          failClosedDcArtRestore(error && error.message ? error.message : 'The saved DC artwork could not be restored.');
          return;
        }
      }
      if (activeDcpWorkspaceMode === 'die_cutting'
        && (dieCuttingStateError || pageParams.get('dcp_artwork_ref') || pageParams.get('dcp_artwork_filename'))) {
        const restoreFailure = dieCuttingStateError || 'Artwork uploads are unavailable for Die Cutting.';
        activeDcpWorkspaceMode = 'print_design';
        selectorState.product_family_key = 'custom_print_design';
        selectorState.product_family = topLevelProductFamiliesByKey.custom_print_design.label;
        selectorState.blank_canvas_subfamily = activeDcpWorkspaceMode;
        if (controls.blankCanvasSubfamily) controls.blankCanvasSubfamily.value = 'print_design';
        setDieCuttingDevelopmentMessage(restoreFailure + ' The design was not restored as Die Cutting.');
      }
      const artworkPreviewReference = pageParams.get('dcp_artwork_preview_ref') || '';
      const artworkCompatibilityReference = pageParams.get('dcp_artwork_compatibility_ref') || pageParams.get('dcp_artwork_ref') || '';
      const artworkReference = artworkPreviewReference || artworkCompatibilityReference;
      const artworkFilename = pageParams.get('dcp_artwork_filename') || '';
      const hasArtworkRestore = Boolean(artworkReference || artworkFilename);
      const hasIntrinsicStructuredObjects = hasMeaningfulDcpStructuredObjects(
        restoredDcpObjects,
        pageParams.get('size'),
        false
      );
      // Older Shape-only lines copied the composed proof into the artwork reference.
      // A named upload is authoritative Artwork; otherwise valid object state wins.
      const hasAuthoritativeArtworkRestore = Boolean(artworkFilename) || (hasArtworkRestore && !hasIntrinsicStructuredObjects);
      if (!dcArtRestoreCompleted && hasAuthoritativeArtworkRestore) {
        restoreBlankCanvasArtworkFromProof(
          artworkReference,
          artworkFilename,
          pageParams.get('dcp_artwork_type'),
          pageParams.get('dcp_artwork_status'),
          restoredDcpObjects
        );
        selectDefaultDcpObject(restoredDcpObjects, true);
      } else if (!dcArtRestoreCompleted && hasIntrinsicStructuredObjects) {
        setDcpProofFromRestore({
          mode: restoredArtworkMode || 'start_blank',
          objects: restoredDcpObjects,
          supported: true,
          previewable: false,
          message: 'Restored structured DCP canvas objects.'
        });
        selectDefaultDcpObject(restoredDcpObjects, false);
      } else if (!dcArtRestoreCompleted && !dcpShapeRestoreValidationError && !dcpSymbolRestoreValidationError && pageParams.get('dcp_proof_ref')) {
        if (controls.blankCanvasStart) controls.blankCanvasStart.value = restoredArtworkMode || 'upload_artwork';
        restoreBlankCanvasArtworkFromProof(
          pageParams.get('dcp_proof_ref'),
          '',
          'image/png',
          'Restored historical proof preview.',
          restoredDcpObjects
        );
        selectDcpObject('artwork');
      }
      adoptCurrentStateAsDcpModeWorkspace(activeDcpWorkspaceMode);
      if (restoredDcpObjects && restoredDcpObjects.symbolObjects.length && !dcpSymbolRestoreValidationError) {
        prepareDcpRestoredSymbolAssets(restoredDcpObjects);
      }
    }
    setControlFromParam(controls.nitrousBottleWeight, pageParams.get('nitrous_bottle_weight'));
    setControlFromParam(controls.material, pageParams.get('material'));
    setControlFromParam(controls.lamination, pageParams.get('lamination'));
    setControlFromParam(controls.font, pageParams.get('font'));

    const fontColorParam = pageParams.get('font_color');
    if (controls.color && fontColorParam) {
      const colorKey = Object.keys(fontColorLabels).find((key) => key === fontColorParam || fontColorLabels[key] === fontColorParam);
      controls.color.value = colorKey || fontColorParam;
    }
    if (controls.body && pageParams.get('message') && !(effectiveTemplate === 'blank_canvas' && restoredDcpObjects && restoredDcpObjects.textObjects.length)) {
      controls.body.value = sanitizeMessage(pageParams.get('message'));
      syncMessageLineInputs(controls.body.value);
    }
    if (controls.quantity && pageParams.get('quantity') && effectiveTemplate !== 'blank_canvas') {
      controls.quantity.value = pageParams.get('quantity');
    }
  }

  function sanitizeMessage(value) {
    return String(value || '').toUpperCase().replace(/\r/g, '').split('\n').slice(0, 3).join('\n');
  }

  function messageFromLineInputs() {
    if (!controls.messageLines || controls.messageLines.length === 0) {
      return controls.body ? controls.body.value : '';
    }
    return Array.from(controls.messageLines).map((input) => input.value || '').slice(0, 3).join('\n');
  }

  function syncMessageLineInputs(message) {
    if (!controls.messageLines || controls.messageLines.length === 0) return;
    const lines = sanitizeMessage(message).split('\n');
    controls.messageLines.forEach((input, index) => {
      const value = lines[index] || '';
      if (input.value !== value) input.value = value;
    });
  }

  function fitMessage() {
    const message = targets.previewMessage;
    if (!message) return;

    const artboard = message.closest('.srd-designer-proof__artboard');
    if (!artboard || message.textContent.length === 0 || root.getAttribute('data-srd-template-selected') !== 'true') {
      root.setAttribute('data-srd-text-overflow', 'false');
      return;
    }

    const maxSize = Math.min(86, Math.max(34, artboard.clientWidth * 0.13));
    const minSize = 20;
    let fitted = false;

    for (let size = maxSize; size >= minSize; size -= 2) {
      message.style.setProperty('--srd-message-font-size', size + 'px');
      if (message.scrollWidth <= message.clientWidth + 1 && message.scrollHeight <= message.clientHeight + 1) {
        fitted = true;
        break;
      }
    }

    if (!fitted) {
      message.style.setProperty('--srd-message-font-size', minSize + 'px');
    }

    root.setAttribute('data-srd-text-overflow', fitted ? 'false' : 'true');
  }

  function isDcpArchedTextObject(object) {
    return normalizeDcpTextShape(object && object.textShape) !== 'straight';
  }

  function dcpTextObjectTransform(object) {
    const rotation = clampDcpNumber(object && object.rotation, -180, 180, 0);
    return 'translate(-50%, -50%) rotate(' + rotation + 'deg)';
  }

  let dcpGlyphMeasurementCanvas = null;
  let dcpGlyphMeasurementContext = null;
  let dcpGlyphMeasurementSvg = null;
  let dcpGlyphMeasurementText = null;
  const dcpGlyphMetricCache = new Map();

  function clearDcpGlyphMeasurementCache() {
    dcpGlyphMetricCache.clear();
  }

  function dcpSvgGlyphMeasurementNode() {
    if (dcpGlyphMeasurementText && dcpGlyphMeasurementText.isConnected) return dcpGlyphMeasurementText;
    dcpGlyphMeasurementSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    dcpGlyphMeasurementSvg.setAttribute('width', '1');
    dcpGlyphMeasurementSvg.setAttribute('height', '1');
    dcpGlyphMeasurementSvg.setAttribute('aria-hidden', 'true');
    dcpGlyphMeasurementSvg.style.position = 'fixed';
    dcpGlyphMeasurementSvg.style.left = '-10000px';
    dcpGlyphMeasurementSvg.style.top = '-10000px';
    dcpGlyphMeasurementSvg.style.overflow = 'visible';
    dcpGlyphMeasurementSvg.style.opacity = '0';
    dcpGlyphMeasurementSvg.style.pointerEvents = 'none';
    dcpGlyphMeasurementText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    dcpGlyphMeasurementText.setAttribute('x', '0');
    dcpGlyphMeasurementText.setAttribute('y', '0');
    dcpGlyphMeasurementText.setAttribute('xml:space', 'preserve');
    dcpGlyphMeasurementText.style.whiteSpace = 'pre';
    dcpGlyphMeasurementSvg.appendChild(dcpGlyphMeasurementText);
    document.body.appendChild(dcpGlyphMeasurementSvg);
    return dcpGlyphMeasurementText;
  }

  function dcpGlyphContext(fontStack, fontSize) {
    return {
      fontStack: fontStack,
      fontSize: Math.max(0.5, Number(fontSize) || 0.5)
    };
  }

  function dcpGlyphMetrics(context, value) {
    const text = String(value || '');
    const cacheKey = context.fontStack + '|' + context.fontSize.toFixed(3) + '|' + text;
    if (dcpGlyphMetricCache.has(cacheKey)) return dcpGlyphMetricCache.get(cacheKey);
    const measurement = dcpSvgGlyphMeasurementNode();
    measurement.style.fontFamily = context.fontStack;
    measurement.style.fontSize = context.fontSize + 'px';
    measurement.style.fontWeight = '950';
    measurement.textContent = text || ' ';
    let bounds;
    let advance;
    try {
      bounds = measurement.getBBox();
      advance = measurement.getComputedTextLength();
    } catch (_error) {
      if (!dcpGlyphMeasurementCanvas) {
        dcpGlyphMeasurementCanvas = document.createElement('canvas');
        dcpGlyphMeasurementCanvas.width = 1;
        dcpGlyphMeasurementCanvas.height = 1;
        dcpGlyphMeasurementContext = dcpGlyphMeasurementCanvas.getContext('2d');
      }
      dcpGlyphMeasurementContext.font = '950 ' + context.fontSize + 'px ' + context.fontStack;
      const fallback = dcpGlyphMeasurementContext.measureText(text);
      bounds = {
        x: -(Number(fallback.actualBoundingBoxLeft) || 0),
        y: -(Number(fallback.actualBoundingBoxAscent) || 0),
        width: (Number(fallback.actualBoundingBoxLeft) || 0) + (Number(fallback.actualBoundingBoxRight) || Number(fallback.width) || 0),
        height: (Number(fallback.actualBoundingBoxAscent) || 0) + (Number(fallback.actualBoundingBoxDescent) || 0)
      };
      advance = Number(fallback.width) || 0;
    }
    if (/\s/u.test(text) && !advance) {
      if (!dcpGlyphMeasurementCanvas) {
        dcpGlyphMeasurementCanvas = document.createElement('canvas');
        dcpGlyphMeasurementCanvas.width = 1;
        dcpGlyphMeasurementCanvas.height = 1;
        dcpGlyphMeasurementContext = dcpGlyphMeasurementCanvas.getContext('2d');
      }
      dcpGlyphMeasurementContext.font = '950 ' + context.fontSize + 'px ' + context.fontStack;
      advance = Number(dcpGlyphMeasurementContext.measureText(text).width) || 0;
    }
    const result = {
      advance: Number(advance) || 0,
      ascent: Math.max(0, -Number(bounds.y || 0)),
      descent: Math.max(0, Number(bounds.y || 0) + Number(bounds.height || 0)),
      left: Number(bounds.x) || 0,
      right: (Number(bounds.x) || 0) + (Number(bounds.width) || 0)
    };
    if (dcpGlyphMetricCache.size > 4000) dcpGlyphMetricCache.clear();
    dcpGlyphMetricCache.set(cacheKey, result);
    return result;
  }

  function dcpPrintGlyphMetrics(context, value) {
    const text = String(value || '');
    const cacheKey = 'print|' + context.fontStack + '|' + context.fontSize.toFixed(3) + '|' + text;
    if (dcpGlyphMetricCache.has(cacheKey)) return dcpGlyphMetricCache.get(cacheKey);
    if (!dcpGlyphMeasurementCanvas) {
      dcpGlyphMeasurementCanvas = document.createElement('canvas');
      dcpGlyphMeasurementCanvas.width = 1;
      dcpGlyphMeasurementCanvas.height = 1;
      dcpGlyphMeasurementContext = dcpGlyphMeasurementCanvas.getContext('2d');
    }
    dcpGlyphMeasurementContext.font = '950 ' + context.fontSize + 'px ' + context.fontStack;
    const measurement = dcpGlyphMeasurementContext.measureText(text || ' ');
    const advance = Number(measurement.width) || 0;
    const left = -(Number(measurement.actualBoundingBoxLeft) || 0);
    const right = Number(measurement.actualBoundingBoxRight);
    const result = {
      advance: advance,
      ascent: Math.max(0, Number(measurement.actualBoundingBoxAscent) || 0),
      descent: Math.max(0, Number(measurement.actualBoundingBoxDescent) || 0),
      left: left,
      right: Number.isFinite(right) ? right : left + advance
    };
    if (dcpGlyphMetricCache.size > 4000) dcpGlyphMetricCache.clear();
    dcpGlyphMetricCache.set(cacheKey, result);
    return result;
  }

  function dcpMeasuredBoundsMargin(bounds) {
    const width = Math.max(0, Number(bounds && bounds.width) || 0);
    const height = Math.max(0, Number(bounds && bounds.height) || 0);
    return Math.max(0.2, Math.min(3, Math.max(width, height) * 0.015));
  }

  function dcpTextOutlineStrokeWidth(object, fontSize) {
    if (!object || !object.outlineEnabled || isDieCuttingMode()) return 0;
    const ratio = dcpTextOutlineThicknessValues[object.outlineThicknessKey] || dcpTextOutlineThicknessValues.medium;
    return Math.max(0, Number(fontSize) || 0) * ratio;
  }

  function dcpTextOutlineColor(object) {
    return colorValueFor(object && object.outlineColorKey ? object.outlineColorKey : 'white') || '#ffffff';
  }

  function dcpTextGraphemes(value) {
    const text = String(value || '');
    if (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function') {
      return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text), (entry) => entry.segment);
    }
    return Array.from(text);
  }

  function dcpTextWidth(context, value) {
    return dcpGlyphMetrics(context, value).advance;
  }

  function dcpBreakLongTextToken(context, token, maxWidth) {
    const pieces = [];
    let current = '';
    dcpTextGraphemes(token).forEach((character) => {
      const candidate = current + character;
      if (current && dcpTextWidth(context, candidate) > maxWidth) {
        pieces.push(current);
        current = character;
      } else {
        current = candidate;
      }
    });
    if (current || !pieces.length) pieces.push(current);
    return pieces;
  }

  function dcpStraightTextLines(context, value, maxWidth) {
    const lines = [];
    String(value || '').replace(/\r\n?/g, '\n').split('\n').forEach((paragraph) => {
      const words = paragraph.trim() ? paragraph.trim().split(/\s+/) : [''];
      let current = '';
      words.forEach((word) => {
        const candidate = current ? current + ' ' + word : word;
        if (!current || dcpTextWidth(context, candidate) <= maxWidth) {
          if (dcpTextWidth(context, candidate) <= maxWidth || !word) {
            current = candidate;
            return;
          }
        }
        if (current) {
          lines.push(current);
          current = '';
        }
        if (dcpTextWidth(context, word) <= maxWidth) {
          current = word;
          return;
        }
        const pieces = dcpBreakLongTextToken(context, word, maxWidth);
        pieces.slice(0, -1).forEach((piece) => lines.push(piece));
        current = pieces[pieces.length - 1] || '';
      });
      lines.push(current);
    });
    return lines.length ? lines : [''];
  }

  function dcpStraightGlyphLayout(value, fontStack, fontSize, boxWidth) {
    const context = dcpGlyphContext(fontStack, fontSize);
    if (!context) return null;
    const lines = dcpStraightTextLines(context, value, Math.max(1, boxWidth));
    const lineGap = fontSize * 0.08;
    let cursorTop = 0;
    let unionLeft = Infinity;
    let unionRight = -Infinity;
    const records = lines.map((line) => {
      const metrics = dcpGlyphMetrics(context, line);
      const visibleHeight = Math.max(0.01, metrics.ascent + metrics.descent);
      const baseline = cursorTop + metrics.ascent;
      const record = {
        text: line,
        baseline: baseline,
        left: metrics.left,
        right: metrics.right,
        top: baseline - metrics.ascent,
        bottom: baseline + metrics.descent
      };
      unionLeft = Math.min(unionLeft, record.left);
      unionRight = Math.max(unionRight, record.right);
      cursorTop += visibleHeight + lineGap;
      return record;
    });
    const unionTop = records.length ? records[0].top : 0;
    const unionBottom = records.length ? records[records.length - 1].bottom : 0;
    const width = Math.max(0.01, unionRight - unionLeft);
    const height = Math.max(0.01, unionBottom - unionTop);
    const margin = dcpMeasuredBoundsMargin({ width: width, height: height });
    return {
      type: 'straight',
      fontSize: fontSize,
      lines: records,
      rawBounds: { left: unionLeft, top: unionTop, width: width, height: height },
      margin: margin
    };
  }

  function dcpPrintStraightTextLines(context, value, maxWidth) {
    const lines = [];
    let current = '';
    dcpTextGraphemes(String(value || '').replace(/\r\n?/g, '\n')).forEach((character) => {
      if (character === '\n') {
        lines.push(current);
        current = '';
        return;
      }
      const candidate = current + character;
      if (current && dcpPrintGlyphMetrics(context, candidate).advance > maxWidth) {
        lines.push(current);
        current = character;
      } else {
        current = candidate;
      }
    });
    lines.push(current);
    return lines.length ? lines : [''];
  }

  function dcpPrintStraightGlyphLayout(value, fontStack, fontSize, boxWidth) {
    const context = dcpGlyphContext(fontStack, fontSize);
    const lines = dcpPrintStraightTextLines(context, value, Math.max(1, boxWidth));
    const lineGap = fontSize * 0.08;
    let cursorTop = 0;
    let unionLeft = Infinity;
    let unionRight = -Infinity;
    let fitLeft = Infinity;
    let fitRight = -Infinity;
    const records = lines.map((line) => {
      const metrics = dcpPrintGlyphMetrics(context, line);
      const visibleHeight = Math.max(0.01, metrics.ascent + metrics.descent);
      const baseline = cursorTop + metrics.ascent;
      const originX = -metrics.advance / 2;
      const record = {
        text: line,
        x: originX,
        baseline: baseline,
        advance: metrics.advance,
        left: originX + metrics.left,
        right: originX + metrics.right,
        top: baseline - metrics.ascent,
        bottom: baseline + metrics.descent
      };
      unionLeft = Math.min(unionLeft, record.left);
      unionRight = Math.max(unionRight, record.right);
      fitLeft = Math.min(fitLeft, originX, record.left);
      fitRight = Math.max(fitRight, originX + metrics.advance, record.right);
      cursorTop += visibleHeight + lineGap;
      return record;
    });
    const unionTop = records.length ? records[0].top : 0;
    const unionBottom = records.length ? records[records.length - 1].bottom : 0;
    const width = Math.max(0.01, unionRight - unionLeft);
    const height = Math.max(0.01, unionBottom - unionTop);
    const margin = dcpMeasuredBoundsMargin({ width: width, height: height });
    return {
      type: 'straight',
      fontSize: fontSize,
      lines: records,
      rawBounds: { left: unionLeft, top: unionTop, width: width, height: height },
      fitBounds: {
        left: fitLeft,
        top: unionTop,
        width: Math.max(0.01, fitRight - fitLeft),
        height: height
      },
      margin: margin,
      preserveHorizontalAdvance: /^\s|\s$/u.test(String(value || ''))
    };
  }

  function dcpArchGeometry(object, width, height) {
    const shape = normalizeDcpTextShape(object && object.textShape);
    const arc = clampDcpNumber(object && object.arcAmount, 0, 100, 35);
    const boxWidth = Math.max(1, Number(width) || 100);
    const boxHeight = Math.max(1, Number(height) || 100);
    const padX = Math.max(4, boxWidth * 0.08);
    const centerX = boxWidth / 2;
    const centerY = boxHeight * 0.52;
    const strength = arc / 100;
    const direction = shape === 'arch_down' ? 1 : -1;
    const endpointY = centerY - direction * boxHeight * 0.32 * strength;
    const apexY = centerY + direction * boxHeight * 0.40 * strength;
    return {
      start: { x: padX, y: endpointY },
      control: { x: centerX, y: 2 * apexY - endpointY },
      end: { x: boxWidth - padX, y: endpointY }
    };
  }

  function dcpPrintArchGeometry(object, width, height) {
    const shape = normalizeDcpTextShape(object && object.textShape);
    const arc = clampDcpNumber(object && object.arcAmount, 0, 100, 35);
    const boxWidth = Math.max(1, Number(width) || 100);
    const boxHeight = Math.max(1, Number(height) || 100);
    const padX = Math.max(4, boxWidth * 0.08);
    const centerX = boxWidth / 2;
    const centerY = boxHeight * 0.52;
    const curve = (arc / 100) * boxHeight * 0.42;
    return {
      start: { x: padX, y: centerY },
      control: { x: centerX, y: shape === 'arch_down' ? centerY + curve : centerY - curve },
      end: { x: boxWidth - padX, y: centerY }
    };
  }

  function dcpQuadraticPoint(geometry, t) {
    const inverse = 1 - t;
    return {
      x: inverse * inverse * geometry.start.x + 2 * inverse * t * geometry.control.x + t * t * geometry.end.x,
      y: inverse * inverse * geometry.start.y + 2 * inverse * t * geometry.control.y + t * t * geometry.end.y
    };
  }

  function dcpQuadraticTangent(geometry, t) {
    return {
      x: 2 * (1 - t) * (geometry.control.x - geometry.start.x) + 2 * t * (geometry.end.x - geometry.control.x),
      y: 2 * (1 - t) * (geometry.control.y - geometry.start.y) + 2 * t * (geometry.end.y - geometry.control.y)
    };
  }

  function dcpQuadraticArcTable(geometry) {
    const samples = [{ t: 0, length: 0, point: dcpQuadraticPoint(geometry, 0) }];
    let length = 0;
    for (let index = 1; index <= 96; index += 1) {
      const t = index / 96;
      const point = dcpQuadraticPoint(geometry, t);
      const previous = samples[samples.length - 1].point;
      length += Math.hypot(point.x - previous.x, point.y - previous.y);
      samples.push({ t: t, length: length, point: point });
    }
    return { samples: samples, length: length };
  }

  function dcpQuadraticPointAtLength(geometry, table, targetLength) {
    const distance = Math.max(0, Math.min(table.length, targetLength));
    let high = table.samples.findIndex((sample) => sample.length >= distance);
    if (high <= 0) high = 1;
    const after = table.samples[high];
    const before = table.samples[high - 1];
    const span = Math.max(0.0001, after.length - before.length);
    const ratio = (distance - before.length) / span;
    const t = before.t + (after.t - before.t) * ratio;
    const point = dcpQuadraticPoint(geometry, t);
    const tangent = dcpQuadraticTangent(geometry, t);
    return { x: point.x, y: point.y, angle: Math.atan2(tangent.y, tangent.x), t: t };
  }

  function dcpRotatedGlyphBounds(metrics, x, y, angle) {
    const advanceCenter = metrics.advance / 2;
    const corners = [
      { x: -advanceCenter + metrics.left, y: -metrics.ascent },
      { x: -advanceCenter + metrics.right, y: -metrics.ascent },
      { x: -advanceCenter + metrics.right, y: metrics.descent },
      { x: -advanceCenter + metrics.left, y: metrics.descent }
    ];
    const cosine = Math.cos(angle);
    const sine = Math.sin(angle);
    return corners.map((corner) => ({
      x: x + corner.x * cosine - corner.y * sine,
      y: y + corner.x * sine + corner.y * cosine
    }));
  }

  function dcpArchedGlyphLayout(object, fontStack, fontSize, boxWidth, boxHeight, geometryOverride, metricResolver) {
    const context = dcpGlyphContext(fontStack, fontSize);
    if (!context) return null;
    const characters = dcpTextGraphemes(String(object && object.text || ''));
    const geometry = geometryOverride || dcpArchGeometry(object, boxWidth, boxHeight);
    const table = dcpQuadraticArcTable(geometry);
    const resolveMetrics = typeof metricResolver === 'function' ? metricResolver : dcpGlyphMetrics;
    const metrics = characters.map((character) => ({
      character: character,
      painted: !/\s/u.test(character),
      metrics: resolveMetrics(context, character)
    }));
    const totalAdvance = metrics.reduce((sum, item) => sum + item.metrics.advance, 0);
    if (!totalAdvance || totalAdvance > table.length) {
      return {
        type: 'arched',
        fontSize: fontSize,
        glyphs: [],
        rawBounds: { left: 0, top: 0, width: Infinity, height: Infinity },
        margin: 0,
        geometry: geometry,
        pathLength: table.length,
        textLength: totalAdvance
      };
    }
    let cursor = (table.length - totalAdvance) / 2;
    let left = Infinity;
    let right = -Infinity;
    let top = Infinity;
    let bottom = -Infinity;
    const glyphs = metrics.map((item) => {
      const centerDistance = cursor + item.metrics.advance / 2;
      const placement = dcpQuadraticPointAtLength(geometry, table, centerDistance);
      if (item.painted) {
        const corners = dcpRotatedGlyphBounds(item.metrics, placement.x, placement.y, placement.angle);
        corners.forEach((corner) => {
          left = Math.min(left, corner.x);
          right = Math.max(right, corner.x);
          top = Math.min(top, corner.y);
          bottom = Math.max(bottom, corner.y);
        });
      }
      cursor += item.metrics.advance;
      return {
        text: item.character,
        x: placement.x,
        y: placement.y,
        angle: placement.angle,
        metrics: item.metrics
      };
    });
    const width = Math.max(0.01, right - left);
    const height = Math.max(0.01, bottom - top);
    const margin = dcpMeasuredBoundsMargin({ width: width, height: height });
    return {
      type: 'arched',
      fontSize: fontSize,
      glyphs: glyphs,
      rawBounds: { left: left, top: top, width: width, height: height },
      margin: margin,
      geometry: geometry,
      pathLength: table.length,
      textLength: totalAdvance
    };
  }

  function dcpPrintTextLayoutAtFontSize(object, boxWidth, boxHeight, fontStack, fontSize) {
    const straight = normalizeDcpTextShape(object && object.textShape) === 'straight';
    const layout = straight
      ? dcpPrintStraightGlyphLayout(object.text, fontStack, fontSize, boxWidth)
      : dcpArchedGlyphLayout(
          object,
          fontStack,
          fontSize,
          boxWidth,
          boxHeight,
          dcpPrintArchGeometry(object, boxWidth, boxHeight),
          dcpPrintGlyphMetrics
        );
    if (!layout || !Number.isFinite(layout.rawBounds.width) || !Number.isFinite(layout.rawBounds.height)) return layout;
    layout.margin += dcpTextOutlineStrokeWidth(object, fontSize) / 2;
    layout.outlineStrokeWidth = dcpTextOutlineStrokeWidth(object, fontSize);
    const preserveHorizontalAdvance = /^\s|\s$/u.test(String(object && object.text || ''));
    layout.preserveHorizontalAdvance = preserveHorizontalAdvance;
    layout.offsetX = straight
      ? boxWidth / 2
      : (preserveHorizontalAdvance ? 0 : boxWidth / 2 - (layout.rawBounds.left + layout.rawBounds.width / 2));
    layout.offsetY = boxHeight / 2 - (layout.rawBounds.top + layout.rawBounds.height / 2);
    layout.paintBounds = {
      left: layout.rawBounds.left + layout.offsetX - layout.margin,
      top: layout.rawBounds.top + layout.offsetY - layout.margin,
      width: layout.rawBounds.width + layout.margin * 2,
      height: layout.rawBounds.height + layout.margin * 2
    };
    return layout;
  }

  function dcpPrintTextLayout(object, boxWidth, boxHeight, fontStack) {
    const configuredMax = clampDcpNumber(object && object.maxFontSize, 18, 320, 260);
    const measurementMax = Math.min(2048, Math.max(configuredMax, boxWidth * 4, boxHeight * 4));
    let low = 0.5;
    let high = measurementMax;
    let best = null;
    for (let index = 0; index < 15; index += 1) {
      const candidate = (low + high) / 2;
      const layout = dcpPrintTextLayoutAtFontSize(object, boxWidth, boxHeight, fontStack, candidate);
      const bounds = layout && (layout.fitBounds || layout.rawBounds);
      const fits = bounds
        && Number.isFinite(bounds.width)
        && Number.isFinite(bounds.height)
        && bounds.width + layout.margin * 2 <= boxWidth
        && bounds.height + layout.margin * 2 <= boxHeight;
      if (fits) {
        best = layout;
        low = candidate;
      } else {
        high = candidate;
      }
    }
    return best || dcpPrintTextLayoutAtFontSize(object, boxWidth, boxHeight, fontStack, 0.5);
  }

  function dcpDieTextLayout(object, boxWidth, boxHeight, fontStack) {
    const configuredMax = clampDcpNumber(object && object.maxFontSize, 18, 320, 260);
    const measurementMax = Math.min(2048, Math.max(configuredMax, boxWidth * 4, boxHeight * 4));
    const straight = normalizeDcpTextShape(object && object.textShape) === 'straight';
    let low = 0.5;
    let high = measurementMax;
    let best = null;
    for (let index = 0; index < 15; index += 1) {
      const candidate = (low + high) / 2;
      const layout = straight
        ? dcpStraightGlyphLayout(object.text, fontStack, candidate, boxWidth)
        : dcpArchedGlyphLayout(object, fontStack, candidate, boxWidth, boxHeight);
      const bounds = layout && layout.rawBounds;
      const fits = bounds
        && Number.isFinite(bounds.width)
        && Number.isFinite(bounds.height)
        && bounds.width + layout.margin * 2 <= boxWidth
        && bounds.height + layout.margin * 2 <= boxHeight;
      if (fits) {
        best = layout;
        low = candidate;
      } else {
        high = candidate;
      }
    }
    if (!best) {
      best = straight
        ? dcpStraightGlyphLayout(object.text, fontStack, 0.5, boxWidth)
        : dcpArchedGlyphLayout(object, fontStack, 0.5, boxWidth, boxHeight);
    }
    const bounds = best.rawBounds;
    const offsetX = (boxWidth - bounds.width) / 2 - bounds.left;
    const offsetY = (boxHeight - bounds.height) / 2 - bounds.top;
    best.offsetX = offsetX;
    best.offsetY = offsetY;
    best.paintBounds = {
      left: bounds.left + offsetX - best.margin,
      top: bounds.top + offsetY - best.margin,
      width: bounds.width + best.margin * 2,
      height: bounds.height + best.margin * 2
    };
    return best;
  }

  function dcpDieTextLayoutAtFontSize(object, boxWidth, boxHeight, fontStack, fontSize) {
    const straight = normalizeDcpTextShape(object && object.textShape) === 'straight';
    const layout = straight
      ? dcpStraightGlyphLayout(object.text, fontStack, fontSize, boxWidth)
      : dcpArchedGlyphLayout(object, fontStack, fontSize, boxWidth, boxHeight);
    if (!layout || !Number.isFinite(layout.rawBounds.width) || !Number.isFinite(layout.rawBounds.height)) return layout;
    layout.offsetX = (boxWidth - layout.rawBounds.width) / 2 - layout.rawBounds.left;
    layout.offsetY = (boxHeight - layout.rawBounds.height) / 2 - layout.rawBounds.top;
    layout.paintBounds = {
      left: layout.rawBounds.left + layout.offsetX - layout.margin,
      top: layout.rawBounds.top + layout.offsetY - layout.margin,
      width: layout.rawBounds.width + layout.margin * 2,
      height: layout.rawBounds.height + layout.margin * 2
    };
    return layout;
  }

  function dcpTextPaintBounds(element) {
    if (!element) return null;
    const left = Number(element.dataset.srdDcpPaintLeft);
    const top = Number(element.dataset.srdDcpPaintTop);
    const width = Number(element.dataset.srdDcpPaintWidth);
    const height = Number(element.dataset.srdDcpPaintHeight);
    return [left, top, width, height].every(Number.isFinite) && width > 0 && height > 0
      ? { left: left, top: top, width: width, height: height }
      : null;
  }

  function applyDcpTextPaintBounds(element, bounds) {
    if (!element || !bounds) return;
    element.dataset.srdDcpPaintLeft = bounds.left.toFixed(3);
    element.dataset.srdDcpPaintTop = bounds.top.toFixed(3);
    element.dataset.srdDcpPaintWidth = bounds.width.toFixed(3);
    element.dataset.srdDcpPaintHeight = bounds.height.toFixed(3);
    const outline = element.querySelector('[data-srd-dcp-text-selection-outline]');
    if (outline) {
      outline.style.left = bounds.left.toFixed(3) + 'px';
      outline.style.top = bounds.top.toFixed(3) + 'px';
      outline.style.width = bounds.width.toFixed(3) + 'px';
      outline.style.height = bounds.height.toFixed(3) + 'px';
    }
  }

  function dcpArchPathData(object, width, height) {
    const shape = normalizeDcpTextShape(object && object.textShape);
    const arc = clampDcpNumber(object && object.arcAmount, 0, 100, 35);
    const boxWidth = Math.max(1, Number(width) || 100);
    const boxHeight = Math.max(1, Number(height) || 100);
    const padX = Math.max(4, boxWidth * 0.08);
    const centerX = boxWidth / 2;
    const centerY = boxHeight * 0.52;
    let controlY;
    if (isDieCuttingMode()) {
      const geometry = dcpArchGeometry(object, boxWidth, boxHeight);
      return 'M ' + geometry.start.x.toFixed(2) + ' ' + geometry.start.y.toFixed(2)
        + ' Q ' + geometry.control.x.toFixed(2) + ' ' + geometry.control.y.toFixed(2)
        + ' ' + geometry.end.x.toFixed(2) + ' ' + geometry.end.y.toFixed(2);
    }
    const curve = Math.max(4, (arc / 100) * boxHeight * 0.42);
    controlY = shape === 'arch_down' ? centerY + curve : centerY - curve;
    return 'M ' + padX.toFixed(2) + ' ' + centerY.toFixed(2) + ' Q ' + centerX.toFixed(2) + ' ' + controlY.toFixed(2) + ' ' + (boxWidth - padX).toFixed(2) + ' ' + centerY.toFixed(2);
  }

  function scheduleDcpTextRefit(fontKey) {
    const entry = fontCatalogById[fontKey];
    if (!entry || entry.browserFormat !== 'woff2' || loadedDcpFontIds.has(fontKey) || failedDcpFontIds.has(fontKey) || pendingDcpFontRefits.has(fontKey)) return;
    const revision = dcpFontLoadRevision;
    const workspaceMode = activeDcpWorkspaceMode;
    const activationRevision = dcpModeActivationRevision;
    pendingDcpFontRefits.add(fontKey);
    ensureDcpFontReady(fontKey)
      .then(() => {
        if (revision !== dcpFontLoadRevision || !isCurrentDcpModeActivation(workspaceMode, activationRevision)) return;
        const boundaryAttachments = captureDcpDieTextBoundaryAttachments();
        const expectedHistoryPresent = cloneDcpHistoryValue(dcpHistory.present);
        invalidateAllDcpTextFits();
        window.requestAnimationFrame(() => {
          if (revision !== dcpFontLoadRevision || !isCurrentDcpModeActivation(workspaceMode, activationRevision)) return;
          if (!sameDcpHistorySnapshot(dcpHistory.present, expectedHistoryPresent)) return;
          fitDcpTextObjects();
          settleDcpDieTextPositionsAfterRefit(boundaryAttachments, expectedHistoryPresent);
          applyDcpObjectSelectionState();
        });
      })
      .catch(() => {})
      .finally(() => pendingDcpFontRefits.delete(fontKey));
  }

  function applyDcpArchedTextFontSize(element, text, fontSize) {
    const value = Math.max(0.5, Number(fontSize) || 0.5);
    element.style.setProperty('--srd-dcp-text-font-size', value.toFixed(3) + 'px');
    text.setAttribute('font-size', value.toFixed(3));
  }

  function dcpArchedTextMeasurementFits(element, text, path, fontSize, viewWidth, viewHeight) {
    applyDcpArchedTextFontSize(element, text, fontSize);
    try {
      const pathLength = path.getTotalLength();
      const textLength = text.getComputedTextLength();
      const bounds = text.getBBox();
      const tolerance = 0.75;
      return Number.isFinite(pathLength)
        && Number.isFinite(textLength)
        && pathLength > 0
        && textLength > 0
        && textLength <= pathLength - tolerance
        && bounds.x >= -tolerance
        && bounds.y >= -tolerance
        && bounds.x + bounds.width <= viewWidth + tolerance
        && bounds.y + bounds.height <= viewHeight + tolerance;
    } catch (_error) {
      return false;
    }
  }

  function dcpArchedTextFontSize(element, text, path, viewWidth, viewHeight) {
    const minSize = 0.5;
    const configuredMax = clampDcpNumber(element.dataset.srdDcpMaxFontSize, 18, 320, 260);
    let low = minSize;
    let high = configuredMax;
    let best = minSize;

    for (let index = 0; index < 12; index += 1) {
      const candidate = (low + high) / 2;
      if (dcpArchedTextMeasurementFits(element, text, path, candidate, viewWidth, viewHeight)) {
        best = candidate;
        low = candidate;
      } else {
        high = candidate;
      }
    }
    return Math.max(minSize, Math.floor(best * 100) / 100);
  }

  function renderDcpDieStraightTextLayout(element, layout, width, height) {
    const svg = element.querySelector('[data-srd-dcp-straight-text-svg]');
    const layer = svg && svg.querySelector('[data-srd-dcp-straight-text-layer]');
    if (!svg || !layer || !layout) return;
    svg.setAttribute('viewBox', '0 0 ' + width.toFixed(3) + ' ' + height.toFixed(3));
    layer.removeAttribute('transform');
    while (layer.firstChild) layer.removeChild(layer.firstChild);
    layout.lines.forEach((line) => {
      const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      const visibleWidth = Math.max(0.01, line.right - line.left);
      const x = (width - visibleWidth) / 2 - line.left;
      text.dataset.srdDcpTextValue = '';
      text.setAttribute('x', x.toFixed(3));
      text.setAttribute('y', (layout.offsetY + line.baseline).toFixed(3));
      text.setAttribute('font-size', layout.fontSize.toFixed(3));
      text.textContent = line.text;
      layer.appendChild(text);
    });
  }

  function renderDcpPrintStraightTextLayout(element, layout, width, height) {
    const svg = element.querySelector('[data-srd-dcp-straight-text-svg]');
    const layer = svg && svg.querySelector('[data-srd-dcp-straight-text-layer]');
    if (!svg || !layer || !layout) return;
    svg.setAttribute('viewBox', '0 0 ' + width.toFixed(3) + ' ' + height.toFixed(3));
    layer.removeAttribute('transform');
    while (layer.firstChild) layer.removeChild(layer.firstChild);
    layout.lines.forEach((line) => {
      const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      text.dataset.srdDcpTextValue = '';
      text.setAttribute('x', (layout.offsetX + line.x).toFixed(3));
      text.setAttribute('y', (layout.offsetY + line.baseline).toFixed(3));
      text.setAttribute('font-size', layout.fontSize.toFixed(3));
      text.setAttribute('xml:space', 'preserve');
      text.style.whiteSpace = 'pre';
      text.textContent = line.text;
      layer.appendChild(text);
    });
  }

  function applyDcpTextOutlineStyle(element, object) {
    if (!element) return;
    const enabled = Boolean(object && object.outlineEnabled && !isDieCuttingMode());
    const layout = element.__srdDcpTextLayout;
    const strokeWidth = enabled
      ? dcpTextOutlineStrokeWidth(object, layout && layout.fontSize)
      : 0;
    const strokeColor = dcpTextOutlineColor(object);
    element.dataset.srdDcpTextOutline = enabled ? 'on' : 'off';
    element.querySelectorAll('[data-srd-dcp-text-value], [data-srd-dcp-arched-glyph]').forEach((text) => {
      text.setAttribute('stroke', enabled ? strokeColor : 'none');
      text.setAttribute('stroke-width', enabled ? strokeWidth.toFixed(3) : '0');
      text.setAttribute('stroke-linejoin', 'round');
      text.setAttribute('paint-order', 'stroke fill');
    });
  }

  function renderDcpDieArchedTextLayout(element, layout, width, height) {
    const svg = element.querySelector('[data-srd-dcp-arched-text-svg]');
    const path = svg && svg.querySelector('[data-srd-dcp-arched-text-path]');
    const layer = svg && svg.querySelector('[data-srd-dcp-arched-glyph-layer]');
    if (!svg || !path || !layer || !layout) return;
    svg.setAttribute('viewBox', '0 0 ' + width.toFixed(3) + ' ' + height.toFixed(3));
    path.setAttribute('d', dcpArchPathData(
      normalizeDcpCanvasObjects(getDcpProofState().objects).textObjects.find((item) => item.id === element.dataset.srdDcpTextId) || {},
      width,
      height
    ));
    while (layer.firstChild) layer.removeChild(layer.firstChild);
    layer.removeAttribute('transform');
    layout.glyphs.forEach((glyph) => {
      const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      const x = glyph.x + layout.offsetX;
      const y = glyph.y + layout.offsetY;
      text.dataset.srdDcpArchedGlyph = '';
      text.setAttribute('x', x.toFixed(3));
      text.setAttribute('y', y.toFixed(3));
      text.setAttribute('font-size', layout.fontSize.toFixed(3));
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('transform', 'rotate(' + (glyph.angle * 180 / Math.PI).toFixed(3) + ' ' + x.toFixed(3) + ' ' + y.toFixed(3) + ')');
      text.textContent = glyph.text;
      layer.appendChild(text);
    });
  }

  function fitDcpPrintTextElement(element) {
    if (!element || element.hidden) return;
    const object = normalizeDcpCanvasObjects(getDcpProofState().objects).textObjects.find((item) => item.id === element.dataset.srdDcpTextId);
    if (!object || !String(object.text || '').trim()) return;
    const objectLayer = element.parentElement;
    const boxWidth = objectLayer && objectLayer.clientWidth
      ? objectLayer.clientWidth * clampDcpNumber(object.width, 1, 100, 1) / 100
      : element.clientWidth;
    const boxHeight = objectLayer && objectLayer.clientHeight
      ? objectLayer.clientHeight * clampDcpNumber(object.height, 1, 100, 1) / 100
      : element.clientHeight;
    if (!boxWidth || !boxHeight) return;
    const fontStack = fontStackFor(object.fontKey);
    scheduleDcpTextRefit(object.fontKey);
    let layout = dcpPrintTextLayout(object, boxWidth, boxHeight, fontStack);
    if (!layout) return;
    const render = () => {
      if (layout.type === 'straight') renderDcpPrintStraightTextLayout(element, layout, boxWidth, boxHeight);
      else renderDcpDieArchedTextLayout(element, layout, boxWidth, boxHeight);
    };
    render();
    element.__srdDcpTextLayout = layout;
    element.style.setProperty('--srd-dcp-text-font-size', layout.fontSize.toFixed(3) + 'px');
    applyDcpTextPaintBounds(element, layout.paintBounds);
    applyDcpTextOutlineStyle(element, object);
  }

  function fitDcpDieTextElement(element) {
    if (!element || element.hidden) return;
    const object = normalizeDcpCanvasObjects(getDcpProofState().objects).textObjects.find((item) => item.id === element.dataset.srdDcpTextId);
    if (!object || !String(object.text || '').trim()) return;
    const objectLayer = element.parentElement;
    const boxWidth = objectLayer && objectLayer.clientWidth
      ? objectLayer.clientWidth * clampDcpNumber(object.width, 1, 100, 1) / 100
      : element.clientWidth;
    const boxHeight = objectLayer && objectLayer.clientHeight
      ? objectLayer.clientHeight * clampDcpNumber(object.height, 1, 100, 1) / 100
      : element.clientHeight;
    if (!boxWidth || !boxHeight) return;
    const fontStack = fontStackFor(object.fontKey);
    const horizontalScale = dcpDieHorizontalScale(object);
    scheduleDcpTextRefit(object.fontKey);
    let layout = dcpDieTextLayout(object, boxWidth, boxHeight, fontStack);
    if (!layout) return;
    if (layout.type === 'straight') renderDcpDieStraightTextLayout(element, layout, boxWidth, boxHeight);
    else renderDcpDieArchedTextLayout(element, layout, boxWidth, boxHeight);
    let layer = element.querySelector('[data-srd-dcp-straight-text-layer], [data-srd-dcp-arched-glyph-layer]');
    let renderedBounds = null;
    try {
      renderedBounds = layer && layer.getBBox();
    } catch (_error) {
      renderedBounds = null;
    }
    if (renderedBounds && renderedBounds.width > 0 && renderedBounds.height > 0) {
      const renderedMargin = dcpMeasuredBoundsMargin(renderedBounds);
      const correction = Math.min(
        1,
        (boxWidth - renderedMargin * 2) / renderedBounds.width,
        (boxHeight - renderedMargin * 2) / renderedBounds.height
      );
      if (correction < 0.999) {
        layout = dcpDieTextLayoutAtFontSize(object, boxWidth, boxHeight, fontStack, Math.max(0.5, layout.fontSize * correction * 0.997));
        if (layout.type === 'straight') renderDcpDieStraightTextLayout(element, layout, boxWidth, boxHeight);
        else renderDcpDieArchedTextLayout(element, layout, boxWidth, boxHeight);
        layer = element.querySelector('[data-srd-dcp-straight-text-layer], [data-srd-dcp-arched-glyph-layer]');
        try {
          renderedBounds = layer && layer.getBBox();
        } catch (_error) {
          renderedBounds = null;
        }
      }
    }
    if (renderedBounds && renderedBounds.width > 0 && renderedBounds.height > 0 && layer) {
      const margin = dcpMeasuredBoundsMargin(renderedBounds);
      const translateX = boxWidth / 2 - (renderedBounds.x + renderedBounds.width / 2);
      const translateY = boxHeight / 2 - (renderedBounds.y + renderedBounds.height / 2);
      layer.setAttribute(
        'transform',
        'translate(' + (boxWidth / 2).toFixed(3) + ' ' + (boxHeight / 2).toFixed(3) + ') '
          + 'scale(' + horizontalScale.toFixed(6) + ' 1) '
          + 'translate(' + (-boxWidth / 2).toFixed(3) + ' ' + (-boxHeight / 2).toFixed(3) + ') '
          + 'translate(' + translateX.toFixed(3) + ' ' + translateY.toFixed(3) + ')'
      );
      layout.renderTranslateX = translateX;
      layout.renderTranslateY = translateY;
      layout.horizontalScale = horizontalScale;
      const scaledPaintWidth = renderedBounds.width * horizontalScale;
      layout.paintBounds = {
        left: (boxWidth - scaledPaintWidth) / 2 - margin,
        top: (boxHeight - renderedBounds.height) / 2 - margin,
        width: scaledPaintWidth + margin * 2,
        height: renderedBounds.height + margin * 2
      };
    }
    element.__srdDcpTextLayout = layout;
    element.style.setProperty('--srd-dcp-text-font-size', layout.fontSize.toFixed(3) + 'px');
    applyDcpTextPaintBounds(element, layout.paintBounds);
  }

  function fitDcpArchedTextElement(element) {
    if (!element || element.hidden) return;
    if (isDieCuttingMode()) {
      fitDcpDieTextElement(element);
      return;
    }
    const svg = element.querySelector('[data-srd-dcp-arched-text-svg]');
    const text = element.querySelector('[data-srd-dcp-arched-text-value]');
    const path = element.querySelector('[data-srd-dcp-arched-text-path]');
    if (!svg || !text || !path || !text.textContent.trim()) return;
    const wrapperRect = element.getBoundingClientRect();
    const wrapperStyle = getComputedStyle(element);
    const horizontalPadding = (Number.parseFloat(wrapperStyle.paddingLeft) || 0) + (Number.parseFloat(wrapperStyle.paddingRight) || 0);
    const verticalPadding = (Number.parseFloat(wrapperStyle.paddingTop) || 0) + (Number.parseFloat(wrapperStyle.paddingBottom) || 0);
    const viewWidth = Math.max(1, wrapperRect.width - horizontalPadding);
    const viewHeight = Math.max(1, wrapperRect.height - verticalPadding);
    const object = normalizeDcpCanvasObjects(getDcpProofState().objects).textObjects.find((item) => item.id === element.dataset.srdDcpTextId) || {};
    scheduleDcpTextRefit(object.fontKey);
    svg.setAttribute('viewBox', '0 0 ' + viewWidth.toFixed(2) + ' ' + viewHeight.toFixed(2));
    if (path) path.setAttribute('d', dcpArchPathData(object, viewWidth, viewHeight));
    const fontSize = dcpArchedTextFontSize(element, text, path, viewWidth, viewHeight);
    applyDcpArchedTextFontSize(element, text, fontSize);
  }

  function fitDcpTextElement(element) {
    if (isDieCuttingMode()) {
      fitDcpDieTextElement(element);
      return;
    }
    fitDcpPrintTextElement(element);
  }

  function dcpTextFitSignature(object, fontStack) {
    const physicalCanvas = isDieCuttingMode() ? dcpPhysicalCanvasForProof() : null;
    return [
      object && object.text ? object.text : '',
      object && object.fontKey ? object.fontKey : '',
      fontStack || '',
      object && Number.isFinite(Number(object.width)) ? Number(object.width).toFixed(3) : '',
      object && Number.isFinite(Number(object.height)) ? Number(object.height).toFixed(3) : '',
      object && Number.isFinite(Number(object.horizontalScale)) ? Number(object.horizontalScale).toFixed(6) : '1.000000',
      object && Number.isFinite(Number(object.maxFontSize)) ? Number(object.maxFontSize).toFixed(3) : '',
      normalizeDcpTextShape(object && object.textShape),
      object && Number.isFinite(Number(object.arcAmount)) ? Number(object.arcAmount).toFixed(3) : '',
      object && object.outlineEnabled ? 'outline-on' : 'outline-off',
      object && object.outlineColorKey ? object.outlineColorKey : '',
      object && object.outlineThicknessKey ? object.outlineThicknessKey : '',
      physicalCanvas ? Number(physicalCanvas.width).toFixed(3) : '',
      physicalCanvas ? Number(physicalCanvas.height).toFixed(3) : '',
      String(dcpWorkspaceRenderRevision)
    ].join('|');
  }

  function isDcpCartTestingLockout() {
    return isDieCuttingMode() && (!dcpDieVariantLookup.productId
      || !Object.keys(dcpDieVariantLookup.variantsByCents || {}).length);
  }

  function parseDcpDieProductData() {
    const element = root.querySelector('[data-srd-die-product-json]')
      || document.querySelector('[data-srd-die-product-json]');
    if (!element || !String(element.textContent || '').trim()) return null;
    try {
      const product = JSON.parse(element.textContent);
      return product && typeof product === 'object' ? product : null;
    } catch (error) {
      return null;
    }
  }

  function buildDcpDieVariantLookup(product) {
    const result = {
      ready: false,
      productId: '',
      handle: '',
      variantsByCents: {},
      failure: 'Custom Die development product setup is required.'
    };
    if (!product || String(product.handle || '') !== dcpDieProductHandle || !Array.isArray(product.variants)) return result;
    const productId = String(product.id || '');
    const variantsByCents = {};
    for (const variant of product.variants) {
      const sku = String(variant && variant.sku || '');
      const match = sku.match(/^SRD-DIE-UNIT-(\d{4})$/);
      const cents = Number(variant && variant.price);
      if (!match || !Number.isInteger(cents) || cents < 0 || Number(match[1]) !== cents || variantsByCents[cents]) continue;
      variantsByCents[cents] = {
        id: String(variant.id || ''),
        sku: sku,
        cents: cents,
        available: variant.available !== false
      };
    }
    // A catalog may legitimately omit price buckets that no certified DC composition
    // can use. The selected composition is still fail-closed below by requiring its
    // exact cents bucket and an available Shopify variant.
    if (!productId || !Object.keys(variantsByCents).length) return result;
    return {
      ready: true,
      productId: productId,
      handle: dcpDieProductHandle,
      variantsByCents: variantsByCents,
      failure: ''
    };
  }

  function dcpDieVariantForCents(cents) {
    return dcpDieVariantLookup.variantsByCents[String(Number(cents))]
      || dcpDieVariantLookup.variantsByCents[Number(cents)]
      || null;
  }

  function assertPrintDesignCommerceAllowed(activationRevision) {
    if (!isBlankCanvasMode(controls.template.value)
      || activeDcpWorkspaceMode !== 'print_design'
      || !dcpModeAllows('commerce', 'print_design')
      || (Number.isFinite(Number(activationRevision)) && dcpModeActivationRevision !== Number(activationRevision))) {
      throw new Error('The active Blank Canvas mode is not authorized for commerce.');
    }
  }

  function assertDieCuttingCommerceAllowed(activationRevision) {
    if (!isBlankCanvasMode(controls.template.value)
      || activeDcpWorkspaceMode !== 'die_cutting'
      || !dcpModeAllows('commerce', 'die_cutting')
      || !dcpDieVariantLookup.productId
      || !Object.keys(dcpDieVariantLookup.variantsByCents || {}).length
      || (Number.isFinite(Number(activationRevision)) && dcpModeActivationRevision !== Number(activationRevision))) {
      throw new Error(dcpDieVariantLookup.failure || 'The active Custom Die design is not authorized for commerce.');
    }
  }

  function syncDieCuttingCommerceFormLock(locked) {
    if (!targets.cartForm) return;
    Array.from(targets.cartForm.elements || []).forEach((element) => {
      if (!element || !element.name) return;
      const commerceField = element.name === 'id'
        || element.name === 'quantity'
        || element.name.indexOf('properties[') === 0;
      if (!commerceField) return;
      if (locked) {
        if (!Object.prototype.hasOwnProperty.call(element.dataset, 'srdDieCuttingWasDisabled')) {
          element.dataset.srdDieCuttingWasDisabled = element.disabled ? 'true' : 'false';
        }
        element.disabled = true;
        return;
      }
      if (!Object.prototype.hasOwnProperty.call(element.dataset, 'srdDieCuttingWasDisabled')) return;
      element.disabled = element.dataset.srdDieCuttingWasDisabled === 'true';
      delete element.dataset.srdDieCuttingWasDisabled;
    });
  }

  function dcpDieTierCharge(value, tiers) {
    const amount = Number(value);
    const match = tiers.find((tier) => amount <= tier[0] + 0.000001);
    return match ? match[1] : tiers[tiers.length - 1][1];
  }

  function dcpDiePricingFor(width, height, colorKeys, quantity, textObjectCount) {
    const safeWidth = clampDcpNumber(width, dcpPhysicalCanvasLimits.width.min, dcpPhysicalCanvasLimits.width.max, dcpPhysicalCanvasDefaults.width);
    const safeHeight = clampDcpNumber(height, dcpPhysicalCanvasLimits.height.min, activeDcpCatalogArtwork ? 12 : dcpPhysicalCanvasLimits.height.max, dcpPhysicalCanvasDefaults.height);
    const requestedColorKeys = Array.isArray(colorKeys) ? colorKeys : [colorKeys];
    const safeColorKeys = Array.from(new Set(requestedColorKeys.map(authorizedDcpDieVinylColorKey).filter(Boolean)));
    const widthChargeCents = dcpDieTierCharge(safeWidth, dcpDiePricing.widthTiers);
    const heightChargeCents = dcpDieTierCharge(safeHeight, dcpDiePricing.heightTiers);
    let vinylSurchargeCents = 0;
    if (safeColorKeys.indexOf('reflective_white') !== -1) {
      vinylSurchargeCents = dcpDieTierCharge(safeWidth * safeHeight, dcpDiePricing.reflectiveAreaTiers);
    } else if (safeColorKeys.some((colorKey) => dcpDiePricing.standardColors.indexOf(colorKey) !== -1)) {
      vinylSurchargeCents = dcpDiePricing.standardColorCents;
    }
    const additionalText = dcpDieAdditionalTextPricing(safeHeight, textObjectCount);
    const totalCents = dcpDiePricing.baseCents + widthChargeCents + heightChargeCents
      + vinylSurchargeCents + additionalText.surcharge_cents;
    const finishedQuantity = Number.isInteger(Number(quantity)) && Number(quantity) > 0 ? Number(quantity) : 0;
    const variant = dcpDieVariantForCents(totalCents);
    const enforcementReady = Boolean(additionalText.valid && dcpDieVariantLookup.productId
      && variant && variant.id && variant.available && variant.cents === totalCents);
    return {
      ready: true,
      enforcement_ready: enforcementReady,
      enforcement_failure: enforcementReady
        ? ''
        : (!additionalText.valid
            ? dcpDieTextObjectAllowanceMessage(safeHeight, additionalText.object_count)
            : (dcpDieVariantLookup.failure || 'No exact Shopify Custom Die price variant is configured.')),
      pricing_model: 'Custom Die Shopify exact-unit-price variants v2',
      width: safeWidth,
      height: safeHeight,
      color_key: safeColorKeys[0] || '',
      color_keys: safeColorKeys,
      color_label: safeColorKeys.length
        ? safeColorKeys.map((colorKey) => dcpDieVinylColorDescriptor(colorKey).label).join(', ')
        : '\u2014',
      base_cents: dcpDiePricing.baseCents,
      width_charge_cents: widthChargeCents,
      height_charge_cents: heightChargeCents,
      vinyl_surcharge_cents: vinylSurchargeCents,
      text_object_count: additionalText.object_count,
      included_text_object_count: additionalText.object_count ? 1 : 0,
      additional_text_object_count: additionalText.additional_object_count,
      additional_text_unit_cents: additionalText.unit_cents,
      additional_text_surcharge_cents: additionalText.surcharge_cents,
      total_cents: totalCents,
      unit_price_cents: totalCents,
      finished_price_cents: finishedQuantity ? totalCents * finishedQuantity : 0,
      subtotal_display: finishedQuantity ? money(totalCents * finishedQuantity / 100) : money(totalCents / 100),
      base_package_price: dcpDiePricing.baseCents / 100,
      default_quantity: 1,
      minimum_package_qty: 1,
      extra_piece_count: 0,
      extra_piece_price: 0,
      extra_piece_variant_id: variant ? variant.id : '',
      surcharge_key: 'die-unit-' + String(totalCents).padStart(4, '0'),
      additional_charge: (vinylSurchargeCents + additionalText.surcharge_cents) / 100,
      lamination_add_on: 0,
      quantity: finishedQuantity,
      variant_id: variant ? variant.id : '',
      variant_sku: variant ? variant.sku : '',
      subtotal: finishedQuantity ? totalCents * finishedQuantity / 100 : totalCents / 100
    };
  }

  function dieCuttingDevelopmentPricing() {
    const proof = normalizeDcpDieObjectColors(getDcpProofState());
    const canvas = normalizeDcpPhysicalCanvas(proof.physicalCanvas);
    const objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
    const catalogEnvelope = activeDcpCatalogArtwork ? dcArtEnvelope() : null;
    if (activeDcpCatalogArtwork) {
      // Physical DC Library artwork is priced by its explicitly selected,
      // certified artwork size. Text labor is a separate production charge;
      // text placement must not promote a 6/8/10/12-inch artwork to a higher
      // artwork-price tier.
      const selectedArtworkSize = Number(proof.catalogArtwork && proof.catalogArtwork.nominalSize);
      const tier = dcpDcArtSupportedSizes.includes(selectedArtworkSize)
        && selectedArtworkSize === Number(activeDcpCatalogArtwork.nominalSize)
        ? selectedArtworkSize
        : null;
      const complexity = String(activeDcpCatalogArtwork.record.complexityTier || '').toLowerCase();
      const textCount = objects.textObjects.length;
      const baseCents = tier && dcpDcArtBasePriceCents[complexity]
        ? dcpDcArtBasePriceCents[complexity][tier]
        : 0;
      const laborUnitCents = catalogEnvelope && catalogEnvelope.height >= 6 ? 600 : 400;
      const totalCents = baseCents + textCount * laborUnitCents;
      const variant = dcpDieVariantForCents(totalCents);
      const configurationReady = Boolean(tier && baseCents && textCount >= 1 && textCount <= 3);
      const enforcementReady = Boolean(configurationReady && dcpDieVariantLookup.productId
        && variant && variant.id && variant.available && variant.cents === totalCents);
      const quantity = Number.isInteger(Number(normalizedQuantity())) && Number(normalizedQuantity()) > 0 ? Number(normalizedQuantity()) : 0;
      return {
        ready: true,
        enforcement_ready: enforcementReady,
        enforcement_failure: enforcementReady ? ''
          : (!tier ? 'The finished DC Library composition exceeds the certified 12-inch size limit.'
            : (!baseCents ? 'The selected DC Library artwork complexity tier is not certified for pricing.'
              : (textCount < 1 ? 'Add at least one text object to order DC Library artwork plus text.'
                : (textCount > 3 ? 'DC Library artwork supports a maximum of three text objects.'
                  : (dcpDieVariantLookup.failure || 'No exact Shopify DC Art Library price variant is configured.'))))),
        pricing_model: 'DC Art Library exact-unit-price variants v1',
        width: catalogEnvelope ? catalogEnvelope.width : canvas.width,
        height: catalogEnvelope ? catalogEnvelope.height : canvas.height,
        color_key: authorizedDcpDieVinylColorKey(proof.dieVinylColorKey) || '',
        color_keys: dcpDieUsedVinylColorKeys(objects, proof),
        color_label: dcpDieVinylColorsLabel(objects, proof),
        base_cents: baseCents,
        width_charge_cents: 0,
        height_charge_cents: 0,
        vinyl_surcharge_cents: 0,
        text_object_count: textCount,
        included_text_object_count: 0,
        additional_text_object_count: textCount,
        additional_text_unit_cents: laborUnitCents,
        additional_text_surcharge_cents: textCount * laborUnitCents,
        total_cents: totalCents,
        unit_price_cents: totalCents,
        finished_price_cents: quantity ? totalCents * quantity : 0,
        subtotal_display: quantity ? money(totalCents * quantity / 100) : money(totalCents / 100),
        base_package_price: baseCents / 100,
        default_quantity: 1,
        minimum_package_qty: 1,
        extra_piece_count: 0,
        extra_piece_price: 0,
        extra_piece_variant_id: '',
        surcharge_key: 'dc-art-' + complexity + '-' + String(tier || '') + '-' + textCount + '-' + (laborUnitCents === 600 ? '6plus' : 'under6'),
        additional_charge: textCount * laborUnitCents / 100,
        lamination_add_on: 0,
        quantity: quantity,
        variant_id: variant ? variant.id : '',
        variant_sku: variant ? variant.sku : '',
        subtotal: quantity ? totalCents * quantity / 100 : totalCents / 100,
        dc_art_complexity_tier: complexity,
        dc_art_price_tier_inches: tier || '',
        dc_art_text_labor_unit_cents: laborUnitCents
      };
    }
    const pricingWidth = catalogEnvelope && !catalogEnvelope.blocked ? catalogEnvelope.width : canvas.width;
    const pricingHeight = catalogEnvelope && !catalogEnvelope.blocked ? catalogEnvelope.height : canvas.height;
    return dcpDiePricingFor(
      pricingWidth,
      pricingHeight,
      dcpDieUsedVinylColorKeys(objects, proof),
      normalizedQuantity(),
      objects.textObjects.length
    );
  }

  function dieCuttingDevelopmentVariantSelection(pricing) {
    const variant = pricing && dcpDieVariantForCents(pricing.total_cents);
    const ready = Boolean(pricing && pricing.enforcement_ready && variant);
    return {
      ready: ready,
      available: Boolean(variant && variant.available),
      variant_id: variant ? variant.id : '',
      sku: variant ? variant.sku : '',
      source: ready ? 'custom_die_product_picker_exact_price' : 'custom_die_product_setup_required',
      price: variant ? variant.cents / 100 : NaN,
      price_display: variant ? money(variant.cents / 100) : '',
      product_id: dcpDieVariantLookup.productId
    };
  }

  function fitDcpTextObjects() {
    if (!isBlankCanvasMode(controls.template.value) || !targets.dcpTextLayer) return;
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    Array.from(targets.dcpTextLayer.querySelectorAll('[data-srd-dcp-text-id]')).forEach((element) => {
      const object = objects.textObjects.find((item) => item.id === element.dataset.srdDcpTextId);
      if (!object) return;
      const content = element.querySelector('[data-srd-dcp-text-content], [data-srd-dcp-straight-text-svg], [data-srd-dcp-arched-text-svg]');
      const fitSignature = dcpTextFitSignature(object, content ? content.style.fontFamily : '');
      if (element.dataset.srdDcpFitSignature === fitSignature) return;
      fitDcpTextElement(element);
      element.dataset.srdDcpFitSignature = fitSignature;
    });
    if (isDieCuttingMode()) syncDcpDiePaintedGeometry(objects);
  }

  function hasWritableArea(config) {
    return config && config.writable_area_center_x !== null && config.writable_area_center_y !== null;
  }

  function applyTemplateGeometry(message, config) {
    if (!message || !hasWritableArea(config)) return false;

    message.style.top = config.writable_area_center_y + '%';
    message.style.left = config.writable_area_center_x + '%';
    message.style.width = config.writable_area_width + '%';
    message.style.height = config.writable_area_height + '%';
    message.style.padding = config.default_padding + '%';
    message.style.justifyItems = config.default_horizontal_alignment || 'center';
    message.style.alignItems = config.default_vertical_alignment || 'center';
    message.style.transform = 'translate(-50%, -50%)';

    return true;
  }

  function blankCanvasTextConfig(objects) {
    const textArea = blankCanvasCalibration.text_area || {};
    const object = objects && objects.id ? objects : defaultDcpTextObject();
    return {
      writable_area_center_x: object.x,
      writable_area_center_y: object.y,
      writable_area_width: object.width,
      writable_area_height: object.height,
      default_horizontal_alignment: textArea.horizontal_alignment || 'center',
      default_vertical_alignment: textArea.vertical_alignment || 'center',
      default_padding: isDieCuttingMode() ? 0 : (Number.isFinite(Number(textArea.padding)) ? Number(textArea.padding) : 1)
    };
  }

  function dcpObjectElement(type) {
    if (type === 'artwork') return targets.blankCanvasArtwork;
    if (type === 'header') return targets.dcpHeaderObject;
    if (type === 'shape') return targets.dcpShapeObject;
    if (dcpObjectType(type) === 'symbol') {
      const symbolId = dcpObjectId(type);
      return symbolId && targets.dcpSymbolLayer ? targets.dcpSymbolLayer.querySelector('[data-srd-dcp-symbol-id="' + symbolId + '"]') : null;
    }
    const id = dcpObjectType(type) === 'text' ? dcpObjectId(type) : type;
    return id && targets.dcpTextLayer ? targets.dcpTextLayer.querySelector('[data-srd-dcp-text-id="' + id + '"]') : null;
  }

  function dcpVisibleLayerOrder(objects, proof) {
    const normalized = normalizeDcpCanvasObjects(objects || getDcpProofState().objects);
    const currentProof = proof || getDcpProofState();
    return normalized.layerOrder.filter((selection) => {
      const type = dcpObjectType(selection);
      if (type === 'artwork') return dcpProofHasArtwork(currentProof);
      if (type === 'header') return Boolean(normalized.header);
      if (type === 'shape') return Boolean(normalized.shape);
      if (type === 'symbol') return normalized.symbolObjects.some((item) => item.id === dcpObjectId(selection));
      if (type === 'text') return normalized.textObjects.some((item) => item.id === dcpObjectId(selection));
      return false;
    });
  }

  function applyDcpPrintableLayerOrder(objects) {
    const proof = getDcpProofState();
    const normalized = normalizeDcpCanvasObjects(objects || proof.objects);
    normalized.layerOrder.forEach((selection, index) => {
      const element = dcpObjectElement(selection);
      if (!element) return;
      const zIndex = 10 + index * 3;
      element.style.zIndex = String(zIndex);
      element.dataset.srdDcpLayerIndex = String(index);
      if (selection === 'artwork' && targets.blankCanvasArtworkHit) {
        targets.blankCanvasArtworkHit.style.zIndex = String(zIndex + 1);
        targets.blankCanvasArtworkHit.dataset.srdDcpLayerIndex = String(index);
      }
    });
  }

  function hasVisibleDcpObject(type) {
    const element = dcpObjectElement(type);
    if (!element || element.hidden) return false;
    if (dcpObjectType(type) === 'artwork' || type === 'artwork') return Boolean(element.getAttribute('src'));
    if (dcpObjectType(type) === 'header' || type === 'header') return Boolean(targets.dcpHeaderImage && targets.dcpHeaderImage.getAttribute('src'));
    if (dcpObjectType(type) === 'shape' || type === 'shape') return Boolean(targets.dcpShapeSvg && targets.dcpShapeSvg.firstElementChild);
    if (dcpObjectType(type) === 'symbol') {
      const image = element.querySelector('[data-srd-dcp-symbol-image]');
      return Boolean(image && image.getAttribute('src'));
    }
    const content = element.querySelector('[data-srd-dcp-text-content]');
    const text = element.querySelector('[data-srd-dcp-text-value]');
    const archedText = element.querySelector('[data-srd-dcp-arched-text-path-ref]');
    const dieText = Array.from(element.querySelectorAll('[data-srd-dcp-straight-text-svg] text, [data-srd-dcp-arched-glyph]'))
      .find((node) => node.textContent.trim());
    return Boolean((text || content || archedText || dieText) && (text || content || archedText || dieText).textContent.trim());
  }

  function selectDcpObject(type) {
    const selection = type === 'artwork' || type === 'header' || type === 'shape' || dcpObjectType(type) === 'text' || dcpObjectType(type) === 'symbol' ? type : null;
    setDcpObjectSelection(selection ? [selection] : [], selection);
  }

  function dcpCatalogArtworkFrame(image, create) {
    const parent = image && image.parentElement;
    if (!image || !parent) return null;
    if (parent.classList.contains('srd-dcp-artwork-frame')) return parent;
    if (!create) return null;
    const frame = document.createElement('div');
    frame.className = 'srd-dcp-artwork-frame';
    frame.setAttribute('aria-hidden', 'true');
    frame.style.position = 'absolute';
    frame.style.overflow = 'hidden';
    frame.style.pointerEvents = 'none';
    parent.insertBefore(frame, image);
    frame.appendChild(image);
    return frame;
  }

  function restoreDcpArtworkFrame(image) {
    const frame = dcpCatalogArtworkFrame(image, false);
    if (!frame || !frame.parentElement) return;
    frame.parentElement.insertBefore(image, frame);
    frame.remove();
  }

  function dcpCatalogArtworkAlphaBounds(image) {
    const source = image.currentSrc || image.src || '';
    if (!image.complete || !image.naturalWidth || !image.naturalHeight) return null;
    if (image._srdDcAlphaBounds && image._srdDcAlphaBounds.source === source) return image._srdDcAlphaBounds;
    try {
      const canvas = document.createElement('canvas');
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(image, 0, 0);
      const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
      let left = canvas.width;
      let top = canvas.height;
      let right = -1;
      let bottom = -1;
      for (let y = 0; y < canvas.height; y += 1) {
        for (let x = 0; x < canvas.width; x += 1) {
          if (pixels[(y * canvas.width + x) * 4 + 3] > 8) {
            left = Math.min(left, x);
            top = Math.min(top, y);
            right = Math.max(right, x);
            bottom = Math.max(bottom, y);
          }
        }
      }
      if (right < left || bottom < top) return null;
      image._srdDcAlphaBounds = { source: source, left: left, top: top, width: right - left + 1, height: bottom - top + 1, sourceWidth: canvas.width, sourceHeight: canvas.height };
      return image._srdDcAlphaBounds;
    } catch (error) {
      return null;
    }
  }

  function applyDcpCatalogArtworkCrop(image) {
    const bounds = dcpCatalogArtworkAlphaBounds(image);
    image.style.position = 'absolute';
    image.style.inset = 'auto';
    image.style.transform = 'none';
    image.style.objectFit = 'fill';
    if (!bounds) {
      image.style.left = '0';
      image.style.top = '0';
      image.style.width = '100%';
      image.style.height = '100%';
      return;
    }
    image.style.left = (-bounds.left / bounds.width * 100) + '%';
    image.style.top = (-bounds.top / bounds.height * 100) + '%';
    image.style.width = (bounds.sourceWidth / bounds.width * 100) + '%';
    image.style.height = (bounds.sourceHeight / bounds.height * 100) + '%';
  }
  function updateDcpArtworkHitTarget() {
    const image = targets.blankCanvasArtwork;
    const hitTarget = targets.blankCanvasArtworkHit;
    const container = targets.blankCanvasPreview;
    const hideHitTarget = () => {
      if (!hitTarget) return;
      hitTarget.hidden = true;
      ['left', 'top', 'width', 'height'].forEach((property) => hitTarget.style.removeProperty(property));
    };
    const visual = activeDcpCatalogArtwork ? dcpCatalogArtworkFrame(image, false) : image;
    if (!image || !visual || !hitTarget || !container || image.hidden || !image.getAttribute('src') || !image.complete || !image.naturalWidth || !image.naturalHeight) {
      hideHitTarget();
      return;
    }
    const imageRect = visual.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    if (!imageRect.width || !imageRect.height || !containerRect.width || !containerRect.height) {
      hideHitTarget();
      return;
    }
    const catalogArtwork = Boolean(activeDcpCatalogArtwork);
    const containScale = Math.min(imageRect.width / image.naturalWidth, imageRect.height / image.naturalHeight);
    const contentWidth = catalogArtwork ? imageRect.width : image.naturalWidth * containScale;
    const contentHeight = catalogArtwork ? imageRect.height : image.naturalHeight * containScale;
    const contentLeft = catalogArtwork ? imageRect.left : imageRect.left + (imageRect.width - contentWidth) / 2;
    const contentTop = catalogArtwork ? imageRect.top : imageRect.top + (imageRect.height - contentHeight) / 2;
    hitTarget.style.left = ((contentLeft - containerRect.left) / containerRect.width * 100) + '%';
    hitTarget.style.top = ((contentTop - containerRect.top) / containerRect.height * 100) + '%';
    hitTarget.style.width = (contentWidth / containerRect.width * 100) + '%';
    hitTarget.style.height = (contentHeight / containerRect.height * 100) + '%';
    hitTarget.hidden = false;
  }
  function applyDcpCatalogArtworkColorFilter(element, colorKey) {
    if (!element) return;
    const namespace = 'http://www.w3.org/2000/svg';
    const filterId = 'SRDDcArtworkCanonicalColor';
    let filter = document.getElementById(filterId);
    if (!filter) {
      const svg = document.createElementNS(namespace, 'svg');
      svg.setAttribute('width', '0');
      svg.setAttribute('height', '0');
      svg.setAttribute('aria-hidden', 'true');
      svg.style.position = 'absolute';
      svg.style.pointerEvents = 'none';
      const defs = document.createElementNS(namespace, 'defs');
      filter = document.createElementNS(namespace, 'filter');
      filter.setAttribute('id', filterId);
      filter.setAttribute('x', '0');
      filter.setAttribute('y', '0');
      filter.setAttribute('width', '100%');
      filter.setAttribute('height', '100%');
      const flood = document.createElementNS(namespace, 'feFlood');
      flood.setAttribute('result', 'canonicalColor');
      const composite = document.createElementNS(namespace, 'feComposite');
      composite.setAttribute('in', 'canonicalColor');
      composite.setAttribute('in2', 'SourceAlpha');
      composite.setAttribute('operator', 'in');
      filter.append(flood, composite);
      defs.appendChild(filter);
      svg.appendChild(defs);
      root.appendChild(svg);
    }
    const descriptor = dcpDieVinylColorDescriptor(colorKey);
    const flood = filter.querySelector('feFlood');
    if (flood) flood.setAttribute('flood-color', descriptor.value);
    element.style.filter = 'url("#' + filterId + '")';
    element.dataset.srdCanonicalVinylColor = descriptor.key;
    element.dataset.srdCanonicalVinylHex = descriptor.value;
  }

  function applyDcpArtworkObjectStyle(objects) {
    if (!targets.blankCanvasArtwork) return;
    const image = targets.blankCanvasArtwork;
    const object = normalizeDcpCanvasObjects(objects).artwork;
    if (activeDcpCatalogArtwork) {
      const frame = dcpCatalogArtworkFrame(image, true);
      frame.style.left = object.x + '%';
      frame.style.top = object.y + '%';
      frame.style.width = object.width + '%';
      frame.style.height = object.height + '%';
      frame.style.transform = 'translate(-50%, -50%) rotate(' + clampDcpNumber(object.rotation, -180, 180, 0) + 'deg)';
      frame.style.zIndex = '10';
      applyDcpCatalogArtworkCrop(image);
      const colorKey = authorizedDcpDieVinylColorKey(getDcpProofState().dieVinylColorKey) || 'white';
      applyDcpCatalogArtworkColorFilter(image, colorKey);
    } else {
      restoreDcpArtworkFrame(image);
      image.style.inset = 'auto';
      image.style.left = object.x + '%';
      image.style.top = object.y + '%';
      image.style.width = object.width + '%';
      image.style.height = object.height + '%';
      image.style.transform = 'translate(-50%, -50%) rotate(' + clampDcpNumber(object.rotation, -180, 180, 0) + 'deg)';
      image.style.removeProperty('object-fit');
      image.style.removeProperty('filter');
      delete image.dataset.srdCanonicalVinylColor;
      delete image.dataset.srdCanonicalVinylHex;
    }
    updateDcpArtworkHitTarget();
  }
  function applyDcpHeaderObjectStyle(objects) {
    if (!targets.dcpHeaderObject || !targets.dcpHeaderImage) return;
    const header = normalizeDcpCanvasObjects(objects).header;
    if (!header) {
      targets.dcpHeaderObject.hidden = true;
      targets.dcpHeaderImage.removeAttribute('src');
      return;
    }
    const catalogItem = dcpHeaderCatalogByKey[header.libraryKey];
    if (!catalogItem || !catalogItem.src) {
      targets.dcpHeaderObject.hidden = true;
      targets.dcpHeaderImage.removeAttribute('src');
      return;
    }
    targets.dcpHeaderObject.style.left = header.x + '%';
    targets.dcpHeaderObject.style.top = header.y + '%';
    targets.dcpHeaderObject.style.width = header.width + '%';
    targets.dcpHeaderObject.style.height = header.height + '%';
    targets.dcpHeaderObject.style.transform = 'translate(-50%, -50%)';
    if (targets.dcpHeaderImage.getAttribute('src') !== catalogItem.src) targets.dcpHeaderImage.src = catalogItem.src;
    targets.dcpHeaderImage.alt = header.label + ' header';
    targets.dcpHeaderObject.hidden = false;
  }

  function applyDcpShapeObjectStyle(objects) {
    if (!targets.dcpShapeObject || !targets.dcpShapeSvg) return;
    const shape = normalizeDcpCanvasObjects(objects).shape;
    if (!shape || !isBlankCanvasMode(controls.template.value) || !dcpModeAllows('shape')) {
      targets.dcpShapeObject.hidden = true;
      while (targets.dcpShapeSvg.firstChild) targets.dcpShapeSvg.removeChild(targets.dcpShapeSvg.firstChild);
      return;
    }
    targets.dcpShapeObject.style.left = shape.x + '%';
    targets.dcpShapeObject.style.top = shape.y + '%';
    targets.dcpShapeObject.style.width = shape.width + '%';
    targets.dcpShapeObject.style.height = shape.height + '%';
    targets.dcpShapeObject.style.transform = 'translate(-50%, -50%) rotate(' + clampDcpNumber(shape.rotation, -180, 180, 0) + 'deg)';
    targets.dcpShapeObject.hidden = false;
    const rect = targets.dcpShapeObject.getBoundingClientRect();
    renderDcpShapeSvg(targets.dcpShapeSvg, shape, rect.width, rect.height);
  }

  function applyDcpSymbolImageCrop(image, object) {
    const bounds = object.contentBounds;
    const contentWidth = bounds[2] - bounds[0];
    const contentHeight = bounds[3] - bounds[1];
    image.style.width = object.pixelWidth / contentWidth * 100 + '%';
    image.style.height = object.pixelHeight / contentHeight * 100 + '%';
    image.style.left = -bounds[0] / contentWidth * 100 + '%';
    image.style.top = -bounds[1] / contentHeight * 100 + '%';
  }

  function syncDcpSymbolObjectElements(objects) {
    if (!targets.dcpSymbolLayer) return;
    const normalized = normalizeDcpCanvasObjects(objects);
    const eligible = isBlankCanvasMode(controls.template.value) && selectedBlankCanvasSubfamily() === 'print_design';
    if (!eligible) {
      targets.dcpSymbolLayer.replaceChildren();
      return;
    }
    Array.from(targets.dcpSymbolLayer.querySelectorAll('[data-srd-dcp-symbol-id]')).forEach((element) => {
      if (!normalized.symbolObjects.some((object) => object.id === element.dataset.srdDcpSymbolId)) element.remove();
    });
    normalized.symbolObjects.forEach((object) => {
      let element = targets.dcpSymbolLayer.querySelector('[data-srd-dcp-symbol-id="' + object.id + '"]');
      if (!element) {
        element = document.createElement('span');
        element.className = 'srd-designer-proof__dcp-symbol-object';
        element.dataset.srdDcpObject = 'symbol';
        element.dataset.srdDcpSymbolId = object.id;
        element.innerHTML = '<span class="srd-designer-proof__dcp-symbol-viewport"><img class="srd-designer-proof__dcp-symbol-image" alt="" draggable="false" data-srd-dcp-symbol-image></span><button type="button" class="srd-designer-proof__dcp-delete" data-srd-dcp-delete-symbol aria-label="Delete symbol object">&times;</button>';
        element.addEventListener('pointerdown', (event) => startDcpObjectInteraction(event, dcpSymbolSelection(object.id), 'move'));
        const deleteButton = element.querySelector('[data-srd-dcp-delete-symbol]');
        if (deleteButton) {
          deleteButton.addEventListener('pointerdown', (event) => event.stopPropagation());
          deleteButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            removeDcpSymbolObject(object.id);
          });
        }
        targets.dcpSymbolLayer.appendChild(element);
      }
      const image = element.querySelector('[data-srd-dcp-symbol-image]');
      element.style.left = object.x + '%';
      element.style.top = object.y + '%';
      element.style.width = object.width + '%';
      element.style.height = object.height + '%';
      element.style.transform = 'translate(-50%, -50%) rotate(' + object.rotation + 'deg)';
      element.style.zIndex = String(object.layer);
      if (image) {
        if (image.getAttribute('src') !== object.src) image.src = object.src;
        image.alt = object.displayTitle + ' symbol';
        applyDcpSymbolImageCrop(image, object);
        image.onerror = () => {
          element.hidden = true;
          if (targets.dcpSymbolActivationStatus) targets.dcpSymbolActivationStatus.textContent = object.displayTitle + ' could not be displayed.';
        };
      }
      element.hidden = false;
    });
  }

  function ensureDcpStraightTextMarkup(element) {
    const arched = element.querySelector('[data-srd-dcp-arched-text-svg]');
    const legacyContent = element.querySelector('[data-srd-dcp-text-content]');
    if (arched) arched.remove();
    if (legacyContent) legacyContent.remove();
    let svg = element.querySelector('[data-srd-dcp-straight-text-svg]');
    if (!svg) {
      svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.classList.add('srd-designer-proof__dcp-straight-text-svg');
      svg.dataset.srdDcpStraightTextSvg = '';
      svg.setAttribute('viewBox', '0 0 100 100');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.innerHTML = '<g data-srd-dcp-straight-text-layer></g>';
      element.insertBefore(svg, element.querySelector('[data-srd-dcp-text-selection-outline], [data-srd-dcp-delete-text]'));
    }
    return svg;
  }

  function ensureDcpArchedTextMarkup(element, object) {
    const existingStraight = element.querySelector('[data-srd-dcp-text-content]');
    if (existingStraight) existingStraight.remove();
    const existingStraightSvg = element.querySelector('[data-srd-dcp-straight-text-svg]');
    if (existingStraightSvg) existingStraightSvg.remove();
    let svg = element.querySelector('[data-srd-dcp-arched-text-svg]');
    if (svg && !svg.querySelector('[data-srd-dcp-arched-glyph-layer]')) {
      svg.remove();
      svg = null;
    }
    if (!svg) {
      svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.classList.add(isDieCuttingMode() ? 'srd-designer-proof__dcp-die-arched-text-svg' : 'srd-designer-proof__dcp-arched-text-svg');
      svg.dataset.srdDcpArchedTextSvg = '';
      svg.setAttribute('viewBox', '0 0 100 100');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.innerHTML = '<defs><path data-srd-dcp-arched-text-path /></defs><g data-srd-dcp-arched-glyph-layer></g>';
      element.insertBefore(svg, element.querySelector('[data-srd-dcp-text-selection-outline], [data-srd-dcp-delete-text]'));
    }
    const safeId = 'srd-dcp-arch-' + String(object.id || '').replace(/[^a-zA-Z0-9_-]/g, '-');
    const path = svg.querySelector('[data-srd-dcp-arched-text-path]');
    if (path) {
      path.setAttribute('id', safeId);
      path.setAttribute('fill', 'none');
    }
    return svg;
  }

  function syncDcpTextObjectElements(objects, fontStack, fontColorValue) {
    if (!targets.dcpTextLayer) return;
    const normalized = normalizeDcpCanvasObjects(objects);
    const existing = Array.from(targets.dcpTextLayer.querySelectorAll('[data-srd-dcp-text-id]'));
    existing.forEach((element) => {
      const id = element.dataset.srdDcpTextId;
      if (!normalized.textObjects.some((object) => object.id === id)) element.remove();
    });
    normalized.textObjects.forEach((object) => {
      let element = targets.dcpTextLayer.querySelector('[data-srd-dcp-text-id="' + object.id + '"]');
      if (!element) {
        element = document.createElement('span');
        element.className = 'srd-designer-proof__dcp-text-object';
        element.dataset.srdDcpObject = 'text';
        element.dataset.srdDcpTextId = object.id;
        element.innerHTML = '<span class="srd-designer-proof__dcp-text-content" data-srd-dcp-text-content><span class="srd-designer-proof__dcp-text-value" data-srd-dcp-text-value></span></span><span class="srd-designer-proof__dcp-text-selection-outline" data-srd-dcp-text-selection-outline></span><button type="button" class="srd-designer-proof__dcp-delete" data-srd-dcp-delete-text aria-label="Delete text object">&times;</button>';
        element.addEventListener('pointerdown', (event) => startDcpObjectInteraction(event, dcpTextSelection(object.id), 'move'));
        const deleteButton = element.querySelector('[data-srd-dcp-delete-text]');
        if (deleteButton) {
          deleteButton.addEventListener('pointerdown', (event) => event.stopPropagation());
          deleteButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            selectDcpObject(dcpTextSelection(object.id));
            deleteSelectedDcpTextObject();
          });
        }
        targets.dcpTextLayer.appendChild(element);
      }
      if (!element.querySelector('[data-srd-dcp-text-selection-outline]')) {
        const outline = document.createElement('span');
        outline.className = 'srd-designer-proof__dcp-text-selection-outline';
        outline.dataset.srdDcpTextSelectionOutline = '';
        element.insertBefore(outline, element.querySelector('[data-srd-dcp-delete-text]'));
      }
      const textShape = normalizeDcpTextShape(object.textShape);
      element.dataset.srdDcpTextShape = textShape;
      let content = null;
      let text = null;
      if (textShape === 'straight') {
        content = ensureDcpStraightTextMarkup(element);
      } else {
        content = ensureDcpArchedTextMarkup(element, object);
      }
      applyTemplateGeometry(element, blankCanvasTextConfig(object));
      element.style.transform = dcpTextObjectTransform(object);
      if (content) {
        const resolvedFontStack = fontStackFor(object.fontKey || (controls.font ? controls.font.value : '')) || fontStack;
        content.style.color = dcpTextColorValue(object.fontColorKey || (isDieCuttingMode() ? 'white' : selectedFontColor()), activeDcpWorkspaceMode) || fontColorValue;
        content.style.fontFamily = resolvedFontStack;
        content.style.setProperty('--srd-font-family', resolvedFontStack);
      }
      element.hidden = false;
      element.dataset.srdDcpMaxFontSize = String(object.maxFontSize || 260);
      const fitSignature = dcpTextFitSignature(object, content ? content.style.fontFamily : fontStack);
      if (element.dataset.srdDcpFitSignature !== fitSignature) {
        fitDcpTextElement(element);
        element.dataset.srdDcpFitSignature = fitSignature;
      }
    });
    syncDcpDiePaintedGeometry(normalized);
  }

  function dcpTextResizeHandlePositions(element, artboardRect) {
    const bounds = dcpTextPaintBounds(element);
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    const object = objects.textObjects.find((item) => item.id === element.dataset.srdDcpTextId);
    if (!bounds || !object || !artboardRect.width || !artboardRect.height) return null;
    const wrapperWidth = object.width / 100 * artboardRect.width;
    const wrapperHeight = object.height / 100 * artboardRect.height;
    const centerX = artboardRect.left + object.x / 100 * artboardRect.width;
    const centerY = artboardRect.top + object.y / 100 * artboardRect.height;
    const rotation = clampDcpNumber(object.rotation, -180, 180, 0) * Math.PI / 180;
    const cosine = Math.cos(rotation);
    const sine = Math.sin(rotation);
    const transformPoint = (x, y) => {
      const localX = x - wrapperWidth / 2;
      const localY = y - wrapperHeight / 2;
      return {
        x: centerX + localX * cosine - localY * sine,
        y: centerY + localX * sine + localY * cosine
      };
    };
    const left = bounds.left;
    const right = bounds.left + bounds.width;
    const top = bounds.top;
    const bottom = bounds.top + bounds.height;
    const centerLocalX = (left + right) / 2;
    const centerLocalY = (top + bottom) / 2;
    return {
      'top-left': transformPoint(left, top),
      left: transformPoint(left, centerLocalY),
      'bottom-left': transformPoint(left, bottom),
      right: transformPoint(right, centerLocalY),
      'top-right': transformPoint(right, top),
      'bottom-right': transformPoint(right, bottom),
      top: transformPoint(centerLocalX, top),
      bottom: transformPoint(centerLocalX, bottom)
    };
  }

  function updateDcpResizeHandle() {
    const handles = targets.dcpResizeHandles || [];
    if (selectedDcpObjects.length !== 1 || !handles.length || !targets.proofArtboard || !isBlankCanvasMode(controls.template.value) || !hasVisibleDcpObject(selectedDcpObject)) {
      handles.forEach((handle) => { handle.hidden = true; });
      return;
    }
    const element = dcpObjectElement(selectedDcpObject);
    const objectRect = element.getBoundingClientRect();
    const artboardRect = targets.proofArtboard.getBoundingClientRect();
    const textPositions = dcpObjectType(selectedDcpObject) === 'text'
      ? dcpTextResizeHandlePositions(element, artboardRect)
      : null;
    const symbolControls = dcpObjectType(selectedDcpObject) === 'symbol';
    const controlWidth = symbolControls ? Math.max(objectRect.width, 24) : objectRect.width;
    const controlHeight = symbolControls ? Math.max(objectRect.height, 24) : objectRect.height;
    const controlLeft = objectRect.left + objectRect.width / 2 - controlWidth / 2;
    const controlTop = objectRect.top + objectRect.height / 2 - controlHeight / 2;
    const controlRight = controlLeft + controlWidth;
    const controlBottom = controlTop + controlHeight;
    const positions = textPositions || {
      'top-left': { x: controlLeft, y: controlTop },
      left: { x: controlLeft, y: controlTop + controlHeight / 2 },
      'bottom-left': { x: controlLeft, y: controlBottom },
      right: { x: controlRight, y: controlTop + controlHeight / 2 },
      'top-right': { x: controlRight, y: controlTop },
      'bottom-right': { x: controlRight, y: controlBottom },
      top: { x: controlLeft + controlWidth / 2, y: controlTop },
      bottom: { x: controlLeft + controlWidth / 2, y: controlBottom }
    };
    const catalogArtworkSelected = Boolean(activeDcpCatalogArtwork && dcpObjectType(selectedDcpObject) === 'artwork');
    const allowedCatalogHandles = new Set(['top-left', 'top-right', 'bottom-left', 'bottom-right']);
    handles.forEach((handle) => {
      const key = handle.dataset.srdDcpResizeHandle || 'bottom-right';
      if (catalogArtworkSelected && !allowedCatalogHandles.has(key)) {
        handle.hidden = true;
        return;
      }
      const point = positions[key] || positions['bottom-right'];
      handle.hidden = false;
      handle.style.left = ((point.x - artboardRect.left) / artboardRect.width * 100) + '%';
      handle.style.top = ((point.y - artboardRect.top) / artboardRect.height * 100) + '%';
    });
  }

  function ensureDcpSelectionDeleteControl() {
    if (dcpSelectionDeleteControl && dcpSelectionDeleteControl.isConnected) return dcpSelectionDeleteControl;
    if (!targets.proofArtboard) return null;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'srd-designer-proof__dcp-delete srd-designer-proof__dcp-selection-delete';
    button.dataset.srdDcpSelectionDelete = '';
    button.setAttribute('aria-label', 'Delete selected object');
    button.innerHTML = '&times;';
    button.hidden = true;
    button.addEventListener('pointerdown', (event) => event.stopPropagation());
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      deleteSelectedDcpObject();
    });
    targets.proofArtboard.appendChild(button);
    dcpSelectionDeleteControl = button;
    return button;
  }

  function dcpSelectionControlGeometry(element, artboardRect) {
    const textPositions = dcpObjectType(selectedDcpObject) === 'text'
      ? dcpTextResizeHandlePositions(element, artboardRect)
      : null;
    const points = textPositions
      ? Object.values(textPositions)
      : (() => {
          const rect = element.getBoundingClientRect();
          return [
            { x: rect.left, y: rect.top },
            { x: rect.right, y: rect.top },
            { x: rect.right, y: rect.bottom },
            { x: rect.left, y: rect.bottom }
          ];
        })();
    if (!points.length || points.some((point) => !Number.isFinite(point.x) || !Number.isFinite(point.y))) return null;
    return {
      left: Math.min(...points.map((point) => point.x)),
      right: Math.max(...points.map((point) => point.x)),
      top: Math.min(...points.map((point) => point.y)),
      bottom: Math.max(...points.map((point) => point.y)),
      handlePoints: points
    };
  }

  function updateDcpSelectionDeleteControl() {
    const button = ensureDcpSelectionDeleteControl();
    const type = dcpObjectType(selectedDcpObject);
    const supported = type === 'text' || type === 'header' || type === 'shape' || type === 'symbol';
    if (!button || selectedDcpObjects.length !== 1 || !supported || !targets.proofArtboard
      || !isBlankCanvasMode(controls.template.value) || !hasVisibleDcpObject(selectedDcpObject)) {
      if (button) button.hidden = true;
      return;
    }
    const element = dcpObjectElement(selectedDcpObject);
    const artboardRect = targets.proofArtboard.getBoundingClientRect();
    const bounds = element && dcpSelectionControlGeometry(element, artboardRect);
    if (!bounds || !artboardRect.width || !artboardRect.height) {
      button.hidden = true;
      return;
    }
    const radius = typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 820px)').matches ? 22 : 16;
    const offset = 7;
    const minX = artboardRect.left + radius + 2;
    const maxX = artboardRect.right - radius - 2;
    const minY = artboardRect.top + radius + 2;
    const maxY = artboardRect.bottom - radius - 2;
    const candidates = [
      { x: bounds.right + radius + offset, y: bounds.top - radius - offset },
      { x: bounds.left - radius - offset, y: bounds.top - radius - offset },
      { x: bounds.right + radius + offset, y: bounds.bottom + radius + offset },
      { x: bounds.left - radius - offset, y: bounds.bottom + radius + offset },
      { x: bounds.right - radius - offset, y: bounds.top + radius + offset },
      { x: bounds.left + radius + offset, y: bounds.top + radius + offset }
    ];
    const positioned = candidates.map((candidate, index) => {
      const point = {
        x: Math.min(maxX, Math.max(minX, candidate.x)),
        y: Math.min(maxY, Math.max(minY, candidate.y))
      };
      const clampDistance = Math.hypot(point.x - candidate.x, point.y - candidate.y);
      const handleDistance = Math.min(...bounds.handlePoints.map((handle) => Math.hypot(point.x - handle.x, point.y - handle.y)));
      return {
        point: point,
        score: index * 2 + clampDistance * 4 + (handleDistance < 25 ? 1000 + (25 - handleDistance) * 20 : 0)
      };
    }).sort((a, b) => a.score - b.score)[0];
    button.style.left = ((positioned.point.x - artboardRect.left) / artboardRect.width * 100) + '%';
    button.style.top = ((positioned.point.y - artboardRect.top) / artboardRect.height * 100) + '%';
    button.hidden = false;
  }

  function applyDcpObjectSelectionState() {
    const proof = getDcpProofState();
    sanitizeDcpObjectSelection(proof.objects, proof);
    const blankCanvasMode = isBlankCanvasMode(controls.template.value);
    [targets.dcpShapeObject, targets.blankCanvasArtwork, targets.dcpHeaderObject]
      .concat(Array.from(targets.dcpTextLayer ? targets.dcpTextLayer.querySelectorAll('[data-srd-dcp-text-id]') : []))
      .concat(Array.from(targets.dcpSymbolLayer ? targets.dcpSymbolLayer.querySelectorAll('[data-srd-dcp-symbol-id]') : []))
      .forEach((element) => {
      if (!element) return;
      const type = element.dataset.srdDcpObject;
      const selection = type === 'artwork' || type === 'header' || type === 'shape'
        ? type
        : (type === 'symbol' ? dcpSymbolSelection(element.dataset.srdDcpSymbolId) : dcpTextSelection(element.dataset.srdDcpTextId));
      const selected = blankCanvasMode && selectedDcpObjects.includes(selection) && !element.hidden;
      const primary = selected && selection === selectedDcpObject;
      element.classList.toggle('is-dcp-selected', selected);
      element.classList.toggle('is-dcp-primary-selected', primary);
      element.classList.toggle('is-dcp-secondary-selected', selected && !primary);
      const deleteButton = element.querySelector ? element.querySelector('[data-srd-dcp-delete-text], [data-srd-dcp-delete-header], [data-srd-dcp-delete-shape], [data-srd-dcp-delete-symbol]') : null;
      if (deleteButton) deleteButton.hidden = true;
    });
    updateDcpResizeHandle();
    updateDcpSelectionDeleteControl();
    updateDcpMultiSelectControls();
    updateDcpAlignmentControls();
    updateDcpLayerControls();
  }

  function dcpLegacyObjectPositionConstraint(object, objectType) {
    if (objectType === 'artwork' || objectType === 'header' || objectType === 'shape' || objectType === 'symbol') {
      const halfWidth = Math.min(50, Math.max(0, Number(object && object.width) || 0) / 2);
      const halfHeight = Math.min(50, Math.max(0, Number(object && object.height) || 0) / 2);
      return {
        minX: halfWidth,
        maxX: 100 - halfWidth,
        minY: halfHeight,
        maxY: 100 - halfHeight
      };
    }
    return { minX: 4, maxX: 96, minY: 4, maxY: 96 };
  }

  function dcpObjectPositionConstraint(selection, object, proof, physicalSize) {
    const objectType = dcpObjectType(selection) || selection;
    if (objectType !== 'text' || !isDieCuttingMode()) {
      return dcpLegacyObjectPositionConstraint(object, objectType);
    }
    const x = Number(object && object.x);
    const y = Number(object && object.y);
    const bounds = dcpAlignmentObjectBounds(
      selection,
      object,
      proof || getDcpProofState(),
      physicalSize || activeDcpPhysicalSize()
    );
    if (![x, y].every(Number.isFinite) || !bounds) {
      return dcpLegacyObjectPositionConstraint(object, objectType);
    }
    const legacy = dcpLegacyObjectPositionConstraint(object, objectType);
    const painted = {
      minX: Math.max(0, x - bounds.left),
      maxX: Math.min(100, 100 - bounds.right + x),
      minY: Math.max(0, y - bounds.top),
      maxY: Math.min(100, 100 - bounds.bottom + y)
    };
    const xFeasible = [painted.minX, painted.maxX].every(Number.isFinite) && painted.minX <= painted.maxX;
    const yFeasible = [painted.minY, painted.maxY].every(Number.isFinite) && painted.minY <= painted.maxY;
    return {
      minX: xFeasible ? painted.minX : legacy.minX,
      maxX: xFeasible ? painted.maxX : legacy.maxX,
      minY: yFeasible ? painted.minY : legacy.minY,
      maxY: yFeasible ? painted.maxY : legacy.maxY,
      infeasibleX: !xFeasible,
      infeasibleY: !yFeasible
    };
  }

  function canonicalDcpObjectPosition(selection, object, values, proof, physicalSize) {
    const constraint = dcpObjectPositionConstraint(selection, object, proof, physicalSize);
    return {
      x: clampDcpNumber(values && values.x, constraint.minX, constraint.maxX, object.x),
      y: clampDcpNumber(values && values.y, constraint.minY, constraint.maxY, object.y),
      constraint: constraint
    };
  }

  function applyDcpObjectTransformValues(object, objectType, values, selection, proof, physicalSize, options) {
    if (objectType === 'header' || objectType === 'shape' || objectType === 'symbol') {
      if (typeof values.width !== 'undefined') object.width = clampDcpNumber(values.width, 4, 96, object.width);
      if (typeof values.height !== 'undefined') object.height = clampDcpNumber(values.height, 2, 96, object.height);
      if (objectType === 'symbol' && typeof values.rotation !== 'undefined') object.rotation = clampDcpNumber(values.rotation, -180, 180, object.rotation);
    } else {
      if ((objectType === 'artwork' || objectType === 'text') && typeof values.rotation !== 'undefined') object.rotation = clampDcpNumber(values.rotation, -180, 180, object.rotation || 0);
      if (typeof values.scale !== 'undefined') object.scale = clampDcpNumber(values.scale, objectType === 'artwork' ? 0.2 : 0.25, objectType === 'artwork' ? 3 : 2.5, object.scale);
      if (objectType === 'text' && isDieCuttingMode() && typeof values.horizontalScale !== 'undefined') {
        object.horizontalScale = clampDcpNumber(
          values.horizontalScale,
          dcpDieMinimumHorizontalScale,
          dcpDieMaximumHorizontalScale,
          object.horizontalScale || 1
        );
      }
      if (typeof values.width !== 'undefined') object.width = clampDcpNumber(values.width, 8, objectType === 'artwork' ? 120 : 96, object.width);
      if (typeof values.height !== 'undefined') object.height = clampDcpNumber(values.height, objectType === 'artwork' ? 8 : 5, objectType === 'artwork' ? 120 : 96, object.height);
    }
    if (typeof values.x !== 'undefined' || typeof values.y !== 'undefined') {
      const deferDieTextPositionConstraint = Boolean(
        options
        && options.deferDieTextPositionConstraint
        && objectType === 'text'
        && isDieCuttingMode()
      );
      if (deferDieTextPositionConstraint) {
        if (typeof values.x !== 'undefined') object.x = clampDcpNumber(values.x, -100, 200, object.x);
        if (typeof values.y !== 'undefined') object.y = clampDcpNumber(values.y, -100, 200, object.y);
        return;
      }
      const position = canonicalDcpObjectPosition(
        selection || objectType,
        object,
        {
          x: typeof values.x !== 'undefined' ? values.x : object.x,
          y: typeof values.y !== 'undefined' ? values.y : object.y
        },
        proof,
        physicalSize
      );
      if (typeof values.x !== 'undefined') object.x = position.x;
      if (typeof values.y !== 'undefined') object.y = position.y;
    }
  }

  function updateDcpObjectTransform(type, values, options) {
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const objectType = dcpObjectType(type) || type;
    const object = dcpObjectRecordForSelection(objects, type);
    if (!object) return objects;
    applyDcpObjectTransformValues(object, objectType, values, type, proof, activeDcpPhysicalSize(), options);
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    return objects;
  }

  function updateDcpObjectPositionSet(positionUpdates) {
    if (!Array.isArray(positionUpdates) || !positionUpdates.length) return false;
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const seen = new Set();
    const resolved = positionUpdates.map((update) => {
      const selection = update && update.selection;
      if (!selection || seen.has(selection) || validDcpHistorySelection(selection, objects, proof) !== selection) return null;
      const object = dcpObjectRecordForSelection(objects, selection);
      const requestedX = Number(update.x);
      const requestedY = Number(update.y);
      if (!object || !Number.isFinite(requestedX) || !Number.isFinite(requestedY)) return null;
      const position = canonicalDcpObjectPosition(
        selection,
        object,
        { x: requestedX, y: requestedY },
        proof,
        activeDcpPhysicalSize()
      );
      seen.add(selection);
      return {
        selection: selection,
        object: object,
        objectType: dcpObjectType(selection),
        x: position.x,
        y: position.y
      };
    });
    if (resolved.some((item) => !item)) return false;

    resolved.forEach((item) => {
      applyDcpObjectTransformValues(
        item.object,
        item.objectType,
        { x: item.x, y: item.y },
        item.selection,
        proof,
        activeDcpPhysicalSize()
      );
    });
    if (resolved.some((item) => !Number.isFinite(Number(item.object.x))
      || !Number.isFinite(Number(item.object.y))
      || Math.abs(Number(item.object.x) - item.x) > 0.000001
      || Math.abs(Number(item.object.y) - item.y) > 0.000001)) return false;

    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    return true;
  }

  function invalidateDcpTextFit(type) {
    if (dcpObjectType(type) !== 'text') return;
    const element = dcpObjectElement(type);
    if (element) delete element.dataset.srdDcpFitSignature;
  }

  function invalidateDcpTextPaintBounds(type) {
    if (dcpObjectType(type) !== 'text') return;
    const element = dcpObjectElement(type);
    if (!element) return;
    delete element.dataset.srdDcpPaintLeft;
    delete element.dataset.srdDcpPaintTop;
    delete element.dataset.srdDcpPaintWidth;
    delete element.dataset.srdDcpPaintHeight;
  }

  function invalidateDcpDieTextDerivedState(selection, clearGlyphMetrics) {
    dcpDieProductionContractCache = { signature: '', contract: null };
    dieCuttingStateError = '';
    if (clearGlyphMetrics) clearDcpGlyphMeasurementCache();
    if (dcpObjectType(selection) === 'text') {
      invalidateDcpTextFit(selection);
      invalidateDcpTextPaintBounds(selection);
      return;
    }
    normalizeDcpCanvasObjects(getDcpProofState().objects, 'die_cutting').textObjects.forEach((object) => {
      const textSelection = dcpTextSelection(object.id);
      invalidateDcpTextFit(textSelection);
      invalidateDcpTextPaintBounds(textSelection);
    });
  }

  function settleDcpDieTextResizePosition(selection) {
    if (!isDieCuttingMode() || dcpObjectType(selection) !== 'text') {
      return { valid: true, changed: false, passes: 0 };
    }
    const tolerance = 0.000001;
    const maximumPasses = 2;
    let changed = false;

    for (let pass = 0; pass < maximumPasses; pass += 1) {
      const proof = currentDcpProofState || emptyDcpProofState();
      const objects = normalizeDcpCanvasObjects(proof.objects);
      const object = dcpObjectRecordForSelection(objects, selection);
      const element = dcpObjectElement(selection);
      const paint = dcpTextPaintBounds(element);
      if (!object || !element || !paint || !element.dataset.srdDcpFitSignature) {
        return { valid: false, changed: changed, passes: pass };
      }
      const position = canonicalDcpObjectPosition(
        selection,
        object,
        { x: object.x, y: object.y },
        proof,
        activeDcpPhysicalSize()
      );
      if (position.constraint.infeasibleX || position.constraint.infeasibleY) {
        return { valid: false, changed: changed, passes: pass };
      }
      const deltaX = position.x - object.x;
      const deltaY = position.y - object.y;
      if (Math.abs(deltaX) <= tolerance && Math.abs(deltaY) <= tolerance) {
        return { valid: true, changed: changed, passes: pass };
      }

      object.x = position.x;
      object.y = position.y;
      proof.objects = objects;
      currentDcpProofState = proof;
      syncDcpProofCompatibilityAlias();
      changed = true;
      applyDcpObjectStyles();
    }

    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const object = dcpObjectRecordForSelection(objects, selection);
    const position = object && canonicalDcpObjectPosition(
      selection,
      object,
      { x: object.x, y: object.y },
      proof,
      activeDcpPhysicalSize()
    );
    return {
      valid: Boolean(position)
        && !position.constraint.infeasibleX
        && !position.constraint.infeasibleY
        && Math.abs(position.x - object.x) <= tolerance
        && Math.abs(position.y - object.y) <= tolerance,
      changed: changed,
      passes: maximumPasses
    };
  }

  function captureDcpDieTextBoundaryAttachments() {
    if (!isDieCuttingMode() || !targets.proofArtboard) return {};
    const proof = getDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const physicalSize = activeDcpPhysicalSize();
    const artboardRect = targets.proofArtboard.getBoundingClientRect();
    if (!artboardRect.width || !artboardRect.height) return {};
    const toleranceX = 0.05 / artboardRect.width * 100;
    const toleranceY = 0.05 / artboardRect.height * 100;
    return objects.textObjects.reduce((attachments, object) => {
      const selection = dcpTextSelection(object.id);
      const bounds = dcpAlignmentObjectBounds(selection, object, proof, physicalSize);
      if (!bounds) return attachments;
      const attachment = {
        left: Math.abs(bounds.left) <= toleranceX,
        right: Math.abs(100 - bounds.right) <= toleranceX,
        top: Math.abs(bounds.top) <= toleranceY,
        bottom: Math.abs(100 - bounds.bottom) <= toleranceY
      };
      if (attachment.left || attachment.right || attachment.top || attachment.bottom) {
        attachments[object.id] = attachment;
      }
      return attachments;
    }, {});
  }

  function applyDcpDieTextBoundaryAttachments(attachments) {
    if (!isDieCuttingMode() || !attachments || typeof attachments !== 'object') return false;
    const proof = getDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const physicalSize = activeDcpPhysicalSize();
    let changed = false;
    objects.textObjects.forEach((object) => {
      const attachment = attachments[object.id];
      if (!attachment) return;
      const selection = dcpTextSelection(object.id);
      const bounds = dcpAlignmentObjectBounds(selection, object, proof, physicalSize);
      if (!bounds) return;
      let nextX = object.x;
      let nextY = object.y;
      if (attachment.left) nextX += -bounds.left;
      else if (attachment.right) nextX += 100 - bounds.right;
      if (attachment.top) nextY += -bounds.top;
      else if (attachment.bottom) nextY += 100 - bounds.bottom;
      if (![nextX, nextY].every(Number.isFinite)) return;
      if (Math.abs(nextX - object.x) > 0.000001 || Math.abs(nextY - object.y) > 0.000001) {
        object.x = nextX;
        object.y = nextY;
        changed = true;
      }
    });
    if (changed) {
      proof.objects = objects;
      currentDcpProofState = proof;
      syncDcpProofCompatibilityAlias();
      applyDcpObjectStyles();
    }
    return changed;
  }

  function settleDcpDieTextPositionsAfterRefit(boundaryAttachments, expectedHistoryPresent) {
    if (!isDieCuttingMode() || dcpObjectInteraction) {
      return { valid: true, changed: false };
    }
    const previousPresent = expectedHistoryPresent || cloneDcpHistoryValue(dcpHistory.present);
    let changed = applyDcpDieTextBoundaryAttachments(boundaryAttachments);
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    for (const object of objects.textObjects) {
      const result = settleDcpDieTextResizePosition(dcpTextSelection(object.id));
      if (!result.valid) return { valid: false, changed: changed };
      changed = changed || result.changed;
    }
    if (changed && dcpHistory.present && !dcpHistory.applying) {
      syncDcpHistoryAfterCanonicalSettlement(previousPresent);
    }
    return { valid: true, changed: changed };
  }

  function resizedDcpObjectValues(object, pointer, start, handle) {
    const startLeft = object.x - object.width / 2;
    const startRight = object.x + object.width / 2;
    const startTop = object.y - object.height / 2;
    const startBottom = object.y + object.height / 2;
    const deltaX = pointer.x - start.x;
    const deltaY = pointer.y - start.y;
    let nextLeft = startLeft;
    let nextRight = startRight;
    let nextTop = startTop;
    let nextBottom = startBottom;

    if (handle.indexOf('left') !== -1) nextLeft = startLeft + deltaX;
    if (handle.indexOf('right') !== -1) nextRight = startRight + deltaX;
    if (handle.indexOf('top') !== -1) nextTop = startTop + deltaY;
    if (handle.indexOf('bottom') !== -1) nextBottom = startBottom + deltaY;

    const minWidth = dcpObjectInteraction.type === 'artwork' ? 8 : 8;
    const minHeight = dcpObjectInteraction.type === 'artwork' ? 8 : 5;
    if (nextRight - nextLeft < minWidth) {
      if (handle.indexOf('left') !== -1) nextLeft = nextRight - minWidth;
      else nextRight = nextLeft + minWidth;
    }
    if (nextBottom - nextTop < minHeight) {
      if (handle.indexOf('top') !== -1) nextTop = nextBottom - minHeight;
      else nextBottom = nextTop + minHeight;
    }

    return {
      x: (nextLeft + nextRight) / 2,
      y: (nextTop + nextBottom) / 2,
      width: nextRight - nextLeft,
      height: nextBottom - nextTop
    };
  }

  function resizedDcCatalogArtworkValues(object, pointer, start) {
    if (!activeDcpCatalogArtwork || !object) return object;
    const dimensions = activeDcpCatalogArtwork.record.exactDimensions['12'];
    const startRadius = Math.hypot(start.x - object.x, start.y - object.y);
    const nextRadius = Math.hypot(pointer.x - object.x, pointer.y - object.y);
    const factor = startRadius > .001 ? nextRadius / startRadius : 1;
    const startControllingPercent = Math.max(Number(object.width) || 0, Number(object.height) || 0);
    const centerLimitX = dimensions.width > 0
      ? (2 * Math.min(object.x, 100 - object.x)) / (dimensions.width / 12)
      : 100;
    const centerLimitY = dimensions.height > 0
      ? (2 * Math.min(object.y, 100 - object.y)) / (dimensions.height / 12)
      : 100;
    const controllingPercent = clampDcpNumber(
      startControllingPercent * factor,
      50,
      Math.min(100, centerLimitX, centerLimitY),
      startControllingPercent
    );
    return {
      x: object.x,
      y: object.y,
      width: dimensions.width / 12 * controllingPercent,
      height: dimensions.height / 12 * controllingPercent,
      scale: 1
    };
  }

  function nearestDcArtNominalSizeFromArtwork(object, startingSize) {
    const controllingInches = Math.max(Number(object && object.width) || 0, Number(object && object.height) || 0) / 100 * 12;
    const direction = controllingInches >= Number(startingSize || 6) ? 1 : -1;
    return [6, 8, 10, 12].slice().sort((left, right) => {
      const difference = Math.abs(left - controllingInches) - Math.abs(right - controllingInches);
      return Math.abs(difference) > .0001 ? difference : direction * (right - left);
    })[0];
  }

  function resizedDcpDieTextHorizontalValues(object, pointer, start, handle, interaction) {
    const rect = targets.proofArtboard ? targets.proofArtboard.getBoundingClientRect() : null;
    const paint = interaction && interaction.startTextPaint;
    if (!rect || !rect.width || !rect.height || !paint || !paint.width || (handle !== 'left' && handle !== 'right')) {
      return resizedDcpObjectValues(object, pointer, start, handle);
    }
    const rotation = clampDcpNumber(object.rotation, -180, 180, 0) * Math.PI / 180;
    const deltaScreenX = (pointer.x - start.x) / 100 * rect.width;
    const deltaScreenY = (pointer.y - start.y) / 100 * rect.height;
    const localDeltaX = deltaScreenX * Math.cos(rotation) + deltaScreenY * Math.sin(rotation);
    const direction = handle === 'right' ? 1 : -1;
    const startScale = dcpDieHorizontalScale(object);
    // Die width scaling stays centered so browser glyph bounds and trusted outline geometry share one anchor.
    const requestedPaintWidth = Math.max(1, paint.width + localDeltaX * direction * 2);
    const horizontalScale = clampDcpNumber(
      startScale * requestedPaintWidth / paint.width,
      dcpDieMinimumHorizontalScale,
      dcpDieMaximumHorizontalScale,
      startScale
    );
    return {
      x: object.x,
      y: object.y,
      horizontalScale: horizontalScale
    };
  }

  function resizedDcpHeaderValues(object, pointer, handle) {
    const rect = targets.proofArtboard ? targets.proofArtboard.getBoundingClientRect() : null;
    if (!rect || !rect.width || !rect.height) return object;
    const catalogItem = dcpHeaderCatalogByKey[object.libraryKey];
    if (!catalogItem) return object;
    const aspect = catalogItem.aspectRatio;
    const centerX = object.x / 100 * rect.width;
    const centerY = object.y / 100 * rect.height;
    const startWidth = object.width / 100 * rect.width;
    const startHeight = object.height / 100 * rect.height;
    const left = centerX - startWidth / 2;
    const right = centerX + startWidth / 2;
    const top = centerY - startHeight / 2;
    const bottom = centerY + startHeight / 2;
    const pointerX = pointer.x / 100 * rect.width;
    const pointerY = pointer.y / 100 * rect.height;
    const minWidth = Math.max(rect.width * 0.04, rect.height * 0.02 * aspect);
    let width = startWidth;
    let height = startHeight;
    let nextX = centerX;
    let nextY = centerY;

    const cornerDirections = {
      'top-left': { anchorX: right, anchorY: bottom, directionX: -1, directionY: -1 },
      'top-right': { anchorX: left, anchorY: bottom, directionX: 1, directionY: -1 },
      'bottom-right': { anchorX: left, anchorY: top, directionX: 1, directionY: 1 },
      'bottom-left': { anchorX: right, anchorY: top, directionX: -1, directionY: 1 }
    };
    const corner = cornerDirections[handle];
    if (corner) {
      const vectorX = (pointerX - corner.anchorX) * corner.directionX;
      const vectorY = (pointerY - corner.anchorY) * corner.directionY;
      const projectedHeight = Math.max(minWidth / aspect, (vectorX * aspect + vectorY) / (aspect * aspect + 1));
      const maxWidth = corner.directionX < 0 ? corner.anchorX : rect.width - corner.anchorX;
      const maxHeight = corner.directionY < 0 ? corner.anchorY : rect.height - corner.anchorY;
      height = Math.min(projectedHeight, maxWidth / aspect, maxHeight);
      height = Math.max(Math.min(minWidth / aspect, maxWidth / aspect, maxHeight), height);
      width = height * aspect;
      nextX = corner.anchorX + corner.directionX * width / 2;
      nextY = corner.anchorY + corner.directionY * height / 2;
    } else if (handle === 'left' || handle === 'right') {
      const anchorX = handle === 'left' ? right : left;
      const directionX = handle === 'left' ? -1 : 1;
      const requestedWidth = (pointerX - anchorX) * directionX;
      const maxWidthByEdge = directionX < 0 ? anchorX : rect.width - anchorX;
      const maxWidthByHeight = Math.min(centerY, rect.height - centerY) * 2 * aspect;
      width = Math.max(Math.min(minWidth, maxWidthByEdge, maxWidthByHeight), Math.min(requestedWidth, maxWidthByEdge, maxWidthByHeight));
      height = width / aspect;
      nextX = anchorX + directionX * width / 2;
      nextY = centerY;
    } else if (handle === 'top' || handle === 'bottom') {
      const anchorY = handle === 'top' ? bottom : top;
      const directionY = handle === 'top' ? -1 : 1;
      const requestedHeight = (pointerY - anchorY) * directionY;
      const maxHeightByEdge = directionY < 0 ? anchorY : rect.height - anchorY;
      const maxHeightByWidth = Math.min(centerX, rect.width - centerX) * 2 / aspect;
      const minHeight = minWidth / aspect;
      height = Math.max(Math.min(minHeight, maxHeightByEdge, maxHeightByWidth), Math.min(requestedHeight, maxHeightByEdge, maxHeightByWidth));
      width = height * aspect;
      nextX = centerX;
      nextY = anchorY + directionY * height / 2;
    }

    return {
      x: nextX / rect.width * 100,
      y: nextY / rect.height * 100,
      width: width / rect.width * 100,
      height: height / rect.height * 100
    };
  }

  function resizedDcpShapeValues(object, pointer, start, handle) {
    const catalogItem = object && dcpShapeCatalogByKey[object.shapeKey];
    if (!catalogItem || catalogItem.resizePolicy !== 'proportional') return resizedDcpObjectValues(object, pointer, start, handle);
    const rect = targets.proofArtboard ? targets.proofArtboard.getBoundingClientRect() : null;
    if (!rect || !rect.width || !rect.height) return object;
    const aspect = catalogItem.aspectRatio;
    const cx = object.x / 100 * rect.width, cy = object.y / 100 * rect.height;
    const sw = object.width / 100 * rect.width, sh = object.height / 100 * rect.height;
    const left = cx - sw / 2, right = cx + sw / 2, top = cy - sh / 2, bottom = cy + sh / 2;
    const px = pointer.x / 100 * rect.width, py = pointer.y / 100 * rect.height;
    const minWidth = Math.max(rect.width * 0.08, rect.height * 0.08 * aspect);
    let width = sw, height = sh, nextX = cx, nextY = cy;
    const corners = {
      'top-left': { ax: right, ay: bottom, dx: -1, dy: -1 },
      'top-right': { ax: left, ay: bottom, dx: 1, dy: -1 },
      'bottom-right': { ax: left, ay: top, dx: 1, dy: 1 },
      'bottom-left': { ax: right, ay: top, dx: -1, dy: 1 }
    };
    const corner = corners[handle];
    if (corner) {
      const vx = (px - corner.ax) * corner.dx, vy = (py - corner.ay) * corner.dy;
      const projectedHeight = Math.max(minWidth / aspect, (vx * aspect + vy) / (aspect * aspect + 1));
      const maxWidth = corner.dx < 0 ? corner.ax : rect.width - corner.ax;
      const maxHeight = corner.dy < 0 ? corner.ay : rect.height - corner.ay;
      height = Math.max(Math.min(minWidth / aspect, maxWidth / aspect, maxHeight), Math.min(projectedHeight, maxWidth / aspect, maxHeight));
      width = height * aspect;
      nextX = corner.ax + corner.dx * width / 2; nextY = corner.ay + corner.dy * height / 2;
    } else if (handle === 'left' || handle === 'right') {
      const ax = handle === 'left' ? right : left, direction = handle === 'left' ? -1 : 1;
      const maxWidth = Math.min(direction < 0 ? ax : rect.width - ax, Math.min(cy, rect.height - cy) * 2 * aspect);
      width = Math.max(Math.min(minWidth, maxWidth), Math.min((px - ax) * direction, maxWidth));
      height = width / aspect; nextX = ax + direction * width / 2;
    } else if (handle === 'top' || handle === 'bottom') {
      const ay = handle === 'top' ? bottom : top, direction = handle === 'top' ? -1 : 1;
      const maxHeight = Math.min(direction < 0 ? ay : rect.height - ay, Math.min(cx, rect.width - cx) * 2 / aspect);
      height = Math.max(Math.min(minWidth / aspect, maxHeight), Math.min((py - ay) * direction, maxHeight));
      width = height * aspect; nextY = ay + direction * height / 2;
    }
    return { x: nextX / rect.width * 100, y: nextY / rect.height * 100, width: width / rect.width * 100, height: height / rect.height * 100 };
  }

  function resizedDcpSymbolValues(object, pointer, start, handle) {
    const rect = targets.proofArtboard ? targets.proofArtboard.getBoundingClientRect() : null;
    const aspect = Number(object && object.aspectRatio);
    if (!rect || !rect.width || !rect.height || !Number.isFinite(aspect) || aspect <= 0) return object;
    const cx = object.x / 100 * rect.width;
    const cy = object.y / 100 * rect.height;
    const startWidth = object.width / 100 * rect.width;
    const startHeight = object.height / 100 * rect.height;
    const left = cx - startWidth / 2;
    const right = cx + startWidth / 2;
    const top = cy - startHeight / 2;
    const bottom = cy + startHeight / 2;
    const deltaX = (pointer.x - start.x) / 100 * rect.width;
    const deltaY = (pointer.y - start.y) / 100 * rect.height;
    const minWidth = Math.max(rect.width * 0.02, rect.height * 0.02 * aspect);
    let width = startWidth;
    let height = startHeight;
    let nextX = cx;
    let nextY = cy;
    const corners = {
      'top-left': { ax: right, ay: bottom, dx: -1, dy: -1 },
      'top-right': { ax: left, ay: bottom, dx: 1, dy: -1 },
      'bottom-right': { ax: left, ay: top, dx: 1, dy: 1 },
      'bottom-left': { ax: right, ay: top, dx: -1, dy: 1 }
    };
    const corner = corners[handle];
    if (corner) {
      const maxWidth = corner.dx < 0 ? corner.ax : rect.width - corner.ax;
      const maxHeight = corner.dy < 0 ? corner.ay : rect.height - corner.ay;
      const requestedScale = Math.max((startWidth + deltaX * corner.dx) / startWidth, (startHeight + deltaY * corner.dy) / startHeight);
      const scale = Math.max(minWidth / startWidth, Math.min(requestedScale, maxWidth / startWidth, maxHeight / startHeight));
      height = startHeight * scale;
      width = height * aspect;
      nextX = corner.ax + corner.dx * width / 2;
      nextY = corner.ay + corner.dy * height / 2;
    } else if (handle === 'left' || handle === 'right') {
      const ax = handle === 'left' ? right : left;
      const direction = handle === 'left' ? -1 : 1;
      const maxWidth = Math.min(direction < 0 ? ax : rect.width - ax, Math.min(cy, rect.height - cy) * 2 * aspect);
      width = Math.max(Math.min(minWidth, maxWidth), Math.min(startWidth + deltaX * direction, maxWidth));
      height = width / aspect;
      nextX = ax + direction * width / 2;
    } else if (handle === 'top' || handle === 'bottom') {
      const ay = handle === 'top' ? bottom : top;
      const direction = handle === 'top' ? -1 : 1;
      const maxHeight = Math.min(direction < 0 ? ay : rect.height - ay, Math.min(cx, rect.width - cx) * 2 / aspect);
      height = Math.max(Math.min(minWidth / aspect, maxHeight), Math.min(startHeight + deltaY * direction, maxHeight));
      width = height * aspect;
      nextY = ay + direction * height / 2;
    }
    return {
      x: nextX / rect.width * 100,
      y: nextY / rect.height * 100,
      width: width / rect.width * 100,
      height: height / rect.height * 100
    };
  }

  function pointerToDcpPercent(event) {
    if (!targets.proofArtboard) return { x: 50, y: 50 };
    const rect = targets.proofArtboard.getBoundingClientRect();
    return {
      x: ((event.clientX - rect.left) / rect.width) * 100,
      y: ((event.clientY - rect.top) / rect.height) * 100
    };
  }

  function dcpAdditiveSelectionFromEvent(event) {
    if (!event) return false;
    const modifierState = typeof event.getModifierState === 'function'
      ? event.getModifierState.bind(event)
      : null;
    return Boolean(
      event.shiftKey ||
      event.ctrlKey ||
      event.metaKey ||
      (modifierState && (
        modifierState('Shift') ||
        modifierState('Control') ||
        modifierState('Meta') ||
        modifierState('OS')
      ))
    );
  }

  function dcpObjectMoveBounds(object, selection) {
    return dcpObjectPositionConstraint(
      selection,
      object,
      getDcpProofState(),
      activeDcpPhysicalSize()
    );
  }

  function startDcpObjectInteraction(event, type, mode) {
    if (!isBlankCanvasMode(controls.template.value) || !hasVisibleDcpObject(type)) return;
    const additiveSelection = mode === 'move' && (dcpMultiSelectMode || dcpAdditiveSelectionFromEvent(event));
    event.preventDefault();
    event.stopPropagation();
    clearDcpSnapIndicators();
    if (additiveSelection) {
      event.stopImmediatePropagation();
      dcpObjectInteraction = null;
      toggleDcpObjectSelection(type);
      return;
    }
    if (mode && mode.indexOf('resize-') === 0 && selectedDcpObjects.length !== 1) return;
    if (activeDcpCatalogArtwork && dcpObjectType(type) === 'artwork' && mode && mode.indexOf('resize-') === 0
        && !['top-left', 'top-right', 'bottom-left', 'bottom-right'].includes(mode.replace('resize-', ''))) return;
    const movingGroup = mode === 'move' && selectedDcpObjects.length > 1 && selectedDcpObjects.includes(type);
    if (!movingGroup) selectDcpObject(type);
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    const objectType = dcpObjectType(type) || type;
    const object = dcpObjectRecordForSelection(objects, type);
    if (!object) return;
    const interactionSelections = movingGroup ? selectedDcpObjects.slice() : [type];
    const startObjects = interactionSelections.map((selection) => {
      const record = dcpObjectRecordForSelection(objects, selection);
      return record ? { selection: selection, object: { ...record } } : null;
    });
    if (startObjects.some((item) => !item)) return;
    const interactionElement = mode && mode.indexOf('resize-') === 0
      ? dcpObjectElement(type)
      : (objectType === 'artwork' && targets.blankCanvasArtworkHit ? targets.blankCanvasArtworkHit : dcpObjectElement(type));
    let startTextPaint = objectType === 'text' && interactionElement
      ? dcpTextPaintBounds(interactionElement)
      : null;
    const trustedPaintedWidth = interactionElement && Number(interactionElement.dataset.srdDcpDiePaintedWidth);
    if (isDieCuttingMode() && startTextPaint && Number.isFinite(trustedPaintedWidth) && trustedPaintedWidth > 0) {
      startTextPaint = { ...startTextPaint, width: trustedPaintedWidth };
    }
    dcpObjectInteraction = {
      type: type,
      mode: mode,
      pointerId: event.pointerId,
      startPointer: pointerToDcpPercent(event),
      startObject: { ...object },
      startObjects: startObjects,
      historyStart: beginDcpHistoryTransaction(),
      startTextPaint: startTextPaint ? { ...startTextPaint } : null,
      startCatalogNominalSize: activeDcpCatalogArtwork ? activeDcpCatalogArtwork.nominalSize : null,
      handle: mode && mode.indexOf('resize-') === 0 ? mode.replace('resize-', '') : 'bottom-right'
    };
    const element = mode && mode.indexOf('resize-') === 0
      ? event.currentTarget
      : (objectType === 'artwork' && targets.blankCanvasArtworkHit ? targets.blankCanvasArtworkHit : dcpObjectElement(type));
    if (element && element.setPointerCapture) element.setPointerCapture(event.pointerId);
    applyDcpObjectSelectionState();
  }

  function moveDcpObjectInteraction(event) {
    if (!dcpObjectInteraction) return;
    if (event.__srdDcpObjectHandled) return;
    event.__srdDcpObjectHandled = true;
    event.preventDefault();
    const rawPointer = pointerToDcpPercent(event);
    const start = dcpObjectInteraction.startPointer;
    const object = dcpObjectInteraction.startObject;
    if (dcpObjectInteraction.mode && dcpObjectInteraction.mode.indexOf('resize-') === 0) {
      const dieTextHorizontalResize = isDieCuttingMode()
        && dcpObjectType(dcpObjectInteraction.type) === 'text'
        && (dcpObjectInteraction.handle === 'left' || dcpObjectInteraction.handle === 'right');
      const pointer = dieTextHorizontalResize
        ? rawPointer
        : snappedDcpResizePointer(rawPointer, dcpObjectInteraction.handle, dcpObjectInteraction.type);
      const resizedValues = dcpObjectInteraction.type === 'header'
        ? resizedDcpHeaderValues(object, pointer, dcpObjectInteraction.handle)
        : (dcpObjectInteraction.type === 'shape'
          ? resizedDcpShapeValues(object, pointer, start, dcpObjectInteraction.handle)
          : (dcpObjectType(dcpObjectInteraction.type) === 'symbol'
            ? resizedDcpSymbolValues(object, pointer, start, dcpObjectInteraction.handle)
            : (dieTextHorizontalResize
              ? resizedDcpDieTextHorizontalValues(
                  object,
                  rawPointer,
                  start,
                  dcpObjectInteraction.handle,
                  dcpObjectInteraction
                )
              : (activeDcpCatalogArtwork && dcpObjectType(dcpObjectInteraction.type) === 'artwork'
                ? resizedDcCatalogArtworkValues(object, pointer, start)
                : resizedDcpObjectValues(object, pointer, start, dcpObjectInteraction.handle)))));
      const dieTextResize = isDieCuttingMode() && dcpObjectType(dcpObjectInteraction.type) === 'text';
      if (dieTextResize) {
        invalidateDcpTextFit(dcpObjectInteraction.type);
        invalidateDcpTextPaintBounds(dcpObjectInteraction.type);
      }
      updateDcpObjectTransform(
        dcpObjectInteraction.type,
        resizedValues,
        dieTextResize ? { deferDieTextPositionConstraint: true } : null
      );
      if (!dieTextResize) invalidateDcpTextFit(dcpObjectInteraction.type);
    } else {
      const startObjects = dcpObjectInteraction.startObjects || [{ selection: dcpObjectInteraction.type, object: object }];
      let deltaX = rawPointer.x - start.x;
      let deltaY = rawPointer.y - start.y;
      if (startObjects.length > 1) {
        let minimumDeltaX = -Infinity;
        let maximumDeltaX = Infinity;
        let minimumDeltaY = -Infinity;
        let maximumDeltaY = Infinity;
        startObjects.forEach((item) => {
          const bounds = dcpObjectMoveBounds(item.object, item.selection);
          minimumDeltaX = Math.max(minimumDeltaX, bounds.minX - item.object.x);
          maximumDeltaX = Math.min(maximumDeltaX, bounds.maxX - item.object.x);
          minimumDeltaY = Math.max(minimumDeltaY, bounds.minY - item.object.y);
          maximumDeltaY = Math.min(maximumDeltaY, bounds.maxY - item.object.y);
        });
        deltaX = Math.min(maximumDeltaX, Math.max(minimumDeltaX, deltaX));
        deltaY = Math.min(maximumDeltaY, Math.max(minimumDeltaY, deltaY));
      }
      const snappedDelta = snappedDcpMoveDelta(startObjects, deltaX, deltaY);
      deltaX = snappedDelta.x;
      deltaY = snappedDelta.y;
      if (startObjects.length > 1) {
        let minimumDeltaX = -Infinity;
        let maximumDeltaX = Infinity;
        let minimumDeltaY = -Infinity;
        let maximumDeltaY = Infinity;
        startObjects.forEach((item) => {
          const bounds = dcpObjectMoveBounds(item.object, item.selection);
          minimumDeltaX = Math.max(minimumDeltaX, bounds.minX - item.object.x);
          maximumDeltaX = Math.min(maximumDeltaX, bounds.maxX - item.object.x);
          minimumDeltaY = Math.max(minimumDeltaY, bounds.minY - item.object.y);
          maximumDeltaY = Math.min(maximumDeltaY, bounds.maxY - item.object.y);
        });
        const clampedX = Math.min(maximumDeltaX, Math.max(minimumDeltaX, deltaX));
        const clampedY = Math.min(maximumDeltaY, Math.max(minimumDeltaY, deltaY));
        if (clampedX !== deltaX || clampedY !== deltaY) clearDcpSnapIndicators();
        deltaX = clampedX;
        deltaY = clampedY;
      }
      const moved = startObjects.length > 1
        ? updateDcpObjectPositionSet(startObjects.map((item) => {
            return {
              selection: item.selection,
              x: item.object.x + deltaX,
              y: item.object.y + deltaY
            };
          }))
        : Boolean(updateDcpObjectTransform(startObjects[0].selection, {
            x: startObjects[0].object.x + deltaX,
            y: startObjects[0].object.y + deltaY
          }));
      if (!moved) {
        const failedInteraction = dcpObjectInteraction;
        dcpObjectInteraction = null;
        applyDcpHistorySnapshot(failedInteraction.historyStart);
        return;
      }
    }
    applyDcpObjectStyles();
    if (dcpObjectInteraction
      && dcpObjectInteraction.mode
      && dcpObjectInteraction.mode.indexOf('resize-') === 0
      && isDieCuttingMode()
      && dcpObjectType(dcpObjectInteraction.type) === 'text') {
      const settlement = settleDcpDieTextResizePosition(dcpObjectInteraction.type);
      if (!settlement.valid) {
        const failedInteraction = dcpObjectInteraction;
        dcpObjectInteraction = null;
        applyDcpHistorySnapshot(failedInteraction.historyStart);
      }
    }
  }

  function endDcpObjectInteraction(event) {
    if (!dcpObjectInteraction) return;
    if (event) {
      if (event.__srdDcpObjectEnded) return;
      event.__srdDcpObjectEnded = true;
    }
    const interaction = dcpObjectInteraction;
    dcpObjectInteraction = null;
    clearDcpSnapIndicators();
    const catalogArtworkResize = Boolean(
      activeDcpCatalogArtwork
      && dcpObjectType(interaction.type) === 'artwork'
      && interaction.mode
      && interaction.mode.indexOf('resize-') === 0
    );
    if (catalogArtworkResize) {
      const artwork = normalizeDcpCanvasObjects(getDcpProofState().objects, 'die_cutting').artwork;
      applyDcArtNominalSize(
        nearestDcArtNominalSizeFromArtwork(artwork, interaction.startCatalogNominalSize),
        { history: false }
      );
    }
    const groupMovement = interaction.mode === 'move' && interaction.startObjects && interaction.startObjects.length > 1;
    if (groupMovement && event && event.type === 'pointercancel') {
      applyDcpHistorySnapshot(interaction.historyStart);
      dcpHistory.present = captureDcpHistorySnapshot();
      updateDcpHistoryControls();
      return;
    }
    update();
    commitDcpHistoryTransaction(
      interaction.historyStart,
      interaction.mode && interaction.mode.indexOf('resize-') === 0
        ? (catalogArtworkResize ? 'Resize catalog artwork' : 'Resize object')
        : (groupMovement ? 'Move selected objects' : 'Move object')
    );
  }

  function applyDcpObjectStyles() {
    if (!isBlankCanvasMode(controls.template.value)) {
      (targets.dcpResizeHandles || []).forEach((handle) => { handle.hidden = true; });
      return;
    }
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    applyDcpShapeObjectStyle(objects);
    applyDcpArtworkObjectStyle(objects);
    applyDcpHeaderObjectStyle(objects);
    syncDcpSymbolObjectElements(objects);
    syncDcpTextObjectElements(objects, fontStackFor(controls.font ? controls.font.value : 'arial'), colorValueFor(selectedFontColor()));
    applyDcpPrintableLayerOrder(objects);
    applyDcpObjectSelectionState();
  }

  function selectedTemplateConfig() {
    const template = controls.template.value;
    return templateIntelligence[template] || templateIntelligence.danger;
  }

  function selectedTemplateLabel() {
    const template = controls.template.value;
    return templateLabels[template] || templateLabels.danger;
  }

  function syncCalibrationFromInputs() {
    if (!calibrationMode) return;
    const activeElement = document.activeElement;
    if (!activeElement || !activeElement.matches('[data-srd-calibration-field]')) return;
    const target = activeCalibrationTarget();
    if (!target.enabled || !target.config) return;

    targets.calibrationFields.forEach((field) => {
      const key = field.dataset.srdCalibrationField;
      const configKey = target.fieldMap[key];
      if (!configKey || field.disabled || field.value === '') return;
      if (target.textFields.includes(key)) {
        target.config[configKey] = field.value;
      } else {
        const value = Number.parseFloat(field.value);
        if (Number.isFinite(value)) target.config[configKey] = value;
      }
    });
  }

  function activeCalibrationTarget() {
    const template = controls.template ? controls.template.value : '';
    const mode = designerModeFromState(template);
    const requestedTarget = targets.calibrationTarget ? targets.calibrationTarget.value : 'auto';
    const standardAllowed = mode === 'standard';
    const nitrousAllowed = mode === 'nitrous';
    const targetType = requestedTarget === 'auto'
      ? (nitrousAllowed ? 'nitrous_header' : 'standard_text')
      : requestedTarget;

    if (targetType === 'standard_text') {
      const config = selectedTemplateConfig();
      const enabled = standardAllowed && template !== '' && hasWritableArea(config);
      return {
        type: targetType,
        mode: mode,
        enabled: enabled,
        title: enabled ? selectedTemplateLabel() + ' - Standard Text Area' : 'Select Standard Safety Signs and Header',
        config: config,
        editableFields: ['x', 'y', 'width', 'height'],
        textFields: [],
        fieldMap: {
          x: 'writable_area_center_x',
          y: 'writable_area_center_y',
          width: 'writable_area_width',
          height: 'writable_area_height'
        },
        payload: enabled ? {
          standard_signs: {
            templates: {
              [template]: {
                writable_area_center_x: config.writable_area_center_x,
                writable_area_center_y: config.writable_area_center_y,
                writable_area_width: config.writable_area_width,
                writable_area_height: config.writable_area_height,
                default_horizontal_alignment: config.default_horizontal_alignment,
                default_vertical_alignment: config.default_vertical_alignment,
                default_padding: config.default_padding
              }
            }
          }
        } : { select_standard_header: true }
      };
    }

    if (targetType === 'nitrous_weight') {
      const bottleWeight = selectedNitrousBottleWeight();
      const profile = selectedNitrousBottleProfile();
      const config = profile.weightCalibration || {};
      const enabled = nitrousAllowed && Boolean(config);
      return {
        type: targetType,
        mode: mode,
        enabled: enabled,
        title: enabled ? bottleWeight + ' - Nitrous Weight Numbers' : 'Select Nitrous Bottle Labels',
        config: config,
        editableFields: ['x', 'y', 'width', 'lineSpacing', 'fontSize', 'alignment'],
        textFields: ['alignment'],
        fieldMap: {
          x: 'x',
          y: 'y',
          width: 'width',
          lineSpacing: 'lineSpacing',
          fontSize: 'fontSize',
          alignment: 'alignment'
        },
        payload: enabled ? {
          nitrous: {
            bottle_sizes: {
              [bottleWeight]: {
                weight_overlay: Object.assign({ background: 'transparent' }, config)
              }
            }
          }
        } : { select_nitrous_bottle_labels: true }
      };
    }

    if (targetType === 'nitrous_header') {
      const headerChoice = selectedNitrousHeaderChoice();
      const config = nitrousHeaderCalibrations[headerChoice.key];
      const enabled = nitrousAllowed && Boolean(config);
      return {
        type: targetType,
        mode: mode,
        enabled: enabled,
        title: enabled ? headerChoice.label + ' - Nitrous Header / Custom Art' : 'Select Nitrous Bottle Labels',
        config: config,
        editableFields: ['x', 'y', 'width', 'height', 'scale', 'rotation'],
        textFields: [],
        fieldMap: {
          x: 'x',
          y: 'y',
          width: 'width',
          height: 'height',
          scale: 'scale',
          rotation: 'rotation'
        },
        payload: enabled ? {
          nitrous: {
            headers: {
              [headerChoice.key]: {
                x: config.x,
                y: config.y,
                width: config.width,
                height: config.height,
                scale: config.scale,
                rotation: config.rotation
              }
            }
          }
        } : { select_nitrous_bottle_labels: true }
      };
    }

    return {
      type: targetType,
      mode: mode,
      enabled: false,
      title: 'Choose a calibration target',
      config: null,
      editableFields: [],
      textFields: [],
      fieldMap: {},
      payload: { choose_calibration_target: true }
    };
  }

  function updateCalibrationPanel() {
    if (!targets.calibrationPanel) return;

    targets.calibrationPanel.hidden = !calibrationMode;
    root.setAttribute('data-srd-calibration-mode', calibrationMode ? 'true' : 'false');

    if (!calibrationMode) return;

    const target = activeCalibrationTarget();

    if (targets.calibrationTemplate) {
      targets.calibrationTemplate.textContent = target.title;
    }

    targets.calibrationFields.forEach((field) => {
      const key = field.dataset.srdCalibrationField;
      const configKey = target.fieldMap[key];
      const fieldVisible = target.editableFields.includes(key);
      const fieldWrapper = field.closest('.srd-designer-calibration__control');
      if (fieldWrapper) fieldWrapper.hidden = !fieldVisible;
      field.disabled = !target.enabled || !configKey;
      field.value = target.enabled && configKey && target.config[configKey] !== undefined ? target.config[configKey] : '';
    });

    if (targets.calibrationJson) {
      targets.calibrationJson.value = JSON.stringify(target.payload, null, 2);
    }
  }

  function quantityDefaultForSize(size) {
    if (isNitrousMode(controls.template ? controls.template.value : '')) {
      return selectedNitrousBottleProfile().defaultQuantity;
    }
    const packagePricing = designerPackagePricing[size];
    return packagePricing ? packagePricing.minimum_package_qty : (quantityDefaultsBySize[size] || '');
  }

  function normalizedQuantity() {
    const size = effectiveDesignerSize(controls.template ? controls.template.value : '');
    const minimum = quantityDefaultForSize(size);
    if (!controls.quantity) return minimum || '';
    if (isBlankCanvasMode(controls.template ? controls.template.value : '')) {
      const raw = String(controls.quantity.value || '').trim();
      if (!raw && isDieCuttingMode()) return 1;
      if (!/^\d+$/.test(raw)) return '';
      const exactQuantity = Number(raw);
      if (!Number.isSafeInteger(exactQuantity) || exactQuantity < minimum) return '';
      return exactQuantity;
    }
    const parsed = Number.parseInt(controls.quantity.value, 10);
    if (!minimum) return Number.isFinite(parsed) && parsed > 0 ? parsed : '';
    if (!Number.isFinite(parsed) || parsed < minimum) return minimum;
    return parsed;
  }

  function formatQuantity(quantity) {
    return quantity ? quantity + ' pcs' : 'Quantity required';
  }

  function money(value) {
    if (!Number.isFinite(value)) return '--';
    return '$' + value.toFixed(2);
  }

  function roundMoney(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  function parseDcpExtraPieceVariantMap() {
    const raw = String(root.dataset.srdDcpExtraPieceVariantMap || '').trim();
    if (!raw) return {};
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (error) {
      debugLog('DCP extra-piece variant map is invalid JSON', error);
      return {};
    }
  }

  function dcpExtraPieceMapKey(size, material) {
    return normalizeSizeForShopify(size) + '|' + String(material || '').trim();
  }

  function dcpExtraPieceVariantId(size, material) {
    const value = dcpExtraPieceVariantMap[dcpExtraPieceMapKey(size, material)];
    const normalized = value === undefined || value === null ? '' : String(value).trim();
    return /^\d+$/.test(normalized) ? normalized : '';
  }

  function dcpNoLaminationVariant(size, material) {
    if (!dcpVariantLookup.loaded) return null;
    const selectedKey = variantLookupKey(size, material, 'No Lamination');
    const landscapeKey = variantLookupKey(dcpLandscapeSize(size), material, 'No Lamination');
    return dcpVariantLookup.variantsByKey[selectedKey] || dcpVariantLookup.variantsByKey[landscapeKey] || null;
  }

  function normalizeVariantOption(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function normalizeSizeForShopify(size) {
    return normalizeVariantOption(size).replace(/\s+in$/i, '');
  }

  function pricingMaterialKey(material) {
    const value = normalizeVariantOption(material).toLowerCase();
    if (value.indexOf('reflective') !== -1) return 'reflective';
    if (value.indexOf('standard') !== -1) return 'standard';
    return '';
  }

  function pricingLaminationKey(lamination) {
    const value = normalizeVariantOption(lamination).toLowerCase();
    if (value === 'yes' || value === 'laminated' || (value.indexOf('laminated') !== -1 && value.indexOf('no') === -1)) {
      return 'laminated';
    }
    if (value === 'no' || value.indexOf('no lamination') !== -1 || value.indexOf('none') !== -1) {
      return 'no_lamination';
    }
    return '';
  }

  function lockedPackagePriceFor(size, material, lamination) {
    const packagePricing = designerPackagePricing[size];
    const materialKey = pricingMaterialKey(material);
    const laminationKey = pricingLaminationKey(lamination);
    if (!packagePricing || !materialKey || !laminationKey) return NaN;
    return packagePricing[materialKey + '_' + laminationKey];
  }

  function variantLookupKey(size, material, lamination) {
    return [
      normalizeSizeForShopify(size),
      normalizeVariantOption(material),
      normalizeVariantOption(lamination)
    ].join('|').toLowerCase();
  }

  function variantOptionValue(variant, index) {
    const optionKey = 'option' + (index + 1);
    if (variant && variant[optionKey] !== undefined) return variant[optionKey];
    if (variant && Array.isArray(variant.options)) return variant.options[index];
    return '';
  }

  function variantPriceDollars(variant) {
    if (!variant || variant.price === undefined || variant.price === null) return NaN;
    const price = Number(variant.price);
    if (!Number.isFinite(price)) return NaN;
    return price >= 1000 ? price / 100 : price;
  }

  function matchedShopifyVariant(size, material, lamination) {
    if (!shopifyVariantLookup.loaded) return null;
    return shopifyVariantLookup.variantsByKey[variantLookupKey(size, material, lamination)] || null;
  }

  function dcpVariantDiagnostic(size, material, lamination) {
    const variants = dcpVariantLookup.product && Array.isArray(dcpVariantLookup.product.variants)
      ? dcpVariantLookup.product.variants
      : [];
    return {
      selected: {
        size: size,
        rendered_size: dcpLandscapeSize(size),
        material: material,
        lamination: lamination
      },
      variants: variants.map((variant) => ({
        id: variant.id || '',
        option1: variant.option1 || '',
        option2: variant.option2 || '',
        option3: variant.option3 || ''
      }))
    };
  }

  function matchedDcpVariant(size, material, lamination) {
    if (!dcpVariantLookup.loaded) return null;
    const selectedKey = variantLookupKey(size, material, lamination);
    const landscapeKey = variantLookupKey(dcpLandscapeSize(size), material, lamination);
    const match = dcpVariantLookup.variantsByKey[selectedKey] || dcpVariantLookup.variantsByKey[landscapeKey] || null;
    dcpVariantLookup.lastMatchDiagnostic = match ? null : dcpVariantDiagnostic(size, material, lamination);
    if (!match) debugLog('dcp variant match failed', dcpVariantLookup.lastMatchDiagnostic);
    return match;
  }

  function fetchJsonWithTimeout(url, timeoutMs) {
    const supportsAbort = typeof window.AbortController === 'function';
    const controller = supportsAbort ? new AbortController() : null;
    let timeout = null;
    const fetchOptions = {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    };
    if (controller) fetchOptions.signal = controller.signal;
    const fetchRequest = fetch(url, fetchOptions);
    const timeoutRequest = new Promise((resolve, reject) => {
      timeout = window.setTimeout(() => {
        if (controller) controller.abort();
        reject(new Error(url + ' timed out.'));
      }, timeoutMs || 7000);
    });
    return Promise.race([fetchRequest, timeoutRequest]).finally(() => {
      if (timeout) window.clearTimeout(timeout);
    });
  }

  function variantOptionText(variant) {
    const values = [];
    for (let index = 0; index < 3; index += 1) {
      const value = variantOptionValue(variant, index);
      if (value) values.push(value);
    }
    return normalizeVariantOption(values.join(' | ')).toLowerCase();
  }

  function selectedNitrousShopifySizeOption() {
    if (!controls.nitrousBottleWeight) return '';
    const option = Array.from(controls.nitrousBottleWeight.options || []).find((item) => item.value === controls.nitrousBottleWeight.value);
    return option && option.dataset.srdShopifyOptionValue ? option.dataset.srdShopifyOptionValue : controls.nitrousBottleWeight.value;
  }

  function nitrousVariantDiagnostic(selectedSize, selectedMaterial, selectedLamination) {
    return {
      selected: {
        size: selectedSize,
        material: selectedMaterial,
        lamination: selectedLamination
      },
      variants: nitrousVariantLookup.variants.map((variant) => ({
        id: variant.id || '',
        option1: variant.option1 || '',
        option2: variant.option2 || '',
        option3: variant.option3 || ''
      }))
    };
  }

  function nitrousVariantDiagnosticText() {
    if (!nitrousVariantLookup.lastMatchDiagnostic) return '';
    return JSON.stringify(nitrousVariantLookup.lastMatchDiagnostic);
  }

  function matchedNitrousVariant(material, lamination) {
    if (!nitrousVariantLookup.loaded) return null;
    const selectedSize = selectedNitrousShopifySizeOption();
    const selectedMaterial = material;
    const selectedLamination = lamination;
    const match = nitrousVariantLookup.variants.find((variant) => (
      variant.option1 === selectedSize &&
      variant.option2 === selectedMaterial &&
      variant.option3 === selectedLamination
    )) || null;
    nitrousVariantLookup.lastMatchDiagnostic = match ? null : nitrousVariantDiagnostic(selectedSize, selectedMaterial, selectedLamination);
    if (!match) debugLog('nitrous exact variant match failed', nitrousVariantLookup.lastMatchDiagnostic);
    return match;
  }

  async function loadDesignerProductJson() {
    shopifyVariantLookup.loading = true;
    shopifyVariantLookup.failed = false;
    shopifyVariantLookup.error = '';
    try {
      let loaded = false;
      let lastError = null;

      for (const productJsonUrl of designerProductJsonUrls) {
        try {
          const response = await fetchJsonWithTimeout(productJsonUrl, 7000);
          if (!response.ok) throw new Error(productJsonUrl + ' HTTP ' + response.status);
          const product = await response.json();
          const variants = Array.isArray(product.variants) ? product.variants : [];
          if (variants.length === 0) throw new Error(productJsonUrl + ' loaded with no variants.');

          shopifyVariantLookup.product = product;
          shopifyVariantLookup.productJsonUrl = productJsonUrl;
          shopifyVariantLookup.variantsByKey = {};
          variants.forEach((variant) => {
            const key = variantLookupKey(
              variantOptionValue(variant, 0),
              variantOptionValue(variant, 1),
              variantOptionValue(variant, 2)
            );
            if (key !== '||') shopifyVariantLookup.variantsByKey[key] = variant;
          });
          shopifyVariantLookup.loaded = true;
          shopifyVariantLookup.failed = false;
          shopifyVariantLookup.error = '';
          loaded = true;
          debugLog('designer product JSON loaded', {
            product_json_url: productJsonUrl,
            handle: product.handle || '',
            variants: variants.length
          });
          break;
        } catch (error) {
          lastError = error;
          debugLog('designer product JSON attempt failed', {
            product_json_url: productJsonUrl,
            error: error && error.message ? error.message : error
          });
        }
      }

      if (!loaded) throw lastError || new Error('Unable to load Designer product JSON from known handles.');
    } catch (error) {
      shopifyVariantLookup.loaded = false;
      shopifyVariantLookup.failed = true;
      shopifyVariantLookup.error = error && error.message ? error.message : 'Unable to load Shopify product JSON.';
      debugLog('designer product JSON failed; emergency fallback available', shopifyVariantLookup.error);
    } finally {
      shopifyVariantLookup.loading = false;
      update();
    }
  }

  async function loadDcpProductJson() {
    dcpVariantLookup.loading = true;
    dcpVariantLookup.failed = false;
    dcpVariantLookup.error = '';
    try {
      let loaded = false;
      let lastError = null;

      for (const productJsonUrl of dcpProductJsonUrls) {
        try {
          const response = await fetchJsonWithTimeout(productJsonUrl, 7000);
          if (!response.ok) throw new Error(productJsonUrl + ' HTTP ' + response.status);
          const product = await response.json();
          const variants = Array.isArray(product.variants) ? product.variants : [];
          if (variants.length === 0) throw new Error(productJsonUrl + ' loaded with no variants.');
          if (String(product.id || '') !== dcpProductId) {
            throw new Error(productJsonUrl + ' loaded product ID ' + product.id + ' instead of ' + dcpProductId + '.');
          }

          dcpVariantLookup.product = product;
          dcpVariantLookup.productJsonUrl = productJsonUrl;
          dcpVariantLookup.variantsByKey = {};
          variants.forEach((variant) => {
            const key = variantLookupKey(
              variantOptionValue(variant, 0),
              variantOptionValue(variant, 1),
              variantOptionValue(variant, 2)
            );
            if (key !== '||') dcpVariantLookup.variantsByKey[key] = variant;
          });
          dcpVariantLookup.loaded = true;
          dcpVariantLookup.failed = false;
          dcpVariantLookup.error = '';
          dcpVariantLookup.lastMatchDiagnostic = null;
          loaded = true;
          debugLog('dcp product JSON loaded', {
            product_json_url: productJsonUrl,
            product_id: product.id || '',
            handle: product.handle || '',
            variants: variants.length
          });
          break;
        } catch (error) {
          lastError = error;
          debugLog('dcp product JSON attempt failed', {
            product_json_url: productJsonUrl,
            error: error && error.message ? error.message : error
          });
        }
      }

      if (!loaded) throw lastError || new Error('Unable to load DCP product JSON from known handles.');
    } catch (error) {
      dcpVariantLookup.loaded = false;
      dcpVariantLookup.failed = true;
      dcpVariantLookup.error = error && error.message ? error.message : 'Unable to load DCP Shopify product JSON.';
      debugLog('dcp product JSON failed', dcpVariantLookup.error);
    } finally {
      dcpVariantLookup.loading = false;
      update();
    }
  }

  async function loadNitrousProductJson() {
    nitrousVariantLookup.loading = true;
    nitrousVariantLookup.failed = false;
    nitrousVariantLookup.error = '';
    try {
      let loaded = false;
      let lastError = null;

      for (const productJsonUrl of nitrousProductJsonUrls) {
        try {
          const response = await fetchJsonWithTimeout(productJsonUrl, 7000);
          if (!response.ok) throw new Error(productJsonUrl + ' HTTP ' + response.status);
          const product = await response.json();
          const variants = Array.isArray(product.variants) ? product.variants : [];
          if (variants.length === 0) throw new Error(productJsonUrl + ' loaded with no variants.');
          if (String(product.id || '') !== nitrousProductId) {
            throw new Error(productJsonUrl + ' loaded product ID ' + product.id + ' instead of ' + nitrousProductId + '.');
          }

          nitrousVariantLookup.product = product;
          nitrousVariantLookup.productJsonUrl = productJsonUrl;
          nitrousVariantLookup.variants = variants;
          nitrousVariantLookup.lastMatchDiagnostic = null;
          nitrousVariantLookup.loaded = true;
          nitrousVariantLookup.failed = false;
          nitrousVariantLookup.error = '';
          loaded = true;
          debugLog('nitrous product JSON loaded', {
            product_json_url: productJsonUrl,
            product_id: product.id || '',
            handle: product.handle || '',
            variants: variants.length
          });
          break;
        } catch (error) {
          lastError = error;
          debugLog('nitrous product JSON attempt failed', {
            product_json_url: productJsonUrl,
            error: error && error.message ? error.message : error
          });
        }
      }

      if (!loaded) throw lastError || new Error('Unable to load Nitrous Designer product JSON.');
    } catch (error) {
      nitrousVariantLookup.loaded = false;
      nitrousVariantLookup.failed = true;
      nitrousVariantLookup.error = error && error.message ? error.message : 'Unable to load Nitrous Shopify product JSON.';
      debugLog('nitrous product JSON failed', nitrousVariantLookup.error);
    } finally {
      nitrousVariantLookup.loading = false;
      update();
    }
  }

  function ensureDesignerProductJsonLoaded() {
    if (designerProductJsonRequested || shopifyVariantLookup.loading || shopifyVariantLookup.loaded || shopifyVariantLookup.failed) return;
    designerProductJsonRequested = true;
    loadDesignerProductJson();
  }

  function ensureDcpProductJsonLoaded() {
    if (dcpProductJsonRequested || dcpVariantLookup.loading || dcpVariantLookup.loaded || dcpVariantLookup.failed) return;
    dcpProductJsonRequested = true;
    loadDcpProductJson();
  }

  function ensureNitrousProductJsonLoaded() {
    if (nitrousProductJsonRequested || nitrousVariantLookup.loading || nitrousVariantLookup.loaded || nitrousVariantLookup.failed) return;
    nitrousProductJsonRequested = true;
    loadNitrousProductJson();
  }

  function pricingFor(size, material, lamination, quantity, matchedVariant) {
    if (isBlankCanvasMode(controls.template ? controls.template.value : '')) {
      const minimumPackageQty = quantityDefaultForSize(size);
      const basePackagePrice = matchedVariant ? variantPriceDollars(matchedVariant) : NaN;
      const noLaminationVariant = dcpNoLaminationVariant(size, material);
      const noLaminationPackagePrice = variantPriceDollars(noLaminationVariant);

      if (!size || !material || !lamination || !quantity || !minimumPackageQty ||
          !Number.isFinite(basePackagePrice) || !Number.isFinite(noLaminationPackagePrice)) {
        return {
          ready: false,
          enforcement_ready: false,
          enforcement_failure: 'DCP package pricing could not be resolved from Shopify.',
          pricing_model: dcpPricingModelName,
          base_package_price: '',
          default_quantity: minimumPackageQty || '',
          minimum_package_qty: minimumPackageQty || '',
          quantity: quantity || '',
          extra_piece_count: 0,
          extra_piece_price: '',
          additional_charge: '',
          lamination_add_on: '',
          subtotal: '',
          subtotal_display: 'Pricing unavailable'
        };
      }

      const extraPieceCount = quantity - minimumPackageQty;
      const extraPiecePrice = roundMoney((noLaminationPackagePrice / minimumPackageQty) * 0.75);
      const additionalCharge = roundMoney(extraPieceCount * extraPiecePrice);
      const laminationAddOn = roundMoney(basePackagePrice - noLaminationPackagePrice);
      const extraPieceVariantId = extraPieceCount > 0 ? dcpExtraPieceVariantId(size, material) : '';
      const enforcementReady = extraPieceCount === 0 || Boolean(extraPieceVariantId);
      return {
        ready: Boolean(matchedVariant && matchedVariant.available !== false),
        enforcement_ready: enforcementReady,
        enforcement_failure: enforcementReady
          ? ''
          : 'DCP additional-piece pricing is not configured for ' + dcpExtraPieceMapKey(size, material) + '.',
        pricing_model: dcpPricingModelName,
        base_package_price: basePackagePrice,
        no_lamination_package_price: noLaminationPackagePrice,
        default_quantity: minimumPackageQty,
        minimum_package_qty: minimumPackageQty,
        quantity: quantity,
        extra_piece_count: extraPieceCount,
        extra_piece_price: extraPiecePrice,
        extra_piece_variant_id: extraPieceVariantId,
        surcharge_key: dcpExtraPieceMapKey(size, material),
        additional_charge: additionalCharge,
        lamination_add_on: laminationAddOn,
        subtotal: roundMoney(basePackagePrice + additionalCharge),
        subtotal_display: money(roundMoney(basePackagePrice + additionalCharge))
      };
    }

    if (isNitrousMode(controls.template ? controls.template.value : '')) {
      const profile = selectedNitrousBottleProfile();
      const templateChoice = selectedNitrousTemplateChoice();
      const materialKey = pricingMaterialKey(material);
      const minimumPackageQty = profile.defaultQuantity;
      const basePackagePrice = profile.materialPackagePrices[materialKey] !== undefined
        ? profile.materialPackagePrices[materialKey]
        : profile.packagePrice;
      const laminationAddOn = pricingLaminationKey(lamination) === 'laminated' ? 4.25 : 0;
      const blackTemplateAddOn = templateChoice && templateChoice.blackSurcharge ? 1 : 0;
      const packagePrice = roundMoney(basePackagePrice + laminationAddOn + blackTemplateAddOn);

      if (!materialKey || !lamination || !quantity || !minimumPackageQty || !Number.isFinite(packagePrice)) {
        return {
          ready: false,
          pricing_model: 'SRD Designer Nitrous Package Pricing',
          base_package_price: '',
          material_package_price: '',
          default_quantity: minimumPackageQty || '',
          minimum_package_qty: minimumPackageQty || '',
          quantity: quantity || '',
          extra_piece_count: 0,
          extra_piece_price: '',
          lamination_add_on: '',
          black_template_add_on: '',
          subtotal: '',
          subtotal_display: 'Complete selections'
        };
      }

      return {
        ready: true,
        pricing_model: 'SRD Designer Nitrous Package Pricing',
        base_package_price: packagePrice,
        material_package_price: basePackagePrice,
        default_quantity: minimumPackageQty,
        minimum_package_qty: minimumPackageQty,
        quantity: quantity,
        extra_piece_count: 0,
        extra_piece_price: '',
        lamination_add_on: laminationAddOn,
        black_template_add_on: blackTemplateAddOn,
        subtotal: packagePrice,
        subtotal_display: money(packagePrice)
      };
    }

    const minimumPackageQty = quantityDefaultForSize(size);
    const basePackagePrice = lockedPackagePriceFor(size, material, lamination);

    if (!size || !material || !lamination || !quantity || !minimumPackageQty || !Number.isFinite(basePackagePrice)) {
      return {
        ready: false,
        pricing_model: pricingModelName,
        base_package_price: '',
        default_quantity: minimumPackageQty || '',
        minimum_package_qty: minimumPackageQty || '',
        quantity: quantity || '',
        extra_piece_count: 0,
        extra_piece_price: '',
        lamination_add_on: '',
        subtotal: '',
        subtotal_display: 'Complete selections'
      };
    }

    const extraPieceCount = Math.max(0, quantity - minimumPackageQty);
    const proportionalMultiplier = quantity / minimumPackageQty;
    const subtotal = roundMoney(basePackagePrice * proportionalMultiplier);
    const extraPiecePrice = extraPieceCount > 0 ? roundMoney((subtotal - basePackagePrice) / extraPieceCount) : '';

    return {
      ready: true,
      pricing_model: pricingModelName,
      base_package_price: basePackagePrice,
      default_quantity: minimumPackageQty,
      minimum_package_qty: minimumPackageQty,
      quantity: quantity,
      extra_piece_count: extraPieceCount,
      extra_piece_price: extraPiecePrice,
      lamination_add_on: 0,
      proportional_multiplier: proportionalMultiplier,
      subtotal: subtotal,
      subtotal_display: money(subtotal)
    };
  }

  function variantSelectionFor(size, material, lamination, pricing, matchedVariant) {
    if (isBlankCanvasMode(controls.template ? controls.template.value : '')) {
      const dcpVariant = matchedDcpVariant(size, material, lamination);
      if (dcpVariant) {
        const productIdMatches = dcpVariantLookup.product && String(dcpVariantLookup.product.id || '') === dcpProductId;
        return {
          ready: Boolean(productIdMatches && pricing && pricing.ready && pricing.enforcement_ready && dcpVariant.available !== false),
          mode: 'dcp_product_json',
          source: 'Custom DCP Order',
          product_id: dcpVariantLookup.product ? dcpVariantLookup.product.id || '' : '',
          product_handle: dcpVariantLookup.product ? dcpVariantLookup.product.handle || 'custom-dcp-order' : 'custom-dcp-order',
          variant_id: String(dcpVariant.id || ''),
          sku: dcpVariant.sku || '',
          price: variantPriceDollars(dcpVariant),
          price_display: pricing && pricing.subtotal_display ? pricing.subtotal_display : money(variantPriceDollars(dcpVariant)),
          available: Boolean(productIdMatches && dcpVariant.available !== false),
          failure: !productIdMatches
            ? 'Custom DCP Order product ID guard failed.'
            : (dcpVariant.available === false
                ? 'Matched DCP variant is unavailable.'
                : (pricing && !pricing.enforcement_ready ? pricing.enforcement_failure : 'None'))
        };
      }
      if (dcpVariantLookup.loading) {
        return {
          ready: false,
          mode: 'dcp_product_json',
          source: 'Custom DCP Order',
          product_id: '',
          variant_id: '',
          sku: '',
          price: NaN,
          price_display: '--',
          available: false,
          failure: 'Loading Custom DCP Order variants.'
        };
      }
      return {
        ready: false,
        mode: 'dcp_product_json',
        source: 'Custom DCP Order',
        product_id: '',
        variant_id: '',
        sku: '',
        price: NaN,
        price_display: '--',
        available: false,
        failure: dcpVariantLookup.failed
          ? 'Custom DCP Order product JSON failed to load: ' + dcpVariantLookup.error
          : 'No DCP variant matched this Size / Material / Lamination selection.'
      };
    }

    if (isNitrousMode(controls.template ? controls.template.value : '')) {
      const nitrousVariant = matchedNitrousVariant(material, lamination);
      if (nitrousVariant) {
        return {
          ready: Boolean(pricing && pricing.ready && nitrousVariant.available !== false),
          mode: 'nitrous_product_json',
          source: 'Custom Nitrous Bottle Label Order',
          product_id: nitrousProductId,
          variant_id: String(nitrousVariant.id || ''),
          sku: nitrousVariant.sku || '',
          price: pricing && pricing.ready ? pricing.subtotal : variantPriceDollars(nitrousVariant),
          price_display: pricing && pricing.ready ? money(pricing.subtotal) : money(variantPriceDollars(nitrousVariant)),
          available: nitrousVariant.available !== false,
          failure: nitrousVariant.available === false ? 'Matched Nitrous variant is unavailable.' : 'None'
        };
      }
      if (nitrousVariantLookup.loading) {
        return {
          ready: false,
          mode: 'nitrous_product_json',
          source: 'Custom Nitrous Bottle Label Order',
          product_id: nitrousProductId,
          variant_id: '',
          sku: '',
          price: NaN,
          price_display: '--',
          available: false,
          failure: 'Loading Custom Nitrous Bottle Label Order variants.'
        };
      }
      return {
        ready: false,
        mode: 'nitrous_product_json',
        source: 'Custom Nitrous Bottle Label Order',
        product_id: nitrousProductId,
        variant_id: '',
        sku: '',
        price: NaN,
        price_display: '--',
        available: false,
        failure: nitrousVariantLookup.failed
          ? 'Custom Nitrous Bottle Label Order lookup failed: ' + nitrousVariantLookup.error
          : 'No exact Nitrous variant matched option1 / option2 / option3. ' + nitrousVariantDiagnosticText()
      };
    }

    if (matchedVariant) {
      return {
        ready: Boolean(pricing && pricing.ready && matchedVariant.available !== false),
        mode: pricingModeName,
        source: 'Shopify Product JSON',
        variant_id: String(matchedVariant.id || ''),
        sku: matchedVariant.sku || '',
        price: variantPriceDollars(matchedVariant),
        price_display: money(variantPriceDollars(matchedVariant)),
        available: matchedVariant.available !== false,
        failure: matchedVariant.available === false ? 'Matched Shopify variant is unavailable.' : 'None'
      };
    }

    if (shopifyVariantLookup.loading) {
      return {
        ready: false,
        mode: pricingModeName,
        source: 'Shopify Product JSON',
        variant_id: '',
        sku: '',
        price: NaN,
        price_display: '--',
        available: false,
        failure: 'Loading Shopify Designer product variants.'
      };
    }

    if (shopifyVariantLookup.failed && hasFallbackVariant()) {
      const fallbackAvailable = true;
      return {
        ready: Boolean(pricing && pricing.ready && fallbackAvailable),
        mode: emergencyFallbackModeName,
        source: 'Emergency fallback',
        variant_id: root.dataset.srdFallbackVariantId.trim(),
        sku: '',
        price: pricing && pricing.ready ? pricing.base_package_price : NaN,
        price_display: pricing && pricing.ready ? money(pricing.base_package_price) : '--',
        available: fallbackAvailable,
        failure: fallbackAvailable ? 'None' : 'Emergency fallback variant is unavailable.'
      };
    }

    return {
      ready: false,
      mode: pricingModeName,
      source: 'Shopify Product JSON',
      variant_id: '',
      sku: '',
      price: NaN,
      price_display: '--',
      available: false,
      failure: shopifyVariantLookup.failed
        ? 'Shopify product JSON failed to load and emergency fallback is not configured.'
        : 'No Shopify variant matched this Size / Material / Lamination selection.'
    };
  }

  function updateVariantLookupDiagnostics(selection, subtotal) {
    const statusTotal = selection && Number.isFinite(selection.price) ? selection.price_display : subtotal;
    if (!calibrationMode || !selection) return;
    if (targets.debugPricingMode) targets.debugPricingMode.textContent = selection.mode || pricingModeName;
    if (targets.debugPricingMapRequired) targets.debugPricingMapRequired.textContent = 'no';
    if (targets.debugBaseVariant) targets.debugBaseVariant.textContent = selection.sku || 'None';
    if (targets.debugLaminationVariant) targets.debugLaminationVariant.textContent = selection.price_display || '--';
    if (targets.debugExtraVariant) {
      targets.debugExtraVariant.textContent = shopifyVariantLookup.loaded
        ? 'Loaded'
        : (shopifyVariantLookup.failed ? 'Failed: ' + shopifyVariantLookup.error : 'Loading');
    }
    if (targets.debugExpectedTotal) targets.debugExpectedTotal.textContent = statusTotal || '--';
  }

  function updatePricingDisplay(pricing, quantity) {
    const blankCanvasMode = isBlankCanvasMode(controls.template ? controls.template.value : '');
    const dieCuttingMode = isDieCuttingMode();
    if (targets.pricingDetails) targets.pricingDetails.hidden = false;
    if (targets.pricingSubtotal) {
      targets.pricingSubtotal.textContent = dieCuttingMode
        ? money(pricing.unit_price_cents / 100)
        : pricing.subtotal_display;
    }
    if (targets.pricingTotalLabel) targets.pricingTotalLabel.textContent = dieCuttingMode ? 'Unit Price' : (blankCanvasMode ? 'Finished Price' : 'Estimated Total');
    if (targets.pricingPackageRow) targets.pricingPackageRow.hidden = blankCanvasMode;
    if (targets.pricingPackagePrice) targets.pricingPackagePrice.textContent = pricing.ready ? money(pricing.base_package_price) : '--';
    if (targets.pricingQuantityLabel) targets.pricingQuantityLabel.textContent = blankCanvasMode ? 'Quantity' : 'Selected Quantity';
    if (targets.pricingQuantity) {
      targets.pricingQuantity.textContent = pricing.ready
        ? (blankCanvasMode ? String(quantity) : formatQuantity(quantity))
        : 'Quantity required';
    }

    if (targets.pricingExtraRow) {
      targets.pricingExtraRow.hidden = blankCanvasMode || !pricing.ready;
    }
    if (targets.pricingExtraPieces) {
      targets.pricingExtraPieces.textContent = pricing.ready
        ? pricing.minimum_package_qty + ' pcs'
        : '--';
    }
    if (targets.pricingAddOns) {
      const hasDieTextCharge = dieCuttingMode && pricing.ready && pricing.additional_text_surcharge_cents > 0;
      const hasAdditionalCharges = hasDieTextCharge
        || (blankCanvasMode && !dieCuttingMode && pricing.ready && pricing.extra_piece_count > 0);
      if (targets.pricingAddOnsRow) targets.pricingAddOnsRow.hidden = !hasAdditionalCharges;
      if (targets.pricingAddOnsLabel) {
        targets.pricingAddOnsLabel.textContent = hasDieTextCharge
          ? 'Additional Text'
          : (blankCanvasMode ? 'Additional Pieces' : 'Additional Charges');
      }
      targets.pricingAddOns.textContent = hasDieTextCharge
        ? pricing.additional_text_object_count + ' @ ' + money(pricing.additional_text_unit_cents / 100) + ' each'
        : (hasAdditionalCharges
            ? pricing.extra_piece_count + ' @ ' + money(pricing.extra_piece_price) + ' each'
            : '--');
    }
    if (targets.dieOrderingStatus) targets.dieOrderingStatus.hidden = !dieCuttingMode || !isDcpCartTestingLockout();
  }

  function isComplete(value) {
    return value !== undefined && value !== null && String(value).trim() !== '';
  }

  function requiredFieldsComplete(message, quantity) {
    const nitrousMode = isNitrousMode(controls.template.value);
    const blankCanvasMode = isBlankCanvasMode(controls.template.value);
    const dieCuttingMode = blankCanvasMode && isDieCuttingMode();
    const dcpProofState = getDcpProofState();
    const trustedDcLibraryArtwork = Boolean(
      dieCuttingMode
      && dcpProofState.catalogArtwork
      && activeDcpCatalogArtwork
      && dcpProofState.catalogArtwork.designId === activeDcpCatalogArtwork.record.designId
      && dcpProofState.catalogArtwork.catalogVersion === dcpDcArtCatalogVersion
    );
    const blankCanvasContent = blankCanvasMode
      ? dcpBlankCanvasContentState(dcpProofState.objects, controls.size.value, dcpProofState)
      : null;
    const blankCanvasHasText = Boolean(blankCanvasContent && blankCanvasContent.hasText);
    const shapeValidation = blankCanvasContent ? blankCanvasContent.shapeValidation : { valid: true, present: false };
    const symbolValidation = blankCanvasContent ? blankCanvasContent.symbolValidation : { valid: true, present: false, ready: true };
    const blankCanvasHasContent = !blankCanvasMode || hasValidBlankCanvasContent(dcpProofState.objects, controls.size.value, dcpProofState);
    return Boolean(
      isComplete(controls.template.value) &&
      (nitrousMode
        ? isComplete(selectedNitrousBottleWeight())
        : (dieCuttingMode ? readDcpDimensionControls().valid : isComplete(controls.size.value))) &&
      (!nitrousMode || isComplete(controls.nitrousHeader.value)) &&
      (!isNitrousCustomArtSelected() || hasSupportedNitrousCustomArtUpload()) &&
      (!nitrousMode || isComplete(controls.nitrousTemplate.value)) &&
      (!blankCanvasMode || isComplete(selectedBlankCanvasStartMode())) &&
      (!blankCanvasMode || !dcpCartEditSession.active || dcpCartEditSession.status === 'resolved') &&
      (!blankCanvasMode || trustedDcLibraryArtwork || blankCanvasContent.artworkFileReady) &&
      (dieCuttingMode || isComplete(controls.material.value)) &&
      (dieCuttingMode || isComplete(controls.lamination.value)) &&
      (nitrousMode || blankCanvasMode || isComplete(controls.font.value)) &&
      (nitrousMode || blankCanvasMode || isComplete(selectedFontColor())) &&
      (nitrousMode || blankCanvasMode || isComplete(message)) &&
      (!blankCanvasMode || shapeValidation.valid) &&
      (!blankCanvasMode || (symbolValidation.valid && (!symbolValidation.present || symbolValidation.ready))) &&
      blankCanvasHasContent &&
      (dieCuttingMode ? (Number.isInteger(Number(quantity)) && Number(quantity) > 0) : isComplete(quantity)) &&
      Boolean(controls.confirmation && controls.confirmation.checked)
    );
  }

  function validationFailure(message, quantity, pricing, pricingVariants) {
    const nitrousMode = isNitrousMode(controls.template.value);
    const blankCanvasMode = isBlankCanvasMode(controls.template.value);
    const dieCuttingMode = blankCanvasMode && isDieCuttingMode();
    const dcpProofState = getDcpProofState();
    const trustedDcLibraryArtwork = Boolean(
      dieCuttingMode
      && dcpProofState.catalogArtwork
      && activeDcpCatalogArtwork
      && dcpProofState.catalogArtwork.designId === activeDcpCatalogArtwork.record.designId
      && dcpProofState.catalogArtwork.catalogVersion === dcpDcArtCatalogVersion
    );
    if (!nitrousMode && !blankCanvasMode && shopifyVariantLookup.failed && !hasFallbackVariant()) return 'Shopify product JSON failed to load and emergency fallback variant ID is not configured.';
    if (!nitrousMode && !blankCanvasMode && !hasConfiguredVariant()) return 'Selected Designer product has no resolved default variant ID.';
    if (!nitrousMode && !blankCanvasMode && !hasAvailableVariant()) return 'Resolved Designer variant is not available.';
    if (!isComplete(controls.template.value)) return 'Template required.';
    if (nitrousMode) {
      if (!isComplete(selectedNitrousBottleWeight())) return 'Bottle Weight required.';
      if (!isComplete(controls.nitrousHeader.value)) return 'Header option required.';
      if (isNitrousCustomArtSelected() && !hasUploadedNitrousCustomArt()) return 'Custom Art upload required.';
      if (isNitrousCustomArtSelected() && !hasSupportedNitrousCustomArtUpload()) return 'Custom Art file type must be EPS, SVG, or PNG.';
      if (!isComplete(controls.nitrousTemplate.value)) return 'Nitrous template required.';
    } else if (blankCanvasMode) {
      if (dcpCartEditSession.active && dcpCartEditSession.status !== 'resolved') {
        return dcpCartEditSession.failure || 'Verifying the original cart design before it can be updated.';
      }
      if (dieCuttingMode) {
        const dimensions = readDcpDimensionControls();
        if (!dimensions.valid) return dimensions.message || 'Valid finished dimensions required.';
      } else if (!isComplete(controls.size.value)) return 'Size required.';
      const content = dcpBlankCanvasContentState(dcpProofState.objects, controls.size.value, dcpProofState);
      const shapeValidation = content.shapeValidation;
      if (!shapeValidation.valid) return 'Shape could not be used: ' + shapeValidation.message + ' Remove and re-add the Shape.';
      if (!content.symbolValidation.valid) return 'Symbol could not be used: ' + content.symbolValidation.message;
      if (content.symbolValidation.present && !content.symbolValidation.ready) return 'The selected Symbol artwork is still loading. Please try again.';
      if (!isComplete(selectedBlankCanvasStartMode())) return 'Artwork mode required.';
      if (content.hasArtwork && !trustedDcLibraryArtwork && !dcpProductionArtworkReady()) return dcpArtworkReselectionGuidance;
      if (content.hasArtwork && !trustedDcLibraryArtwork && !(dcpProofState.filename || dcpProofState.name || dcpProofState.originalFilename)) return 'Artwork upload required.';
      if (content.hasArtwork && !trustedDcLibraryArtwork && !dcpProofState.supported) return 'Artwork file type must be EPS, AI, PDF, SVG, PNG, JPG, JPEG, WEBP, GIF, or BMP.';
      if (!hasValidBlankCanvasContent(content.objects, controls.size.value, dcpProofState)) {
        return isDieCuttingMode()
          ? 'Add at least one text object.'
          : 'Add text, a Header, a Shape, a Symbol, or upload artwork before adding this DCP proof.';
      }
      if (pricing && pricing.ready && !pricing.enforcement_ready) return pricing.enforcement_failure;
    } else if (!isComplete(controls.size.value)) return 'Size required.';
    if (!dieCuttingMode && !isComplete(controls.material.value)) return 'Material required.';
    if (!dieCuttingMode && !isComplete(controls.lamination.value)) return 'Lamination required.';
    if (!nitrousMode && !blankCanvasMode && !isComplete(controls.font.value)) return 'Font required.';
    if (!nitrousMode && !blankCanvasMode && !isComplete(selectedFontColor())) return 'Font color required.';
    if (!nitrousMode && !blankCanvasMode && !isComplete(message)) return 'Customer message required.';
    if (dieCuttingMode && (!Number.isInteger(Number(quantity)) || Number(quantity) < 1)) return 'Valid positive whole-number quantity required.';
    if (!dieCuttingMode && !isComplete(quantity)) return 'Valid quantity required.';
    if (!controls.confirmation || !controls.confirmation.checked) return 'Design proof confirmation required.';
    if (pricing && !pricing.ready) return 'Pricing incomplete.';
    if (pricingVariants && !pricingVariants.ready) return pricingVariants.failure;
    return 'None';
  }

  function setDebugStatus(valid, failure, cartStatus) {
    if (!calibrationMode) return;
    if (targets.debugProduct) targets.debugProduct.textContent = hasConfiguredProduct() ? 'Yes' : 'No';
    if (targets.debugFallbackVariant) targets.debugFallbackVariant.textContent = hasFallbackVariant() ? root.dataset.srdFallbackVariantId : 'None';
    if (targets.debugVariantId) targets.debugVariantId.textContent = hasConfiguredVariant() ? targets.variantId.value : 'None';
    if (targets.debugVariantSource) targets.debugVariantSource.textContent = root.dataset.srdVariantSource || 'None';
    if (targets.debugVariantAvailable) targets.debugVariantAvailable.textContent = hasAvailableVariant() ? 'Yes' : 'No';
    if (targets.debugValid) targets.debugValid.textContent = valid ? 'Yes' : 'No';
    if (targets.debugFailure) targets.debugFailure.textContent = failure || 'None';
    if (cartStatus && targets.debugCartStatus) targets.debugCartStatus.textContent = cartStatus;
  }

  function debugLog(label, details) {
    if (!calibrationMode || !window.console) return;
    window.console.info('[SRD Designer] ' + label, details || '');
  }

  function setDebugValue(target, value) {
    if (!calibrationMode || !target) return;
    target.value = value || '';
  }

  function setDebugText(target, value) {
    if (!calibrationMode || !target) return;
    target.textContent = value || 'None';
  }

  function setCartDebugDetails(details) {
    if (!calibrationMode || !details) return;
    if (details.payload !== undefined) {
      setDebugValue(targets.debugCartPayload, JSON.stringify(details.payload, null, 2));
    }
    if (details.httpStatus !== undefined) {
      setDebugText(targets.debugHttpStatus, String(details.httpStatus));
    }
    if (details.shopifyMessage !== undefined) {
      setDebugText(targets.debugShopifyMessage, details.shopifyMessage || 'None');
    }
    if (details.responseJson !== undefined) {
      setDebugValue(targets.debugResponseJson, details.responseJson ? JSON.stringify(details.responseJson, null, 2) : '');
    }
    if (details.responseText !== undefined) {
      setDebugValue(targets.debugResponseText, details.responseText || '');
    }
  }

  function setCartMessage(message, type) {
    if (!targets.cartMessage) return;
    targets.cartMessage.textContent = message || '';
    targets.cartMessage.setAttribute('data-srd-cart-message-type', type || 'neutral');
  }

  function imageAlreadyUsesSource(image, src) {
    if (!image || !src) return false;
    return image.getAttribute('src') === src || image.currentSrc === src || image.src === src;
  }

  function setImageSourceIfChanged(image, src, alt) {
    if (!image) return;
    if (!src) {
      image.hidden = true;
      if (image.getAttribute('src')) image.removeAttribute('src');
      image.alt = '';
      return;
    }
    image.hidden = false;
    image.alt = alt || '';
    if (!imageAlreadyUsesSource(image, src)) {
      image.src = src;
    }
  }

  function syncCartReadinessMessage(mode, failure, readyForCart) {
    if (!targets.cartMessage || cartAddInProgress) return;
    if (mode === 'none') {
      setCartMessage('', 'neutral');
      return;
    }
    if (readyForCart) {
      if (!['success', 'error'].includes(targets.cartMessage.getAttribute('data-srd-cart-message-type'))) {
        setCartMessage('', 'neutral');
      }
      return;
    }
    const failureText = failure || '';
    const shouldShowLookupStatus =
      failureText.indexOf('Loading ') === 0 ||
      failureText.indexOf('lookup failed') !== -1 ||
      failureText.indexOf('failed to load') !== -1 ||
      failureText.indexOf('No Shopify variant matched') !== -1 ||
      failureText.indexOf('No DCP variant matched') !== -1 ||
      failureText.indexOf('No Nitrous variant matched') !== -1 ||
      failureText.indexOf('No exact Nitrous variant matched') !== -1 ||
      failureText.indexOf('DCP additional-piece pricing is not configured') !== -1 ||
      failureText.indexOf('route is not configured') !== -1 ||
      failureText.indexOf('variant is unavailable') !== -1 ||
      failureText.indexOf('DCP testing mode') !== -1 ||
      failureText.indexOf('Die Cutting development preview') !== -1 ||
      failureText.indexOf('DC ') === 0 ||
      failureText.indexOf('certified') !== -1 ||
      failureText.indexOf('approved') !== -1 ||
      failureText.indexOf('meaningful painted height') !== -1 ||
      failureText.indexOf('Verifying the original cart design') !== -1 ||
      failureText.indexOf('original cart') !== -1 ||
      failureText.indexOf('edit session') !== -1 ||
      failureText.indexOf('Shape could not be used') !== -1 ||
      failureText.indexOf('Symbol') !== -1 ||
      failureText.indexOf('no resolved default variant ID') !== -1 ||
      (dcpCartEditSession.active && failureText !== 'None');
    if (shouldShowLookupStatus) {
      setCartMessage(
        failureText,
        failureText.indexOf('Loading ') === 0 || failureText.indexOf('Verifying the original cart design') === 0 ? 'neutral' : 'error'
      );
    } else if (!['success', 'error'].includes(targets.cartMessage.getAttribute('data-srd-cart-message-type'))) {
      setCartMessage('', 'neutral');
    }
  }

  function hasConfiguredVariant() {
    return Boolean(targets.variantId && targets.variantId.value);
  }

  function hasConfiguredProduct() {
    return root.dataset.srdHasDesignerProduct === 'true';
  }

  function hasFallbackVariant() {
    return Boolean(root.dataset.srdFallbackVariantId && root.dataset.srdFallbackVariantId.trim());
  }

  function hasAvailableVariant() {
    return root.dataset.srdDesignerVariantAvailable === 'true';
  }

  function compactDcpCartProperties(properties) {
    return Object.keys(properties || {}).reduce((result, key) => {
      const value = properties[key];
      if (!key || value === undefined || value === null || value === '') return result;
      result[key] = value;
      return result;
    }, {});
  }

  function dcpPricingIntegrityProperties(data) {
    if (!data || data.selected_template_category !== 'blank_canvas') return {};
    return compactDcpCartProperties({
      '_DCP Minimum Package Quantity': String(data.minimum_package_qty || ''),
      '_DCP Additional Pieces': String(data.extra_piece_count || 0),
      '_DCP Additional Piece Price Cents': data.extra_piece_price === '' || data.extra_piece_price === undefined
        ? ''
        : String(Math.round(Number(data.extra_piece_price) * 100)),
      '_DCP Surcharge Variant ID': String(data.extra_piece_variant_id || ''),
      '_DCP Surcharge Key': String(data.surcharge_key || ''),
      '_DCP Base Package Price Cents': data.base_package_price === '' || data.base_package_price === undefined
        ? ''
        : String(Math.round(Number(data.base_package_price) * 100)),
      '_DCP Finished Price Cents': data.subtotal === '' || data.subtotal === undefined
        ? ''
        : String(Math.round(Number(data.subtotal) * 100))
    });
  }

  function serializeDcpDieProofForCart(data) {
    if (!isDieCuttingMode() || !data || normalizeBlankCanvasSubfamily(data.blank_canvas_subfamily) !== 'die_cutting') {
      throw new Error('The active design is not an authorized Custom Die order.');
    }
    const proof = normalizeDcpDieObjectColors(getDcpProofState());
    const stateValidation = dieCuttingStateValidation(proof.objects, proof);
    if (!stateValidation.valid) throw new Error(stateValidation.message);
    const objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
    if (objects.shape || objects.header || objects.symbolObjects.length || (dcpProofHasArtwork(proof) && !proof.catalogArtwork)) {
      throw new Error('Custom Die orders must contain text only or one certified DC Art Library artwork plus text.');
    }
    const contract = buildDcpDieProductionContract(objects, proof);
    if (!contract || !contract.eligibility || contract.eligibility.status !== 'ready') {
      throw new Error(contract && contract.eligibility && contract.eligibility.failures && contract.eligibility.failures.length
        ? contract.eligibility.failures.map((issue) => issue.message || issue.detail || issue.code).join(' ')
        : 'Trusted Custom Die production geometry is not ready.');
    }
    const pricingContract = {
      model: String(data.pricing_model || ''),
      textObjectCount: objects.textObjects.length,
      includedTextObjectCount: Number(data.included_text_object_count || 0),
      additionalTextObjectCount: Number(data.additional_text_object_count || 0),
      additionalTextUnitCents: Number(data.additional_text_unit_cents || 0),
      additionalTextSurchargeCents: Number(data.additional_text_surcharge_cents || 0),
      unitPriceCents: Math.round(Number(data.matched_variant_price || 0) * 100),
      finishedQuantity: Number(data.quantity || 0),
      finishedPriceCents: Math.round(Number(data.subtotal || 0) * 100)
    };
    const dcArtContract = proof.catalogArtwork
      ? buildDcpDcArtProductionContract(proof, objects, contract)
      : null;
    return {
      proof: proof,
      objects: objects,
      contract: { ...contract, pricing: pricingContract },
      dcArtContract: dcArtContract ? { ...dcArtContract, pricing: pricingContract } : null,
      physicalCanvas: normalizeDcpPhysicalCanvas(proof.physicalCanvas)
    };
  }

  function dcpDiePricingIntegrityProperties(data) {
    return compactDcpCartProperties({
      '_DCP Pricing Model': String(data.pricing_model || ''),
      '_DCP Unit Price Cents': String(Math.round(Number(data.matched_variant_price || 0) * 100)),
      '_DCP Finished Price Cents': String(Math.round(Number(data.subtotal || 0) * 100)),
      '_DCP Finished Quantity': String(data.quantity || ''),
      '_DCP Price Variant ID': String(data.matched_variant_id || ''),
      '_DCP Price Key': String(data.surcharge_key || ''),
      '_DCP Text Object Count': String(data.text_object_count || 0),
      '_DCP Included Text Objects': String(data.included_text_object_count || 0),
      '_DCP Additional Text Objects': String(data.additional_text_object_count || 0),
      '_DCP Additional Text Unit Cents': String(data.additional_text_unit_cents || 0),
      '_DCP Additional Text Surcharge Cents': String(data.additional_text_surcharge_cents || 0)
    });
  }

  function buildCartProperties(data) {
    if (data.selected_template_category === 'blank_canvas') {
      if (data.product_family_key === 'custom_die_cut_design'
        || normalizeBlankCanvasSubfamily(data.blank_canvas_subfamily) === 'die_cutting') {
        const dieProof = serializeDcpDieProofForCart(data);
        const colors = dcpDieVinylColorsLabel(dieProof.objects, dieProof.proof);
        return compactDcpCartProperties({
          ...dcpTextCartProperties(dieProof.objects, 'die_cutting'),
          'Product Family': 'Custom Die-Cut Vinyl Lettering',
          Size: dcpPhysicalCanvasLabel(dieProof.physicalCanvas),
          Width: String(dieProof.physicalCanvas.width) + ' in',
          Height: String(dieProof.physicalCanvas.height) + ' in',
          Quantity: String(data.quantity || ''),
          'VINYL COLORS': colors,
          'Transfer Tape': 'Included',
          'Text Object Count': String(dieProof.objects.textObjects.length),
          'Additional Text Objects': String(data.additional_text_object_count || 0),
          'Additional Text Charge': money(Number(data.additional_text_surcharge_cents || 0) / 100),
          _SRDDESIGNER: 'true',
          '_SRD Designer Build': 'v4.5.3-development',
          '_Template Key': 'blank_canvas',
          '_Blank Canvas Subfamily Key': 'die_cutting',
          '_dcp_canvas_objects': JSON.stringify(dieProof.objects),
          '_dcp_physical_canvas': JSON.stringify(dieProof.physicalCanvas),
          '_dcp_die_production': JSON.stringify(dieProof.contract),
          ...(dieProof.dcArtContract ? {
            'DC Art Library Design': dieProof.dcArtContract.designId,
            'DC Artwork Title': dieProof.dcArtContract.title,
            'DC Artwork Size': String(dieProof.dcArtContract.artSizeInches) + ' in',
            'DC Price Tier': String(dieProof.dcArtContract.priceTierInches) + ' in',
            'DC Finished Envelope': dcpDieRound(dieProof.dcArtContract.finishedEnvelopeInches.width) + ' x ' + dcpDieRound(dieProof.dcArtContract.finishedEnvelopeInches.height) + ' in',
            'DC Installation Space': dcpPhysicalCanvasLabel(dieProof.physicalCanvas),
            'DC Vinyl Color': dieProof.dcArtContract.vinylColor,
            'DC Art Complexity': String(data.dc_art_complexity_tier || ''),
            'DC Text Labor': String(data.text_object_count || 0) + ' @ ' + money(Number(data.dc_art_text_labor_unit_cents || 0) / 100),
            '_DCP DC Art Catalog Version': dieProof.dcArtContract.catalogVersion,
            '_DCP DC Art Pricing Formula': 'trusted fixed-art base at certified artwork size plus text-object labor by finished-envelope height',
            '_dcp_dc_art_production': JSON.stringify(dieProof.dcArtContract)
          } : {}),
          '_Matched Variant ID': data.matched_variant_id || '',
          ...dcpDiePricingIntegrityProperties(data)
        });
      }
      const dcpProofProperties = serializeDcpProofForCart();
      const properties = {
        ...dcpTextCartProperties(data.dcp_canvas_objects),
        ...(dcpProofProperties.Header ? { Header: dcpProofProperties.Header } : {}),
        ...(dcpProofProperties._dcp_header_production
          ? { '_dcp_header_production': dcpProofProperties._dcp_header_production }
          : {}),
        ...(dcpProofProperties.Shape ? { Shape: dcpProofProperties.Shape } : {}),
        ...(dcpProofProperties.Symbols ? { Symbols: dcpProofProperties.Symbols } : {}),
        ...(dcpProofProperties._dcp_symbol_production
          ? { '_dcp_symbol_production': dcpProofProperties._dcp_symbol_production }
          : {}),
        'Product Family': 'Blank Canvas',
        'Blank Canvas Type': data.blank_canvas_subfamily_label || 'Print Design',
        Size: data.size || '',
        Material: data.material || '',
        Lamination: data.lamination || '',
        Quantity: String(data.quantity || ''),
        _SRDDESIGNER: 'true',
        '_SRD Designer Build': 'v1',
        '_Template Key': data.template_key || 'blank_canvas',
        '_Blank Canvas Subfamily Key': normalizeBlankCanvasSubfamily(data.blank_canvas_subfamily),
        '_dcp_canvas_objects': dcpProofProperties._dcp_canvas_objects || '',
        '_Matched Variant ID': data.matched_variant_id || '',
        ...dcpPricingIntegrityProperties(data)
      };

      if (data.blank_canvas_has_artwork) {
        Object.assign(properties, {
          'Artwork File': dcpProofProperties._dcp_original_filename || data.blank_canvas_artwork_filename || '',
          '_Blank Canvas Artwork Mode Key': data.blank_canvas_artwork_mode_key || '',
          '_dcp_original_filename': dcpProofProperties._dcp_original_filename || data.blank_canvas_artwork_filename || '',
          '_dcp_artwork_type': dcpProofProperties._dcp_artwork_type || data.blank_canvas_artwork_type || ''
        });
        const retainedProductionReference = dcpProductionArtworkReferenceForCart();
        if (retainedProductionReference) properties[dcpNativeArtworkPropertyName] = retainedProductionReference;
      }

      if (data.blank_canvas_has_artwork && data.blank_canvas_artwork_status && data.blank_canvas_artwork_status.indexOf('Warning:') === 0) {
        properties['Artwork Status'] = data.blank_canvas_artwork_status;
      }

      return compactDcpCartProperties(properties);
    }

    const properties = {
      _SRDDESIGNER: 'true',
      '_SRD Designer Build': 'v1',
      Template: data.template_label,
      Message: data.customer_message,
      Font: data.font,
      'Font Color': data.font_color,
      'Label Quantity': String(data.quantity),
      'Estimated Subtotal': data.subtotal_display,
      'Product Family': data.product_family || '',
      '_Template Key': data.template_key,
      _Header: data.header,
      '_Finished Size': data.size,
      _Size: data.size,
      _Material: data.material,
      _Lamination: data.lamination,
      '_Minimum Package Qty': String(data.minimum_package_qty || data.default_quantity),
      '_Base Package Price': data.base_package_price_display,
      '_Extra Pieces': String(data.extra_piece_count),
      '_Extra Piece Price': data.extra_piece_price_display,
      '_Lamination Add-On': data.lamination_add_on_display,
      '_Pricing Model': data.pricing_model || pricingModeName,
      '_Matched Variant SKU': data.matched_variant_sku || '',
      '_Matched Variant ID': data.matched_variant_id || '',
      '_Variant Source': data.variant_selection ? data.variant_selection.source || '' : '',
      '_SRD Designer Data': JSON.stringify(data),
      '_Proof Watermark': 'Preview only',
      '_Production Export Watermark': 'false'
    };

    if (data.selected_template_category === 'nitrous') {
      properties['_Selected Template Category'] = 'nitrous';
      properties['Color / Pattern'] = data.nitrous_template_label || '';
      properties['_Nitrous Product ID'] = data.nitrous_product_id || nitrousProductId;
      properties['_Nitrous Template Key'] = data.nitrous_template_key || '';
      properties['_Nitrous Template'] = data.nitrous_template_label || '';
      properties['_Nitrous Template Image URL'] = data.nitrous_template_image_url || '';
      properties['Nitrous Header'] = data.nitrous_header_label || '';
      properties['_Nitrous Header'] = data.nitrous_header_label || '';
      properties['_Nitrous Header Key'] = data.nitrous_header_key || '';
      properties['_Nitrous Header Image URL'] = data.nitrous_header_src || '';
      properties['_Nitrous Bottle Weight'] = data.nitrous_bottle_weight || '';
      properties['_Nitrous Finished Label Size'] = data.nitrous_finished_label_size || '';
      properties['_Nitrous Calibration Profile'] = data.nitrous_calibration_profile || '';
      properties['_Nitrous Weight Values'] = Array.isArray(data.nitrous_weight_values) ? data.nitrous_weight_values.join(' / ') : '';
      properties['_Nitrous Package Quantity'] = String(data.minimum_package_qty || data.default_quantity || '');
      properties['_Nitrous Package Price'] = data.nitrous_package_price_display || '';
      properties['_Nitrous Material'] = data.nitrous_material || '';
      properties['_Nitrous Plain Black Surcharge'] = data.nitrous_plain_black_surcharge_display || '';
      properties['_Nitrous Lamination Add-On'] = data.nitrous_lamination_addon_display || '';
      properties['_Nitrous Estimated Total'] = data.nitrous_estimated_total_display || '';
      properties['Bottle Size'] = data.nitrous_bottle_weight || '';
      properties['Finished Label Size'] = data.nitrous_finished_label_size || '';
      properties['Material'] = data.nitrous_material || data.material || '';
      properties['Lamination'] = data.lamination || '';
      properties['Package Quantity'] = String(data.minimum_package_qty || data.default_quantity || '');
      properties['Package Price'] = data.nitrous_package_price_display || '';
      properties['Lamination Add-On'] = data.nitrous_lamination_addon_display || '';
      properties['Estimated Total'] = data.nitrous_estimated_total_display || '';
      if (data.nitrous_header_key === 'custom_art') {
        properties['Uploaded Artwork Filename'] = data.nitrous_custom_art_filename || '';
        properties['Uploaded Artwork File Reference'] = data.nitrous_custom_art_reference || '';
        properties['Uploaded Artwork Type'] = data.nitrous_custom_art_type || '';
        properties['Uploaded Artwork Dimensions'] = data.nitrous_custom_art_dimensions || '';
        properties['Custom Art Status'] = data.nitrous_custom_art_status || '';
      }
    }

    return properties;
  }

  function buildDesignerAddonProperties(type, data) {
    return {
      _SRDDESIGNER: 'true',
      '_SRD Designer Add-On': type,
      '_SRD Designer Parent': 'Custom Safety Label',
      Template: data.template_label,
      Message: data.customer_message,
      'Label Quantity': String(data.quantity),
      '_Finished Size': data.size,
      _Material: data.material,
      _Lamination: data.lamination
    };
  }

  function buildDesignerCartItems(data, proofProperties) {
    const selection = data.variant_selection;
    const dieCuttingOrder = data.selected_template_category === 'blank_canvas'
      && normalizeBlankCanvasSubfamily(data.blank_canvas_subfamily) === 'die_cutting';
    return [
      {
        id: Number(selection.variant_id),
        quantity: dieCuttingOrder ? Number(data.quantity || 1) : 1,
        properties: {
          ...buildCartProperties(data),
          ...(proofProperties || {})
        }
      }
    ];
  }

  function buildCartPayload(data) {
    const selection = data.variant_selection;
    if (!selection || !selection.ready || !data.ready_for_cart) return null;
    return {
      items: buildDesignerCartItems(data)
    };
  }

  function shouldUseNativeUploadSubmit() {
    const dcpProofState = getDcpProofState();
    return (isNitrousCustomArtSelected() && hasSupportedNitrousCustomArtUpload()) ||
      (isBlankCanvasMode(controls.template.value) &&
        dcpProofHasArtwork(dcpProofState) &&
        dcpProofState.supported === true &&
        dcpProductionArtworkSource.status === 'native_file' &&
        dcpProofState.source === 'upload');
  }

  function setNativeUploadProofProperties(properties) {
    if (!targets.cartForm) return;
    Array.from(targets.cartForm.querySelectorAll('[data-srd-native-proof-property]')).forEach((element) => element.remove());
    Object.keys(properties || {}).forEach((key) => {
      if (!key || properties[key] === undefined || properties[key] === null || properties[key] === '') return;
      if (typeof File === 'function' && properties[key] instanceof File) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + key + ']';
      input.value = String(properties[key]);
      input.setAttribute('data-srd-native-proof-property', 'true');
      targets.cartForm.appendChild(input);
    });
  }

  function prepareDcpNativeUploadSubmit() {
    if (!targets.cartForm || !isBlankCanvasMode(controls.template.value)) return;
    const serializedProperties = serializeDcpProofForCart();
    if (targets.propertyDcpCanvasObjects) targets.propertyDcpCanvasObjects.value = serializedProperties._dcp_canvas_objects || '';
    if (targets.propertyDcpSymbolsLabel) targets.propertyDcpSymbolsLabel.value = serializedProperties.Symbols || '';
    if (targets.propertyDcpSymbolProduction) targets.propertyDcpSymbolProduction.value = serializedProperties._dcp_symbol_production || '';
    const allowedNames = new Set([
      'properties[_SRDDESIGNER]',
      'properties[_SRD Designer Build]',
      'properties[Product Family]',
      'properties[Size]',
      'properties[Material]',
      'properties[Lamination]',
      'properties[Quantity]',
      'properties[Artwork File]',
      'properties[DCP Uploaded Artwork File]',
      'properties[Artwork Status]',
      'properties[Header]',
      'properties[Shape]',
      'properties[Symbols]',
      'properties[_Template Key]',
      'properties[Blank Canvas Type]',
      'properties[_Blank Canvas Subfamily Key]',
      'properties[_Blank Canvas Artwork Mode Key]',
      'properties[_dcp_original_filename]',
      'properties[_dcp_artwork_type]',
      'properties[_dcp_canvas_objects]',
      'properties[_dcp_header_production]',
      'properties[_dcp_symbol_production]',
      'properties[_DCP Final Proof File]',
      'properties[_dcp_cart_edit_token]',
      'properties[_dcp_pricing_group]',
      'properties[_DCP Minimum Package Quantity]',
      'properties[_DCP Additional Pieces]',
      'properties[_DCP Additional Piece Price Cents]',
      'properties[_DCP Surcharge Variant ID]',
      'properties[_DCP Surcharge Key]',
      'properties[_DCP Base Package Price Cents]',
      'properties[_DCP Finished Price Cents]',
      'properties[_Matched Variant ID]',
      'properties[_Proof Image Status]'
    ]);
    Array.from(targets.cartForm.elements || []).forEach((element) => {
      if (!element || !element.name || element.name.indexOf('properties[') !== 0) return;
      const isDcpTextDetail = /^properties\[(Text|Font|Color) [123]( Shape| Arc| Rotation)?\]$/.test(element.name);
      const isNativeArtworkFile = element.name === 'properties[DCP Uploaded Artwork File]' && element.type === 'file';
      element.disabled =
        (!allowedNames.has(element.name) && !isDcpTextDetail) ||
        (isNativeArtworkFile
          ? !(dcpProductionArtworkSource.status === 'native_file' && element.files && element.files.length)
          : !element.value);
    });
  }

  function prepareNitrousNativeUploadSubmit() {
    if (!targets.cartForm || !latestDesignData || latestDesignData.selected_template_category !== 'nitrous') return;
    const allowedNames = new Set(
      Object.entries(buildCartProperties(latestDesignData))
        .filter((entry) => entry[1] !== undefined && entry[1] !== null && entry[1] !== '')
        .map((entry) => 'properties[' + entry[0] + ']')
    );
    allowedNames.add('properties[Uploaded Artwork File]');
    Array.from(targets.cartForm.querySelectorAll('[data-srd-native-proof-property]')).forEach((element) => {
      if (element.name) allowedNames.add(element.name);
    });
    Array.from(targets.cartForm.elements || []).forEach((element) => {
      if (!element || !element.name || element.name.indexOf('properties[') !== 0) return;
      const isNativeArtworkFile = element.name === 'properties[Uploaded Artwork File]' && element.type === 'file';
      element.disabled = !allowedNames.has(element.name) || (!isNativeArtworkFile && !element.value);
    });
  }

  function prepareFamilyNativeUploadSubmit() {
    if (isBlankCanvasMode(controls.template.value)) {
      prepareDcpNativeUploadSubmit();
      return;
    }
    prepareNitrousNativeUploadSubmit();
  }

  function compactProofPreview(data) {
    return JSON.stringify({
      template: data.template_label,
      template_key: data.template_key,
      selected_template_category: data.selected_template_category || '',
      header: data.header,
      message: data.customer_message,
      size: data.size,
      nitrous_template_key: data.nitrous_template_key || '',
      nitrous_template_label: data.nitrous_template_label || '',
      nitrous_header_key: data.nitrous_header_key || '',
      nitrous_header_label: data.nitrous_header_label || '',
      nitrous_custom_art_filename: data.nitrous_custom_art_filename || '',
      nitrous_custom_art_type: data.nitrous_custom_art_type || '',
      nitrous_custom_art_dimensions: data.nitrous_custom_art_dimensions || '',
      nitrous_custom_art_status: data.nitrous_custom_art_status || '',
      nitrous_bottle_weight: data.nitrous_bottle_weight || '',
      nitrous_finished_label_size: data.nitrous_finished_label_size || '',
      nitrous_calibration_profile: data.nitrous_calibration_profile || '',
      nitrous_weight_values: data.nitrous_weight_values || [],
      blank_canvas_subfamily: normalizeBlankCanvasSubfamily(data.blank_canvas_subfamily),
      blank_canvas_artwork_mode: data.blank_canvas_artwork_mode || '',
      blank_canvas_artwork_filename: data.blank_canvas_artwork_filename || '',
      blank_canvas_artwork_type: data.blank_canvas_artwork_type || '',
      blank_canvas_artwork_dimensions: data.blank_canvas_artwork_dimensions || '',
      blank_canvas_artwork_status: data.blank_canvas_artwork_status || '',
      dcp_header_label: data.dcp_header_label || '',
      dcp_canvas_objects: data.dcp_canvas_objects || null,
      material: data.material,
      lamination: data.lamination,
      font: data.font,
      font_color: data.font_color,
      label_quantity: data.quantity,
      estimated_subtotal: data.subtotal_display,
      proof_watermark: 'Preview only'
    });
  }

  function proofFallbackProperties(data) {
    return {
      '_Proof Image Included': 'false',
      '_Proof Preview JSON': compactProofPreview(data),
      '_Proof Image Status': 'Pending backend proof storage'
    };
  }

  function dcpProofFallbackProperties() {
    return {
      '_Proof Image Status': 'Pending backend proof storage'
    };
  }

  function dcpProofFileFromCanvas(canvas) {
    return new Promise((resolve, reject) => {
      if (!canvas || typeof canvas.toBlob !== 'function' || typeof File !== 'function') {
        reject(new Error('This browser cannot create the durable DCP proof file.'));
        return;
      }
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('The final DCP proof image could not be encoded.'));
          return;
        }
        const filename = 'srd-dcp-final-proof-' + Date.now().toString(36) + '.png';
        resolve(new File([blob], filename, {
          type: 'image/png',
          lastModified: Date.now()
        }));
      }, 'image/png');
    });
  }

  function dcpHeaderProofError(cause) {
    const error = new Error('The selected Header could not be loaded into your proof. Please reselect the Header or try again.');
    error.code = 'DCP_HEADER_PROOF_FAILED';
    error.cause = cause || null;
    return error;
  }

  function isDcpHeaderProofError(error) {
    return Boolean(error && error.code === 'DCP_HEADER_PROOF_FAILED');
  }

  function dcpShapeProofError(cause) {
    const detail = cause && cause.message ? cause.message : String(cause || 'The Shape is invalid.');
    const error = new Error('The selected Shape could not be added to your proof. ' + detail + ' Please remove and re-add the Shape.');
    error.code = 'DCP_SHAPE_PROOF_FAILED';
    error.cause = cause || null;
    return error;
  }

  function isDcpShapeProofError(error) {
    return Boolean(error && error.code === 'DCP_SHAPE_PROOF_FAILED');
  }

  function dcpSymbolProofError(cause) {
    const detail = cause && cause.message ? cause.message : String(cause || 'The Symbol is invalid.');
    const error = new Error('The selected Symbol could not be added to your proof. ' + detail + ' Please remove and re-add the Symbol.');
    error.code = 'DCP_SYMBOL_PROOF_FAILED';
    error.cause = cause || null;
    return error;
  }

  function isDcpSymbolProofError(error) {
    return Boolean(error && error.code === 'DCP_SYMBOL_PROOF_FAILED');
  }

  function isDcpRequiredProofError(error) {
    return isDcpHeaderProofError(error) || isDcpShapeProofError(error) || isDcpSymbolProofError(error);
  }

  function drawDcpProofShape(context, shape, canvasWidth, canvasHeight) {
    const validation = validateDcpShapeObject(shape, canvasWidth / canvasHeight);
    if (!validation.valid || !validation.shape) throw dcpShapeProofError(validation.message);
    const trustedShape = validation.shape;
    const boxWidth = canvasWidth * trustedShape.width / 100;
    const boxHeight = canvasHeight * trustedShape.height / 100;
    const boxX = canvasWidth * trustedShape.x / 100 - boxWidth / 2;
    const boxY = canvasHeight * trustedShape.y / 100 - boxHeight / 2;
    const hasStroke = trustedShape.borderColorKey !== 'none';
    const strokePercent = dcpShapeThicknessValues[trustedShape.borderThicknessKey];
    const strokeWidth = hasStroke ? Math.min(boxWidth, boxHeight) * strokePercent : 0;
    const inset = strokeWidth / 2;
    const innerWidth = boxWidth - strokeWidth;
    const innerHeight = boxHeight - strokeWidth;
    if (!(innerWidth > 0 && innerHeight > 0)) throw dcpShapeProofError('The Shape border leaves no printable interior.');
    const mapX = (value) => boxX + inset + innerWidth * value / 100;
    const mapY = (value) => boxY + inset + innerHeight * value / 100;
    const polygonPoints = trustedShape.shapeKey === 'triangle'
      ? [[50, 0], [100, 100], [0, 100]]
      : trustedShape.shapeKey === 'diamond'
        ? [[50, 0], [100, 50], [50, 100], [0, 50]]
        : trustedShape.shapeKey === 'five_point_star'
          ? Array.from({ length: 10 }, (_, index) => {
            const radius = index % 2 === 0 ? 50 : 50 * 0.381966;
            const angle = (-90 + index * 36) * Math.PI / 180;
            return [50 + Math.cos(angle) * radius, 50 + Math.sin(angle) * radius];
          })
          : [];

    context.save();
    context.translate(boxX + boxWidth / 2, boxY + boxHeight / 2);
    context.rotate(clampDcpNumber(trustedShape.rotation, -180, 180, 0) * Math.PI / 180);
    context.translate(-(boxX + boxWidth / 2), -(boxY + boxHeight / 2));
    context.beginPath();
    if (trustedShape.shapeKey === 'rectangle') {
      context.rect(boxX + inset, boxY + inset, innerWidth, innerHeight);
    } else if (trustedShape.shapeKey === 'rounded_rectangle') {
      const left = boxX + inset;
      const top = boxY + inset;
      const right = left + innerWidth;
      const bottom = top + innerHeight;
      const radius = Math.min(innerWidth, innerHeight) * 0.12;
      context.moveTo(left + radius, top);
      context.lineTo(right - radius, top);
      context.quadraticCurveTo(right, top, right, top + radius);
      context.lineTo(right, bottom - radius);
      context.quadraticCurveTo(right, bottom, right - radius, bottom);
      context.lineTo(left + radius, bottom);
      context.quadraticCurveTo(left, bottom, left, bottom - radius);
      context.lineTo(left, top + radius);
      context.quadraticCurveTo(left, top, left + radius, top);
      context.closePath();
    } else if (trustedShape.shapeKey === 'circle_oval') {
      context.ellipse(
        boxX + boxWidth / 2,
        boxY + boxHeight / 2,
        innerWidth / 2,
        innerHeight / 2,
        0,
        0,
        Math.PI * 2
      );
    } else if (trustedShape.shapeKey === 'shield') {
      context.moveTo(mapX(50), mapY(0));
      context.lineTo(mapX(92), mapY(14));
      context.lineTo(mapX(86), mapY(62));
      context.quadraticCurveTo(mapX(78), mapY(87), mapX(50), mapY(100));
      context.quadraticCurveTo(mapX(22), mapY(87), mapX(14), mapY(62));
      context.lineTo(mapX(8), mapY(14));
      context.closePath();
    } else {
      if (!polygonPoints.length) {
        context.restore();
        throw dcpShapeProofError('The Shape geometry is not recognized.');
      }
      polygonPoints.forEach((point, index) => {
        if (index === 0) context.moveTo(mapX(point[0]), mapY(point[1]));
        else context.lineTo(mapX(point[0]), mapY(point[1]));
      });
      context.closePath();
    }

    if (trustedShape.fillColorKey !== 'transparent') {
      context.fillStyle = dcpShapeColorValues[trustedShape.fillColorKey];
      context.fill();
    }
    if (hasStroke) {
      context.strokeStyle = dcpShapeColorValues[trustedShape.borderColorKey];
      context.lineWidth = strokeWidth;
      context.lineJoin = 'round';
      context.stroke();
    }
    context.restore();
  }

  function loadCanvasImage(src) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      const timeout = window.setTimeout(() => {
        image.onload = null;
        image.onerror = null;
        reject(new Error('Proof template image load timed out.'));
      }, 7000);
      image.crossOrigin = 'anonymous';
      image.onload = () => {
        window.clearTimeout(timeout);
        resolve(image);
      };
      image.onerror = () => {
        window.clearTimeout(timeout);
        reject(new Error('Proof template image could not be loaded.'));
      };
      image.src = src;
    });
  }

  async function loadDcpSymbolProofImages(symbols) {
    const loads = new Map();
    const images = new Map();
    await Promise.all(symbols.map(async (symbol) => {
      const catalogItem = trustedDcpSymbolRecord(symbol.canonicalId);
      if (!catalogItem || catalogItem.src !== symbol.src) throw dcpSymbolProofError('Trusted Symbol artwork is unavailable.');
      if (!loads.has(catalogItem.canonicalId)) {
        loads.set(catalogItem.canonicalId, (async () => {
          const image = await loadCanvasImage(catalogItem.src);
          if (typeof image.decode === 'function') await image.decode();
          if (image.naturalWidth !== Number(catalogItem.pixelWidth) || image.naturalHeight !== Number(catalogItem.pixelHeight)) {
            throw new Error('Trusted Symbol artwork dimensions do not match the catalog.');
          }
          return image;
        })());
      }
      try {
        images.set(symbol.id, await loads.get(catalogItem.canonicalId));
      } catch (error) {
        throw dcpSymbolProofError(error);
      }
    }));
    return images;
  }

  function dcpSymbolProofSnapshot(symbols) {
    return JSON.stringify(symbols.map((symbol) => ({
      id: symbol.id,
      canonicalId: symbol.canonicalId,
      x: symbol.x,
      y: symbol.y,
      width: symbol.width,
      height: symbol.height,
      rotation: symbol.rotation
    })));
  }

  function assertDcpSymbolProofSnapshotCurrent(revision, snapshot) {
    const current = getDcpProofState();
    const validation = validateDcpSymbolObjects(
      current && current.objects && current.objects.symbolObjects,
      controls.size ? controls.size.value : '',
      true
    );
    if (revision !== dcpSymbolProofRevision
      || !isBlankCanvasMode(controls.template ? controls.template.value : '')
      || selectedBlankCanvasSubfamily() !== 'print_design'
      || !validation.valid
      || !validation.ready
      || dcpSymbolProofSnapshot(validation.symbols) !== snapshot) {
      throw dcpSymbolProofError('The Symbol design changed while the proof was being prepared.');
    }
  }

  function drawDcpProofSymbol(context, image, symbol, canvasWidth, canvasHeight) {
    const bounds = symbol.contentBounds;
    const sourceX = Number(bounds[0]);
    const sourceY = Number(bounds[1]);
    const sourceWidth = Number(bounds[2]) - sourceX;
    const sourceHeight = Number(bounds[3]) - sourceY;
    const drawWidth = canvasWidth * symbol.width / 100;
    const drawHeight = canvasHeight * symbol.height / 100;
    if (!(sourceWidth > 0 && sourceHeight > 0 && drawWidth > 0 && drawHeight > 0)) {
      throw dcpSymbolProofError('The selected Symbol geometry is not printable.');
    }
    context.save();
    context.translate(canvasWidth * symbol.x / 100, canvasHeight * symbol.y / 100);
    context.rotate(symbol.rotation * Math.PI / 180);
    context.drawImage(
      image,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      -drawWidth / 2,
      -drawHeight / 2,
      drawWidth,
      drawHeight
    );
    context.restore();
  }

  function fitCanvasLines(context, text, maxWidth, maxLines) {
    const source = String(text || '').split(/\s+/).filter(Boolean);
    if (!source.length) return [];

    const lines = [];
    let line = '';

    source.forEach((word) => {
      const candidate = line ? line + ' ' + word : word;
      if (context.measureText(candidate).width <= maxWidth || !line) {
        line = candidate;
      } else if (lines.length < maxLines - 1) {
        lines.push(line);
        line = word;
      } else {
        line = candidate;
      }
    });

    if (line) lines.push(line);
    return lines.slice(0, maxLines);
  }

  function drawProofWatermark(context, area) {
    context.save();
    context.beginPath();
    context.rect(area.x, area.y, area.width, area.height);
    context.clip();
    context.translate(area.x + area.width / 2, area.y + area.height / 2);
    context.rotate(-Math.PI / 6);
    context.globalAlpha = 0.12;
    context.fillStyle = '#111111';
    context.font = '700 30px Arial, Helvetica, sans-serif';
    context.textAlign = 'center';
    context.textBaseline = 'middle';

    for (let y = -area.height; y <= area.height; y += 82) {
      for (let x = -area.width; x <= area.width; x += 210) {
        context.fillText('SRD PROOF', x, y);
      }
    }

    context.restore();
  }

  const dcpProofWatermarkText = 'SRD PROOF';
  const dcpProofWatermarkAngle = -18;

  function dcpProofWatermarkPattern(width, height, textWidth, textHeight) {
    const safeWidth = Math.max(1, Number(width) || 1);
    const safeHeight = Math.max(1, Number(height) || 1);
    const safeTextWidth = Math.max(1, Number(textWidth) || 1);
    const safeTextHeight = Math.max(1, Number(textHeight) || 1);
    const radians = Math.abs(dcpProofWatermarkAngle) * Math.PI / 180;
    const rotatedWidth = (safeTextWidth * Math.cos(radians)) + (safeTextHeight * Math.sin(radians));
    const rotatedHeight = (safeTextWidth * Math.sin(radians)) + (safeTextHeight * Math.cos(radians));
    const horizontalStep = rotatedWidth + Math.max(14, safeTextHeight * 1.15);
    const verticalStep = rotatedHeight + Math.max(12, safeTextHeight * 0.85);
    const positions = [];
    let row = 0;

    for (let y = -verticalStep * 0.25; y <= safeHeight + verticalStep * 0.5; y += verticalStep) {
      const rowOffset = row % 2 ? horizontalStep / 2 : 0;
      for (let x = -horizontalStep + rowOffset; x <= safeWidth + horizontalStep; x += horizontalStep) {
        positions.push({ x: x, y: y, row: row });
      }
      row += 1;
    }

    return {
      positions: positions,
      horizontalStep: horizontalStep,
      verticalStep: verticalStep,
      rotatedWidth: rotatedWidth,
      rotatedHeight: rotatedHeight
    };
  }

  function resetSharedProofWatermarkLayout() {
    const watermark = targets.proofWatermark;
    if (!watermark || watermark.dataset.srdDcpWatermarkLayout !== 'true') return;
    const fragment = document.createDocumentFragment();
    for (let index = 0; index < 9; index += 1) {
      const span = document.createElement('span');
      span.textContent = dcpProofWatermarkText;
      fragment.appendChild(span);
    }
    watermark.replaceChildren(fragment);
    watermark.style.removeProperty('font-size');
    delete watermark.dataset.srdDcpWatermarkLayout;
    delete watermark.dataset.srdDcpWatermarkSignature;
  }

  function syncDcpProofWatermarkLayout(active) {
    const watermark = targets.proofWatermark;
    if (!watermark) return;
    if (!active) {
      resetSharedProofWatermarkLayout();
      return;
    }
    if (watermark.hidden) return;

    const width = watermark.clientWidth;
    const height = watermark.clientHeight;
    if (!width || !height) return;
    const fontSize = Math.max(14, Math.min(28, Math.min(width, height) * 0.055));
    const signature = Math.round(width) + 'x' + Math.round(height) + '@' + fontSize.toFixed(2);
    if (watermark.dataset.srdDcpWatermarkSignature === signature) return;

    watermark.style.fontSize = fontSize.toFixed(2) + 'px';
    const probe = document.createElement('span');
    probe.className = 'srd-designer-proof__watermark-probe';
    probe.textContent = dcpProofWatermarkText;
    watermark.replaceChildren(probe);
    const probeRect = probe.getBoundingClientRect();
    const pattern = dcpProofWatermarkPattern(width, height, probeRect.width, probeRect.height);
    const fragment = document.createDocumentFragment();

    pattern.positions.forEach((position) => {
      const span = document.createElement('span');
      span.textContent = dcpProofWatermarkText;
      span.style.left = position.x.toFixed(2) + 'px';
      span.style.top = position.y.toFixed(2) + 'px';
      span.dataset.srdDcpWatermarkRow = String(position.row);
      fragment.appendChild(span);
    });

    watermark.replaceChildren(fragment);
    watermark.dataset.srdDcpWatermarkLayout = 'true';
    watermark.dataset.srdDcpWatermarkSignature = signature;
  }

  function drawDcpBlankCanvasProofWatermark(context, canvasWidth, canvasHeight) {
    const width = Math.max(1, Number(canvasWidth) || 1);
    const height = Math.max(1, Number(canvasHeight) || 1);
    const fontSize = Math.max(20, Math.min(34, Math.round(Math.min(width, height) * 0.055)));

    context.save();
    context.beginPath();
    context.rect(0, 0, width, height);
    context.clip();
    context.globalAlpha = 0.12;
    context.fillStyle = '#111111';
    context.font = '700 ' + fontSize + 'px Arial, Helvetica, sans-serif';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    const measurement = context.measureText(dcpProofWatermarkText);
    const measuredHeight = (measurement.actualBoundingBoxAscent || fontSize * 0.75) +
      (measurement.actualBoundingBoxDescent || fontSize * 0.25);
    const pattern = dcpProofWatermarkPattern(width, height, measurement.width, measuredHeight);

    pattern.positions.forEach((position) => {
      context.save();
      context.translate(position.x, position.y);
      context.rotate(dcpProofWatermarkAngle * Math.PI / 180);
      context.fillText(dcpProofWatermarkText, 0, 0);
      context.restore();
    });

    context.restore();
  }

  function drawProofMessage(context, data, config, canvasWidth, canvasHeight, includeWatermark) {
    const height = canvasHeight || canvasWidth;
    const shortestSide = Math.min(canvasWidth, height);
    const padding = ((config.default_padding || 0) / 100) * shortestSide;
    const area = {
      centerX: (config.writable_area_center_x / 100) * canvasWidth,
      centerY: (config.writable_area_center_y / 100) * height,
      width: (config.writable_area_width / 100) * canvasWidth,
      height: (config.writable_area_height / 100) * height
    };
    const bounds = {
      x: area.centerX - area.width / 2,
      y: area.centerY - area.height / 2,
      width: area.width,
      height: area.height
    };
    const maxWidth = Math.max(40, area.width - padding * 2);
    const maxHeight = Math.max(40, area.height - padding * 2);
    const fontStack = fontStackFor(data.font_key || (controls.font ? controls.font.value : 'arial'));
    const fontColor = colorValueFor(data.font_color_key || selectedFontColor());
    let fontSize = Math.min(86, Math.max(34, shortestSide * 0.13));
    const minSize = 20;
    let lines = [];
    let lineHeight = 1.05;

    for (; fontSize >= minSize; fontSize -= 2) {
      context.font = '800 ' + fontSize + 'px ' + fontStack;
      lines = fitCanvasLines(context, data.customer_message, maxWidth, 3);
      if (lines.length * fontSize * lineHeight <= maxHeight && lines.every((line) => context.measureText(line).width <= maxWidth + 1)) {
        break;
      }
    }

    context.save();
    context.beginPath();
    context.rect(bounds.x, bounds.y, bounds.width, bounds.height);
    context.clip();
    context.fillStyle = fontColor;
    context.font = '800 ' + Math.max(fontSize, minSize) + 'px ' + fontStack;
    context.textAlign = 'center';
    context.textBaseline = 'middle';

    const fittedLineHeight = Math.max(fontSize, minSize) * lineHeight;
    const startY = area.centerY - ((lines.length - 1) * fittedLineHeight) / 2;
    lines.forEach((line, index) => {
      context.fillText(line, area.centerX, startY + index * fittedLineHeight);
    });
    context.restore();

    if (includeWatermark !== false) drawProofWatermark(context, bounds);
  }

  function dcpProofTextArea(config, canvasWidth, canvasHeight) {
    const height = canvasHeight || canvasWidth;
    return {
      centerX: (config.writable_area_center_x / 100) * canvasWidth,
      centerY: (config.writable_area_center_y / 100) * height,
      width: (config.writable_area_width / 100) * canvasWidth,
      height: (config.writable_area_height / 100) * height
    };
  }

  function drawDcpArchedProofMessage(context, data, textObject, config, canvasWidth, canvasHeight) {
    const area = dcpProofTextArea(config, canvasWidth, canvasHeight);
    const bounds = {
      x: area.centerX - area.width / 2,
      y: area.centerY - area.height / 2,
      width: area.width,
      height: area.height
    };
    const message = String(data.customer_message || '');
    if (!message.trim()) return;
    const fontStack = fontStackFor(data.font_key || textObject.fontKey || 'arial');
    const fontColor = colorValueFor(data.font_color_key || textObject.fontColorKey || 'black');
    const arc = clampDcpNumber(textObject.arcAmount, 0, 100, 35);
    const direction = normalizeDcpTextShape(textObject.textShape) === 'arch_down' ? 1 : -1;
    const maxWidth = Math.max(20, area.width * 0.9);
    const maxHeight = Math.max(20, area.height * 0.74);
    const minSize = 8;
    const configuredMax = clampDcpNumber(textObject.maxFontSize, 18, 320, 260);
    let fontSize = Math.min(configuredMax, Math.max(18, Math.max(maxWidth * 0.18, maxHeight * 1.5)));

    for (; fontSize >= minSize; fontSize -= 1) {
      context.font = '900 ' + fontSize + 'px ' + fontStack;
      if (context.measureText(message).width <= maxWidth && fontSize * 1.2 <= maxHeight) break;
    }

    context.save();
    context.beginPath();
    context.rect(bounds.x, bounds.y, bounds.width, bounds.height);
    context.clip();
    context.translate(area.centerX, area.centerY);
    context.rotate((clampDcpNumber(textObject.rotation, -180, 180, 0) * Math.PI) / 180);
    context.fillStyle = fontColor;
    context.font = '900 ' + Math.max(fontSize, minSize) + 'px ' + fontStack;
    context.textAlign = 'center';
    context.textBaseline = 'middle';

    const totalWidth = Math.min(context.measureText(message).width, maxWidth);
    const curve = direction * (arc / 100) * Math.min(area.height * 0.5, area.width * 0.22);
    let cursor = -totalWidth / 2;
    Array.from(message).forEach((character) => {
      const characterWidth = context.measureText(character).width;
      const x = cursor + characterWidth / 2;
      const normalized = totalWidth ? x / totalWidth : 0;
      const y = curve * (1 - Math.min(1, Math.pow(normalized * 2, 2)));
      const angle = Math.atan((-8 * curve * normalized) / Math.max(1, totalWidth));
      context.save();
      context.translate(x, y);
      context.rotate(angle);
      context.fillText(character, 0, 0);
      context.restore();
      cursor += characterWidth;
    });
    context.restore();
  }

  function drawDcpDieProofTextObject(context, data, textObject, config, canvasWidth, canvasHeight) {
    const area = dcpProofTextArea(config, canvasWidth, canvasHeight);
    const fontStack = fontStackFor(data.font_key || textObject.fontKey || 'anton');
    const fontColor = dcpTextColorValue(data.font_color_key || textObject.fontColorKey || 'white', 'die_cutting');
    const layout = dcpDieTextLayout(textObject, area.width, area.height, fontStack);
    if (!layout) return;
    context.save();
    context.translate(area.centerX, area.centerY);
    context.rotate((clampDcpNumber(textObject.rotation, -180, 180, 0) * Math.PI) / 180);
    context.translate(-area.width / 2, -area.height / 2);
    context.beginPath();
    context.rect(0, 0, area.width, area.height);
    context.clip();
    context.fillStyle = fontColor;
    context.font = '950 ' + layout.fontSize + 'px ' + fontStack;
    context.textBaseline = 'alphabetic';
    if (layout.type === 'straight') {
      context.textAlign = 'left';
      layout.lines.forEach((line) => {
        const visibleWidth = Math.max(0.01, line.right - line.left);
        const x = (area.width - visibleWidth) / 2 - line.left;
        context.fillText(line.text, x, layout.offsetY + line.baseline);
      });
    } else {
      context.textAlign = 'center';
      layout.glyphs.forEach((glyph) => {
        context.save();
        context.translate(glyph.x + layout.offsetX, glyph.y + layout.offsetY);
        context.rotate(glyph.angle);
        context.fillText(glyph.text, 0, 0);
        context.restore();
      });
    }
    context.restore();
  }

  function drawDcpPrintProofTextObject(context, data, textObject, config, canvasWidth, canvasHeight) {
    const area = dcpProofTextArea(config, canvasWidth, canvasHeight);
    const fontStack = fontStackFor(data.font_key || textObject.fontKey || 'arial');
    const fontColor = colorValueFor(data.font_color_key || textObject.fontColorKey || 'black');
    const layout = dcpPrintTextLayout(textObject, area.width, area.height, fontStack);
    if (!layout) return;
    context.save();
    context.translate(area.centerX, area.centerY);
    context.rotate((clampDcpNumber(textObject.rotation, -180, 180, 0) * Math.PI) / 180);
    context.translate(-area.width / 2, -area.height / 2);
    context.beginPath();
    context.rect(0, 0, area.width, area.height);
    context.clip();
    context.fillStyle = fontColor;
    const outlineWidth = dcpTextOutlineStrokeWidth(textObject, layout.fontSize);
    if (outlineWidth > 0) {
      context.strokeStyle = dcpTextOutlineColor(textObject);
      context.lineWidth = outlineWidth;
      context.lineJoin = 'round';
      context.miterLimit = 2;
    }
    context.font = '950 ' + layout.fontSize + 'px ' + fontStack;
    context.textBaseline = 'alphabetic';
    context.textAlign = 'left';
    if (layout.type === 'straight') {
      layout.lines.forEach((line) => {
        if (outlineWidth > 0) context.strokeText(line.text, layout.offsetX + line.x, layout.offsetY + line.baseline);
        context.fillText(line.text, layout.offsetX + line.x, layout.offsetY + line.baseline);
      });
    } else {
      context.textAlign = 'center';
      layout.glyphs.forEach((glyph) => {
        context.save();
        context.translate(glyph.x + layout.offsetX, glyph.y + layout.offsetY);
        context.rotate(glyph.angle);
        if (outlineWidth > 0) context.strokeText(glyph.text, 0, 0);
        context.fillText(glyph.text, 0, 0);
        context.restore();
      });
    }
    context.restore();
  }

  function drawDcpProofTextObject(context, data, textObject, config, canvasWidth, canvasHeight) {
    if (isDieCuttingMode()) {
      drawDcpDieProofTextObject(context, data, textObject, config, canvasWidth, canvasHeight);
      return;
    }
    drawDcpPrintProofTextObject(context, data, textObject, config, canvasWidth, canvasHeight);
  }

  function centeredImageBox(image, canvasWidth, canvasHeight) {
    const ratio = Math.min(canvasWidth / image.naturalWidth, canvasHeight / image.naturalHeight);
    const width = image.naturalWidth * ratio;
    const height = image.naturalHeight * ratio;
    return {
      x: (canvasWidth - width) / 2,
      y: (canvasHeight - height) / 2,
      width: width,
      height: height
    };
  }

  function canvasRectFromCalibration(imageBox, calibration, centered) {
    const width = Number(calibration.width) * imageBox.width;
    const height = Number(calibration.height || calibration.width || 0) * imageBox.height;
    const rawX = imageBox.x + (Number(calibration.x) * imageBox.width);
    const rawY = imageBox.y + (Number(calibration.y) * imageBox.height);
    return {
      x: centered ? rawX - width / 2 : rawX,
      y: centered ? rawY - height / 2 : rawY,
      width: width,
      height: height
    };
  }

  function fittedImageSize(image, maxWidth, maxHeight) {
    const ratio = Math.min(maxWidth / image.naturalWidth, maxHeight / image.naturalHeight);
    return {
      width: image.naturalWidth * ratio,
      height: image.naturalHeight * ratio
    };
  }

  function drawNitrousHeaderImage(context, image, imageBox, calibration) {
    if (!image || !calibration) return;
    const rect = canvasRectFromCalibration(imageBox, calibration, false);
    if (!rect.width || !rect.height) return;

    const scale = Number(calibration.scale) || 1;
    const rotation = ((Number(calibration.rotation) || 0) * Math.PI) / 180;
    const fitted = fittedImageSize(image, rect.width * scale, rect.height * scale);

    context.save();
    context.translate(rect.x + rect.width / 2, rect.y + rect.height / 2);
    context.rotate(rotation);
    context.drawImage(image, -fitted.width / 2, -fitted.height / 2, fitted.width, fitted.height);
    context.restore();
  }

  function drawNitrousWeightValues(context, data, profile, imageBox) {
    const calibration = (profile && profile.weightCalibration) || {};
    const values = Array.isArray(data.nitrous_weight_values) && data.nitrous_weight_values.length
      ? data.nitrous_weight_values
      : ((profile && profile.weightCard) || []);
    if (!values.length || !calibration.width) return;

    const rect = canvasRectFromCalibration(imageBox, calibration, true);
    const fontScale = Number(calibration.fontSize) || 1;
    const lineSpacing = Number(calibration.lineSpacing);
    const lineGap = Number.isFinite(lineSpacing) ? lineSpacing : 0.45;
    const fontSize = Math.max(12, Math.min(48, rect.width * 0.28 * fontScale));
    const lineHeight = fontSize * (1 + lineGap);
    const groupHeight = ((values.length - 1) * lineHeight) + fontSize;
    const startY = rect.y + rect.height / 2 - groupHeight / 2 + fontSize / 2;

    context.save();
    context.fillStyle = '#000000';
    context.font = '900 ' + fontSize + 'px "Arial Rounded MT Bold", "Arial Rounded", Arial, Helvetica, sans-serif';
    context.textAlign = 'right';
    context.textBaseline = 'middle';
    values.slice(0, 3).forEach((value, index) => {
      context.fillText(String(value || ''), rect.x + rect.width, startY + index * lineHeight);
    });
    context.restore();
  }

  async function captureNitrousProofImage(data) {
    if (!data || !data.ready_for_cart || !data.nitrous_template_image_url) {
      return proofFallbackProperties(data || {});
    }

    try {
      if (document.fonts && document.fonts.ready) await document.fonts.ready;

      const canvasSize = 900;
      const canvas = document.createElement('canvas');
      canvas.width = canvasSize;
      canvas.height = canvasSize;
      const context = canvas.getContext('2d');
      const templateImage = await loadCanvasImage(data.nitrous_template_image_url);
      const imageBox = centeredImageBox(templateImage, canvasSize, canvasSize);
      const headerCalibration = nitrousHeaderCalibrations[data.nitrous_header_key] || nitrousHeaderCalibrations.nitrous_oxide_performance;
      const proofReference = 'srd-proof-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);

      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvasSize, canvasSize);
      context.drawImage(templateImage, imageBox.x, imageBox.y, imageBox.width, imageBox.height);

      const skipCustomArtPreview = data.nitrous_header_key === 'custom_art' && data.nitrous_custom_art_previewable === false;
      if (data.nitrous_header_src && !skipCustomArtPreview) {
        try {
          const headerImage = await loadCanvasImage(data.nitrous_header_src);
          drawNitrousHeaderImage(context, headerImage, imageBox, headerCalibration);
        } catch (error) {
          debugLog('nitrous proof header image skipped', error);
        }
      }

      if (data.proof_watermark !== false) {
        drawProofWatermark(context, imageBox);
      }

      const dataUrl = canvas.toDataURL('image/png');
      sessionStorage.setItem(proofReference, dataUrl);

      return {
        '_Proof Image Type': 'Watermarked PNG',
        '_Proof Image Included': 'true',
        '_Proof Image Data': proofReference,
        '_Proof Preview JSON': compactProofPreview(data)
      };
    } catch (error) {
      return proofFallbackProperties(data);
    }
  }

  async function captureDcpProofImage(data) {
    const proofState = getDcpProofState();
    const proofPreviewUrl = proofState.previewUrl || proofState.url || '';
    const sourceObjects = proofState.objects;
    const shapeValidation = dcpShapeValidation(sourceObjects, data && data.size);
    if (!shapeValidation.valid) throw dcpShapeProofError(shapeValidation.message);
    const symbolValidation = validateDcpSymbolObjects(sourceObjects && sourceObjects.symbolObjects, data && data.size, true);
    if (!symbolValidation.valid || (symbolValidation.present && !symbolValidation.ready)) {
      throw dcpSymbolProofError(symbolValidation.message);
    }
    const objects = normalizeDcpCanvasObjects(sourceObjects);
    const hasCustomerMessage = hasDcpTextObjects(objects);
    const header = objects.header;
    const shape = shapeValidation.shape;
    const symbols = symbolValidation.symbols;
    const symbolProofRevision = ++dcpSymbolProofRevision;
    const symbolSnapshot = dcpSymbolProofSnapshot(symbols);
    const vectorNoticeOnly = proofState.noticeImage && !proofState.previewable;
    if (!data || !data.ready_for_cart || vectorNoticeOnly || (!hasCustomerMessage && !header && !shape && !symbols.length && (!proofState.previewable || !proofPreviewUrl))) {
      return dcpProofFallbackProperties();
    }

    try {
      await Promise.all(objects.textObjects.map((textObject) => ensureDcpFontReady(textObject.fontKey).catch(() => false)));
      if (document.fonts && document.fonts.ready) await document.fonts.ready;
      const image = proofState.previewable && proofPreviewUrl ? await loadCanvasImage(proofPreviewUrl) : null;
      const symbolImages = symbols.length ? await loadDcpSymbolProofImages(symbols) : new Map();
      if (symbols.length) assertDcpSymbolProofSnapshotCurrent(symbolProofRevision, symbolSnapshot);
      let headerImage = null;
      let headerCatalogItem = null;
      if (header) {
        headerCatalogItem = dcpHeaderCatalogByKey[header.libraryKey];
        if (!headerCatalogItem || !headerCatalogItem.src) throw dcpHeaderProofError('Trusted Header PNG is unavailable.');
        try {
          headerImage = await loadCanvasImage(headerCatalogItem.src);
        } catch (error) {
          throw dcpHeaderProofError(error);
        }
      }
      if (symbols.length) assertDcpSymbolProofSnapshotCurrent(symbolProofRevision, symbolSnapshot);
      const diePhysicalCanvas = isDieCuttingMode() ? dcpPhysicalCanvasForProof(proofState) : null;
      const aspect = diePhysicalCanvas
        ? { ratio: diePhysicalCanvas.width + ' / ' + diePhysicalCanvas.height, number: diePhysicalCanvas.width / diePhysicalCanvas.height }
        : aspectForDesignerSize(dcpLandscapeSize(data.size));
      const canvasWidth = 900;
      const canvasHeight = Math.max(1, Math.round(canvasWidth / (aspect.number || 1)));
      const canvas = document.createElement('canvas');
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const context = canvas.getContext('2d');
      const artworkWidth = canvasWidth * (objects.artwork.width / 100);
      const artworkHeight = canvasHeight * (objects.artwork.height / 100);
      const artworkBox = {
        x: (canvasWidth * objects.artwork.x / 100) - artworkWidth / 2,
        y: (canvasHeight * objects.artwork.y / 100) - artworkHeight / 2,
        width: artworkWidth,
        height: artworkHeight
      };

      const dieProofContrast = isDieCuttingMode()
        ? resolveDcpDieProofContrast(objects, proofState)
        : { mode: 'light', colorKeys: [] };
      paintDcpDieProofContrastSurface(context, canvasWidth, canvasHeight, dieProofContrast);
      const symbolById = new Map(symbols.map((symbol) => [symbol.id, symbol]));
      const textById = new Map(objects.textObjects.map((textObject) => [textObject.id, textObject]));
      dcpVisibleLayerOrder(objects, proofState).forEach((selection) => {
        const type = dcpObjectType(selection);
        if (type === 'shape' && shape) {
          drawDcpProofShape(context, shape, canvasWidth, canvasHeight);
        } else if (type === 'artwork' && image) {
          const ratio = Math.min(artworkBox.width / image.naturalWidth, artworkBox.height / image.naturalHeight);
          const drawWidth = image.naturalWidth * ratio;
          const drawHeight = image.naturalHeight * ratio;
          const drawX = artworkBox.x + (artworkBox.width - drawWidth) / 2;
          const drawY = artworkBox.y + (artworkBox.height - drawHeight) / 2;
          // The live designer applies catalog-art color with an SVG filter.
          // A canvas proof needs the same alpha-mask treatment explicitly so
          // the durable cart proof depicts the selected single vinyl color.
          const artworkLayer = document.createElement('canvas');
          artworkLayer.width = Math.max(1, Math.round(drawWidth));
          artworkLayer.height = Math.max(1, Math.round(drawHeight));
          const artworkContext = artworkLayer.getContext('2d');
          artworkContext.drawImage(image, 0, 0, artworkLayer.width, artworkLayer.height);
          if (isDieCuttingMode() && proofState.catalogArtwork) {
            artworkContext.globalCompositeOperation = 'source-in';
            artworkContext.fillStyle = dcpDieVinylColorDescriptor(proofState.dieVinylColorKey).value;
            artworkContext.fillRect(0, 0, artworkLayer.width, artworkLayer.height);
          }
          const artworkRotation = clampDcpNumber(objects.artwork.rotation, -180, 180, 0) * Math.PI / 180;
          context.save();
          context.translate(drawX + drawWidth / 2, drawY + drawHeight / 2);
          context.rotate(artworkRotation);
          context.drawImage(artworkLayer, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
          context.restore();
        } else if (type === 'symbol') {
          const symbol = symbolById.get(dcpObjectId(selection));
          const symbolImage = symbol && symbolImages.get(symbol.id);
          if (!symbol || !symbolImage) throw dcpSymbolProofError('Trusted Symbol artwork is unavailable.');
          drawDcpProofSymbol(context, symbolImage, symbol, canvasWidth, canvasHeight);
        } else if (type === 'header' && headerImage && headerCatalogItem) {
          const headerWidth = canvasWidth * (header.width / 100);
          const headerHeight = canvasHeight * (header.height / 100);
          const headerX = (canvasWidth * header.x / 100) - headerWidth / 2;
          const headerY = (canvasHeight * header.y / 100) - headerHeight / 2;
          context.drawImage(headerImage, headerX, headerY, headerWidth, headerHeight);
        } else if (type === 'text') {
          const textObject = textById.get(dcpObjectId(selection));
          if (!textObject || !isComplete(textObject.text)) return;
          drawDcpProofTextObject(context, {
            ...data,
            customer_message: textObject.text,
            font_key: textObject.fontKey,
            font_color_key: textObject.fontColorKey,
            font: textObject.font || fontLabels[textObject.fontKey] || data.font,
            font_color: textObject.fontColor || fontColorLabels[textObject.fontColorKey] || data.font_color
          }, textObject, blankCanvasTextConfig(textObject), canvasWidth, canvasHeight);
        }
      });
      drawDcpBlankCanvasProofWatermark(context, canvasWidth, canvasHeight);
      const proofFile = await dcpProofFileFromCanvas(canvas);

      return compactDcpCartProperties({
        [dcpProofFilePropertyName]: proofFile
      });
    } catch (error) {
      if (isDcpRequiredProofError(error)) throw error;
      if (symbols.length) throw dcpSymbolProofError(error);
      if (shape) throw dcpShapeProofError(error);
      debugLog('dcp proof image skipped', error);
      return dcpProofFallbackProperties();
    }
  }

  async function captureProofImage(data) {
    if (data && data.selected_template_category === 'nitrous') {
      return captureNitrousProofImage(data);
    }
    if (data && data.selected_template_category === 'blank_canvas') {
      return captureDcpProofImage(data);
    }

    const config = selectedTemplateConfig();
    if (!data || !data.ready_for_cart || !hasWritableArea(config) || !targets.templateArtwork || !targets.templateArtwork.src) {
      return proofFallbackProperties(data || {});
    }

    try {
      if (document.fonts && document.fonts.ready) await document.fonts.ready;

      const canvasSize = 900;
      const canvas = document.createElement('canvas');
      canvas.width = canvasSize;
      canvas.height = canvasSize;
      const context = canvas.getContext('2d');
      const image = await loadCanvasImage(targets.templateArtwork.src);
      const ratio = Math.min(canvasSize / image.naturalWidth, canvasSize / image.naturalHeight);
      const drawWidth = image.naturalWidth * ratio;
      const drawHeight = image.naturalHeight * ratio;
      const drawX = (canvasSize - drawWidth) / 2;
      const drawY = (canvasSize - drawHeight) / 2;
      const proofReference = 'srd-proof-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);

      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvasSize, canvasSize);
      context.drawImage(image, drawX, drawY, drawWidth, drawHeight);
      drawProofMessage(context, data, config, canvasSize);

      const dataUrl = canvas.toDataURL('image/png');
      sessionStorage.setItem(proofReference, dataUrl);

      return {
        '_Proof Image Type': 'Watermarked PNG',
        '_Proof Image Included': 'true',
        '_Proof Image Data': proofReference,
        '_Proof Preview JSON': compactProofPreview(data)
      };
    } catch (error) {
      return proofFallbackProperties(data);
    }
  }

  async function buildCartPayloadWithProof() {
    if (!latestCartPayload || !latestDesignData) return latestCartPayload;
    const symbolSnapshot = dcpSymbolSubmissionSnapshot(latestDesignData);
    let proofProperties = proofFallbackProperties(latestDesignData);
    try {
      proofProperties = await captureProofImage(latestDesignData);
    } catch (error) {
      if (isDcpRequiredProofError(error)) throw error;
      debugLog('proof image capture failed; using fallback', error);
      proofProperties = proofFallbackProperties(latestDesignData);
    }
    assertDcpSymbolSubmissionSnapshotCurrent(latestDesignData, symbolSnapshot);
    debugLog('proof image status', proofProperties);
    return {
      items: buildDesignerCartItems(latestDesignData, proofProperties)
    };
  }

  function closeColorMenu() {
    if (!controls.colorMenu || !controls.colorButton) return;
    controls.colorMenu.hidden = true;
    controls.colorButton.setAttribute('aria-expanded', 'false');
  }

  function toggleColorMenu() {
    if (!controls.colorMenu || !controls.colorButton) return;
    const willOpen = controls.colorMenu.hidden;
    controls.colorMenu.hidden = !willOpen;
    controls.colorButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  function updateColorSelectState(fontColor) {
    if (!controls.colorButton || !controls.colorSelectedLabel) return;
    const label = fontColorLabels[fontColor] || 'Select Font Color';
    controls.colorSelectedLabel.textContent = fontColor ? label : 'Select Font Color';

    if (controls.colorSelectedChip) {
      controls.colorSelectedChip.hidden = !fontColor;
      controls.colorSelectedChip.className = 'srd-designer-color-select__chip';
      if (fontColor) controls.colorSelectedChip.classList.add('srd-designer-swatch__chip--' + fontColor);
    }

    controls.colorOptions.forEach((option) => {
      const selected = option.dataset.srdColorOption === fontColor;
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  }

  function emptyUploadedNitrousHeaderArtwork() {
    return {
      url: '',
      name: '',
      type: '',
      dimensions: '',
      width: '',
      height: '',
      reference: '',
      status: '',
      supported: false,
      previewable: false,
      message: ''
    };
  }

  function readUploadDimensions(url) {
    return new Promise((resolve) => {
      if (!url) {
        resolve({ width: '', height: '', dimensions: '' });
        return;
      }
      const image = new Image();
      image.onload = () => {
        const width = image.naturalWidth || image.width || '';
        const height = image.naturalHeight || image.height || '';
        resolve({
          width: width,
          height: height,
          dimensions: width && height ? width + ' x ' + height + ' px' : ''
        });
      };
      image.onerror = () => resolve({ width: '', height: '', dimensions: '' });
      image.src = url;
    });
  }

  function customArtStatusFor(fileType, extension, dimensions) {
    if (extension === 'eps') return 'EPS uploaded successfully.\nBrowser preview is unavailable.\nYour original EPS will be used for production.';
    if (fileType === 'image/svg+xml' || extension === 'svg') return 'SVG uploaded successfully and previewed for proof reference.';
    if (fileType === 'image/png' || extension === 'png') {
      if (dimensions.width && dimensions.height && (dimensions.width < 1500 || dimensions.height < 1500)) {
        return 'Warning: PNG is below the recommended 1500 x 1500 px resolution.';
      }
      return 'PNG uploaded successfully and previewed for proof reference.';
    }
    return 'Unsupported file type selected. Preferred file types are EPS, transparent PNG, or SVG.';
  }

  function isSupportedCustomArtUpload(fileType, extension) {
    return fileType === 'image/png' ||
      fileType === 'image/svg+xml' ||
      extension === 'png' ||
      extension === 'svg' ||
      extension === 'eps';
  }

  async function handleNitrousUploadChange() {
    if (!controls.nitrousUpload || !controls.nitrousUpload.files || !controls.nitrousUpload.files.length) {
      uploadedNitrousHeaderArtwork = emptyUploadedNitrousHeaderArtwork();
      update();
      return;
    }

    const file = controls.nitrousUpload.files[0];
    if (uploadedNitrousHeaderArtwork.url) URL.revokeObjectURL(uploadedNitrousHeaderArtwork.url);
    const name = file.name || '';
    const type = file.type || '';
    const extension = name.split('.').pop().toLowerCase();
    const previewable = type === 'image/png' || type === 'image/svg+xml' || extension === 'png' || extension === 'svg';
    const supported = isSupportedCustomArtUpload(type, extension);
    const objectUrl = previewable ? URL.createObjectURL(file) : '';
    const dimensions = await readUploadDimensions(objectUrl);
    const status = customArtStatusFor(type, extension, dimensions);

    uploadedNitrousHeaderArtwork = {
      url: objectUrl,
      name: name,
      type: type || extension,
      dimensions: dimensions.dimensions,
      width: dimensions.width,
      height: dimensions.height,
      reference: 'Attached via Shopify line item file upload',
      status: status,
      supported: supported,
      previewable: previewable,
      message: previewable ? status : status
    };
    update();
  }

  function emptyUploadedBlankCanvasArtwork() {
    return {
      url: '',
      name: '',
      type: '',
      dimensions: '',
      width: '',
      height: '',
      reference: '',
      status: '',
      supported: false,
      previewable: false,
      message: ''
    };
  }

  function blankCanvasStatusFor(fileType, extension, dimensions) {
    if (extension === 'eps') return 'EPS uploaded successfully. Browser preview is unavailable. Your original EPS will be used for production review.';
    if (extension === 'ai') return 'AI uploaded successfully. Browser preview is unavailable. Your original AI file will be used for production review.';
    if (extension === 'pdf' || fileType === 'application/pdf') return 'PDF uploaded successfully. Browser preview is unavailable. Your original PDF will be used for production review.';
    if (fileType === 'image/svg+xml' || extension === 'svg') return 'SVG uploaded successfully and previewed for proof reference.';
    if (isDcpRasterPreview(fileType, extension)) {
      if (dimensions.width && dimensions.height && (dimensions.width < 1500 || dimensions.height < 1500)) {
        return 'Warning: raster artwork is below the recommended 1500 x 1500 px resolution.';
      }
      return 'Artwork uploaded successfully and previewed for proof reference.';
    }
    return 'Unsupported file type selected. Accepted file types are EPS, AI, PDF, SVG, PNG, JPG, JPEG, and WEBP.';
  }

  function isSupportedBlankCanvasUpload(fileType, extension) {
    return isDcpRasterPreview(fileType, extension) ||
      fileType === 'image/svg+xml' ||
      fileType === 'application/pdf' ||
      extension === 'svg' ||
      extension === 'eps' ||
      extension === 'ai' ||
      extension === 'pdf';
  }

  function openDcpArtworkPicker() {
    if (isDieCuttingMode()) {
      setDieCuttingDevelopmentMessage('Artwork uploads are unavailable for Die Cutting.');
      return;
    }
    if (!controls.blankCanvasUpload || !requireDcpObjectToolbarCanvas()) return;
    if (controls.blankCanvasStart) controls.blankCanvasStart.value = 'upload_artwork';
    if (dcpArtworkNeedsReselection) clearDcpNativeArtworkInputForReselection();
    update();
    controls.blankCanvasUpload.click();
  }

  async function handleBlankCanvasUploadChange() {
    if (isDieCuttingMode()) {
      if (controls.blankCanvasUpload) controls.blankCanvasUpload.value = '';
      setDieCuttingDevelopmentMessage('Artwork uploads are unavailable for Die Cutting.');
      return;
    }
    const activationRevision = dcpModeActivationRevision;
    const historyStart = beginDcpHistoryTransaction();
    const previousProof = getDcpProofState();
    const previousNeedsReselection = dcpArtworkNeedsReselection;
    const previousArtworkAssetToken = dcpArtworkAssetToken;
    const previousProductionSourceToken = dcpProductionArtworkAssetToken;
    if (!controls.blankCanvasUpload || !controls.blankCanvasUpload.files || !controls.blankCanvasUpload.files.length) {
      dcpArtworkNeedsReselection = previousNeedsReselection;
      update();
      return;
    }

    const file = controls.blankCanvasUpload.files[0];
    const name = file.name || '';
    const type = file.type || '';
    const extension = name.split('.').pop().toLowerCase();
    const rasterPreview = isDcpRasterPreview(type, extension);
    const svgPreview = type === 'image/svg+xml' || extension === 'svg';
    const vectorPdfNotice = isDcpVectorPdfNotice(extension, type);
    const previewable = rasterPreview || svgPreview;
    const supported = isSupportedBlankCanvasUpload(type, extension);
    let objectUrl = '';

    if (!supported) {
      controls.blankCanvasUpload.value = '';
      restoreDcpArtworkFileRevision({
        design: {
          artwork: dcpHistoryArtworkState(previousProof),
          artworkAssetToken: previousArtworkAssetToken,
          artworkNeedsReselection: previousNeedsReselection
        }
      });
      restoreDcpProductionArtworkSource(previousProductionSourceToken);
      setCartMessage('Artwork file type must be EPS, AI, PDF, SVG, PNG, JPG, JPEG, WEBP, GIF, or BMP.', 'error');
      update();
      return;
    }

    try {
      objectUrl = previewable ? URL.createObjectURL(file) : '';
      const normalizedRaster = rasterPreview ? await normalizeDcpRasterProof(objectUrl) : null;
      if (!isCurrentDcpModeActivation('print_design', activationRevision)) {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        if (controls.blankCanvasUpload.files
          && sameDcpArtworkFile(controls.blankCanvasUpload.files[0], file)) {
          controls.blankCanvasUpload.value = '';
        }
        return;
      }
      if (rasterPreview && !normalizedRaster) throw new Error('The selected raster Artwork file could not be read.');
      if (normalizedRaster && objectUrl) {
        URL.revokeObjectURL(objectUrl);
        objectUrl = '';
      }
      const dimensions = normalizedRaster || await readUploadDimensions(objectUrl);
      if (!isCurrentDcpModeActivation('print_design', activationRevision)) {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        if (controls.blankCanvasUpload.files
          && sameDcpArtworkFile(controls.blankCanvasUpload.files[0], file)) {
          controls.blankCanvasUpload.value = '';
        }
        return;
      }
      if (previewable && (!dimensions.width || !dimensions.height)) throw new Error('The selected Artwork preview could not be read.');
      if (!controls.blankCanvasUpload.files || !sameDcpArtworkFile(controls.blankCanvasUpload.files[0], file)) {
        throw new Error('The selected production Artwork file is no longer available.');
      }

      const status = blankCanvasStatusFor(type, extension, dimensions);
      const displayStatus = name ? name + ' - ' + status : status;
      const revisionToken = registerDcpArtworkFileRevision(file);
      if (!revisionToken) throw new Error('The selected production Artwork file could not be registered.');

      dcpArtworkAssetToken = revisionToken;
      registerDcpProductionArtworkSource({
        status: 'native_file',
        originalFilename: name,
        fileType: type || extension,
        mutation: dcpCartEditSession.active ? 'replaced' : 'unchanged'
      });
      setDcpProofFromUpload({
        url: normalizedRaster ? normalizedRaster.url : objectUrl,
        name: name,
        type: type || extension,
        dimensions: dimensions.dimensions,
        width: dimensions.width,
        height: dimensions.height,
        reference: normalizedRaster ? normalizedRaster.reference : 'Attached via Shopify line item file upload',
        originalFilename: name,
        status: status,
        supported: true,
        previewable: previewable,
        noticeImage: vectorPdfNotice,
        noticeUrl: vectorPdfNotice ? dcpVectorPdfNoticeSrc : '',
        message: displayStatus
      });
      selectDcpObject('artwork');
      update();
      commitDcpHistoryTransaction(historyStart, dcpProofHasArtwork(previousProof) ? 'Replace artwork' : 'Add artwork');
    } catch (error) {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      if (!isCurrentDcpModeActivation('print_design', activationRevision)) {
        if (controls.blankCanvasUpload.files
          && sameDcpArtworkFile(controls.blankCanvasUpload.files[0], file)) {
          controls.blankCanvasUpload.value = '';
        }
        return;
      }
      controls.blankCanvasUpload.value = '';
      restoreDcpArtworkFileRevision({
        design: {
          artwork: dcpHistoryArtworkState(previousProof),
          artworkAssetToken: previousArtworkAssetToken,
          artworkNeedsReselection: previousNeedsReselection
        }
      });
      restoreDcpProductionArtworkSource(previousProductionSourceToken);
      setCartMessage(error && error.message ? error.message : 'The selected Artwork file could not be read.', 'error');
      debugLog('dcp artwork selection rejected', error);
      update();
    }
  }

  function update() {
    syncCalibrationFromInputs();

    const template = controls.template.value;
    const templateSelected = template !== '';
    if (isNitrousTemplate(template)) selectorState.template_category = 'nitrous';
    if (isBlankCanvasTemplate(template)) selectorState.template_category = 'blank_canvas';
    if (templateSelected && !isNitrousTemplate(template) && !isBlankCanvasTemplate(template)) selectorState.template_category = 'standard';
    if (selectorState.template_category === 'blank_canvas') {
      const expectedCustomFamily = topLevelProductFamilyForWorkspace(activeDcpWorkspaceMode);
      selectorState.product_family_key = expectedCustomFamily;
      selectorState.product_family = topLevelProductFamiliesByKey[expectedCustomFamily].label;
    } else if (selectorState.template_category === 'nitrous') {
      selectorState.product_family_key = 'nitrous_bottle_labels';
      selectorState.product_family = topLevelProductFamiliesByKey.nitrous_bottle_labels.label;
    } else if (selectorState.template_category === 'standard') {
      selectorState.product_family_key = 'standard_safety_signs';
      selectorState.product_family = topLevelProductFamiliesByKey.standard_safety_signs.label;
    }
    const designerMode = designerModeFromState(template);
    const nitrousMode = designerMode === 'nitrous';
    const standardMode = designerMode === 'standard';
    const blankCanvasMode = designerMode === 'blank_canvas';
    resetDcpWorkspaceAtFamilyBoundary(designerMode);
    const dcpProofState = getDcpProofState();
    const nitrousActive = nitrousMode && isNitrousTemplate(template);
    const config = nitrousMode && !nitrousActive
      ? { preview_png: nitrousDefaultPreviewSrc, alt: 'Nitrous bottle label customizer preview', custom_upload: false }
      : (templateIntelligence[template] || templateIntelligence.danger);
    const nitrousBottleWeight = selectedNitrousBottleWeight();
    const nitrousProfile = selectedNitrousBottleProfile();
    const nitrousCalibration = activeNitrousWeightCalibration(nitrousProfile);
    const nitrousHeaderChoice = selectedNitrousHeaderChoice();
    const nitrousHeaderCalibration = nitrousHeaderCalibrations[nitrousHeaderChoice.key] || nitrousHeaderCalibrations.nitrous_oxide_performance;
    const nitrousCustomArt = nitrousMode && Boolean(nitrousHeaderChoice.customUpload);
    const nitrousHeaderSrc = nitrousCustomArt ? uploadedNitrousHeaderArtwork.url : nitrousHeaderChoice.src;
    const nitrousTemplateChoice = selectedNitrousTemplateChoice();
    const blankCanvasSubfamily = blankCanvasMode ? selectedBlankCanvasSubfamily() : '';
    const dieCuttingMode = blankCanvasMode && blankCanvasSubfamily === 'die_cutting';
    const blankCanvasSubfamilyLabel = blankCanvasMode ? selectedBlankCanvasSubfamilyLabel() : '';
    if (blankCanvasMode) {
      syncDcpFontControlCatalog();
      syncDcpTextColorControlCatalog(dcpProofState.objects);
    }
    if (dieCuttingMode) syncDcpDimensionControls(false);
    const blankCanvasStartMode = selectedBlankCanvasStartMode();
    const showDcpVectorPdfNotice = blankCanvasMode && blankCanvasStartMode === 'upload_artwork' && dcpProofState.noticeImage && dcpProofState.noticeUrl;
    const blankCanvasStartLabel = optionLabel(controls.blankCanvasStart, 'Start Blank');
    const fontColor = selectedFontColor();
    const fontColorLabel = fontColorLabels[fontColor] || fontColorLabels[''];
    const fontColorValue = fontColorValues[fontColor] || fontColorValues.black;
    const customFamilyLabel = blankCanvasMode ? selectedTopLevelProductFamilyLabel() : '';
    const templateLabel = blankCanvasMode
      ? customFamilyLabel
      : (templateLabels[template] || (nitrousMode ? 'Nitrous Bottle Labels' : templateLabels.danger));
    const templateDisplayLabel = blankCanvasMode
      ? customFamilyLabel
      : (templateDisplayLabels[template] || (nitrousMode ? 'Template required' : templateDisplayLabels.danger));
    const fontLabel = fontLabels[controls.font.value] || fontLabels[''];
    const fontStack = fontStacks[controls.font.value] || fontStacks.arial;
    const message = sanitizeMessage(messageFromLineInputs());
    let dcpCanvasObjects = blankCanvasMode
      ? updateSelectedDcpTextObjectFromEditor()
      : normalizeDcpCanvasObjects(getDcpProofState().objects);
    if (dieCuttingMode) {
      dcpCanvasObjects = normalizeDcpCanvasObjects(dcpCanvasObjects, 'die_cutting');
      dcpProofState.objects = dcpCanvasObjects;
      dcpShapeRestoreValidationError = '';
      syncDcpProofCompatibilityAlias();
    }
    const size = effectiveDesignerSize(template);
    const physicalSize = blankCanvasMode ? activeDcpPhysicalSize(size) : null;
    if (blankCanvasMode && physicalSize) {
      if (previousDcpPhysicalSize && previousDcpPhysicalSize !== physicalSize.key) {
        if (dieCuttingMode) {
          if (!dcpDimensionEditSession) setDcpEditingZoom('fit', dcpFitEditingZoom, false);
        }
        else resetDcpEditingZoom(false);
        if (!dieCuttingMode) {
          dcpCanvasObjects = reconcileDcpProportionalObjectsForSize(dcpCanvasObjects, physicalSize);
        }
        const proof = currentDcpProofState || emptyDcpProofState();
        proof.objects = dcpCanvasObjects;
        currentDcpProofState = proof;
        syncDcpProofCompatibilityAlias();
      }
      previousDcpPhysicalSize = physicalSize.key;
    } else if (!blankCanvasMode && (dcpEditingZoom !== 1 || dcpEditingZoomIntent !== 'relative')) {
      resetDcpEditingZoom(false);
    }
    const material = controls.material ? controls.material.value : '';
    const lamination = controls.lamination ? controls.lamination.value : '';

    setDesignerMode(designerMode);
    syncDcpToolbarAndEditor(dcpCanvasObjects);
    if (dieCuttingMode) {
      scheduleDcpDieProductionReadiness();
    } else if (targets.dieCuttingReadiness) {
      targets.dieCuttingReadiness.hidden = true;
    }
    if (standardMode) ensureDesignerProductJsonLoaded();
    if (blankCanvasMode && !dieCuttingMode) ensureDcpProductJsonLoaded();
    if (nitrousMode) ensureNitrousProductJsonLoaded();

    if (controls.quantity && size !== previousSize) {
      if (!dieCuttingMode) {
        controls.quantity.value = blankCanvasMode && dcpCartEditSession.active && dcpCartEditSession.status !== 'resolved'
          ? ''
          : quantityDefaultForSize(size);
      }
      previousSize = size;
    }

    // The external Designer asset can execute while Shopify is still parsing
    // the section's inline product JSON. Refresh the strict exact-price lookup
    // before pricing/cart readiness so a transient empty initial parse cannot
    // permanently lock a correctly configured physical product.
    if (!dcpDieVariantLookup.ready) {
      dcpDieVariantLookup = buildDcpDieVariantLookup(parseDcpDieProductData());
    }
    const quantity = normalizedQuantity();
    const matchedVariant = blankCanvasMode && !dieCuttingMode
      ? matchedDcpVariant(size, material, lamination)
      : (dieCuttingMode ? null : matchedShopifyVariant(size, material, lamination));
    const pricing = dieCuttingMode
      ? dieCuttingDevelopmentPricing()
      : pricingFor(size, material, lamination, quantity, matchedVariant);
    const variantSelection = dieCuttingMode
      ? dieCuttingDevelopmentVariantSelection(pricing)
      : variantSelectionFor(size, material, lamination, pricing, matchedVariant);
    if (targets.variantId) targets.variantId.value = variantSelection.variant_id || '';
    root.dataset.srdVariantSource = variantSelection.source || 'None';
    root.dataset.srdDesignerVariantAvailable = variantSelection.available ? 'true' : 'false';
    latestPricing = pricing;
    latestPricingVariants = variantSelection;
    const subtotal = pricing.subtotal_display;

    if (controls.quantity) {
      const minimum = quantityDefaultForSize(size);
      controls.quantity.min = minimum || 1;
      if (quantity) controls.quantity.value = quantity;
      if (targets.quantityHint) {
        targets.quantityHint.textContent = dieCuttingMode
          ? 'Finished decal quantity. Minimum 1.'
          : (minimum ? 'Minimum Package Qty: ' + minimum + ' pcs.' : 'Select a size to set the Minimum Package Qty.');
      }
    }

    const readyForCart = requiredFieldsComplete(message, quantity) && pricing.ready && variantSelection.ready;
    const failure = validationFailure(message, quantity, pricing, variantSelection);
    const activeVariantReady = Boolean(variantSelection.ready && variantSelection.variant_id && variantSelection.available);
    const dcpCartLocked = blankCanvasMode && isDcpCartTestingLockout();
    const effectiveReadyForCart = readyForCart && !dcpCartLocked;
    const effectiveFailure = dcpCartLocked ? (dcpDieVariantLookup.failure || 'Custom Die development product setup is required.') : failure;
    syncCartReadinessMessage(designerMode, effectiveFailure, effectiveReadyForCart);
    const designData = {
      ready_for_cart: effectiveReadyForCart,
      template_key: templateSelected ? template : '',
      template_label: templateSelected ? templateDisplayLabel : '',
      selected_template_category: nitrousMode ? 'nitrous' : (blankCanvasMode ? 'blank_canvas' : ''),
      product_family_key: normalizeTopLevelProductFamily(selectorState.product_family_key),
      product_family: selectedTopLevelProductFamilyLabel() === 'Select Product Family' ? '' : selectedTopLevelProductFamilyLabel(),
      blank_canvas_subfamily: blankCanvasSubfamily,
      blank_canvas_subfamily_label: blankCanvasSubfamilyLabel,
      nitrous_product_id: nitrousMode ? nitrousProductId : '',
      header: templateSelected ? templateLabel : '',
      customer_message: templateSelected && !nitrousMode ? (blankCanvasMode ? dcpTextSummary(dcpCanvasObjects) : message) : '',
      dcp_text_summary: blankCanvasMode ? dcpTextSummary(dcpCanvasObjects) : '',
      size: size,
      nitrous_template_key: nitrousMode ? template : '',
      nitrous_template_label: nitrousMode && nitrousTemplateChoice ? nitrousTemplateChoice.label : '',
      nitrous_header_key: nitrousMode ? nitrousHeaderChoice.key : '',
      nitrous_header_label: nitrousMode ? nitrousHeaderChoice.label : '',
      nitrous_header_src: nitrousMode ? nitrousHeaderSrc : '',
      nitrous_template_image_url: nitrousMode && config.preview_png ? config.preview_png : '',
      nitrous_custom_art_file: nitrousCustomArt ? uploadedNitrousHeaderArtwork.name : '',
      nitrous_custom_art_filename: nitrousCustomArt ? uploadedNitrousHeaderArtwork.name : '',
      nitrous_custom_art_reference: nitrousCustomArt ? uploadedNitrousHeaderArtwork.reference : '',
      nitrous_custom_art_type: nitrousCustomArt ? uploadedNitrousHeaderArtwork.type : '',
      nitrous_custom_art_dimensions: nitrousCustomArt ? uploadedNitrousHeaderArtwork.dimensions : '',
      nitrous_custom_art_status: nitrousCustomArt ? uploadedNitrousHeaderArtwork.status : '',
      nitrous_custom_art_previewable: nitrousCustomArt ? uploadedNitrousHeaderArtwork.previewable : false,
      nitrous_bottle_weight: nitrousMode ? nitrousBottleWeight : '',
      nitrous_finished_label_size: nitrousMode ? nitrousProfile.finishedSize : '',
      nitrous_calibration_profile: nitrousMode ? nitrousProfile.calibrationProfile : '',
      nitrous_weight_values: nitrousMode ? nitrousProfile.weightCard.slice() : [],
      nitrous_package_price: nitrousMode && pricing.ready ? pricing.material_package_price : '',
      nitrous_package_price_display: nitrousMode && pricing.ready ? money(pricing.material_package_price) : '',
      nitrous_material: nitrousMode ? material : '',
      nitrous_plain_black_surcharge: nitrousMode && pricing.ready ? pricing.black_template_add_on : '',
      nitrous_plain_black_surcharge_display: nitrousMode && pricing.ready ? money(pricing.black_template_add_on) : '',
      nitrous_lamination_addon: nitrousMode && pricing.ready ? pricing.lamination_add_on : '',
      nitrous_lamination_addon_display: nitrousMode && pricing.ready ? money(pricing.lamination_add_on) : '',
      nitrous_estimated_total: nitrousMode && pricing.ready ? pricing.subtotal : '',
      nitrous_estimated_total_display: nitrousMode && pricing.ready ? money(pricing.subtotal) : '',
      blank_canvas_artwork_mode: blankCanvasMode ? blankCanvasStartLabel : '',
      blank_canvas_artwork_mode_key: blankCanvasMode ? blankCanvasStartMode : '',
      blank_canvas_artwork_filename: blankCanvasMode ? dcpProofState.originalFilename || dcpProofState.filename || dcpProofState.name : '',
      blank_canvas_artwork_type: blankCanvasMode ? dcpProofState.fileType || dcpProofState.type : '',
      blank_canvas_artwork_dimensions: blankCanvasMode ? dcpProofState.dimensions : '',
      blank_canvas_artwork_status: blankCanvasMode ? dcpProofState.status : '',
      blank_canvas_has_artwork: blankCanvasMode && dcpProofHasArtwork(dcpProofState),
      dcp_header_label: blankCanvasMode && dcpCanvasObjects.header ? dcpCanvasObjects.header.label : '',
      dcp_canvas_objects: blankCanvasMode
        ? (dieCuttingMode ? normalizeDcpCanvasObjects(dcpCanvasObjects, 'die_cutting') : dcpCanvasObjectsForExistingCommerce(dcpCanvasObjects, size, false))
        : null,
      blank_canvas_pricing_note: blankCanvasMode && !dieCuttingMode ? pricing.pricing_model : '',
      material: material,
      lamination: lamination,
      font: (!nitrousMode && controls.font.value) ? fontLabel : '',
      font_color: (!nitrousMode && fontColor) ? fontColorLabel : '',
      quantity: quantity || '',
      pricing_model: pricing.pricing_model || pricingModeName,
      dc_art_complexity_tier: pricing.ready ? pricing.dc_art_complexity_tier : '',
      dc_art_price_tier_inches: pricing.ready ? pricing.dc_art_price_tier_inches : '',
      dc_art_text_labor_unit_cents: pricing.ready ? pricing.dc_art_text_labor_unit_cents : '',
      base_package_price: pricing.ready ? pricing.base_package_price : '',
      base_package_price_display: pricing.ready ? money(pricing.base_package_price) : '',
      default_quantity: pricing.default_quantity || '',
      minimum_package_qty: pricing.minimum_package_qty || pricing.default_quantity || '',
      extra_piece_count: pricing.ready ? pricing.extra_piece_count : '',
      extra_piece_price: pricing.ready ? pricing.extra_piece_price : '',
      extra_piece_price_display: pricing.ready ? money(pricing.extra_piece_price) : '',
      extra_piece_variant_id: pricing.ready ? pricing.extra_piece_variant_id : '',
      surcharge_key: pricing.ready ? pricing.surcharge_key : '',
      additional_charge: pricing.ready ? pricing.additional_charge : '',
      text_object_count: pricing.ready ? pricing.text_object_count : '',
      included_text_object_count: pricing.ready ? pricing.included_text_object_count : '',
      additional_text_object_count: pricing.ready ? pricing.additional_text_object_count : '',
      additional_text_unit_cents: pricing.ready ? pricing.additional_text_unit_cents : '',
      additional_text_surcharge_cents: pricing.ready ? pricing.additional_text_surcharge_cents : '',
      pricing_enforcement_ready: pricing.ready ? pricing.enforcement_ready : false,
      lamination_add_on: pricing.ready ? pricing.lamination_add_on : '',
      lamination_add_on_display: pricing.ready ? money(pricing.lamination_add_on) : '',
      subtotal: pricing.ready ? pricing.subtotal : '',
      subtotal_display: subtotal,
      variant_selection: variantSelection,
      matched_variant_id: variantSelection.variant_id || '',
      matched_variant_sku: variantSelection.sku || '',
      matched_variant_price: Number.isFinite(variantSelection.price) ? variantSelection.price : '',
      matched_variant_price_display: variantSelection.price_display || '',
      proof_watermark: true,
      production_export_watermark: false
    };
    latestDesignData = designData;
    latestCartPayload = buildCartPayload(designData);

    if (controls.body.value !== message) {
      controls.body.value = message;
    }
    syncMessageLineInputs(message);
    updateColorSelectState(fontColor);
    updateSelectionRows();
    updatePricingDisplay(pricing, quantity);
    updateVariantLookupDiagnostics(variantSelection, subtotal);

    root.setAttribute('data-srd-template-selected', templateSelected ? 'true' : 'false');
    root.setAttribute('data-srd-nitrous-template', nitrousMode ? 'true' : 'false');
    root.setAttribute('data-srd-blank-canvas-subfamily', blankCanvasSubfamily);
    syncDcpDieVinylWorkspaceContrast(dcpCanvasObjects);
    root.setAttribute('data-srd-font-color', fontColor);
    root.setAttribute('data-srd-font', controls.font.value);
    const blankCanvasAspect = dieCuttingMode && physicalSize
      ? { ratio: physicalSize.width + ' / ' + physicalSize.height, number: physicalSize.width / physicalSize.height }
      : aspectForDesignerSize(blankCanvasMode ? dcpLandscapeSize(size) : size);
    if (targets.proofArtboard) {
      targets.proofArtboard.style.setProperty('--srd-proof-aspect-ratio', nitrousMode ? nitrousProfile.aspectRatio : (blankCanvasMode ? blankCanvasAspect.ratio : '1'));
      targets.proofArtboard.style.setProperty('--srd-proof-aspect-number', nitrousMode ? String(nitrousProfile.aspectNumber || 1) : (blankCanvasMode ? String(blankCanvasAspect.number || 1) : '1'));
    }
    if (blankCanvasMode) applyDcpPhysicalCanvasSize(size);
    syncDcpZoomControls(blankCanvasMode);
    syncDcpPrecisionTools();
    if (targets.templateArtwork) {
      if (blankCanvasMode || (nitrousMode && !config.preview_png)) {
        setImageSourceIfChanged(targets.templateArtwork, '', '');
      } else if (config.preview_png) {
        setImageSourceIfChanged(targets.templateArtwork, config.preview_png, config.alt);
      }
    }
    if (targets.blankCanvasPreview) {
      targets.blankCanvasPreview.hidden = !blankCanvasMode;
      const safeArea = blankCanvasCalibration.safe_area || {};
      targets.blankCanvasPreview.style.setProperty('--blank-canvas-safe-inset', Number.isFinite(Number(safeArea.inset)) ? String(Number(safeArea.inset)) : '0.06');
      targets.blankCanvasPreview.style.setProperty('--blank-canvas-safe-stroke', Number.isFinite(Number(safeArea.stroke_width)) ? String(Number(safeArea.stroke_width)) + 'px' : '2px');
    }
    if (targets.blankCanvasArtwork) {
      const dcpPreviewUrl = dcpProofState.previewUrl || dcpProofState.url || '';
      const dcpArtworkUrl = showDcpVectorPdfNotice ? dcpProofState.noticeUrl : dcpPreviewUrl;
      const showBlankArtwork = blankCanvasMode && selectedBlankCanvasStartMode() === 'upload_artwork' && Boolean(dcpArtworkUrl) && (dcpProofState.previewable || showDcpVectorPdfNotice);
      targets.blankCanvasArtwork.hidden = !showBlankArtwork;
      if (showBlankArtwork) {
        setImageSourceIfChanged(targets.blankCanvasArtwork, dcpArtworkUrl, showDcpVectorPdfNotice ? 'Vector artwork upload notification' : 'Uploaded blank canvas artwork');
      } else {
        setImageSourceIfChanged(targets.blankCanvasArtwork, '', '');
      }
      applyDcpArtworkObjectStyle(dcpCanvasObjects);
    }
    if (blankCanvasMode) {
      applyDcpShapeObjectStyle(dcpCanvasObjects);
      applyDcpHeaderObjectStyle(dcpCanvasObjects);
      syncDcpSymbolObjectElements(dcpCanvasObjects);
    } else {
      if (targets.dcpShapeObject) targets.dcpShapeObject.hidden = true;
      if (targets.dcpHeaderObject) targets.dcpHeaderObject.hidden = true;
      if (targets.dcpSymbolLayer) targets.dcpSymbolLayer.replaceChildren();
    }
    if (targets.blankCanvasUploadNotice) {
      const blankUploadMessage = blankCanvasMode && selectedBlankCanvasStartMode() === 'upload_artwork'
        ? (dcpArtworkNeedsReselection ? dcpArtworkReselectionGuidance : (dcpProofState.message || dcpProofState.status))
        : '';
      targets.blankCanvasUploadNotice.hidden = !blankUploadMessage;
      targets.blankCanvasUploadNotice.textContent = blankUploadMessage;
    }
    if (targets.blankCanvasSelectedFile) {
      const selectedFilename = blankCanvasMode && selectedBlankCanvasStartMode() === 'upload_artwork'
        ? dcpProofState.originalFilename || dcpProofState.filename || dcpProofState.name || ''
        : '';
      targets.blankCanvasSelectedFile.hidden = !selectedFilename;
      targets.blankCanvasSelectedFile.textContent = selectedFilename;
    }
    if (targets.blankCanvasRemoveArtwork) {
      const hasDcpArtwork = Boolean(dcpProofState.originalFilename || dcpProofState.filename || dcpProofState.name || dcpProofState.previewUrl || dcpProofState.url || dcpProofState.noticeUrl);
      targets.blankCanvasRemoveArtwork.hidden = !(blankCanvasMode && selectedBlankCanvasStartMode() === 'upload_artwork' && hasDcpArtwork);
      targets.blankCanvasRemoveArtwork.disabled = !hasDcpArtwork;
    }
    if (targets.nitrousUploadNotice) {
      const uploadMessage = nitrousCustomArt ? uploadedNitrousHeaderArtwork.message : '';
      targets.nitrousUploadNotice.hidden = !uploadMessage;
      targets.nitrousUploadNotice.textContent = uploadMessage;
    }
    if (targets.nitrousHeaderLogo) {
      targets.nitrousHeaderLogo.hidden = !(nitrousActive && nitrousHeaderSrc);
      if (nitrousActive && nitrousHeaderSrc) {
        targets.nitrousHeaderLogo.src = nitrousHeaderSrc;
        targets.nitrousHeaderLogo.alt = nitrousCustomArt ? 'Uploaded custom art' : nitrousHeaderChoice.label + ' logo';
        applyPercentCalibration(targets.nitrousHeaderLogo, 'nitrous-header', nitrousHeaderCalibration);
      } else {
        targets.nitrousHeaderLogo.removeAttribute('src');
        targets.nitrousHeaderLogo.alt = '';
      }
    }
    if (targets.nitrousWeightCard) {
      targets.nitrousWeightCard.hidden = !nitrousActive;
      targets.nitrousWeightCard.dataset.calibrationProfile = nitrousActive ? nitrousProfile.calibrationProfile : '';
      applyWeightCalibration(targets.nitrousWeightCard, nitrousCalibration);
    }
    if (targets.nitrousWeightTitle) targets.nitrousWeightTitle.textContent = nitrousBottleWeight;
    targets.nitrousWeightLines.forEach((line, index) => {
      line.textContent = nitrousActive ? (nitrousProfile.weightCard[index] || '') : '';
    });
    if (nitrousMode && selectorState.industry !== 'Motorsports') {
      selectorState.industry = 'Motorsports';
      selectorState.product_family = 'Nitrous';
    }
    const activeMessageConfig = blankCanvasMode ? null : config;
    const showPreviewMessage = templateSelected && !nitrousMode && !blankCanvasMode && isComplete(message);
    if (blankCanvasMode) {
      if (targets.previewMessage) {
        targets.previewMessage.textContent = '';
        targets.previewMessage.hidden = true;
      }
      syncDcpTextObjectElements(dcpCanvasObjects, fontStack, fontColorValue);
      applyDcpPrintableLayerOrder(dcpCanvasObjects);
    } else {
      syncDcpDiePaintedGeometry(null);
      if (targets.dcpTextLayer) {
        Array.from(targets.dcpTextLayer.querySelectorAll('[data-srd-dcp-text-id]')).forEach((element) => { element.hidden = true; });
      }
    }
    if (!blankCanvasMode) {
      if (!nitrousMode && applyTemplateGeometry(targets.previewMessage, activeMessageConfig)) {
        targets.previewMessage.style.color = fontColorValue;
        targets.previewMessage.style.fontFamily = fontStack;
      } else if (targets.previewMessage) {
        targets.previewMessage.hidden = false;
        targets.previewMessage.textContent = '';
        targets.previewMessage.removeAttribute('style');
      }
    }
    if (targets.previewMessage && showPreviewMessage) {
      targets.previewMessage.hidden = false;
      targets.previewMessage.textContent = message;
      targets.previewMessage.style.color = fontColorValue;
      targets.previewMessage.style.fontFamily = fontStack;
    } else if (targets.previewMessage && !showPreviewMessage) {
      targets.previewMessage.textContent = '';
    }
    applyDcpObjectSelectionState();
    if (targets.summaryTemplate) targets.summaryTemplate.textContent = templateSelected ? 'Header: ' + templateLabel : 'Select a product family to begin';
    if (targets.summarySize) targets.summarySize.textContent = size ? 'Size: ' + size : 'Select a size';
    renderOrderDetails(designerMode, {
      productFamilyLabel: designData.product_family,
      templateDisplayLabel: templateSelected ? templateDisplayLabel : '',
      size: size,
      material: material,
      lamination: lamination,
      fontLabel: nitrousMode ? '' : fontLabel,
      fontColorLabel: nitrousMode ? '' : fontColorLabel,
      customerMessage: !nitrousMode ? message : '',
      dcpTextObjectCount: blankCanvasMode ? dcpCanvasObjects.textObjects.length : 0,
      quantity: quantity,
      subtotal: subtotal,
      packagePrice: pricing.ready ? money(pricing.base_package_price) : '',
      nitrousTemplateLabel: nitrousMode && nitrousTemplateChoice ? nitrousTemplateChoice.label : '',
      nitrousHeaderLabel: nitrousMode ? nitrousHeaderChoice.label : '',
      nitrousBottleWeight: nitrousMode ? nitrousBottleWeight : '',
      blankCanvasSubfamilyLabel: blankCanvasMode ? blankCanvasSubfamilyLabel : '',
      blankCanvasStartLabel: blankCanvasMode ? blankCanvasStartLabel : '',
      blankCanvasArtworkFilename: blankCanvasMode ? dcpProofState.originalFilename || dcpProofState.filename || dcpProofState.name : '',
      blankCanvasHasArtwork: blankCanvasMode && dcpProofHasArtwork(dcpProofState),
      blankCanvasArtworkNeedsReselection: blankCanvasMode && dcpProofHasArtwork(dcpProofState) && dcpArtworkNeedsReselection,
      dieCuttingMode: dieCuttingMode,
      dieFinishedSize: dieCuttingMode ? dcpDieFinishedSizeLabel(dcpProofState.physicalCanvas) : '',
      dieVinylColors: dieCuttingMode ? dcpDieVinylColorsLabel(dcpCanvasObjects, dcpProofState) : '',
      pricing_enforcement_ready: pricing.ready ? pricing.enforcement_ready : false,
      diePricing: dieCuttingMode ? pricing : null
    });
    targets.propertyTemplate.value = templateSelected ? templateDisplayLabel : '';
    if (targets.propertyTemplateKey) targets.propertyTemplateKey.value = templateSelected ? template : '';
    targets.propertyHeader.value = templateSelected ? templateLabel : '';
    targets.propertyBody.value = templateSelected && !nitrousMode ? (blankCanvasMode ? dcpTextSummary(dcpCanvasObjects) : message) : '';
    targets.propertyFont.value = !nitrousMode && controls.font.value ? fontLabel : '';
    targets.propertyColor.value = !nitrousMode && fontColor ? fontColorLabel : '';
    targets.propertySize.value = size;
    if (targets.propertySizeAlias) targets.propertySizeAlias.value = size;
    if (targets.propertyProductFamily) {
      targets.propertyProductFamily.value = blankCanvasMode && !dieCuttingMode
        ? 'Blank Canvas'
        : (designData.product_family || '');
    }
    if (targets.propertySelectedTemplateCategory) targets.propertySelectedTemplateCategory.value = designData.selected_template_category;
    if (targets.propertyNitrousColorPattern) targets.propertyNitrousColorPattern.value = nitrousMode && nitrousTemplateChoice ? nitrousTemplateChoice.label : '';
    if (targets.propertyNitrousProductId) targets.propertyNitrousProductId.value = nitrousMode ? nitrousProductId : '';
    if (targets.propertyNitrousTemplateKey) targets.propertyNitrousTemplateKey.value = nitrousMode ? template : '';
    if (targets.propertyNitrousTemplateLabel) targets.propertyNitrousTemplateLabel.value = nitrousMode && nitrousTemplateChoice ? nitrousTemplateChoice.label : '';
    if (targets.propertyNitrousTemplateImageUrl) targets.propertyNitrousTemplateImageUrl.value = designData.nitrous_template_image_url || '';
    if (targets.propertyNitrousHeaderPublic) targets.propertyNitrousHeaderPublic.value = nitrousMode ? nitrousHeaderChoice.label : '';
    if (targets.propertyNitrousHeaderLabel) targets.propertyNitrousHeaderLabel.value = nitrousMode ? nitrousHeaderChoice.label : '';
    if (targets.propertyNitrousHeaderKey) targets.propertyNitrousHeaderKey.value = nitrousMode ? nitrousHeaderChoice.key : '';
    if (targets.propertyNitrousHeaderImageUrl) targets.propertyNitrousHeaderImageUrl.value = designData.nitrous_header_src || '';
    if (targets.propertyNitrousBottleWeight) targets.propertyNitrousBottleWeight.value = nitrousMode ? nitrousBottleWeight : '';
    if (targets.propertyNitrousFinishedSize) targets.propertyNitrousFinishedSize.value = nitrousMode ? nitrousProfile.finishedSize : '';
    if (targets.propertyNitrousCalibrationProfile) targets.propertyNitrousCalibrationProfile.value = nitrousMode ? nitrousProfile.calibrationProfile : '';
    if (targets.propertyNitrousWeightValues) targets.propertyNitrousWeightValues.value = nitrousMode ? nitrousProfile.weightCard.join(' / ') : '';
    if (targets.propertyNitrousPackageQuantity) targets.propertyNitrousPackageQuantity.value = nitrousMode ? String(designData.minimum_package_qty || designData.default_quantity || '') : '';
    if (targets.propertyCustomArtFilename) targets.propertyCustomArtFilename.value = nitrousCustomArt ? uploadedNitrousHeaderArtwork.name : '';
    if (targets.propertyCustomArtReference) targets.propertyCustomArtReference.value = nitrousCustomArt ? uploadedNitrousHeaderArtwork.reference : '';
    if (targets.propertyCustomArtType) targets.propertyCustomArtType.value = nitrousCustomArt ? uploadedNitrousHeaderArtwork.type : '';
    if (targets.propertyCustomArtDimensions) targets.propertyCustomArtDimensions.value = nitrousCustomArt ? uploadedNitrousHeaderArtwork.dimensions : '';
    if (targets.propertyCustomArtStatus) targets.propertyCustomArtStatus.value = nitrousCustomArt ? uploadedNitrousHeaderArtwork.status : '';
    if (targets.propertyBlankCanvasSubfamily) targets.propertyBlankCanvasSubfamily.value = blankCanvasMode ? blankCanvasSubfamilyLabel : '';
    if (targets.propertyBlankCanvasSubfamilyKey) targets.propertyBlankCanvasSubfamilyKey.value = blankCanvasMode ? blankCanvasSubfamily : '';
    if (targets.propertyBlankCanvasMode) targets.propertyBlankCanvasMode.value = blankCanvasMode ? blankCanvasStartLabel : '';
    const dcpOriginalFilename = dcpProofState.originalFilename || dcpProofState.filename || dcpProofState.name || '';
    if (targets.propertyBlankCanvasFilename) targets.propertyBlankCanvasFilename.value = blankCanvasMode ? dcpOriginalFilename : '';
    if (targets.propertyBlankCanvasType) targets.propertyBlankCanvasType.value = blankCanvasMode ? dcpProofState.fileType || dcpProofState.type : '';
    if (targets.propertyBlankCanvasStatus) targets.propertyBlankCanvasStatus.value = blankCanvasMode ? dcpProofState.status : '';
    if (targets.propertyBlankCanvasModeKey) targets.propertyBlankCanvasModeKey.value = blankCanvasMode ? blankCanvasStartMode : '';
    if (targets.propertyDcpArtworkFileDisplay) targets.propertyDcpArtworkFileDisplay.value = blankCanvasMode ? dcpOriginalFilename : '';
    if (targets.propertyDcpUploadedFileReference) targets.propertyDcpUploadedFileReference.value = blankCanvasMode ? dcpProductionArtworkReferenceForCart() : '';
    if (targets.propertyDcpOriginalFilename) targets.propertyDcpOriginalFilename.value = blankCanvasMode ? dcpOriginalFilename : '';
    if (targets.propertyDcpArtworkFilenameHidden) targets.propertyDcpArtworkFilenameHidden.value = blankCanvasMode ? dcpOriginalFilename : '';
    if (targets.propertyDcpArtworkTypeHidden) targets.propertyDcpArtworkTypeHidden.value = blankCanvasMode ? dcpProofState.fileType || dcpProofState.type : '';
    if (targets.propertyDcpCanvasSizeHidden) targets.propertyDcpCanvasSizeHidden.value = blankCanvasMode ? size : '';
    if (targets.propertyDcpMaterialHidden) targets.propertyDcpMaterialHidden.value = blankCanvasMode ? material : '';
    if (targets.propertyDcpLaminationHidden) targets.propertyDcpLaminationHidden.value = blankCanvasMode ? lamination : '';
    if (targets.propertyDcpQuantityHidden) targets.propertyDcpQuantityHidden.value = blankCanvasMode && quantity ? String(quantity) : '';
    if (targets.propertyDcpArtworkTransform) targets.propertyDcpArtworkTransform.value = blankCanvasMode ? 'fit-contain-center' : '';
    if (targets.propertyDcpCanvasObjects) {
      targets.propertyDcpCanvasObjects.value = blankCanvasMode && !dieCuttingMode
        ? JSON.stringify(dcpCanvasObjectsForExistingCommerce(dcpCanvasObjects, size, false))
        : '';
    }
    const dcpHeaderProperties = blankCanvasMode ? dcpHeaderCartProperties(dcpCanvasObjects) : {};
    if (targets.propertyDcpHeaderLabel) targets.propertyDcpHeaderLabel.value = dcpHeaderProperties.Header || '';
    if (targets.propertyDcpHeaderProduction) targets.propertyDcpHeaderProduction.value = dcpHeaderProperties._dcp_header_production || '';
    const dcpShapeProperties = blankCanvasMode && !dieCuttingMode ? dcpShapeCartProperties(dcpCanvasObjects, size) : {};
    if (targets.propertyDcpShapeLabel) targets.propertyDcpShapeLabel.value = dcpShapeProperties.Shape || '';
    if (targets.propertyDcpShapeProduction) targets.propertyDcpShapeProduction.value = dcpShapeProperties._dcp_shape_production || '';
    const dcpSymbolProperties = blankCanvasMode ? dcpSymbolCartProperties(dcpCanvasObjects, size, false) : {};
    if (targets.propertyDcpSymbolsLabel) targets.propertyDcpSymbolsLabel.value = dcpSymbolProperties.Symbols || '';
    if (targets.propertyDcpSymbolProduction) targets.propertyDcpSymbolProduction.value = dcpSymbolProperties._dcp_symbol_production || '';
    if (targets.propertyDcpTextPosition) targets.propertyDcpTextPosition.value = '';
    if (targets.propertyDcpArtworkPosition) targets.propertyDcpArtworkPosition.value = '';
    if (targets.propertyDcpSize) targets.propertyDcpSize.value = blankCanvasMode ? size : '';
    if (targets.propertyDcpMaterial) targets.propertyDcpMaterial.value = blankCanvasMode ? material : '';
    if (targets.propertyDcpLamination) targets.propertyDcpLamination.value = blankCanvasMode ? lamination : '';
    if (targets.propertyDcpQuantity) targets.propertyDcpQuantity.value = blankCanvasMode && quantity ? String(quantity) : '';
    if (targets.propertyDcpArtworkStatus) {
      targets.propertyDcpArtworkStatus.value = blankCanvasMode && dcpProofState.status && dcpProofState.status.indexOf('Warning:') === 0
        ? dcpProofState.status
        : '';
    }
    targets.propertyMaterial.value = material;
    targets.propertyLamination.value = lamination;
    targets.propertyQuantity.value = quantity ? String(quantity) : '';
    targets.propertySubtotal.value = subtotal;
    if (targets.propertyPricingModel) targets.propertyPricingModel.value = designData.pricing_model;
    if (targets.propertyBasePackagePrice) targets.propertyBasePackagePrice.value = designData.base_package_price_display;
    if (targets.propertyDefaultQuantity) targets.propertyDefaultQuantity.value = designData.default_quantity ? String(designData.default_quantity) : '';
    if (targets.propertyExtraPieceCount) targets.propertyExtraPieceCount.value = pricing.ready ? String(pricing.extra_piece_count) : '';
    if (targets.propertyExtraPiecePrice) targets.propertyExtraPiecePrice.value = designData.extra_piece_price_display;
    if (targets.propertyLaminationAddOn) targets.propertyLaminationAddOn.value = designData.lamination_add_on_display;
    if (targets.propertyMarker) targets.propertyMarker.value = 'true';
    if (targets.propertyBuild) targets.propertyBuild.value = 'v1';
    if (targets.propertyProofWatermark) targets.propertyProofWatermark.value = 'Preview only';
    if (targets.propertyProductionWatermark) targets.propertyProductionWatermark.value = 'false';
    if (targets.propertyMatchedVariantSku) targets.propertyMatchedVariantSku.value = designData.matched_variant_sku || '';
    if (targets.propertyMatchedVariantId) targets.propertyMatchedVariantId.value = designData.matched_variant_id || '';
    if (targets.propertyVariantSource) targets.propertyVariantSource.value = designData.variant_selection ? designData.variant_selection.source || '' : '';
    targets.propertyDesignData.value = dieCuttingMode ? '' : JSON.stringify(designData);
    syncDieCuttingCommerceFormLock(dieCuttingMode && !dcpModeAllows('commerce', 'die_cutting'));

    if (targets.proofWatermark) {
      targets.proofWatermark.hidden = !templateSelected;
      syncDcpProofWatermarkLayout(blankCanvasMode && templateSelected);
    }

    if (targets.addButton) {
      targets.addButton.disabled = dcpCartLocked || !activeVariantReady || !readyForCart;
      targets.addButton.setAttribute('aria-disabled', targets.addButton.disabled ? 'true' : 'false');
      targets.addButton.textContent = blankCanvasMode && dcpCartEditSession.active
        ? 'Update Design In Cart'
        : 'Add Design Proof To Cart';
    }

    setDebugStatus(activeVariantReady && effectiveReadyForCart, effectiveFailure);
    debugLog('validation', {
      product_picker_configured: hasConfiguredProduct(),
      fallback_variant_id: root.dataset.srdFallbackVariantId || '',
      resolved_variant_id: hasConfiguredVariant() ? targets.variantId.value : '',
      variant_source: root.dataset.srdVariantSource || '',
      variant_available: hasAvailableVariant(),
      required_fields_valid: activeVariantReady && effectiveReadyForCart,
      failure: effectiveFailure,
      cart_payload: latestCartPayload
    });

    window.requestAnimationFrame(() => {
      fitMessage();
      fitDcpTextObjects();
    });
    updateCalibrationPanel();
    syncDcpHistoryContextBoundary(designerMode, size);
    root.dataset.srdDesignerReady = 'true';
    root.removeAttribute('aria-busy');
  }

  function dcpHistoryControlMutation(target) {
    if (!target || !target.matches) return null;
    const selectors = [
      '[data-srd-dcp-text-input]',
      '[data-srd-dcp-font]',
      '[data-srd-dcp-font-color]',
      '[data-srd-dcp-text-outline-color]',
      '[data-srd-dcp-text-outline-thickness]',
      '[data-srd-dcp-text-shape]',
      '[data-srd-dcp-arc-amount]',
      '[data-srd-dcp-rotation]'
    ];
    if (!selectors.some((selector) => target.matches(selector))) return null;
    return {
      label: target.matches('[data-srd-dcp-text-input]') ? 'Edit text' : 'Change text style',
      coalescingKey: 'text-property:' + (dcpObjectId(selectedDcpObject) || 'none') + ':' + (target.name || target.id || target.dataset.srdDcpTextShape || target.type || 'control'),
      coalescingWindow: target.matches('[data-srd-dcp-text-input]') ? 750 : 300
    };
  }

  function handleDieCuttingTextBeforeInput(event) {
    if (!isDieCuttingMode()) return;
    if (event.inputType === 'insertLineBreak' || event.inputType === 'insertParagraph') {
      event.preventDefault();
      setDieCuttingDevelopmentMessage('Each Die Cutting text object is one line.');
      return;
    }
    if (event.inputType && event.inputType.indexOf('insert') === 0 && typeof event.data === 'string') {
      const control = event.currentTarget;
      const start = Number.isFinite(control.selectionStart) ? control.selectionStart : control.value.length;
      const end = Number.isFinite(control.selectionEnd) ? control.selectionEnd : start;
      const candidate = control.value.slice(0, start) + event.data + control.value.slice(end);
      const validation = validateDieCuttingTextValue(candidate);
      if (!validation.valid) {
        event.preventDefault();
        setDieCuttingDevelopmentMessage(validation.message);
      }
    }
  }

  function handleDieCuttingTextPaste(event) {
    if (!isDieCuttingMode()) return;
    const clipboard = event.clipboardData && event.clipboardData.getData('text/plain');
    event.preventDefault();
    const control = event.currentTarget;
    const start = Number.isFinite(control.selectionStart) ? control.selectionStart : control.value.length;
    const end = Number.isFinite(control.selectionEnd) ? control.selectionEnd : start;
    const replacement = normalizeDieCuttingWhitespace(clipboard);
    const candidate = control.value.slice(0, start) + replacement + control.value.slice(end);
    const validation = validateDieCuttingTextValue(candidate);
    if (!validation.valid) {
      setDieCuttingDevelopmentMessage(validation.message);
      return;
    }
    const historyStart = beginDcpHistoryTransaction();
    const normalizedPrefix = normalizeDieCuttingTextValue(control.value.slice(0, start) + replacement);
    control.value = validation.value;
    if (typeof control.setSelectionRange === 'function') {
      const cursor = Math.min(normalizedPrefix.length, control.value.length);
      control.setSelectionRange(cursor, cursor);
    }
    update();
    commitDcpHistoryTransaction(historyStart, 'Edit text', {
      coalescingKey: 'text-property:' + (dcpObjectId(selectedDcpObject) || 'none') + ':paste',
      coalescingWindow: 750
    });
    if (/[\r\n]/.test(String(clipboard || ''))) {
      setDieCuttingDevelopmentMessage('Pasted line breaks were converted to spaces.');
    }
  }

  async function handleDcpFontSelection(event) {
    event.stopPropagation();
    if (dcpEditorSyncing) return;
    const workflow = currentDcpFontWorkflow();
    const requested = controls.dcpFont.value;
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    const selectedText = selectedDcpTextObject(objects);
    const workspaceMode = activeDcpWorkspaceMode;
    const activationRevision = dcpModeActivationRevision;
    const selectionAtRequest = selectedDcpObject;
    const previous = selectedText && selectedText.fontKey
      ? selectedText.fontKey
      : dcpDefaultFontKey(workflow);
    if (!dcpFontAllowedForWorkflow(requested, workflow)) {
      controls.dcpFont.value = previous;
      setDieCuttingDevelopmentMessage('That font is unavailable for the selected Blank Canvas type.');
      return;
    }
    const revision = ++dcpFontLoadRevision;
    if (event.type !== 'focus') controls.dcpFont.disabled = true;
    try {
      await ensureDcpFontReady(requested);
      if (revision !== dcpFontLoadRevision) return;
      if (!isCurrentDcpModeActivation(workspaceMode, activationRevision)
        || selectedDcpObject !== selectionAtRequest) {
        controls.dcpFont.disabled = false;
        return;
      }
      controls.dcpFont.disabled = false;
      invalidateDcpDieTextDerivedState(selectionAtRequest, true);
      const historyStart = beginDcpHistoryTransaction();
      update();
      commitDcpHistoryTransaction(historyStart, 'Change text style', {
        coalescingKey: 'text-property:' + (dcpObjectId(selectedDcpObject) || 'none') + ':font',
        coalescingWindow: 300
      });
    } catch (error) {
      if (revision !== dcpFontLoadRevision) return;
      if (!isCurrentDcpModeActivation(workspaceMode, activationRevision)
        || selectedDcpObject !== selectionAtRequest) {
        controls.dcpFont.disabled = false;
        return;
      }
      failedDcpFontIds.add(requested);
      controls.dcpFont.disabled = false;
      controls.dcpFont.value = previous;
      controls.dcpFont.dataset.srdFontWorkflow = '';
      syncDcpFontControlCatalog();
      controls.dcpFont.value = previous;
      setDieCuttingDevelopmentMessage('The selected font could not be loaded. Choose another font.');
      update();
    }
  }

  function handleDesignerRootMutation(event) {
    if (controls.dieVinylColor && event.target === controls.dieVinylColor) {
      if (!controls.dieVinylColor.disabled && !targets.dieVinylColorField.hidden) {
        setSelectedDcpDieObjectVinylColor(controls.dieVinylColor.value);
      }
      return;
    }
    const mutation = dcpHistoryControlMutation(event.target);
    const historyStart = mutation ? beginDcpHistoryTransaction() : null;
    update();
    if (mutation) commitDcpHistoryTransaction(historyStart, mutation.label, mutation);
  }

  function dcpSelectedObjectRecord(objects) {
    const type = dcpObjectType(selectedDcpObject);
    if (type === 'artwork') return objects.artwork;
    if (type === 'header') return objects.header;
    if (type === 'shape') return objects.shape;
    if (type === 'symbol') return selectedDcpSymbolObject(objects);
    if (type === 'text') return selectedDcpTextObject(objects);
    return null;
  }

  function closeDcpAlignmentFlyout(restoreFocus) {
    if (!targets.dcpAlignFlyout || targets.dcpAlignFlyout.hidden) return false;
    targets.dcpAlignFlyout.hidden = true;
    if (targets.dcpAlignToggle) {
      targets.dcpAlignToggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) targets.dcpAlignToggle.focus();
    }
    return true;
  }

  function updateDcpAlignmentControls() {
    const available = isBlankCanvasMode(controls.template ? controls.template.value : '');
    const enabled = available
      && Boolean(activeDcpPhysicalSize())
      && selectedDcpObjects.length > 0;
    if (targets.dcpAlignControls) targets.dcpAlignControls.hidden = !available;
    if (targets.dcpAlignToggle) targets.dcpAlignToggle.disabled = !enabled;
    if (!enabled) closeDcpAlignmentFlyout();
  }

  function updateDcpLayerControls() {
    const printMode = isBlankCanvasMode(controls.template ? controls.template.value : '')
      && selectedBlankCanvasSubfamily() === 'print_design';
    const proof = getDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const order = printMode ? dcpVisibleLayerOrder(objects, proof) : [];
    const eligibleSelection = selectedDcpObjects.length === 1 && order.includes(selectedDcpObject);
    const index = eligibleSelection ? order.indexOf(selectedDcpObject) : -1;
    if (targets.dcpBringForward) {
      targets.dcpBringForward.hidden = !printMode;
      targets.dcpBringForward.disabled = !eligibleSelection || index === order.length - 1;
    }
    if (targets.dcpSendBackward) {
      targets.dcpSendBackward.hidden = !printMode;
      targets.dcpSendBackward.disabled = !eligibleSelection || index <= 0;
    }
  }

  function moveSelectedDcpLayer(direction) {
    if (selectedBlankCanvasSubfamily() !== 'print_design' || selectedDcpObjects.length !== 1) return false;
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const visibleOrder = dcpVisibleLayerOrder(objects, proof);
    const visibleIndex = visibleOrder.indexOf(selectedDcpObject);
    const nextVisibleIndex = visibleIndex + (direction > 0 ? 1 : -1);
    if (visibleIndex < 0 || nextVisibleIndex < 0 || nextVisibleIndex >= visibleOrder.length) {
      updateDcpLayerControls();
      return false;
    }
    const historyStart = beginDcpHistoryTransaction();
    const adjacent = visibleOrder[nextVisibleIndex];
    const currentIndex = objects.layerOrder.indexOf(selectedDcpObject);
    const adjacentIndex = objects.layerOrder.indexOf(adjacent);
    if (currentIndex < 0 || adjacentIndex < 0) return false;
    objects.layerOrder[currentIndex] = adjacent;
    objects.layerOrder[adjacentIndex] = selectedDcpObject;
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    update();
    commitDcpHistoryTransaction(historyStart, direction > 0 ? 'Bring object forward' : 'Send object backward');
    return true;
  }

  function openDcpAlignmentFlyout() {
    if (!targets.dcpAlignFlyout || !targets.dcpAlignToggle || targets.dcpAlignToggle.disabled) return false;
    closeDcpObjectToolbarFlyouts();
    if (!flyout.hidden) closeFlyout();
    if (controls.colorMenu && !controls.colorMenu.hidden) closeColorMenu();
    targets.dcpAlignFlyout.hidden = false;
    targets.dcpAlignToggle.setAttribute('aria-expanded', 'true');
    const firstAction = targets.dcpAlignActions[0];
    if (firstAction) firstAction.focus();
    return true;
  }

  function dcpAlignmentObjectBounds(selection, object, proof, physicalSize) {
    const objectType = dcpObjectType(selection);
    const canvasAspect = physicalSize.width / physicalSize.height;
    let width = Number(object && object.width);
    let height = Number(object && object.height);
    const x = Number(object && object.x);
    const y = Number(object && object.y);
    if (![x, y, width, height, canvasAspect].every(Number.isFinite) || width <= 0 || height <= 0 || canvasAspect <= 0) return null;

    if (objectType === 'text' && targets.proofArtboard) {
      const element = dcpObjectElement(selection);
      const paint = dcpTextPaintBounds(element);
      const artboardRect = targets.proofArtboard.getBoundingClientRect();
      if (paint && artboardRect.width && artboardRect.height) {
        const wrapperWidth = width / 100 * artboardRect.width;
        const wrapperHeight = height / 100 * artboardRect.height;
        const rotation = (Number(object.rotation) || 0) * Math.PI / 180;
        const cosine = Math.cos(rotation);
        const sine = Math.sin(rotation);
        const corners = [
          { x: paint.left, y: paint.top },
          { x: paint.left + paint.width, y: paint.top },
          { x: paint.left + paint.width, y: paint.top + paint.height },
          { x: paint.left, y: paint.top + paint.height }
        ].map((point) => {
          const localX = point.x - wrapperWidth / 2;
          const localY = point.y - wrapperHeight / 2;
          return {
            x: x + (localX * cosine - localY * sine) / artboardRect.width * 100,
            y: y + (localX * sine + localY * cosine) / artboardRect.height * 100
          };
        });
        return {
          left: Math.min(...corners.map((point) => point.x)),
          right: Math.max(...corners.map((point) => point.x)),
          top: Math.min(...corners.map((point) => point.y)),
          bottom: Math.max(...corners.map((point) => point.y))
        };
      }
    }

    // Artwork geometry is a contain box. Use its centered painted rectangle when
    // trusted raster dimensions are available, then retain the model's minimum
    // center constraint so the serialized state remains valid after alignment.
    if (objectType === 'artwork') {
      const imageWidth = Number(proof && proof.width);
      const imageHeight = Number(proof && proof.height);
      if (imageWidth > 0 && imageHeight > 0) {
        const imageAspect = imageWidth / imageHeight;
        const boxAspect = width * canvasAspect / height;
        if (imageAspect > boxAspect) height = width * canvasAspect / imageAspect;
        else width = height * imageAspect / canvasAspect;
      }
    }

    let halfWidth = width / 2;
    let halfHeight = height / 2;
    const rotation = objectType === 'text' || objectType === 'symbol' || objectType === 'artwork' ? Number(object.rotation) || 0 : 0;
    if (rotation) {
      const radians = rotation * Math.PI / 180;
      const cos = Math.abs(Math.cos(radians));
      const sin = Math.abs(Math.sin(radians));
      halfWidth = (width * cos + height * sin / canvasAspect) / 2;
      halfHeight = (width * sin * canvasAspect + height * cos) / 2;
    }

    const modelHalfWidth = objectType === 'header' || objectType === 'shape' || objectType === 'symbol'
      ? Number(object.width) / 2
      : 4;
    const modelHalfHeight = objectType === 'header' || objectType === 'shape' || objectType === 'symbol'
      ? Number(object.height) / 2
      : 4;
    halfWidth = Math.max(halfWidth, modelHalfWidth);
    halfHeight = Math.max(halfHeight, modelHalfHeight);
    if (![halfWidth, halfHeight].every(Number.isFinite)) return null;
    return {
      left: x - halfWidth,
      right: x + halfWidth,
      top: y - halfHeight,
      bottom: y + halfHeight
    };
  }

  function alignSelectedDcpObjects(action) {
    if (!selectedDcpObjects.length || !isBlankCanvasMode(controls.template ? controls.template.value : '')) return false;
    const physicalSize = activeDcpPhysicalSize();
    if (!physicalSize) return false;
    const proof = getDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const selections = selectedDcpObjects.slice();
    const records = selections.map((selection) => {
      const object = dcpObjectRecordForSelection(objects, selection);
      const bounds = object ? dcpAlignmentObjectBounds(selection, object, proof, physicalSize) : null;
      return object && bounds ? { selection: selection, object: object, bounds: bounds } : null;
    });
    if (records.some((record) => !record)) return false;

    const group = records.reduce((bounds, record) => {
      return {
        left: Math.min(bounds.left, record.bounds.left),
        right: Math.max(bounds.right, record.bounds.right),
        top: Math.min(bounds.top, record.bounds.top),
        bottom: Math.max(bounds.bottom, record.bounds.bottom)
      };
    }, { left: Infinity, right: -Infinity, top: Infinity, bottom: -Infinity });
    const tolerance = 0.000001;
    const groupCenterX = (group.left + group.right) / 2;
    const groupCenterY = (group.top + group.bottom) / 2;
    const singleSelection = records.length === 1;
    const canvasCenterAction = action === 'center-canvas';
    const sharedDeltaX = action === 'left'
      ? -group.left
      : (action === 'center-horizontal' || canvasCenterAction ? 50 - groupCenterX : (action === 'right' ? 100 - group.right : 0));
    const sharedDeltaY = action === 'top'
      ? -group.top
      : (action === 'center-vertical' || canvasCenterAction ? 50 - groupCenterY : (action === 'bottom' ? 100 - group.bottom : 0));
    const validAction = ['left', 'center-horizontal', 'right', 'top', 'center-vertical', 'bottom', 'center-canvas'].includes(action);
    if (!validAction || ![sharedDeltaX, sharedDeltaY].every(Number.isFinite)) return false;

    const positionUpdates = records.map((record) => {
      let deltaX = sharedDeltaX;
      let deltaY = sharedDeltaY;
      if (!singleSelection) {
        if (canvasCenterAction) {
          deltaX = 50 - (record.bounds.left + record.bounds.right) / 2;
          deltaY = 50 - (record.bounds.top + record.bounds.bottom) / 2;
        } else if (action === 'left') deltaX = group.left - record.bounds.left;
        else if (action === 'center-horizontal') deltaX = groupCenterX - (record.bounds.left + record.bounds.right) / 2;
        else if (action === 'right') deltaX = group.right - record.bounds.right;
        else if (action === 'top') deltaY = group.top - record.bounds.top;
        else if (action === 'center-vertical') deltaY = groupCenterY - (record.bounds.top + record.bounds.bottom) / 2;
        else if (action === 'bottom') deltaY = group.bottom - record.bounds.bottom;
      }
      if (![deltaX, deltaY].every(Number.isFinite)) return null;
      const requested = {
        selection: record.selection,
        x: record.object.x + (Math.abs(deltaX) < tolerance ? 0 : deltaX),
        y: record.object.y + (Math.abs(deltaY) < tolerance ? 0 : deltaY)
      };
      const canonical = canonicalDcpObjectPosition(
        record.selection,
        record.object,
        requested,
        proof,
        physicalSize
      );
      return {
        selection: record.selection,
        x: canonical.x,
        y: canonical.y
      };
    });
    if (positionUpdates.some((position) => !position)) return false;
    if (positionUpdates.every((position, index) => {
      return Math.abs(position.x - records[index].object.x) < tolerance
        && Math.abs(position.y - records[index].object.y) < tolerance;
    })) return false;

    const historyStart = beginDcpHistoryTransaction();
    const moved = updateDcpObjectPositionSet(positionUpdates);
    if (!moved) return false;
    update();
    commitDcpHistoryTransaction(
      historyStart,
      singleSelection || canvasCenterAction ? 'Align selected objects to canvas' : 'Align selected objects'
    );
    return true;
  }

  function closeDcpRotateFlyout(restoreFocus) {
    if (!targets.dcpRotateFlyout) return;
    targets.dcpRotateFlyout.hidden = true;
    if (targets.dcpRotateToggle) {
      targets.dcpRotateToggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) targets.dcpRotateToggle.focus();
    }
  }

  function rotateSelectedDcpObject(action) {
    if (selectedDcpObjects.length !== 1) return false;
    const type = dcpObjectType(selectedDcpObject);
    if (type !== 'artwork' && type !== 'text') return false;
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects, isDieCuttingMode() ? 'die_cutting' : activeDcpWorkspaceMode);
    const object = dcpObjectRecordForSelection(objects, selectedDcpObject);
    if (!object) return false;
    const historyStart = beginDcpHistoryTransaction();
    const previous = clampDcpNumber(object.rotation, -180, 180, 0);
    const next = action === 'reset' ? 0 : clampDcpNumber(previous + Number(action || 0), -180, 180, previous);
    if (Math.abs(next - previous) < .0001) return false;
    object.rotation = next;
    if (type === 'text') {
      if (targets.dcpRotation) targets.dcpRotation.value = String(next);
      invalidateDcpDieTextDerivedState(selectedDcpObject, false);
    }
    proof.objects = objects;
    currentDcpProofState = proof;
    if (controls.confirmation) controls.confirmation.checked = false;
    syncDcpProofCompatibilityAlias();
    update();
    commitDcpHistoryTransaction(historyStart, 'Rotate selected object');
    document.dispatchEvent(new CustomEvent('srd:dc-art-changed', { detail: dcArtState() }));
    return true;
  }

  function dcpObjectNudgeBounds(object, selection, proof, physicalSize) {
    return dcpObjectPositionConstraint(selection, object, proof, physicalSize);
  }

  function nudgeSelectedDcpObject(direction, largeStep) {
    if (!selectedDcpObjects.length || !selectedDcpObject || !isBlankCanvasMode(controls.template.value)) return false;
    const physicalSize = activeDcpPhysicalSize();
    if (!physicalSize) return false;
    const objects = normalizeDcpCanvasObjects(getDcpProofState().objects);
    const inches = largeStep ? 0.125 : 0.03125;
    const deltaX = inches / physicalSize.width * 100;
    const deltaY = inches / physicalSize.height * 100;
    const movement = {
      ArrowLeft: { x: -deltaX, y: 0 },
      ArrowRight: { x: deltaX, y: 0 },
      ArrowUp: { x: 0, y: -deltaY },
      ArrowDown: { x: 0, y: deltaY }
    }[direction];
    if (!movement) return false;

    if (selectedDcpObjects.length > 1) {
      const selections = selectedDcpObjects.slice();
      const selectedRecords = selections.map((selection) => {
        const object = dcpObjectRecordForSelection(objects, selection);
        return object ? { selection: selection, object: object } : null;
      });
      if (selectedRecords.some((item) => !item)) return false;

      let minimumDeltaX = -Infinity;
      let maximumDeltaX = Infinity;
      let minimumDeltaY = -Infinity;
      let maximumDeltaY = Infinity;
      selectedRecords.forEach((item) => {
        const bounds = dcpObjectNudgeBounds(item.object, item.selection, getDcpProofState(), physicalSize);
        minimumDeltaX = Math.max(minimumDeltaX, bounds.minX - item.object.x);
        maximumDeltaX = Math.min(maximumDeltaX, bounds.maxX - item.object.x);
        minimumDeltaY = Math.max(minimumDeltaY, bounds.minY - item.object.y);
        maximumDeltaY = Math.min(maximumDeltaY, bounds.maxY - item.object.y);
      });
      const sharedDeltaX = movement.x > 0
        ? Math.max(0, Math.min(maximumDeltaX, movement.x))
        : (movement.x < 0 ? Math.min(0, Math.max(minimumDeltaX, movement.x)) : 0);
      const sharedDeltaY = movement.y > 0
        ? Math.max(0, Math.min(maximumDeltaY, movement.y))
        : (movement.y < 0 ? Math.min(0, Math.max(minimumDeltaY, movement.y)) : 0);
      if (!sharedDeltaX && !sharedDeltaY) return false;

      const historyStart = beginDcpHistoryTransaction();
      const moved = updateDcpObjectPositionSet(selectedRecords.map((item) => {
        return {
          selection: item.selection,
          x: item.object.x + sharedDeltaX,
          y: item.object.y + sharedDeltaY
        };
      }));
      if (!moved) return false;
      update();
      commitDcpHistoryTransaction(
        historyStart,
        largeStep ? 'Nudge selected objects 1/8 inch' : 'Nudge selected objects 1/32 inch',
        {
          coalescingKey: 'nudge-group:' + selections.join('|'),
          coalescingWindow: 300
        }
      );
      return true;
    }

    const object = dcpSelectedObjectRecord(objects);
    if (!object) return false;
    const bounds = dcpObjectNudgeBounds(object, selectedDcpObject, getDcpProofState(), physicalSize);
    const nextX = clampDcpNumber(object.x + movement.x, bounds.minX, bounds.maxX, object.x);
    const nextY = clampDcpNumber(object.y + movement.y, bounds.minY, bounds.maxY, object.y);
    if (nextX === object.x && nextY === object.y) return false;
    const historyStart = beginDcpHistoryTransaction();
    updateDcpObjectTransform(selectedDcpObject, { x: nextX, y: nextY });
    applyDcpObjectStyles();
    update();
    commitDcpHistoryTransaction(historyStart, largeStep ? 'Nudge object 1/8 inch' : 'Nudge object 1/32 inch', {
      coalescingKey: 'nudge:' + selectedDcpObject,
      coalescingWindow: 300
    });
    return true;
  }

  function deleteSelectedDcpObjectGroup() {
    if (selectedDcpObjects.length < 2) return false;
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const selections = selectedDcpObjects.slice();
    const textIds = new Set();
    const symbolIds = new Set();
    let deleteArtwork = false;
    let deleteHeader = false;
    let deleteShape = false;

    selections.forEach((selection) => {
      const type = dcpObjectType(selection);
      const id = dcpObjectId(selection);
      if (type === 'text' && id) textIds.add(id);
      else if (type === 'symbol' && id) symbolIds.add(id);
      else if (type === 'artwork') deleteArtwork = dcpProofHasArtwork(proof);
      else if (type === 'header') deleteHeader = Boolean(objects.header);
      else if (type === 'shape') deleteShape = Boolean(objects.shape);
    });

    const nextTextObjects = objects.textObjects.filter((item) => !textIds.has(item.id));
    const nextSymbolObjects = objects.symbolObjects.filter((item) => !symbolIds.has(item.id));
    const deleted = nextTextObjects.length !== objects.textObjects.length
      || nextSymbolObjects.length !== objects.symbolObjects.length
      || deleteArtwork
      || deleteHeader
      || deleteShape;
    if (!deleted) return false;

    objects.textObjects = nextTextObjects;
    objects.symbolObjects = nextSymbolObjects;
    if (deleteHeader) objects.header = null;
    if (deleteShape) {
      objects.shape = null;
      dcpShapeRestoreValidationError = '';
    }
    if (symbolIds.size) {
      dcpSymbolLoadRevision += 1;
      dcpSymbolRestorePending = false;
      dcpSymbolRestoreValidationError = '';
    }

    if (deleteArtwork) {
      objects.artwork = defaultDcpCanvasObjects().artwork;
      if (controls.blankCanvasUpload) controls.blankCanvasUpload.value = '';
      dcpArtworkAssetToken = '';
      setDcpProofFromUpload({
        ...emptyDcpProofState(),
        mode: selectedBlankCanvasStartMode(),
        objects: objects
      });
      registerDcpProductionArtworkSource({
        status: 'none',
        mutation: dcpCartEditSession.active && dcpCartEditSession.originalHadArtwork ? 'removed' : 'unchanged'
      });
    } else {
      proof.objects = objects;
      currentDcpProofState = proof;
      syncDcpProofCompatibilityAlias();
    }

    clearDcpObjectSelection();
    if (deleteHeader) closeDcpHeaderLibrary();
    if (deleteShape) closeDcpShapeLibrary();
    if (symbolIds.size) closeDcpSymbolLibrary();
    update();
    commitDcpHistoryTransaction(historyStart, 'Delete selected objects');
    return true;
  }

  function deleteSelectedDcpObject() {
    if (selectedDcpObjects.length > 1) return deleteSelectedDcpObjectGroup();
    if (selectedDcpObjects.length !== 1) return false;
    const type = dcpObjectType(selectedDcpObject);
    if (type === 'text') deleteSelectedDcpTextObject();
    else if (type === 'artwork') clearDcpUploadedArtwork();
    else if (type === 'header') clearDcpHeader();
    else if (type === 'shape') clearDcpShape();
    else if (type === 'symbol') removeDcpSymbolObject();
    else return false;
    return true;
  }

  function closeActiveDesignerFlyout() {
    if (targets.dcpAlignFlyout && !targets.dcpAlignFlyout.hidden) {
      closeDcpAlignmentFlyout(true);
      return true;
    }
    if (targets.dcpSymbolFlyout && !targets.dcpSymbolFlyout.hidden) {
      closeDcpSymbolLibrary();
      return true;
    }
    if (targets.dcpShapeFlyout && !targets.dcpShapeFlyout.hidden) {
      closeDcpShapeLibrary();
      return true;
    }
    if (targets.dcpHeaderFlyout && !targets.dcpHeaderFlyout.hidden) {
      closeDcpHeaderLibrary();
      return true;
    }
    if (!flyout.hidden) {
      closeFlyout();
      return true;
    }
    if (controls.colorMenu && !controls.colorMenu.hidden) {
      closeColorMenu();
      return true;
    }
    return false;
  }

  function dcpShortcutTargetIsProtected(target) {
    if (!target || !target.closest) return false;
    return Boolean(target.closest('input, textarea, select, option, button, [contenteditable=""], [contenteditable="true"], [role="textbox"], [data-srd-shortcut-protected]'));
  }

  function dcpShortcutTargetIsTextEntry(target) {
    if (!target || !target.closest) return false;
    return Boolean(target.closest('input, textarea, select, option, [contenteditable=""], [contenteditable="true"], [role="textbox"]'));
  }

  function selectAllDcpObjects() {
    const proof = getDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects);
    const selections = objects.textObjects.map((item) => dcpTextSelection(item.id))
      .concat(objects.header ? ['header'] : [])
      .concat(objects.shape ? ['shape'] : [])
      .concat(objects.symbolObjects.map((item) => dcpSymbolSelection(item.id)))
      .concat(dcpProofHasArtwork(proof) ? ['artwork'] : []);
    if (!selections.length) return false;
    const primary = validDcpHistorySelection(selectedDcpObject, objects, proof) || selections[selections.length - 1];
    dcpObjectInteraction = null;
    setDcpObjectSelection(selections, primary);
    applyDcpObjectSelectionState();
    return true;
  }

  function handleDcpKeyboardShortcut(event) {
    if (!isBlankCanvasMode(controls.template.value) || event.defaultPrevented || event.isComposing || event.altKey) return;
    const key = String(event.key || '');
    const normalizedKey = key.toLowerCase();
    if (key === 'Escape' && !dcpShortcutTargetIsTextEntry(event.target)) {
      if (event.repeat) return;
      if (closeActiveDesignerFlyout()) {
        event.preventDefault();
      } else if (dcpMultiSelectMode) {
        dcpMultiSelectMode = false;
        dcpObjectInteraction = null;
        updateDcpMultiSelectControls();
        applyDcpObjectSelectionState();
        event.preventDefault();
      } else if (selectedDcpObjects.length) {
        clearDcpObjectSelection();
        applyDcpObjectSelectionState();
        update();
        event.preventDefault();
      }
      return;
    }
    if (dcpShortcutTargetIsTextEntry(event.target)) return;
    const commandModifier = event.ctrlKey || event.metaKey;
    if (commandModifier && normalizedKey === 'z') {
      if (event.repeat) return;
      const handled = event.shiftKey ? redoDcpHistory() : undoDcpHistory();
      if (handled) event.preventDefault();
      return;
    }
    if (commandModifier && normalizedKey === 'y' && !event.shiftKey) {
      if (event.repeat) return;
      if (redoDcpHistory()) event.preventDefault();
      return;
    }
    if (commandModifier && normalizedKey === 'a' && !event.shiftKey) {
      if (event.repeat) return;
      if (selectAllDcpObjects()) event.preventDefault();
      return;
    }
    if (commandModifier) return;
    if (dcpShortcutTargetIsProtected(event.target)) return;
    if (key === 'Delete' || key === 'Backspace') {
      if (event.repeat) return;
      if (deleteSelectedDcpObject()) event.preventDefault();
      return;
    }
    if (key === 'ArrowLeft' || key === 'ArrowRight' || key === 'ArrowUp' || key === 'ArrowDown') {
      if (nudgeSelectedDcpObject(key, event.shiftKey)) event.preventDefault();
    }
  }

  function dcpCartEditToken() {
    return 'dcp-edit-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function dcpCartEditTransactionKind(originalVariantId, selectedVariantId, productionSourceStatus) {
    return 'replace';
  }

  function dcpCartLineByTransaction(cart, token) {
    return cart && Array.isArray(cart.items)
      ? cart.items.find((item) => String(dcpCartLineProperties(item)._dcp_cart_edit_token || '') === token) || null
      : null;
  }

  function validateUpdatedDcpCartLine(line, expectedVariantId, transactionToken, expectedProductionReference, expectNativeFile) {
    if (!line) return 'Shopify did not return the updated design line.';
    if (String(line.product_id || '') !== dcpProductId || String(line.variant_id || line.id || '') !== String(expectedVariantId || '')) {
      return 'The updated cart line does not match the selected DCP product variant.';
    }
    const properties = dcpCartLineProperties(line);
    if (String(properties._dcp_cart_edit_token || '') !== transactionToken ||
        !hasDcpCartIdentity(properties) ||
        String(properties['Product Family'] || '') !== 'Blank Canvas') {
      return 'The updated cart line failed SRD Blank Canvas verification.';
    }
    const productionReference = String(properties[dcpNativeArtworkPropertyName] || '');
    const proofReferences = new Set([
      String(properties[dcpProofFilePropertyName] || ''),
      String(properties['_Proof Image Data'] || ''),
      String(properties._dcp_proof_image_data || ''),
      String(properties._dcp_artwork_image_data || '')
    ].filter(Boolean));
    if (expectedProductionReference && productionReference !== expectedProductionReference) {
      return 'The original production Artwork reference was not preserved.';
    }
    if (expectNativeFile && !isTrustedDcpUploadUrl(productionReference)) {
      return 'Shopify did not attach a trusted native production Artwork file.';
    }
    if (!isTrustedDcpUploadUrl(properties[dcpProofFilePropertyName])) {
      return 'Shopify did not attach the durable final DCP proof file.';
    }
    if ((expectedProductionReference || expectNativeFile) && proofReferences.has(productionReference)) {
      return 'The proof image cannot replace the native production Artwork file.';
    }
    if (!dcpProofHasArtwork() && productionReference) {
      return 'Removed Artwork remained attached to the updated cart line.';
    }
    let expectedSymbolProperties = null;
    try {
      expectedSymbolProperties = serializeDcpProofForCart();
    } catch (error) {
      return error && error.message ? error.message : 'The updated Symbol state could not be verified.';
    }
    if (String(properties._dcp_canvas_objects || '') !== String(expectedSymbolProperties._dcp_canvas_objects || '')
      || String(properties.Symbols || '') !== String(expectedSymbolProperties.Symbols || '')
      || String(properties._dcp_symbol_production || '') !== String(expectedSymbolProperties._dcp_symbol_production || '')) {
      return 'The updated cart line does not match the current Symbol design state.';
    }
    return '';
  }

  async function currentDcpEditLineForMutation() {
    if (!dcpCartEditSession.active || dcpCartEditSession.status !== 'resolved') {
      throw new Error(dcpCartEditSession.failure || 'The original cart design has not been verified.');
    }
    const cart = await fetchCurrentDcpCart();
    const line = findDcpCartLine(cart, dcpCartEditSession.lineKey);
    const identityError = dcpCartLineIdentityError(line, dcpCartEditSession);
    if (identityError) throw new Error(identityError);
    const pricingIntegrity = dcpPricingSnapshotFromCartLine(line);
    if (pricingIntegrity.error) throw new Error(pricingIntegrity.error);
    const pricingError = validateDcpPricingGroup(
      cart,
      pricingIntegrity.group,
      String(line.variant_id || line.id || ''),
      pricingIntegrity.pricing
    );
    if (pricingError) throw new Error(pricingError);
    const currentReference = String(dcpCartLineProperties(line)[dcpNativeArtworkPropertyName] || '');
    if (currentReference !== dcpCartEditSession.originalProductionReference) {
      throw new Error('The original production Artwork reference changed in another cart session.');
    }
    if (dcpProductionArtworkSource.status === 'trusted_cart_reference') {
      const trust = existingProductionArtworkReferenceIsTrusted(line);
      if (!trust.trusted || trust.reference !== dcpProductionArtworkSource.reference) {
        throw new Error(trust.reason || 'The original production Artwork reference is no longer trusted.');
      }
      if (!await verifyDcpProductionReferenceAccessible(trust.reference)) {
        throw new Error('The original production Artwork reference is no longer accessible.');
      }
    }
    return line;
  }

  function dcpCartJsonRequest(url, body) {
    return dcpCartFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
  }

  function dcpPricingGroupLines(cart, pricingGroup) {
    return cart && Array.isArray(cart.items)
      ? cart.items.filter((item) =>
          String(dcpCartLineProperties(item)._dcp_pricing_group || '') === String(pricingGroup || '')
        )
      : [];
  }

  function isDcpExtraPieceLine(line) {
    return String(dcpCartLineProperties(line)['_SRD Designer Add-On'] || '') === dcpExtraPieceAddonType;
  }

  function dcpCartLinePriceCents(line) {
    const value = Number(line && (
      line.final_line_price !== undefined ? line.final_line_price : line.line_price
    ));
    return Number.isFinite(value) ? value : NaN;
  }

  function dcpPricingSnapshotFromCartLine(line) {
    const props = dcpCartLineProperties(line);
    const group = String(props._dcp_pricing_group || '');
    if (String(props['_Blank Canvas Subfamily Key'] || '') === 'die_cutting') {
      const integerProperty = (name) => {
        const raw = String(props[name] === undefined || props[name] === null ? '' : props[name]);
        return /^\d+$/.test(raw) ? Number(raw) : NaN;
      };
      const quantity = integerProperty('_DCP Finished Quantity');
      const unitCents = integerProperty('_DCP Unit Price Cents');
      const finishedCents = integerProperty('_DCP Finished Price Cents');
      const textObjectCount = integerProperty('_DCP Text Object Count');
      const additionalTextObjectCount = integerProperty('_DCP Additional Text Objects');
      const additionalTextUnitCents = integerProperty('_DCP Additional Text Unit Cents');
      const additionalTextSurchargeCents = integerProperty('_DCP Additional Text Surcharge Cents');
      const variantId = String(props['_DCP Price Variant ID'] || '');
      const dcArtworkLine = Boolean(String(props._dcp_dc_art_production || ''));
      let canvas = null;
      let objects = null;
      try {
        canvas = normalizeDcpPhysicalCanvas(JSON.parse(String(props._dcp_physical_canvas || '')));
        objects = normalizeDcpCanvasObjects(JSON.parse(String(props._dcp_canvas_objects || '')), 'die_cutting');
      } catch (error) {
        return { error: 'The Custom Die cart design has unreadable physical or object state.' };
      }
      if (!group || !Number.isInteger(quantity) || quantity < 1 || !Number.isInteger(unitCents)
          || finishedCents !== unitCents * quantity || !variantId || objects.shape || objects.header
          || objects.symbolObjects.length || textObjectCount !== objects.textObjects.length
          || additionalTextObjectCount !== (dcArtworkLine ? textObjectCount : Math.max(0, textObjectCount - 1))
          || !Number.isInteger(additionalTextUnitCents) || !Number.isInteger(additionalTextSurchargeCents)) {
        return { error: 'The Custom Die cart design has unresolved pricing integrity data.' };
      }
      let calculated = null;
      if (dcArtworkLine) {
        try {
          const contract = JSON.parse(String(props._dcp_dc_art_production || ''));
          const record = trustedDcArtRecordForRestore(contract.designId);
          const artSize = Number(contract.artSizeInches);
          const complexity = String(record.complexityTier || '');
          const baseCents = dcpDcArtBasePriceCents[complexity]
            ? Number(dcpDcArtBasePriceCents[complexity][artSize] || 0)
            : 0;
          const finishedHeight = Number(contract.finishedEnvelopeInches && contract.finishedEnvelopeInches.height);
          const contractPricing = contract.pricing && typeof contract.pricing === 'object'
            ? contract.pricing
            : null;
          // New cart lines preserve the exact pricing snapshot that was certified
          // before Add. Older Draft lines fall back to their private integrity
          // properties. The minimum check prevents a rounded envelope from ever
          // lowering a six-inch-or-taller composition into the cheaper labor tier.
          const laborUnitCents = contractPricing
            ? Number(contractPricing.additionalTextUnitCents)
            : additionalTextUnitCents;
          const minimumLaborUnitCents = finishedHeight >= 6 ? 600 : 400;
          const totalCents = baseCents + textObjectCount * laborUnitCents;
          const variant = dcpDieVariantForCents(totalCents);
          const contractTextCount = Array.isArray(contract.textObjects) ? contract.textObjects.length : -1;
          const contractPricingValid = !contractPricing || (
            Number(contractPricing.textObjectCount) === textObjectCount
            && Number(contractPricing.additionalTextObjectCount) === textObjectCount
            && Number(contractPricing.additionalTextUnitCents) === laborUnitCents
            && Number(contractPricing.additionalTextSurchargeCents) === textObjectCount * laborUnitCents
            && Number(contractPricing.unitPriceCents) === totalCents
            && Number(contractPricing.finishedQuantity) === quantity
            && Number(contractPricing.finishedPriceCents) === totalCents * quantity
          );
          if (contract.contractVersion !== dcpDcArtProductionContractVersion
            || contract.catalogVersion !== dcpDcArtCatalogVersion
            || !dcpDcArtSupportedSizes.includes(artSize)
            || Number(contract.priceTierInches) !== artSize
            || contractTextCount !== textObjectCount
            || complexity !== String(props['DC Art Complexity'] || '')
            || !Number.isFinite(finishedHeight) || !Number.isInteger(baseCents) || baseCents <= 0
            || ![400, 600].includes(laborUnitCents) || laborUnitCents < minimumLaborUnitCents
            || !contractPricingValid || !variant) {
            return { error: 'The Custom Die cart design does not match its trusted DC artwork pricing contract.' };
          }
          calculated = {
            enforcement_ready: true,
            total_cents: totalCents,
            finished_price_cents: totalCents * quantity,
            variant_id: variant.id,
            additional_text_object_count: textObjectCount,
            additional_text_unit_cents: laborUnitCents,
            additional_text_surcharge_cents: textObjectCount * laborUnitCents
          };
        } catch (error) {
          return { error: 'The Custom Die cart design does not match its trusted DC artwork pricing contract.' };
        }
      } else {
        calculated = dieCuttingDevelopmentPricing();
      }
      if (!calculated.enforcement_ready || calculated.total_cents !== unitCents
          || calculated.finished_price_cents !== finishedCents || String(calculated.variant_id) !== variantId) {
        return { error: 'The Custom Die cart price does not reconcile with the certified pricing contract.' };
      }
      if (calculated.additional_text_object_count !== additionalTextObjectCount
          || calculated.additional_text_unit_cents !== additionalTextUnitCents
          || calculated.additional_text_surcharge_cents !== additionalTextSurchargeCents) {
        return { error: 'The Custom Die additional-text charge does not reconcile with the certified pricing contract.' };
      }
      return {
        error: '',
        group: group,
        pricing: {
          dieCutting: true,
          quantity: quantity,
          unit_price_cents: unitCents,
          finished_price_cents: finishedCents,
          text_object_count: textObjectCount,
          additional_text_object_count: additionalTextObjectCount,
          additional_text_unit_cents: additionalTextUnitCents,
          additional_text_surcharge_cents: additionalTextSurchargeCents,
          variant_id: variantId,
          subtotal: finishedCents / 100
        }
      };
    }
    const surchargeKey = String(props['_DCP Surcharge Key'] || '');
    const integerProperty = (name) => {
      const raw = String(props[name] === undefined || props[name] === null ? '' : props[name]);
      return /^\d+$/.test(raw) ? Number(raw) : NaN;
    };
    const extraCount = integerProperty('_DCP Additional Pieces');
    const minimumQuantity = integerProperty('_DCP Minimum Package Quantity');
    const selectedQuantityRaw = String(props.Quantity === undefined || props.Quantity === null ? '' : props.Quantity);
    const selectedQuantity = /^\d+$/.test(selectedQuantityRaw) ? Number(selectedQuantityRaw) : NaN;
    const unitCents = integerProperty('_DCP Additional Piece Price Cents');
    const baseCents = integerProperty('_DCP Base Package Price Cents');
    const finishedCents = integerProperty('_DCP Finished Price Cents');
    const surchargeVariantId = String(props['_DCP Surcharge Variant ID'] || '');
    const lineSize = String(props.Size || '');
    const lineMaterial = String(props.Material || '');
    const applicableMinimum = Number(quantityDefaultForSize(lineSize) || 0);
    const expectedSurchargeKey = dcpExtraPieceMapKey(lineSize, lineMaterial);
    const expectedSurchargeVariantId = extraCount > 0 ? String(dcpExtraPieceVariantId(lineSize, lineMaterial) || '') : '';
    if (!group || !surchargeKey || !Number.isFinite(extraCount) || !Number.isFinite(minimumQuantity) ||
        !Number.isFinite(selectedQuantity) || selectedQuantity !== minimumQuantity + extraCount ||
        !Number.isFinite(unitCents) ||
        !Number.isFinite(baseCents) || !Number.isFinite(finishedCents) ||
        (extraCount > 0 && !surchargeVariantId)) {
      return { error: 'The cart design has unresolved DCP pricing integrity data.' };
    }
    if (!applicableMinimum || minimumQuantity !== applicableMinimum || selectedQuantity < applicableMinimum) {
      return { error: 'The cart Quantity does not meet the applicable DCP minimum package quantity.' };
    }
    if (!lineMaterial || surchargeKey !== expectedSurchargeKey ||
        (extraCount > 0 && (!expectedSurchargeVariantId || surchargeVariantId !== expectedSurchargeVariantId))) {
      return { error: 'The cart Quantity does not reconcile with the certified DCP surcharge mapping.' };
    }
    return {
      error: '',
      group: group,
      pricing: {
        base_package_price: baseCents / 100,
        minimum_package_qty: minimumQuantity,
        quantity: selectedQuantity,
        extra_piece_count: extraCount,
        extra_piece_price: unitCents / 100,
        extra_piece_variant_id: surchargeVariantId,
        surcharge_key: surchargeKey,
        additional_charge: (unitCents * extraCount) / 100,
        subtotal: finishedCents / 100
      }
    };
  }

  function validateDcpPricingGroup(cart, pricingGroup, expectedVariantId, pricing) {
    const lines = dcpPricingGroupLines(cart, pricingGroup);
    if (pricing && pricing.dieCutting) {
      if (lines.length !== 1) return 'Shopify did not preserve exactly one Custom Die design line.';
      const line = lines[0];
      if (isDcpExtraPieceLine(line)) return 'A Print surcharge line cannot belong to a Custom Die design.';
      if (String(line.product_id || '') !== dcpDieVariantLookup.productId
          || String(line.variant_id || line.id || '') !== String(expectedVariantId || pricing.variant_id || '')) {
        return 'The price-bearing Custom Die line does not match the selected exact-price variant.';
      }
      if (Number(line.quantity || 0) !== Number(pricing.quantity || 0)) {
        return 'The Shopify Custom Die quantity does not match the finished decal quantity.';
      }
      if (dcpCartLinePriceCents(line) !== Number(pricing.finished_price_cents || 0)) {
        return 'The Shopify Custom Die line total does not match the certified price.';
      }
      const props = dcpCartLineProperties(line);
      if (Number(props['_DCP Unit Price Cents']) !== Number(pricing.unit_price_cents)
          || Number(props['_DCP Finished Price Cents']) !== Number(pricing.finished_price_cents)
          || Number(props['_DCP Finished Quantity']) !== Number(pricing.quantity)
          || Number(props['_DCP Text Object Count']) !== Number(pricing.text_object_count)
          || Number(props['_DCP Additional Text Objects']) !== Number(pricing.additional_text_object_count)
          || Number(props['_DCP Additional Text Unit Cents']) !== Number(pricing.additional_text_unit_cents)
          || Number(props['_DCP Additional Text Surcharge Cents']) !== Number(pricing.additional_text_surcharge_cents)) {
        return 'The Custom Die pricing integrity properties do not match Shopify merchandise.';
      }
      return '';
    }
    const baseLines = lines.filter((line) => !isDcpExtraPieceLine(line));
    const addOnLines = lines.filter(isDcpExtraPieceLine);
    if (baseLines.length !== 1) return 'Shopify did not preserve exactly one DCP package line.';
    const baseLine = baseLines[0];
    if (String(baseLine.product_id || '') !== dcpProductId ||
        String(baseLine.variant_id || baseLine.id || '') !== String(expectedVariantId || '')) {
      return 'The price-bearing DCP package line does not match the selected variant.';
    }
    if (Number(baseLine.quantity || 0) !== 1) {
      return 'The price-bearing DCP package line quantity must remain locked at one.';
    }
    if (dcpCartLinePriceCents(baseLine) !== Math.round(Number(pricing && pricing.base_package_price) * 100)) {
      return 'The Shopify DCP package price does not match the authoritative package price.';
    }
    const baseProperties = dcpCartLineProperties(baseLine);
    const expectedSurchargeKey = String(pricing && pricing.surcharge_key || '');
    if (String(baseProperties['_DCP Surcharge Key'] || '') !== expectedSurchargeKey) {
      return 'The DCP package line is missing its authoritative surcharge key.';
    }

    const expectedExtraCount = Number(pricing && pricing.extra_piece_count || 0);
    if (Number(baseProperties.Quantity || 0) !== Number(pricing && pricing.quantity || 0) ||
        Number(pricing && pricing.quantity || 0) !== Number(pricing && pricing.minimum_package_qty || 0) + expectedExtraCount) {
      return 'The readable DCP Quantity does not match its minimum package and Additional Pieces.';
    }
    if (!expectedExtraCount) {
      if (addOnLines.length) return 'An unexpected DCP additional-piece charge remained in the cart.';
    } else {
      if (addOnLines.length !== 1) return 'Shopify did not preserve exactly one DCP additional-piece charge line.';
      const addOnLine = addOnLines[0];
      if (String(addOnLine.variant_id || addOnLine.id || '') !== String(pricing.extra_piece_variant_id || '')) {
        return 'The DCP additional-piece charge used the wrong Shopify variant.';
      }
      if (String(dcpCartLineProperties(addOnLine)['_DCP Surcharge Key'] || '') !== expectedSurchargeKey) {
        return 'The DCP additional-piece charge used the wrong private surcharge key.';
      }
      if (Number(addOnLine.quantity || 0) !== expectedExtraCount) {
        return 'The DCP additional-piece charge quantity does not match the selected quantity.';
      }
      const expectedUnitCents = Math.round(Number(pricing.extra_piece_price) * 100);
      if (Number(addOnLine.final_price) !== expectedUnitCents) {
        return 'The Shopify additional-piece unit price does not match the authoritative DCP rate.';
      }
      const expectedAddOnCents = Math.round(Number(pricing.additional_charge) * 100);
      if (dcpCartLinePriceCents(addOnLine) !== expectedAddOnCents) {
        return 'The Shopify additional-piece charge does not match the Designer pricing calculation.';
      }
    }

    const actualTotalCents = lines.reduce((sum, line) => sum + dcpCartLinePriceCents(line), 0);
    const expectedTotalCents = Math.round(Number(pricing && pricing.subtotal) * 100);
    if (!Number.isFinite(actualTotalCents) || actualTotalCents !== expectedTotalCents) {
      return 'The Shopify cart total does not match the Designer Finished Price.';
    }
    return '';
  }

  async function addDcpExtraPieceCharge(pricing, pricingGroup) {
    const extraPieceCount = Number(pricing && pricing.extra_piece_count || 0);
    if (!extraPieceCount) return null;
    if (!pricing.enforcement_ready || !pricing.extra_piece_variant_id) {
      throw new Error(pricing.enforcement_failure || 'DCP additional-piece pricing is not configured.');
    }
    return dcpCartJsonRequest('/cart/add.js', {
      items: [{
        id: Number(pricing.extra_piece_variant_id),
        quantity: extraPieceCount,
        properties: {
          '_SRD Designer Add-On': dcpExtraPieceAddonType,
          '_SRD Designer Parent': 'Custom DCP Order',
          _dcp_pricing_group: pricingGroup,
          '_DCP Surcharge Key': String(pricing.surcharge_key || '')
        }
      }]
    });
  }

  async function removeDcpPricingGroup(cart, pricingGroup) {
    const lines = dcpPricingGroupLines(cart, pricingGroup);
    if (!lines.length) return cart;
    const updates = {};
    lines.forEach((line) => {
      if (line && line.key) updates[line.key] = 0;
    });
    const updatedCart = await dcpCartJsonRequest('/cart/update.js', { updates: updates });
    if (dcpPricingGroupLines(updatedCart, pricingGroup).length) {
      throw new Error('Shopify did not remove the incomplete DCP pricing group.');
    }
    return updatedCart;
  }

  async function addAndVerifyDcpPricingGroup(pricingGroup, expectedVariantId, pricing) {
    await addDcpExtraPieceCharge(pricing, pricingGroup);
    const cart = await fetchCurrentDcpCart();
    const validationError = validateDcpPricingGroup(
      cart,
      pricingGroup,
      expectedVariantId,
      pricing
    );
    if (validationError) throw new Error(validationError);
    return cart;
  }

  async function removeDcpCartLine(lineKey) {
    const cart = await dcpCartJsonRequest('/cart/change.js', { id: lineKey, quantity: 0 });
    if (findDcpCartLine(cart, lineKey)) throw new Error('Shopify did not remove the original cart line.');
    return cart;
  }

  async function rollbackDcpReplacementLine(lineKey) {
    if (!lineKey) return false;
    try {
      await removeDcpCartLine(lineKey);
      return true;
    } catch (error) {
      debugLog('DCP replacement rollback failed', error);
      return false;
    }
  }

  function dcpPropertiesWithTransaction(properties, transactionToken) {
    const result = { ...(properties || {}) };
    result._dcp_cart_edit_token = transactionToken;
    result._dcp_pricing_group = transactionToken;
    if (!dcpProofHasArtwork()) {
      delete result['Artwork File'];
      delete result['_Blank Canvas Artwork Mode'];
      delete result['_Blank Canvas Artwork Mode Key'];
      delete result['_Blank Canvas Artwork Filename'];
      delete result['_Blank Canvas Artwork Type'];
      delete result['_Blank Canvas Artwork Dimensions'];
      delete result['_Blank Canvas Artwork Status'];
      delete result._dcp_original_filename;
      delete result._dcp_artwork_filename;
      delete result._dcp_uploaded_file_reference;
      delete result._dcp_artwork_type;
      delete result._dcp_artwork_transform;
      delete result[dcpNativeArtworkPropertyName];
      delete result['Artwork Status'];
      delete result._dcp_artwork_image_data;
    }
    return result;
  }

  async function buildDcpEditedJsonItem(transactionToken) {
    const payload = await buildCartPayloadWithProof();
    const item = payload && Array.isArray(payload.items) ? payload.items[0] : null;
    if (!item) throw new Error('The updated DCP cart payload could not be created.');
    return {
      ...item,
      properties: dcpPropertiesWithTransaction(item.properties, transactionToken)
    };
  }

  async function buildDcpEditedNativeFormData(transactionToken) {
    const input = controls.blankCanvasUpload;
    const requiresNewArtworkFile = dcpProductionArtworkSource.status === 'native_file';
    if (!targets.cartForm || (requiresNewArtworkFile &&
        (!input || !input.files || !input.files.length || !sameDcpArtworkFile(input.files[0], dcpArtworkFileRevisions.get(dcpArtworkAssetToken))))) {
      throw new Error('Select a valid production Artwork file before updating this cart design.');
    }
    const symbolSnapshot = dcpSymbolSubmissionSnapshot(latestDesignData);
    let proofProperties = null;
    try {
      proofProperties = await captureDcpProofImage(latestDesignData);
    } catch (error) {
      if (isDcpRequiredProofError(error)) throw error;
      proofProperties = dcpProofFallbackProperties();
    }
    assertDcpSymbolSubmissionSnapshotCurrent(latestDesignData, symbolSnapshot);
    setNativeUploadProofProperties({
      ...dcpTextCartProperties(latestDesignData.dcp_canvas_objects),
      ...proofProperties,
      ...dcpPricingIntegrityProperties(latestDesignData),
      ...(dcpProductionArtworkReferenceForCart()
        ? { [dcpNativeArtworkPropertyName]: dcpProductionArtworkReferenceForCart() }
        : {}),
      _dcp_cart_edit_token: transactionToken,
      _dcp_pricing_group: transactionToken
    });
    const disabledStates = Array.from(targets.cartForm.elements || []).map((element) => ({ element: element, disabled: element.disabled }));
    try {
      prepareFamilyNativeUploadSubmit();
      const formData = new FormData(targets.cartForm);
      const proofFile = proofProperties[dcpProofFilePropertyName];
      if (!(typeof File === 'function' && proofFile instanceof File)) {
        throw new Error('The durable final DCP proof file is unavailable.');
      }
      formData.set('properties[' + dcpProofFilePropertyName + ']', proofFile, proofFile.name);
      return formData;
    } finally {
      disabledStates.forEach((entry) => { entry.element.disabled = entry.disabled; });
    }
  }

  async function addAndVerifyDcpReplacement(itemOrFormData, transactionToken, expectedVariantId, expectedProductionReference, expectNativeFile) {
    const multipart = itemOrFormData instanceof FormData;
    const response = await dcpCartFetch('/cart/add.js', multipart
      ? {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: itemOrFormData
        }
      : {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [itemOrFormData] })
        });
    debugLog('DCP replacement add response', response);
    const cart = await fetchCurrentDcpCart();
    const line = dcpCartLineByTransaction(cart, transactionToken);
    const validationError = validateUpdatedDcpCartLine(
      line,
      expectedVariantId,
      transactionToken,
      expectedProductionReference,
      expectNativeFile
    );
    if (validationError) throw new Error(validationError);
    return line;
  }

  async function buildDcpDieMultipartFormData(transactionToken, activationRevision) {
    assertDieCuttingCommerceAllowed(activationRevision);
    if (!latestDesignData || !latestPricing || !latestPricing.enforcement_ready || !latestPricingVariants || !latestPricingVariants.ready) {
      throw new Error(latestPricing && latestPricing.enforcement_failure
        ? latestPricing.enforcement_failure
        : 'The exact Shopify Custom Die price is not ready.');
    }
    const proofProperties = await captureDcpProofImage(latestDesignData);
    assertDieCuttingCommerceAllowed(activationRevision);
    const proofFile = proofProperties[dcpProofFilePropertyName];
    if (!(typeof File === 'function' && proofFile instanceof File)) {
      throw new Error('The durable final Custom Die proof file is unavailable.');
    }
    const properties = dcpPropertiesWithTransaction({
      ...buildCartProperties(latestDesignData),
      ...proofProperties
    }, transactionToken);
    if (properties._dcp_dc_art_production) {
      const dcArtContract = JSON.parse(properties._dcp_dc_art_production);
      properties['_DCP Production Reference ID'] = dcpDcArtProductionReferenceId(dcArtContract, transactionToken);
    }
    const formData = new FormData();
    formData.set('id', String(latestPricingVariants.variant_id || ''));
    formData.set('quantity', String(latestPricing.quantity || ''));
    Object.keys(properties).forEach((key) => {
      if (key === dcpProofFilePropertyName || properties[key] === undefined || properties[key] === null) return;
      formData.set('properties[' + key + ']', String(properties[key]));
    });
    formData.set('properties[' + dcpProofFilePropertyName + ']', proofFile, proofFile.name);
    return {
      formData: formData,
      properties: properties,
      pricing: { ...latestPricing, dieCutting: true },
      variantId: String(latestPricingVariants.variant_id || '')
    };
  }

  function validateDcpDieSubmittedLine(line, transactionToken, expectedProperties, pricing, expectedVariantId) {
    if (!line) return 'Shopify did not return the Custom Die cart line.';
    const props = dcpCartLineProperties(line);
    if (String(props._dcp_cart_edit_token || '') !== transactionToken
      || String(props._dcp_pricing_group || '') !== transactionToken) {
      return 'Shopify did not preserve the Custom Die transaction identity.';
    }
    const pricingError = validateDcpPricingGroup(
      { items: [line] },
      transactionToken,
      expectedVariantId,
      pricing
    );
    if (pricingError) return pricingError;
    const protectedKeys = [
      'Product Family',
      '_Blank Canvas Subfamily Key',
      '_dcp_canvas_objects',
      '_dcp_physical_canvas',
      '_dcp_die_production',
      '_dcp_dc_art_production',
      '_DCP Production Reference ID',
      'DC Art Library Design',
      'DC Artwork Size',
      'DC Price Tier',
      'DC Finished Envelope',
      'DC Installation Space',
      'DC Vinyl Color',
      'DC Art Complexity',
      'DC Text Labor',
      '_DCP DC Art Catalog Version',
      '_DCP DC Art Pricing Formula',
      '_DCP Unit Price Cents',
      '_DCP Finished Price Cents',
      '_DCP Finished Quantity',
      '_DCP Price Variant ID',
      '_DCP Text Object Count',
      '_DCP Additional Text Objects',
      '_DCP Additional Text Unit Cents',
      '_DCP Additional Text Surcharge Cents'
    ];
    for (const key of protectedKeys) {
      if (String(props[key] || '') !== String(expectedProperties[key] || '')) {
        return 'Shopify did not preserve trusted Custom Die property: ' + key + '.';
      }
    }
    if (!isTrustedDcpUploadUrl(props[dcpProofFilePropertyName])) {
      return 'Shopify did not preserve the durable Custom Die proof file.';
    }
    return '';
  }

  async function addAndVerifyDcpDieLine(bundle, transactionToken) {
    await dcpCartFetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: bundle.formData
    });
    const cart = await fetchCurrentDcpCart();
    const line = dcpCartLineByTransaction(cart, transactionToken);
    const validationError = validateDcpDieSubmittedLine(
      line,
      transactionToken,
      bundle.properties,
      bundle.pricing,
      bundle.variantId
    );
    if (validationError) throw new Error(validationError);
    return line;
  }

  async function addNewDcpDieDesignToCart(activationRevision) {
    const transactionToken = dcpCartEditToken();
    let line = null;
    try {
      const bundle = await buildDcpDieMultipartFormData(transactionToken, activationRevision);
      line = await addAndVerifyDcpDieLine(bundle, transactionToken);
      return line;
    } catch (error) {
      try {
        const cart = await fetchCurrentDcpCart();
        if (dcpPricingGroupLines(cart, transactionToken).length) await removeDcpPricingGroup(cart, transactionToken);
      } catch (cleanupError) {
        debugLog('Custom Die add rollback failed', cleanupError);
      }
      throw error;
    }
  }

  async function updateExistingDcpDieCartDesign(activationRevision) {
    if (cartAddInProgress) return;
    assertDieCuttingCommerceAllowed(activationRevision);
    cartAddInProgress = true;
    if (targets.addButton) {
      targets.addButton.disabled = true;
      targets.addButton.setAttribute('aria-disabled', 'true');
    }
    setCartMessage('Updating your Custom Die design in cart...', 'neutral');
    const transactionToken = dcpCartEditToken();
    let replacementLine = null;
    try {
      const originalLine = await currentDcpEditLineForMutation();
      const originalGroup = String(dcpCartLineProperties(originalLine)._dcp_pricing_group || '');
      const bundle = await buildDcpDieMultipartFormData(transactionToken, activationRevision);
      replacementLine = await addAndVerifyDcpDieLine(bundle, transactionToken);
      try {
        if (originalGroup) await removeDcpPricingGroup(await fetchCurrentDcpCart(), originalGroup);
        else await removeDcpCartLine(originalLine.key);
      } catch (removeError) {
        await removeDcpPricingGroup(await fetchCurrentDcpCart(), transactionToken);
        replacementLine = null;
        throw new Error('The original Custom Die cart design was preserved because it could not be replaced safely.');
      }
      setCartMessage('Custom Die design updated in cart.', 'success');
      window.location.href = '/cart';
    } catch (error) {
      if (replacementLine) {
        try {
          await removeDcpPricingGroup(await fetchCurrentDcpCart(), transactionToken);
        } catch (cleanupError) {
          debugLog('Custom Die replacement rollback failed', cleanupError);
        }
      }
      const message = error && error.message ? error.message : 'The Custom Die cart design could not be updated.';
      setDebugStatus(false, message, 'Custom Die cart update failed');
      cartAddInProgress = false;
      update();
      setCartMessage(message, 'error');
    }
  }

  async function updateExistingDcpCartDesign(activationRevision) {
    if (isDieCuttingMode()) return updateExistingDcpDieCartDesign(activationRevision);
    if (cartAddInProgress) return;
    assertPrintDesignCommerceAllowed(activationRevision);
    cartAddInProgress = true;
    if (targets.addButton) {
      targets.addButton.disabled = true;
      targets.addButton.setAttribute('aria-disabled', 'true');
    }
    setCartMessage('Updating your design in cart...', 'neutral');
    let replacementLine = null;
    let transactionToken = '';
    try {
      const originalLine = await currentDcpEditLineForMutation();
      assertPrintDesignCommerceAllowed(activationRevision);
      const selectedVariantId = String(targets.variantId && targets.variantId.value || '');
      const pricingSnapshot = { ...(latestPricing || {}) };
      if (!pricingSnapshot.ready || !pricingSnapshot.enforcement_ready) {
        throw new Error(pricingSnapshot.enforcement_failure || 'DCP pricing could not be enforced.');
      }
      transactionToken = dcpCartEditToken();
      const retainedReference = dcpProductionArtworkReferenceForCart();
      const usesNewNativeFile = dcpProductionArtworkSource.status === 'native_file';
      const transactionKind = dcpCartEditTransactionKind(
        originalLine.variant_id || originalLine.id,
        selectedVariantId,
        dcpProductionArtworkSource.status
      );

      if (transactionKind === 'change') {
        const item = await buildDcpEditedJsonItem(transactionToken);
        assertPrintDesignCommerceAllowed(activationRevision);
        const cart = await dcpCartJsonRequest('/cart/change.js', {
          id: originalLine.key,
          quantity: Number(item.quantity || 1),
          properties: item.properties
        });
        const updatedLine = dcpCartLineByTransaction(cart, transactionToken);
        const validationError = validateUpdatedDcpCartLine(
          updatedLine,
          selectedVariantId,
          transactionToken,
          retainedReference,
          false
        );
        if (validationError) {
          let rolledBack = false;
          if (updatedLine) {
            try {
              await dcpCartJsonRequest('/cart/change.js', {
                id: updatedLine.key,
                quantity: Number(originalLine.quantity || 1),
                properties: dcpCartLineProperties(originalLine)
              });
              rolledBack = true;
            } catch (rollbackError) {
              debugLog('DCP in-place rollback failed', rollbackError);
            }
          }
          throw new Error(rolledBack
            ? 'The original cart line update failed verification. Its contents were restored; reopen Edit Design before trying again. ' + validationError
            : validationError + ' Review the cart before continuing.');
        }
      } else {
        const replacement = await buildDcpEditedNativeFormData(transactionToken);
        assertPrintDesignCommerceAllowed(activationRevision);
        replacementLine = await addAndVerifyDcpReplacement(
          replacement,
          transactionToken,
          selectedVariantId,
          retainedReference,
          usesNewNativeFile
        );
        await addAndVerifyDcpPricingGroup(
          transactionToken,
          selectedVariantId,
          pricingSnapshot
        );
        try {
          const originalPricingGroup = String(dcpCartLineProperties(originalLine)._dcp_pricing_group || '');
          if (originalPricingGroup) {
            await removeDcpPricingGroup(await fetchCurrentDcpCart(), originalPricingGroup);
          } else {
            await removeDcpCartLine(originalLine.key);
          }
        } catch (removeError) {
          let rolledBack = false;
          try {
            await removeDcpPricingGroup(await fetchCurrentDcpCart(), transactionToken);
            rolledBack = true;
          } catch (rollbackError) {
            debugLog('DCP replacement pricing-group rollback failed', rollbackError);
          }
          replacementLine = null;
          throw new Error(rolledBack
            ? 'The original cart line could not be replaced. Your original line was preserved; please try again.'
            : 'The original cart line could not be removed and the replacement could not be rolled back. Review the cart before continuing.');
        }
      }

      setCartMessage('Design updated in cart.', 'success');
      window.location.href = '/cart';
    } catch (error) {
      if (replacementLine && transactionToken) {
        try {
          await removeDcpPricingGroup(await fetchCurrentDcpCart(), transactionToken);
        } catch (rollbackError) {
          debugLog('DCP replacement pricing-group cleanup failed', rollbackError);
        }
      }
      if (!replacementLine && transactionToken) {
        try {
          const cart = await fetchCurrentDcpCart();
          if (dcpPricingGroupLines(cart, transactionToken).length) {
            await removeDcpPricingGroup(cart, transactionToken);
          } else {
            const unverifiedReplacement = dcpCartLineByTransaction(cart, transactionToken);
            if (unverifiedReplacement) await rollbackDcpReplacementLine(unverifiedReplacement.key);
          }
        } catch (cleanupError) {
          debugLog('DCP unverified replacement cleanup failed', cleanupError);
        }
      }
      const message = error && error.message ? error.message : 'The cart design could not be updated.';
      if (message.indexOf('original cart') !== -1 || message.indexOf('edit session') !== -1 || message.indexOf('production Artwork reference changed') !== -1) {
        setDcpCartEditFailure(message);
      } else {
        setCartMessage(message, 'error');
      }
      setDebugStatus(false, message, 'Cart update failed');
      debugLog('DCP cart update failed', error);
      cartAddInProgress = false;
      update();
    }
  }

  async function addNewDcpDesignToCart(activationRevision) {
    if (isDieCuttingMode()) return addNewDcpDieDesignToCart(activationRevision);
    assertPrintDesignCommerceAllowed(activationRevision);
    if (!targets.cartForm || !latestDesignData) throw new Error('The DCP upload form is unavailable.');
    if (!latestPricing || !latestPricing.ready || !latestPricing.enforcement_ready) {
      throw new Error(latestPricing && latestPricing.enforcement_failure
        ? latestPricing.enforcement_failure
        : 'DCP pricing could not be enforced.');
    }
    const pricingSnapshot = { ...latestPricing };
    const pricingGroup = dcpCartEditToken();
    const selectedVariantId = String(targets.variantId && targets.variantId.value || '');
    const symbolSnapshot = dcpSymbolSubmissionSnapshot(latestDesignData);
    const proofProperties = await captureDcpProofImage(latestDesignData);
    assertPrintDesignCommerceAllowed(activationRevision);
    assertDcpSymbolSubmissionSnapshotCurrent(latestDesignData, symbolSnapshot);
    setNativeUploadProofProperties({
      ...dcpTextCartProperties(latestDesignData.dcp_canvas_objects),
      ...proofProperties,
      ...dcpPricingIntegrityProperties(latestDesignData),
      _dcp_pricing_group: pricingGroup
    });
    const disabledStates = Array.from(targets.cartForm.elements || []).map((element) => ({ element: element, disabled: element.disabled }));
    let addedLine = null;
    try {
      prepareFamilyNativeUploadSubmit();
      const formData = new FormData(targets.cartForm);
      const proofFile = proofProperties[dcpProofFilePropertyName];
      if (!(typeof File === 'function' && proofFile instanceof File)) {
        throw new Error('The durable final DCP proof file is unavailable.');
      }
      formData.set('properties[' + dcpProofFilePropertyName + ']', proofFile, proofFile.name);
      assertPrintDesignCommerceAllowed(activationRevision);
      addedLine = await dcpCartFetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body: formData
      });
    } finally {
      disabledStates.forEach((entry) => { entry.element.disabled = entry.disabled; });
    }
    const properties = dcpCartLineProperties(addedLine);
    const proofReference = String(properties[dcpProofFilePropertyName] || '');
    const productionReference = String(properties[dcpNativeArtworkPropertyName] || '');
    if (!isTrustedDcpUploadUrl(proofReference) || (productionReference && productionReference === proofReference)) {
      if (addedLine && addedLine.key) await rollbackDcpReplacementLine(addedLine.key);
      throw new Error('Shopify did not preserve the durable DCP proof separately from production Artwork.');
    }
    try {
      await addAndVerifyDcpPricingGroup(
        pricingGroup,
        selectedVariantId,
        pricingSnapshot
      );
    } catch (error) {
      try {
        await removeDcpPricingGroup(await fetchCurrentDcpCart(), pricingGroup);
      } catch (cleanupError) {
        debugLog('DCP pricing-group rollback failed', cleanupError);
      }
      throw error;
    }
    return addedLine;
  }

  async function addDesignToCart() {
    if (cartAddInProgress) return;
    const quantity = normalizedQuantity();
    const message = sanitizeMessage(messageFromLineInputs());
    if (isDcpCartTestingLockout()) {
      const setupFailure = dcpDieVariantLookup.failure || 'Custom Die development product setup is required.';
      setCartMessage(setupFailure, 'error');
      setDebugStatus(false, setupFailure, 'Custom Die product setup missing');
      update();
      return;
    }
    const activeProofState = getDcpProofState();
    const trustedDcLibraryArtwork = Boolean(
      isBlankCanvasMode(controls.template.value)
      && isDieCuttingMode()
      && activeProofState.catalogArtwork
      && activeDcpCatalogArtwork
      && activeProofState.catalogArtwork.designId === activeDcpCatalogArtwork.record.designId
      && activeProofState.catalogArtwork.catalogVersion === dcpDcArtCatalogVersion
    );
    if (isBlankCanvasMode(controls.template.value) && !trustedDcLibraryArtwork
        && dcpProofHasArtwork(activeProofState) && !dcpProductionArtworkReady()) {
      setCartMessage(dcpArtworkReselectionGuidance, 'error');
      setDebugStatus(false, 'Production Artwork file re-selection required.', 'Artwork file required');
      update();
      return;
    }
    setDebugStatus(false, validationFailure(message, quantity, latestPricing, latestPricingVariants), 'Clicked');
    debugLog('add button clicked', {
      final_variant_id: hasConfiguredVariant() ? targets.variantId.value : '',
      required_fields_valid: requiredFieldsComplete(message, quantity),
      latest_cart_payload: latestCartPayload
    });

    if (!isNitrousMode(controls.template.value) && !isBlankCanvasMode(controls.template.value) && shopifyVariantLookup.failed && !hasFallbackVariant()) {
      setCartMessage('Theme setup needed: Shopify product lookup failed and the emergency Designer variant ID fallback is not configured.', 'error');
      setDebugStatus(false, 'Shopify product JSON failed to load and emergency fallback variant ID is not configured.', 'Variant setup missing');
      update();
      return;
    }
    if (!hasConfiguredVariant()) {
      setCartMessage('Theme setup needed: the selected Designer product does not have a resolved Shopify variant ID.', 'error');
      setDebugStatus(false, 'Selected Designer product has no resolved default variant ID.', 'Variant ID missing');
      update();
      return;
    }
    if (!hasAvailableVariant()) {
      setCartMessage('Theme setup needed: the selected Designer product variant is not available.', 'error');
      setDebugStatus(false, 'Resolved Designer variant is not available.', 'Variant unavailable');
      update();
      return;
    }
    if (!requiredFieldsComplete(message, quantity) || !latestCartPayload) {
      const failure = validationFailure(message, quantity, latestPricing, latestPricingVariants);
      setCartMessage(
        isBlankCanvasMode(controls.template.value)
          && (failure.indexOf('Shape could not be used') !== -1 || failure.indexOf('Symbol') !== -1)
          ? failure
          : 'Complete all required fields before adding your design proof to cart.',
        'error'
      );
      setDebugStatus(false, failure, 'Validation blocked');
      update();
      return;
    }

    if (isBlankCanvasMode(controls.template.value) && dcpCartEditSession.active) {
      await updateExistingDcpCartDesign(dcpModeActivationRevision);
      return;
    }

    if (isBlankCanvasMode(controls.template.value)) {
      const activationRevision = dcpModeActivationRevision;
      cartAddInProgress = true;
      if (targets.addButton) {
        targets.addButton.disabled = true;
        targets.addButton.setAttribute('aria-disabled', 'true');
      }
      setCartMessage('Adding your design proof to cart...', 'neutral');
      try {
        await addNewDcpDesignToCart(activationRevision);
        setDebugStatus(true, 'None', 'Added successfully');
        window.location.href = '/cart';
      } catch (error) {
        const detail = error && error.message ? error.message : 'Unable to add this DCP design to cart.';
        setCartMessage(detail, 'error');
        setDebugStatus(false, detail, 'DCP cart add failed');
        cartAddInProgress = false;
        update();
      }
      return;
    }

    if (shouldUseNativeUploadSubmit()) {
      if (!targets.cartForm) {
        setCartMessage('Unable to attach the uploaded artwork. Please try again.', 'error');
        setDebugStatus(false, 'Artwork upload form unavailable.', 'Upload form missing');
        return;
      }
      cartAddInProgress = true;
      setCartMessage('Adding your design proof and uploaded artwork to cart...', 'neutral');
      setDebugStatus(true, 'None', 'Submitting upload');
      const dcpProofState = getDcpProofState();
      debugLog('native upload form submit', {
        filename: isBlankCanvasMode(controls.template.value) ? dcpProofState.filename || dcpProofState.name : uploadedNitrousHeaderArtwork.name,
        type: isBlankCanvasMode(controls.template.value) ? dcpProofState.fileType || dcpProofState.type : uploadedNitrousHeaderArtwork.type,
        dimensions: isBlankCanvasMode(controls.template.value) ? dcpProofState.dimensions : uploadedNitrousHeaderArtwork.dimensions,
        status: isBlankCanvasMode(controls.template.value) ? dcpProofState.status : uploadedNitrousHeaderArtwork.status
      });
      if (isBlankCanvasMode(controls.template.value) && latestDesignData) {
        const symbolSnapshot = dcpSymbolSubmissionSnapshot(latestDesignData);
        let proofProperties = null;
        try {
          proofProperties = await captureDcpProofImage(latestDesignData);
        } catch (error) {
          if (!isDcpRequiredProofError(error)) throw error;
          cartAddInProgress = false;
          setCartMessage(error.message, 'error');
          setDebugStatus(false, error.message, isDcpSymbolProofError(error) ? 'Symbol proof failed' : (isDcpShapeProofError(error) ? 'Shape proof failed' : 'Header proof failed'));
          return;
        }
        assertDcpSymbolSubmissionSnapshotCurrent(latestDesignData, symbolSnapshot);
        setNativeUploadProofProperties({
          ...dcpTextCartProperties(latestDesignData.dcp_canvas_objects),
          ...proofProperties
        });
      } else if (latestDesignData && latestDesignData.selected_template_category === 'nitrous') {
        setNativeUploadProofProperties(await captureNitrousProofImage(latestDesignData));
      }
      prepareFamilyNativeUploadSubmit();
      HTMLFormElement.prototype.submit.call(targets.cartForm);
      return;
    }

    if (targets.addButton) {
      targets.addButton.disabled = true;
      targets.addButton.setAttribute('aria-disabled', 'true');
    }
    cartAddInProgress = true;
    setCartMessage('Adding your design proof to cart...', 'neutral');

    try {
      const payload = await buildCartPayloadWithProof();
      debugLog('cart payload', payload);
      if (!payload) throw new Error('Cart payload could not be created.');
      setDebugStatus(true, 'None', 'Payload built');
      setCartDebugDetails({
        payload: payload,
        httpStatus: 'Pending',
        shopifyMessage: 'Pending',
        responseJson: null,
        responseText: ''
      });
      setDebugStatus(true, 'None', 'Adding to cart');
      debugLog('fetch /cart/add.js start', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: payload
      });
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      debugLog('fetch /cart/add.js response status', response.status);
      if (!response.ok) {
        let detail = 'Unable to add this design proof to cart. Please try again.';
        let rawText = '';
        let errorData = null;
        try {
          rawText = await response.text();
          if (rawText) {
            try {
              errorData = JSON.parse(rawText);
            } catch (parseError) {
              errorData = null;
            }
          }
          debugLog('fetch /cart/add.js response body', errorData || rawText);
          if (errorData && errorData.description) detail = errorData.description;
          if (errorData && errorData.message) detail = errorData.message;
        } catch (error) {
          rawText = 'Unable to read Shopify response body: ' + (error.message || 'Unknown error');
        }
        setCartDebugDetails({
          httpStatus: response.status,
          shopifyMessage: detail,
          responseJson: errorData,
          responseText: rawText
        });
        setDebugStatus(false, validationFailure(message, quantity, latestPricing, latestPricingVariants), 'Failed: ' + detail);
        throw new Error(detail);
      }

      setCartDebugDetails({
        httpStatus: response.status,
        shopifyMessage: 'Added successfully',
        responseJson: null,
        responseText: ''
      });
      setDebugStatus(true, 'None', 'Added successfully');
      debugLog('cart add success', { redirect: '/cart' });
      window.location.href = '/cart';
    } catch (error) {
      const cartErrorMessage = error.message || 'Unable to add this design proof to cart. Please try again.';
      setCartMessage(cartErrorMessage, 'error');
      setDebugStatus(false, validationFailure(message, quantity, latestPricing, latestPricingVariants), 'Cart add failed: ' + (error.message || 'Unknown error'));
      debugLog('cart add failed', error);
      cartAddInProgress = false;
      update();
      if (isDcpRequiredProofError(error)) setCartMessage(cartErrorMessage, 'error');
    }
  }

  root.addEventListener('submit', (event) => {
    event.preventDefault();
    addDesignToCart();
  });

  if (targets.addButton) {
    targets.addButton.addEventListener('click', (event) => {
      event.preventDefault();
      addDesignToCart();
    });
  }

  if (controls.dcpTextInput) {
    controls.dcpTextInput.addEventListener('beforeinput', handleDieCuttingTextBeforeInput);
    controls.dcpTextInput.addEventListener('paste', handleDieCuttingTextPaste);
  }
  if (controls.dcpFont) {
    controls.dcpFont.addEventListener('focus', handleDcpFontSelection);
    controls.dcpFont.addEventListener('input', handleDcpFontSelection);
    controls.dcpFont.addEventListener('change', handleDcpFontSelection);
  }
  [controls.dcpWidth, controls.dcpHeight].filter(Boolean).forEach((control) => {
    control.addEventListener('focus', beginDcpDimensionEdit);
    control.addEventListener('input', applyDcpDimensionInputs);
    control.addEventListener('change', applyDcpDimensionInputs);
    control.addEventListener('blur', finishDcpDimensionEdit);
    control.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        cancelDcpDimensionEdit(event);
      } else if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        finishDcpDimensionEdit(event);
        control.blur();
      }
    });
  });
  if (targets.dcpSwapDimensions) targets.dcpSwapDimensions.addEventListener('click', swapDcpDimensions);
  root.addEventListener('input', handleDesignerRootMutation);
  root.addEventListener('change', handleDesignerRootMutation);
  if (controls.nitrousUpload) {
    controls.nitrousUpload.addEventListener('change', handleNitrousUploadChange);
  }
  if (controls.blankCanvasUpload) {
    controls.blankCanvasUpload.addEventListener('change', handleBlankCanvasUploadChange);
  }
  if (targets.blankCanvasPreview) {
    targets.blankCanvasPreview.addEventListener('pointerdown', (event) => {
      if (!isBlankCanvasMode(controls.template.value)) return;
      if (event.target !== targets.blankCanvasPreview
        && !event.target.classList.contains('srd-designer-proof__blank-canvas-guide')
        && !event.target.classList.contains('srd-designer-proof__precision-grid')) return;
      selectDcpObject(null);
      syncDcpTextEditorFromSelection(getDcpProofState().objects);
      applyDcpObjectSelectionState();
      update();
    });
  }
  if (targets.blankCanvasArtwork && targets.blankCanvasArtworkHit && targets.blankCanvasArtworkHit.dataset.srdDcpArtworkHitBound !== 'true') {
    targets.blankCanvasArtworkHit.dataset.srdDcpArtworkHitBound = 'true';
    targets.blankCanvasArtworkHit.addEventListener('pointerdown', (event) => startDcpObjectInteraction(event, 'artwork', 'move'));
    targets.blankCanvasArtwork.addEventListener('load', updateDcpArtworkHitTarget);
  }
  if (targets.dcpHeaderObject) {
    targets.dcpHeaderObject.addEventListener('pointerdown', (event) => startDcpObjectInteraction(event, 'header', 'move'));
  }
  if (targets.dcpShapeObject) {
    targets.dcpShapeObject.addEventListener('pointerdown', (event) => startDcpObjectInteraction(event, 'shape', 'move'));
  }
  if (targets.dcpDeleteHeader) {
    targets.dcpDeleteHeader.addEventListener('pointerdown', (event) => event.stopPropagation());
    targets.dcpDeleteHeader.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      clearDcpHeader();
    });
  }
  if (targets.dcpDeleteShape) {
    targets.dcpDeleteShape.addEventListener('pointerdown', (event) => event.stopPropagation());
    targets.dcpDeleteShape.addEventListener('click', (event) => {
      event.preventDefault(); event.stopPropagation(); clearDcpShape();
    });
  }
  (targets.dcpResizeHandles || []).forEach((handle) => {
    handle.addEventListener('pointerdown', (event) => {
      const resizeHandle = event.currentTarget.dataset.srdDcpResizeHandle || 'corner';
      startDcpObjectInteraction(event, selectedDcpObject, 'resize-' + resizeHandle);
    });
  });
  if (targets.blankCanvasRemoveArtwork) {
    targets.blankCanvasRemoveArtwork.addEventListener('click', (event) => {
      event.preventDefault();
      clearDcpUploadedArtwork();
    });
  }
  if (targets.dcpRemoveArtwork) {
    targets.dcpRemoveArtwork.addEventListener('click', (event) => {
      event.preventDefault();
      clearDcpUploadedArtwork();
    });
  }
  if (targets.dcpReplaceArtwork) {
    targets.dcpReplaceArtwork.addEventListener('click', (event) => {
      event.preventDefault();
      openDcpArtworkPicker();
    });
  }
  if (targets.dcpCatalogArtworkChange) {
    targets.dcpCatalogArtworkChange.addEventListener('click', (event) => {
      event.preventDefault();
      const opener = root.querySelector('[data-srd-dc-art-open]');
      if (opener) opener.click();
    });
  }
  if (targets.dcpCatalogArtworkReset) {
    targets.dcpCatalogArtworkReset.addEventListener('click', (event) => {
      event.preventDefault();
      resetDcArtPosition();
    });
  }
  if (targets.dcpAddText) {
    targets.dcpAddText.addEventListener('click', (event) => {
      event.preventDefault();
      openDcpTextTool();
    });
  }
  if (targets.dcpPlacement) {
    targets.dcpPlacement.addEventListener('input', (event) => {
      event.stopPropagation();
      placeSelectedDcArtText(targets.dcpPlacement.value);
    });
  }
  if (targets.dcpToolbarArtwork && controls.blankCanvasUpload) {
    targets.dcpToolbarArtwork.addEventListener('click', (event) => {
      event.preventDefault();
      openDcpArtworkPicker();
    });
  }
  [targets.dcpToolbarQr, targets.dcpToolbarBarcode].filter(Boolean).forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      requireDcpObjectToolbarCanvas();
    });
  });
  if (targets.dcpZoomOut) targets.dcpZoomOut.addEventListener('click', (event) => { event.preventDefault(); stepDcpEditingZoom(-1); });
  if (targets.dcpZoomRelative) targets.dcpZoomRelative.addEventListener('click', (event) => { event.preventDefault(); resetDcpEditingZoom(); });
  if (targets.dcpZoomIn) targets.dcpZoomIn.addEventListener('click', (event) => { event.preventDefault(); stepDcpEditingZoom(1); });
  if (targets.dcpZoomFit) targets.dcpZoomFit.addEventListener('click', (event) => { event.preventDefault(); setDcpEditingZoom('fit'); });
  targets.dcpPrecisionToggles.forEach((control) => {
    const applyPrecisionSetting = (event) => {
      event.stopPropagation();
      updateDcpPrecisionSetting(event.currentTarget);
    };
    control.addEventListener('input', applyPrecisionSetting);
    control.addEventListener('change', applyPrecisionSetting);
  });
  if (targets.dcpHorizontalRuler) {
    targets.dcpHorizontalRuler.addEventListener('pointerdown', (event) => {
      beginDcpGuideInteraction(event, 'horizontal', -1, true);
    });
  }
  if (targets.dcpVerticalRuler) {
    targets.dcpVerticalRuler.addEventListener('pointerdown', (event) => {
      beginDcpGuideInteraction(event, 'vertical', -1, true);
    });
  }
  if (targets.dcpUndo) targets.dcpUndo.addEventListener('click', (event) => { event.preventDefault(); undoDcpHistory(); });
  if (targets.dcpRedo) targets.dcpRedo.addEventListener('click', (event) => { event.preventDefault(); redoDcpHistory(); });
  if (targets.dcpBringForward) targets.dcpBringForward.addEventListener('click', (event) => {
    event.preventDefault();
    if (!targets.dcpBringForward.disabled) moveSelectedDcpLayer(1);
  });
  if (targets.dcpSendBackward) targets.dcpSendBackward.addEventListener('click', (event) => {
    event.preventDefault();
    if (!targets.dcpSendBackward.disabled) moveSelectedDcpLayer(-1);
  });
  if (targets.dcpAlignControls) {
    targets.dcpAlignControls.addEventListener('pointerdown', (event) => event.stopPropagation());
  }
  if (targets.dcpAlignToggle) {
    targets.dcpAlignToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (targets.dcpAlignFlyout && !targets.dcpAlignFlyout.hidden) closeDcpAlignmentFlyout();
      else openDcpAlignmentFlyout();
    });
  }
  targets.dcpAlignActions.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      alignSelectedDcpObjects(button.dataset.srdDcpAlignAction || '');
      closeDcpAlignmentFlyout(true);
    });
  });
  if (targets.dcpRotateControls) targets.dcpRotateControls.addEventListener('pointerdown', (event) => event.stopPropagation());
  if (targets.dcpRotateToggle) {
    targets.dcpRotateToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (targets.dcpRotateToggle.disabled) return;
      const opening = targets.dcpRotateFlyout && targets.dcpRotateFlyout.hidden;
      if (targets.dcpRotateFlyout) targets.dcpRotateFlyout.hidden = !opening;
      targets.dcpRotateToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening && targets.dcpRotateActions[0]) targets.dcpRotateActions[0].focus();
    });
  }
  targets.dcpRotateActions.forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    rotateSelectedDcpObject(button.dataset.srdDcpRotateAction || 'reset');
    closeDcpRotateFlyout(true);
  }));
  if (targets.dcpAlignFlyout) {
    targets.dcpAlignFlyout.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeDcpAlignmentFlyout(true);
        return;
      }
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      const actions = targets.dcpAlignActions.filter((button) => !button.disabled);
      const index = actions.indexOf(document.activeElement);
      if (index < 0 || !actions.length) return;
      const columns = 3;
      let nextIndex = index;
      if (event.key === 'ArrowLeft') nextIndex = Math.max(0, index - 1);
      else if (event.key === 'ArrowRight') nextIndex = Math.min(actions.length - 1, index + 1);
      else if (event.key === 'ArrowUp') nextIndex = Math.max(0, index - columns);
      else if (event.key === 'ArrowDown') nextIndex = Math.min(actions.length - 1, index + columns);
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = actions.length - 1;
      event.preventDefault();
      actions[nextIndex].focus();
    });
  }
  if (targets.dcpMultiSelectToggle) {
    targets.dcpMultiSelectToggle.addEventListener('click', (event) => {
      event.preventDefault();
      dcpMultiSelectMode = !dcpMultiSelectMode;
      dcpObjectInteraction = null;
      updateDcpMultiSelectControls();
      applyDcpObjectSelectionState();
    });
  }
  if (targets.dcpToolbarHeader) {
    targets.dcpToolbarHeader.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (targets.dcpHeaderFlyout && !targets.dcpHeaderFlyout.hidden) closeDcpHeaderLibrary();
      else openDcpHeaderLibrary();
    });
  }
  if (targets.dcpToolbarShape) {
    targets.dcpToolbarShape.addEventListener('click', (event) => {
      event.preventDefault(); event.stopPropagation();
      if (targets.dcpShapeFlyout && !targets.dcpShapeFlyout.hidden) closeDcpShapeLibrary();
      else openDcpShapeLibrary();
    });
  }
  if (targets.dcpToolbarSymbol) {
    targets.dcpToolbarSymbol.addEventListener('click', (event) => {
      event.preventDefault(); event.stopPropagation();
      if (targets.dcpSymbolFlyout && !targets.dcpSymbolFlyout.hidden) closeDcpSymbolLibrary();
      else openDcpSymbolLibrary();
    });
  }
  if (targets.dcpSymbolFlyoutClose) targets.dcpSymbolFlyoutClose.addEventListener('click', (event) => {
    event.preventDefault(); closeDcpSymbolLibrary();
  });
  if (targets.dcpSymbolSearch) targets.dcpSymbolSearch.addEventListener('input', () => {
    dcpSymbolQuery = String(targets.dcpSymbolSearch.value || '').trim().replace(/\s+/g, ' ');
    if (targets.dcpSymbolActivationStatus) targets.dcpSymbolActivationStatus.textContent = '';
    renderDcpSymbolLibrary();
  });
  if (targets.dcpSymbolSearchClear) targets.dcpSymbolSearchClear.addEventListener('click', (event) => {
    event.preventDefault();
    targets.dcpSymbolSearch.value = '';
    dcpSymbolQuery = '';
    renderDcpSymbolLibrary();
    targets.dcpSymbolSearch.focus();
  });
  if (targets.dcpSymbolResults) targets.dcpSymbolResults.addEventListener('scroll', () => {
    if (typeof IntersectionObserver !== 'function') loadVisibleDcpSymbolThumbnails();
  }, { passive: true });
  if (targets.dcpSymbolGrid) targets.dcpSymbolGrid.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-srd-dcp-symbol-choice]');
    if (!choice) return;
    event.preventDefault();
    activateDcpSymbolLibraryCard(choice.dataset.srdDcpSymbolChoice);
  });
  if (targets.dcpSymbolRotation) {
    targets.dcpSymbolRotation.addEventListener('input', () => updateSelectedDcpSymbolRotation(targets.dcpSymbolRotation.value));
    targets.dcpSymbolRotation.addEventListener('change', () => updateSelectedDcpSymbolRotation(targets.dcpSymbolRotation.value));
  }
  if (targets.dcpReplaceSymbol) targets.dcpReplaceSymbol.addEventListener('click', (event) => {
    event.preventDefault();
    openDcpSymbolLibrary('replace');
  });
  if (targets.dcpRemoveSymbol) targets.dcpRemoveSymbol.addEventListener('click', (event) => {
    event.preventDefault();
    removeDcpSymbolObject();
  });
  if (targets.dcpSymbolFlyout) targets.dcpSymbolFlyout.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    event.preventDefault(); event.stopPropagation();
    closeDcpSymbolLibrary();
    if (targets.dcpToolbarSymbol) targets.dcpToolbarSymbol.focus();
  });
  if (targets.dcpHeaderFlyoutClose) {
    targets.dcpHeaderFlyoutClose.addEventListener('click', (event) => {
      event.preventDefault();
      closeDcpHeaderLibrary();
    });
  }
  if (targets.dcpHeaderFlyoutGrid) {
    targets.dcpHeaderFlyoutGrid.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-srd-dcp-header-choice]');
      if (!choice) return;
      event.preventDefault();
      setDcpHeader(choice.dataset.srdDcpHeaderChoice);
    });
  }
  if (targets.dcpShapeFlyoutClose) targets.dcpShapeFlyoutClose.addEventListener('click', (event) => { event.preventDefault(); closeDcpShapeLibrary(); });
  if (targets.dcpShapeFlyoutGrid) targets.dcpShapeFlyoutGrid.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-srd-dcp-shape-choice]');
    if (!choice) return; event.preventDefault(); setDcpShape(choice.dataset.srdDcpShapeChoice);
  });
  targets.dcpShapeLibraryAppearance.forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault(); dcpShapeLibraryAppearance = button.dataset.srdDcpShapeLibraryAppearance === 'outline' ? 'outline' : 'solid'; renderDcpShapeLibrary();
  }));
  targets.dcpShapeAppearance.forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault(); updateSelectedDcpShape({ appearanceMode: button.dataset.srdDcpShapeAppearance === 'outline' ? 'outline' : 'solid' });
  }));
  targets.dcpTextOutlineToggles.forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault();
    setSelectedDcpTextOutlineEnabled(button.dataset.srdDcpTextOutline === 'on');
  }));
  bindDcpShapeStyleControl(targets.dcpShapeFill, 'fillColorKey');
  bindDcpShapeStyleControl(targets.dcpShapeBorder, 'borderColorKey');
  bindDcpShapeStyleControl(targets.dcpShapeThickness, 'borderThicknessKey');
  if (targets.dcpShapeRotation) {
    const updateShapeRotation = (event) => {
      event.stopPropagation();
      const value = clampDcpNumber(targets.dcpShapeRotation.value, -180, 180, 0);
      if (targets.dcpShapeRotationValue) targets.dcpShapeRotationValue.textContent = Math.round(value) + '\u00b0';
      const shape = normalizeDcpCanvasObjects(getDcpProofState().objects).shape;
      if (shape && Math.abs(shape.rotation - value) > 0.0001) updateSelectedDcpShape({ rotation: value });
    };
    targets.dcpShapeRotation.addEventListener('input', updateShapeRotation);
    targets.dcpShapeRotation.addEventListener('change', updateShapeRotation);
  }
  if (targets.dcpReplaceShape) targets.dcpReplaceShape.addEventListener('click', (event) => { event.preventDefault(); openDcpShapeLibrary(); });
  if (targets.dcpRemoveShape) targets.dcpRemoveShape.addEventListener('click', (event) => { event.preventDefault(); clearDcpShape(); });
  if (targets.dcpReplaceHeader) {
    targets.dcpReplaceHeader.addEventListener('click', (event) => {
      event.preventDefault();
      openDcpHeaderLibrary();
    });
  }
  if (targets.dcpRemoveHeader) {
    targets.dcpRemoveHeader.addEventListener('click', (event) => {
      event.preventDefault();
      clearDcpHeader();
    });
  }
  window.addEventListener('pointermove', moveDcpGuideInteraction);
  window.addEventListener('pointerup', endDcpGuideInteraction);
  window.addEventListener('pointercancel', endDcpGuideInteraction);
  window.addEventListener('pointermove', moveDcpObjectInteraction);
  window.addEventListener('pointerup', endDcpObjectInteraction);
  window.addEventListener('pointercancel', endDcpObjectInteraction);
  document.addEventListener('pointermove', moveDcpObjectInteraction);
  document.addEventListener('pointerup', endDcpObjectInteraction);
  document.addEventListener('pointercancel', endDcpObjectInteraction);
  selectionTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const type = trigger.dataset.srdFlyoutTrigger;
      if (selectorState.openType === type && !flyout.hidden) {
        closeFlyout();
        return;
      }
      openFlyout(type, trigger);
    });
  });
  if (controls.colorButton) {
    controls.colorButton.addEventListener('click', toggleColorMenu);
  }
  controls.colorOptions.forEach((option) => {
    option.addEventListener('click', () => {
      if (controls.color) {
        controls.color.value = option.dataset.srdColorOption || '';
      }
      closeColorMenu();
      update();
    });
  });
  document.addEventListener('click', (event) => {
    if (!flyout.hidden && !flyout.contains(event.target) && !event.target.closest('[data-srd-flyout-trigger]')) {
      closeFlyout();
    }
    if (targets.dcpHeaderFlyout && !targets.dcpHeaderFlyout.hidden && !targets.dcpHeaderFlyout.contains(event.target) && !event.target.closest('[data-srd-dcp-toolbar-header]') && !event.target.closest('[data-srd-dcp-replace-header]')) {
      closeDcpHeaderLibrary();
    }
    if (targets.dcpShapeFlyout && !targets.dcpShapeFlyout.hidden && !targets.dcpShapeFlyout.contains(event.target) && !event.target.closest('[data-srd-dcp-toolbar-shape]') && !event.target.closest('[data-srd-dcp-replace-shape]')) closeDcpShapeLibrary();
    if (targets.dcpSymbolFlyout && !targets.dcpSymbolFlyout.hidden && !targets.dcpSymbolFlyout.contains(event.target) && !event.target.closest('[data-srd-dcp-toolbar-symbol]') && !event.target.closest('[data-srd-dcp-replace-symbol]')) closeDcpSymbolLibrary();
    if (targets.dcpAlignFlyout && !targets.dcpAlignFlyout.hidden && !targets.dcpAlignControls.contains(event.target)) closeDcpAlignmentFlyout();
    if (targets.dcpRotateFlyout && !targets.dcpRotateFlyout.hidden && !targets.dcpRotateControls.contains(event.target)) closeDcpRotateFlyout();
    if (controls.colorSelect && !controls.colorSelect.contains(event.target)) {
      closeColorMenu();
    }
  });
  document.addEventListener('keydown', handleDcpKeyboardShortcut);
  window.addEventListener('scroll', closeFlyout, { passive: true });
  window.addEventListener('resize', () => {
    fitMessage();
    update();
  });
  if (targets.proofCanvas && typeof ResizeObserver === 'function') {
    dcpWorkspaceObserver = new ResizeObserver(() => scheduleDcpWorkspaceSync());
    dcpWorkspaceObserver.observe(targets.proofCanvas);
    window.addEventListener('pagehide', () => {
      if (dcpWorkspaceObserver) dcpWorkspaceObserver.disconnect();
      if (dcpWorkspaceFrame) window.cancelAnimationFrame(dcpWorkspaceFrame);
      dcpWorkspaceObserver = null;
      dcpWorkspaceFrame = 0;
    }, { once: true });
  }
  if (targets.templateArtwork) {
    targets.templateArtwork.addEventListener('load', () => {
      fitMessage();
    });
  }
  function normalizedDcArtRecord(record) {
    const source = record && typeof record === 'object' ? record : {};
    const designId = String(source.designId || '').trim();
    const previewSrc = String(source.previewSrc || '').trim();
    const catalogVersion = String(source.catalogVersion || '').trim();
    const orientation = String(source.orientation || '').trim().toLowerCase();
    const exactDimensions = source.exactDimensions && typeof source.exactDimensions === 'object' ? source.exactDimensions : {};
    const requiredSizes = ['6', '8', '10', '12'];
    if (!designId || !previewSrc || catalogVersion !== 'srd-dc-art-catalog-v1'
        || Number(source.defaultNominalSize) !== 6 || source.productionReady6in !== true
        || !['horizontal', 'square', 'vertical'].includes(orientation)
        || requiredSizes.some((size) => !exactDimensions[size]
          || !(Number(exactDimensions[size].width) > 0)
          || !(Number(exactDimensions[size].height) > 0)
          || Math.max(Number(exactDimensions[size].width), Number(exactDimensions[size].height)) > Number(size) + .011
          || (orientation === 'horizontal' && Math.abs(Number(exactDimensions[size].width) - Number(size)) > .011)
          || (orientation === 'vertical' && Math.abs(Number(exactDimensions[size].height) - Number(size)) > .011)
          || (orientation === 'square' && (Math.abs(Number(exactDimensions[size].width) - Number(size)) > .011
            || Math.abs(Number(exactDimensions[size].height) - Number(size)) > .011)))) {
      throw new Error('The selected DC artwork is not an approved catalog record.');
    }
    return {
      designId: designId,
      title: String(source.title || designId).trim(),
      previewSrc: previewSrc,
      previewWidth: Number(source.previewWidth) || 0,
      previewHeight: Number(source.previewHeight) || 0,
      catalogVersion: catalogVersion,
      defaultNominalSize: 6,
      productionReady6in: true,
      complexityTier: String(source.complexityTier || '').trim().toLowerCase(),
      orientation: orientation,
      exactDimensions: requiredSizes.reduce((dimensions, size) => {
        dimensions[size] = {
          width: Number(exactDimensions[size].width),
          height: Number(exactDimensions[size].height)
        };
        return dimensions;
      }, {}),
      approvedVinylColors: Array.isArray(source.approvedVinylColors) ? source.approvedVinylColors.slice() : []
    };
  }

  function dcArtCanvasSize() {
    return { version: 1, unit: 'in', width: 12, height: 12, trustedDcArtRestore: true };
  }

  function applyDcArtNominalSize(nominalSize, options) {
    if (!activeDcpCatalogArtwork) return null;
    const settings = options || {};
    const historyStart = settings.history === false ? null : beginDcpHistoryTransaction();
    const size = [6, 8, 10, 12].includes(Number(nominalSize)) ? Number(nominalSize) : 6;
    const dimensions = activeDcpCatalogArtwork.record.exactDimensions[String(size)];
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
    objects.artwork.width = dimensions.width / 12 * 100;
    objects.artwork.height = dimensions.height / 12 * 100;
    objects.artwork.scale = 1;
    objects.artwork.x = Math.min(100 - objects.artwork.width / 2, Math.max(objects.artwork.width / 2, objects.artwork.x || 50));
    objects.artwork.y = Math.min(100 - objects.artwork.height / 2, Math.max(objects.artwork.height / 2, objects.artwork.y || 50));
    activeDcpCatalogArtwork.nominalSize = size;
    proof.catalogArtwork = {
      designId: activeDcpCatalogArtwork.record.designId,
      catalogVersion: activeDcpCatalogArtwork.record.catalogVersion,
      nominalSize: size,
      physicalSizeIn: { width: dimensions.width, height: dimensions.height },
      lockedAspectRatio: true
    };
    proof.physicalCanvas = dcArtCanvasSize();
    proof.objects = objects;
    currentDcpProofState = proof;
    if (controls.dcpWidth) controls.dcpWidth.value = '12';
    if (controls.dcpHeight) controls.dcpHeight.value = '12';
    syncDcpProofCompatibilityAlias();
    update();
    if (historyStart) commitDcpHistoryTransaction(historyStart, 'Change catalog artwork size');
    document.dispatchEvent(new CustomEvent('srd:dc-art-changed', { detail: dcArtState() }));
    return dcArtState();
  }

  function activateDcArtRecord(record, options) {
    const trustedRecord = normalizedDcArtRecord(record);
    const settings = options || {};
    if (!activateTopLevelProductFamily('custom_die_cut_design')) {
      throw new Error('The Custom Die Designer could not be opened.');
    }
    activeDcpCatalogArtwork = { record: trustedRecord, nominalSize: 6 };
    const requestedColorKey = authorizedDcpDieVinylColorKey(settings.colorKey) || 'white';
    const approvedColorKeys = trustedRecord.approvedVinylColors.map((label) => authorizedDcpDieVinylColorKey(label));
    const colorKey = approvedColorKeys.includes(requestedColorKey) ? requestedColorKey : 'white';
    const proof = currentDcpProofState || emptyDcpProofState();
    proof.source = 'dc_art_catalog';
    proof.url = trustedRecord.previewSrc;
    proof.previewUrl = trustedRecord.previewSrc;
    proof.name = trustedRecord.title;
    proof.filename = trustedRecord.designId;
    proof.originalFilename = trustedRecord.designId;
    proof.type = 'catalog_artwork';
    proof.fileType = 'catalog_artwork';
    proof.dimensions = '';
    proof.reference = '';
    proof.artworkReference = '';
    proof.status = 'Approved DC Art Library design';
    proof.supported = true;
    proof.previewable = true;
    proof.restored = false;
    proof.transform = 'catalog-locked-aspect';
    proof.dieVinylColorKey = colorKey;
    proof.physicalCanvas = dcArtCanvasSize();
    proof.objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
    proof.objects.artwork = { x: 50, y: 50, width: 50, height: 50, scale: 1, rotation: 0 };
    currentDcpProofState = normalizeDcpDieObjectColors(proof);
    dcpArtworkAssetToken = '';
    dcpArtworkNeedsReselection = false;
    if (controls.blankCanvasStart) controls.blankCanvasStart.value = 'upload_artwork';
    if (controls.dieVinylColor) controls.dieVinylColor.value = colorKey;
    dcpDieVinylColorContext = colorKey;
    selectDcpObject('artwork');
    const state = applyDcArtNominalSize(settings.nominalSize, { history: false });
    resetDcpHistoryBaseline('dc-art-catalog-selection', dcpHistoryContextValue('blank_canvas'));
    return state;
  }

  function removeDcArtRecord() {
    if (!activeDcpCatalogArtwork) return false;
    activeDcpCatalogArtwork = null;
    const proof = currentDcpProofState || emptyDcpProofState();
    ['url', 'previewUrl', 'name', 'filename', 'originalFilename', 'type', 'fileType', 'dimensions', 'status'].forEach((key) => { proof[key] = ''; });
    delete proof.catalogArtwork;
    proof.source = '';
    proof.supported = false;
    proof.previewable = false;
    proof.objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
    currentDcpProofState = proof;
    if (controls.blankCanvasStart) controls.blankCanvasStart.value = 'start_blank';
    clearDcpObjectSelection();
    syncDcpProofCompatibilityAlias();
    update();
    document.dispatchEvent(new CustomEvent('srd:dc-art-changed', { detail: null }));
    return true;
  }

  function resetDcArtPosition() {
    if (!activeDcpCatalogArtwork) return null;
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
    objects.artwork.x = 50;
    objects.artwork.y = 50;
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpProofCompatibilityAlias();
    update();
    commitDcpHistoryTransaction(historyStart, 'Reset catalog artwork position');
    document.dispatchEvent(new CustomEvent('srd:dc-art-changed', { detail: dcArtState() }));
    return dcArtState();
  }

  function placeDcArtText(placement) {
    if (!activeDcpCatalogArtwork) throw new Error('Choose a DC Art Library design before adding text.');
    const objectsBefore = normalizeDcpCanvasObjects(getDcpProofState().objects, 'die_cutting');
    if (objectsBefore.textObjects.length >= 3) throw new Error('A maximum of three text objects is allowed.');
    const historyStart = beginDcpHistoryTransaction();
    addDcpTextObject({ history: false, update: false });
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
    const text = selectedDcpTextObject(objects);
    if (!text) throw new Error('The text object could not be created.');
    const art = objects.artwork;
    const mode = String(placement || 'free').toLowerCase();
    text.width = Math.min(70, Math.max(30, art.width * .9));
    text.height = 10;
    text.x = art.x;
    text.y = mode === 'above' || mode === 'arch_up'
      ? Math.max(text.height / 2 + 1, art.y - art.height / 2 - text.height / 2 - 2)
      : (mode === 'below' || mode === 'arch_down'
        ? Math.min(100 - text.height / 2 - 1, art.y + art.height / 2 + text.height / 2 + 2)
        : (mode === 'over' ? art.y : Math.min(88, 20 + objects.textObjects.length * 12)));
    text.textShape = mode === 'arch_up' ? 'arch_up' : (mode === 'arch_down' ? 'arch_down' : 'straight');
    text.arcAmount = mode === 'arch_up' || mode === 'arch_down' ? 45 : 0;
    text.fontColorKey = getDcpProofState().dieVinylColorKey || 'white';
    text.fontColor = dcpDieVinylColorDescriptor(text.fontColorKey).label;
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpTextEditorFromSelection(objects, true);
    syncDcpProofCompatibilityAlias();
    update();
    commitDcpHistoryTransaction(historyStart, 'Add ' + mode.replace('_', ' ') + ' text');
    document.dispatchEvent(new CustomEvent('srd:dc-art-changed', { detail: dcArtState() }));
    return dcArtState();
  }

  function placeSelectedDcArtText(placement) {
    if (!activeDcpCatalogArtwork || selectedDcpObjects.length !== 1 || dcpObjectType(selectedDcpObject) !== 'text') return false;
    const historyStart = beginDcpHistoryTransaction();
    const proof = currentDcpProofState || emptyDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
    const text = selectedDcpTextObject(objects);
    if (!text) return false;
    const art = objects.artwork;
    const mode = String(placement || 'free').toLowerCase();
    text.x = mode === 'free' ? text.x : art.x;
    text.y = mode === 'above' || mode === 'arch_up'
      ? Math.max(text.height / 2 + 1, art.y - art.height / 2 - text.height / 2 - 2)
      : (mode === 'below' || mode === 'arch_down'
        ? Math.min(100 - text.height / 2 - 1, art.y + art.height / 2 + text.height / 2 + 2)
        : (mode === 'over' ? art.y : text.y));
    text.textShape = mode === 'arch_up' ? 'arch_up' : (mode === 'arch_down' ? 'arch_down' : 'straight');
    text.arcAmount = mode === 'arch_up' || mode === 'arch_down' ? 45 : 0;
    proof.objects = objects;
    currentDcpProofState = proof;
    syncDcpTextEditorFromSelection(objects, true);
    // Keep the shared editor controls aligned before update() reads them back.
    // Without this, a placement selection could be overwritten by the prior
    // Text Shape control value during the same atomic history transaction.
    if (targets.dcpTextShape) targets.dcpTextShape.value = text.textShape;
    if (targets.dcpArcAmount) targets.dcpArcAmount.value = String(text.arcAmount);
    syncDcpProofCompatibilityAlias();
    update();
    commitDcpHistoryTransaction(historyStart, 'Change text placement');
    document.dispatchEvent(new CustomEvent('srd:dc-art-changed', { detail: dcArtState() }));
    return true;
  }

  function setDcArtVinylColor(colorKey) {
    if (!activeDcpCatalogArtwork) throw new Error('Choose a DC Art Library design before changing vinyl color.');
    const safeColorKey = authorizedDcpDieVinylColorKey(colorKey);
    const allowed = activeDcpCatalogArtwork.record.approvedVinylColors
      .map((label) => authorizedDcpDieVinylColorKey(label));
    if (!safeColorKey || !allowed.includes(safeColorKey)) throw new Error('That vinyl color is not approved for this design.');
    const proof = currentDcpProofState || emptyDcpProofState();
    const previousColorKey = authorizedDcpDieVinylColorKey(proof.dieVinylColorKey) || 'white';
    if (previousColorKey === safeColorKey) return dcArtState();
    const historyStart = beginDcpHistoryTransaction();
    proof.dieVinylColorKey = safeColorKey;
    const objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
    objects.textObjects.forEach((text) => {
      text.fontColorKey = safeColorKey;
      text.fontColor = dcpDieVinylColorDescriptor(safeColorKey).label;
    });
    proof.objects = objects;
    currentDcpProofState = proof;
    dcpDieVinylColorContext = safeColorKey;
    if (controls.dieVinylColor) controls.dieVinylColor.value = safeColorKey;
    syncDcpProofCompatibilityAlias();
    update();
    commitDcpHistoryTransaction(historyStart, 'Change vinyl color');
    document.dispatchEvent(new CustomEvent('srd:dc-art-changed', { detail: dcArtState() }));
    return dcArtState();
  }

  function dcArtEnvelope() {
    if (!activeDcpCatalogArtwork) return null;
    const proof = getDcpProofState();
    const objects = normalizeDcpCanvasObjects(proof.objects, 'die_cutting');
    const dieContract = buildDcpDieProductionContract(objects, proof);
    const containment = dieContract.compositionContainment;
    const envelope = containment && containment.envelope;
    const width = Math.max(0, Number(envelope && envelope.width || 0));
    const height = Math.max(0, Number(envelope && envelope.height || 0));
    const controlling = Math.max(width, height, activeDcpCatalogArtwork.nominalSize);
    const tier = [6, 8, 10, 12].find((value) => value + .001 >= controlling) || null;
    return {
      width: width,
      height: height,
      controllingDimension: controlling,
      tier: tier,
      blocked: !tier || !containment || !containment.valid,
      failures: containment ? containment.failures.map((failure) => failure.message) : []
    };
  }

  function dcArtState() {
    if (!activeDcpCatalogArtwork) return null;
    const proof = getDcpProofState();
    const commerceReady = Boolean(
      latestDesignData
      && latestDesignData.ready_for_cart
      && latestPricing
      && latestPricing.ready
      && latestPricing.enforcement_ready
      && latestPricingVariants
      && latestPricingVariants.ready
      && latestPricingVariants.variant_id
      && latestPricingVariants.available
      && !isDcpCartTestingLockout()
    );
    return {
      designId: activeDcpCatalogArtwork.record.designId,
      title: activeDcpCatalogArtwork.record.title,
      previewSrc: activeDcpCatalogArtwork.record.previewSrc,
      catalogVersion: activeDcpCatalogArtwork.record.catalogVersion,
      nominalSize: activeDcpCatalogArtwork.nominalSize,
      vinylColorKey: proof.dieVinylColorKey || 'white',
      textObjectCount: normalizeDcpCanvasObjects(proof.objects, 'die_cutting').textObjects.length,
      envelope: dcArtEnvelope(),
      commerceReady: commerceReady
    };
  }

  window.SRDDesignerDcArt = Object.freeze({
    contractVersion: 'srd-dc-art-plus-text-production-v1',
    activate: activateDcArtRecord,
    remove: removeDcArtRecord,
    setNominalSize: applyDcArtNominalSize,
    resetPosition: resetDcArtPosition,
    setVinylColor: setDcArtVinylColor,
    addText: placeDcArtText,
    getState: dcArtState,
    calculateEnvelope: dcArtEnvelope
  });

  window.SRDDesignerDieProduction = Object.freeze({
    contractType: dcpDieProductionContractType,
    contractVersion: dcpDieProductionContractVersion,
    generate: () => buildDcpDieProductionContract(getDcpProofState().objects, getDcpProofState()),
    serialize: () => serializeDcpDieProductionContract(),
    restore: (serialized) => restoreDcpDieProductionContract(serialized),
    renderProof: () => renderDcpDieProductionProof()
  });
  initializeProductFamilyFromPathname();
  restoreDesignFromQuery();
  if (controls.color && !controls.color.value) {
    controls.color.value = 'black';
  }
  update();
  if (dcpCartEditSession.active) resolveDcpCartEditSession();
  window.addEventListener('load', () => {
    // The section's strict product JSON can finish parsing after this deferred
    // asset. Rebuild the exact-price map once the document is complete so an
    // Edit Design session cannot remain permanently locked on an empty parse.
    if (!dcpDieVariantLookup.ready) {
      dcpDieVariantLookup = buildDcpDieVariantLookup(parseDcpDieProductData());
      update();
    }
  }, { once: true });
})();


;(function initDcpCustomerBoundsGuidance() {
  'use strict';

  var ROOT_SELECTOR = '[data-srd-designer]';
  var STATUS_SELECTOR = '[aria-label="Custom Die-Cut Design status"]';
  var WORKSPACE_WARNING_ID = 'srd-customer-workspace-bounds-warning';
  var ACTION_WARNING_ID = 'srd-customer-action-bounds-warning';
  var TARGET_ATTRIBUTE = 'data-srd-customer-bounds-warning-target';
  var STYLE_ID = 'srd-customer-bounds-guidance-style';

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.srd-customer-bounds-warning{display:none;margin:10px 0;padding:11px 13px;border:2px solid #f06a21;border-left-width:6px;border-radius:8px;background:#fff4ed;color:#782900;font-weight:700;font-size:1.05rem;line-height:1.35;box-shadow:0 2px 8px rgba(120,41,0,.16)}' +
      '.srd-customer-bounds-warning.is-active{display:block}' +
      '[data-srd-customer-bounds-warning-target="true"]{outline:3px solid #ff5a36!important;outline-offset:3px!important;box-shadow:inset 0 0 0 3px #ff4b1f,0 0 0 3px #ff4b1f!important;filter:drop-shadow(0 0 2px #ff4b1f) drop-shadow(0 0 7px rgba(255,75,31,.95))}' +
      '.srd-designer-proof__blank-canvas-artwork-hit[data-srd-customer-bounds-warning-target="true"],[data-srd-dcp-text-id][data-srd-customer-bounds-warning-target="true"]{box-sizing:border-box!important;border:3px solid #ff4b1f!important;background:rgba(255,75,31,.08)!important}' +
      '@media(max-width:600px){.srd-customer-bounds-warning{margin:8px 0;padding:10px 11px;font-size:1rem}}';
    document.head.appendChild(style);
  }

  function warningState(text) {
    text = String(text || '');
    if (/Artwork is outside the .* installation workspace[.]/i.test(text)) {
      return {
        kind: 'artwork',
        message: 'Your artwork is outside the available design area. Move it or make it smaller to continue.'
      };
    }
    if (/Text [0-9]+ is outside the .* installation workspace[.]/i.test(text)) {
      return {
        kind: 'text',
        message: 'Your text is outside the available design area. Move it or make it smaller to continue.'
      };
    }
    return null;
  }

  function ensureWarning(root, id, anchor, before) {
    var warning = document.getElementById(id);
    if (!warning) {
      warning = document.createElement('div');
      warning.id = id;
      warning.className = 'srd-customer-bounds-warning';
      warning.setAttribute('role', 'status');
      warning.setAttribute('aria-live', 'polite');
      warning.setAttribute('aria-atomic', 'true');
    }
    if (anchor && anchor.parentNode) {
      var correctParent = warning.parentNode === anchor.parentNode;
      var correctPosition = before ? warning.nextSibling === anchor : warning.previousSibling === anchor;
      if (!correctParent || !correctPosition) {
        anchor.parentNode.insertBefore(warning, before ? anchor : anchor.nextSibling);
      }
    } else if (!warning.isConnected) {
      root.appendChild(warning);
    }
    return warning;
  }

  function workspaceAnchor(root) {
    return root.querySelector('[aria-label="Live design proof"]') ||
      root.querySelector('[data-srd-proof-workspace]') ||
      root.querySelector('canvas') ||
      root.querySelector('svg');
  }

  function actionButton(root) {
    return root.querySelector('[data-srd-add-to-cart]') ||
      Array.from(root.querySelectorAll('button')).find(function(button) {
        return /^(Add Design Proof To Cart|Update Design In Cart)$/i.test((button.textContent || '').trim());
      });
  }

  function clearTargets(root) {
    root.querySelectorAll('[' + TARGET_ATTRIBUTE + ']').forEach(function(node) {
      node.removeAttribute(TARGET_ATTRIBUTE);
    });
  }

  function markTarget(root, kind) {
    var selectors = kind === 'artwork'
      ? '[data-srd-dcp-artwork-hit],[data-srd-dcp-artwork],[data-srd-blank-canvas-artwork]'
      : '[data-srd-dcp-text-id]';
    var nodes = root.querySelectorAll(selectors);
    if (nodes.length) {
      Array.from(nodes).forEach(function(node) {
        node.setAttribute(TARGET_ATTRIBUTE, 'true');
      });
      return;
    }
    var proof = workspaceAnchor(root);
    if (proof) proof.setAttribute(TARGET_ATTRIBUTE, 'true');
  }

  function sync(root, status) {
    var state = warningState(status.textContent);
    var workspace = workspaceAnchor(root);
    var button = actionButton(root);
    var workspaceWarningAnchor = workspace && workspace.firstElementChild;
    var workspaceWarning = ensureWarning(root, WORKSPACE_WARNING_ID, workspaceWarningAnchor || workspace, !workspaceWarningAnchor);
    var actionWarning = ensureWarning(root, ACTION_WARNING_ID, button, true);

    clearTargets(root);
    if (!state) {
      workspaceWarning.classList.remove('is-active');
      actionWarning.classList.remove('is-active');
      if (workspaceWarning.textContent) workspaceWarning.textContent = '';
      if (actionWarning.textContent) actionWarning.textContent = '';
      if (button) button.removeAttribute('aria-describedby');
      return;
    }

    if (workspaceWarning.textContent !== state.message) workspaceWarning.textContent = state.message;
    if (actionWarning.textContent !== state.message) actionWarning.textContent = state.message;
    workspaceWarning.classList.add('is-active');
    actionWarning.classList.add('is-active');
    if (button) button.setAttribute('aria-describedby', ACTION_WARNING_ID);
    markTarget(root, state.kind);
  }

  function start(root) {
    var status = root.querySelector(STATUS_SELECTOR);
    if (!status || status.dataset.srdCustomerBoundsGuidance === 'ready') return;
    status.dataset.srdCustomerBoundsGuidance = 'ready';
    addStyle();
    sync(root, status);
    new MutationObserver(function() {
      sync(root, status);
    }).observe(status, { childList: true, subtree: true, characterData: true });
    if (root.dataset.srdCustomerBoundsRootObserver !== 'ready') {
      root.dataset.srdCustomerBoundsRootObserver = 'ready';
      var rootSyncQueued = false;
      new MutationObserver(function() {
        if (rootSyncQueued) return;
        rootSyncQueued = true;
        queueMicrotask(function() {
          rootSyncQueued = false;
          var currentStatus = root.querySelector(STATUS_SELECTOR);
          if (currentStatus) sync(root, currentStatus);
        });
      }).observe(root, { childList: true, subtree: true, characterData: true });
    }
  }

  function boot() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    start(root);
    var status = root.querySelector(STATUS_SELECTOR);
    if (status) sync(root, status);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  var renderSyncQueued = false;
  function scheduleRenderSync() {
    if (renderSyncQueued) return;
    renderSyncQueued = true;
    requestAnimationFrame(function() {
      renderSyncQueued = false;
      boot();
    });
  }
  ['click', 'input', 'change', 'pointerup'].forEach(function(eventName) {
    document.addEventListener(eventName, scheduleRenderSync, true);
  });
  new MutationObserver(scheduleRenderSync).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
